_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[56],{

/***/ "/a9y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__("/GRZ");

var _createClass = __webpack_require__("i2R6");

var _inherits = __webpack_require__("48fX");

var _possibleConstructorReturn = __webpack_require__("tCBg");

var _getPrototypeOf = __webpack_require__("T0f4");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _interopRequireDefault = __webpack_require__("AroE");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

var _head = _interopRequireDefault(__webpack_require__("8Kt/"));

var statusCodes = {
  400: 'Bad Request',
  404: 'This page could not be found',
  405: 'Method Not Allowed',
  500: 'Internal Server Error'
};

function _getInitialProps(_ref) {
  var res = _ref.res,
      err = _ref.err;
  var statusCode = res && res.statusCode ? res.statusCode : err ? err.statusCode : 404;
  return {
    statusCode: statusCode
  };
}
/**
* `Error` component used for handling errors.
*/


var Error = /*#__PURE__*/function (_react$default$Compon) {
  _inherits(Error, _react$default$Compon);

  var _super = _createSuper(Error);

  function Error() {
    _classCallCheck(this, Error);

    return _super.apply(this, arguments);
  }

  _createClass(Error, [{
    key: "render",
    value: function render() {
      var statusCode = this.props.statusCode;
      var title = this.props.title || statusCodes[statusCode] || 'An unexpected error has occurred';
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.error
      }, /*#__PURE__*/_react["default"].createElement(_head["default"], null, /*#__PURE__*/_react["default"].createElement("title", null, statusCode, ": ", title)), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("style", {
        dangerouslySetInnerHTML: {
          __html: 'body { margin: 0 }'
        }
      }), statusCode ? /*#__PURE__*/_react["default"].createElement("h1", {
        style: styles.h1
      }, statusCode) : null, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.desc
      }, /*#__PURE__*/_react["default"].createElement("h2", {
        style: styles.h2
      }, title, "."))));
    }
  }]);

  return Error;
}(_react["default"].Component);

exports["default"] = Error;
Error.displayName = 'ErrorPage';
Error.getInitialProps = _getInitialProps;
Error.origGetInitialProps = _getInitialProps;
var styles = {
  error: {
    color: '#000',
    background: '#fff',
    fontFamily: '-apple-system, BlinkMacSystemFont, Roboto, "Segoe UI", "Fira Sans", Avenir, "Helvetica Neue", "Lucida Grande", sans-serif',
    height: '100vh',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  desc: {
    display: 'inline-block',
    textAlign: 'left',
    lineHeight: '49px',
    height: '49px',
    verticalAlign: 'middle'
  },
  h1: {
    display: 'inline-block',
    borderRight: '1px solid rgba(0, 0, 0,.3)',
    margin: 0,
    marginRight: '20px',
    padding: '10px 23px 10px 0',
    fontSize: '24px',
    fontWeight: 500,
    verticalAlign: 'top'
  },
  h2: {
    fontSize: '14px',
    fontWeight: 'normal',
    lineHeight: 'inherit',
    margin: 0,
    padding: 0
  }
};

/***/ }),

/***/ "/cY/":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/soundboks_build-768-e43ba8c300c863aebf7eafafea819d2a.jpg", "placeholder": "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAKABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAQGAwf/xAAkEAABAwMDBAMAAAAAAAAAAAABAgMEAAURBhIhEzFBUSNhkf/EABYBAQEBAAAAAAAAAAAAAAAAAAAEBf/EABwRAAICAgMAAAAAAAAAAAAAAAECAAURUQQSIf/aAAwDAQACEQMRAD8A6/JehwLYZ8lfSZSjerKTkfVQtv1Xd5LssONxQFHEdL4UFhRV2IHcAd8eh7qg1M2h61OJeQlxPpYyPFI2WLH6Weg1lJVtOwcc+KjbntqaK1ab8j1w1TYrc+GJk/a/tClJSk8ZorNMCGMkRY4JJJ+Mcn8oobBgcYgVKEZ7T//Z"};

/***/ }),

/***/ "0zxa":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/engadget_black-2e84d05c511302e60f77922963f1bf1d.png", "placeholder": ""};

/***/ }),

/***/ "12ur":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/soundboks_slider-768-8599971ec35c271d800d707c566634cd.jpg", "placeholder": "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAKABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABQYA/8QAJBAAAgEDAwQDAQAAAAAAAAAAAQIDAAQRBRIhBgcTURQVImH/xAAVAQEBAAAAAAAAAAAAAAAAAAAEA//EAB8RAAAGAQUAAAAAAAAAAAAAAAABAhESMQMhQlFh4f/aAAwDAQACEQMRAD8AtbnuvdQ/Ej3wq9y4jQlAMn1/GBIBBHFE9Qd630N5TcTXE23aEiRYw7HnJP5x6qbkjSaNTMiyFW4LjOKO6lsbSXSH8lrA+SCd0YOeKPJ1dBDJLHWvPgr4e6t7cwxz/a6jAJVDhDFGcAj3461AaLBENMt1ESBVQADaOBWqs0ltBTk9j//Z"};

/***/ }),

/***/ "1TYF":
/***/ (function(module, exports) {

module.exports = { "url": "data:image/png;base64,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" };

/***/ }),

/***/ "1kso":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/Soundboks3-lifestyle-4-large-f7ea04131d4b00b80033790806e3abc3.png", "placeholder": ""};

/***/ }),

/***/ "2BJw":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/soundboks_sound-1920-872678c77da4f0a086d3009b7ba79691.jpg", "placeholder": ""};

/***/ }),

/***/ "37+v":
/***/ (function(module, exports) {

module.exports = { "url": "data:image/png;base64,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" };

/***/ }),

/***/ "3e8x":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/USP_teamup_375-b5b0cb5610c22c7942804e26f84ca45b.png", "placeholder": ""};

/***/ }),

/***/ "52F1":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/Soundboks3-lifestyle-3-small-d527fb76dcbe7ea556a0ac6de4d2cf80.png", "placeholder": ""};

/***/ }),

/***/ "5CrD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ index_web_VideoPlayer; });

// UNUSED EXPORTS: useControls

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/atoms/Icon/index.tsx + 105 modules
var Icon = __webpack_require__("ZSX1");

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/styles/theme.ts
var theme = __webpack_require__("isV7");

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// CONCATENATED MODULE: ./components/elements/video-player/styled.ts

var Container = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Container",
  componentId: "sc-1yesasa-0"
})(["display:flex;flex:1;position:relative;"]);
var Video = styled_components_browser_esm["default"].video.withConfig({
  displayName: "styled__Video",
  componentId: "sc-1yesasa-1"
})(["width:100%;height:100%;object-fit:", ";"], function (_ref) {
  var resizeMode = _ref.resizeMode;
  return resizeMode || 'initial';
});
var Controls = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Controls",
  componentId: "sc-1yesasa-2"
})(["position:absolute;top:0;left:0;width:100%;height:100%;cursor:pointer;"]);
var ControlIcons = styled_components_browser_esm["default"].button.withConfig({
  displayName: "styled__ControlIcons",
  componentId: "sc-1yesasa-3"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transition:opacity 400ms;padding:0;cursor:pointer;"]);
var Play = Object(styled_components_browser_esm["default"])(ControlIcons).withConfig({
  displayName: "styled__Play",
  componentId: "sc-1yesasa-4"
})(["padding-left:12px;z-index:2;opacity:", ";"], function (_ref2) {
  var isVisible = _ref2.isVisible;
  return isVisible ? 1 : 0;
});
var Pause = Object(styled_components_browser_esm["default"])(ControlIcons).withConfig({
  displayName: "styled__Pause",
  componentId: "sc-1yesasa-5"
})(["z-index:1;opacity:", ";"], function (_ref3) {
  var isVisible = _ref3.isVisible;
  return isVisible ? 1 : 0;
});
// CONCATENATED MODULE: ./components/elements/video-player/use-controls.tsx

function useControls() {
  var autoPlay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _useState = Object(react["useState"])(null),
      timer = _useState[0],
      setTimer = _useState[1];

  var _useState2 = Object(react["useState"])(autoPlay),
      isPlaying = _useState2[0],
      setIsPlaying = _useState2[1];

  var _useState3 = Object(react["useState"])(true),
      isControlsVisible = _useState3[0],
      setIsControlsVisible = _useState3[1];

  Object(react["useEffect"])(function () {
    return function () {
      return clearTimeout(timer);
    };
  }, [timer]);

  var toggle = function toggle() {
    clearTimeout(timer);
    setIsControlsVisible(true);

    if (!isPlaying) {
      setTimer(setTimeout(function () {
        return setIsControlsVisible(false);
      }, 1000));
    }

    setIsPlaying(!isPlaying);
  };

  var play = function play() {
    clearTimeout(timer);
    setIsControlsVisible(true);
    setTimer(setTimeout(function () {
      return setIsControlsVisible(false);
    }, 1000));
    setIsPlaying(true);
  };

  var pause = function pause() {
    clearTimeout(timer);
    setIsControlsVisible(true);
    setIsPlaying(false);
  };

  var handleVideoEnded = pause;

  var handleMouseHover = function handleMouseHover() {
    if (isPlaying) {
      clearTimeout(timer);
      setIsControlsVisible(true);
      setTimer(setTimeout(function () {
        return setIsControlsVisible(false);
      }, 1000));
    }
  };

  return {
    isPlaying: isPlaying,
    isControlsVisible: isControlsVisible,
    toggle: toggle,
    play: play,
    pause: pause,
    handleVideoEnded: handleVideoEnded,
    handleMouseHover: handleMouseHover
  };
}
// CONCATENATED MODULE: ./components/elements/video-player/index.web.tsx
var __jsx = react_default.a.createElement;




 // eslint-disable-next-line prefer-arrow-callback

var index_web_VideoPlayer = /*#__PURE__*/react_default.a.memo(function VideoPlayer(_ref) {
  var videoUri = _ref.videoUri,
      _ref$videoType = _ref.videoType,
      videoType = _ref$videoType === void 0 ? 'video/mp4' : _ref$videoType,
      posterUri = _ref.posterUri,
      muted = _ref.muted,
      autoPlay = _ref.autoPlay,
      _ref$preload = _ref.preload,
      preload = _ref$preload === void 0 ? 'none' : _ref$preload,
      controls = _ref.controls,
      _ref$hideControls = _ref.hideControls,
      hideControls = _ref$hideControls === void 0 ? false : _ref$hideControls,
      _ref$loop = _ref.loop,
      loop = _ref$loop === void 0 ? false : _ref$loop,
      _ref$rewindOnEnd = _ref.rewindOnEnd,
      rewindOnEnd = _ref$rewindOnEnd === void 0 ? false : _ref$rewindOnEnd,
      _ref$resizeMode = _ref.resizeMode,
      resizeMode = _ref$resizeMode === void 0 ? 'cover' : _ref$resizeMode;
  var controlsFallback = useControls(autoPlay);

  var _ref2 = controls || controlsFallback,
      isPlaying = _ref2.isPlaying,
      isControlsVisible = _ref2.isControlsVisible,
      toggle = _ref2.toggle,
      handleVideoEnded = _ref2.handleVideoEnded,
      handleMouseHover = _ref2.handleMouseHover;

  var videoRef = Object(react["useRef"])(null);
  var showPlay = !isPlaying;
  var showPause = isPlaying && isControlsVisible;
  Object(react["useEffect"])(function () {
    videoRef.current.onended = function () {
      if (rewindOnEnd) {
        videoRef.current.currentTime = 0;
      }

      handleVideoEnded();
    };
  }, [handleVideoEnded, rewindOnEnd]);
  Object(react["useEffect"])(function () {
    if (isPlaying) {
      videoRef.current.play();
    } else {
      videoRef.current.pause();
    }
  }, [isPlaying]);
  return /*#__PURE__*/react_default.a.createElement(Container, null, /*#__PURE__*/react_default.a.createElement(Video, {
    ref: videoRef,
    poster: posterUri,
    muted: muted,
    preload: preload,
    loop: loop,
    autoPlay: autoPlay,
    resizeMode: resizeMode,
    playsInline: true
  }, /*#__PURE__*/react_default.a.createElement("source", {
    src: videoUri,
    type: videoType
  })), !hideControls && /*#__PURE__*/react_default.a.createElement(Controls, {
    onClick: toggle,
    onMouseMove: handleMouseHover
  }, /*#__PURE__*/react_default.a.createElement(Play, {
    isVisible: showPlay
  }, /*#__PURE__*/react_default.a.createElement(Icon["b" /* default */], {
    id: Icon["a" /* IconId */].Play,
    color: theme["a" /* Color */].White,
    size: theme["d" /* IconSize */].MediumLarge
  })), /*#__PURE__*/react_default.a.createElement(Pause, {
    isVisible: showPause
  }, /*#__PURE__*/react_default.a.createElement(Icon["b" /* default */], {
    id: Icon["a" /* IconId */].Pause,
    color: theme["a" /* Color */].White,
    size: theme["d" /* IconSize */].MediumLarge
  }))));
});


/***/ }),

/***/ "723w":
/***/ (function(module, exports) {

module.exports = { "url": "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIj4KICA8ZyBpZD0iaWNvbi1jb21wYXJpc29uLXllcyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEyOCAtMzMzNikiPgogICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8xNjM3IiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAxNjM3IiB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyOCAzMzM2KSIgZmlsbD0ibm9uZSIvPgogICAgPHBhdGggaWQ9IlBhdGhfMTUzMyIgZGF0YS1uYW1lPSJQYXRoIDE1MzMiIGQ9Ik0yMi41LDMuNSwxOC45LDAsOSwxMCwzLjUsNC41LDAsOC4xLDksMTdIOVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzMyAzMzQzLjg0KSIgZmlsbD0iIzBlOWY2ZCIvPgogIDwvZz4KPC9zdmc+Cg==" };

/***/ }),

/***/ "746X":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/all-grillz-f93f33d0217da17f11975402384c9ea2.png", "placeholder": ""};

/***/ }),

/***/ "7BfX":
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__("q1tI")) :
  undefined;
}(this, (function (exports, React) {
  function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function () {
              return e[k];
            }
          });
        }
      });
    }
    n['default'] = e;
    return n;
  }

  var React__namespace = /*#__PURE__*/_interopNamespace(React);

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  var LEFT = "Left";
  var RIGHT = "Right";
  var UP = "Up";
  var DOWN = "Down";

  var defaultProps = {
    delta: 10,
    preventDefaultTouchmoveEvent: false,
    rotationAngle: 0,
    trackMouse: false,
    trackTouch: true
  };
  var initialState = {
    first: true,
    initial: [0, 0],
    start: 0,
    swiping: false,
    xy: [0, 0]
  };
  var mouseMove = "mousemove";
  var mouseUp = "mouseup";
  var touchEnd = "touchend";
  var touchMove = "touchmove";
  var touchStart = "touchstart";

  function getDirection(absX, absY, deltaX, deltaY) {
    if (absX > absY) {
      if (deltaX > 0) {
        return RIGHT;
      }

      return LEFT;
    } else if (deltaY > 0) {
      return DOWN;
    }

    return UP;
  }

  function rotateXYByAngle(pos, angle) {
    if (angle === 0) return pos;
    var angleInRadians = Math.PI / 180 * angle;
    var x = pos[0] * Math.cos(angleInRadians) + pos[1] * Math.sin(angleInRadians);
    var y = pos[1] * Math.cos(angleInRadians) - pos[0] * Math.sin(angleInRadians);
    return [x, y];
  }

  function getHandlers(set, handlerProps) {
    var onStart = function onStart(event) {
      if (event && "touches" in event && event.touches.length > 1) return;
      set(function (state, props) {
        if (props.trackMouse) {
          document.addEventListener(mouseMove, onMove);
          document.addEventListener(mouseUp, onUp);
        }

        var _ref = "touches" in event ? event.touches[0] : event,
            clientX = _ref.clientX,
            clientY = _ref.clientY;

        var xy = rotateXYByAngle([clientX, clientY], props.rotationAngle);
        return _extends({}, state, initialState, {
          initial: [].concat(xy),
          xy: xy,
          start: event.timeStamp || 0
        });
      });
    };

    var onMove = function onMove(event) {
      set(function (state, props) {
        if ("touches" in event && event.touches.length > 1) {
          return state;
        }

        var _ref2 = "touches" in event ? event.touches[0] : event,
            clientX = _ref2.clientX,
            clientY = _ref2.clientY;

        var _rotateXYByAngle = rotateXYByAngle([clientX, clientY], props.rotationAngle),
            x = _rotateXYByAngle[0],
            y = _rotateXYByAngle[1];

        var deltaX = x - state.xy[0];
        var deltaY = y - state.xy[1];
        var absX = Math.abs(deltaX);
        var absY = Math.abs(deltaY);
        var time = (event.timeStamp || 0) - state.start;
        var velocity = Math.sqrt(absX * absX + absY * absY) / (time || 1);
        var vxvy = [deltaX / (time || 1), deltaY / (time || 1)];
        var dir = getDirection(absX, absY, deltaX, deltaY);
        var delta = typeof props.delta === "number" ? props.delta : props.delta[dir.toLowerCase()] || defaultProps.delta;
        if (absX < delta && absY < delta && !state.swiping) return state;
        var eventData = {
          absX: absX,
          absY: absY,
          deltaX: deltaX,
          deltaY: deltaY,
          dir: dir,
          event: event,
          first: state.first,
          initial: state.initial,
          velocity: velocity,
          vxvy: vxvy
        };
        eventData.first && props.onSwipeStart && props.onSwipeStart(eventData);
        props.onSwiping && props.onSwiping(eventData);
        var cancelablePageSwipe = false;

        if (props.onSwiping || props.onSwiped || "onSwiped" + dir in props) {
          cancelablePageSwipe = true;
        }

        if (cancelablePageSwipe && props.preventDefaultTouchmoveEvent && props.trackTouch && event.cancelable) event.preventDefault();
        return _extends({}, state, {
          first: false,
          eventData: eventData,
          swiping: true
        });
      });
    };

    var onEnd = function onEnd(event) {
      set(function (state, props) {
        var eventData;

        if (state.swiping && state.eventData) {
          eventData = _extends({}, state.eventData, {
            event: event
          });
          props.onSwiped && props.onSwiped(eventData);
          var onSwipedDir = props["onSwiped" + eventData.dir];
          onSwipedDir && onSwipedDir(eventData);
        } else {
          props.onTap && props.onTap({
            event: event
          });
        }

        return _extends({}, state, initialState, {
          eventData: eventData
        });
      });
    };

    var cleanUpMouse = function cleanUpMouse() {
      document.removeEventListener(mouseMove, onMove);
      document.removeEventListener(mouseUp, onUp);
    };

    var onUp = function onUp(e) {
      cleanUpMouse();
      onEnd(e);
    };

    var attachTouch = function attachTouch(el, passive) {
      var cleanup = function cleanup() {};

      if (el && el.addEventListener) {
        var tls = [[touchStart, onStart], [touchMove, onMove], [touchEnd, onEnd]];
        tls.forEach(function (_ref3) {
          var e = _ref3[0],
              h = _ref3[1];
          return el.addEventListener(e, h, {
            passive: passive
          });
        });

        cleanup = function cleanup() {
          return tls.forEach(function (_ref4) {
            var e = _ref4[0],
                h = _ref4[1];
            return el.removeEventListener(e, h);
          });
        };
      }

      return cleanup;
    };

    var onRef = function onRef(el) {
      if (el === null) return;
      set(function (state, props) {
        if (state.el === el) return state;
        var addState = {};

        if (state.el && state.el !== el && state.cleanUpTouch) {
          state.cleanUpTouch();
          addState.cleanUpTouch = undefined;
        }

        if (props.trackTouch && el) {
          addState.cleanUpTouch = attachTouch(el, !props.preventDefaultTouchmoveEvent);
        }

        return _extends({}, state, {
          el: el
        }, addState);
      });
    };

    var output = {
      ref: onRef
    };

    if (handlerProps.trackMouse) {
      output.onMouseDown = onStart;
    }

    return [output, attachTouch];
  }

  function updateTransientState(state, props, attachTouch) {
    var addState = {};

    if (!props.trackTouch && state.cleanUpTouch) {
      state.cleanUpTouch();
      addState.cleanUpTouch = undefined;
    } else if (props.trackTouch && !state.cleanUpTouch) {
      if (state.el) {
        addState.cleanUpTouch = attachTouch(state.el, !props.preventDefaultTouchmoveEvent);
      }
    }

    return _extends({}, state, addState);
  }

  function useSwipeable(options) {
    var trackMouse = options.trackMouse;
    var transientState = React__namespace.useRef(_extends({}, initialState));
    var transientProps = React__namespace.useRef(_extends({}, defaultProps));
    transientProps.current = _extends({}, defaultProps, options);

    var _React$useMemo = React__namespace.useMemo(function () {
      return getHandlers(function (stateSetter) {
        return transientState.current = stateSetter(transientState.current, transientProps.current);
      }, {
        trackMouse: trackMouse
      });
    }, [trackMouse]),
        handlers = _React$useMemo[0],
        attachTouch = _React$useMemo[1];

    transientState.current = updateTransientState(transientState.current, transientProps.current, attachTouch);
    return handlers;
  }

  exports.DOWN = DOWN;
  exports.LEFT = LEFT;
  exports.RIGHT = RIGHT;
  exports.UP = UP;
  exports.useSwipeable = useSwipeable;

})));
//# sourceMappingURL=react-swipeable.umd.js.map


/***/ }),

/***/ "8zpj":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/section_battery-bd0114af515af544055590036dade3a7.jpg", "placeholder": "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAuABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAYEBQgH/8QANBAAAQMDAgIHBAsAAAAAAAAAAQIDBAAFEQYSBxMIITFBUXWzIjJhcRQVFiMmUlNygZGh/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/ADUnSM1RbdS3a3x7VZSxEmPR2y4l0qKULKQThQGeqljTnSB1Ral3PkW2zufTZi5q+Yl07VLAykYX7o2iuea5H451F5nJ9ZVUkcAKXig2pwh4m3TWWm5U+6QoTL7UtUcCPuCSkIQrPWT1+2f6opH6NAzoW4eZuek1RQZ51aVzNTXa4NDEeXNffbCjhQSpxShkeODUBiFIU2XMIA/dVtqoCDep9uwVmFKdj8zON+xZTnHdnHZUJFySy2GS0TlAVnd40HVuDXEizaO0zLt92YnuPuTVvgx2krTtLbae0qHXlJoqr4X8MftvYpVzF2MLly1R+XyOZnCEKznI/N/lFBWcYnIj2q5ghqZUtEqSHQ2gJIVzT733acn+VfOkCYlaJKA4naQy2R8iMg098QrW8NaX8bm8/WEg9p73FHw+NKj9rkrVuUtonATkqPYOod1BonovnOgbh5m56TVFTejHbJDegZ25TXtXJwjCj+k0PD4UUH//2Q=="};

/***/ }),

/***/ "94BA":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/usp-sbgo-performance-3ae3ff58e6bed32e858000cf5803d1d7.jpg", "placeholder": ""};

/***/ }),

/***/ "9ZUu":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/soundboks_build-1920-71893b4b9d85479a5989e32c6db510c0.jpg", "placeholder": ""};

/***/ }),

/***/ "AHcM":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/9to5Mac-13abde352b9bc5da224ac771e1da6d32.png", "placeholder": ""};

/***/ }),

/***/ "AYZk":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/Soundboks3-lifestyle-2-large-4ee42b9a8fd8372bd35485432fb6326b.png", "placeholder": ""};

/***/ }),

/***/ "AmAZ":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/USP_battery_375-8851959efef52cf56cd97110bc034265.png", "placeholder": ""};

/***/ }),

/***/ "BVkU":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/soundboks_battery-4b1231e924aa42d32ca899a30310f2e4.jpg", "placeholder": ""};

/***/ }),

/***/ "ChL7":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/Soundboks3-lifestyle-3-large-c75daabfb8cda0462d107c64d368444e.png", "placeholder": ""};

/***/ }),

/***/ "E+LM":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/SBGO_STRAP_DESKTOP-42785cbaf25f522a99116ca34426bb54.jpg", "placeholder": ""};

/***/ }),

/***/ "E7uR":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/WeekenderPack_small-97ff7daeca2b73cbc65006ca435e29d1.jpg", "placeholder": ""};

/***/ }),

/***/ "EjuJ":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/soundboks_slider-1920-09892286c616eaf65fe3faed87056571.jpg", "placeholder": ""};

/***/ }),

/***/ "EnV8":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/usp-sbgo-breakthrough-010e082d7a5e2602c15af2f21bf5e772.jpg", "placeholder": ""};

/***/ }),

/***/ "F1ob":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/icon-amp-e8fed31e7f724b7b19a397a2d7acfa13.png", "placeholder": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAE60lEQVQ4yzVUS28TVxS+DlIX3aBWqlo1QEuCQxI/5nnnZY899ngcO3bs+BESx4EQEwhJwHYednhVCOhLXbULlu0f6IpfwKoVEpt2xR9gD6zaxPY9PXeglo7ujMb3O9/5vnMOseM2cRIpDGfMTbhkKqgQz5urOsn0c8uMvTHN+L+qSpksq0xVtWOqau8opS+Ttr25l1cCB90uKRVLp5qrl0koJBPiOC5GmkhCOCAJErGteCJmxV+YRgxUhYIoyhAORyEciuKzBLKkgCIrQBX1VWl+vkbwBwBkeXklkEIc4rre2Phn4wEvnSGmZh1IogKSxEMeIthAUbSRqhrIkDL8xqIRcSBEeUiAVUF5ofRzo1kjUlglnpsNkJXGJUI1g6TT7sEHIMASB4ZhMcO0geoxJis6k1WdqdRgVLOAn6IgDRF8KCFrqtKnU8EpMjkRDJDFSo2kUumEZcV9ZqZpDe1ECnQjzkSJsggyCYVFmA0J/hkVFEapySwrAajriFchCCLKIa4jOCEJO1nVqPGClxCzYgPXzYJp2UySNQhHJJiZjcLUxRAEg7NwcTrsAyMosjRZ3E5hNfrwg0yvy+XyaWJoxnMuvq4Zw1xunjmpLDMMzpbi5SicnwjC2XMTcO6rSf/kwDyRrGiYOMGSjsuZnlBqgB1L7hBFUt+gHuC6mUGxtAiptPe+HLwwPRPmesGllTVoXd+GufkiXAhO+yxRU7+StJsDO+74LKmi/UkEQflHQYaVSm20UK6yjJcHrqGiGoBmwcrqFbh3/yF8+91P0L/zALK5gp+Im8NL9rLzLIsRCQuQ9bIDIgrKSMOLy8tNtlhZYrl8EVlmwYolwIzZUKuvQHfvEI4QbHu3DbwKUVJBxw5wUhmYyxWhUCiDhppyxzkgambB2to6qy01WKlchVx+AdxMDgQsg7MtL9Z84HKliols0PQYgnmcHRSKi/i9znTdgmgkygg27rGmmbCxsckazXVWX2rgxTqUEMSKJeHr8xfQBGwXnJjpmRk8JeC6zWHS4kKVJ2JL9QZQqnOGjMgSfadgiyDDQevaFjTXrrLV5jpqd5k/Q9LJ+KBfnjnruz6XW0BGS1CpLUN9adX/T622POIDIcvK3wTZvZRQk2JxcXC7vc9arRtsEx29tnkTrt/YgZ3dDmy0tqCxug6rzasIsOGfa1dasHZ5w/9vLlc4eT/n8l0Sjyc2dc18pVELtrfbw+5eD7Z32qzd3ofbnX241d4DTITAXdjavo1JdmHz+g5PyG7ie6u1NUJDAOf7rSLJ40TTSQCbus7LTqW8Yb9/f3R0dB+d7bFe/x4P2D84gr39PnS6vQ/gbdbpHsLurT3mON4xTho4jtP3vAxBUxRcXTLBXfeLKKrgefMDbJHho8ffw4MHj3gPMnz3gXv9u/555+43HHiE/Xcso1xoyLP/1xh3+RR/6XQ6BEt/SnEC4nEHXb9xgmAI/AN7/ORHeIznw4dP4LB3b4RGnCR488sUNE1/Njb28UeHvX1SKBQC2IeU4BYOJG2DnBmfIDjk6+j8ay4BjhSaVYFq9RIrl2uQzy8w23Zw8eoY2ltRkPtfnPmcTJyfxC3vjeXzeUIuTArITCeGbgY++XQ8gOsIV7l0WojKO9GI9EckLA5EPqe4A3GL8xH7C8u8g1tmPDQrkt9/+xVJyAG+uiKRKPkPn2t9iUqzdQ8AAAAASUVORK5CYII="};

/***/ }),

/***/ "FDS1":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/theoutbound-2b9e62d977505026f84e6672977365a1.png", "placeholder": ""};

/***/ }),

/***/ "FYf8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ main_Image; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ imgix_createUrl; });

// UNUSED EXPORTS: butterUrlFormatter, storyblokUrlFormatter, calculateRatio, Ratio

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__("ODXe");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// CONCATENATED MODULE: ./node_modules/@soundboks/elements-image/main/useMediaInfo.tsx
var __jsx = react_default.a.createElement;

/* eslint-disable unicorn/filename-case */


var getWindowDimensions = function getWindowDimensions() {
  var _document$documentEle = document.documentElement,
      clientWidth = _document$documentEle.clientWidth,
      clientHeight = _document$documentEle.clientHeight;
  return "Window Dimension ".concat(clientWidth, "px \u2715 ").concat(clientHeight, "px");
};

function useMediaInfo(visible) {
  var _useState = Object(react["useState"])(""),
      imageLocation = _useState[0],
      setImageLocation = _useState[1];

  var _useState2 = Object(react["useState"])(""),
      windowDimensions = _useState2[0],
      setWindowDimensions = _useState2[1];

  Object(react["useEffect"])(function () {
    var handleResize = function handleResize() {
      return setWindowDimensions(getWindowDimensions());
    };

    window.addEventListener("resize", function () {
      return handleResize;
    });
    handleResize();
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (visible === false) {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return [function () {}, function () {
      return null;
    }, {}];
  }

  var backgroundGrid = {
    backgroundColor: "#269",
    backgroundImage: "linear-gradient(rgba(255,255,255,.5) 2px, transparent 2px), linear-gradient(90deg, rgba(255,255,255,.5) 2px, transparent 2px), linear-gradient(rgba(255,255,255,.28) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.28) 1px, transparent 1px)",
    backgroundSize: "100px 100px, 100px 100px, 20px 20px, 20px 20px",
    backgroundPosition: "-2px -2px, -2px -2px, -1px -1px, -1px -1px"
  };

  var sourceTracker = function sourceTracker(event) {
    setImageLocation(event.target.currentSrc);
  };

  var displayInfo = function displayInfo() {
    return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement("div", {
      // eslint-disable-next-line react-native/no-inline-styles
      style: {
        position: "absolute",
        top: 0,
        left: 0,
        padding: "2px 4px",
        backgroundColor: "rgba(255, 255, 255, 0.7)",
        font: "small monospace"
      }
    }, windowDimensions), /*#__PURE__*/react_default.a.createElement("div", {
      // eslint-disable-next-line react-native/no-inline-styles
      style: {
        position: "absolute",
        bottom: 0,
        left: 0,
        padding: "2px 4px",
        backgroundColor: "rgba(255, 255, 255, 0.7)",
        font: "small monospace"
      }
    }, imageLocation));
  };

  return [sourceTracker, displayInfo, backgroundGrid];
}
// CONCATENATED MODULE: ./node_modules/@soundboks/elements-image/main/common.ts
function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var MediaConditions;

(function (MediaConditions) {
  MediaConditions["Phone"] = "(max-width: 599px)";
  MediaConditions["TabletPortrait"] = "(min-width: 600px)";
  MediaConditions["TabletLandscape"] = "(min-width: 900px)";
  MediaConditions["Desktop"] = "(min-width: 1200px)";
  MediaConditions["BigDesktop"] = "(min-width: 1800px)";
})(MediaConditions || (MediaConditions = {}));

var Ratio;

(function (Ratio) {
  Ratio[Ratio["Square"] = 1] = "Square";
  Ratio[Ratio["FourToThree"] = 0.75] = "FourToThree";
  Ratio[Ratio["ThreeToFour"] = 1.3333333333333333] = "ThreeToFour";
})(Ratio || (Ratio = {}));

var calculateRatio = function calculateRatio(value, ratio) {
  return value * ratio;
};
var isNum = function isNum(value) {
  return typeof value === "number" && !Number.isNaN(value);
};
var withCreateDensityUrlSet = function withCreateDensityUrlSet(createUrl, path, options) {
  var _ref = options || {},
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 0 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 0 : _ref$height,
      _ref$density = _ref.density,
      density = _ref$density === void 0 ? [] : _ref$density;

  var densities = !Array.isArray(density) ? [density] : density;
  var sourceList = [];
  sourceList.push(createUrl(path, {
    width: width,
    height: height
  }));

  var _iterator = _createForOfIteratorHelper(densities),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var value = _step.value;

      if (value > 1) {
        var url = createUrl(path, {
          width: isNum(width) ? width * value : 0,
          height: isNum(height) ? height * value : 0
        });
        sourceList.push("".concat(url, " ").concat(value, "x"));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return sourceList.join(", ");
};
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// CONCATENATED MODULE: ./node_modules/@soundboks/elements-image/main/styles.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var createFrameStyles = function createFrameStyles(width, height, maxWidth, maxHeight, backgroundGrid) {
  return {
    frame: _objectSpread({
      width: width,
      height: height,
      maxWidth: maxWidth,
      maxHeight: maxHeight,
      display: "flex",
      position: "relative",
      justifyContent: "center",
      alignItems: "center",
      overflow: "hidden"
    }, backgroundGrid)
  };
};
var createSourceStyles = function createSourceStyles(objectFit) {
  return {
    picture: {
      display: "block",
      position: "relative",
      width: "100%",
      height: "100%"
    },
    img: {
      display: "block",
      position: "relative",
      height: "100%",
      width: "100%",
      objectFit: objectFit
    }
  };
};
var createAppStyle = function createAppStyle(resizeMode, width, height, maxWidth, maxHeight) {
  return {
    frame: {
      width: width,
      height: height,
      maxWidth: maxWidth,
      maxHeight: maxHeight
    },
    imageNative: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      resizeMode: resizeMode
    }
  };
};
// CONCATENATED MODULE: ./node_modules/@soundboks/elements-image/main/index.tsx

var main_jsx = react_default.a.createElement;





var main_createRanges = function createRanges(sourceSet, mediaCondition) {
  return Array.isArray(sourceSet) ? sourceSet.map(function (param) {
    return /*#__PURE__*/react_default.a.createElement("source", {
      srcSet: param.uriSet,
      type: param.type,
      media: mediaCondition,
      key: "".concat(param.uriSet).concat(mediaCondition)
    });
  }) : /*#__PURE__*/react_default.a.createElement("source", {
    srcSet: sourceSet,
    media: mediaCondition,
    key: "".concat(sourceSet)
  });
};

var main_displaySources = function displaySources(uri, objectFit, ranges, alt, sourceTracker) {
  var styles = createSourceStyles(objectFit);
  var defaultImage = /*#__PURE__*/react_default.a.createElement("img", {
    style: styles.img,
    onLoad: sourceTracker,
    alt: alt,
    src: uri
  });

  if (!ranges) {
    return defaultImage;
  }

  return /*#__PURE__*/react_default.a.createElement("picture", {
    style: styles.picture
  }, (ranges === null || ranges === void 0 ? void 0 : ranges.bigDesktop) && main_createRanges(ranges.bigDesktop, MediaConditions.BigDesktop), (ranges === null || ranges === void 0 ? void 0 : ranges.desktop) && main_createRanges(ranges.desktop, MediaConditions.Desktop), (ranges === null || ranges === void 0 ? void 0 : ranges.tabletLandscape) && main_createRanges(ranges.tabletLandscape, MediaConditions.TabletLandscape), (ranges === null || ranges === void 0 ? void 0 : ranges.tabletPortrait) && main_createRanges(ranges.tabletPortrait, MediaConditions.TabletPortrait), (ranges === null || ranges === void 0 ? void 0 : ranges.phone) && main_createRanges(ranges.phone, MediaConditions.Phone), defaultImage);
};

var main_Image = /*#__PURE__*/react_default.a.memo(function Image(_ref) {
  var uri = _ref.uri,
      ranges = _ref.ranges,
      _ref$objectFit = _ref.objectFit,
      objectFit = _ref$objectFit === void 0 ? "cover" : _ref$objectFit,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? "auto" : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? "auto" : _ref$height,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? "none" : _ref$maxWidth,
      _ref$maxHeight = _ref.maxHeight,
      maxHeight = _ref$maxHeight === void 0 ? "none" : _ref$maxHeight,
      alt = _ref.alt,
      _ref$showInfo = _ref.showInfo,
      showInfo = _ref$showInfo === void 0 ? false : _ref$showInfo;

  var _useMediaInfo = useMediaInfo(showInfo),
      _useMediaInfo2 = Object(slicedToArray["a" /* default */])(_useMediaInfo, 3),
      sourceTracker = _useMediaInfo2[0],
      displayInfo = _useMediaInfo2[1],
      backgroundGrid = _useMediaInfo2[2];

  var styles = createFrameStyles(width, height, maxWidth, maxHeight, backgroundGrid);
  return /*#__PURE__*/react_default.a.createElement("div", {
    style: styles.frame
  }, main_displaySources(uri, objectFit, ranges, alt, sourceTracker), displayInfo());
});
// CONCATENATED MODULE: ./node_modules/@soundboks/elements-image/main/hosts/butter.ts

var baseUrl = "https://cdn.buttercms.com";
var butter_createUrl = function createUrl(path) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!path || path.trim() === "") {
    return "";
  }

  var width = isNum(options.width) ? options.width : 0;
  var height = isNum(options.height) ? options.height : 0;
  var resizeParam = [];

  if (width > 0) {
    resizeParam.push("w:".concat(width));
  }

  if (height > 0) {
    resizeParam.push("h:".concat(height));
  }

  if (width > 0 || height > 0) {
    resizeParam.push("f:crop");
  }

  var url = width > 0 || height > 0 ? new URL("resize=".concat(resizeParam.join(","), "/").concat(path.replace(/^\/+/, "")), baseUrl) : new URL("".concat(path), baseUrl);
  return url.href;
};
var butter_createDensityUrlSet = function createDensityUrlSet(path, options) {
  return withCreateDensityUrlSet(butter_createUrl, path, options);
};
// CONCATENATED MODULE: ./node_modules/@soundboks/elements-image/main/hosts/storyblok.ts

var storyblok_baseUrl = "https://a.storyblok.com";
var baseParamsUrl = "https://img2.storyblok.com";
var storyblok_createUrl = function createUrl(path) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!path || path.trim() === "") {
    return "";
  }

  var width = isNum(options.width) ? options.width : 0;
  var height = isNum(options.height) ? options.height : 0;
  var url = width > 0 || height > 0 ? new URL("".concat(width, "x").concat(height, "/").concat(path.replace(/^\/+/, "")), baseParamsUrl) : new URL("".concat(path), storyblok_baseUrl);
  return url.href;
};
var storyblok_createDensityUrlSet = function createDensityUrlSet(path, options) {
  return withCreateDensityUrlSet(storyblok_createUrl, path, options);
};
// CONCATENATED MODULE: ./node_modules/@soundboks/elements-image/main/hosts/imgix.ts

var imgix_baseUrl = "https://soundboks.imgix.net";
var imgix_createUrl = function createUrl(path) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!path || path.trim() === "") {
    return "";
  }

  var width = isNum(options.width) ? options.width : 0;
  var height = isNum(options.height) ? options.height : 0;
  var url = new URL(path, imgix_baseUrl);

  if (width > 0) {
    url.searchParams.set("w", width.toString());
  }

  if (height > 0) {
    url.searchParams.set("h", height.toString());
  }

  if (width > 0 || height > 0) {
    url.searchParams.set("fit", "crop");
  }

  url.searchParams.set("auto", "format");
  return url.href;
};
var imgix_createDensityUrlSet = function createDensityUrlSet(path, options) {
  return withCreateDensityUrlSet(imgix_createUrl, path, options);
};
// CONCATENATED MODULE: ./node_modules/@soundboks/elements-image/index.ts






/***/ }),

/***/ "G0OZ":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/Soundboks3-lifestyle-1-small-7c4f4282451825bc661ac3f734a0ff49.jpg", "placeholder": ""};

/***/ }),

/***/ "GF5w":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/USP_portability_375-c8f033139e169729141308828483313b.png", "placeholder": ""};

/***/ }),

/***/ "GUDp":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/usp-sbgo-app-caa903ff8f155a700f0dd75c9380badd.png", "placeholder": ""};

/***/ }),

/***/ "HpDZ":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/chip_black-37f20aec48bc1ee7eb8570cc7260b56a.png", "placeholder": ""};

/***/ }),

/***/ "Hsne":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/geekdad_black-75afa1ad52b99f6932ec90103c1e9732.png", "placeholder": ""};

/***/ }),

/***/ "ICjs":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/icon-volume-372a679af81ad04c80207a98bf3107a8.png", "placeholder": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEXklEQVQ4y41UW0hcZxD+zzl7NRrQ9bLGKkrVhwjesGrdqnGtptGkLmh1zW6lAS8xSjWNgg8iSiyKCFpFK/rgk+AlRU2RGEke+iAieGFXK6hQxOtDFZQiVHbPP505aKhESgf+/fecM//3z3zzzTD2H+bn5yeGhoaqcNcGBARoo6KiVPgssv9jgiAou0ajYT4+PpLRaNTgoyo2NpbRSkhIYF9mZpKLFBkZqfb39xdVKtW1sx+BkSGQhJsYHR3NAEBMTU19iGDPUlJSnhUUFOTiO3V+fj65qtBHugnjgwUGBqo7OjpYa2vrbZPJ9OCWh8cbfA3/Xpjyb08rKlIQWIOLhYWFqa6BiKLIPD09mbe3t66oqIhlZmaG4fMGHcYd4uPjZbvd7qqqqnLl5j6UDQZfkCQJwsM/XcXLP2lpaWHIr06v1ytYTK1WU5qaubdv2enp6W0swCaBZZjNrpqaGndXVxefn5/n+/v7/Pj4mL97/959//5XbvKJiIhwYpT6lZUVKqDmilOFD/pJSkrqJccia/HF4OAgb2pq4g0NDTA5Ocm3trb47u4uEDh9y8gwX5BvcnJyB0b8AYNSJRlIeJOA1f397t0oePXqF3l4eJh3d3fz5uZmGBsbg4ODA1hfX4eenh5eVlbGKyoqZEwV7twJ3MazBCbhs8hQWyKRu7Gx4W0wGPZevKiDxcVF+dfXr/nU1BSMjIzAzMwMHB0dwfj4OFRWVkJhYSH/7skT+fMUEyDIH3heSxhIgUD86TFVlp6eXunl5QWjo6Ouzc1Nvry8DKurq7C2tgaU6vb2NgwNDUFjYyPU1tZCfX09z7NYZA8PD8jJyfkmKyuLGbE4Cpl4CwsJCanX6XQUjevk5IRTirjD2dkZHB4eAhYEkHyYnp6GgYEBWtxqLXYJoggYzPfIJSPBM4xKi1qi1Emt0NfX55ZlmRMogWARYGJiAlABynI4HHxubo7Pzs7y9PR7MgoarFZrjs1mY8HBwRpmNpsFTIO1vnxpxI9/4W1wfn4uY1WBDra3t0Nvby/s7e0BXkTF4Ts7O3SJjG1KHJ7gf4PT4WDFxcUC9S5VWUutk5iY2EpRYnVdyB9va2uD6upq3tnZqXB5cXHBkXxAQI7t6CJf5P/Hy7ZDxnSC0oNxcXH0RktvMeyfUOzQ3NLy988DAzLqkPf393On08ndbjdfWFiQ0V/RILZn26WONdjXgtIpVxYeHq7CKjK7zRbg6+u7RQdiYmJI5PJTlMrz5z9ATm6uOzs7W2k9LKLjqp9prN04wagnMSK2tLRkQG57UehnmABgKi7sVWU4pKWl/onTpi02Ns770aOvadRRZh+PGhwKRALJSBEpGerPWFJSkp+XlxdTV1d377OEhEJM1w+1S6NNUQjNzyv/a0b9SM1NUwNv1ROd5eXlzGKxsC9MJvat3U46Y0FBQQrVWq32Fp2hGlz28s1GoHQrWWlpqYDRSQgo2h4/FrG1pLS0NCU9mlI3Af0DWf0TLqn3I6YAAAAASUVORK5CYII="};

/***/ }),

/***/ "IIcZ":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/Soundboks3-lifestyle-5-small-09e59c669cce7d6bd1603bee7d0f49b6.png", "placeholder": ""};

/***/ }),

/***/ "JaE3":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/soundboks_build-7236df03e9d41d02000d0880addc3517.jpg", "placeholder": ""};

/***/ }),

/***/ "JoWG":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/SBGO_STRAP_MOBILE-90d1bb1a689cc0d1525241ff5771da9d.jpg", "placeholder": ""};

/***/ }),

/***/ "JxcM":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/SBGO_lifestyle_2_small-fdddf045c020e163c192f195f1e96e26.png", "placeholder": ""};

/***/ }),

/***/ "KCNt":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/soundboks_slider-1024-f40700e2a9de34a0257749e258d03c41.jpg", "placeholder": ""};

/***/ }),

/***/ "KlDg":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/soundboks_hero-768-9d61ec454277051d276743fea48a695f.jpg", "placeholder": "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAWABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAcFAgj/xAArEAABAwMCBQEJAAAAAAAAAAABAgMEAAUREjEGEyEiUQcjMkFScYGRkqH/xAAWAQEBAQAAAAAAAAAAAAAAAAACAAT/xAAdEQACAQQDAAAAAAAAAAAAAAAAARECEhMhMVFh/9oADAMBAAIRAxEAPwCu3u42h67x2ps6K1ISnW2FOp1frWzaYVrYhLTbm0ll4ZHxB8714uXd3p92ustTyyZOhCyTkrSAMA+fdH4qk8HcezeGrGyylLoZKezSjUlZ+Yknf+UMutiSTqLxMssF6QpfKAPQHTlOT9BSpAv1W5p1PtvBzY8lYCT9iTSrN6KxdEwlsQre0mTCitrRIJPtkglKgBsB0x1FcQLlK5iWZCkONOEpCNA0jAztSlZmLhmiwolHZHipGeuElOT5wDSlKEDk/9k="};

/***/ }),

/***/ "KriC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// productSubPages
var byId = {
  overview: {
    name:
    /*i18n*/
    {
      id: "Overview"
    },
    id: 'overview'
  },
  techspecs: {
    name:
    /*i18n*/
    {
      id: "Tech Specs"
    },
    id: 'techspecs'
  },
  compare: {
    name:
    /*i18n*/
    {
      id: "Compare"
    },
    id: 'compare'
  },
  reviews: {
    name:
    /*i18n*/
    {
      id: "Reviews"
    },
    id: 'reviews'
  },
  teamup: {
    name:
    /*i18n*/
    {
      id: "TeamUp"
    },
    id: 'teamup'
  },
  app: {
    name:
    /*i18n*/
    {
      id: "App"
    },
    id: 'app'
  }
};
var allIds = Object.keys(byId);
module.exports = {
  byId: byId,
  allIds: allIds
};

/***/ }),

/***/ "L76f":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/computer-bild-67824469a93dc1ec1fedc99464fa3739.png", "placeholder": ""};

/***/ }),

/***/ "LDxQ":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/soundboks_slider-eb6999f44261e282e2228d10322e2e5a.jpg", "placeholder": ""};

/***/ }),

/***/ "M0FR":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/Soundboks3-lifestyle-1-small-7c4f4282451825bc661ac3f734a0ff49.jpg", "placeholder": ""};

/***/ }),

/***/ "MYjm":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/Soundboks3-lifestyle-1-large-419fef0b1d6bb3384f3d0583249a5f57.jpg", "placeholder": ""};

/***/ }),

/***/ "Mefb":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/SBGO_lifestyle_2_large-c6cb293f14224be568cf646c74ab5516.png", "placeholder": ""};

/***/ }),

/***/ "MkLq":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/soundboks-components-c414ad225e676415429e48800f083206.jpg", "placeholder": "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAgHBAb/xAArEAABAwMCBAQHAAAAAAAAAAABAgMRAAQFEiEGBwgxE0FRYRQiIzJjcdL/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8A23P8wME47fYjG8RNWectnIWj4YurToUNadJgGRImdpnyrIcl1C3jd08WrZxprWrQ34TaykAx31b/AL2r3HNBWHwudFjbYGzTfZayurtWQbZHioWhxqZVEwoLIJnvA86jq+ulqfuUFPyl5QM7yAo0FDJ6hcgtIUlBIP4Ef1Sp5LiZ+jqQiBtPf3pQX1zPt2Twhk7ktINwlkNhzSNQSXEEifQkDb2FQG62krvVn7hcFIPoCTSlBzaiAI2mlKUH/9k="};

/***/ }),

/***/ "NSeO":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/play_experience-cf810a6587e1ab4e4103fab6115065dc.webp", "placeholder": ""};

/***/ }),

/***/ "NXYy":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/product",
      function () {
        return __webpack_require__("kLgK");
      }
    ]);
  

/***/ }),

/***/ "ONLd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return libraries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return klarnaDataKeys; });
var libraries = {
  // Docs: https://docs.affirm.com/Integrate_Affirm/Promotional_Messaging
  affirm: {
    id: 'sb-affirm',
    url: '/static/scripts/affirmScript.js'
  },
  // https://developers.klarna.com/documentation/on-site-messaging/getting-started/
  // https://x.klarnacdn.net/plugins/KlarnaOnSiteMessagingapponShopifySupportGuide.html
  klarnaDE: {
    id: 'sb-klarna-de',
    url: 'https://eu-library.klarnaservices.com/lib.js',
    clientId: '469bf45e-d307-516b-a590-bd65832268f8'
  },
  klarnaNO: {
    id: 'sb-klarna-no',
    url: 'https://eu-library.klarnaservices.com/lib.js',
    clientId: '8cd5c8d5-2cc0-53de-a3b8-2f7cab77bf04'
  },
  klarnaDK: {
    id: 'sb-klarna-dk',
    url: 'https://eu-library.klarnaservices.com/lib.js',
    clientId: '11f9a365-884d-5854-ba2d-9653a73f0986'
  }
};
var klarnaDataKeys = {
  creditSmall: 'credit-promotion-small',
  creditStandard: 'credit-promotion-standard',
  creditAuto: 'credit-promotion-auto-size'
};

/***/ }),

/***/ "OZZO":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/soundboks_hero-8510c14caf911e3f8fa2278274359045.jpg", "placeholder": ""};

/***/ }),

/***/ "OeER":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/soundboks_sound-768-d15bb21e924644b8254593eb79beee93.jpg", "placeholder": "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAKABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAUEBgcI/8QAJhAAAgECBgEEAwAAAAAAAAAAAQIDBBEABQYHEiETIiMkMTJRcf/EABUBAQEAAAAAAAAAAAAAAAAAAAEA/8QAGxEBAAICAwAAAAAAAAAAAAAAAQARAgMiMaH/2gAMAwEAAhEDEQA/ALTrbX9RpHU0+RuZGrXg8kLIvkVmYHxAD7JJHY6sB/MRsq3ppKmKkoqpmSskSNTUx2ZC5AHIgfjd+rW6uL4y7c35GuR5/d5LFy5+q/oH3fCvbGKN8wqWdEZkamKki5HyE+sOfGOgdi43Xfhc6v09QLnuWLX5XnWYPTtJJGWL2PNHKt0R+1ODCDZCWRNtst4SOt5agmzEXPnk7wYhYoDP/9k="};

/***/ }),

/***/ "OgpL":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/tech_drawing-acee29f1348462ff8df436bb235fbbf4.jpg", "placeholder": "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAUABQDASIAAhEBAxEB/8QAGAABAQADAAAAAAAAAAAAAAAAAAIBAwj/xAAiEAACAgEDBAMAAAAAAAAAAAAAAQIRIQMxURITIoFCYaH/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8A6knJ4vHNENyXy+y9VKLT33deiFSTqnad0gNilqZ8Y4fILiq9gBKKlXUrMduPH6ABQAA//9k="};

/***/ }),

/***/ "PndN":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/digitaltrends-f05f5438483a35b0d4bb65e9a4897130.png", "placeholder": ""};

/***/ }),

/***/ "Q3bz":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/games-mag-1c49c47639dffbad3bf1fb52b52be2be.png", "placeholder": ""};

/***/ }),

/***/ "QN2O":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/dinside_black-94026dda2a435eb2fae16e69ec0a34f1.png", "placeholder": ""};

/***/ }),

/***/ "QevL":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/bonedo-06fd765bd8a7ff4f2eeee1a3b78843d3.png", "placeholder": ""};

/***/ }),

/***/ "R+0+":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/soundboks_2-d817c7d652b272af7f78e7698efaceb9.png", "placeholder": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFF0lEQVQ4y1XUyW9aVxQH4NO+LLus2sQEzGhmYzM8ZjDggcmAwQwG24ANBmM8BQ+J7dhx0iQkcSJXyiJtum4WlSKlat1l1H8iUpddVOqyi24q43t6wFGtPunoCj3e9373nvsuPHr4GKrVKmSzOWg0VqC5sgLv3r6F589OqJ7D/aNj2Lq1BQulRZhKJCGRmAKH0wXfvXoFpyfP4GhvHw5u34aHx8fQux4/avfAfD4P9Xpd0Vxp6H969+MXT9tPVc+enpjuHd7ztjZbkXJpITeVSJWSU6n9aDjywzcvXwbaXz0Q3tne+Wy31YLjg4NLcHfnNszPzXGpZBJKpVJ7tdnEFyfP/7p/fP+faqXamcnlkVLh2Ng4ut1etFh4nE5N49cvTtluaxub9UaVCtYaTa4Hvn//K7Qfta8dHR7Bg/sPlp60n+DZz2f45vs3GIvF0eX2oM3mYGaL9WLQMNTR6QfP15pr58lMkQUCQWytboTWG02olquf9sAPH36D9uM2t7O9C3cPDmuvv32Nv5ydnZ+enrJgMMycLg/jrXY2bDQznd7A1Botqy5WWDSRZd6RAG40VsebSw0ozy9cgvmZAhzePeIO9u/2wC2aBjWqMzdXZB6vDwOj42jhbThkNKFaq0PFgBJpPdnmRosFx0NYyBWC2eksZNPZS7B7bW/t9MD9vYPa/HwJxyeCHbd3hLk8I2h3unuY0WxBpUqNEqkc52bnWHF2ntltdpzJzAST8SRMxaeuwPW1TW6rtdOF67ncDIZCkQ5hjKcHjGYeff4AmgiUDwygSCzBbCbHHA4nG6C09Uo9WClXIJlIXYHLyyvcxvombGzcqk9SI2x2Z8fucLFhkxktVhuaeSthSpQqFCgQ9WM4HGXp6QwbDYxhKpEMJWIJiE/Gr8BKZYlrUKdWVpq1YCjcRTqUjhmMRtTo9DigUqGMMLFMhgKhCMfGJ5h+0MAUlDiXzoYzqWmYGJ+4AsvlBW5pqQ612nKN1g8J69CaMa1ej0qNppdOLJWiUCzGPqGwu5WYy+VmxuFhHAuMhkc8HvCP+Lj/wGKxzFFK+mJqtcDoGBpN5o5WP8gUSpqmXI79HzGBSITXb95Es4VnNquVqVRKDPj9Ea/bA1RXIG0RbmGxAouVpZp3xIc0nY5CqWLdaXbRLtgnEvbSfdnXh3qDgQ1RDQwougmjPq/3/+BMvsDNF8tQLC3U3B4PqjWaDmFMQmt22QhRD7tB6bqgRqtlWipFDwxMXoLuS7CxXIN0Osvl8wUoFOZqDqcTVWp1hzAmkkh6U5XRg93xOmHXBYLufaZUKS8UCjmOBwIx/0cwm4gD7NHRE48nuNR0GtKZTM1ssVBH5ecSmZRAMdPodLR9TOxmv4jdEAgYJWQDSiWTK+QXMrkMfR5PzO10gMNu5xDxEqRD4FoymQKqqslkRLFEwqQyKXVW0u0u66ffApHwQiAUdijhuVQmO+8X919I6P6o35/sdtnjcnF//vE70OG5CZFImItGwlDIz5y4nA4cHh76W6vVXKjUKqQkKKNOSykNpabPT4UulwvNlNrK85hOJltTsRgkJiev1RdKAAd7d8BqNX/C8yaIRkJGu433BQJ+Oc9bzDqd1qXVaUcJjqo16gyt26x+UN/y+0beFGcLY9FQUO2w8p8bDYPgtFlhe32Vpry7CwaDDoYMeoiGQ2Cz8eD3++glPBAIBAKBoNGoaVSCXk//i8ZgvlCAeDTSg0zDQ71xa20V/gWBGhxjpxlmfAAAAABJRU5ErkJggg=="};

/***/ }),

/***/ "RJ4o":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/SBGO_lifestyle_4_small-588fbe392449e1ae6b4288bb2043c0c0.png", "placeholder": ""};

/***/ }),

/***/ "RX7f":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/usp-app-3b56aaafd0b383fe8bb809acd5e22f7d.png", "placeholder": ""};

/***/ }),

/***/ "RaHW":
/***/ (function(module, exports) {

module.exports = { "url": "data:image/svg+xml;base64,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" };

/***/ }),

/***/ "RyK0":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/soundboks_sound-d33a95a51f73000389dbaec25688d428.jpg", "placeholder": ""};

/***/ }),

/***/ "S7QA":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/SBGO_lifestyle_1_large-9cbacaf031f028d877ffa5f926bd99f2.jpg", "placeholder": ""};

/***/ }),

/***/ "T2M4":
/***/ (function(module, exports) {

module.exports = { "url": "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIgogICB4bWxuczpjYz0iaHR0cDovL2NyZWF0aXZlY29tbW9ucy5vcmcvbnMjIgogICB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiCiAgIHhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgeG1sbnM6c29kaXBvZGk9Imh0dHA6Ly9zb2RpcG9kaS5zb3VyY2Vmb3JnZS5uZXQvRFREL3NvZGlwb2RpLTAuZHRkIgogICB4bWxuczppbmtzY2FwZT0iaHR0cDovL3d3dy5pbmtzY2FwZS5vcmcvbmFtZXNwYWNlcy9pbmtzY2FwZSIKICAgd2lkdGg9IjE4My41IgogICBoZWlnaHQ9IjMwIgogICB2aWV3Qm94PSIwIDAgMTgzLjUgMzAiCiAgIHZlcnNpb249IjEuMSIKICAgaWQ9InN2Zzc4IgogICBzb2RpcG9kaTpkb2NuYW1lPSJyZXZpZXctc3RhcnMxLnN2ZyIKICAgaW5rc2NhcGU6dmVyc2lvbj0iMC45Mi40ICg1ZGE2ODljMzEzLCAyMDE5LTAxLTE0KSI+CiAgPG1ldGFkYXRhCiAgICAgaWQ9Im1ldGFkYXRhODQiPgogICAgPHJkZjpSREY+CiAgICAgIDxjYzpXb3JrCiAgICAgICAgIHJkZjphYm91dD0iIj4KICAgICAgICA8ZGM6Zm9ybWF0PmltYWdlL3N2Zyt4bWw8L2RjOmZvcm1hdD4KICAgICAgICA8ZGM6dHlwZQogICAgICAgICAgIHJkZjpyZXNvdXJjZT0iaHR0cDovL3B1cmwub3JnL2RjL2RjbWl0eXBlL1N0aWxsSW1hZ2UiIC8+CiAgICAgICAgPGRjOnRpdGxlPjwvZGM6dGl0bGU+CiAgICAgIDwvY2M6V29yaz4KICAgIDwvcmRmOlJERj4KICA8L21ldGFkYXRhPgogIDxkZWZzCiAgICAgaWQ9ImRlZnM4MiIgLz4KICA8c29kaXBvZGk6bmFtZWR2aWV3CiAgICAgcGFnZWNvbG9yPSIjZmZmZmZmIgogICAgIGJvcmRlcmNvbG9yPSIjNjY2NjY2IgogICAgIGJvcmRlcm9wYWNpdHk9IjEiCiAgICAgb2JqZWN0dG9sZXJhbmNlPSIxMCIKICAgICBncmlkdG9sZXJhbmNlPSIxMCIKICAgICBndWlkZXRvbGVyYW5jZT0iMTAiCiAgICAgaW5rc2NhcGU6cGFnZW9wYWNpdHk9IjAiCiAgICAgaW5rc2NhcGU6cGFnZXNoYWRvdz0iMiIKICAgICBpbmtzY2FwZTp3aW5kb3ctd2lkdGg9IjE5MjAiCiAgICAgaW5rc2NhcGU6d2luZG93LWhlaWdodD0iMTAwMSIKICAgICBpZD0ibmFtZWR2aWV3ODAiCiAgICAgc2hvd2dyaWQ9ImZhbHNlIgogICAgIGlua3NjYXBlOnpvb209IjYuMDU0NTAxNiIKICAgICBpbmtzY2FwZTpjeD0iNzUuODE5ODMiCiAgICAgaW5rc2NhcGU6Y3k9IjExLjgyMzEwNSIKICAgICBpbmtzY2FwZTp3aW5kb3cteD0iLTkiCiAgICAgaW5rc2NhcGU6d2luZG93LXk9Ii05IgogICAgIGlua3NjYXBlOndpbmRvdy1tYXhpbWl6ZWQ9IjEiCiAgICAgaW5rc2NhcGU6Y3VycmVudC1sYXllcj0icmV2aWV3LXN0YXJzIgogICAgIHVuaXRzPSJpbiIgLz4KICA8ZwogICAgIGlkPSJyZXZpZXctc3RhcnMiCiAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTI1MC4wMDEsLTEwNjUzKSI+CiAgICA8cGF0aAogICAgICAgaWQ9IlBhdGhfNDc1IgogICAgICAgZGF0YS1uYW1lPSJQYXRoIDQ3NSIKICAgICAgIGQ9Ik0gMTYuODEsMC42MzQgMjAuOCw4LjcgYSAxLjE1MSwxLjE1MSAwIDAgMCAwLjg2LDAuNjIyIGwgOC45MTUsMS4yOTQgQSAxLjEyOCwxLjEyOCAwIDAgMSAzMS4yLDEyLjU0IGwgLTYuNDQ2LDYuMjcgYSAxLjE1MywxLjE1MyAwIDAgMCAtMC4zMjQsMS4wMDggbCAxLjUyMSw4Ljg1NyBBIDEuMTM0LDEuMTM0IDAgMCAxIDI0LjMsMjkuODY4IGwgLTcuOTgsLTQuMTggYSAxLjE0LDEuMTQgMCAwIDAgLTEuMDYsMCBsIC03Ljk4LDQuMTggQSAxLjEzNCwxLjEzNCAwIDAgMSA1LjYzNCwyOC42NzQgTCA3LjE1NSwxOS44MTcgQSAxLjE1MywxLjE1MyAwIDAgMCA2LjgzMSwxOC44MDkgTCAwLjM4OSwxMi41NCBBIDEuMTMsMS4xMyAwIDAgMSAxLjAxMiwxMC42MTIgTCA5LjkyNyw5LjMxOCBhIDEuMTQzLDEuMTQzIDAgMCAwIDAuODYsLTAuNjIyIGwgMy45OTEsLTguMDYyIGEgMS4xMzEsMS4xMzEgMCAwIDEgMi4wMzIsMCB6IgogICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjQ5Ljk1NSwxMDY1MykiCiAgICAgICBpbmtzY2FwZTpjb25uZWN0b3ItY3VydmF0dXJlPSIwIgogICAgICAgc3R5bGU9ImZpbGw6IzAwMCIgLz4KICAgIDxwYXRoCiAgICAgICBpZD0iUGF0aF85NTAiCiAgICAgICBkYXRhLW5hbWU9IlBhdGggOTUwIgogICAgICAgZD0ibSAzMDUuMzA1MywxMDY1My45MjIgMy45OSw4LjA2NiBhIDEuMTUxLDEuMTUxIDAgMCAwIDAuODYsMC42MjIgbCA4LjkxNSwxLjI5NCBhIDEuMTI4LDEuMTI4IDAgMCAxIDAuNjI1LDEuOTI0IGwgLTYuNDQ2LDYuMjcgYSAxLjE1MywxLjE1MyAwIDAgMCAtMC4zMjQsMS4wMDggbCAxLjUyMSw4Ljg1NyBhIDEuMTM0LDEuMTM0IDAgMCAxIC0xLjY1MSwxLjE5MyBsIC03Ljk4LC00LjE4IGEgMS4xNCwxLjE0IDAgMCAwIC0xLjA2LDAgbCAtNy45OCw0LjE4IGEgMS4xMzQsMS4xMzQgMCAwIDEgLTEuNjQ2LC0xLjE5NCBsIDEuNTIxLC04Ljg1NyBhIDEuMTUzLDEuMTUzIDAgMCAwIC0wLjMyNCwtMS4wMDggbCAtNi40NDIsLTYuMjY5IGEgMS4xMywxLjEzIDAgMCAxIDAuNjIzLC0xLjkyOCBsIDguOTE1LC0xLjI5NCBhIDEuMTQzLDEuMTQzIDAgMCAwIDAuODYsLTAuNjIyIGwgMy45OTEsLTguMDYyIGEgMS4xMzEsMS4xMzEgMCAwIDEgMi4wMzIsMCB6IgogICAgICAgaW5rc2NhcGU6Y29ubmVjdG9yLWN1cnZhdHVyZT0iMCIKICAgICAgIHN0eWxlPSJmaWxsOiMwMDAiIC8+CiAgICA8cGF0aAogICAgICAgaWQ9IlBhdGhfOTUxIgogICAgICAgZGF0YS1uYW1lPSJQYXRoIDk1MSIKICAgICAgIGQ9Im0gMzQzLjM3OTY3LDEwNjUzLjc3MiAzLjk5LDguMDY2IGEgMS4xNTEsMS4xNTEgMCAwIDAgMC44NiwwLjYyMiBsIDguOTE1LDEuMjk0IGEgMS4xMjgsMS4xMjggMCAwIDEgMC42MjUsMS45MjQgbCAtNi40NDYsNi4yNyBhIDEuMTUzLDEuMTUzIDAgMCAwIC0wLjMyNCwxLjAwOCBsIDEuNTIxLDguODU3IGEgMS4xMzQsMS4xMzQgMCAwIDEgLTEuNjUxLDEuMTkzIGwgLTcuOTgsLTQuMTggYSAxLjE0LDEuMTQgMCAwIDAgLTEuMDYsMCBsIC03Ljk4LDQuMTggYSAxLjEzNCwxLjEzNCAwIDAgMSAtMS42NDYsLTEuMTk0IGwgMS41MjEsLTguODU3IGEgMS4xNTMsMS4xNTMgMCAwIDAgLTAuMzI0LC0xLjAwOCBsIC02LjQ0MiwtNi4yNjkgYSAxLjEzLDEuMTMgMCAwIDEgMC42MjMsLTEuOTI4IGwgOC45MTUsLTEuMjk0IGEgMS4xNDMsMS4xNDMgMCAwIDAgMC44NiwtMC42MjIgbCAzLjk5MSwtOC4wNjIgYSAxLjEzMSwxLjEzMSAwIDAgMSAyLjAzMiwwIHoiCiAgICAgICBpbmtzY2FwZTpjb25uZWN0b3ItY3VydmF0dXJlPSIwIgogICAgICAgc3R5bGU9ImZpbGw6IzAwMCIgLz4KICAgIDxwYXRoCiAgICAgICBpZD0iUGF0aF85NTAtNCIKICAgICAgIGRhdGEtbmFtZT0iUGF0aCA5NTAiCiAgICAgICBkPSJtIDM4MC45NDQ4NywxMDY1My44MDMgMy45OSw4LjA2NiBhIDEuMTUxLDEuMTUxIDAgMCAwIDAuODYsMC42MjIgbCA4LjkxNSwxLjI5NCBhIDEuMTI4LDEuMTI4IDAgMCAxIDAuNjI1LDEuOTI0IGwgLTYuNDQ2LDYuMjcgYSAxLjE1MywxLjE1MyAwIDAgMCAtMC4zMjQsMS4wMDggbCAxLjUyMSw4Ljg1NyBhIDEuMTM0LDEuMTM0IDAgMCAxIC0xLjY1MSwxLjE5MyBsIC03Ljk4LC00LjE4IGEgMS4xNCwxLjE0IDAgMCAwIC0xLjA2LDAgbCAtNy45OCw0LjE4IGEgMS4xMzQsMS4xMzQgMCAwIDEgLTEuNjQ2LC0xLjE5NCBsIDEuNTIxLC04Ljg1NyBhIDEuMTUzLDEuMTUzIDAgMCAwIC0wLjMyNCwtMS4wMDggbCAtNi40NDIsLTYuMjY5IGEgMS4xMywxLjEzIDAgMCAxIDAuNjIzLC0xLjkyOCBsIDguOTE1LC0xLjI5NCBhIDEuMTQzLDEuMTQzIDAgMCAwIDAuODYsLTAuNjIyIGwgMy45OTEsLTguMDYyIGEgMS4xMzEsMS4xMzEgMCAwIDEgMi4wMzIsMCB6IgogICAgICAgaW5rc2NhcGU6Y29ubmVjdG9yLWN1cnZhdHVyZT0iMCIKICAgICAgIHN0eWxlPSJmaWxsOiMwMDAiIC8+CiAgICA8cGF0aAogICAgICAgaWQ9IlBhdGhfOTUxLTUiCiAgICAgICBkYXRhLW5hbWU9IlBhdGggOTUxIgogICAgICAgZD0ibSA0MTguODg4NzEsMTA2NTMuODE4IDMuOTksOC4wNjYgYSAxLjE1MSwxLjE1MSAwIDAgMCAwLjg2LDAuNjIyIGwgOC45MTUsMS4yOTQgYSAxLjEyOCwxLjEyOCAwIDAgMSAwLjYyNSwxLjkyNCBsIC02LjQ0Niw2LjI3IGEgMS4xNTMsMS4xNTMgMCAwIDAgLTAuMzI0LDEuMDA4IGwgMS41MjEsOC44NTcgYSAxLjEzNCwxLjEzNCAwIDAgMSAtMS42NTEsMS4xOTMgbCAtNy45OCwtNC4xOCBhIDEuMTQsMS4xNCAwIDAgMCAtMS4wNiwwIGwgLTcuOTgsNC4xOCBhIDEuMTM0LDEuMTM0IDAgMCAxIC0xLjY0NiwtMS4xOTQgbCAxLjUyMSwtOC44NTcgYSAxLjE1MywxLjE1MyAwIDAgMCAtMC4zMjQsLTEuMDA4IGwgLTYuNDQyLC02LjI2OSBhIDEuMTMsMS4xMyAwIDAgMSAwLjYyMywtMS45MjggbCA4LjkxNSwtMS4yOTQgYSAxLjE0MywxLjE0MyAwIDAgMCAwLjg2LC0wLjYyMiBsIDMuOTkxLC04LjA2MiBhIDEuMTMxLDEuMTMxIDAgMCAxIDIuMDMyLDAgeiIKICAgICAgIGlua3NjYXBlOmNvbm5lY3Rvci1jdXJ2YXR1cmU9IjAiCiAgICAgICBzdHlsZT0iZmlsbDojMDAwIiAvPgogIDwvZz4KPC9zdmc+Cg==" };

/***/ }),

/***/ "T2cC":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/Soundboks3-lifestyle-4-small-cc4b93fd4617c18fc96261dfdde4b0ef.png", "placeholder": ""};

/***/ }),

/***/ "TCdS":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/ElevationPack-lifestyle-large-692fdf8abe7a0bc49e191745f4ea7d03.jpg", "placeholder": ""};

/***/ }),

/***/ "TMeu":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/Soundboks3-lifestyle-2-large-4ee42b9a8fd8372bd35485432fb6326b.png", "placeholder": ""};

/***/ }),

/***/ "Tdr2":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/SBGO_lifestyle_3_small-ed6f1c80a297d576bc9353a1c105827c.png", "placeholder": ""};

/***/ }),

/***/ "Tu7v":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/curved-cec70f9d40bfc74888ba0673bb249620.png", "placeholder": ""};

/***/ }),

/***/ "U3dx":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/Soundboks3-lifestyle-3-large-c75daabfb8cda0462d107c64d368444e.png", "placeholder": ""};

/***/ }),

/***/ "UmJs":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/PerformerPack-lifestyle-small-e17e4143d7f300ce6ccd6b0cb36960ad.jpg", "placeholder": ""};

/***/ }),

/***/ "Uw/i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 23 modules
var es = __webpack_require__("/MKj");

// EXTERNAL MODULE: ./data/regions.js
var regions = __webpack_require__("keR7");
var regions_default = /*#__PURE__*/__webpack_require__.n(regions);

// EXTERNAL MODULE: ./data/abstractProducts.js
var abstractProducts = __webpack_require__("eTmy");
var abstractProducts_default = /*#__PURE__*/__webpack_require__.n(abstractProducts);

// EXTERNAL MODULE: ./data/productImages.js
var productImages = __webpack_require__("GQ8G");
var productImages_default = /*#__PURE__*/__webpack_require__.n(productImages);

// EXTERNAL MODULE: ./data/shops.js
var shops = __webpack_require__("z1id");
var shops_default = /*#__PURE__*/__webpack_require__.n(shops);

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./utils/paramToResolutions.js
var paramToResolutions = __webpack_require__("vE80");

// EXTERNAL MODULE: ./components/atoms/Link/index.tsx
var Link = __webpack_require__("ZT91");

// EXTERNAL MODULE: ./components/atoms/Text/index.js + 17 modules
var Text = __webpack_require__("wCgk");

// EXTERNAL MODULE: ./data/productMainUrls.js
var productMainUrls = __webpack_require__("v8DS");

// EXTERNAL MODULE: ./styles/theme.js
var theme = __webpack_require__("NVT0");

// EXTERNAL MODULE: ./components/shared/Row/index.js
var Row = __webpack_require__("OfJt");

// EXTERNAL MODULE: ./components/atoms/Picture/index.js + 3 modules
var Picture = __webpack_require__("Z1QS");

// EXTERNAL MODULE: ./node_modules/@lingui/react/index.js
var _lingui_react = __webpack_require__("ZD0w");

// CONCATENATED MODULE: ./components/shared/ShopSection/ProductInfo.js
var __jsx = react_default.a.createElement;




var Desc = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductInfo__Desc",
  componentId: "sc-1c4bcra-0"
})([""]);
var PriceWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductInfo__PriceWrapper",
  componentId: "sc-1c4bcra-1"
})(["display:flex;justify-content:center;h2{margin:0 5px;}"]);
var Price = Object(styled_components_browser_esm["default"])(Text["d" /* H2 */]).withConfig({
  displayName: "ProductInfo__Price",
  componentId: "sc-1c4bcra-2"
})(["color:", ";"], function (props) {
  return props.oldPrice ? props.theme.colors.primary : props.theme.colors.white;
});
var OldPrice = Object(styled_components_browser_esm["default"])(Text["d" /* H2 */]).withConfig({
  displayName: "ProductInfo__OldPrice",
  componentId: "sc-1c4bcra-3"
})(["text-decoration:line-through;color:", ";text-decoration-color:", ";"], function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.colors.primary;
});
var OfferText = Object(styled_components_browser_esm["default"])(Text["d" /* H2 */]).withConfig({
  displayName: "ProductInfo__OfferText",
  componentId: "sc-1c4bcra-4"
})(["color:", ";text-align:center;"], function (props) {
  return props.theme.colors.white;
});

var ProductInfo_ProductInfo = function ProductInfo(_ref) {
  var title = _ref.title,
      oldPrice = _ref.oldPrice,
      price = _ref.price,
      currencyCode = _ref.currencyCode;
  return /*#__PURE__*/react_default.a.createElement(Desc, null, /*#__PURE__*/react_default.a.createElement(OfferText, null, title), /*#__PURE__*/react_default.a.createElement(PriceWrapper, null, oldPrice && /*#__PURE__*/react_default.a.createElement(OldPrice, null, /*#__PURE__*/react_default.a.createElement(_lingui_react["NumberFormat"], {
    value: oldPrice,
    format: {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }
  })), /*#__PURE__*/react_default.a.createElement(Price, {
    oldPrice: oldPrice
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["NumberFormat"], {
    value: price,
    format: {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }
  }))));
};

ProductInfo_ProductInfo.defaultProps = {
  oldPrice: null
};
/* harmony default export */ var ShopSection_ProductInfo = (ProductInfo_ProductInfo);
// CONCATENATED MODULE: ./components/shared/ShopSection/Component.js
var Component_jsx = react_default.a.createElement;











var Component_getImageOptions = function getImageOptions(image) {
  return [{
    src: image.url,
    width: 640,
    height: 640,
    media: theme["a" /* default */].breakpoints.desktopLarge,
    key: '1'
  }, {
    src: image.url,
    width: 344,
    height: 344,
    media: theme["a" /* default */].breakpoints.tablet,
    key: '2'
  }, {
    src: image.url,
    width: 640,
    height: 640,
    key: '3'
  }];
};

var Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Component__Wrapper",
  componentId: "iiknq4-0"
})(["overflow:", ";background-color:", ";min-height:300px;", ";@media ", "{margin-bottom:5px;}"], function (props) {
  return props.isVisible ? 'visible' : 'hidden';
}, function (props) {
  return props.theme.colors.black;
}, Object(paramToResolutions["a" /* default */])('padding', ['50px 0', '60px 0', '70px 0', '100px 0']), function (props) {
  return props.theme.breakpoints.tablet;
});
var OffersWrapper = Object(styled_components_browser_esm["default"])(Row["a" /* default */]).withConfig({
  displayName: "Component__OffersWrapper",
  componentId: "iiknq4-1"
})(["position:relative;display:grid;justify-content:space-between;grid-column-gap:", "px;", ";"], function (props) {
  return props.theme.halfBaseline * 5;
}, Object(paramToResolutions["a" /* default */])('grid-template-columns', ['1fr', '1fr 1fr', '1fr 1fr 1fr']));
var BgText = Object(styled_components_browser_esm["default"])(Text["g" /* Highlight1 */]).withConfig({
  displayName: "Component__BgText",
  componentId: "iiknq4-2"
})(["position:absolute;text-align:center;top:-1em;font-size:", "px;color:", ";"], function (props) {
  return props.theme.halfBaseline * 7;
}, function (props) {
  return props.theme.colors.grey1;
});
var OfferWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Component__OfferWrapper",
  componentId: "iiknq4-3"
})(["cursor:pointer;position:relative;margin-bottom:40px;&:last-child{margin-bottom:0;}@media ", "{display:none;&:nth-of-type(-n + 3){display:block;}}@media ", "{transition:all 0.2s ease-in-out;&:hover{transform:scale(1.05);}}"], function (props) {
  return props.theme.breakpoints.onlyTablet;
}, function (props) {
  return props.theme.breakpoints.desktop;
});
var ImageOuter = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Component__ImageOuter",
  componentId: "iiknq4-4"
})(["@media ", "{max-width:400px;margin:0 auto;}"], function (props) {
  return props.theme.breakpoints.onlyMobile;
});
var ImageWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Component__ImageWrapper",
  componentId: "iiknq4-5"
})(["position:relative;width:100%;padding-bottom:100%;@media ", "{margin-bottom:30px;}> div{position:absolute;width:100%;height:100%;}"], function (props) {
  return props.theme.breakpoints.desktopLarge;
});

var Component_Offer = function Offer(_ref) {
  var _ref$product = _ref.product,
      oldPrice = _ref$product.oldPrice,
      price = _ref$product.price,
      title = _ref$product.title,
      image = _ref$product.image,
      handle = _ref$product.handle,
      currencyCode = _ref.currencyCode;
  var productMainUrl = productMainUrls["a" /* default */][handle];
  return /*#__PURE__*/react_default.a.createElement(Link["a" /* default */], {
    href: productMainUrl.handler,
    as: productMainUrl.url
  }, /*#__PURE__*/react_default.a.createElement(OfferWrapper, null, /*#__PURE__*/react_default.a.createElement(ImageOuter, null, /*#__PURE__*/react_default.a.createElement(ImageWrapper, null, /*#__PURE__*/react_default.a.createElement(Picture["a" /* default */], {
    images: Component_getImageOptions(image),
    placeholder: image.placeholder,
    alt: "product image"
  }))), /*#__PURE__*/react_default.a.createElement(ShopSection_ProductInfo, {
    oldPrice: oldPrice,
    price: price,
    title: title,
    currencyCode: currencyCode
  })));
};

var Component_ShopSection = function ShopSection(_ref2) {
  var products = _ref2.products,
      currencyCode = _ref2.currencyCode,
      isVisible = _ref2.isVisible;
  return /*#__PURE__*/react_default.a.createElement(Wrapper, {
    isVisible: isVisible
  }, /*#__PURE__*/react_default.a.createElement(OffersWrapper, null, /*#__PURE__*/react_default.a.createElement(BgText, null, "Shop", /*#__PURE__*/react_default.a.createElement("br", null), "Shop", /*#__PURE__*/react_default.a.createElement("br", null), "Shop"), products.map(function (product) {
    return /*#__PURE__*/react_default.a.createElement(Component_Offer, {
      key: product.id,
      product: product,
      currencyCode: currencyCode
    });
  })));
};

Component_ShopSection.defaultProps = {
  isVisible: false
};
/* harmony default export */ var Component = (Component_ShopSection);
// CONCATENATED MODULE: ./components/shared/ShopSection/Container.js

var Container_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









var Container_ConnectedShopSectionContainer = function ConnectedShopSectionContainer(_ref) {
  var products = _ref.products,
      variants = _ref.variants,
      crossSellHandles = _ref.crossSellHandles,
      currencyCode = _ref.currencyCode,
      isVisible = _ref.isVisible;
  var crossSalesProducts = crossSellHandles.reduce(function (acc, handle) {
    var product = products.find(function (p) {
      return p.handle === handle;
    });

    if (!product) {
      return acc;
    } // eslint-disable-next-line max-len


    var imageId = abstractProducts_default.a.byId[product.handle].productImageIds[0]; // find related product // get its first image

    var variant = product.variantIds[0]; // get first product variant

    var oldPrice = variants[variant].compareAtPrice;
    var price = variants[variant].price;
    acc.push(_objectSpread(_objectSpread({}, product), {}, {
      image: productImages_default.a.byId[imageId],
      price: price,
      oldPrice: oldPrice
    }));
    return acc;
  }, []);
  return /*#__PURE__*/react_default.a.createElement(Component, {
    products: crossSalesProducts,
    currencyCode: currencyCode,
    isVisible: isVisible
  });
};

Container_ConnectedShopSectionContainer.defaultProps = {
  isVisible: false
};

// Map state to props
var Container_mapStateToProps = function mapStateToProps(state) {
  var regionId = state.settings.regionId;
  var _regions$byId$regionI = regions_default.a.byId[regionId],
      shopId = _regions$byId$regionI.shopId,
      currencyCode = _regions$byId$regionI.currencyId;
  var shopCurrencyCode = shops_default.a.byId[shopId].currencyId;
  var allProducts = state.entities.products;
  var filteredProducts = allProducts.allIds.reduce(function (acc, productId) {
    var product = allProducts.byId[productId];

    if (product.shopId === shopId) {
      acc.push(product);
    }

    return acc;
  }, []);
  return {
    products: filteredProducts,
    variants: state.entities.variants.byId,
    currencyCode: currencyCode,
    shopCurrencyCode: shopCurrencyCode
  };
};

var ShopSectionContainer = Object(es["b" /* connect */])(Container_mapStateToProps)(Container_ConnectedShopSectionContainer);
/* harmony default export */ var Container = (ShopSectionContainer);
// CONCATENATED MODULE: ./components/shared/ShopSection/index.js

/* harmony default export */ var shared_ShopSection = __webpack_exports__["a"] = (Container);

/***/ }),

/***/ "VbXa":
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__("SksO");

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  setPrototypeOf(subClass, superClass);
}

module.exports = _inheritsLoose;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "VgIB":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/SBGO_lifestyle_5_small-de75357f9bbde34c7f2307b55501a0b0.png", "placeholder": ""};

/***/ }),

/***/ "WLKl":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/GQ-481e718220cdfeb8b6c5080276310ff4.png", "placeholder": ""};

/***/ }),

/***/ "XLOO":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/soundboks_battery-768-6bd3da48557abb7e762ee1787eee01a8.jpg", "placeholder": "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAKABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAYEBwj/xAAnEAAABQMCBQUAAAAAAAAAAAABAgMFEQAEBgchEhMVMUEiQlFhkf/EABcBAAMBAAAAAAAAAAAAAAAAAAABAgP/xAAXEQADAQAAAAAAAAAAAAAAAAAAARES/9oADAMBAAIRAxEAPwCPqLnenuY4ie3s2pysXxIwq2YkRKXhUj3GKaOAe3ztNKGG6iZMS4t2UtwVwTWVIBOpKHVBId9yiIyXv4HxVla5Y+zNuLWS7e0t9ovBw5iFsRM36ATWdExGJnenXTJqD476iOJ3K557e1LHKcSCoAKwaBiQ9f1RSKIBNFBOmf/Z"};

/***/ }),

/***/ "YakH":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/WeekenderPack_large-06c7e33eacf631a397ba068d20fe4de6.jpg", "placeholder": ""};

/***/ }),

/***/ "YtPQ":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/soundboks_battery-1920-cd548c87884352cf90bcea3334f565c6.jpg", "placeholder": ""};

/***/ }),

/***/ "ZDPV":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/Soundboks3-lifestyle-2-small-51f68e5eb59602b32e019b180414936b.png", "placeholder": ""};

/***/ }),

/***/ "anZF":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/Soundboks3-lifestyle-5-large-433b88692815b3c86459a4eb41dedae2.png", "placeholder": ""};

/***/ }),

/***/ "avul":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/soundboks_hero-1024-af8a661ede4ace4ae95bcc18e21ed3b9.jpg", "placeholder": ""};

/***/ }),

/***/ "bDvF":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/Soundboks3-lifestyle-2-small-51f68e5eb59602b32e019b180414936b.png", "placeholder": ""};

/***/ }),

/***/ "biPD":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/Soundboks3-lifestyle-4-small-cc4b93fd4617c18fc96261dfdde4b0ef.png", "placeholder": ""};

/***/ }),

/***/ "cEte":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/soundboks_build-1024-7641d9fb5108b70334c1e66389102808.jpg", "placeholder": ""};

/***/ }),

/***/ "cujP":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/Soundboks3-lifestyle-5-small-09e59c669cce7d6bd1603bee7d0f49b6.png", "placeholder": ""};

/***/ }),

/***/ "ec63":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/computer-bild_black-aed66022827d77de97a45404cd37563d.png", "placeholder": ""};

/***/ }),

/***/ "eomm":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("/a9y")


/***/ }),

/***/ "f1NO":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/icon-modes-3cb8adbd91264c4c9e4a572766834d2b.png", "placeholder": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEqUlEQVQ4y4VUbyydZxQ/773X/3KZ+E/FJNog1OUu6iKuBqHmT1HtrEUiw9C5U3ExahrR1GhKl+CLIG0qvrVpE5HST6O6LyU1a5toVROGBKGZuO9zds5blXXZsic593nv+57nd37nnN95AP5jOTk5Kbu1tbWvRqOJUKvVISqVyovfOTg4SLTg/xZ7aBnjAEh99uxZfrQl8yRzI/uspqaG36kcHR3tDvwdyZzJNP8E5Bd6Gxsbj6ysLPDy8oKnT59qi4qKEtLS0orJ0hFRTfbxoB+xNNCuI4shczlEsre3Bx8fH+W5ublZ2Y1GY4O7u/sKpYn0VzFnZ+ffjx49Ouvv799GwJKbm9uH1P6evl6vh9zcXMjPz5fe774HcrRKNBqbbG1tUavVYmxsnHz+/FeWgoICWafTKcDe3t5YVFT4i0Zj5cOgFEB9CNjW1gZlZWXSvXv34MWLFw7Hjx+fsba2YSBLQ0OjZWBgQDx+/Fi8evVKbG5uyg8ePLCUlJTsHTniwAF/JQK2ZHDu3DkoLy8HqDebmbKaigwxMTHt9IyG2Li90tJSUVFRgZ2dneL+/fs4Pz+P29vbgg7j4uvXIvrkyX0rKyu8ceNGDPlCYWGh2lRdDZCZmSn19/fD+Pi4i6ur6x+enl5YWVkl5+TkIDmJ9vZ2Qd/wzZs3aLFYkFiKly9firt3RyzuHh5IKY9zo5hlGQFz8dWJiYlw5syZDGaXmnZavnXrZ1FXV6cwbGlpwYmJCWaHOzs7ODU1hb29vXizu1ukf5khkz6xvr4+tbi4GEgRKiAwVUpKMly48HU0CVg2mb7H2dlZwSBjY2OKLSws4MbGBlL98Nq1a2gyVQvSo/i2osJCCsH09PSyhIQESEpK0kBqaqqUl5cL5BBCNdkzm824tbUllpeXcXV1Fd++fYuLi4u4traGMzMzeOfOHezo6BBc2+YrVxRAwiiPi4tjcpoPKRuNLJ0MlkRGRoZMYGKOWFJ3cWhoCB8+fIhLS0u4u7uLKysr+OTJE5yenhaNjY0yn0lJSTkdqdNBVFSUGpKTkyX6AD09PW4uLi4bHHF0dFTmVLkhra2t/F9hx6y5Kevr62yW6OhopDKNcVO2NjfhxIkTAFVVVcps8k9YWFgXRySx/0lyELW1tXj16lUxPDyMjx49wrm5OfHu3TuWjujq6tpn37y8vCTdATtlckikkJ2dLdFB6Ovr09K4PWdHAt//oalJpo6KkZERMTk5yXKRqZYyZbPHI0kAz589e+YkhFCIBQYGApDegOrGEVTUJaD2u/r6+v7EoB6ks5ycXIu5vmH/+vWOfZocNBgMyvjRlPxG4/g5j+0Xer2K74Day5cBKDoEBweDn58fREZGqkwmkzKSFO1H0uU2H7azs0OuLQl/iTKYP3bsWPd3ly45Ug0hJCREFRAQoJA6XMyS2HANFV1+uEAknk93GsfsWIOhhvZvqLtavsL4zMWLFyEiIkJFTIEC8uXy6WXIdfh483BduVHx8fEQGhoKXPTw8HAg7fFt9PGbdOrUKSDWwLL71zU4OAhBQUFA8lGc6OaRiLWaAmm4i5SWRCMKXBa+ECorK+H27dufYPwFGNk+gg4a+RAAAAAASUVORK5CYII="};

/***/ }),

/***/ "f6Fs":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/soundboks_battery-1024-60771d0a4c444c5c8e23aaa846936b28.jpg", "placeholder": ""};

/***/ }),

/***/ "fGH9":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/mashable-96f1c3fa87820886b940133d0397aed7.png", "placeholder": ""};

/***/ }),

/***/ "guMD":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/usp-sbgo-portability-cc2cb985bda5de3867422310e8647aeb.jpg", "placeholder": ""};

/***/ }),

/***/ "hqBC":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/section_tech_specs-2c876bbf9594e62e2b0c7c56e65472a8.jpg", "placeholder": "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAZABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAECAwQI/8QAKhAAAQQAAwYGAwAAAAAAAAAAAQACAxEhMUEEEhMiMnEzUVJh0fBykbH/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AOjCMiQ8EDOyB+/uSk0yO6JmH2u1l2NwnibI9oZvYFvpOqlJw4pgI2B2GJDb8/hFbWcSubdJvMaoVEE75GlxsY5UhBTsLHwwNE/K825+tFxs/wBV/BZIHSXRybWlJydT+3wkPBn/ADKAYQRdAXjh2QnqfuiEH//Z"};

/***/ }),

/***/ "jNdC":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/Soundboks3-lifestyle-3-small-d527fb76dcbe7ea556a0ac6de4d2cf80.png", "placeholder": ""};

/***/ }),

/***/ "k/jh":
/***/ (function(module, exports) {

module.exports = { "url": "data:image/png;base64,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" };

/***/ }),

/***/ "kLgK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/next/error.js
var next_error = __webpack_require__("eomm");
var error_default = /*#__PURE__*/__webpack_require__.n(next_error);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 23 modules
var es = __webpack_require__("/MKj");

// EXTERNAL MODULE: ./components/wrappers/Layout/index.js + 33 modules
var Layout = __webpack_require__("8hyx");

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./components/shared/Row/index.js
var Row = __webpack_require__("OfJt");

// EXTERNAL MODULE: ./data/abstractProducts.js
var abstractProducts = __webpack_require__("eTmy");
var abstractProducts_default = /*#__PURE__*/__webpack_require__.n(abstractProducts);

// EXTERNAL MODULE: ./components/shared/ShopSection/index.js + 3 modules
var ShopSection = __webpack_require__("Uw/i");

// EXTERNAL MODULE: ./utils/hooks/useGetDynamicVariants.ts + 2 modules
var useGetDynamicVariants = __webpack_require__("3f9c");

// EXTERNAL MODULE: ./utils/hooks/useDefaultVariantIdFromProductId.js + 1 modules
var useDefaultVariantIdFromProductId = __webpack_require__("WJix");

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/molecules/Composition/index.ts + 16 modules
var Composition = __webpack_require__("C2Jz");

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/styles/theme.ts
var theme = __webpack_require__("isV7");

// EXTERNAL MODULE: ./node_modules/@lingui/react/index.js
var _lingui_react = __webpack_require__("ZD0w");

// EXTERNAL MODULE: ./components/wrappers/PageTracker/utils.ts + 1 modules
var utils = __webpack_require__("IUCn");

// EXTERNAL MODULE: ./utils/tracking/mergeUACategories.ts
var mergeUACategories = __webpack_require__("ZrlA");

// EXTERNAL MODULE: ./utils/product/checkProduct.js
var checkProduct = __webpack_require__("aPyg");

// EXTERNAL MODULE: ./components/shared/BuyProduct/Package/index.js + 2 modules
var Package = __webpack_require__("TmJc");

// EXTERNAL MODULE: ./components/atoms/Text/index.js + 17 modules
var Text = __webpack_require__("wCgk");

// EXTERNAL MODULE: ./components/atoms/Button/index.js + 7 modules
var atoms_Button = __webpack_require__("8BE4");

// EXTERNAL MODULE: ./utils/paramToResolutions.js
var paramToResolutions = __webpack_require__("vE80");

// CONCATENATED MODULE: ./components/shared/BuyProduct/FAQ/Components.js
var __jsx = react_default.a.createElement;







var Components_Section = function Section(_ref) {
  var name = _ref.name,
      children = _ref.children;
  return /*#__PURE__*/react_default.a.createElement(SectionWrapper, null, /*#__PURE__*/react_default.a.createElement(SectionHeader, null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: name.id
  })), /*#__PURE__*/react_default.a.createElement("div", null, children));
};
var Components_Wrapper = Object(styled_components_browser_esm["default"])(Row["a" /* default */]).withConfig({
  displayName: "Components__Wrapper",
  componentId: "sc-1pev1s1-0"
})(["", ";", ";"], Object(paramToResolutions["a" /* default */])('margin-top', [50, 80, 120, 190]), function (_ref2) {
  var showMore = _ref2.showMore;
  return showMore ? Object(paramToResolutions["a" /* default */])('padding-bottom', [40, 50]) : Object(paramToResolutions["a" /* default */])('padding-bottom', [50, 80, 120, 190]);
});
var SectionWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Components__SectionWrapper",
  componentId: "sc-1pev1s1-1"
})(["display:flex;flex-wrap:wrap;justify-content:space-between;border-top:2px solid ", ";&:last-of-type{border-bottom:2px solid ", ";}", ";@media ", "{h2{margin-bottom:20px;}}@media ", "{border-width:3px;> *{&:nth-child(1){width:35%;}&:nth-child(2){width:60%;}}}"], function (props) {
  return props.theme.colors.black;
}, function (props) {
  return props.theme.colors.black;
}, Object(paramToResolutions["a" /* default */])('padding', ['30px 0', '50px 0', undefined, '100px 0']), function (props) {
  return props.theme.breakpoints.onlyMobile;
}, function (props) {
  return props.theme.breakpoints.tablet;
});
var SectionHeader = Object(styled_components_browser_esm["default"])(Text["d" /* H2 */]).withConfig({
  displayName: "Components__SectionHeader",
  componentId: "sc-1pev1s1-2"
})(["margin:0;white-space:pre-wrap;"]);
var SectionP = Object(styled_components_browser_esm["default"])(Text["k" /* P */]).withConfig({
  displayName: "Components__SectionP",
  componentId: "sc-1pev1s1-3"
})(["margin:0;&:not(:last-child){", "}a{font-weight:bold;color:inherit;text-decoration:underline;}"], function (_ref3) {
  var bold = _ref3.bold,
      _ref3$theme = _ref3.theme,
      halfBaseline = _ref3$theme.halfBaseline,
      baseline = _ref3$theme.baseline;
  return bold ? Object(paramToResolutions["a" /* default */])('margin-bottom', [baseline, baseline * 2]) : Object(paramToResolutions["a" /* default */])('margin-bottom', [halfBaseline * 6, baseline * 7, undefined, baseline * 11]);
});
var MoreWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Components__MoreWrapper",
  componentId: "sc-1pev1s1-4"
})(["", ";"], Object(paramToResolutions["a" /* default */])('margin', ['40px 0', '90px 0', '60px 0', '160px 0']));
var MoreHeader = Object(styled_components_browser_esm["default"])(Text["g" /* Highlight1 */]).withConfig({
  displayName: "Components__MoreHeader",
  componentId: "sc-1pev1s1-5"
})(["text-align:center;margin:0;", ";font-size:", "px;"], function (_ref4) {
  var _ref4$theme = _ref4.theme,
      baseline = _ref4$theme.baseline,
      halfBaseline = _ref4$theme.halfBaseline;
  return Object(paramToResolutions["a" /* default */])('margin-bottom', [halfBaseline * 5, halfBaseline * 7, undefined, baseline * 7]);
}, function (props) {
  return props.theme.halfBaseline * 7;
});
var MoreButton = Object(styled_components_browser_esm["default"])(atoms_Button["e" /* StandardButton */]).withConfig({
  displayName: "Components__MoreButton",
  componentId: "sc-1pev1s1-6"
})(["display:block;margin:0 auto;", ";"], Object(paramToResolutions["a" /* default */])('width', [180, 180, 180, 240]));
var SubQnA = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Components__SubQnA",
  componentId: "sc-1pev1s1-7"
})(["margin-top:", "px;&:first-child{margin-top:0;}"], function (props) {
  return props.theme.halfBaseline * 7;
});
// CONCATENATED MODULE: ./components/shared/BuyProduct/FAQ/config/getPhysicalProductFAQs.js
var getPhysicalProductFAQs = function getPhysicalProductFAQs() {
  return [{
    id: 'warranty-return',
    category:
    /*i18n*/
    {
      id: "product.faq.warranty.title"
    },
    isRegional: true,
    content: {
      "default":
      /*i18n*/
      {
        id: "product.faq.warranty.body"
      },
      na:
      /*i18n*/
      {
        id: "product.faq.warranty.body.na"
      },
      no:
      /*i18n*/
      {
        id: "product.faq.warranty.body.no"
      },
      dk:
      /*i18n*/
      {
        id: "product.faq.warranty.body.dk"
      },
      de:
      /*i18n*/
      {
        id: "product.faq.warranty.body.de"
      },
      fr:
      /*i18n*/
      {
        id: "product.faq.warranty.body.fr"
      }
    },
    articleUrl: '/articles/211920329-RETURN-AND-REFUND-POLICY-AND-PROCESS',
    articleText:
    /*i18n*/
    {
      id: "product.faq.readArticleText"
    }
  }, {
    id: 'delivery-time',
    category:
    /*i18n*/
    {
      id: "product.faq.deliveryTime.title"
    },
    isRegional: true,
    content: {
      "default":
      /*i18n*/
      {
        id: "product.faq.deliveryTime.body"
      },
      na:
      /*i18n*/
      {
        id: "product.faq.deliveryTime.body.na"
      },
      no:
      /*i18n*/
      {
        id: "product.faq.deliveryTime.body.no"
      },
      dk:
      /*i18n*/
      {
        id: "product.faq.deliveryTime.body.dk"
      },
      de:
      /*i18n*/
      {
        id: "product.faq.deliveryTime.body.de"
      },
      fr:
      /*i18n*/
      {
        id: "product.faq.deliveryTime.body.fr"
      }
    },
    articleUrl: '/sections/360003609413-SHIPPING',
    articleText:
    /*i18n*/
    {
      id: "product.faq.readArticleText"
    }
  }, {
    id: 'duties-vat',
    category:
    /*i18n*/
    {
      id: "product.faq.duties.title"
    },
    isRegional: true,
    content: {
      "default":
      /*i18n*/
      {
        id: "product.faq.duties.body"
      },
      no:
      /*i18n*/
      {
        id: "product.faq.duties.body.no"
      }
    },
    articleUrl: '/articles/115005061493-VAT-IN-NORWAY-ISRAEL-SWITZERLAND-AND-CANADA',
    articleText:
    /*i18n*/
    {
      id: "product.faq.readArticleText"
    }
  }];
};

/* harmony default export */ var config_getPhysicalProductFAQs = (getPhysicalProductFAQs);
// CONCATENATED MODULE: ./components/shared/BuyProduct/FAQ/Layouts.js
var Layouts_jsx = react_default.a.createElement;





/**
 * @param  {} regionId
 * @param  {} slug articleUrl from FAQ config
 */

var getHelpCenterUrl = function getHelpCenterUrl(regionId, slug) {
  var baseUrl = 'https://soundboks.zendesk.com/hc';

  switch (regionId) {
    case 'de':
      return "".concat(baseUrl, "/de").concat(slug);

    case 'fr':
      return "".concat(baseUrl, "/fr-fr").concat(slug);

    default:
      return "".concat(baseUrl, "/en-gb").concat(slug);
  }
}; // Return FAQ Question Answers layout


var Layouts_getFaqQuestionsAnswers = function getFaqQuestionsAnswers(faqContent, regionId) {
  return faqContent.map(function (faq) {
    return /*#__PURE__*/react_default.a.createElement(SubQnA, {
      key: faq.question.id
    }, /*#__PURE__*/react_default.a.createElement(SectionP, {
      bold: true
    }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
      id: faq.question.id
    })), /*#__PURE__*/react_default.a.createElement(SectionP, null, faq.isRegional && /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
      id: faq.answer[regionId] || faq.answer["default"]
    }), !faq.isRegional && /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
      id: faq.answer
    }), ' ', faq.articleUrl && faq.articleText && /*#__PURE__*/react_default.a.createElement("a", {
      href: getHelpCenterUrl(regionId, faq.articleUrl)
    }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
      id: faq.articleText.id
    }))));
  });
}; // Return FAQ Regional content layout


var Layouts_getFaqRegionalContent = function getFaqRegionalContent(faq, regionId) {
  return /*#__PURE__*/react_default.a.createElement(SectionP, null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: faq.content[regionId] || faq.content["default"]
  }), ' ', faq.articleUrl && faq.articleText && /*#__PURE__*/react_default.a.createElement("a", {
    href: getHelpCenterUrl(regionId, faq.articleUrl)
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: faq.articleText.id
  })));
}; // Return FAQ standard content layout


var Layouts_getFAQStandardContent = function getFAQStandardContent(faq, regionId) {
  return /*#__PURE__*/react_default.a.createElement(SectionP, null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: faq.content.id
  }), ' ', faq.articleUrl && faq.articleText && /*#__PURE__*/react_default.a.createElement("a", {
    href: getHelpCenterUrl(regionId, faq.articleUrl)
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: faq.articleText.id
  })));
}; // Component


var Layouts_FAQDefault = function FAQDefault(_ref) {
  var faqs = _ref.faqs,
      showMore = _ref.showMore;
  var regionId = Object(es["d" /* useSelector */])(function (state) {
    return state.settings.regionId;
  });
  return /*#__PURE__*/react_default.a.createElement(Components_Wrapper, {
    id: "faq",
    showMore: showMore
  }, /*#__PURE__*/react_default.a.createElement("div", null, Array.isArray(faqs) && faqs.map(function (faq) {
    return /*#__PURE__*/react_default.a.createElement(Components_Section, {
      name: faq.category,
      key: faq.id
    }, !faq.hasSubQuests && !faq.isRegional && Layouts_getFAQStandardContent(faq, regionId), faq.isRegional && Layouts_getFaqRegionalContent(faq, regionId), faq.hasSubQuests && Layouts_getFaqQuestionsAnswers(faq.content, regionId));
  })), showMore && /*#__PURE__*/react_default.a.createElement(MoreWrapper, null, /*#__PURE__*/react_default.a.createElement(MoreHeader, {
    as: "h1"
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "More info"
  })), /*#__PURE__*/react_default.a.createElement(MoreButton, {
    id: "product-faq__button--moreInfo",
    href: "https://soundboks.zendesk.com"
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "FAQ"
  }))));
};

Layouts_FAQDefault.defaultProps = {
  faqs: config_getPhysicalProductFAQs(),
  showMore: true
};
/* harmony default export */ var Layouts = (Layouts_FAQDefault);
// CONCATENATED MODULE: ./components/shared/BuyProduct/FAQ/config/digitalProductFAQs.js
var digitalProductFAQs = [{
  id: 'gift-cards',
  category:
  /*i18n*/
  {
    id: "GIFT CARDS"
  },
  content:
  /*i18n*/
  {
    id: "No shipping costs apply to gift cards, as they will be e-mailed to the e-mail address that you provided during the ordering process. You receive the gift card code in a separate e-mail shortly after placing your order and receiving your order confirmation e-mail. Gift cards cannot be returned or redeemed for cash, except where required by law."
  },
  articleUrl: '/sections/360003261759-GIFT-CARD',
  articleText:
  /*i18n*/
  {
    id: "Read our full article."
  }
}, {
  id: 'duties-vat',
  category:
  /*i18n*/
  {
    id: "IMPORT DUTIES, VAT & TAXES"
  },
  isRegional: true,
  content: {
    "default":
    /*i18n*/
    {
      id: "All of the products on our European webshop are sold with taxes included. See full article for information about Switzerland. On our USA and CAN webshop, our products are sold excluding taxes with the exception of California where Sales Tax is applied."
    }
  },
  articleUrl: '/articles/115005061493-VAT-IN-NORWAY-SWITZERLAND-AND-CANADA-CALIFORNIA-TAXES',
  articleText:
  /*i18n*/
  {
    id: "Read our full article."
  }
}];
/* harmony default export */ var config_digitalProductFAQs = (digitalProductFAQs);
// CONCATENATED MODULE: ./components/shared/BuyProduct/FAQ/config/soundboksGen3FAQs.js
var soundboksGen3FAQs = {
  id: 'general-topics',
  category:
  /*i18n*/
  {
    id: "General Topics"
  },
  hasSubQuests: true,
  content: [{
    id: 'payment-option',
    question:
    /*i18n*/
    {
      id: "product.FAQs.nSB.payment-option.question"
    },
    isRegional: true,
    answer: {
      "default":
      /*i18n*/
      {
        id: "product.FAQs.payment-option.answer"
      }
    },
    articleUrl: '/articles/360022123454-PAYMENT-OPTIONS',
    articleText:
    /*i18n*/
    {
      id: "product.FAQs.readFullArticle"
    }
  }, {
    id: 'battery-life',
    question:
    /*i18n*/
    {
      id: "product.FAQs.nSB.battery-life.question"
    },
    answer:
    /*i18n*/
    {
      id: "product.FAQs.nSB.battery-life.answer"
    },
    articleUrl: '/articles/360007732080-VIDEO-GUIDE-BATTERYBOKS',
    articleText:
    /*i18n*/
    {
      id: "product.FAQs.readFullArticle"
    }
  }, {
    id: 'water-proof',
    question:
    /*i18n*/
    {
      id: "product.FAQs.waterproof.question"
    },
    answer:
    /*i18n*/
    {
      id: "product.FAQs.nSB.waterproof.answer"
    },
    articleUrl: '/articles/360007732120-DURABILITY-NEW-SOUNDBOKS',
    articleText:
    /*i18n*/
    {
      id: "product.FAQs.readFullArticle"
    }
  }, {
    id: 'input-ports',
    question:
    /*i18n*/
    {
      id: "product.FAQs.nSB.input-ports.question"
    },
    answer:
    /*i18n*/
    {
      id: "product.FAQs.nSB.input-ports.answer"
    },
    articleUrl: '/articles/360007812739-PRO-PANEL-NEW-SOUNDBOKS',
    articleText:
    /*i18n*/
    {
      id: "product.FAQs.readFullArticle"
    }
  }, {
    id: 'multiple-soundboks',
    question:
    /*i18n*/
    {
      id: "product.FAQs.nSB.multiple-soundboks.question"
    },
    answer:
    /*i18n*/
    {
      id: "product.FAQs.nSB.multiple-soundboks.answer"
    },
    articleUrl: '/articles/360007812719-TEAMUP-NEW-SOUNDBOKS',
    articleText:
    /*i18n*/
    {
      id: "product.FAQs.readFullArticle"
    }
  }, {
    id: 'instruments',
    question:
    /*i18n*/
    {
      id: "product.FAQs.nSB.instruments.question"
    },
    answer:
    /*i18n*/
    {
      id: "product.FAQs.nSB.instruments.answer"
    },
    articleUrl: '/articles/360007812739-PRO-PANEL-NEW-SOUNDBOKS',
    articleText:
    /*i18n*/
    {
      id: "product.FAQs.readFullArticle"
    }
  }, {
    id: 'loudness',
    question:
    /*i18n*/
    {
      id: "product.FAQs.nSB.loudness.question"
    },
    answer:
    /*i18n*/
    {
      id: "product.FAQs.nSB.loudness.answer"
    },
    articleUrl: '/articles/360007812699-ACOUSTICS-FREQUENCY-NEW-SOUNDBOKS',
    articleText:
    /*i18n*/
    {
      id: "product.FAQs.readFullArticle"
    }
  }],
  articleUrl: 'https://soundboks.zendesk.com/',
  articleText:
  /*i18n*/
  {
    id: "product.FAQs.readFullArticle"
  }
};
/* harmony default export */ var config_soundboksGen3FAQs = (soundboksGen3FAQs);
// CONCATENATED MODULE: ./components/shared/BuyProduct/FAQ/config/soundboks2FAQs.js
var soundboks2FAQs = {
  id: 'general-topics',
  category:
  /*i18n*/
  {
    id: "General Topics"
  },
  hasSubQuests: true,
  articleUrl: '/',
  articleText:
  /*i18n*/
  {
    id: "Read our full article."
  },
  content: [{
    id: 'payment-option',
    question:
    /*i18n*/
    {
      id: "product.FAQs.SB2.payment-option.question"
    },
    isRegional: true,
    answer: {
      "default":
      /*i18n*/
      {
        id: "All our prices are displayed in USD or EURO, depending on your choice of location. We accept Visa, MasterCard, and Maestro. We offer financing options for Germany and the USA."
      },
      no: 'product.FAQs.payment-option.answer'
    },
    articleUrl: '/articles/360007266013-FINANCING-OPTIONS',
    articleText:
    /*i18n*/
    {
      id: "Read our full article."
    }
  }, {
    id: 'battery-life',
    question:
    /*i18n*/
    {
      id: "How long does the battery really last?"
    },
    answer:
    /*i18n*/
    {
      id: "product.FAQs.SB2.battery-life.answer"
    },
    articleUrl: '/articles/115003698353-VIDEOGUIDE-BATTERYBOKS-2',
    articleText:
    /*i18n*/
    {
      id: "Read our full article."
    }
  }, {
    id: 'water-proof',
    question:
    /*i18n*/
    {
      id: "product.FAQs.waterproof.question"
    },
    answer:
    /*i18n*/
    {
      id: "The SOUNDBOKS is not waterproof, however it is weather and splash resistant. It can handle temperatures from -4 to + 122 \xB0F (-20 to + 50 \xB0C), and conditions such as rain, sand, snow, and occasional liquid spills."
    },
    articleUrl: '/articles/115004910433-DURABILITY-SB2',
    articleText:
    /*i18n*/
    {
      id: "Read our full article."
    }
  }, {
    id: 'input-ports',
    question:
    /*i18n*/
    {
      id: "product.FAQs.SB2.input-ports.question"
    },
    answer:
    /*i18n*/
    {
      id: "You can plug in your chosen device, phone, tablet etc. using the 3.5mm AUX/Jack cable, or you can connect directly to the SOUNDBOKS via Bluetooth."
    },
    articleUrl: '/articles/115004900874-VIDEOGUIDE-SOUNDBOKS-2',
    articleText:
    /*i18n*/
    {
      id: "View instructional video."
    }
  }, {
    id: 'multiple-soundboks',
    question:
    /*i18n*/
    {
      id: "Can I connect multiple SOUNDBOKS speakers?"
    },
    answer:
    /*i18n*/
    {
      id: "Yes, you can! You can pair any models together by using a preamplifier which also ensures that the sound quality does not deteriorate."
    },
    articleUrl: '/articles/360007812719-TEAMUP-NEW-SOUNDBOKS',
    articleText:
    /*i18n*/
    {
      id: "View instructional video."
    }
  }, {
    id: 'instruments',
    question:
    /*i18n*/
    {
      id: "product.FAQs.SB2.instruments.question"
    },
    answer:
    /*i18n*/
    {
      id: "Yes, that is possible. Connecting with a pre-amplifier allows you to pair the SOUNDBOKS with various equipment and instruments, such as microphones, mixer, guitar etc."
    }
  }, {
    id: 'loudness',
    question:
    /*i18n*/
    {
      id: "How loud is the SOUNDBOKS?"
    },
    answer:
    /*i18n*/
    {
      id: "The SOUNDBOKS can play up to 122dB which can be compared to being front row at a concert."
    },
    articleUrl: '/articles/115004910453-WATTAGE-SB2',
    articleText:
    /*i18n*/
    {
      id: "Read our full article."
    }
  }]
};
/* harmony default export */ var config_soundboks2FAQs = (soundboks2FAQs);
// CONCATENATED MODULE: ./components/shared/BuyProduct/FAQ/index.js
var FAQ_jsx = react_default.a.createElement;





 // Append product FAQ to selected FAQ list
// only add if additional FAQ does not exist

var appendFAQ = function appendFAQ(selectedFAQs, additionalFAQ) {
  // Check if additional FAQ is already exist
  var index = selectedFAQs.findIndex(function (currentVal) {
    return currentVal.id.includes(additionalFAQ.id);
  });

  if (index < 0) {
    selectedFAQs.push(additionalFAQ);
  }

  return selectedFAQs;
}; // Get FAQ content from Product handle


var FAQ_getFAQFromProduct = function getFAQFromProduct(productHandle) {
  var physicalProductFAQs = config_getPhysicalProductFAQs();

  if (productHandle === 'soundboks-gen-2' || productHandle === 'soundboks-gen-2-x-yes' || productHandle === 'w-o-a-soundboks-gen-2' || productHandle === 'batteryboks-1') {
    return appendFAQ(physicalProductFAQs, config_soundboks2FAQs);
  }

  if (productHandle === 'gift-card') {
    return config_digitalProductFAQs;
  }

  return appendFAQ(physicalProductFAQs, config_soundboksGen3FAQs);
}; // Component


var FAQ_FAQ = function FAQ(_ref) {
  var productHandle = _ref.productHandle;
  var FAQs = FAQ_getFAQFromProduct(productHandle);
  return /*#__PURE__*/react_default.a.createElement(Layouts, {
    faqs: FAQs,
    showMore: productHandle !== 'gift-card'
  });
};

/* harmony default export */ var BuyProduct_FAQ = (FAQ_FAQ);
// EXTERNAL MODULE: ./components/shared/BuyProduct/Gallery/index.jsx
var Gallery = __webpack_require__("IY8M");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__("HR29");
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/View/index.js
var View = __webpack_require__("Epja");
var View_default = /*#__PURE__*/__webpack_require__.n(View);

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/atoms/Icon/index.tsx + 105 modules
var atoms_Icon = __webpack_require__("ZSX1");

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/atoms/Text/index.tsx
var atoms_Text = __webpack_require__("Zd2Y");

// CONCATENATED MODULE: ./node_modules/@soundboks/sb-components/src/molecules/Tag/index.tsx

var Tag_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var TagSize;

(function (TagSize) {
  TagSize[TagSize["Tiny"] = 0] = "Tiny";
  TagSize[TagSize["Small"] = 1] = "Small";
})(TagSize || (TagSize = {}));

var defaultTinySize = {
  iconSize: theme["d" /* IconSize */].Tiny,
  textType: atoms_Text["i" /* TextType */].CaptionSmall,
  spaceRightOfIcon: theme["l" /* Space */].Tiny,
  paddingVertical: theme["j" /* Size */].BaseUnit * 0.25,
  paddingHorizontal: theme["j" /* Size */].BaseUnit * 0.5
};

var Tag_getTagStyles = function getTagStyles(size) {
  if (size === TagSize.Small) {
    return _objectSpread(_objectSpread({}, defaultTinySize), {}, {
      paddingVertical: theme["j" /* Size */].BaseUnit * 0.5,
      paddingHorizontal: theme["j" /* Size */].BaseUnit
    });
  }

  return defaultTinySize;
};

var styles = StyleSheet_default.a.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row'
  }
});

var Tag_Tag = function Tag(_ref) {
  var colorForeground = _ref.colorForeground,
      colorBackground = _ref.colorBackground,
      children = _ref.children,
      alignSelf = _ref.alignSelf,
      size = _ref.size,
      iconId = _ref.iconId;

  var _getTagStyles = Tag_getTagStyles(size),
      iconSize = _getTagStyles.iconSize,
      textType = _getTagStyles.textType,
      spaceRightOfIcon = _getTagStyles.spaceRightOfIcon,
      paddingVertical = _getTagStyles.paddingVertical,
      paddingHorizontal = _getTagStyles.paddingHorizontal;

  return /*#__PURE__*/react_default.a.createElement(View_default.a, {
    style: [styles.container, {
      backgroundColor: colorBackground,
      paddingHorizontal: paddingHorizontal,
      paddingVertical: paddingVertical,
      alignSelf: alignSelf
    }]
  }, iconId && /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(atoms_Icon["b" /* default */], {
    size: iconSize,
    color: colorForeground,
    id: iconId
  }), /*#__PURE__*/react_default.a.createElement(Composition["e" /* Spacer */], {
    direction: Composition["f" /* SpacerDirection */].Horizontal,
    size: spaceRightOfIcon
  })), /*#__PURE__*/react_default.a.createElement(atoms_Text["j" /* default */], {
    colorForeground: colorForeground,
    type: textType
  }, children));
};

/* harmony default export */ var molecules_Tag = (Tag_Tag);
// CONCATENATED MODULE: ./components/shared/BuyProduct/Tags/index.tsx
var Tags_jsx = react_default.a.createElement;






var Tags_Tags = function Tags(_ref) {
  var tags = _ref.tags;
  return /*#__PURE__*/react_default.a.createElement(TagWrapper, null, tags !== null && tags.map(function (text, index) {
    return /*#__PURE__*/react_default.a.createElement(molecules_Tag, {
      key: index,
      size: TagSize.Small,
      alignSelf: Composition["c" /* LayoutAlignment */].Start,
      colorBackground: theme["a" /* Color */].Green,
      colorForeground: theme["a" /* Color */].White
    }, text);
  }));
};

/* harmony default export */ var BuyProduct_Tags = (Tags_Tags);
var TagWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Tags__TagWrapper",
  componentId: "cjwiqc-0"
})(["display:flex;flex-wrap:wrap;gap:15px;"]);
// EXTERNAL MODULE: ./components/shared/BuyProduct/Perks/index.js + 1 modules
var Perks = __webpack_require__("8YZW");

// EXTERNAL MODULE: ./components/atoms/Link/index.tsx
var Link = __webpack_require__("ZT91");

// CONCATENATED MODULE: ./components/shared/Banner/BannerLink.tsx
var BannerLink_jsx = react_default.a.createElement;





var BannerLink_BannerLink = function BannerLink(_ref) {
  var as = _ref.as,
      href = _ref.href,
      children = _ref.children,
      big = _ref.big;
  return /*#__PURE__*/react_default.a.createElement(Link["a" /* default */], {
    as: as,
    href: href
  }, /*#__PURE__*/react_default.a.createElement("a", null, /*#__PURE__*/react_default.a.createElement(atoms_Text["j" /* default */], {
    textDecorationLine: atoms_Text["g" /* TextDecorationLine */].Underline,
    colorForeground: theme["a" /* Color */].Charcoal,
    type: big ? atoms_Text["i" /* TextType */].CaptionLarge : atoms_Text["i" /* TextType */].CaptionSmall
  }, children)));
};

/* harmony default export */ var Banner_BannerLink = (BannerLink_BannerLink);
// CONCATENATED MODULE: ./components/shared/BuyProduct/Description/index.js
var Description_jsx = react_default.a.createElement;







var Description_Description = function Description(_ref) {
  var description = _ref.description,
      href = _ref.href,
      hrefAs = _ref.hrefAs,
      linkText = _ref.linkText;

  if (description.id === 'product.soundboksGen3.buy-page.description.text') {
    return /*#__PURE__*/react_default.a.createElement(DescriptionWrapper, null, /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
      id: description.id,
      components: [/*#__PURE__*/react_default.a.createElement(Banner_BannerLink, {
        big: true,
        as: "/products/explorer-pack/",
        href: "/products/explorer-pack/"
      }), /*#__PURE__*/react_default.a.createElement("sup", null), /*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement("b", null)]
    })));
  }

  if (description.id === 'product.batteryboks.buy-page.description') {
    return /*#__PURE__*/react_default.a.createElement(DescriptionWrapper, null, /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
      id: description.id,
      components: [/*#__PURE__*/react_default.a.createElement("b", null), /*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement("br", null)]
    })));
  }

  return /*#__PURE__*/react_default.a.createElement(DescriptionWrapper, null, /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: description.id,
    components: [/*#__PURE__*/react_default.a.createElement("br", null)]
  }), !!href && /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, ' ', /*#__PURE__*/react_default.a.createElement(Link["a" /* default */], {
    passHref: true,
    href: href,
    as: hrefAs
  }, /*#__PURE__*/react_default.a.createElement("a", null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: linkText.id
  }))))));
};

var DescriptionWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Description__DescriptionWrapper",
  componentId: "sc-1yhw2m9-0"
})(["display:flex;flex-direction:column;justify-content:center;align-items:flex-start;padding:0;margin:0;a{font-weight:bold;color:black;text-decoration:underline;}p{margin:0;}"]);
Description_Description.defaultProps = {
  href: null,
  hrefAs: null,
  linkText: null
};
/* harmony default export */ var BuyProduct_Description = (Description_Description);
// CONCATENATED MODULE: ./components/shared/BuyProduct/wrappers/OfferWrapper/index.js


var OfferWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OfferWrapper",
  componentId: "icpcop-0"
})(["display:grid;justify-content:space-between;align-items:start;grid-template:'title' 'tags' 'gallery' 'perks' 'description' 'options' 'buy' /1fr;", ";@media ", "{justify-content:center;}@media ", "{margin-bottom:", ";grid-template:'gallery title' 'gallery tags' 'gallery perks' 'gallery description' 1fr 'options options' 'buy buy' / 328px 360px;}@media ", "{grid-template:'gallery title' 'gallery tags' 'gallery perks' 'gallery description' 'gallery options' 'gallery buy' 1fr / 460px 460px;}@media ", "{grid-template-columns:640px 640px;}"], Object(paramToResolutions["a" /* default */])('margin-top', [40, 55, 85, 105]), function (props) {
  return props.theme.breakpoints.onlyMobile;
}, function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.space.xl;
}, function (props) {
  return props.theme.breakpoints.desktop;
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
});
/* harmony default export */ var wrappers_OfferWrapper = (OfferWrapper);
// CONCATENATED MODULE: ./components/shared/BuyProduct/wrappers/index.js


// EXTERNAL MODULE: ./components/shared/Meta/index.js + 6 modules
var Meta = __webpack_require__("ACIN");

// EXTERNAL MODULE: ./data/productImages.js
var data_productImages = __webpack_require__("GQ8G");
var productImages_default = /*#__PURE__*/__webpack_require__.n(data_productImages);

// EXTERNAL MODULE: ./data/shops.js
var shops = __webpack_require__("z1id");
var shops_default = /*#__PURE__*/__webpack_require__.n(shops);

// EXTERNAL MODULE: ./public/static/images/meta/all-grillz.png
var all_grillz = __webpack_require__("746X");
var all_grillz_default = /*#__PURE__*/__webpack_require__.n(all_grillz);

// CONCATENATED MODULE: ./data/productMetadata.js

var productMetadata = {}; // Default

productMetadata["default"] = {
  title:
  /*i18n*/
  {
    id: "products.soundboksGen3.meta.deafult.title"
  },
  desc:
  /*i18n*/
  {
    id: "products.soundboksGen3.meta.deafult.description"
  },
  url: '/products/soundboks-gen-3'
}; // Jagermeister Soundboks (Gen. 3)

productMetadata['soundboks-go'] = {
  "default": {
    title:
    /*i18n*/
    {
      id: "product.soundboks-go.metaTitle"
    },
    desc:
    /*i18n*/
    {
      id: "product.soundboks-go.metaDescription"
    },
    url: '/products/soundboks-go'
  }
}; // Jagermeister Soundboks (Gen. 3)

productMetadata['jagermeister-2022-edition'] = {
  "default": {
    title:
    /*i18n*/
    {
      id: "product.jagermeister-limited-edition.metaTitle"
    },
    desc:
    /*i18n*/
    {
      id: "product.jagermeister-limited-edition.metaDescription"
    },
    url: '/products/jagermeister-2022-edition'
  }
}; // Roskilde Soundboks (Gen. 3)

productMetadata['soundboks-rf50'] = {
  "default": {
    title:
    /*i18n*/
    {
      id: "product.soundboks-rf50.metaTitle"
    },
    desc:
    /*i18n*/
    {
      id: "product.soundboks-rf50.metaDescription"
    },
    url: '/products/soundboks-rf50'
  }
}; // Backpack

productMetadata.backpack = {
  "default": {
    title:
    /*i18n*/
    {
      id: "products.backpack.meta.title",
      defaults: "The SOUNDBOKS Backpack | SOUNDBOKS"
    },
    desc:
    /*i18n*/
    {
      id: "products.backpack.meta.description",
      defaults: "Buy the SOUNDBOKS backpack today and take the most powerful speaker with you anywhere. The journey starts here."
    },
    url: '/products/backpack'
  },
  eu: {
    title: 'The SOUNDBOKS Backpack | SOUNDBOKS EU',
    desc: 'Buy the SOUNDBOKS backpack today and take the most powerful speaker with you anywhere. The journey starts here.'
  }
}; // Batteryboks

productMetadata.batteryboks = {
  "default": {
    title:
    /*i18n*/
    {
      id: "products.batteryboks.meta.title",
      defaults: "BATTERYBOKS 2 - Bluetooth Speaker Battery | SOUNDBOKS"
    },
    desc:
    /*i18n*/
    {
      id: "products.batteryboks.meta.description",
      defaults: "Order the only 40-hr, swappable battery pack in the game. The BATTERYBOKS is compatible with all SOUNDBOKS Bluetooth Performance Speakers."
    },
    url: '/products/batteryboks'
  },
  eu: {
    title: 'BATTERYBOKS 2 - Bluetooth Speaker Battery | SOUNDBOKS EU',
    desc: 'Order the only 40-hr, swappable battery pack in the game. The BATTERYBOKS is compatible with all SOUNDBOKS Bluetooth Performance Speakers.'
  }
}; // Batteryboks 1

productMetadata['batteryboks-1'] = {
  "default": {
    title:
    /*i18n*/
    {
      id: "products.batteryboks1.meta.title",
      defaults: "BATTERYBOKS 1 - Bluetooth Speaker Battery | SOUNDBOKS"
    },
    desc:
    /*i18n*/
    {
      id: "products.batteryboks1.meta.description",
      defaults: "Get the 1st Gen BATTERYBOKS. Swappable and interchangeable Bluetooth speaker battery for your SOUNDBOKS 1 or 2."
    },
    url: '/products/batteryboks-1'
  },
  eu: {
    title: 'BATTERYBOKS 1 - Bluetooth Speaker Battery | SOUNDBOKS EU',
    desc: 'Get the 1st Gen BATTERYBOKS. Swappable and interchangeable Bluetooth speaker battery for your SOUNDBOKS 1 or 2.'
  }
}; // Charger

productMetadata['charger-2'] = {
  title:
  /*i18n*/
  {
    id: "Bluetooth Speaker Charger | SOUNDBOKS Charger"
  },
  desc:
  /*i18n*/
  {
    id: "The battery-powered SOUNDBOKS recharges in just 3.5 hours. This is the only replacement charger for your BATTERYBOKS."
  },
  url: '/products/charger-2'
}; // Charger

productMetadata.charger = {
  "default": {
    title:
    /*i18n*/
    {
      id: "products.charger.meta.title",
      defaults: "BATTERYBOKS Chargers | SOUNDBOKS"
    },
    desc:
    /*i18n*/
    {
      id: "products.charger.meta.description",
      defaults: "Get the SOUNDBOKS charger with Free Shipping and 2-year warranty. Shop now."
    },
    url: '/products/charger'
  },
  eu: {
    title: 'BATTERYBOKS Chargers | SOUNDBOKS EU',
    desc: 'Get the SOUNDBOKS charger with Free Shipping and 2-year warranty. Shop now.'
  }
}; // Explorer pack

productMetadata['explorer-pack'] = {
  "default": {
    title:
    /*i18n*/
    {
      id: "products.explorerPack.meta.title"
    },
    desc:
    /*i18n*/
    {
      id: "products.explorerPack.meta.description"
    },
    url: '/products/explorer-pack'
  },
  eu: {
    title: 'The Explorer Pack - Backpack + Bluetooth Speaker Package | SOUNDBOKS EU',
    desc: 'Buy the SOUNDBOKS Explorer Pack with a Backpack for ultimate portability with the worlds most powerful wireless Bluetooth Speaker.'
  }
}; // 7 Battery Swaps

productMetadata['7-battery-swaps'] = {
  "default": {
    title:
    /*i18n*/
    {
      id: "products.batteryboks.meta.title",
      defaults: "BATTERYBOKS 2 - Bluetooth Speaker Battery | SOUNDBOKS"
    },
    desc:
    /*i18n*/
    {
      id: "products.batteryboks.meta.description",
      defaults: "Order the only 40-hr, swappable battery pack in the game. The BATTERYBOKS is compatible with all SOUNDBOKS Bluetooth Performance Speakers."
    },
    url: '/products/batteryboks'
  },
  eu: {
    title: 'BATTERYBOKS 2 - Bluetooth Speaker Battery | SOUNDBOKS EU',
    desc: 'Order the only 40-hr, swappable battery pack in the game. The BATTERYBOKS is compatible with all SOUNDBOKS Bluetooth Performance Speakers.'
  }
}; // Adventure Pack

productMetadata['adventure-pack'] = {
  "default": {
    title:
    /*i18n*/
    {
      id: "product.adventure-pack.meta.title"
    },
    desc:
    /*i18n*/
    {
      id: "product.adventure-pack.meta.description"
    },
    url: '/products/adventure-pack'
  }
}; // Back to school bundle

productMetadata['back-to-school-bundle'] = {
  title:
  /*i18n*/
  {
    id: "product.back-to-school-bundle.metaTitle"
  },
  desc:
  /*i18n*/
  {
    id: "product.back-to-school-bundle.metaDescription"
  },
  url: '/products/back-to-school-bundle'
}; // Soundboks Gen. 2

productMetadata['soundboks-gen-2'] = {
  "default": {
    title:
    /*i18n*/
    {
      id: "products.soundboks2.meta.title"
    },
    desc:
    /*i18n*/
    {
      id: "products.soundboks2.meta.description"
    },
    url: '/products/soundboks-gen-2'
  },
  eu: {
    title:
    /*i18n*/
    {
      id: "products.soundboks2.meta.title"
    },
    desc:
    /*i18n*/
    {
      id: "products.soundboks2.meta.description"
    }
  }
}; // Soundboks Gen. 3

productMetadata['soundboks-gen-3'] = {
  "default": {
    title:
    /*i18n*/
    {
      id: "speakers.sb3.meta.title"
    },
    desc:
    /*i18n*/
    {
      id: "speakers.sb3.meta.description"
    },
    url: '/products/soundboks-gen-3/'
  }
}; // Soundboks Gen. 3 Refurbished

productMetadata['soundboks-gen-3-refurbished'] = {
  "default": {
    title:
    /*i18n*/
    {
      id: "speakers.sb3-ref.meta.title"
    },
    desc:
    /*i18n*/
    {
      id: "speakers.sb3-ref.meta.description"
    },
    url: '/products/soundboks-gen-3-refurbished/'
  }
}; // Gift Card

productMetadata['gift-card'] = {
  "default": {
    title:
    /*i18n*/
    {
      id: "products.giftCard.meta.title",
      defaults: "The SOUNDBOKS Gift Card | SOUNDBOKS"
    },
    desc:
    /*i18n*/
    {
      id: "products.giftCard.meta.description",
      defaults: "Give loud. Get loud. Order your SOUNDBOKS gift card today"
    },
    url: '/products/gift-card'
  },
  eu: {
    title: 'The SOUNDBOKS Gift Card | SOUNDBOKS EU',
    desc: 'Give loud. Get loud. Order your SOUNDBOKS gift card today'
  }
}; // White grill

productMetadata['grill-white'] = {
  title:
  /*i18n*/
  {
    id: "Buy Special Edition Grills | SOUNDBOKS Grills"
  },
  desc:
  /*i18n*/
  {
    id: "Buy replacement & Special Edition speaker grills for SOUNDBOKS (Gen. 3)."
  },
  url: '/products/grill-white',
  imgSrc: "".concat(all_grillz_default.a.url),
  ogImgSrc: "".concat(all_grillz_default.a.url)
}; // Black grill

productMetadata['grill-black'] = {
  title:
  /*i18n*/
  {
    id: "Buy Special Edition Grills | SOUNDBOKS Grills"
  },
  desc:
  /*i18n*/
  {
    id: "Buy replacement & Special Edition speaker grills for SOUNDBOKS (Gen. 3)."
  },
  url: '/products/grill-black',
  imgSrc: "".concat(all_grillz_default.a.url),
  ogImgSrc: "".concat(all_grillz_default.a.url)
}; // Orange grill

productMetadata['grill-orange'] = {
  title:
  /*i18n*/
  {
    id: "Buy Special Edition Grills | SOUNDBOKS Grills"
  },
  desc:
  /*i18n*/
  {
    id: "Buy replacement & Special Edition speaker grills for SOUNDBOKS (Gen 3)."
  },
  url: '/products/grill-orange',
  imgSrc: "".concat(all_grillz_default.a.url),
  ogImgSrc: "".concat(all_grillz_default.a.url)
}; // Artist edition grill - Johan Buchler

productMetadata['artist-edition-grill-johan-buchler'] = {
  title:
  /*i18n*/
  {
    id: "Limited Artist Edition Grill af Johan B\xFCchler | SOUNDBOKS DK"
  },
  desc:
  /*i18n*/
  {
    id: "Limited Edition grill-design af den danske illustrator, Johan B\xFCchler. Der f\xF8lger tre specialdesignede SOUNDBOKS stickers med."
  },
  url: '/products/artist-edition-grill-johan-buchler',
  imgSrc: "".concat(all_grillz_default.a.url),
  ogImgSrc: "".concat(all_grillz_default.a.url)
}; // Artist edition grill - Anna T-Iron

productMetadata['artist-edition-grill-anna-eisenhauer'] = {
  title:
  /*i18n*/
  {
    id: "product.artist-edition-grill-anna-eisenhauer.metaTitle"
  },
  desc:
  /*i18n*/
  {
    id: "product.artist-edition-grill-anna-eisenhauer.metaDescription"
  },
  url: '/products/artist-edition-anna-eisenhauer',
  imgSrc: "".concat(all_grillz_default.a.url),
  ogImgSrc: "".concat(all_grillz_default.a.url)
}; // Artist edition grill - Daniel Triendl

productMetadata['artist-edition-grill-daniel-triendl'] = {
  title:
  /*i18n*/
  {
    id: "product.artist-edition-grill-daniel-triendl.metaTitle"
  },
  desc:
  /*i18n*/
  {
    id: "product.artist-edition-grill-daniel-triendl.metaDescription"
  },
  url: '/products/artist-edition-grill-daniel-triendl',
  imgSrc: "".concat(all_grillz_default.a.url),
  ogImgSrc: "".concat(all_grillz_default.a.url)
}; // Artist edition grill - Pippa Toole

productMetadata['artist-edition-grill-pippa-toole'] = {
  title:
  /*i18n*/
  {
    id: "product.artist-edition-grill-pippa-toole.metaTitle"
  },
  desc:
  /*i18n*/
  {
    id: "product.artist-edition-grill-pippa-toole.metaDescription"
  },
  url: '/products/artist-edition-grill-pippa-toole',
  imgSrc: "".concat(all_grillz_default.a.url),
  ogImgSrc: "".concat(all_grillz_default.a.url)
}; // Artist edition grill - Pippa Toole

productMetadata['artist-edition-grill-jess-ebsworth'] = {
  title:
  /*i18n*/
  {
    id: "product.artist-edition-grill-jess-ebsworth.metaTitle"
  },
  desc:
  /*i18n*/
  {
    id: "product.artist-edition-grill-jess-ebsworth.metaDescription"
  },
  url: '/products/artist-edition-grill-jess-ebsworth',
  imgSrc: "".concat(all_grillz_default.a.url),
  ogImgSrc: "".concat(all_grillz_default.a.url)
}; // Dortmund Football Edition

productMetadata['fan-edition-yellow'] = {
  title:
  /*i18n*/
  {
    id: "product.dortmund-football-edition.buy-page.metaTitle"
  },
  desc:
  /*i18n*/
  {
    id: "product.dortmund-football-edition.buy-page.description"
  },
  url: '/products/fan-edition-yellow'
}; // Bayern Football Edition

productMetadata['fan-edition-red'] = {
  title:
  /*i18n*/
  {
    id: "product.bayern-football-edition.buy-page.metaTitle"
  },
  desc:
  /*i18n*/
  {
    id: "product.bayern-football-edition.buy-page.description"
  },
  url: '/products/fan-edition-red'
}; // FCK Limited Edition speaker

productMetadata['fck-edition'] = {
  title:
  /*i18n*/
  {
    id: "product.fck-edition.metaTitle"
  },
  desc:
  /*i18n*/
  {
    id: "product.fck-edition.metaDescription"
  },
  url: '/products/fck-edition'
}; // Carrier Strap

productMetadata['carrier-strap'] = {
  "default": {
    title:
    /*i18n*/
    {
      id: "product.carrier-strap.metaTitle"
    },
    desc:
    /*i18n*/
    {
      id: "product.carrier-strap.metaDescription"
    },
    url: '/products/carrier-strap'
  }
}; // Tripod

productMetadata['tripod-speaker-stand'] = {
  "default": {
    title:
    /*i18n*/
    {
      id: "product.tripod.metaTitle"
    },
    desc:
    /*i18n*/
    {
      id: "product.tripod.metaDescription"
    },
    url: '/products/tripod'
  },
  eu: {
    title:
    /*i18n*/
    {
      id: "product.tripod.metaTitle.eu"
    },
    desc:
    /*i18n*/
    {
      id: "product.tripod.metaDescription.eu"
    }
  }
}; // Powerbank

productMetadata.powerbank = {
  "default": {
    title:
    /*i18n*/
    {
      id: "product.powerbank.metaTitle"
    },
    desc:
    /*i18n*/
    {
      id: "product.powerbank.metaDescription"
    },
    url: '/products/powerbank'
  },
  eu: {
    title:
    /*i18n*/
    {
      id: "product.powerbank.metaTitle.eu"
    },
    desc:
    /*i18n*/
    {
      id: "product.powerbank.metaDescription.eu"
    }
  }
}; // XLR Cable

productMetadata['xlr-cable'] = {
  "default": {
    title:
    /*i18n*/
    {
      id: "product.xlr-cable.metaTitle"
    },
    desc:
    /*i18n*/
    {
      id: "product.xlr-cable.metaDescription"
    },
    url: '/products/xlr-cable'
  },
  eu: {
    title:
    /*i18n*/
    {
      id: "product.xlr-cable.metaTitle.eu"
    },
    desc:
    /*i18n*/
    {
      id: "product.xlr-cable.metaDescription.eu"
    }
  }
}; // TRS Cable

productMetadata['trs-cable'] = {
  "default": {
    title:
    /*i18n*/
    {
      id: "product.trs-cable.metaTitle"
    },
    desc:
    /*i18n*/
    {
      id: "product.trs-cable.metaDescription"
    },
    url: '/products/trs-cable'
  },
  eu: {
    title:
    /*i18n*/
    {
      id: "product.trs-cable.metaTitle.eu"
    },
    desc:
    /*i18n*/
    {
      id: "product.trs-cable.metaDescription.eu"
    }
  }
}; // FCK Limited Edition speaker

productMetadata['aux-cable'] = {
  "default": {
    title:
    /*i18n*/
    {
      id: "product.aux-cable.metaTitle"
    },
    desc:
    /*i18n*/
    {
      id: "product.aux-cable.metaDescription"
    },
    url: '/products/aux-cable'
  },
  eu: {
    title:
    /*i18n*/
    {
      id: "product.aux-cable.metaTitle.eu"
    },
    desc:
    /*i18n*/
    {
      id: "product.aux-cable.metaDescription.eu"
    }
  }
}; // Cable Bundle

productMetadata['cable-bundle'] = {
  "default": {
    title:
    /*i18n*/
    {
      id: "product.cable-bundle.metaTitle"
    },
    desc:
    /*i18n*/
    {
      id: "product.cable-bundle.metaDescription"
    },
    url: '/products/cable-bundle'
  }
}; // Elevation Pack

productMetadata['elevation-pack'] = {
  "default": {
    title:
    /*i18n*/
    {
      id: "product.elevation-pack.metaTitle"
    },
    desc:
    /*i18n*/
    {
      id: "product.elevation-pack.metaDescription"
    },
    url: '/products/elevation-pack'
  }
};
productMetadata.microphone = {
  "default": {
    title:
    /*i18n*/
    {
      id: "product.microphone.metaTitle"
    },
    desc:
    /*i18n*/
    {
      id: "product.microphone.metaDescription"
    },
    url: '/products/microphone'
  }
};
productMetadata['performer-pack'] = {
  "default": {
    title:
    /*i18n*/
    {
      id: "product.performer-pack.metaTitle"
    },
    desc:
    /*i18n*/
    {
      id: "product.performer-pack.metaDescription"
    },
    url: '/products/performer-pack'
  }
}; // Endurance pack

productMetadata['endurance-pack'] = {
  "default": {
    title:
    /*i18n*/
    {
      id: "product.endurance-pack.metaTitle"
    },
    desc:
    /*i18n*/
    {
      id: "product.endurance-pack.metaDescription"
    },
    url: '/products/endurance-pack'
  }
}; // Soundboks Mikkeller Edition DK

productMetadata['soundboks-mikkeller-edition-dk'] = {
  "default": {
    title:
    /*i18n*/
    {
      id: "product.soundboks-mikkeller-edition-dk.metaTitle"
    },
    desc:
    /*i18n*/
    {
      id: "product.soundboks-mikkeller-edition-dk"
    },
    url: '/products/soundboks-mikkeller-edition-dk'
  }
}; // Soundboks Mikkeller Edition US

productMetadata['soundboks-mikkeller-edition-us'] = {
  "default": {
    title:
    /*i18n*/
    {
      id: "product.soundboks-mikkeller-edition-us.metaTitle"
    },
    desc:
    /*i18n*/
    {
      id: "product.soundboks-mikkeller-edition-us"
    },
    url: '/products/soundboks-mikkeller-edition-us'
  }
}; // Soundboks Mikkeller Edition DE

productMetadata['soundboks-mikkeller-edition-de'] = {
  "default": {
    title:
    /*i18n*/
    {
      id: "product.soundboks-mikkeller-edition-de.metaTitle"
    },
    desc:
    /*i18n*/
    {
      id: "product.soundboks-mikkeller-edition-de.metaDescription"
    },
    url: '/products/soundboks-mikkeller-edition-de'
  }
}; // Soundboks LGBT+ Ungdom Edition DK

productMetadata['soundboks-lgbt-ungdom-dk'] = {
  title:
  /*i18n*/
  {
    id: "product.soundboks-lgbt-ungdom-dk.metaTitle"
  },
  desc:
  /*i18n*/
  {
    id: "product.soundboks-lgbt-ungdom-dk.metaDescription"
  },
  url: '/products/soundboks-lgbt-ungdom-dk'
}; // Soundboks george-f-baker-artist-grill

productMetadata['george-f-baker-artist-grill'] = {
  title:
  /*i18n*/
  {
    id: "product.georgeBakerSpeaker.metaTitle"
  },
  desc:
  /*i18n*/
  {
    id: "product.georgeBakerSpeaker.metaDescription"
  },
  url: '/products/george-f-baker-artist-grill'
}; // Red Cross Package Edition DK

productMetadata['red-cross-care-package-edition'] = {
  title:
  /*i18n*/
  {
    id: "product.red-cross-package.metaTitle"
  },
  desc:
  /*i18n*/
  {
    id: "product.red-cross-package.metaDescription"
  },
  url: '/products/red-cross-care-package-edition'
}; // Red Cross Package Edition DK

productMetadata['zack-rosebrugh-artist-grill'] = {
  title:
  /*i18n*/
  {
    id: "product.zack-rosebrugh-artist-grill.metaTitle"
  },
  desc:
  /*i18n*/
  {
    id: "product.zack-rosebrugh-artist-grill.metaDescription"
  },
  url: '/products/zack-rosebrugh-artist-grill'
}; // Power Pack Edition

productMetadata['power-pack'] = {
  title:
  /*i18n*/
  {
    id: "product.power-pack.metaTitle"
  },
  desc:
  /*i18n*/
  {
    id: "product.power-pack.metaDescription"
  },
  url: '/products/power-pack'
}; // Weekender pack

productMetadata['weekender-pack'] = {
  "default": {
    title:
    /*i18n*/
    {
      id: "product.weekender-pack.metaTitle"
    },
    desc:
    /*i18n*/
    {
      id: "product.weekender-pack.metaDescription"
    },
    url: '/products/weekender-pack'
  }
};
/* harmony default export */ var data_productMetadata = (productMetadata);
// EXTERNAL MODULE: ./data/regions.js
var regions = __webpack_require__("keR7");
var regions_default = /*#__PURE__*/__webpack_require__.n(regions);

// CONCATENATED MODULE: ./utils/hooks/useRegion.js



var useRegion_useRegion = function useRegion() {
  var regionId = Object(es["d" /* useSelector */])(function (state) {
    return state.settings.regionId;
  });
  return regions_default.a.byId[regionId];
};

/* harmony default export */ var hooks_useRegion = (useRegion_useRegion);
// CONCATENATED MODULE: ./components/shared/BuyProduct/Meta/index.js

var Meta_jsx = react_default.a.createElement;

function Meta_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Meta_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Meta_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Meta_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







 // Meta tag component for a single product base on data loaded from Shopify

var Meta_Component = function Component(_ref) {
  var shopId = _ref.shopId,
      selectedVariantPrice = _ref.selectedVariantPrice,
      handle = _ref.handle;
  var _abstractProducts$byI = abstractProducts_default.a.byId[handle],
      productImageIds = _abstractProducts$byI.productImageIds,
      rating = _abstractProducts$byI.rating;

  var _useRegion = hooks_useRegion(),
      regionId = _useRegion.id;

  var currency = shops_default.a.byId[shopId].currencyId;
  var price = selectedVariantPrice;
  var metaImage = data_productImages["byId"][productImageIds[0]].url;

  var pageInfo = Meta_objectSpread({}, data_productMetadata["default"]);

  var productMeta = data_productMetadata[handle];
  if (!productMeta) throw new Error("Meta data for product is missing: ".concat(handle));
  var hasRegionalMeta = Object.keys(productMeta).includes('default');
  var hasCurrentRegionMeta = Object.keys(productMeta).includes(regionId);
  var metaInfo = hasRegionalMeta && hasCurrentRegionMeta && productMeta[regionId] || hasRegionalMeta && productMeta["default"] || productMeta;

  try {
    pageInfo = Meta_objectSpread({
      imgSrc: "".concat(metaImage, "?w=600&h=600"),
      ogImgSrc: "".concat(metaImage, "?w=1200&h=630"),
      product: {
        price: price,
        currency: currency
      },
      rating: rating
    }, metaInfo);
  } catch (e) {
    console.log(e);
  }

  return /*#__PURE__*/react_default.a.createElement(Meta["a" /* default */], {
    isProduct: true,
    pageInfo: pageInfo
  });
};

/* harmony default export */ var BuyProduct_Meta = (Meta_Component);
// EXTERNAL MODULE: ./components/shared/BuyProduct/ProductOptions/index.js + 5 modules
var ProductOptions = __webpack_require__("gPJZ");

// EXTERNAL MODULE: ./components/shared/BuyProduct/PriceAndCart/index.js + 9 modules
var PriceAndCart = __webpack_require__("Y5yV");

// CONCATENATED MODULE: ./components/shared/BuyProduct/Title/index.tsx
var Title_jsx = react_default.a.createElement;




var Title_Title = function Title(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/react_default.a.createElement(StyledH1, null, children);
};

var StyledH1 = Object(styled_components_browser_esm["default"])(Text["c" /* H1 */]).withConfig({
  displayName: "Title__StyledH1",
  componentId: "sc-819w73-0"
})(["margin-bottom:0;"]);
/* harmony default export */ var BuyProduct_Title = (Title_Title);
// CONCATENATED MODULE: ./components/shared/BuyProduct/utils.js
var shouldShowPerks = function shouldShowPerks(handle) {
  return handle !== 'gift-card';
}; // prettier-ignore

var shouldShowProductDescription = function shouldShowProductDescription(handle, isLiveUS, hasEnded) {
  return handle === 'gift-card' || handle === 'soundboks-gen-3' || handle === 'soundboks-go' || handle === 'soundboks-gen-2' && isLiveUS && !hasEnded || handle === 'soundboks-gen-3-refurbished' || handle === 'jagermeister-2022-edition' || handle === 'artist-edition-grill-johan-buchler' || handle === 'artist-edition-grill-anna-eisenhauer' || handle === 'artist-edition-grill-daniel-triendl' || handle === 'artist-edition-grill-pippa-toole' || handle === 'george-f-baker-artist-grill' || handle === 'red-cross-care-package-edition' || handle === 'zack-rosebrugh-artist-grill' || handle === 'performer-pack' || handle === 'carrier-strap' || handle === 'artist-edition-grill-jess-ebsworth' || handle === 'soundboks-lgbt-ungdom-dk' || handle === 'soundboks-mikkeller-edition-dk' || handle === 'soundboks-mikkeller-edition-us' || handle === 'soundboks-mikkeller-edition-de' || handle === 'back-to-school-bundle' || handle === 'weekender-pack' || handle === 'tripod-speaker-stand' || handle === 'powerbank' || handle === 'aux-cable' || handle === 'explorer-pack' || handle === 'adventure-pack' || handle === 'xlr-cable' || handle === 'trs-cable' || handle === 'cable-bundle' || handle === 'elevation-pack' || handle === 'microphone' || handle === 'fck-edition' || handle === 'endurance-pack' || handle === 'batteryboks';
};
var shouldShowTags = function shouldShowTags(handle) {
  return handle === 'soundboks-gen-3';
};
// CONCATENATED MODULE: ./components/shared/BuyProduct/index.jsx
var BuyProduct_jsx = react_default.a.createElement;



























var BuyProduct_renderDescription = function renderDescription(handle, regionId) {
  var _abstractProducts$byI = abstractProducts_default.a.byId[handle].descriptionBuyPage,
      text = _abstractProducts$byI.text,
      href = _abstractProducts$byI.href,
      hrefAs = _abstractProducts$byI.hrefAs,
      linkText = _abstractProducts$byI.linkText;

  var _checkProduct = Object(checkProduct["a" /* checkProduct */])(handle),
      isSoundboksGen3 = _checkProduct.isSoundboksGen3;

  var description = isSoundboksGen3 ? text.jan2022Promo : text[regionId] || text["default"];

  if (!description) {
    return null;
  }

  return /*#__PURE__*/react_default.a.createElement(BuyProduct_Description, {
    description: description,
    href: href,
    hrefAs: hrefAs,
    linkText: linkText
  });
};

var BuyProduct_renderTags = function renderTags(i18n, handle, regionId) {
  var tagsBuyPage = abstractProducts_default.a.byId[handle].tagsBuyPage;
  var tags = tagsBuyPage.reduce(function (list, tag) {
    var label = tag[regionId] || tag["default"];

    if (label) {
      list.push(i18n._(label));
    }

    return list;
  }, []);

  if (tags.length === 0) {
    return /*#__PURE__*/react_default.a.createElement(BuyProduct_Tags, {
      tags: null
    });
  }

  return /*#__PURE__*/react_default.a.createElement(BuyProduct_Tags, {
    tags: tags
  });
};

var BuyProduct_BuyProductPage = function BuyProductPage(_ref) {
  var _dynamicVariants$byId, _dynamicVariants$byId2, _dynamicVariants$byId3;

  var productId = _ref.productId;

  var _useSelector = Object(es["d" /* useSelector */])(function (state) {
    return state.entities.products.byId[productId];
  }),
      shopId = _useSelector.shopId,
      handle = _useSelector.handle,
      title = _useSelector.title,
      variantIds = _useSelector.variantIds,
      optionIds = _useSelector.optionIds;

  var regionId = Object(es["d" /* useSelector */])(function (state) {
    return state.settings.regionId;
  });
  var defaultVariantId = Object(useDefaultVariantIdFromProductId["a" /* default */])(productId);

  var _useState = Object(react["useState"])(defaultVariantId),
      selectedVariantId = _useState[0],
      setSelectedVariantId = _useState[1];

  var productCategories = Object(mergeUACategories["a" /* default */])(abstractProducts_default.a.byId[handle].categories);
  var _abstractProducts$byI2 = abstractProducts_default.a.byId[handle],
      financingOptions = _abstractProducts$byI2.financingOptions,
      crossSellHandles = _abstractProducts$byI2.crossSellHandles,
      excludeProductOptions = _abstractProducts$byI2.excludeProductOptions;
  var selectedVariant = Object(es["d" /* useSelector */])(function (state) {
    return state.entities.variants.byId[selectedVariantId];
  });
  var abstractProduct = abstractProducts_default.a.byId[handle];
  var hasVariants = variantIds.length > 1;
  var hasPackage = abstractProduct.packageItemIds && abstractProduct.packageItemIds.length > 0; // Dynamically getting the variants through hook

  var dynamicVariants = Object(useGetDynamicVariants["a" /* default */])(variantIds, shopId);
  var variantPrice = (_dynamicVariants$byId = dynamicVariants.byId[selectedVariantId]) === null || _dynamicVariants$byId === void 0 ? void 0 : _dynamicVariants$byId.price;
  var variantAvailability = (_dynamicVariants$byId2 = dynamicVariants.byId[selectedVariantId]) === null || _dynamicVariants$byId2 === void 0 ? void 0 : _dynamicVariants$byId2.available;
  var variantcompareAtPrice = (_dynamicVariants$byId3 = dynamicVariants.byId[selectedVariantId]) === null || _dynamicVariants$byId3 === void 0 ? void 0 : _dynamicVariants$byId3.compareAtPrice;

  var makeSoundBoksTitlePretty = function makeSoundBoksTitlePretty(productTitle) {
    if (/SOUNDBOKS \(Gen\. 3\)/i.test(productTitle)) {
      return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "SOUNDBOKS", /*#__PURE__*/react_default.a.createElement("br", null), "(Gen. 3)");
    }

    if (/SOUNDBOKS \(Gen\. 2\)/i.test(productTitle)) {
      return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "SOUNDBOKS", /*#__PURE__*/react_default.a.createElement("br", null), "(Gen. 2)");
    }

    return productTitle;
  }; // Change the selected variant in case the product changes (e.g. country change). This doesn't
  // preserve the current selection but it's better than nothing.


  Object(react["useEffect"])(function () {
    setSelectedVariantId(defaultVariantId);
  }, [defaultVariantId]);
  Object(react["useEffect"])(function () {
    var timer = setTimeout(function () {
      return Object(utils["i" /* trackProductPageview */])({
        name: title,
        id: selectedVariant.sku,
        price: selectedVariant.price,
        brand: 'soundboks',
        category: productCategories,
        variant: selectedVariant.title === 'Default Title' ? title : selectedVariant.title,
        image: selectedVariant.image
      });
    }, 1000);
    return function () {
      return clearTimeout(timer);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [regionId, selectedVariant]);
  return /*#__PURE__*/react_default.a.createElement("div", null, /*#__PURE__*/react_default.a.createElement(BuyProduct_Meta, {
    handle: handle,
    shopId: shopId,
    selectedVariantPrice: selectedVariant.price
  }), /*#__PURE__*/react_default.a.createElement(Row["a" /* default */], null, /*#__PURE__*/react_default.a.createElement(wrappers_OfferWrapper, {
    hasVariants: hasVariants,
    numOfOptions: optionIds.length
  }, /*#__PURE__*/react_default.a.createElement(GridItemWrapper, {
    area: "title"
  }, /*#__PURE__*/react_default.a.createElement(BuyProduct_Title, null, makeSoundBoksTitlePretty(title))), /*#__PURE__*/react_default.a.createElement(GridItemWrapper, {
    area: "gallery"
  }, /*#__PURE__*/react_default.a.createElement(Gallery["a" /* default */], {
    title: title,
    handle: handle,
    variantId: selectedVariantId
  })), shouldShowTags(handle) && /*#__PURE__*/react_default.a.createElement(GridItemWrapper, {
    area: "tags"
  }, /*#__PURE__*/react_default.a.createElement(Composition["e" /* Spacer */], {
    size: theme["l" /* Space */].Small,
    direction: Composition["f" /* SpacerDirection */].Vertical
  }), /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return BuyProduct_renderTags(i18n, handle, regionId);
  })), shouldShowPerks(handle) && /*#__PURE__*/react_default.a.createElement(GridItemWrapper, {
    area: "perks"
  }, /*#__PURE__*/react_default.a.createElement(Composition["e" /* Spacer */], {
    size: theme["l" /* Space */].Large,
    direction: Composition["f" /* SpacerDirection */].Vertical
  }), /*#__PURE__*/react_default.a.createElement(Perks["a" /* default */], {
    handle: handle
  })), shouldShowProductDescription(handle) && /*#__PURE__*/react_default.a.createElement(GridItemWrapper, {
    area: "description"
  }, /*#__PURE__*/react_default.a.createElement(Composition["e" /* Spacer */], {
    size: theme["l" /* Space */].Large,
    direction: Composition["f" /* SpacerDirection */].Vertical
  }), BuyProduct_renderDescription(handle, regionId)), hasVariants && /*#__PURE__*/react_default.a.createElement(GridItemWrapper, {
    area: "options"
  }, /*#__PURE__*/react_default.a.createElement(ProductOptions["a" /* default */], {
    selectedVariantId: selectedVariantId,
    setSelectedVariantId: setSelectedVariantId,
    excludeProductOptions: excludeProductOptions
  })), /*#__PURE__*/react_default.a.createElement(GridItemWrapper, {
    area: "buy"
  }, /*#__PURE__*/react_default.a.createElement(Composition["e" /* Spacer */], {
    size: theme["l" /* Space */].Large,
    direction: Composition["f" /* SpacerDirection */].Vertical
  }), /*#__PURE__*/react_default.a.createElement(PriceAndCart["a" /* default */], {
    handle: handle,
    variantPrice: variantPrice,
    variantAvailability: variantAvailability,
    variantcompareAtPrice: variantcompareAtPrice,
    selectedVariantId: selectedVariantId,
    financingOptions: financingOptions
  })))), hasPackage && /*#__PURE__*/react_default.a.createElement(Package["a" /* default */], {
    handle: handle,
    variantId: selectedVariantId
  }), /*#__PURE__*/react_default.a.createElement(BuyProduct_FAQ, {
    productHandle: handle
  }), /*#__PURE__*/react_default.a.createElement(ShopSection["a" /* default */], {
    crossSellHandles: crossSellHandles
  }));
};

var GridItemWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "BuyProduct__GridItemWrapper",
  componentId: "ycf2uh-0"
})(["grid-area:", ";"], function (props) {
  return props.area;
});
/* harmony default export */ var BuyProduct = (BuyProduct_BuyProductPage);
// EXTERNAL MODULE: ./data/productSubPages.js
var data_productSubPages = __webpack_require__("KriC");
var productSubPages_default = /*#__PURE__*/__webpack_require__.n(data_productSubPages);

// EXTERNAL MODULE: ./components/shared/Header/index.js + 13 modules
var Header = __webpack_require__("OxDG");

// EXTERNAL MODULE: ./components/shared/Header/Menu.js
var Menu = __webpack_require__("m65x");

// EXTERNAL MODULE: ./components/shared/Header/MenuItem.js
var MenuItem = __webpack_require__("dX32");

// CONCATENATED MODULE: ./components/shared/ProductHeader/index.js
var ProductHeader_jsx = react_default.a.createElement;








var productBaseUrl = '/products/product?productHandle=';

var ProductHeader_ProductMenuItems = function ProductMenuItems(_ref) {
  var productHandle = _ref.productHandle,
      activeSubPageId = _ref.activeSubPageId;
  var abstractProduct = abstractProducts_default.a.byId[productHandle];
  var memoizedItems = Object(react["useMemo"])(function () {
    var items;

    if (abstractProduct) {
      items = abstractProduct.subPages.map(function (subPageId) {
        var _productSubPages$byId = productSubPages_default.a.byId[subPageId],
            name = _productSubPages$byId.name,
            id = _productSubPages$byId.id;
        var href = "".concat(productBaseUrl).concat(productHandle, "&subPage=").concat(id);
        var as = "/products/".concat(productHandle, "/").concat(id);
        var isActive = activeSubPageId === id;
        return {
          name: name,
          id: id,
          href: href,
          as: as,
          isActive: isActive
        };
      });
    }

    return items;
  }, [abstractProduct, activeSubPageId, productHandle]);
  return memoizedItems.map(function (item) {
    return /*#__PURE__*/react_default.a.createElement(MenuItem["a" /* default */], {
      key: item.id,
      href: item.href,
      as: item.as,
      isActive: item.isActive,
      isShopThemed: item.isShopThemed
    }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
      id: item.name
    }));
  });
};

var StickyHeader = /*#__PURE__*/react_default.a.memo(function (_ref2) {
  var productHandle = _ref2.productHandle,
      activeSubPageId = _ref2.activeSubPageId;

  var _useState = Object(react["useState"])(false),
      isSticky = _useState[0],
      setIsSticky = _useState[1];

  var ref = Object(react["useRef"])(null);
  var handleScrollEvent = Object(react["useCallback"])(function () {
    var _ref$current$getBound = ref.current.getBoundingClientRect(),
        top = _ref$current$getBound.top;

    if (!isSticky && top && top <= 0) {
      setIsSticky(true);
    } else if (isSticky && top && top > 0) {
      setIsSticky(false);
    }
  }, [isSticky]);
  Object(react["useEffect"])(function () {
    handleScrollEvent();
    window.addEventListener('scroll', handleScrollEvent);
    return function () {
      window.removeEventListener('scroll', handleScrollEvent);
    };
  });
  return /*#__PURE__*/react_default.a.createElement(Reference, {
    ref: ref
  }, /*#__PURE__*/react_default.a.createElement(Header["a" /* default */], {
    isInverted: true,
    isFixed: isSticky,
    hasLogo: false,
    hasCountrySelectorButton: false,
    hasCartButton: isSticky,
    centerContent: /*#__PURE__*/react_default.a.createElement(Menu["a" /* default */], {
      activeLabel: activeSubPageId === '/' ? /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Buy"
      }) : activeSubPageId
    }, /*#__PURE__*/react_default.a.createElement(ProductHeader_ProductMenuItems, {
      productHandle: productHandle,
      activeSubPageId: activeSubPageId
    })),
    endContent: /*#__PURE__*/react_default.a.createElement(MenuItem["a" /* default */], {
      href: "".concat(productBaseUrl).concat(productHandle),
      as: "/products/".concat(productHandle),
      isActive: activeSubPageId === '/',
      isShopThemed: true
    }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
      id: "Buy"
    }))
  }));
});
var Reference = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductHeader__Reference",
  componentId: "sc-166lrhg-0"
})(["display:flex;position:static;width:100%;"]);
StickyHeader.defaultProps = {
  activeSubPageId: null
};
/* harmony default export */ var ProductHeader = (StickyHeader);
// EXTERNAL MODULE: ./components/wrappers/PageTracker/index.tsx
var PageTracker = __webpack_require__("LDcx");

// EXTERNAL MODULE: ./components/shared/HeroImg/index.js + 4 modules
var HeroImg = __webpack_require__("mnsV");

// CONCATENATED MODULE: ./public/static/video/driver@2x.mp4
/* harmony default export */ var driver_2x = ("/_next/static/public/static/video/driver@2x-4dda8ebd81844e81834d9256bed22f20.mp4");
// EXTERNAL MODULE: ./components/atoms/Picture/index.js + 3 modules
var Picture = __webpack_require__("Z1QS");

// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/Sound/InfoBlockWrapper.js

var InfoBlockWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InfoBlockWrapper",
  componentId: "sc-1f2ka85-0"
})(["height:175px;width:175px;justify-self:center;align-self:center;margin-bottom:20px;& > video{max-width:100%;height:auto;}@media ", "{height:250px;width:250px;margin-bottom:0;}@media ", "{height:300px;width:300px;}@media ", "{height:420px;width:420px;}", ""], function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.breakpoints.desktop;
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
}, function (props) {
  return props.scl && 'transform: scale(0.8)';
});
/* harmony default export */ var Sound_InfoBlockWrapper = (InfoBlockWrapper);
// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/Sound/InfoBlock.js
var InfoBlock_jsx = react_default.a.createElement;





var InfoBlock_InfoBlock = function InfoBlock(_ref) {
  var image = _ref.image,
      video = _ref.video;
  return /*#__PURE__*/react_default.a.createElement(Sound_InfoBlockWrapper, null, video ? /*#__PURE__*/react_default.a.createElement(VideoWrapper, null, /*#__PURE__*/react_default.a.createElement("video", {
    playsInline: true,
    muted: true,
    autoPlay: true,
    loop: true,
    src: video,
    poster: image.url
  })) : /*#__PURE__*/react_default.a.createElement(Picture["a" /* default */], {
    images: [{
      src: image.url,
      height: 300,
      key: '1'
    }],
    placeholder: image.placeholder,
    alt: "Soundboks"
  }));
};

var VideoWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InfoBlock__VideoWrapper",
  componentId: "sc-1y3jof4-0"
})(["width:75%;margin:0 auto;margin-bottom:33px;> video{max-width:100%;height:auto;}"]);
InfoBlock_InfoBlock.defaultProps = {
  video: null
};
/* harmony default export */ var Sound_InfoBlock = (InfoBlock_InfoBlock);
// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/Sound/InfoText.js

 // 16 20 28

var InfoText = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InfoText",
  componentId: "sc-12xyfhr-0"
})(["display:flex;justify-self:center;align-self:center;align-items:center;font-size:16px;line-height:24px;font-weight:bold;", ";&:not(:last-child){margin-bottom:64px;}@media ", "{text-align:center;}@media ", "{font-size:20px;line-height:30px;margin-bottom:0;}@media ", "{font-size:30px;line-height:40px;}"], Object(paramToResolutions["a" /* default */])('width', ['100%', 250, 300, 420]), function (props) {
  return props.theme.breakpoints.onlyMobile;
}, function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
});
/* harmony default export */ var Sound_InfoText = (InfoText);
// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/Sound/InfoWrapper.js


var InfoWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InfoWrapper",
  componentId: "ga2ky9-0"
})(["display:grid;grid-template-columns:1fr;", ";@media ", "{grid-template-columns:1fr 1fr;div:nth-of-type(1){order:1;}div:nth-of-type(2){order:2;justify-self:flex-start;}div:nth-of-type(3){order:4;}div:nth-of-type(4){order:3;justify-self:flex-end;}div:nth-of-type(5){order:5;}div:nth-of-type(6){order:6;justify-self:flex-start;}}"], Object(paramToResolutions["a" /* default */])('grid-row-gap', [null, 66, undefined, 130]), function (props) {
  return props.theme.breakpoints.tablet;
});
/* harmony default export */ var Sound_InfoWrapper = (InfoWrapper);
// EXTERNAL MODULE: ./styles/theme.js
var styles_theme = __webpack_require__("NVT0");

// EXTERNAL MODULE: ./components/pages/product/Soundboks2/Overview/Sound/images/soundboks_sound.jpg
var soundboks_sound = __webpack_require__("RyK0");
var soundboks_sound_default = /*#__PURE__*/__webpack_require__.n(soundboks_sound);

// EXTERNAL MODULE: ./components/pages/product/Soundboks2/Overview/Sound/images/soundboks_sound-768.jpg?placeholder
var soundboks_sound_768placeholder = __webpack_require__("OeER");
var soundboks_sound_768placeholder_default = /*#__PURE__*/__webpack_require__.n(soundboks_sound_768placeholder);

// EXTERNAL MODULE: ./components/pages/product/Soundboks2/Overview/Sound/images/soundboks_sound-1024.jpg
var soundboks_sound_1024 = __webpack_require__("uFxA");
var soundboks_sound_1024_default = /*#__PURE__*/__webpack_require__.n(soundboks_sound_1024);

// EXTERNAL MODULE: ./components/pages/product/Soundboks2/Overview/Sound/images/soundboks_sound-1920.jpg
var soundboks_sound_1920 = __webpack_require__("2BJw");
var soundboks_sound_1920_default = /*#__PURE__*/__webpack_require__.n(soundboks_sound_1920);

// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/Sound/soundImageSrc.js





var soundDimension = {
  desktopLarge: {
    width: 1920,
    height: 650,
    // maxHeight: '650px',
    imgAlign: 'bottom'
  },
  desktop: {
    width: 1024,
    height: 520,
    // maxHeight: '520px',
    imgAlign: 'center'
  },
  tablet: {
    width: 768,
    height: 400,
    // maxHeight: '400px',
    imgAlign: 'bottom'
  },
  mobile: {
    width: 320,
    height: 320,
    // maxHeight: '320',
    imgAlign: 'bottom'
  }
};
var sounds = [{
  src: soundboks_sound_1920_default.a.url,
  width: soundDimension.desktopLarge.width,
  height: soundDimension.desktopLarge.height,
  media: styles_theme["a" /* default */].breakpoints.desktopLarge,
  key: '0'
}, {
  src: soundboks_sound_1024_default.a.url,
  width: soundDimension.desktop.width,
  height: soundDimension.desktop.height,
  media: styles_theme["a" /* default */].breakpoints.desktop,
  key: '1'
}, {
  src: soundboks_sound_768placeholder_default.a.url,
  width: soundDimension.tablet.width,
  height: soundDimension.tablet.height,
  media: styles_theme["a" /* default */].breakpoints.tablet,
  key: '2'
}, {
  src: soundboks_sound_default.a.url,
  width: soundDimension.mobile.width,
  height: soundDimension.mobile.height,
  key: '3'
}];
var soundPlaceholder = soundboks_sound_default.a.placeholder;

// EXTERNAL MODULE: ./components/atoms/Text/mixins/highlightMixins.js
var highlightMixins = __webpack_require__("8BqB");

// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/shared/Headline.js



var Headline = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Headline",
  componentId: "sc-12gun3c-0"
})(["", ";margin:", "px auto 0 auto;width:", "px;text-align:center;@media ", "{width:", "px;margin-top:", "px;}@media ", "{width:", "px;}@media ", "{width:", "px;margin-top:", "px;}"], highlightMixins["d" /* highlightMixin4 */], styles_theme["a" /* default */].baseline * 6, function (_ref) {
  var widths = _ref.widths;
  return widths[0];
}, styles_theme["a" /* default */].breakpoints.tablet, function (_ref2) {
  var widths = _ref2.widths;
  return widths[1];
}, styles_theme["a" /* default */].baseline * 10, styles_theme["a" /* default */].breakpoints.desktop, function (_ref3) {
  var widths = _ref3.widths;
  return widths[2];
}, styles_theme["a" /* default */].breakpoints.desktopLarge, function (_ref4) {
  var widths = _ref4.widths;
  return widths[3];
}, styles_theme["a" /* default */].baseline * 16);
/* harmony default export */ var shared_Headline = (Headline);
// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/Sound/index.js
var Sound_jsx = react_default.a.createElement;













var volumeImg = __webpack_require__("ICjs");

var modeImg = __webpack_require__("f1NO");

var ampImg = __webpack_require__("F1ob");

var ContentRow = Object(styled_components_browser_esm["default"])(Row["a" /* default */]).withConfig({
  displayName: "Sound__ContentRow",
  componentId: "sc-123ax03-0"
})(["", ";", ";"], Object(paramToResolutions["a" /* default */])('padding-top', [42, 40, 55, 160]), Object(paramToResolutions["a" /* default */])('padding-bottom', [90, 40, 130, 215]));

var Sound_Sound = function Sound() {
  return /*#__PURE__*/react_default.a.createElement("div", {
    id: "sound"
  }, /*#__PURE__*/react_default.a.createElement("div", null, /*#__PURE__*/react_default.a.createElement(HeroImg["a" /* default */], {
    heros: sounds,
    heroDimension: soundDimension,
    heroPlaceholder: soundPlaceholder,
    heroAlt: "SOUNDBOKS (Gen. 2) Hero Image",
    text:
    /*i18n*/
    {
      id: "Sound"
    }
  }), /*#__PURE__*/react_default.a.createElement(shared_Headline, {
    widths: [289, 512, 600, 940]
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "FEEL THE POWER. EXPERIENCE THE CLARITY."
  }))), /*#__PURE__*/react_default.a.createElement(ContentRow, null, /*#__PURE__*/react_default.a.createElement(Sound_InfoWrapper, null, /*#__PURE__*/react_default.a.createElement(Sound_InfoBlock, {
    image: volumeImg
  }), /*#__PURE__*/react_default.a.createElement(Sound_InfoText, null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Hear every detail at any volume all the way to 11, up to 122 dB, down to 40 Hz."
  })), /*#__PURE__*/react_default.a.createElement(Sound_InfoBlock, {
    image: modeImg
  }), /*#__PURE__*/react_default.a.createElement(Sound_InfoText, null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Indoor/outdoor modes with dynamic EQ at every volume. Easy to access, easy to control."
  })), /*#__PURE__*/react_default.a.createElement(Sound_InfoBlock, {
    image: ampImg,
    video: driver_2x
  }), /*#__PURE__*/react_default.a.createElement(Sound_InfoText, null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Move air with two 10\u201D drivers, a silk dome tweeter and pro-grade amp."
  })))));
};

/* harmony default export */ var Overview_Sound = (Sound_Sound);
// EXTERNAL MODULE: ./components/shared/BlueprintPointer/index.js
var BlueprintPointer = __webpack_require__("AGMF");

// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/Build/ImageWrapper.js

var ImageWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ImageWrapper",
  componentId: "keht3-0"
})(["position:relative;width:55%;height:auto;margin-left:auto;svg{&:nth-child(2){top:21.6%;}&:nth-child(3){top:40%;}&:nth-child(4){top:70.5%;}}@media ", "{width:100%;margin-left:30%;svg{&:nth-child(2){width:25%;top:14%;left:21%;transform:rotate(45deg);}&:nth-child(3){top:29%;left:1%;transform:rotate(40deg);}&:nth-child(4){width:15%;top:58.2%;left:7.5%;transform:rotate(-30deg);}}}"], function (props) {
  return props.theme.breakpoints.onlyMobile;
});
/* harmony default export */ var Build_ImageWrapper = (ImageWrapper);
// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/Build/DescriptionWrapper.js

var DescriptionWrapper_DescriptionWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DescriptionWrapper",
  componentId: "sc-1suuolo-0"
})(["position:relative;width:45%;height:100%;p{&:nth-child(1){top:17%;}&:nth-child(2){top:35%;}&:nth-child(3){top:65%;}@media ", "{&:nth-child(2){top:40%;}}}@media ", "{width:100%;p{top:initial !important;&:nth-child(1){width:50%;bottom:100%;right:0;}&:nth-child(2){width:50%;bottom:75%;}&:nth-child(3){width:40%;bottom:12%;}}}"], function (props) {
  return props.theme.breakpoints.onlyTablet;
}, function (props) {
  return props.theme.breakpoints.onlyMobile;
});
/* harmony default export */ var Build_DescriptionWrapper = (DescriptionWrapper_DescriptionWrapper);
// EXTERNAL MODULE: ./components/pages/product/Soundboks2/Overview/Build/images/soundboks_build.jpg
var soundboks_build = __webpack_require__("JaE3");
var soundboks_build_default = /*#__PURE__*/__webpack_require__.n(soundboks_build);

// EXTERNAL MODULE: ./components/pages/product/Soundboks2/Overview/Build/images/soundboks_build-768.jpg?placeholder
var soundboks_build_768placeholder = __webpack_require__("/cY/");
var soundboks_build_768placeholder_default = /*#__PURE__*/__webpack_require__.n(soundboks_build_768placeholder);

// EXTERNAL MODULE: ./components/pages/product/Soundboks2/Overview/Build/images/soundboks_build-1024.jpg
var soundboks_build_1024 = __webpack_require__("cEte");
var soundboks_build_1024_default = /*#__PURE__*/__webpack_require__.n(soundboks_build_1024);

// EXTERNAL MODULE: ./components/pages/product/Soundboks2/Overview/Build/images/soundboks_build-1920.jpg
var soundboks_build_1920 = __webpack_require__("9ZUu");
var soundboks_build_1920_default = /*#__PURE__*/__webpack_require__.n(soundboks_build_1920);

// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/Build/buildHeroImageSrc.js





var buildDimension = {
  desktopLarge: {
    width: 1920,
    height: 650,
    imgAlign: 'bottom'
  },
  desktop: {
    width: 1024,
    height: 520,
    imgAlign: 'center'
  },
  tablet: {
    width: 768,
    height: 400,
    imgAlign: 'bottom'
  },
  mobile: {
    width: 320,
    height: 320,
    imgAlign: 'bottom'
  }
};
var builds = [{
  src: soundboks_build_1920_default.a.url,
  width: buildDimension.desktopLarge.width,
  height: buildDimension.desktopLarge.height,
  media: styles_theme["a" /* default */].breakpoints.desktopLarge,
  key: '0'
}, {
  src: soundboks_build_1024_default.a.url,
  width: buildDimension.desktop.width,
  height: buildDimension.desktop.height,
  media: styles_theme["a" /* default */].breakpoints.desktop,
  key: '1'
}, {
  src: soundboks_build_768placeholder_default.a.url,
  width: buildDimension.tablet.width,
  height: buildDimension.tablet.height,
  media: styles_theme["a" /* default */].breakpoints.tablet,
  key: '2'
}, {
  src: soundboks_build_default.a.url,
  width: buildDimension.mobile.width,
  height: buildDimension.mobile.height,
  key: '3'
}];
var buildPlaceholder = soundboks_build_default.a.placeholder;

// EXTERNAL MODULE: ./components/pages/product/Soundboks2/Overview/Build/images/soundboks-components.jpg?placeholder
var soundboks_componentsplaceholder = __webpack_require__("MkLq");
var soundboks_componentsplaceholder_default = /*#__PURE__*/__webpack_require__.n(soundboks_componentsplaceholder);

// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/Build/sbComponentsImageSrc.js


var sbComponentsImgs = [{
  src: soundboks_componentsplaceholder_default.a.url,
  media: styles_theme["a" /* default */].breakpoints.desktopLarge,
  key: '1'
}, {
  src: soundboks_componentsplaceholder_default.a.url,
  height: 1060,
  media: styles_theme["a" /* default */].breakpoints.desktop,
  key: '2'
}, {
  src: soundboks_componentsplaceholder_default.a.url,
  height: 600,
  media: styles_theme["a" /* default */].breakpoints.tablet,
  key: '3'
}, {
  src: soundboks_componentsplaceholder_default.a.url,
  height: 520,
  key: '4'
}];
var sbComponentsPlaceholder = soundboks_componentsplaceholder_default.a.placeholder;

// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/Build/index.js
var Build_jsx = react_default.a.createElement;














var Build_Build = function Build() {
  return /*#__PURE__*/react_default.a.createElement("div", {
    id: "build"
  }, /*#__PURE__*/react_default.a.createElement("div", null, /*#__PURE__*/react_default.a.createElement(HeroImg["a" /* default */], {
    heros: builds,
    heroDimension: buildDimension,
    heroPlaceholder: buildPlaceholder,
    heroAlt: "SOUNDBOKS (Gen. 2) Build Image",
    text:
    /*i18n*/
    {
      id: "Build"
    }
  }), /*#__PURE__*/react_default.a.createElement(shared_Headline, {
    widths: [288, 638, 640, 940]
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "BREAK OUT. BREAK FREE. NEVER BREAK DOWN."
  }))), /*#__PURE__*/react_default.a.createElement(BlueprintContainer, null, /*#__PURE__*/react_default.a.createElement(Build_ImageWrapper, null, /*#__PURE__*/react_default.a.createElement(Picture["a" /* default */], {
    images: sbComponentsImgs,
    placeholder: sbComponentsPlaceholder,
    alt: "Soundboks"
  }), /*#__PURE__*/react_default.a.createElement(BlueprintPointer["a" /* default */], {
    width: 45
  }), /*#__PURE__*/react_default.a.createElement(BlueprintPointer["a" /* default */], {
    width: 8
  }), /*#__PURE__*/react_default.a.createElement(BlueprintPointer["a" /* default */], {
    width: 21
  })), /*#__PURE__*/react_default.a.createElement(DescriptionContainer, null, /*#__PURE__*/react_default.a.createElement(Build_DescriptionWrapper, null, /*#__PURE__*/react_default.a.createElement(PointDescription, null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Constructed for destruction with solid birch cabinet and aluminum frame."
  })), /*#__PURE__*/react_default.a.createElement(PointDescription, null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Reinforced, slotted plastic port keeps the BATTERYBOKS secure and accessible."
  })), /*#__PURE__*/react_default.a.createElement(PointDescription, null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Made to move at 33 lbs. With handles that can handle anything."
  }))))));
};

var DescriptionContainer = Object(styled_components_browser_esm["default"])(Row["a" /* default */]).withConfig({
  displayName: "Build__DescriptionContainer",
  componentId: "iktpuv-0"
})(["position:absolute;height:100%;top:0;left:0;right:0;"]);
var BlueprintContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Build__BlueprintContainer",
  componentId: "iktpuv-1"
})(["position:relative;@media ", "{margin-top:100px;}"], function (props) {
  return props.theme.breakpoints.onlyMobile;
});
var PointDescription = Object(styled_components_browser_esm["default"])(Text["b" /* DescriptionText */]).withConfig({
  displayName: "Build__PointDescription",
  componentId: "iktpuv-2"
})(["position:absolute;margin:0;padding-right:0.5em;"]);
/* harmony default export */ var Overview_Build = (Build_Build);
// EXTERNAL MODULE: ./components/shared/Composition/index.js + 27 modules
var shared_Composition = __webpack_require__("FpTs");

// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/Hero/configuration/imageSources.js
var imageSources = {};
imageSources.heroMobile = __webpack_require__("OZZO");
imageSources.heroTablet = __webpack_require__("KlDg");
imageSources.heroDesktop = __webpack_require__("avul");
imageSources.heroDesktopLarge = __webpack_require__("tvl1");
/* harmony default export */ var configuration_imageSources = (imageSources);
// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/Hero/index.js
var Hero_jsx = react_default.a.createElement;








var Hero_Hero = function Hero(_ref) {
  var productHandle = _ref.productHandle;
  return /*#__PURE__*/react_default.a.createElement(Container, null, /*#__PURE__*/react_default.a.createElement(shared_Composition["s" /* default */], {
    content: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(shared_Composition["j" /* LayoutBackground */], {
      content: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(shared_Composition["b" /* BackgroundSolidColor */], {
        colorName: "black4"
      }), /*#__PURE__*/react_default.a.createElement(shared_Composition["g" /* Image */], {
        sourceSet: {
          mobile: configuration_imageSources.heroMobile.url,
          tablet: configuration_imageSources.heroTablet.url,
          desktop: configuration_imageSources.heroDesktop.url,
          desktopLarge: configuration_imageSources.heroDesktopLarge.url,
          placeholder: configuration_imageSources.heroTablet.placeholder
        },
        objectFit: "cover",
        objectPosition: "center center"
      }))
    }), /*#__PURE__*/react_default.a.createElement(shared_Composition["h" /* LayoutAlignCenterStart */], {
      content: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(shared_Composition["o" /* TextHeadingLarge */], {
        colorName: "white"
      }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "THROW REAL PARTIES.<0/>ANYWHERE.",
        components: [/*#__PURE__*/react_default.a.createElement("br", null)]
      })), /*#__PURE__*/react_default.a.createElement(ButtonGroup, null, /*#__PURE__*/react_default.a.createElement(Link["a" /* default */], {
        as: "/products/".concat(productHandle),
        href: "/products/product?productHandle=".concat(productHandle),
        passHref: true
      }, /*#__PURE__*/react_default.a.createElement(shared_Composition["e" /* ButtonPrimaryShop */], {
        id: "hero-new_soundboks-button-buy",
        as: "button"
      }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "BUY"
      })))))
    }))
  }));
};

var Container = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Hero__Container",
  componentId: "sc-1ablzqb-0"
})(["display:flex;height:calc(86vh - ", "px);@media ", "{height:calc(100vh - ", "px);}@media ", "{height:calc(100vh - ", "px);}@media ", "{height:calc(100vh - ", "px);}"], styles_theme["a" /* default */].headerHeight.mobile * 2, styles_theme["a" /* default */].breakpoints.tablet, styles_theme["a" /* default */].headerHeight.tablet * 2, styles_theme["a" /* default */].breakpoints.desktop, styles_theme["a" /* default */].headerHeight.desktop * 2, styles_theme["a" /* default */].breakpoints.desktopLarge, styles_theme["a" /* default */].headerHeight.desktopLarge * 2);
var ButtonGroup = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Hero__ButtonGroup",
  componentId: "sc-1ablzqb-1"
})(["display:flex;width:fit-content;flex-direction:column;align-items:center;"]);
/* harmony default export */ var Overview_Hero = (Hero_Hero);
// EXTERNAL MODULE: ./components/atoms/Text/DescriptionText/index.js
var DescriptionText = __webpack_require__("PIqi");

// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/Battery/BatteryImage.js
var BatteryImage_jsx = react_default.a.createElement;




var batteryImg = __webpack_require__("8zpj");

var BatteryImage_BatteryImage = function BatteryImage() {
  return /*#__PURE__*/react_default.a.createElement(Picture["a" /* default */], {
    images: [{
      src: batteryImg.url,
      media: styles_theme["a" /* default */].breakpoints.desktopLarge,
      height: 1100,
      key: '1'
    }, {
      src: batteryImg.url,
      height: 620,
      key: '2'
    }],
    placeholder: batteryImg.placeholder,
    alt: "Soundboks battery"
  });
};

/* harmony default export */ var Battery_BatteryImage = (BatteryImage_BatteryImage);
// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/Battery/MobileView.js
var MobileView_jsx = react_default.a.createElement;






var MobileView_PointDescription = Object(styled_components_browser_esm["default"])(DescriptionText["a" /* default */]).withConfig({
  displayName: "MobileView__PointDescription",
  componentId: "e97ufd-0"
})(["position:absolute;margin:0;padding-right:0.5em;"]);
var BlueprintWrapperMobile = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MobileView__BlueprintWrapperMobile",
  componentId: "e97ufd-1"
})(["display:none;@media ", "{display:flex;}"], function (props) {
  return props.theme.breakpoints.onlyMobile;
});
var DescriptionWrapperMobile = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MobileView__DescriptionWrapperMobile",
  componentId: "e97ufd-2"
})(["position:relative;width:100%;padding-right:20px;padding-left:5%;p{&:nth-of-type(1){top:15%;}&:nth-of-type(2){top:42%;}&:nth-of-type(3){top:78%;}}"]);
var BatteryImageMobileWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MobileView__BatteryImageMobileWrapper",
  componentId: "e97ufd-3"
})(["position:relative;width:100%;margin-left:-22%;> div{transform:rotate(180deg);height:500px;img{width:auto;}}svg{width:14%;left:92%;transform:rotate(180deg);&:nth-of-type(1){top:18%;}&:nth-of-type(2){top:45%;}&:nth-of-type(3){top:80%;}}"]);

var MobileView_MobileView = function MobileView() {
  return /*#__PURE__*/react_default.a.createElement(BlueprintWrapperMobile, null, /*#__PURE__*/react_default.a.createElement(BatteryImageMobileWrapper, null, /*#__PURE__*/react_default.a.createElement(Battery_BatteryImage, null), /*#__PURE__*/react_default.a.createElement(BlueprintPointer["a" /* default */], null), /*#__PURE__*/react_default.a.createElement(BlueprintPointer["a" /* default */], null), /*#__PURE__*/react_default.a.createElement(BlueprintPointer["a" /* default */], null)), /*#__PURE__*/react_default.a.createElement(DescriptionWrapperMobile, null, /*#__PURE__*/react_default.a.createElement(MobileView_PointDescription, null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Super efficient, self-maintaining Lithium Iron Phosphate cells."
  })), /*#__PURE__*/react_default.a.createElement(MobileView_PointDescription, null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "A full charge lasts 40 hours at mid-volume, and up to 8 hours at 11. Recharge in just 3.5 hours."
  })), /*#__PURE__*/react_default.a.createElement(MobileView_PointDescription, null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Swap in a snap to keep the music going forever. But you\u2019ll need two batteries for that."
  }))));
};

/* harmony default export */ var Battery_MobileView = (MobileView_MobileView);
// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/Battery/TabletView.js
var TabletView_jsx = react_default.a.createElement;







var TabletView_PointDescription = Object(styled_components_browser_esm["default"])(DescriptionText["a" /* default */]).withConfig({
  displayName: "TabletView__PointDescription",
  componentId: "iw2h1j-0"
})(["position:absolute;margin:0;padding-right:0.5em;"]);
var TabletDescriptionsLeft = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TabletView__TabletDescriptionsLeft",
  componentId: "iw2h1j-1"
})(["position:relative;padding-right:25%;p{padding-right:20%;:nth-of-type(1){top:20%;}:nth-of-type(2){top:75%;}}"]);
var TabletDescriptionsRight = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TabletView__TabletDescriptionsRight",
  componentId: "iw2h1j-2"
})(["position:relative;p{padding-left:25%;top:43%;}"]);
var BlueprintWrapperTablet = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TabletView__BlueprintWrapperTablet",
  componentId: "iw2h1j-3"
})(["display:grid;grid-template-columns:1fr 1fr 1fr;grid-column-gap:15px;@media ", "{display:none;}"], function (props) {
  return props.theme.breakpoints.onlyMobile;
});
var BatteryImageWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TabletView__BatteryImageWrapper",
  componentId: "iw2h1j-4"
})(["position:relative;svg{width:30%;left:-20%;&:nth-of-type(1){top:25%;}&:nth-of-type(2){top:52%;left:90%;transform:rotate(180deg);}&:nth-of-type(3){top:80.8%;}}"]);

var TabletView_TabletView = function TabletView() {
  return /*#__PURE__*/react_default.a.createElement(Row["a" /* default */], null, /*#__PURE__*/react_default.a.createElement(BlueprintWrapperTablet, null, /*#__PURE__*/react_default.a.createElement(TabletDescriptionsLeft, null, /*#__PURE__*/react_default.a.createElement(TabletView_PointDescription, null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Super efficient, self-maintaining Lithium Iron Phosphate cells."
  })), /*#__PURE__*/react_default.a.createElement(TabletView_PointDescription, null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "A full charge lasts 40 hours at mid-volume, and up to 8 hours at 11. Recharge in just 3.5 hours."
  }))), /*#__PURE__*/react_default.a.createElement(BatteryImageWrapper, null, /*#__PURE__*/react_default.a.createElement(BlueprintPointer["a" /* default */], null), /*#__PURE__*/react_default.a.createElement(BlueprintPointer["a" /* default */], null), /*#__PURE__*/react_default.a.createElement(BlueprintPointer["a" /* default */], null), /*#__PURE__*/react_default.a.createElement(Battery_BatteryImage, null)), /*#__PURE__*/react_default.a.createElement(TabletDescriptionsRight, null, /*#__PURE__*/react_default.a.createElement(TabletView_PointDescription, null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Swap in a snap to keep the music going forever. But you\u2019ll need two batteries for that."
  })))));
};

/* harmony default export */ var Battery_TabletView = (TabletView_TabletView);
// EXTERNAL MODULE: ./components/pages/product/Soundboks2/Overview/Battery/images/soundboks_battery.jpg
var soundboks_battery = __webpack_require__("BVkU");
var soundboks_battery_default = /*#__PURE__*/__webpack_require__.n(soundboks_battery);

// EXTERNAL MODULE: ./components/pages/product/Soundboks2/Overview/Battery/images/soundboks_battery-768.jpg?placeholder
var soundboks_battery_768placeholder = __webpack_require__("XLOO");
var soundboks_battery_768placeholder_default = /*#__PURE__*/__webpack_require__.n(soundboks_battery_768placeholder);

// EXTERNAL MODULE: ./components/pages/product/Soundboks2/Overview/Battery/images/soundboks_battery-1024.jpg
var soundboks_battery_1024 = __webpack_require__("f6Fs");
var soundboks_battery_1024_default = /*#__PURE__*/__webpack_require__.n(soundboks_battery_1024);

// EXTERNAL MODULE: ./components/pages/product/Soundboks2/Overview/Battery/images/soundboks_battery-1920.jpg
var soundboks_battery_1920 = __webpack_require__("YtPQ");
var soundboks_battery_1920_default = /*#__PURE__*/__webpack_require__.n(soundboks_battery_1920);

// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/Battery/batteryHeroImageSrc.js





var batteryDimension = {
  desktopLarge: {
    width: 1920,
    height: 650,
    imgAlign: 'bottom'
  },
  desktop: {
    width: 1024,
    height: 520,
    imgAlign: 'center'
  },
  tablet: {
    width: 768,
    height: 400,
    imgAlign: 'bottom'
  },
  mobile: {
    width: 320,
    height: 320,
    imgAlign: 'bottom'
  }
};
var batteries = [{
  src: soundboks_battery_1920_default.a.url,
  width: batteryDimension.desktopLarge.width,
  height: batteryDimension.desktopLarge.height,
  media: styles_theme["a" /* default */].breakpoints.desktopLarge,
  key: '0'
}, {
  src: soundboks_battery_1024_default.a.url,
  width: batteryDimension.desktop.width,
  height: batteryDimension.desktop.height,
  media: styles_theme["a" /* default */].breakpoints.desktop,
  key: '1'
}, {
  src: soundboks_battery_768placeholder_default.a.url,
  width: batteryDimension.tablet.width,
  height: batteryDimension.tablet.height,
  media: styles_theme["a" /* default */].breakpoints.tablet,
  key: '2'
}, {
  src: soundboks_battery_default.a.url,
  width: batteryDimension.mobile.width,
  height: batteryDimension.mobile.height,
  key: '3'
}];
var batteryPlaceholder = soundboks_battery_default.a.placeholder;

// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/Battery/index.js
var Battery_jsx = react_default.a.createElement;


/* eslint-disable  react/jsx-indent */








var BlueprintWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Battery__BlueprintWrapper",
  componentId: "deuk66-0"
})(["", ";", ";"], Object(paramToResolutions["a" /* default */])('margin-bottom', [70, 100, 100, 150]), Object(paramToResolutions["a" /* default */])('margin-top', [50, 84, 52, 94]));

var Battery_Battery = function Battery() {
  return /*#__PURE__*/react_default.a.createElement("div", {
    id: "battery"
  }, /*#__PURE__*/react_default.a.createElement(HeroImg["a" /* default */], {
    heros: batteries,
    heroDimension: batteryDimension,
    heroPlaceholder: batteryPlaceholder,
    heroAlt: "SOUNDBOKS (Gen. 2) Hero Image",
    text:
    /*i18n*/
    {
      id: "Battery"
    }
  }), /*#__PURE__*/react_default.a.createElement(shared_Headline, {
    widths: [288, 600, 620, 800]
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "THE BATTERY LIFE OF THE PARTY."
  })), /*#__PURE__*/react_default.a.createElement(BlueprintWrapper, null, /*#__PURE__*/react_default.a.createElement(Battery_MobileView, null), /*#__PURE__*/react_default.a.createElement(Battery_TabletView, null)));
};

/* harmony default export */ var Overview_Battery = (Battery_Battery);
// CONCATENATED MODULE: ./utils/string/index.js
function toTitleCase(str) {
  return str.toLowerCase().split(' ').map(function (word) {
    return word.replace(word[0], word[0].toUpperCase());
  }).join(' ');
}
function toTitleCaseNoSpace(str) {
  return toTitleCase(str).replace(/[^\w]/gi, '').replace(/[_-]/gi, '');
}
// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/TechSpecs/ImageWrapper.js

var ImageWrapper_ImageWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ImageWrapper",
  componentId: "a1qmlz-0"
})(["position:absolute;height:120%;width:100%;@media ", "{height:100%;}@media ", "{height:85%;bottom:0;}img{height:100%;width:auto;}"], function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.breakpoints.desktop;
});
/* harmony default export */ var TechSpecs_ImageWrapper = (ImageWrapper_ImageWrapper);
// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/TechSpecs/Wrappers.js



var Wrappers_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Wrappers__Wrapper",
  componentId: "sc-1ctoq43-0"
})(["position:relative;", ";background-color:", ";overflow:hidden;"], Object(paramToResolutions["a" /* default */])('height', [400, 500, 500, 800]), function (props) {
  return props.theme.colors.grey3;
});
var Wrappers_ContentRow = Object(styled_components_browser_esm["default"])(Row["a" /* default */]).withConfig({
  displayName: "Wrappers__ContentRow",
  componentId: "sc-1ctoq43-1"
})(["height:100%;display:flex;flex-direction:column;justify-content:center;position:relative;h1{text-align:center;}"]);

// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/TechSpecs/LinkButton.js
var LinkButton_jsx = react_default.a.createElement;






var LinkButton_LinkButton = function LinkButton(_ref) {
  var as = _ref.as,
      href = _ref.href,
      id = _ref.id;
  return /*#__PURE__*/react_default.a.createElement(Link["a" /* default */], {
    as: as,
    href: href,
    passHref: true
  }, /*#__PURE__*/react_default.a.createElement(StyledLinkButton, {
    fixedWidth: true,
    id: id,
    flexButton: true
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Tech Specs"
  })));
};

var StyledLinkButton = Object(styled_components_browser_esm["default"])(atoms_Button["e" /* StandardButton */]).withConfig({
  displayName: "LinkButton__StyledLinkButton",
  componentId: "qrlk23-0"
})(["margin-left:auto;margin-right:auto;background-color:", ";@media ", "{width:fit-content;}"], function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.breakpoints.desktop;
});
/* harmony default export */ var TechSpecs_LinkButton = (LinkButton_LinkButton);
// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/TechSpecs/index.js
var TechSpecs_jsx = react_default.a.createElement;










var specsImg = __webpack_require__("hqBC");

var TechSpecs_TechSpecs = function TechSpecs(_ref) {
  var productHandle = _ref.productHandle;
  return /*#__PURE__*/react_default.a.createElement(Wrappers_Wrapper, {
    id: "techspecs"
  }, /*#__PURE__*/react_default.a.createElement(TechSpecs_ImageWrapper, null, /*#__PURE__*/react_default.a.createElement(Picture["a" /* default */], {
    images: [{
      src: specsImg.url,
      media: styles_theme["a" /* default */].breakpoints.desktopLarge,
      height: 900,
      key: '1'
    }, {
      src: specsImg.url,
      height: 700,
      key: '2'
    }],
    placeholder: specsImg.placeholder,
    alt: "Hero image"
  })), /*#__PURE__*/react_default.a.createElement(Wrappers_ContentRow, null, /*#__PURE__*/react_default.a.createElement(Text["c" /* H1 */], {
    variation: "big"
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "DO YOU<0/> NEED MORE<1/> TECH<2/>DETAILS?",
    components: [/*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement("br", null)]
  })), /*#__PURE__*/react_default.a.createElement(TechSpecs_LinkButton, {
    as: "/products/".concat(productHandle, "/techspecs"),
    href: "/products/product?productHandle=".concat(productHandle, "&subPage=techspecs"),
    id: "productOverview-techSpecs__button--to".concat(toTitleCaseNoSpace(productHandle), "Specs")
  }, "Shop")));
};

/* harmony default export */ var Overview_TechSpecs = (TechSpecs_TechSpecs);
// EXTERNAL MODULE: ./utils/hooks/useCheckRegion.js
var useCheckRegion = __webpack_require__("h5Ls");

// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/Comparison/CompareTable.js
var CompareTable_jsx = react_default.a.createElement;






var compareBtImg = __webpack_require__("l8P3");

var comparePaImg = __webpack_require__("RaHW");

var compareBoxImg = __webpack_require__("y14P");

var iconCross = __webpack_require__("nxir");

var iconTick = __webpack_require__("723w"); // 11 18 18


var headerFont = Object(styled_components_browser_esm["css"])(["text-align:center;word-break:keep-all;color:", ";", ";@media ", "{font-weight:bold;}@media ", "{font-family:", ";text-transform:uppercase;}"], function (props) {
  return props.theme.colors.white;
}, Object(paramToResolutions["a" /* default */])('font-size', [11, 18]), function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.fonts.main;
}); // 12 16 20

var bodyFont = Object(styled_components_browser_esm["css"])(["font-weight:bold;color:", ";", ";", ";"], function (props) {
  return props.theme.colors.white;
}, Object(paramToResolutions["a" /* default */])('font-size', [12, 16, undefined, 20]), Object(paramToResolutions["a" /* default */])('line-height', [16, 24, undefined, 28])); // 12 18 28

var priceFont = Object(styled_components_browser_esm["css"])(["font-weight:bold;color:", ";", ";", ";@media ", "{text-align:center;}"], function (props) {
  return props.theme.colors.white;
}, Object(paramToResolutions["a" /* default */])('font-size', [12, 18, undefined, 28]), Object(paramToResolutions["a" /* default */])('line-height', [16, 28, undefined, 40]), function (props) {
  return props.theme.breakpoints.onlyMobile;
});
var CompareTable_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CompareTable__Wrapper",
  componentId: "k8c06r-0"
})(["display:grid;grid-template-columns:1fr 1fr 1.2fr 1fr;grid-auto-rows:1fr;position:relative;"]);
var CompareImage = styled_components_browser_esm["default"].img.withConfig({
  displayName: "CompareTable__CompareImage",
  componentId: "k8c06r-1"
})(["height:auto;width:80%;margin:0 auto;@media ", "{width:60%;}"], function (props) {
  return props.theme.breakpoints.tablet;
});
var Cell = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CompareTable__Cell",
  componentId: "k8c06r-2"
})(["position:relative;display:flex;flex-direction:column;justify-content:flex-end;border-bottom:2px solid ", ";"], function (props) {
  return props.theme.colors.grey1;
});
var HeaderCell = Object(styled_components_browser_esm["default"])(Cell).withConfig({
  displayName: "CompareTable__HeaderCell",
  componentId: "k8c06r-3"
})(["padding:10% 2px;", ";@media ", "{padding:10% 10px 15%;}", " span{margin-top:1em;}"], headerFont, function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.highlight && "\n    border: 2px solid ".concat(props.theme.colors.primary, ";\n    border-bottom-width: 0 !important;\n    position: relative;\n    &::after {\n      position: absolute;\n      height: 2px;\n      content: '';\n      background-color: ").concat(props.theme.colors.grey1, ";\n      width: 100%;\n      bottom: 0;\n      left: 0;\n    }\n  ");
});
var BodyCell = Object(styled_components_browser_esm["default"])(Cell).withConfig({
  displayName: "CompareTable__BodyCell",
  componentId: "k8c06r-4"
})(["padding:0.5em 0;justify-content:center;border-top:0;", ";@media ", "{padding:0.5em 0;}", ""], bodyFont, function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.highlight && "\n    padding: 0;\n    border: 2px solid ".concat(props.theme.colors.primary, ";\n    border-top-width: 0;\n    border-bottom-width: 0;\n    &::after {\n      position: absolute;\n      height: 2px;\n      content: '';\n      background-color: ").concat(props.theme.colors.grey1, ";\n      width: 100%;\n      bottom: 0;\n      left: 0;\n    }\n  ");
});
var PriceCell = Object(styled_components_browser_esm["default"])(Cell).withConfig({
  displayName: "CompareTable__PriceCell",
  componentId: "k8c06r-5"
})(["align-items:center;justify-content:center;padding:0.5em 0;", ";", ";@media ", "{br{display:none;}}"], priceFont, function (props) {
  return props.highlight && "\n    border: 2px solid ".concat(props.theme.colors.primary, ";\n    border-top-width: 0;\n  ");
}, function (props) {
  return props.theme.breakpoints.tablet;
});
var TickIcon = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CompareTable__TickIcon",
  componentId: "k8c06r-6"
})(["background-image:url(", ");background-size:contain;height:18.5px;width:18.5px;margin:0 auto;@media ", "{height:40px;width:40px;}"], iconTick.url, function (props) {
  return props.theme.breakpoints.tablet;
});
var CrossIcon = Object(styled_components_browser_esm["default"])(TickIcon).withConfig({
  displayName: "CompareTable__CrossIcon",
  componentId: "k8c06r-7"
})(["background-image:url(", ");"], iconCross.url);

var CompareTable_SpecRow = function SpecRow(_ref) {
  var children = _ref.children,
      values = _ref.values;
  return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(BodyCell, null, children), /*#__PURE__*/react_default.a.createElement(BodyCell, null, values[0] ? /*#__PURE__*/react_default.a.createElement(TickIcon, null) : /*#__PURE__*/react_default.a.createElement(CrossIcon, null)), /*#__PURE__*/react_default.a.createElement(BodyCell, {
    highlight: true
  }, values[1] ? /*#__PURE__*/react_default.a.createElement(TickIcon, null) : /*#__PURE__*/react_default.a.createElement(CrossIcon, null)), /*#__PURE__*/react_default.a.createElement(BodyCell, null, values[2] ? /*#__PURE__*/react_default.a.createElement(TickIcon, null) : /*#__PURE__*/react_default.a.createElement(CrossIcon, null)));
};

var CompareTable_renderPriceRow = function renderPriceRow(region) {
  if (region.isDK) {
    return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(BodyCell, null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
      id: "Cost price?"
    })), /*#__PURE__*/react_default.a.createElement(PriceCell, null, "DKK 500 ", /*#__PURE__*/react_default.a.createElement("br", null), "-", /*#__PURE__*/react_default.a.createElement("br", null), " DKK 10,000"), /*#__PURE__*/react_default.a.createElement(PriceCell, {
      highlight: true
    }, "DKK 6299"), /*#__PURE__*/react_default.a.createElement(PriceCell, null, "DKK 10,000 ", /*#__PURE__*/react_default.a.createElement("br", null), "-", /*#__PURE__*/react_default.a.createElement("br", null), " DKK 50,000"));
  }

  if (region.isNO) {
    return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(BodyCell, null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
      id: "Cost price?"
    })), /*#__PURE__*/react_default.a.createElement(PriceCell, null, "NOK 500 ", /*#__PURE__*/react_default.a.createElement("br", null), "-", /*#__PURE__*/react_default.a.createElement("br", null), " NOK 10,000"), /*#__PURE__*/react_default.a.createElement(PriceCell, {
      highlight: true
    }, "NOK 9399"), /*#__PURE__*/react_default.a.createElement(PriceCell, null, "NOK 10,000 ", /*#__PURE__*/react_default.a.createElement("br", null), "-", /*#__PURE__*/react_default.a.createElement("br", null), " NOK 50,000"));
  }

  if (region.isNA) {
    return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(BodyCell, null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
      id: "Cost price?"
    })), /*#__PURE__*/react_default.a.createElement(PriceCell, null, "$100 ", /*#__PURE__*/react_default.a.createElement("br", null), "to", /*#__PURE__*/react_default.a.createElement("br", null), " $1000"), /*#__PURE__*/react_default.a.createElement(PriceCell, {
      highlight: true
    }, "$899"), /*#__PURE__*/react_default.a.createElement(PriceCell, null, "$1000 ", /*#__PURE__*/react_default.a.createElement("br", null), "to", /*#__PURE__*/react_default.a.createElement("br", null), " $5000"));
  }

  return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(BodyCell, null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Cost price?"
  })), /*#__PURE__*/react_default.a.createElement(PriceCell, null, "\u20AC100 ", /*#__PURE__*/react_default.a.createElement("br", null), "-", /*#__PURE__*/react_default.a.createElement("br", null), " \u20AC1000"), /*#__PURE__*/react_default.a.createElement(PriceCell, {
    highlight: true
  }, "\u20AC849"), /*#__PURE__*/react_default.a.createElement(PriceCell, null, "\u20AC1000 ", /*#__PURE__*/react_default.a.createElement("br", null), "-", /*#__PURE__*/react_default.a.createElement("br", null), " \u20AC5000"));
};

var CompareTable_CompareTable = function CompareTable() {
  var region = Object(useCheckRegion["a" /* default */])();
  return /*#__PURE__*/react_default.a.createElement("div", null, /*#__PURE__*/react_default.a.createElement(CompareTable_Wrapper, null, /*#__PURE__*/react_default.a.createElement(HeaderCell, null), /*#__PURE__*/react_default.a.createElement(HeaderCell, null, /*#__PURE__*/react_default.a.createElement(CompareImage, {
    src: compareBtImg.url
  }), /*#__PURE__*/react_default.a.createElement("span", null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "BT SPEAKERS"
  }))), /*#__PURE__*/react_default.a.createElement(HeaderCell, {
    highlight: true
  }, /*#__PURE__*/react_default.a.createElement(CompareImage, {
    src: compareBoxImg.url
  }), /*#__PURE__*/react_default.a.createElement("span", null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "SOUNDBOKS"
  }))), /*#__PURE__*/react_default.a.createElement(HeaderCell, null, /*#__PURE__*/react_default.a.createElement(CompareImage, {
    src: comparePaImg.url
  }), /*#__PURE__*/react_default.a.createElement("span", null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "PA SYSTEM"
  })))), /*#__PURE__*/react_default.a.createElement(CompareTable_Wrapper, null, /*#__PURE__*/react_default.a.createElement(CompareTable_SpecRow, {
    values: [false, true, true]
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Loud enough for 100+ people?"
  })), /*#__PURE__*/react_default.a.createElement(CompareTable_SpecRow, {
    values: [false, true, false]
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Durable enough for drunk Vikings?"
  })), /*#__PURE__*/react_default.a.createElement(CompareTable_SpecRow, {
    values: [true, true, false]
  }, "Bluetooth?"), /*#__PURE__*/react_default.a.createElement(CompareTable_SpecRow, {
    values: [true, true, false]
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Setup in less than 10 seconds?"
  })), /*#__PURE__*/react_default.a.createElement(CompareTable_SpecRow, {
    values: [false, true, false]
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Modular battery and infinite playtime?"
  })), CompareTable_renderPriceRow(region)));
};

/* harmony default export */ var Comparison_CompareTable = (CompareTable_CompareTable);
// EXTERNAL MODULE: ./components/pages/product/Soundboks2/Overview/Comparison/images/soundboks_slider.jpg
var soundboks_slider = __webpack_require__("LDxQ");
var soundboks_slider_default = /*#__PURE__*/__webpack_require__.n(soundboks_slider);

// EXTERNAL MODULE: ./components/pages/product/Soundboks2/Overview/Comparison/images/soundboks_slider-768.jpg?placeholder
var soundboks_slider_768placeholder = __webpack_require__("12ur");
var soundboks_slider_768placeholder_default = /*#__PURE__*/__webpack_require__.n(soundboks_slider_768placeholder);

// EXTERNAL MODULE: ./components/pages/product/Soundboks2/Overview/Comparison/images/soundboks_slider-1024.jpg
var soundboks_slider_1024 = __webpack_require__("KCNt");
var soundboks_slider_1024_default = /*#__PURE__*/__webpack_require__.n(soundboks_slider_1024);

// EXTERNAL MODULE: ./components/pages/product/Soundboks2/Overview/Comparison/images/soundboks_slider-1920.jpg
var soundboks_slider_1920 = __webpack_require__("EjuJ");
var soundboks_slider_1920_default = /*#__PURE__*/__webpack_require__.n(soundboks_slider_1920);

// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/Comparison/sliderImageSrc.js





var sliderDimension = {
  desktopLarge: {
    width: 1920,
    height: 650,
    imgAlign: 'bottom'
  },
  desktop: {
    width: 1024,
    height: 520,
    imgAlign: 'center'
  },
  tablet: {
    width: 768,
    height: 400,
    imgAlign: 'bottom'
  },
  mobile: {
    width: 320,
    height: 320,
    imgAlign: 'bottom'
  }
};
var sliders = [{
  src: soundboks_slider_1920_default.a.url,
  width: sliderDimension.desktopLarge.width,
  height: sliderDimension.desktopLarge.height,
  media: styles_theme["a" /* default */].breakpoints.desktopLarge,
  key: '0'
}, {
  src: soundboks_slider_1024_default.a.url,
  width: sliderDimension.desktop.width,
  height: sliderDimension.desktop.height,
  media: styles_theme["a" /* default */].breakpoints.desktop,
  key: '1'
}, {
  src: soundboks_slider_768placeholder_default.a.url,
  width: sliderDimension.tablet.width,
  height: sliderDimension.tablet.height,
  media: styles_theme["a" /* default */].breakpoints.tablet,
  key: '2'
}, {
  src: soundboks_slider_default.a.url,
  width: sliderDimension.mobile.width,
  height: sliderDimension.mobile.height,
  key: '3'
}];
var sliderPlaceholder = soundboks_slider_default.a.placeholder;

// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/Comparison/index.js
var Comparison_jsx = react_default.a.createElement;








var ContentWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Comparison__ContentWrapper",
  componentId: "sc-1k4bmw0-0"
})(["position:relative;background-color:", ";> div{", " ", "}"], function (props) {
  return props.theme.colors.black;
}, Object(paramToResolutions["a" /* default */])('padding-top', [undefined, 30, 50, 150]), Object(paramToResolutions["a" /* default */])('padding-bottom', [30, 30, 50, 150]));
var Comparison_BackgroundText = Object(styled_components_browser_esm["default"])(Text["c" /* H1 */]).withConfig({
  displayName: "Comparison__BackgroundText",
  componentId: "sc-1k4bmw0-1"
})(["margin:0;color:", ";@media ", "{font-size:", "px;padding-left:", "px;padding-top:", "px;}@media ", "{position:absolute;top:0.4em;left:-1%;}"], function (props) {
  return props.theme.colors.grey1;
}, function (props) {
  return props.theme.breakpoints.onlyMobile;
}, function (props) {
  return props.theme.halfBaseline * 7;
}, function (props) {
  return props.theme.baseline * 2;
}, function (props) {
  return props.theme.baseline * 2;
}, function (props) {
  return props.theme.breakpoints.tablet;
});

var Comparison_Comparison = function Comparison() {
  return /*#__PURE__*/react_default.a.createElement("div", {
    id: "compare"
  }, /*#__PURE__*/react_default.a.createElement(HeroImg["a" /* default */], {
    heros: sliders,
    heroDimension: sliderDimension,
    heroPlaceholder: sliderPlaceholder,
    heroAlt: "SOUNDBOKS (Gen. 2) Slider Image",
    noTape: true
  }), /*#__PURE__*/react_default.a.createElement(ContentWrapper, null, /*#__PURE__*/react_default.a.createElement(Comparison_BackgroundText, {
    variation: "big"
  }, "A NEW", /*#__PURE__*/react_default.a.createElement("br", null), "KIND OF", /*#__PURE__*/react_default.a.createElement("br", null), "SPEAKER."), /*#__PURE__*/react_default.a.createElement(Row["a" /* default */], null, /*#__PURE__*/react_default.a.createElement(Comparison_CompareTable, null))));
};

/* harmony default export */ var Overview_Comparison = (Comparison_Comparison);
// EXTERNAL MODULE: ./components/shared/ReviewComponents/index.js + 5 modules
var ReviewComponents = __webpack_require__("wjrY");

// EXTERNAL MODULE: ./components/pages/product/Soundboks2/Overview/Reviews/UserReviews.js + 1 modules
var Reviews_UserReviews = __webpack_require__("v04A");

// EXTERNAL MODULE: ./components/atoms/Button/StandardButton/index.js
var StandardButton = __webpack_require__("i1kc");

// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/Reviews/LinkButton.js
var Reviews_LinkButton_jsx = react_default.a.createElement;





var LinkButton_StyledLinkButton = Object(styled_components_browser_esm["default"])(StandardButton["a" /* default */]).withConfig({
  displayName: "LinkButton__StyledLinkButton",
  componentId: "bjb3x3-0"
})(["display:block;margin:50px auto 0 auto;background-color:", ";@media ", "{width:fit-content;}"], function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.breakpoints.desktop;
});

var Reviews_LinkButton_LinkButton = function LinkButton(_ref) {
  var as = _ref.as,
      href = _ref.href,
      id = _ref.id;
  return /*#__PURE__*/react_default.a.createElement(Link["a" /* default */], {
    as: as,
    href: href,
    passHref: true
  }, /*#__PURE__*/react_default.a.createElement(LinkButton_StyledLinkButton, {
    fixedWidth: true,
    id: id
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "See all reviews"
  })));
};

/* harmony default export */ var Reviews_LinkButton = (Reviews_LinkButton_LinkButton);
// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/Reviews/index.js
var Reviews_jsx = react_default.a.createElement;








var Reviews_Wrapper = Object(styled_components_browser_esm["default"])(Row["a" /* default */]).withConfig({
  displayName: "Reviews__Wrapper",
  componentId: "sc-1s2bks3-0"
})(["", ";", ";> div:first-child{", ";}"], Object(paramToResolutions["a" /* default */])('padding-top', [65, 100, undefined, 150]), Object(paramToResolutions["a" /* default */])('padding-bottom', [40, 100, undefined, 120]), Object(paramToResolutions["a" /* default */])('margin-bottom', ['50px', undefined, undefined, '110px']));
var StyledPlatformRatings = Object(styled_components_browser_esm["default"])(ReviewComponents["b" /* PlatformRatings */]).withConfig({
  displayName: "Reviews__StyledPlatformRatings",
  componentId: "sc-1s2bks3-1"
})(["display:flex;@media ", "{display:none;}"], function (props) {
  return props.theme.breakpoints.tablet;
});

var Reviews_Reviews = function Reviews(_ref) {
  var productHandle = _ref.productHandle;
  return /*#__PURE__*/react_default.a.createElement(Reviews_Wrapper, null, /*#__PURE__*/react_default.a.createElement(StyledPlatformRatings, null), /*#__PURE__*/react_default.a.createElement(Reviews_UserReviews["a" /* default */], {
    productHandle: productHandle
  }), /*#__PURE__*/react_default.a.createElement(Reviews_LinkButton, {
    id: "productOverview-reviews__button--".concat(toTitleCaseNoSpace(productHandle)),
    as: "/products/".concat(productHandle, "/reviews"),
    href: "/products/product?productHandle=".concat(productHandle, "&subPage=reviews")
  }));
};

/* harmony default export */ var Overview_Reviews = (Reviews_Reviews);
// EXTERNAL MODULE: ./components/shared/OmitSearchIndex/index.js
var OmitSearchIndex = __webpack_require__("1slv");

// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/Buy/index.js
var Buy_jsx = react_default.a.createElement;













var soundboksImg = __webpack_require__("R+0+");

var Buy_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Buy__Wrapper",
  componentId: "sc-13w30gu-0"
})(["position:relative;background-color:", ";"], function (props) {
  return props.theme.colors.primary;
});
var Buy_ContentWrapper = Object(styled_components_browser_esm["default"])(Row["a" /* default */]).withConfig({
  displayName: "Buy__ContentWrapper",
  componentId: "sc-13w30gu-1"
})(["", ";", ";position:relative;height:100%;display:flex;flex-direction:column;justify-content:flex-start;align-items:center;@media ", "{flex-direction:row;justify-content:center;> div{width:50%;}}"], Object(paramToResolutions["a" /* default */])('padding-top', [150, 50, 60, 160]), Object(paramToResolutions["a" /* default */])('padding-bottom', [50, 50, 60, 160]), function (props) {
  return props.theme.breakpoints.tablet;
});
var StyledShopButton = Object(styled_components_browser_esm["default"])(atoms_Button["e" /* StandardButton */]).withConfig({
  displayName: "Buy__StyledShopButton",
  componentId: "sc-13w30gu-2"
})(["margin:0 auto;display:flex;justify-content:center;background-color:", ";@media ", "{width:fit-content;}"], function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.breakpoints.desktop;
});

var Buy_BuyButton = function BuyButton(_ref) {
  var as = _ref.as,
      href = _ref.href,
      id = _ref.id;
  return /*#__PURE__*/react_default.a.createElement(Link["a" /* default */], {
    as: as,
    href: href,
    passHref: true
  }, /*#__PURE__*/react_default.a.createElement(StyledShopButton, {
    fixedWidth: true,
    id: id
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "BUY"
  })));
};

var Buy_ImageWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Buy__ImageWrapper",
  componentId: "sc-13w30gu-3"
})(["", ";> div{height:auto;}"], Object(paramToResolutions["a" /* default */])('width', ['100%', 350, 380, 530]));
var BackgroundTextWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Buy__BackgroundTextWrapper",
  componentId: "sc-13w30gu-4"
})(["position:absolute;top:10px;height:100%;h1{position:relative;width:1000%;color:", ";&:nth-child(odd){right:3em;}@media ", "{font-size:30px;margin:0 0 0.2em;}}@media ", "{top:0;display:flex;flex-wrap:nowrap;flex-direction:column;justify-content:center;h1{&:nth-child(n + 5){display:none;}}}"], function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.breakpoints.onlyMobile;
}, function (props) {
  return props.theme.breakpoints.tablet;
});

var Buy_BackgroundText = function BackgroundText() {
  return /*#__PURE__*/react_default.a.createElement(BackgroundTextWrapper, null, /*#__PURE__*/react_default.a.createElement(OmitSearchIndex["a" /* default */], null,
  /* eslint-disable react/no-array-index-key */
  Array.from({
    length: 8
  }).map(function (el, idx) {
    return /*#__PURE__*/react_default.a.createElement(Text["c" /* H1 */], {
      key: idx,
      variation: "big"
    }, ' Soundboks (Gen. 2)'.repeat(10));
  })
  /* eslint-enable react/no-array-index-key */
  ));
};

var Buy_Buy = function Buy(_ref2) {
  var productHandle = _ref2.productHandle;
  return /*#__PURE__*/react_default.a.createElement(Buy_Wrapper, null, /*#__PURE__*/react_default.a.createElement(Buy_BackgroundText, null), /*#__PURE__*/react_default.a.createElement(Buy_ContentWrapper, null, /*#__PURE__*/react_default.a.createElement(Buy_ImageWrapper, null, /*#__PURE__*/react_default.a.createElement(Picture["a" /* default */], {
    images: [{
      src: soundboksImg.url,
      media: styles_theme["a" /* default */].breakpoints.desktopLarge,
      key: '1'
    }, {
      src: soundboksImg.url,
      height: 520,
      media: styles_theme["a" /* default */].breakpoints.tablet,
      key: '2'
    }, {
      src: soundboksImg.url,
      height: 400,
      key: '3'
    }],
    placeholder: soundboksImg.placeholder,
    alt: "Soundboks image"
  })), /*#__PURE__*/react_default.a.createElement("div", null, /*#__PURE__*/react_default.a.createElement(Buy_BuyButton, {
    id: "productOverview-buy__button--".concat(toTitleCaseNoSpace(productHandle)),
    as: "/products/".concat(productHandle),
    href: "/products/product?productHandle=".concat(productHandle)
  }))));
};

/* harmony default export */ var Overview_Buy = (Buy_Buy);
// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/Meta.js
var Overview_Meta_jsx = react_default.a.createElement;




var Overview_Meta_Component = function Component(_ref) {
  var productHandle = _ref.productHandle;

  var _useCheckRegion = Object(useCheckRegion["a" /* default */])(),
      isROEU = _useCheckRegion.isROEU;

  var title =
  /*i18n*/
  {
    id: "products.soundboks2.overview.meta.title",
    defaults: "SOUNDBOKS (Gen. 2) Wireless Bluetooth Speaker - Overview | SOUNDBOKS"
  };
  title = isROEU ? "".concat(title.defaults, " EU") : title;
  var pageInfo = {
    title: title,
    desc:
    /*i18n*/
    {
      id: "products.soundboks2.overview.meta.description",
      defaults: "SOUNDBOKS (Gen. 2) is the wireless Bluetooth speaker with incredible sound, extreme durability, and unbelievable battery life."
    },
    url: "/products/".concat(productHandle, "/overview/")
  };
  return /*#__PURE__*/react_default.a.createElement(Meta["a" /* default */], {
    pageInfo: pageInfo
  });
};

/* harmony default export */ var Overview_Meta = (Overview_Meta_Component);
// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/PlatformRatings/index.js
var PlatformRatings_jsx = react_default.a.createElement;






var PlatformRatings_PlatformRatingsSection = function PlatformRatingsSection() {
  return /*#__PURE__*/react_default.a.createElement(PlatformRatings_Wrapper, null, /*#__PURE__*/react_default.a.createElement(ReviewComponents["b" /* PlatformRatings */], null));
};

var PlatformRatings_Wrapper = Object(styled_components_browser_esm["default"])(Row["a" /* default */]).withConfig({
  displayName: "PlatformRatings__Wrapper",
  componentId: "sc-6x23i0-0"
})(["display:none;margin:auto;", ";", ";@media ", "{display:block;}"], Object(paramToResolutions["a" /* default */])('padding-top', [20, 60, 60, 90]), Object(paramToResolutions["a" /* default */])('padding-bottom', [20, 50, 50, 80]), function (props) {
  return props.theme.breakpoints.tablet;
});
/* harmony default export */ var PlatformRatings = (PlatformRatings_PlatformRatingsSection);
// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Overview/index.js
var Overview_jsx = react_default.a.createElement;














var Overview_Overview = function Overview(_ref) {
  var productId = _ref.productId,
      productHandle = _ref.productHandle;
  return /*#__PURE__*/react_default.a.createElement(PageTracker["a" /* default */], null, /*#__PURE__*/react_default.a.createElement("div", null, /*#__PURE__*/react_default.a.createElement(Overview_Meta, {
    productHandle: productHandle
  }), /*#__PURE__*/react_default.a.createElement(Overview_Hero, {
    productHandle: productHandle
  }), /*#__PURE__*/react_default.a.createElement(ProductHeader, {
    activeSubPageId: "overview",
    productId: productId,
    productHandle: productHandle
  }), /*#__PURE__*/react_default.a.createElement(PlatformRatings, null), /*#__PURE__*/react_default.a.createElement(Overview_Sound, null), /*#__PURE__*/react_default.a.createElement(Overview_Build, null), /*#__PURE__*/react_default.a.createElement(Overview_Battery, null), /*#__PURE__*/react_default.a.createElement(Overview_TechSpecs, {
    productHandle: productHandle
  }), /*#__PURE__*/react_default.a.createElement(Overview_Comparison, null), /*#__PURE__*/react_default.a.createElement(Overview_Reviews, {
    productHandle: productHandle
  }), /*#__PURE__*/react_default.a.createElement(Overview_Buy, {
    productHandle: productHandle
  })));
};

/* harmony default export */ var Soundboks2_Overview = (Overview_Overview);
// CONCATENATED MODULE: ./components/shared/Hero/index.js
var shared_Hero_jsx = react_default.a.createElement;








var HERO_HEIGHTS = [[320, 490, 490, 800], [528, 860, 600, 900], [340, 600, 400, 600]];

var Hero_getImageOptions = function getImageOptions(image, height) {
  return [{
    src: image.url,
    media: styles_theme["a" /* default */].breakpoints.desktopLarge,
    key: '1'
  }, {
    src: image.url,
    height: HERO_HEIGHTS[height][2],
    media: styles_theme["a" /* default */].breakpoints.desktop,
    key: '2'
  }, {
    src: image.url,
    height: HERO_HEIGHTS[height][1],
    media: styles_theme["a" /* default */].breakpoints.tablet,
    key: '3'
  }, {
    src: image.url,
    height: HERO_HEIGHTS[height][0],
    key: '4'
  }];
};

var Hero_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Hero__Wrapper",
  componentId: "x7ac3x-0"
})(["position:relative;@media ", "{display:", ";}"], function (props) {
  return props.theme.breakpoints.onlyMobile;
}, function (props) {
  return props.hideMobile ? 'none' : 'block';
});
var TapeWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Hero__TapeWrapper",
  componentId: "x7ac3x-1"
})(["position:relative;", ";"], Object(paramToResolutions["a" /* default */])('top', ['-24px', '-40px', undefined, '-60px']));
var Hero_ImageWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Hero__ImageWrapper",
  componentId: "x7ac3x-2"
})(["position:relative;", ";> div:first-child{position:absolute;z-index:-1;}"], function (props) {
  return Object(paramToResolutions["a" /* default */])('height', HERO_HEIGHTS[props.height]);
});
var StyledTapeHeading = Object(styled_components_browser_esm["default"])(Text["o" /* TapeHeading */]).withConfig({
  displayName: "Hero__StyledTapeHeading",
  componentId: "x7ac3x-3"
})(["margin-bottom:0.5em;width:fit-content;"]);
var TapeSub = styled_components_browser_esm["default"].h3.withConfig({
  displayName: "Hero__TapeSub",
  componentId: "x7ac3x-4"
})(["", ";", ";margin:", "px auto 0;white-space:pre-wrap;text-align:center;@media ", "{margin-top:", "px;}"], Object(paramToResolutions["a" /* default */])('width', ['100%', 500, 720, 940]), highlightMixins["d" /* highlightMixin4 */], function (props) {
  return props.theme.halfBaseline * 5;
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
}, function (props) {
  return props.theme.halfBaseline * 8;
});

var shared_Hero_Hero = function Hero(_ref) {
  var height = _ref.height,
      image = _ref.image,
      tapeTitle = _ref.tapeTitle,
      tapeSub = _ref.tapeSub,
      children = _ref.children,
      tape = _ref.tape,
      hideMobile = _ref.hideMobile;
  return /*#__PURE__*/react_default.a.createElement(Hero_Wrapper, {
    hideMobile: hideMobile
  }, image && /*#__PURE__*/react_default.a.createElement(Hero_ImageWrapper, {
    height: height,
    image: image
  }, /*#__PURE__*/react_default.a.createElement(Picture["a" /* default */], {
    images: Hero_getImageOptions(image, height),
    placeholder: image.placeholder,
    alt: "Hero image",
    fullWidth: true
  }), children), tapeTitle && /*#__PURE__*/react_default.a.createElement(TapeWrapper, null, /*#__PURE__*/react_default.a.createElement(StyledTapeHeading, {
    text: tapeTitle,
    tape: tape,
    center: true
  }), tapeSub && /*#__PURE__*/react_default.a.createElement(TapeSub, null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: tapeSub
  }))));
};

shared_Hero_Hero.defaultProps = {
  image: undefined
};
shared_Hero_Hero.defaultProps = {
  height: 0,
  children: null,
  tapeTitle: null,
  tapeSub: null,
  tape: 0,
  hideMobile: false
};
/* harmony default export */ var shared_Hero = (shared_Hero_Hero);
// EXTERNAL MODULE: ./components/shared/SliderGallery/index.js
var SliderGallery = __webpack_require__("CR6s");

// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Reviews/config/reviewsConfig.js
var avatarTestImg = __webpack_require__("qcE3");

var trustpilotLogo = __webpack_require__("2932");

var facebookLogo = __webpack_require__("XE64");

var outBoundLogo = __webpack_require__("FDS1");

var mashableLogo = __webpack_require__("fGH9");

var gqLogo = __webpack_require__("WLKl");

var engadgetLogo = __webpack_require__("1TYF");

var digitalTrendsLogo = __webpack_require__("PndN");

var chipLogo = __webpack_require__("xQ0t");

var curvedLogo = __webpack_require__("Tu7v");

var computedBildLogo = __webpack_require__("L76f");

var bonedoLogo = __webpack_require__("QevL");

var userReviewsConfig = {
  en: [{
    name: 'Christopher',
    avatar: avatarTestImg,
    platformImage: trustpilotLogo,
    text: 'Very impressed with the Soundboks 2. Saw many reviews on YouTube and sound demos but that doesn’t do justice for what this speaker produces. Holy cow! Awesome job by Soundboks!'
  }, {
    name: 'Inês Marques',
    avatar: avatarTestImg,
    platformImage: facebookLogo,
    text: 'No lies, this is the loudest speaker in the world - simply outstanding performance and unbelievable sound quality'
  }, {
    name: 'Marco Ramirez',
    avatar: avatarTestImg,
    platformImage: trustpilotLogo,
    text: 'Soundboks 2 Best purchase ever I use it on a daily basis playing music while getting ready for work and finally got to see its full potential on an Easter picnic with all my family and friends I received a lot of compliments by people at the park not to mention it drowned all of the music coming from other picnic, they never stood a chance lol greatly guarantee this speaker it’s worth paying more to only buy once and this speaker sure feels like it can stand time.'
  }, {
    name: 'FG',
    avatar: avatarTestImg,
    platformImage: trustpilotLogo,
    text: 'I have never seen such an friedly and opend minded Company. There is always time and space for ideas and Wishes and also a very lovely rellationsip too there Customers. I can ask whatever i want and also get help in any way. Even if you ask dumb questions haha:) Stay as you are guys and #getlouder'
  }, {
    name: 'Jan Siekierski',
    avatar: avatarTestImg,
    platformImage: facebookLogo,
    text: 'This speaker is just unbelievable. It&#39;s exactly what you expect and much more. Seems indestructible, battery can go for days, sound is beautiful and incredibly powerful, while being clear. It really brings people together. I didn’t realize that a speaker can change so much.'
  }],
  de: [{
    name: 'Nils',
    avatar: avatarTestImg,
    platformImage: trustpilotLogo,
    text: 'Bester, robuster, lautester, den Mädels die Klamotten vom Leib reißender Bluetooth Speaker ! Holt ihn oder geht hört weiterhin leise Musik mit schlechten Sound. Klares must have!'
  }, {
    name: 'Jens Hornschuh',
    avatar: avatarTestImg,
    platformImage: facebookLogo,
    text: 'Kaufen, ab an Strand und Paaarty satt! Einfach nur geil Hammerteil!'
  }, {
    name: 'Johannes Lui',
    avatar: avatarTestImg,
    platformImage: facebookLogo,
    text: 'ist jeden Cent wert. Nicht mehr wegzudenken😛 Akku ist der Wahnsinn. Sound ist brutal.'
  }, {
    name: 'Oliver Dokter',
    avatar: avatarTestImg,
    platformImage: trustpilotLogo,
    text: 'Kenne die Soundboks von freunden habe mir nun selbst eine zugelegt, ist einfach die beste musikbox. Bin gespannr auf die Versand zeit direkt über die Soundboks seite'
  }, {
    name: 'Aaron Caffrey',
    avatar: avatarTestImg,
    platformImage: facebookLogo,
    text: 'Der Klang zum Handling zum Gewicht ist ein Geiler Faktor bei der soundboks Ich nehme sie auf mein Moped mit auf die Arbeit und ist einfach der hammer:))'
  }, {
    name: 'Markus',
    avatar: avatarTestImg,
    platformImage: trustpilotLogo,
    text: 'Schneller Versand: ich war beeindruckt wie schnell der Artikel aus den USA bei mir war. Der Service ist hervorragend und das Soundboks Team ständig auf der Suche nach Verbesserung. Ich würde hier immer wieder kaufen und kann es nur weiterempfehlen. An das Soundboks Team: macht weiter so! Einfach klasse!'
  }, {
    name: 'Markus Rink',
    avatar: avatarTestImg,
    platformImage: facebookLogo,
    text: 'Meine Boks ist angekommen und der Sound ist der Hammer. Zudem ist dieses Gerät einfach nur laut ! Der Kundenservice ist zudem einfach nur top. Vielen Dank Soundboks-Team!'
  }]
};
var featuredReviewsConfig = {
  en: [{
    logo: outBoundLogo,
    text: 'Looking for the ultimate portable party speaker? The Soundboks 2 may be it.'
  }, {
    logo: mashableLogo,
    text: 'Party anytime, anywhere with this hardcore portable speaker.'
  }, {
    logo: gqLogo,
    text: 'The Soundboks is insane – and we love it.'
  }, {
    logo: engadgetLogo,
    text: 'This thing is a monster, but in a good way.'
  }, {
    logo: digitalTrendsLogo,
    text: 'Calling the Soundboks a "Bluetooth speaker" is like calling Andre The Giant "a wrestler".'
  }],
  de: [{
    logo: chipLogo,
    text: 'Klassische Bluetooth Lautsprecher können da nicht mithalten'
  }, {
    logo: curvedLogo,
    text: 'Da hat der Hersteller ordentlich nachgebessert'
  }, {
    logo: computedBildLogo,
    text: 'Besonders gut gefällt der fein durchgezeichnete und detailreiche Hochtonbereich, mit dem die Box schön lebendig klingt.'
  }, {
    logo: bonedoLogo,
    text: 'Es gibt bislang einfach keine Alternative. Wer laut und netzunabhängig Musik hören will in der Wallachei, kommt an der Soundboks 2 nicht vorbei.'
  }]
};
// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Reviews/FeaturedReviews.js
var FeaturedReviews_jsx = react_default.a.createElement;










var starsImg = __webpack_require__("T2M4");

var FeaturedReviews_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FeaturedReviews__Wrapper",
  componentId: "sc-1404ry5-0"
})([""]);
var FeaturedReviews_ContentRow = Object(styled_components_browser_esm["default"])(Row["a" /* default */]).withConfig({
  displayName: "FeaturedReviews__ContentRow",
  componentId: "sc-1404ry5-1"
})(["", ";", ";"], Object(paramToResolutions["a" /* default */])('padding-top', [50, 65, 65, 110]), Object(paramToResolutions["a" /* default */])('padding-bottom', [100, 100, 130, 150]));
var TabletHeader = Object(styled_components_browser_esm["default"])(Text["o" /* TapeHeading */]).withConfig({
  displayName: "FeaturedReviews__TabletHeader",
  componentId: "sc-1404ry5-2"
})(["@media ", "{display:none;}", ";"], function (props) {
  return props.theme.breakpoints.onlyMobile;
}, Object(paramToResolutions["a" /* default */])('margin-bottom', [100, undefined, undefined, 150]));
var MobileHero = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FeaturedReviews__MobileHero",
  componentId: "sc-1404ry5-3"
})(["margin-top:", "px;@media ", "{display:none;}"], function (props) {
  return props.theme.baseline * 10;
}, function (props) {
  return props.theme.breakpoints.tablet;
});
var ReviewWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FeaturedReviews__ReviewWrapper",
  componentId: "sc-1404ry5-4"
})(["display:flex;flex-direction:column;padding:0 ", "px;"], function (props) {
  return props.theme.baseline * 4;
});
var ReviewStars = styled_components_browser_esm["default"].img.withConfig({
  displayName: "FeaturedReviews__ReviewStars",
  componentId: "sc-1404ry5-5"
})(["display:block;", ";width:auto;margin:0 auto;"], Object(paramToResolutions["a" /* default */])('height', [17, undefined, undefined, 20]));
var ReviewText = styled_components_browser_esm["default"].p.withConfig({
  displayName: "FeaturedReviews__ReviewText",
  componentId: "sc-1404ry5-6"
})(["", ";", ";font-weight:300;text-align:center;"], Object(paramToResolutions["a" /* default */])('font-size', [20, undefined, undefined, 30]), Object(paramToResolutions["a" /* default */])('line-height', [24, undefined, undefined, 40]));
var ReviewLogo = styled_components_browser_esm["default"].img.withConfig({
  displayName: "FeaturedReviews__ReviewLogo",
  componentId: "sc-1404ry5-7"
})(["display:block;", ";width:auto;margin:0 auto;"], Object(paramToResolutions["a" /* default */])('height', [24, 20, undefined, 30]));

var FeaturedReviews_FeaturedReview = function FeaturedReview(_ref) {
  var children = _ref.children,
      logo = _ref.logo;
  return /*#__PURE__*/react_default.a.createElement(ReviewWrapper, null, /*#__PURE__*/react_default.a.createElement(ReviewStars, {
    src: starsImg.url
  }), /*#__PURE__*/react_default.a.createElement(ReviewText, null, children), /*#__PURE__*/react_default.a.createElement(ReviewLogo, {
    src: logo.url
  }));
};

var FeaturedReviews_FeaturedReviews = function FeaturedReviews() {
  var language = Object(es["d" /* useSelector */])(function (state) {
    return state.settings.langaugeId;
  });
  language = featuredReviewsConfig[language] ? language : 'en';
  return /*#__PURE__*/react_default.a.createElement(FeaturedReviews_Wrapper, null, /*#__PURE__*/react_default.a.createElement(MobileHero, null, /*#__PURE__*/react_default.a.createElement(shared_Hero, {
    tapeTitle:
    /*i18n*/
    {
      id: "Reviews"
    },
    tape: 1
  })), /*#__PURE__*/react_default.a.createElement(FeaturedReviews_ContentRow, null, /*#__PURE__*/react_default.a.createElement(TabletHeader, {
    text:
    /*i18n*/
    {
      id: "Reviews"
    },
    center: true,
    tape: 1
  }), /*#__PURE__*/react_default.a.createElement(SliderGallery["a" /* default */], {
    splits: [1, 2, 3, 3],
    navigation: [true, true, true, true]
  }, featuredReviewsConfig[language].map(function (review) {
    return /*#__PURE__*/react_default.a.createElement(FeaturedReviews_FeaturedReview, {
      key: review.text,
      logo: review.logo
    }, "\"", review.text, "\"");
  }))));
};

/* harmony default export */ var Reviews_FeaturedReviews = (FeaturedReviews_FeaturedReviews);
// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Reviews/UserReviews.js
var UserReviews_jsx = react_default.a.createElement;








var UserReviews_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "UserReviews__Wrapper",
  componentId: "sc-1xyge1a-0"
})(["position:relative;@media ", "{background-color:", ";}"], function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.colors.grey3;
});
var SliderWrapper = Object(styled_components_browser_esm["default"])(Row["a" /* default */]).withConfig({
  displayName: "UserReviews__SliderWrapper",
  componentId: "sc-1xyge1a-1"
})(["position:relative;", ";", ";@media ", "{padding-left:0;padding-right:0;}"], Object(paramToResolutions["a" /* default */])('padding-top', [100, 70, 100, 125]), Object(paramToResolutions["a" /* default */])('padding-bottom', [80, 70, 100, 125]), function (props) {
  return props.theme.breakpoints.onlyMobile;
});
var UserReviews_BackgroundText = styled_components_browser_esm["default"].h1.withConfig({
  displayName: "UserReviews__BackgroundText",
  componentId: "sc-1xyge1a-2"
})(["font-family:", ";color:", ";line-height:1;text-transform:uppercase;", ";", ";margin:0;position:absolute;top:0;left:0;width:500px;@media ", "{width:auto;left:unset;top:unset;right:-40px;bottom:40px;}@media ", "{right:-70px;}@media ", "{right:-170px;}"], function (props) {
  return props.theme.fonts.main;
}, function (props) {
  return props.theme.colors.primary;
}, Object(paramToResolutions["a" /* default */])('font-size', [50, 35, 35, 50]), Object(paramToResolutions["a" /* default */])('line-height', [48, 40, 40, 48]), function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.breakpoints.desktop;
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
});
var StyledReview = Object(styled_components_browser_esm["default"])(ReviewComponents["c" /* Review */]).withConfig({
  displayName: "UserReviews__StyledReview",
  componentId: "sc-1xyge1a-3"
})(["margin-right:", "px;@media ", "{margin-left:", "px;margin-right:", "px;}@media ", "{margin-left:", "px;margin-right:", "px;}"], function (props) {
  return props.theme.baseline * 2;
}, function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.baseline * 1;
}, function (props) {
  return props.theme.baseline * 1;
}, function (props) {
  return props.theme.breakpoints.desktop;
}, function (props) {
  return props.theme.baseline * 2;
}, function (props) {
  return props.theme.baseline * 2;
});

var UserReviews_UserReviews = function UserReviews() {
  var language = Object(es["d" /* useSelector */])(function (state) {
    return state.settings.langaugeId;
  });
  language = userReviewsConfig[language] ? language : 'en';
  return /*#__PURE__*/react_default.a.createElement(UserReviews_Wrapper, null, /*#__PURE__*/react_default.a.createElement(SliderWrapper, null, /*#__PURE__*/react_default.a.createElement(UserReviews_BackgroundText, null, "Get loud", /*#__PURE__*/react_default.a.createElement("br", null), "Get loud", /*#__PURE__*/react_default.a.createElement("br", null), "Get loud"), /*#__PURE__*/react_default.a.createElement(SliderGallery["a" /* default */], {
    offsets: [10, 0, 0, 0]
  }, userReviewsConfig[language].map(function (review) {
    return /*#__PURE__*/react_default.a.createElement(StyledReview, {
      name: review.name // avatar={review.avatar}
      ,
      platformImage: review.platformImage,
      key: review.text
    }, review.text);
  }))));
};

/* harmony default export */ var Soundboks2_Reviews_UserReviews = (UserReviews_UserReviews);
// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Reviews/PlatformReviews.js
var PlatformReviews_jsx = react_default.a.createElement;





var PlatformReviews_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PlatformReviews__Wrapper",
  componentId: "sc-1k49yeu-0"
})(["background-color:", ";"], function (props) {
  return props.theme.colors.black;
});
var PlatformReviews_ContentWrapper = Object(styled_components_browser_esm["default"])(Row["a" /* default */]).withConfig({
  displayName: "PlatformReviews__ContentWrapper",
  componentId: "sc-1k49yeu-1"
})(["", ";", ";"], Object(paramToResolutions["a" /* default */])('padding-top', [50, 70, undefined, 90]), Object(paramToResolutions["a" /* default */])('padding-bottom', [50, 50, undefined, 90]));

var PlatformReviews_PlatformReviews = function PlatformReviews() {
  return /*#__PURE__*/react_default.a.createElement(PlatformReviews_Wrapper, null, /*#__PURE__*/react_default.a.createElement(PlatformReviews_ContentWrapper, null, /*#__PURE__*/react_default.a.createElement(ReviewComponents["b" /* PlatformRatings */], {
    version: "white"
  })));
};

/* harmony default export */ var Reviews_PlatformReviews = (PlatformReviews_PlatformReviews);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("1OyB");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("vuIU");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__("Ji7U");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("md7G");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("foSv");

// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Reviews/ArticlesAndVideos.js





var ArticlesAndVideos_jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }











var ArticlesAndVideos_HeaderPicture = function HeaderPicture(_ref) {
  var imageObj = _ref.imageObj;
  return /*#__PURE__*/react_default.a.createElement(Picture["a" /* default */], {
    images: [{
      src: imageObj.url,
      height: 500,
      media: styles_theme["a" /* default */].breakpoints.desktop,
      key: '1'
    }, {
      src: imageObj.url,
      height: 300,
      key: '2'
    }],
    placeholder: imageObj.placeholder,
    alt: "Article image",
    fullWidth: true
  });
};

var REVIEWS = {
  en: [/*#__PURE__*/react_default.a.createElement(ReviewComponents["a" /* Article */], {
    key: "wirelessSpeaker",
    title: "DON'T Buy A Wireless Speaker Without Watching This...",
    header: /*#__PURE__*/react_default.a.createElement(ReviewComponents["d" /* YoutubeVideo */], {
      id: "Db17w0DjDS0"
    })
  }), /*#__PURE__*/react_default.a.createElement(ReviewComponents["a" /* Article */], {
    key: "review",
    title: "SOUNDBOKS 2 - review & soundcheck",
    header: /*#__PURE__*/react_default.a.createElement(ReviewComponents["d" /* YoutubeVideo */], {
      id: "iklQ4jMNUu4"
    })
  }), /*#__PURE__*/react_default.a.createElement(ReviewComponents["a" /* Article */], {
    key: "black",
    title: "The Soundboks 2 - Back In Black",
    header: /*#__PURE__*/react_default.a.createElement(ReviewComponents["d" /* YoutubeVideo */], {
      id: "aezKP7Pho9I"
    })
  }), /*#__PURE__*/react_default.a.createElement(ReviewComponents["a" /* Article */], {
    key: "portableSpeaker",
    title: "World's Loudest Portable Speaker 2.0 - SOUNDBOK 2.0",
    header: /*#__PURE__*/react_default.a.createElement(ReviewComponents["d" /* YoutubeVideo */], {
      id: "eGrL0yKtrHw"
    })
  })],
  de: [/*#__PURE__*/react_default.a.createElement(ReviewComponents["a" /* Article */], {
    key: "wirelessSpeaker",
    title: "DON'T Buy A Wireless Speaker Without Watching This...",
    header: /*#__PURE__*/react_default.a.createElement(ReviewComponents["d" /* YoutubeVideo */], {
      id: "Db17w0DjDS0"
    })
  }), /*#__PURE__*/react_default.a.createElement(ReviewComponents["a" /* Article */], {
    key: "lautsprecher",
    title: "122dB Bluetooth Lautsprecher f\xFCr Festivals | SoundBoks 2 Unboxing",
    header: /*#__PURE__*/react_default.a.createElement(ReviewComponents["d" /* YoutubeVideo */], {
      id: "gopHN4a7Taw"
    })
  }), /*#__PURE__*/react_default.a.createElement(ReviewComponents["a" /* Article */], {
    key: "lauteste",
    title: "Soundboks 2 im Test: der lauteste (119 db) Bluetooth-Speaker der Welt | deutsch",
    header: /*#__PURE__*/react_default.a.createElement(ReviewComponents["d" /* YoutubeVideo */], {
      id: "NGoNaKRx6fs"
    })
  }), /*#__PURE__*/react_default.a.createElement(ReviewComponents["a" /* Article */], {
    key: "riesen",
    title: "Riesen-Bluetooth-Lautsprecher: Soundboks 2 im Test",
    header: /*#__PURE__*/react_default.a.createElement(ReviewComponents["d" /* YoutubeVideo */], {
      id: "5mG9S-ag6lY"
    })
  })]
};
var ArticlesAndVideos_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ArticlesAndVideos__Wrapper",
  componentId: "sc-18lnrhb-0"
})(["", ";", ";"], Object(paramToResolutions["a" /* default */])('padding-top', [80, 100, undefined, 150]), Object(paramToResolutions["a" /* default */])('padding-bottom', [80, 100, undefined, 150]));
var ArticlesAndVideos_TabletView = Object(styled_components_browser_esm["default"])(Row["a" /* default */]).withConfig({
  displayName: "ArticlesAndVideos__TabletView",
  componentId: "sc-18lnrhb-1"
})(["display:grid;grid-template-columns:1fr 1fr;grid-column-gap:20px;grid-row-gap:20px;"]);

var ArticlesAndVideos_ArticlesAndVideos = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(ArticlesAndVideos, _Component);

  var _super = _createSuper(ArticlesAndVideos);

  /*
  fix for vertical/horizontal modes on tablets
  if you run a vid on a tablet in vertical mode and then turn it so that
  width becomes tablet+, the mobile section will be hidden but the vid
  will still be played and unnecessary youtube containers remain =>
  show containers based only on resolution without using css display property
  */
  function ArticlesAndVideos(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, ArticlesAndVideos);

    _this = _super.call(this, props);
    _this.state = {
      isMobile: false
    };
    return _this;
  }

  Object(createClass["a" /* default */])(ArticlesAndVideos, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.setState({
        isMobile: window.matchMedia(styles_theme["a" /* default */].breakpoints.onlyMobile).matches
      });

      window.onresize = function () {
        var prev = _this2.state.isMobile;
        var next = window.matchMedia(styles_theme["a" /* default */].breakpoints.onlyMobile).matches;

        if (prev !== next) {
          _this2.setState({
            isMobile: next
          });
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var language = this.props.language;
      var isMobile = this.state.isMobile;
      var reviews = language === 'en' ? REVIEWS.en : REVIEWS.de;
      return /*#__PURE__*/react_default.a.createElement(ArticlesAndVideos_Wrapper, null, isMobile ? /*#__PURE__*/react_default.a.createElement(SliderGallery["a" /* default */], null, reviews) : /*#__PURE__*/react_default.a.createElement(ArticlesAndVideos_TabletView, null, reviews));
    }
  }]);

  return ArticlesAndVideos;
}(react["Component"]);

var ArticlesAndVideos_mapStateToProps = function mapStateToProps(state) {
  return {
    language: state.settings.languageId
  };
};

ArticlesAndVideos_ArticlesAndVideos.defaultProps = {
  language: 'en'
};
/* harmony default export */ var Reviews_ArticlesAndVideos = (Object(es["b" /* connect */])(ArticlesAndVideos_mapStateToProps)(ArticlesAndVideos_ArticlesAndVideos));
// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Reviews/Meta.js
var Reviews_Meta_jsx = react_default.a.createElement;




var Reviews_Meta_Component = function Component(_ref) {
  var productHandle = _ref.productHandle;

  var _useCheckRegion = Object(useCheckRegion["a" /* default */])(),
      isROEU = _useCheckRegion.isROEU;

  var title = isROEU ?
  /*i18n*/
  {
    id: "SOUNDBOKS (GEN. 2) Reviews | SOUNDBOKS EU"
  } :
  /*i18n*/
  {
    id: "products.soundboks2.review.meta.title",
    defaults: "Read the Reviews | SOUNDBOKS (GEN. 2) Reviews"
  };
  var pageInfo = {
    title: title,
    desc:
    /*i18n*/
    {
      id: "products.soundboks2.review.meta.description",
      defaults: "SOUNDBOKS (Gen. 2) is the only battery powered Bluetooth speaker with a swappable battery. Read the SOUNDBOKS (Gen. 2) reviews and hear what the experts say."
    },
    url: "/products/".concat(productHandle, "/reviews/")
  };
  return /*#__PURE__*/react_default.a.createElement(Meta["a" /* default */], {
    pageInfo: pageInfo
  });
};

/* harmony default export */ var Reviews_Meta = (Reviews_Meta_Component);
// CONCATENATED MODULE: ./components/pages/product/Soundboks2/Reviews/index.js
var Soundboks2_Reviews_jsx = react_default.a.createElement;










var Soundboks2_Reviews_Reviews = function Reviews(_ref) {
  var productId = _ref.productId,
      productHandle = _ref.productHandle;
  return /*#__PURE__*/react_default.a.createElement(PageTracker["a" /* default */], null, /*#__PURE__*/react_default.a.createElement("div", null, /*#__PURE__*/react_default.a.createElement(Reviews_Meta, {
    productHandle: productHandle
  }), /*#__PURE__*/react_default.a.createElement(ProductHeader, {
    productHandle: productHandle,
    productId: productId,
    activeSubPageId: "reviews"
  }), /*#__PURE__*/react_default.a.createElement(Reviews_FeaturedReviews, null), /*#__PURE__*/react_default.a.createElement(Soundboks2_Reviews_UserReviews, null), /*#__PURE__*/react_default.a.createElement(Reviews_PlatformReviews, null), /*#__PURE__*/react_default.a.createElement(Reviews_ArticlesAndVideos, null), /*#__PURE__*/react_default.a.createElement(Overview_Buy, {
    productHandle: productHandle
  })));
};

/* harmony default export */ var Soundboks2_Reviews = (Soundboks2_Reviews_Reviews);
// CONCATENATED MODULE: ./components/pages/product/Soundboks2/TechSpecs/Meta.js
var TechSpecs_Meta_jsx = react_default.a.createElement;




var TechSpecs_Meta_Component = function Component(_ref) {
  var productHandle = _ref.productHandle;

  var _useCheckRegion = Object(useCheckRegion["a" /* default */])(),
      isROEU = _useCheckRegion.isROEU;

  var title =
  /*i18n*/
  {
    id: "products.soundboks2.techSpecs.meta.title",
    defaults: "SOUNDBOKS (Gen. 2) Tech Specs | SOUNDBOKS"
  };
  title = isROEU ? "".concat(title.defaults, " EU") : title;
  var desc = isROEU ?
  /*i18n*/
  {
    id: "What makes a Bluetooth Performance Speaker? Inside the SOUNDBOKS (Gen. 2)."
  } :
  /*i18n*/
  {
    id: "products.soundboks2.techSpecs.meta.description",
    defaults: "SOUNDBOKS (Gen. 2) is designed and built to be the life of the party. This is what makes a Bluetooth Performance Speaker."
  };
  var pageInfo = {
    title: title,
    desc: desc,
    url: "/products/".concat(productHandle, "/techspecs/")
  };
  return /*#__PURE__*/react_default.a.createElement(Meta["a" /* default */], {
    pageInfo: pageInfo
  });
};

/* harmony default export */ var TechSpecs_Meta = (TechSpecs_Meta_Component);
// CONCATENATED MODULE: ./components/pages/product/Soundboks2/TechSpecs/TechHeader.js
var TechHeader_jsx = react_default.a.createElement;






var TechHeader_soundboksImg = __webpack_require__("OgpL");

var TechHeader_ContentRow = Object(styled_components_browser_esm["default"])(Row["a" /* default */]).withConfig({
  displayName: "TechHeader__ContentRow",
  componentId: "sc-1s5fkdr-0"
})(["padding-top:60px;padding-bottom:60px;@media ", "{position:absolute;}@media ", "{padding-top:110px;padding-bottom:110px;}div:first-child{margin-bottom:8px;}"], function (props) {
  return props.theme.breakpoints.onlyMobile;
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
});
var TechHeader_ImageWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TechHeader__ImageWrapper",
  componentId: "sc-1s5fkdr-1"
})(["max-width:350px;margin:0 auto;@media ", "{display:none;}img{height:auto;width:100%;}"], function (props) {
  return props.theme.breakpoints.tablet;
});

var TechHeader_TechHeader = function TechHeader() {
  return /*#__PURE__*/react_default.a.createElement("div", null, /*#__PURE__*/react_default.a.createElement(TechHeader_ContentRow, null, /*#__PURE__*/react_default.a.createElement(Text["o" /* TapeHeading */], {
    center: true,
    text:
    /*i18n*/
    {
      id: "Tech Specs"
    },
    tape: 1
  })), /*#__PURE__*/react_default.a.createElement(TechHeader_ImageWrapper, null, /*#__PURE__*/react_default.a.createElement(Picture["a" /* default */], {
    images: [{
      src: TechHeader_soundboksImg.url,
      key: '1'
    }],
    placeholder: TechHeader_soundboksImg.placeholder,
    alt: "Soundboks scheme"
  })));
};

/* harmony default export */ var TechSpecs_TechHeader = (TechHeader_TechHeader);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("JX7q");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__("8OQS");
var objectWithoutPropertiesLoose_default = /*#__PURE__*/__webpack_require__.n(objectWithoutPropertiesLoose);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/inheritsLoose.js
var inheritsLoose = __webpack_require__("VbXa");
var inheritsLoose_default = /*#__PURE__*/__webpack_require__.n(inheritsLoose);

// CONCATENATED MODULE: ./node_modules/@tanem/svg-injector/node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

// EXTERNAL MODULE: ./node_modules/content-type/index.js
var content_type = __webpack_require__("tA+R");

// CONCATENATED MODULE: ./node_modules/@tanem/svg-injector/dist/svg-injector.esm.js



var cloneSvg = function cloneSvg(sourceSvg) {
  return sourceSvg.cloneNode(true);
};

var isLocal = function isLocal() {
  return window.location.protocol === 'file:';
};

var svg_injector_esm_makeAjaxRequest = function makeAjaxRequest(url, callback) {
  var httpRequest = new XMLHttpRequest();

  httpRequest.onreadystatechange = function () {
    try {
      if (!/\.svg/i.test(url) && httpRequest.readyState === 2) {
        var contentType = httpRequest.getResponseHeader('Content-Type');

        if (!contentType) {
          throw new Error('Content type not found');
        }

        var type = Object(content_type["parse"])(contentType).type;

        if (!(type === 'image/svg+xml' || type === 'text/plain')) {
          throw new Error("Invalid content type: " + type);
        }
      }

      if (httpRequest.readyState === 4) {
        if (httpRequest.status === 404 || httpRequest.responseXML === null) {
          throw new Error(isLocal() ? 'Note: SVG injection ajax calls do not work locally without ' + 'adjusting security settings in your browser. Or consider ' + 'using a local webserver.' : 'Unable to load SVG file: ' + url);
        }

        if (httpRequest.status === 200 || isLocal() && httpRequest.status === 0) {
          callback(null, httpRequest);
        } else {
          throw new Error('There was a problem injecting the SVG: ' + httpRequest.status + ' ' + httpRequest.statusText);
        }
      }
    } catch (error) {
      httpRequest.abort();
      callback(error, httpRequest);
    }
  };

  httpRequest.open('GET', url);

  if (httpRequest.overrideMimeType) {
    httpRequest.overrideMimeType('text/xml');
  }

  httpRequest.send();
};

var svgCache = new Map();

var requestQueue = {};
var queueRequest = function queueRequest(url, callback) {
  requestQueue[url] = requestQueue[url] || [];
  requestQueue[url].push(callback);
};
var processRequestQueue = function processRequestQueue(url) {
  var _loop_1 = function _loop_1(i, len) {
    setTimeout(function () {
      if (Array.isArray(requestQueue[url])) {
        var cacheValue = svgCache.get(url);
        var callback = requestQueue[url][i];

        if (cacheValue instanceof SVGElement) {
          callback(null, cloneSvg(cacheValue));
        }

        if (cacheValue instanceof Error) {
          callback(cacheValue);
        }

        if (i === requestQueue[url].length - 1) {
          delete requestQueue[url];
        }
      }
    }, 0);
  };

  for (var i = 0, len = requestQueue[url].length; i < len; i++) {
    _loop_1(i);
  }
};

var loadSvgCached = function loadSvgCached(url, callback) {
  if (svgCache.has(url)) {
    var cacheValue = svgCache.get(url);

    if (cacheValue instanceof SVGElement) {
      callback(null, cloneSvg(cacheValue));
      return;
    }

    if (cacheValue instanceof Error) {
      callback(cacheValue);
      return;
    }

    queueRequest(url, callback);
    return;
  }

  svgCache.set(url, undefined);
  queueRequest(url, callback);
  svg_injector_esm_makeAjaxRequest(url, function (error, httpRequest) {
    if (error) {
      svgCache.set(url, error);
    } else if (httpRequest.responseXML instanceof Document && httpRequest.responseXML.documentElement && httpRequest.responseXML.documentElement instanceof SVGElement) {
      svgCache.set(url, httpRequest.responseXML.documentElement);
    }

    processRequestQueue(url);
  });
};

var loadSvgUncached = function loadSvgUncached(url, callback) {
  svg_injector_esm_makeAjaxRequest(url, function (error, httpRequest) {
    if (error) {
      callback(error);
    } else if (httpRequest.responseXML instanceof Document && httpRequest.responseXML.documentElement && httpRequest.responseXML.documentElement instanceof SVGElement) {
      callback(null, httpRequest.responseXML.documentElement);
    }
  });
};

var idCounter = 0;

var uniqueId = function uniqueId() {
  return ++idCounter;
};

var injectedElements = [];
var ranScripts = {};
var svgNamespace = 'http://www.w3.org/2000/svg';
var xlinkNamespace = 'http://www.w3.org/1999/xlink';

var svg_injector_esm_injectElement = function injectElement(el, evalScripts, renumerateIRIElements, cacheRequests, beforeEach, callback) {
  var imgUrl = el.getAttribute('data-src') || el.getAttribute('src');

  if (!imgUrl) {
    callback(new Error('Invalid data-src or src attribute'));
    return;
  }

  if (injectedElements.indexOf(el) !== -1) {
    injectedElements.splice(injectedElements.indexOf(el), 1);
    el = null;
    return;
  }

  injectedElements.push(el);
  el.setAttribute('src', '');
  var loadSvg = cacheRequests ? loadSvgCached : loadSvgUncached;
  loadSvg(imgUrl, function (error, svg) {
    if (!svg) {
      injectedElements.splice(injectedElements.indexOf(el), 1);
      el = null;
      callback(error);
      return;
    }

    var imgId = el.getAttribute('id');

    if (imgId) {
      svg.setAttribute('id', imgId);
    }

    var imgTitle = el.getAttribute('title');

    if (imgTitle) {
      svg.setAttribute('title', imgTitle);
    }

    var imgWidth = el.getAttribute('width');

    if (imgWidth) {
      svg.setAttribute('width', imgWidth);
    }

    var imgHeight = el.getAttribute('height');

    if (imgHeight) {
      svg.setAttribute('height', imgHeight);
    }

    var mergedClasses = Array.from(new Set(__spreadArrays((svg.getAttribute('class') || '').split(' '), ['injected-svg'], (el.getAttribute('class') || '').split(' ')))).join(' ').trim();
    svg.setAttribute('class', mergedClasses);
    var imgStyle = el.getAttribute('style');

    if (imgStyle) {
      svg.setAttribute('style', imgStyle);
    }

    svg.setAttribute('data-src', imgUrl);
    var imgData = [].filter.call(el.attributes, function (at) {
      return /^data-\w[\w-]*$/.test(at.name);
    });
    Array.prototype.forEach.call(imgData, function (dataAttr) {
      if (dataAttr.name && dataAttr.value) {
        svg.setAttribute(dataAttr.name, dataAttr.value);
      }
    });

    if (renumerateIRIElements) {
      var iriElementsAndProperties_1 = {
        clipPath: ['clip-path'],
        'color-profile': ['color-profile'],
        cursor: ['cursor'],
        filter: ['filter'],
        linearGradient: ['fill', 'stroke'],
        marker: ['marker', 'marker-start', 'marker-mid', 'marker-end'],
        mask: ['mask'],
        path: [],
        pattern: ['fill', 'stroke'],
        radialGradient: ['fill', 'stroke']
      };
      var element_1;
      var elements_1;
      var properties_1;
      var currentId_1;
      var newId_1;
      Object.keys(iriElementsAndProperties_1).forEach(function (key) {
        element_1 = key;
        properties_1 = iriElementsAndProperties_1[key];
        elements_1 = svg.querySelectorAll(element_1 + '[id]');

        var _loop_1 = function _loop_1(a, elementsLen) {
          currentId_1 = elements_1[a].id;
          newId_1 = currentId_1 + '-' + uniqueId();
          var referencingElements;
          Array.prototype.forEach.call(properties_1, function (property) {
            referencingElements = svg.querySelectorAll('[' + property + '*="' + currentId_1 + '"]');

            for (var b = 0, referencingElementLen = referencingElements.length; b < referencingElementLen; b++) {
              var attrValue = referencingElements[b].getAttribute(property);

              if (attrValue && !attrValue.match(new RegExp('url\\("?#' + currentId_1 + '"?\\)'))) {
                continue;
              }

              referencingElements[b].setAttribute(property, 'url(#' + newId_1 + ')');
            }
          });
          var allLinks = svg.querySelectorAll('[*|href]');
          var links = [];

          for (var c = 0, allLinksLen = allLinks.length; c < allLinksLen; c++) {
            var href = allLinks[c].getAttributeNS(xlinkNamespace, 'href');

            if (href && href.toString() === '#' + elements_1[a].id) {
              links.push(allLinks[c]);
            }
          }

          for (var d = 0, linksLen = links.length; d < linksLen; d++) {
            links[d].setAttributeNS(xlinkNamespace, 'href', '#' + newId_1);
          }

          elements_1[a].id = newId_1;
        };

        for (var a = 0, elementsLen = elements_1.length; a < elementsLen; a++) {
          _loop_1(a);
        }
      });
    }

    svg.removeAttribute('xmlns:a');
    var scripts = svg.querySelectorAll('script');
    var scriptsToEval = [];
    var script;
    var scriptType;

    for (var i = 0, scriptsLen = scripts.length; i < scriptsLen; i++) {
      scriptType = scripts[i].getAttribute('type');

      if (!scriptType || scriptType === 'application/ecmascript' || scriptType === 'application/javascript' || scriptType === 'text/javascript') {
        script = scripts[i].innerText || scripts[i].textContent;

        if (script) {
          scriptsToEval.push(script);
        }

        svg.removeChild(scripts[i]);
      }
    }

    if (scriptsToEval.length > 0 && (evalScripts === 'always' || evalScripts === 'once' && !ranScripts[imgUrl])) {
      for (var l = 0, scriptsToEvalLen = scriptsToEval.length; l < scriptsToEvalLen; l++) {
        new Function(scriptsToEval[l])(window);
      }

      ranScripts[imgUrl] = true;
    }

    var styleTags = svg.querySelectorAll('style');
    Array.prototype.forEach.call(styleTags, function (styleTag) {
      styleTag.textContent += '';
    });
    svg.setAttribute('xmlns', svgNamespace);
    svg.setAttribute('xmlns:xlink', xlinkNamespace);
    beforeEach(svg);

    if (el.parentNode) {
      el.parentNode.replaceChild(svg, el);
    }

    injectedElements.splice(injectedElements.indexOf(el), 1);
    el = null;
    callback(null, svg);
  });
};

var SVGInjector = function SVGInjector(elements, _a) {
  var _b = _a === void 0 ? {} : _a,
      _c = _b.afterAll,
      afterAll = _c === void 0 ? function () {
    return undefined;
  } : _c,
      _d = _b.afterEach,
      afterEach = _d === void 0 ? function () {
    return undefined;
  } : _d,
      _e = _b.beforeEach,
      beforeEach = _e === void 0 ? function () {
    return undefined;
  } : _e,
      _f = _b.cacheRequests,
      cacheRequests = _f === void 0 ? true : _f,
      _g = _b.evalScripts,
      evalScripts = _g === void 0 ? 'never' : _g,
      _h = _b.renumerateIRIElements,
      renumerateIRIElements = _h === void 0 ? true : _h;

  if (elements && 'length' in elements) {
    var elementsLoaded_1 = 0;

    for (var i = 0, j = elements.length; i < j; i++) {
      svg_injector_esm_injectElement(elements[i], evalScripts, renumerateIRIElements, cacheRequests, beforeEach, function (error, svg) {
        afterEach(error, svg);

        if (elements && 'length' in elements && elements.length === ++elementsLoaded_1) {
          afterAll(elementsLoaded_1);
        }
      });
    }
  } else if (elements) {
    svg_injector_esm_injectElement(elements, evalScripts, renumerateIRIElements, cacheRequests, beforeEach, function (error, svg) {
      afterEach(error, svg);
      afterAll(1);
      elements = null;
    });
  } else {
    afterAll(0);
  }
};


//# sourceMappingURL=svg-injector.esm.js.map

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__("17x9");

// EXTERNAL MODULE: ./node_modules/react-dom/server.browser.js
var server_browser = __webpack_require__("KAy6");
var server_browser_default = /*#__PURE__*/__webpack_require__.n(server_browser);

// CONCATENATED MODULE: ./node_modules/react-svg/dist/react-svg.esm.js







// Hat-tip: https://github.com/developit/preact-compat/blob/master/src/index.js#L402.
var shallowDiffers = function shallowDiffers(a, b) {
  for (var i in a) {
    if (!(i in b)) {
      return true;
    }
  }

  for (var _i in b) {
    if (a[_i] !== b[_i]) {
      return true;
    }
  }

  return false;
};

var react_svg_esm_ReactSVG = /*#__PURE__*/function (_React$Component) {
  inheritsLoose_default()(ReactSVG, _React$Component);

  function ReactSVG() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;
    _this.initialState = {
      hasError: false,
      isLoading: true
    };
    _this.state = _this.initialState;
    _this._isMounted = false;

    _this.refCallback = function (container) {
      _this.container = container;
    };

    return _this;
  }

  var _proto = ReactSVG.prototype;

  _proto.renderSVG = function renderSVG() {
    var _this2 = this;

    /* istanbul ignore else */
    if (this.container instanceof Node) {
      var _this$props = this.props,
          beforeInjection = _this$props.beforeInjection,
          evalScripts = _this$props.evalScripts,
          renumerateIRIElements = _this$props.renumerateIRIElements,
          src = _this$props.src,
          useRequestCache = _this$props.useRequestCache;
      /* eslint-disable @typescript-eslint/no-non-null-assertion */

      var afterInjection = this.props.afterInjection;
      var Wrapper = this.props.wrapper;
      /* eslint-enable @typescript-eslint/no-non-null-assertion */

      var wrapper = document.createElement(Wrapper);
      wrapper.innerHTML = server_browser_default.a.renderToStaticMarkup( /*#__PURE__*/Object(react["createElement"])(Wrapper, null, /*#__PURE__*/Object(react["createElement"])(Wrapper, {
        "data-src": src
      })));
      this.svgWrapper = this.container.appendChild(wrapper.firstChild);

      var afterEach = function afterEach(error, svg) {
        if (error) {
          _this2.removeSVG();
        } // TODO: It'd be better to cleanly unsubscribe from SVGInjector
        // callbacks instead of tracking a property like this.


        if (_this2._isMounted) {
          _this2.setState(function () {
            return {
              hasError: !!error,
              isLoading: false
            };
          }, function () {
            afterInjection(error, svg);
          });
        }
      };

      SVGInjector(this.svgWrapper.firstChild, {
        afterEach: afterEach,
        beforeEach: beforeInjection,
        cacheRequests: useRequestCache,
        evalScripts: evalScripts,
        renumerateIRIElements: renumerateIRIElements
      });
    }
  };

  _proto.removeSVG = function removeSVG() {
    if (this.container instanceof Node && this.svgWrapper instanceof Node) {
      this.container.removeChild(this.svgWrapper);
      this.svgWrapper = null;
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this.renderSVG();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this3 = this;

    if (shallowDiffers(prevProps, this.props)) {
      this.setState(function () {
        return _this3.initialState;
      }, function () {
        _this3.removeSVG();

        _this3.renderSVG();
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;
    this.removeSVG();
  };

  _proto.render = function render() {
    /* eslint-disable @typescript-eslint/no-unused-vars */
    var _this$props2 = this.props;
        _this$props2.afterInjection;
        _this$props2.beforeInjection;
        _this$props2.evalScripts;
        var Fallback = _this$props2.fallback,
        Loading = _this$props2.loading;
        _this$props2.renumerateIRIElements;
        _this$props2.src;
        _this$props2.useRequestCache;
        var wrapper = _this$props2.wrapper,
        rest = objectWithoutPropertiesLoose_default()(_this$props2, ["afterInjection", "beforeInjection", "evalScripts", "fallback", "loading", "renumerateIRIElements", "src", "useRequestCache", "wrapper"]);
    /* eslint-enable @typescript-eslint/no-unused-vars */
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion


    var Wrapper = wrapper;
    return /*#__PURE__*/Object(react["createElement"])(Wrapper, Object.assign({}, rest, {
      ref: this.refCallback
    }), this.state.isLoading && Loading && /*#__PURE__*/Object(react["createElement"])(Loading, null), this.state.hasError && Fallback && /*#__PURE__*/Object(react["createElement"])(Fallback, null));
  };

  return ReactSVG;
}(react["Component"]);
react_svg_esm_ReactSVG.defaultProps = {
  afterInjection: function afterInjection() {
    return undefined;
  },
  beforeInjection: function beforeInjection() {
    return undefined;
  },
  evalScripts: 'never',
  fallback: null,
  loading: null,
  renumerateIRIElements: true,
  useRequestCache: true,
  wrapper: 'div'
};
react_svg_esm_ReactSVG.propTypes = {
  afterInjection: prop_types["func"],
  beforeInjection: prop_types["func"],
  evalScripts: Object(prop_types["oneOf"])(['always', 'once', 'never']),
  fallback: Object(prop_types["oneOfType"])([prop_types["func"], prop_types["object"], prop_types["string"]]),
  loading: Object(prop_types["oneOfType"])([prop_types["func"], prop_types["object"], prop_types["string"]]),
  renumerateIRIElements: prop_types["bool"],
  src: prop_types["string"].isRequired,
  useRequestCache: prop_types["bool"],
  wrapper: Object(prop_types["oneOf"])(['div', 'span'])
} ;


//# sourceMappingURL=react-svg.esm.js.map

// CONCATENATED MODULE: ./components/pages/product/Soundboks2/TechSpecs/SpecDetails.js







var SpecDetails_jsx = react_default.a.createElement;

function SpecDetails_createSuper(Derived) { var hasNativeReflectConstruct = SpecDetails_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function SpecDetails_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }









/*
  The magic behind soundboks blueprint animation happens mainly in the svg file:
  1) It has png background (the original blueprint
  2) It has several overlays where desired parts were outlined
  3) Each layer has it's own id prefixed with 'blueprint' (e.g. blueprint_frame)
  4) Each layer has defined onmouseover/onmouseleave events
  5) When an event triggered, we set layer opacity to 1 (0 by default) to show the
  overlaying color
  6) also highlight outer text by selecting it by id (should be prefixed by
  'text' (e.g. text_frame)
*/
var SpecDetails_soundboksImg = __webpack_require__("vrg1");

var SpecDetails_Wrapper = Object(styled_components_browser_esm["default"])(Row["a" /* default */]).withConfig({
  displayName: "SpecDetails__Wrapper",
  componentId: "sc-1gio892-0"
})(["padding-top:0;padding-bottom:0;"]);
var LoadingWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SpecDetails__LoadingWrapper",
  componentId: "sc-1gio892-1"
})(["height:100%;width:100%;display:flex;justify-content:center;align-items:center;"]);
var SoundboksImage = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SpecDetails__SoundboksImage",
  componentId: "sc-1gio892-2"
})(["grid-area:image;display:none;width:100%;height:auto;@media ", "{display:block;}> div{height:100%;width:100%;}svg{grid-area:image;display:none;width:100%;height:auto;path[id^=\"", "\"]{opacity:1 !important;}@media ", "{display:block;}}"], function (props) {
  return props.theme.breakpoints.desktop;
}, function (props) {
  return props.highlight;
}, function (props) {
  return props.theme.breakpoints.desktop;
});

var SpecDetails_LoadingIndicator = function LoadingIndicator() {
  return /*#__PURE__*/react_default.a.createElement(LoadingWrapper, null, /*#__PURE__*/react_default.a.createElement(Text["e" /* H3 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Loading..."
  })));
};

var HoverableP = Object(styled_components_browser_esm["default"])(Text["k" /* P */]).withConfig({
  displayName: "SpecDetails__HoverableP",
  componentId: "sc-1gio892-3"
})(["cursor:pointer;@media ", "{&:hover{color:", ";}}"], function (props) {
  return props.theme.breakpoints.tablet;
}, function (props) {
  return props.theme.colors.primary;
}); // eslint-disable-next-line react/prop-types

var SpecDetails_createHighlightP = function createHighlightP(onEnter, onLeave) {
  return function (_ref) {
    var name = _ref.name,
        children = _ref.children;
    return /*#__PURE__*/react_default.a.createElement(HoverableP, {
      id: "text_".concat(name),
      onMouseEnter: function onMouseEnter() {
        return onEnter("blueprint_".concat(name));
      },
      onMouseLeave: onLeave
    }, children);
  };
};

var SpecDetails_SpecDetails = /*#__PURE__*/function (_Component) {
  Object(inherits["a" /* default */])(SpecDetails, _Component);

  var _super = SpecDetails_createSuper(SpecDetails);

  function SpecDetails(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, SpecDetails);

    _this = _super.call(this, props);

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "setHighlight", function (name) {
      return _this.setState({
        highlight: name
      });
    });

    Object(defineProperty["a" /* default */])(Object(assertThisInitialized["a" /* default */])(_this), "clearHighlight", function () {
      return _this.setState({
        highlight: null
      });
    });

    _this.state = {
      highlight: null
    };
    _this.HighlightP = SpecDetails_createHighlightP(_this.setHighlight, _this.clearHighlight);
    return _this;
  }

  Object(createClass["a" /* default */])(SpecDetails, [{
    key: "render",
    value: function render() {
      var highlight = this.state.highlight;
      var HighlightP = this.HighlightP;
      return /*#__PURE__*/react_default.a.createElement(SpecDetails_Wrapper, null, /*#__PURE__*/react_default.a.createElement(SpecDetails_SectionWrapper, null, /*#__PURE__*/react_default.a.createElement(Text["d" /* H2 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Sound"
      })), /*#__PURE__*/react_default.a.createElement("div", null, /*#__PURE__*/react_default.a.createElement(Text["e" /* H3 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Amplifier"
      })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Merus Audio eximo\xAE amp switching"
      })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "3 x 72Wrms class D amplifier"
      })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Advanced DSP"
      })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Dynamic DC/DC Boost Converter"
      }))), /*#__PURE__*/react_default.a.createElement("div", null, /*#__PURE__*/react_default.a.createElement(Text["e" /* H3 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Driver units"
      })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "2 x 96dB 10\u201D (\xD8254mm) woofers"
      })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "1 x 96dB 1\u201D (\xD825mm) neodymium silk dome tweeter"
      }))), /*#__PURE__*/react_default.a.createElement("div", null, /*#__PURE__*/react_default.a.createElement(Text["e" /* H3 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Acoustics"
      })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Effective frequency range: 40Hz - 20kHz"
      })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Psychoacoustic sound design"
      }))), /*#__PURE__*/react_default.a.createElement("div", null, /*#__PURE__*/react_default.a.createElement(Text["e" /* H3 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Connectivity"
      })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Bluetooth 3.0 (Up to 60 feet/20 meter range)"
      })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "1 x \u215B\u201D (3.5mm) Stereo Jack"
      })))), /*#__PURE__*/react_default.a.createElement(BuildSectionWrapper, null, /*#__PURE__*/react_default.a.createElement(Text["d" /* H2 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Build"
      })), /*#__PURE__*/react_default.a.createElement("div", null, /*#__PURE__*/react_default.a.createElement(Text["e" /* H3 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Dimensions"
      })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "25.6 x 17 x 13 in (66 x 43 x 32 cm)"
      }))), /*#__PURE__*/react_default.a.createElement("div", null, /*#__PURE__*/react_default.a.createElement(Text["e" /* H3 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Weight"
      })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "33 pounds (15 kilos)"
      }))), /*#__PURE__*/react_default.a.createElement("div", null, /*#__PURE__*/react_default.a.createElement(Text["e" /* H3 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Materials"
      })), /*#__PURE__*/react_default.a.createElement(HighlightP, {
        name: "cabinet"
      }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Birch plywood bass reflex cabinet"
      })), /*#__PURE__*/react_default.a.createElement(HighlightP, {
        name: "frame"
      }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Powder coated aluminum frame"
      })), /*#__PURE__*/react_default.a.createElement(HighlightP, {
        name: "corners"
      }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Molded solid aluminum ball corners"
      })), /*#__PURE__*/react_default.a.createElement(HighlightP, {
        name: "glue"
      }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "SMP temperature-flex adhesive"
      }))), /*#__PURE__*/react_default.a.createElement("div", null, /*#__PURE__*/react_default.a.createElement(Text["e" /* H3 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Features"
      })), /*#__PURE__*/react_default.a.createElement(HighlightP, null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Weather and splash resistant"
      })), /*#__PURE__*/react_default.a.createElement(HighlightP, {
        name: "bass"
      }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "2 x \xD856mm bass reflex ports"
      })), /*#__PURE__*/react_default.a.createElement(HighlightP, {
        name: "interface"
      }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Simple user interface with volume knob (going to 11)"
      })), /*#__PURE__*/react_default.a.createElement(HighlightP, {
        name: "interface"
      }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "3-step mode switch"
      })), /*#__PURE__*/react_default.a.createElement(HighlightP, {
        name: "battery"
      }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Compact battery port"
      })), /*#__PURE__*/react_default.a.createElement(HighlightP, {
        name: "mount"
      }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "1 x \xD835mm Pole mount"
      }))), /*#__PURE__*/react_default.a.createElement(SoundboksImage, {
        highlight: highlight
      }, /*#__PURE__*/react_default.a.createElement(react_svg_esm_ReactSVG, {
        src: SpecDetails_soundboksImg.url,
        loading: SpecDetails_LoadingIndicator
      }))), /*#__PURE__*/react_default.a.createElement(SpecDetails_SectionWrapper, null, /*#__PURE__*/react_default.a.createElement(Text["d" /* H2 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Battery"
      })), /*#__PURE__*/react_default.a.createElement("div", null, /*#__PURE__*/react_default.a.createElement(Text["e" /* H3 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Life"
      })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "40 hours on moderate volume, up to 8 hours on full volume"
      })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "3.5 hours full recharge"
      }))), /*#__PURE__*/react_default.a.createElement("div", null, /*#__PURE__*/react_default.a.createElement(Text["e" /* H3 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Design"
      })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "5-step LED battery-life indicator"
      })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Heavy duty DC battery connector"
      }))), /*#__PURE__*/react_default.a.createElement("div", null, /*#__PURE__*/react_default.a.createElement(Text["e" /* H3 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Cell type"
      })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "12.8V, 7.8Ah Lithium Iron Phosphate (LiFePO4)"
      }))), /*#__PURE__*/react_default.a.createElement("div", null, /*#__PURE__*/react_default.a.createElement(Text["e" /* H3 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Battery management system (BMS)"
      })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Over and under-discharge protection"
      })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Short circuit protection"
      })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Overheat protection"
      })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "Cell voltage management"
      })))));
    }
  }]);

  return SpecDetails;
}(react["Component"]);

var sectionBase = Object(styled_components_browser_esm["css"])(["display:grid;grid-template-columns:1fr;grid-row-gap:20px;grid-column-gap:20px;", ";", ";border-top:2px solid ", ";@media ", "{h2{margin-bottom:20px;}}"], Object(paramToResolutions["a" /* default */])('padding-top', [40, 60, undefined, 80]), Object(paramToResolutions["a" /* default */])('padding-bottom', [40, 60, undefined, 80]), function (props) {
  return props.theme.colors.black;
}, function (props) {
  return props.theme.breakpoints.onlyMobile;
});
var sectionTabletParams = Object(styled_components_browser_esm["css"])(["> h2:first-child{grid-area:title;}grid-template:'title a b' 'title c d' / 25% 1fr 1fr;"]);
var SpecDetails_SectionWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SpecDetails__SectionWrapper",
  componentId: "sc-1gio892-4"
})(["", ";@media ", "{", "}"], sectionBase, function (props) {
  return props.theme.breakpoints.tablet;
}, sectionTabletParams);
var BuildSectionWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SpecDetails__BuildSectionWrapper",
  componentId: "sc-1gio892-5"
})(["", ";@media ", "{", "}@media ", "{grid-column-gap:30px;grid-template:'a image' 'b image' 'c image' 'd image' 'e image' / 25% 75%;}"], sectionBase, function (props) {
  return props.theme.breakpoints.onlyTablet;
}, sectionTabletParams, function (props) {
  return props.theme.breakpoints.desktop;
});
/* harmony default export */ var TechSpecs_SpecDetails = (SpecDetails_SpecDetails);
// CONCATENATED MODULE: ./components/pages/product/Soundboks2/TechSpecs/index.js
var Soundboks2_TechSpecs_jsx = react_default.a.createElement;








var Soundboks2_TechSpecs_TechSpecs = function TechSpecs(_ref) {
  var productId = _ref.productId,
      productHandle = _ref.productHandle;
  return /*#__PURE__*/react_default.a.createElement(PageTracker["a" /* default */], null, /*#__PURE__*/react_default.a.createElement("div", null, /*#__PURE__*/react_default.a.createElement(TechSpecs_Meta, {
    productHandle: productHandle
  }), /*#__PURE__*/react_default.a.createElement(ProductHeader, {
    productId: productId,
    productHandle: productHandle,
    activeSubPageId: "techspecs"
  }), /*#__PURE__*/react_default.a.createElement(TechSpecs_TechHeader, null), /*#__PURE__*/react_default.a.createElement(TechSpecs_SpecDetails, null), /*#__PURE__*/react_default.a.createElement(Overview_Buy, {
    productHandle: productHandle
  })));
};

/* harmony default export */ var Soundboks2_TechSpecs = (Soundboks2_TechSpecs_TechSpecs);
// CONCATENATED MODULE: ./components/pages/product/Soundboks2/index.js
var Soundboks2_jsx = react_default.a.createElement;








var Soundboks2_productPage = function productPage(productHandle, productId) {
  return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(ProductHeader, {
    productHandle: productHandle,
    productId: productId,
    activeSubPageId: "/"
  }), /*#__PURE__*/react_default.a.createElement(BuyProduct, {
    productId: productId
  }));
};

var Soundboks2_Soundboks2 = function Soundboks2(_ref) {
  var productId = _ref.productId,
      productHandle = _ref.productHandle,
      subPage = _ref.subPage;

  // If there is no subPage, use Product page
  if (!subPage) {
    return Soundboks2_productPage(productHandle, productId);
  } // If there is no subPage, return a correspond page.


  switch (subPage) {
    case 'overview':
      return /*#__PURE__*/react_default.a.createElement(Soundboks2_Overview, {
        productId: productId,
        productHandle: productHandle
      });

    case 'reviews':
      return /*#__PURE__*/react_default.a.createElement(Soundboks2_Reviews, {
        productId: productId,
        productHandle: productHandle
      });

    case 'techspecs':
      return /*#__PURE__*/react_default.a.createElement(Soundboks2_TechSpecs, {
        productId: productId,
        productHandle: productHandle
      });

    default:
      return /*#__PURE__*/react_default.a.createElement(error_default.a, {
        statusCode: 404
      });
  }
}; // defaultProps


Soundboks2_Soundboks2.defaultProps = {
  productHandle: 'soundboks-gen-2',
  subPage: null
}; // propTypes

/* harmony default export */ var product_Soundboks2 = (Soundboks2_Soundboks2);
// CONCATENATED MODULE: ./components/pages/product/Batteryboks/TechSpecs/SpecDetails.js
var TechSpecs_SpecDetails_jsx = react_default.a.createElement;






var TechSpecs_SpecDetails_Wrapper = Object(styled_components_browser_esm["default"])(Row["a" /* default */]).withConfig({
  displayName: "SpecDetails__Wrapper",
  componentId: "xyo3d3-0"
})(["padding-top:0;padding-bottom:0;"]);
var TapeHeaderWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SpecDetails__TapeHeaderWrapper",
  componentId: "xyo3d3-1"
})(["padding-top:60px;padding-bottom:60px;@media ", "{display:none;}@media ", "{padding-top:110px;padding-bottom:110px;}div:first-child{margin-bottom:8px;}"], function (props) {
  return props.theme.breakpoints.onlyMobile;
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
});
var TechSpecs_SpecDetails_SectionWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "SpecDetails__SectionWrapper",
  componentId: "xyo3d3-2"
})(["display:grid;grid-template-columns:1fr;grid-row-gap:20px;grid-column-gap:20px;", ";", ";border-top:2px solid ", ";@media ", "{h2{margin-bottom:20px;}}@media ", "{grid-template:'title a b' 'title c d' / 25% 1fr 1fr;> h2:first-child{grid-area:title;}}"], Object(paramToResolutions["a" /* default */])('padding-top', [40, 60, undefined, 80]), Object(paramToResolutions["a" /* default */])('padding-bottom', [40, 60, undefined, 80]), function (props) {
  return props.theme.colors.black;
}, function (props) {
  return props.theme.breakpoints.onlyMobile;
}, function (props) {
  return props.theme.breakpoints.tablet;
});

var TechSpecs_SpecDetails_SpecDetails = function SpecDetails() {
  return /*#__PURE__*/react_default.a.createElement(TechSpecs_SpecDetails_Wrapper, null, /*#__PURE__*/react_default.a.createElement(TapeHeaderWrapper, null, /*#__PURE__*/react_default.a.createElement(Text["o" /* TapeHeading */], {
    center: true,
    text:
    /*i18n*/
    {
      id: "Tech Specs"
    }
  })), /*#__PURE__*/react_default.a.createElement(TechSpecs_SpecDetails_SectionWrapper, null, /*#__PURE__*/react_default.a.createElement(Text["d" /* H2 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Battery"
  })), /*#__PURE__*/react_default.a.createElement("div", null, /*#__PURE__*/react_default.a.createElement(Text["e" /* H3 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Life"
  })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "40 hours on moderate volume, up to 8 hours on full volume"
  })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "3.5 hours full recharge"
  }))), /*#__PURE__*/react_default.a.createElement("div", null, /*#__PURE__*/react_default.a.createElement(Text["e" /* H3 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Design"
  })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "5-step LED battery-life indicator"
  })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Heavy duty DC battery connector"
  }))), /*#__PURE__*/react_default.a.createElement("div", null, /*#__PURE__*/react_default.a.createElement(Text["e" /* H3 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Cell type"
  })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "12.8V, 7.8Ah Lithium Iron Phosphate (LiFePO4)"
  }))), /*#__PURE__*/react_default.a.createElement("div", null, /*#__PURE__*/react_default.a.createElement(Text["e" /* H3 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Battery management system (BMS)"
  })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Over and under-discharge protection"
  })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Short circuit protection"
  })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Overheat protection"
  })), /*#__PURE__*/react_default.a.createElement(Text["k" /* P */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Cell voltage management"
  })))));
};

/* harmony default export */ var Batteryboks_TechSpecs_SpecDetails = (TechSpecs_SpecDetails_SpecDetails);
// CONCATENATED MODULE: ./components/pages/product/Batteryboks/TechSpecs/index.js
var Batteryboks_TechSpecs_jsx = react_default.a.createElement;







var Batteryboks_TechSpecs_TechSpecs = function TechSpecs(_ref) {
  var productId = _ref.productId,
      productHandle = _ref.productHandle;

  var _useCheckRegion = Object(useCheckRegion["a" /* default */])(),
      isROEU = _useCheckRegion.isROEU;

  var title =
  /*i18n*/
  {
    id: "products.batteryboks.techSpecs.meta.title",
    defaults: "BATTERYBOKS 2 - Battery Tech Specs | SOUNDBOKS"
  };
  title = isROEU ? "".concat(title.defaults, " EU") : title;
  var pageInfo = {
    title: title,
    desc:
    /*i18n*/
    {
      id: "products.batteryboks.techSpecs.meta.description",
      defaults: "40 hour battery life even in extreme weather. Check out the full BATTERYBOKS 2 tech specs here"
    },
    url: "/products/".concat(productHandle, "/techspecs")
  };
  return /*#__PURE__*/react_default.a.createElement(PageTracker["a" /* default */], null, /*#__PURE__*/react_default.a.createElement("div", null, /*#__PURE__*/react_default.a.createElement(Meta["a" /* default */], {
    pageInfo: pageInfo
  }), /*#__PURE__*/react_default.a.createElement(ProductHeader, {
    activeSubPageId: "techspecs",
    productId: productId,
    productHandle: productHandle
  }), /*#__PURE__*/react_default.a.createElement(Batteryboks_TechSpecs_SpecDetails, null)));
};

/* harmony default export */ var Batteryboks_TechSpecs = (Batteryboks_TechSpecs_TechSpecs);
// CONCATENATED MODULE: ./components/pages/product/Batteryboks/index.js
var Batteryboks_jsx = react_default.a.createElement;






var Batteryboks_productPage = function productPage(productHandle, productId) {
  return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(ProductHeader, {
    productHandle: productHandle,
    productId: productId,
    activeSubPageId: "/"
  }), /*#__PURE__*/react_default.a.createElement(BuyProduct, {
    productId: productId
  }));
};

var Batteryboks_Batteryboks = function Batteryboks(_ref) {
  var productId = _ref.productId,
      productHandle = _ref.productHandle,
      subPage = _ref.subPage;

  if (!subPage) {
    return Batteryboks_productPage(productHandle, productId);
  }

  switch (subPage) {
    case 'techspecs':
      return /*#__PURE__*/react_default.a.createElement(Batteryboks_TechSpecs, {
        productId: productId,
        productHandle: productHandle
      });

    default:
      return /*#__PURE__*/react_default.a.createElement(error_default.a, {
        statusCode: 404
      });
  }
}; // defaultProps


Batteryboks_Batteryboks.defaultProps = {
  productHandle: 'batteryboks',
  subPage: null
}; // propTypes

/* harmony default export */ var product_Batteryboks = (Batteryboks_Batteryboks);
// EXTERNAL MODULE: ./actions/handleAddCartItem.js + 1 modules
var handleAddCartItem = __webpack_require__("2OoW");

// EXTERNAL MODULE: ./data/abstractVariants.js
var abstractVariants = __webpack_require__("hvQ7");
var abstractVariants_default = /*#__PURE__*/__webpack_require__.n(abstractVariants);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__("20a2");

// EXTERNAL MODULE: ./node_modules/@soundboks/elements-theme/index.ts + 2 modules
var elements_theme = __webpack_require__("s4Yu");

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__("/Dxq");
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);

// EXTERNAL MODULE: ./node_modules/@soundboks/elements-utils/index.ts + 2 modules
var elements_utils = __webpack_require__("moal");

// CONCATENATED MODULE: ./node_modules/@soundboks/elements-vstack/main/vstack.tsx

var vstack_jsx = react_default.a.createElement;

function vstack_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function vstack_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { vstack_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { vstack_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var vstack_styles = StyleSheet_default.a.create({
  outer: {
    flexDirection: "column",
    flexGrow: 0,
    flexShrink: 0
  },
  inner: {
    flexGrow: 1,
    flexShrink: 0
  }
});
var vstack_VStack = /*#__PURE__*/react_default.a.memo(function VStack(_ref) {
  var width = _ref.width,
      height = _ref.height,
      padding = _ref.padding,
      margin = _ref.margin,
      backgroundColor = _ref.backgroundColor,
      flexGrow = _ref.grow,
      wrapContent = _ref.wrapContent,
      _ref$contentOverflow = _ref.contentOverflow,
      contentOverflow = _ref$contentOverflow === void 0 ? "visible" : _ref$contentOverflow,
      hideHorizontalScrollIndicator = _ref.hideHorizontalScrollIndicator,
      hideVerticalScrollIndicator = _ref.hideVerticalScrollIndicator,
      _ref$alignContentVert = _ref.alignContentVertical,
      alignContentVertical = _ref$alignContentVert === void 0 ? "top" : _ref$alignContentVert,
      _ref$alignContentHori = _ref.alignContentHorizontal,
      alignContentHorizontal = _ref$alignContentHori === void 0 ? "stretch" : _ref$alignContentHori,
      customStyle = _ref.style,
      children = _ref.children;
  var paddingSet = Object(elements_utils["a" /* createEdgeSet */])(padding);
  var marginSet = Object(elements_utils["a" /* createEdgeSet */])(margin);

  var outerOverwrites = vstack_objectSpread(vstack_objectSpread(vstack_objectSpread(vstack_objectSpread(vstack_objectSpread(vstack_objectSpread(vstack_objectSpread({}, width !== undefined && {
    width: width
  }), height !== undefined && {
    height: height
  }), paddingSet && vstack_objectSpread({}, Object(elements_utils["c" /* edgeSetToPadding */])(paddingSet))), marginSet && vstack_objectSpread({}, Object(elements_utils["b" /* edgeSetToMargin */])(marginSet))), backgroundColor && {
    backgroundColor: backgroundColor
  }), flexGrow !== undefined && {
    flexGrow: flexGrow,
    flexShrink: 1
  }), contentOverflow === "hidden" && {
    overflow: "hidden"
  });

  var innerOverwrites = vstack_objectSpread(vstack_objectSpread({}, wrapContent && {
    flexWrap: "wrap",
    flexShrink: 1
  }), {}, {
    alignItems: elements_utils["d" /* valueToAlignItems */].get(alignContentHorizontal),
    justifyContent: elements_utils["e" /* valueToJustifyContent */].get(alignContentVertical)
  });

  if (contentOverflow === "scroll") {
    return /*#__PURE__*/react_default.a.createElement(ScrollView_default.a, {
      scrollEnabled: true,
      style: [vstack_styles.outer, outerOverwrites, customStyle],
      contentContainerStyle: [vstack_styles.inner, innerOverwrites],
      showsHorizontalScrollIndicator: !hideHorizontalScrollIndicator,
      showsVerticalScrollIndicator: !hideVerticalScrollIndicator
    }, children);
  }

  return /*#__PURE__*/react_default.a.createElement(View_default.a, {
    style: [vstack_styles.outer, outerOverwrites, innerOverwrites, customStyle]
  }, children);
});
// CONCATENATED MODULE: ./node_modules/@soundboks/elements-vstack/index.ts

// EXTERNAL MODULE: ./components/elements/spacer/index.web.tsx + 1 modules
var index_web = __webpack_require__("n75Q");

// CONCATENATED MODULE: ./components/elements/buy-btn-services/services/affirm/styled.ts


var Affirm = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Affirm",
  componentId: "sc-1aoi331-0"
})(["font-family:", ";font-size:11px;font-weight:normal;text-transform:none;a{color:", ";}span.__affirm-logo{color:", ";}"], function (props) {
  return props.theme.fonts.regular;
}, function (_ref) {
  var isBlackTheme = _ref.isBlackTheme;
  return isBlackTheme ? styles_theme["a" /* default */].colors.grey : styles_theme["a" /* default */].colors.black;
}, function (_ref2) {
  var isBlackTheme = _ref2.isBlackTheme;
  return isBlackTheme ? styles_theme["a" /* default */].colors.white : styles_theme["a" /* default */].colors.black;
});
// CONCATENATED MODULE: ./components/elements/buy-btn-services/services/affirm/index.web.tsx
var index_web_jsx = react_default.a.createElement;


var index_web_AffirmService = function AffirmService(_ref) {
  var price = _ref.price,
      isBlackTheme = _ref.isBlackTheme,
      locale = _ref.locale;
  Object(react["useEffect"])(function () {
    try {
      var _window$affirm;

      if ((_window$affirm = window.affirm) === null || _window$affirm === void 0 ? void 0 : _window$affirm.ui) {
        window.affirm.ui.ready(function () {
          return window.affirm.ui.refresh();
        });
      }
    } catch (e) {
      console.log(e);
    }
  }, [locale]);
  return /*#__PURE__*/react_default.a.createElement(Affirm, {
    className: "affirm-as-low-as",
    "data-page-type": "product",
    "data-amount": price * 100
    /* Convert USD to USD cents */
    ,
    "data-modal-id": "RP84PHVVBKNM1ZA2",
    "data-learnmore-show": false,
    isBlackTheme: isBlackTheme
  });
};
// CONCATENATED MODULE: ./components/elements/buy-btn-services/services/klarna/styled.ts

var Klarna = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Klarna",
  componentId: "sc-1tuxzut-0"
})([""]);
// EXTERNAL MODULE: ./components/elements/buy-btn-services/scripts/config.js
var config = __webpack_require__("ONLd");

// CONCATENATED MODULE: ./components/elements/buy-btn-services/services/klarna/index.web.tsx
var klarna_index_web_jsx = react_default.a.createElement;



var index_web_KlarnaService = function KlarnaService(_ref) {
  var price = _ref.price,
      locale = _ref.locale,
      klarnaClassName = _ref.klarnaClassName;
  Object(react["useEffect"])(function () {
    try {
      if (true) {
        window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
        window.KlarnaOnsiteService.push({
          eventName: 'refresh-placements'
        });
      }
    } catch (e) {
      console.log(e);
    }
  }, [locale, price]);
  return /*#__PURE__*/react_default.a.createElement(Klarna, {
    as: 'klarna-placement',
    className: klarnaClassName,
    "data-key": config["a" /* klarnaDataKeys */].creditAuto,
    "data-locale": locale,
    "data-purchase-amount": price * 100
  });
};
// CONCATENATED MODULE: ./node_modules/@soundboks/elements-spacer/main/spacer.tsx

var spacer_jsx = react_default.a.createElement;

function spacer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function spacer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { spacer_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { spacer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var spacer_styles = StyleSheet_default.a.create({
  container: {
    flexGrow: 0
  }
});
var spacer_Spacer = /*#__PURE__*/react_default.a.memo(function Spacer(_ref) {
  var flexGrow = _ref.grow,
      width = _ref.width,
      height = _ref.height,
      customStyle = _ref.style;

  var containerOverwrites = spacer_objectSpread(spacer_objectSpread(spacer_objectSpread({}, width !== undefined && {
    minWidth: width
  }), height !== undefined && {
    minHeight: height
  }), flexGrow !== undefined && {
    flexGrow: flexGrow,
    flexShrink: 1
  });

  return /*#__PURE__*/react_default.a.createElement(View_default.a, {
    style: [spacer_styles.container, containerOverwrites, customStyle]
  });
});
// CONCATENATED MODULE: ./node_modules/@soundboks/elements-spacer/index.ts

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/Pressable/index.js
var Pressable = __webpack_require__("XY2T");
var Pressable_default = /*#__PURE__*/__webpack_require__.n(Pressable);

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/Text/index.js
var exports_Text = __webpack_require__("38aF");
var Text_default = /*#__PURE__*/__webpack_require__.n(exports_Text);

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/Platform/index.js
var Platform = __webpack_require__("Hnp+");
var Platform_default = /*#__PURE__*/__webpack_require__.n(Platform);

// CONCATENATED MODULE: ./node_modules/@soundboks/elements-button/main/style.tsx


function style_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function style_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { style_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { style_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var buttonTextBase = style_objectSpread({
  fontFamily: elements_theme["b" /* FontFamily */].GTAmericaRegularBold,
  fontSize: 14,
  lineHeight: 14
}, Platform_default.a.OS === "web" && {
  cursor: "inherit",
  whiteSpace: "nowrap"
});

var buttonText = {
  solid: {
    orange: StyleSheet_default.a.create({
      normal: style_objectSpread(style_objectSpread({}, buttonTextBase), {}, {
        color: elements_theme["a" /* Color */].White
      })
    }),
    blue: StyleSheet_default.a.create({
      normal: style_objectSpread(style_objectSpread({}, buttonTextBase), {}, {
        color: elements_theme["a" /* Color */].White
      })
    }),
    charcoal: StyleSheet_default.a.create({
      normal: style_objectSpread(style_objectSpread({}, buttonTextBase), {}, {
        color: elements_theme["a" /* Color */].White
      })
    })
  },
  outline: {
    orange: StyleSheet_default.a.create({
      normal: style_objectSpread(style_objectSpread({}, buttonTextBase), {}, {
        color: elements_theme["a" /* Color */].Orange
      })
    }),
    blue: StyleSheet_default.a.create({
      normal: style_objectSpread(style_objectSpread({}, buttonTextBase), {}, {
        color: elements_theme["a" /* Color */].Blue
      })
    }),
    charcoal: StyleSheet_default.a.create({
      normal: style_objectSpread(style_objectSpread({}, buttonTextBase), {}, {
        color: elements_theme["a" /* Color */].Charcoal
      })
    })
  },
  text: {
    orange: StyleSheet_default.a.create({
      normal: style_objectSpread(style_objectSpread({}, buttonTextBase), {}, {
        color: elements_theme["a" /* Color */].Orange
      })
    }),
    blue: StyleSheet_default.a.create({
      normal: style_objectSpread(style_objectSpread({}, buttonTextBase), {}, {
        color: elements_theme["a" /* Color */].Blue
      })
    }),
    charcoal: StyleSheet_default.a.create({
      normal: style_objectSpread(style_objectSpread({}, buttonTextBase), {}, {
        color: elements_theme["a" /* Color */].Charcoal
      })
    })
  }
};
var buttonContainerBase = {
  alignItems: "center",
  justifyContent: "center",
  height: 44,
  borderRadius: 4,
  paddingHorizontal: 18,
  minWidth: 156
};
var buttonContainerShadow = {
  shadowOffset: {
    width: 1,
    height: 1
  },
  shadowColor: "rgba(0, 0, 0, 0.25)"
};
var buttonContainer = {
  solid: {
    orange: StyleSheet_default.a.create({
      normal: style_objectSpread(style_objectSpread(style_objectSpread({}, buttonContainerBase), buttonContainerShadow), {}, {
        backgroundColor: elements_theme["a" /* Color */].Orange
      }),
      hovered: {
        backgroundColor: elements_theme["a" /* Color */].OrangeBrighter
      },
      pressed: {
        backgroundColor: elements_theme["a" /* Color */].Orange
      }
    }),
    blue: StyleSheet_default.a.create({
      normal: style_objectSpread(style_objectSpread(style_objectSpread({}, buttonContainerBase), buttonContainerShadow), {}, {
        backgroundColor: elements_theme["a" /* Color */].Blue
      }),
      hovered: {
        backgroundColor: elements_theme["a" /* Color */].BlueBrighter
      },
      pressed: {
        backgroundColor: elements_theme["a" /* Color */].Blue
      }
    }),
    charcoal: StyleSheet_default.a.create({
      normal: style_objectSpread(style_objectSpread(style_objectSpread({}, buttonContainerBase), buttonContainerShadow), {}, {
        backgroundColor: elements_theme["a" /* Color */].Charcoal
      }),
      hovered: {
        backgroundColor: elements_theme["a" /* Color */].CharcoalBrighter
      },
      pressed: {
        backgroundColor: elements_theme["a" /* Color */].Charcoal
      }
    })
  },
  outline: {
    orange: StyleSheet_default.a.create({
      normal: style_objectSpread(style_objectSpread({}, buttonContainerBase), {}, {
        borderWidth: 1,
        borderColor: elements_theme["a" /* Color */].Orange
      }),
      hovered: {
        borderColor: elements_theme["a" /* Color */].OrangeBrighter
      },
      pressed: {
        borderColor: elements_theme["a" /* Color */].Orange
      }
    }),
    blue: StyleSheet_default.a.create({
      normal: style_objectSpread(style_objectSpread({}, buttonContainerBase), {}, {
        borderWidth: 1,
        borderColor: elements_theme["a" /* Color */].Blue
      }),
      hovered: {
        borderColor: elements_theme["a" /* Color */].BlueBrighter
      },
      pressed: {
        borderColor: elements_theme["a" /* Color */].Blue
      }
    }),
    charcoal: StyleSheet_default.a.create({
      normal: style_objectSpread(style_objectSpread({}, buttonContainerBase), {}, {
        borderWidth: 1,
        borderColor: elements_theme["a" /* Color */].Charcoal
      }),
      hovered: {
        borderColor: elements_theme["a" /* Color */].CharcoalBrighter
      },
      pressed: {
        borderColor: elements_theme["a" /* Color */].Charcoal
      }
    })
  },
  text: {
    orange: StyleSheet_default.a.create({
      normal: style_objectSpread(style_objectSpread({}, buttonContainerBase), {}, {
        borderColor: elements_theme["a" /* Color */].Transparent
      })
    }),
    blue: StyleSheet_default.a.create({
      normal: style_objectSpread(style_objectSpread({}, buttonContainerBase), {}, {
        borderColor: elements_theme["a" /* Color */].Transparent
      })
    }),
    charcoal: StyleSheet_default.a.create({
      normal: style_objectSpread(style_objectSpread({}, buttonContainerBase), {}, {
        borderColor: elements_theme["a" /* Color */].Transparent
      })
    })
  }
};
var buttonTextDisabled = {
  color: elements_theme["a" /* Color */].WhiteOff
};
var buttonContainerDisabled = {
  backgroundColor: elements_theme["a" /* Color */].Grey
};
// CONCATENATED MODULE: ./node_modules/@soundboks/elements-button/main/button.tsx
var button_jsx = react_default.a.createElement;




var button_Button = /*#__PURE__*/react_default.a.memo(function Button(_ref) {
  var label = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "solid" : _ref$variant,
      _ref$palette = _ref.palette,
      palette = _ref$palette === void 0 ? "orange" : _ref$palette,
      width = _ref.width,
      disabled = _ref.disabled,
      onAction = _ref.onAction;
  var containerSet = buttonContainer[variant][palette];
  var textSet = buttonText[variant][palette];

  var handleContainerStyle = function handleContainerStyle(_ref2) {
    var hovered = _ref2.hovered,
        pressed = _ref2.pressed;
    return [containerSet.normal, hovered && containerSet.hovered, pressed && containerSet.pressed, width !== undefined && {
      minWidth: width
    }, disabled && buttonContainerDisabled];
  };

  var getTextStyle = function getTextStyle() {
    return [textSet.normal, disabled && buttonTextDisabled];
  };

  return /*#__PURE__*/react_default.a.createElement(Pressable_default.a, {
    disabled: disabled,
    onPress: onAction,
    style: handleContainerStyle
  }, /*#__PURE__*/react_default.a.createElement(Text_default.a, {
    style: getTextStyle()
  }, label));
});
// CONCATENATED MODULE: ./node_modules/@soundboks/elements-button/index.ts

// EXTERNAL MODULE: ./config/klaviyo/klaviyoListIds.ts
var klaviyoListIds = __webpack_require__("tKbB");

// EXTERNAL MODULE: ./actions/addPopup.js
var addPopup = __webpack_require__("pOZZ");

// EXTERNAL MODULE: ./components/shared/PopupSystem/popupNames.js
var popupNames = __webpack_require__("IFDz");

// EXTERNAL MODULE: ./utils/generateClickableId.js
var generateClickableId = __webpack_require__("7dJx");

// CONCATENATED MODULE: ./components/elements/utils/waitlist-button/index.tsx
var waitlist_button_jsx = react_default.a.createElement;







// eslint-disable-next-line prefer-arrow-callback
var waitlist_button_WaitlistButton = /*#__PURE__*/react_default.a.memo(function WaitlistButton(_ref) {
  var handle = _ref.handle,
      label = _ref.label;
  var dispatch = Object(es["c" /* useDispatch */])();

  var _useSelector = Object(es["d" /* useSelector */])(function (state) {
    return state.settings;
  }),
      regionId = _useSelector.regionId;

  var spawnModal = function spawnModal() {
    var source = "waitlist_".concat(handle, "_").concat(regionId);
    var payload = {
      profile: {
        source: source
      },
      listIds: klaviyoListIds["a" /* masterListIds */]
    };
    dispatch(Object(addPopup["a" /* default */])(popupNames["b" /* EMAIL_SIGNUP */], payload, true, true, Object(generateClickableId["a" /* generateClickableId */])(3, handle, 'Buy-WaitlistPopup', 'Subscribe')));
  };

  return /*#__PURE__*/react_default.a.createElement(button_Button, {
    palette: "blue",
    onAction: function onAction() {
      return spawnModal();
    }
  }, label);
});
// CONCATENATED MODULE: ./components/elements/sub-navigation/styled.ts



var SubNavigationContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__SubNavigationContainer",
  componentId: "sc-17oysfq-0"
})(["display:flex;position:fixed;@media ", "{padding:0 24px 0 0;}@media ", "{padding:0;}z-index:1;top:", ";flex-direction:row;justify-content:center;background-color:", ";height:76px;width:100%;box-shadow:0px 3px 3px 0px rgb(0 0 0 / 30%);transition:top 200ms;"], styles_theme["a" /* default */].breakpoints.tablet, styles_theme["a" /* default */].breakpoints.desktop, function (_ref) {
  var isHeaderVisibility = _ref.isHeaderVisibility;
  return isHeaderVisibility ? '48px' : '-80px';
}, elements_theme["a" /* Color */].Charcoal);
var SubHStack = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__SubHStack",
  componentId: "sc-17oysfq-1"
})(["display:flex;flex:1;flex-direction:row;gap:20px;max-width:1064px;@media ", "{& > a:first-child{margin-left:20px;}}@media ", "{overflow:auto;max-width:none;-ms-overflow-style:none;overflow:-moz-scrollbars-none;&::-webkit-scrollbar{display:none;}& > a:first-child{margin-left:20px;}}"], styles_theme["a" /* default */].breakpoints.maxTablet, styles_theme["a" /* default */].breakpoints.maxMobile);
var AnchorItem = styled_components_browser_esm["default"].a.withConfig({
  displayName: "styled__AnchorItem",
  componentId: "sc-17oysfq-2"
})(["display:flex;position:relative;align-items:flex-end;text-transform:uppercase;color:#fff;padding-bottom:12px;@media ", "{padding-bottom:20px;}font-family:", ";text-transform:uppercase;font-size:12px;white-space:nowrap;&:hover{text-decoration:none;}@media ", "{font-size:10px;}&:after{content:\"\";position:absolute;bottom:0px;width:100%;height:4px;background-color:transparent;transition:background-color 200ms;}", "}"], styles_theme["a" /* default */].breakpoints.tablet, elements_theme["b" /* FontFamily */].GTAmericaRegular, styles_theme["a" /* default */].breakpoints.maxMobile, function (_ref2) {
  var isAnchored = _ref2.isAnchored;
  return isAnchored && Object(styled_components_browser_esm["css"])(["&:after{background-color:", ";"], styles_theme["a" /* default */].colors.primary);
});
var Purchase = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Purchase",
  componentId: "sc-17oysfq-3"
})(["display:flex;flex-direction:row;align-items:center;@media ", "{background-color:#000;height:60px;position:fixed;width:100%;bottom:", ";z-index:1;padding-left:24px;transition:bottom 200ms;}"], styles_theme["a" /* default */].breakpoints.maxTablet, function (_ref3) {
  var isHeaderVisibility = _ref3.isHeaderVisibility;
  return isHeaderVisibility ? '0px' : '-60px';
});
var Price = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Price",
  componentId: "sc-17oysfq-4"
})(["display:flex;flex-direction:column;color:#fff;@media ", "{flex:1;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
var BeforePrice = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__BeforePrice",
  componentId: "sc-17oysfq-5"
})(["display:flex;align-self:flex-start;position:relative;font-family:", ";font-size:12px;line-height:12px;&:after{content:\"\";position:absolute;top:calc(50% - 1px);left:-2px;right:-2px;height:2px;background-color:", ";}@media ", "{font-size:10px;line-height:12px;}"], elements_theme["b" /* FontFamily */].GTAmericaExtendedBold, elements_theme["a" /* Color */].Orange, styles_theme["a" /* default */].breakpoints.maxMobile);
var CurrentPrice = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__CurrentPrice",
  componentId: "sc-17oysfq-6"
})(["display:flex;position:relative;font-family:", ";font-size:16px;line-height:16px;@media ", "{font-family:", ";font-size:10px;line-height:12px;}"], elements_theme["b" /* FontFamily */].GTAmericaExtendedBold, styles_theme["a" /* default */].breakpoints.maxMobile, elements_theme["b" /* FontFamily */].GTAmericaExtendedBold);
var Purchage = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Purchage",
  componentId: "sc-17oysfq-7"
})(["display:flex;align-items:center;background-color:#0ff;@media ", "{flex:1;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
var ButtonContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__ButtonContainer",
  componentId: "sc-17oysfq-8"
})(["display:flex;padding-left:10px;@media ", "{width:50%;height:100%;padding:0;& > div{border-radius:0;height:100%;width:100%;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
// CONCATENATED MODULE: ./components/elements/sub-navigation/header-anchors.tsx
var header_anchors_jsx = react_default.a.createElement;



var scrollToAnchor = function scrollToAnchor(element, offset) {
  window.scrollTo({
    top: element.getBoundingClientRect().top + window.pageYOffset - offset + 1,
    behavior: 'smooth'
  });
};
var header_anchors_HeaderAnchors = function HeaderAnchors(_ref) {
  var _ref$anchorStack = _ref.anchorStack,
      anchorStack = _ref$anchorStack === void 0 ? [] : _ref$anchorStack,
      selectedAnchor = _ref.selectedAnchor,
      offset = _ref.offset;

  var isAnchored = function isAnchored(element) {
    return selectedAnchor === element;
  };

  var anchorItemRef = Object(react["useCallback"])(function (anchorItem, anchorElement) {
    if (anchorItem && selectedAnchor === anchorElement) {
      var rect = anchorItem.getBoundingClientRect();

      if (rect.x < 20) {
        anchorItem.parentElement.scrollTo({
          left: anchorItem.offsetLeft - 20,
          behavior: 'smooth'
        });
      } else if (rect.x + rect.width > anchorItem.parentElement.offsetWidth) {
        anchorItem.parentElement.scrollTo({
          left: anchorItem.offsetWidth + anchorItem.offsetLeft + 20 - anchorItem.parentElement.offsetWidth,
          behavior: 'smooth'
        });
      }
    }
  }, [selectedAnchor]);
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return anchorStack.map(function (anchor) {
      return /*#__PURE__*/react_default.a.createElement(AnchorItem, {
        key: anchor.label,
        ref: function ref(element) {
          return anchorItemRef(element, anchor.ref.current);
        },
        isAnchored: isAnchored(anchor.ref.current),
        onClick: function onClick() {
          return scrollToAnchor(anchor.ref.current, offset);
        }
      }, i18n._(anchor.label));
    });
  });
};
// CONCATENATED MODULE: ./components/elements/utils/index.ts
var formatLocale = function formatLocale(region, language) {
  return "".concat(language, "-").concat(region);
};
var formatPrice = function formatPrice(locale, currency, price) {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency
  }).format(price);
};
// CONCATENATED MODULE: ./components/elements/sub-navigation/header-price.tsx
var header_price_jsx = react_default.a.createElement;



var header_price_HeaderPrice = function HeaderPrice(_ref) {
  var locale = _ref.locale,
      currency = _ref.currency,
      compareAtPrice = _ref.compareAtPrice,
      price = _ref.price,
      discount = _ref.discount;
  var formattedPrice = formatPrice(locale, currency, price);

  if (discount) {
    var formattedOldPrice = formatPrice(locale, currency, compareAtPrice);
    return /*#__PURE__*/react_default.a.createElement(Price, null, /*#__PURE__*/react_default.a.createElement(BeforePrice, null, formattedOldPrice), /*#__PURE__*/react_default.a.createElement(CurrentPrice, null, formattedPrice));
  }

  return /*#__PURE__*/react_default.a.createElement(Price, null, /*#__PURE__*/react_default.a.createElement(CurrentPrice, null, formattedPrice));
};
// CONCATENATED MODULE: ./components/elements/sub-navigation/index.tsx
var sub_navigation_jsx = react_default.a.createElement;








// eslint-disable-next-line prefer-arrow-callback
var sub_navigation_SubNavigation = /*#__PURE__*/react_default.a.memo(function SubNavigation(_ref) {
  var isHeaderVisibility = _ref.isHeaderVisibility,
      anchorStack = _ref.anchorStack,
      selectedAnchor = _ref.selectedAnchor,
      offset = _ref.offset,
      productData = _ref.productData,
      productVariant = _ref.productVariant,
      handleAddToCart = _ref.handleAddToCart;
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(SubNavigationContainer, {
      isHeaderVisibility: isHeaderVisibility
    }, /*#__PURE__*/react_default.a.createElement(SubHStack, null, /*#__PURE__*/react_default.a.createElement(header_anchors_HeaderAnchors, {
      anchorStack: anchorStack,
      selectedAnchor: selectedAnchor,
      offset: offset
    }), /*#__PURE__*/react_default.a.createElement(spacer_Spacer, {
      grow: 1
    }), productVariant && /*#__PURE__*/react_default.a.createElement(Purchase, {
      isHeaderVisibility: isHeaderVisibility
    }, /*#__PURE__*/react_default.a.createElement(header_price_HeaderPrice, {
      locale: productData.locale,
      currency: productVariant.currency,
      price: productVariant.price,
      compareAtPrice: productVariant.compareAtPrice,
      discount: productVariant.discount,
      promotion: productVariant.promotion
    }), /*#__PURE__*/react_default.a.createElement(ButtonContainer, null, productVariant.available ? /*#__PURE__*/react_default.a.createElement(button_Button, {
      palette: "blue",
      onAction: handleAddToCart
    }, i18n._('product.buy-page.button.addToCart')) : /*#__PURE__*/react_default.a.createElement(waitlist_button_WaitlistButton, {
      label: i18n._('product.buy-page.button.waitlist'),
      handle: productData.handle
    })))));
  });
});
// EXTERNAL MODULE: ./utils/product/getProductImages.js
var getProductImages = __webpack_require__("NgCz");

// EXTERNAL MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/assets/Soundboks3-lifestyle-1-large.jpg
var Soundboks3_lifestyle_1_large = __webpack_require__("vzqh");
var Soundboks3_lifestyle_1_large_default = /*#__PURE__*/__webpack_require__.n(Soundboks3_lifestyle_1_large);

// EXTERNAL MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/assets/Soundboks3-lifestyle-1-small.jpg
var Soundboks3_lifestyle_1_small = __webpack_require__("M0FR");
var Soundboks3_lifestyle_1_small_default = /*#__PURE__*/__webpack_require__.n(Soundboks3_lifestyle_1_small);

// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/styled.ts




var BackgroundImage = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__BackgroundImage",
  componentId: "b4h1fz-0"
})(["display:block;width:100%;height:400px;background-image:url(", ");background-repeat:no-repeat;background-size:cover;background-position:30% 70%;@media ", "{height:852px;padding:20px;background-position:center;background-image:url(", ");}"], Soundboks3_lifestyle_1_large_default.a.url, styles_theme["a" /* default */].breakpoints.tablet, Soundboks3_lifestyle_1_small_default.a.url);
// EXTERNAL MODULE: ./node_modules/@soundboks/elements-typography/index.ts + 9 modules
var elements_typography = __webpack_require__("Bk55");

// EXTERNAL MODULE: ./node_modules/@soundboks/elements-image/index.ts + 7 modules
var elements_image = __webpack_require__("FYf8");

// CONCATENATED MODULE: ./components/elements/product-feature/styled.ts


var VariantWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__VariantWrapper",
  componentId: "sc-14q3rme-0"
})(["display:grid;justify-items:center;padding-left:24px;padding-right:24px;grid-template-columns:1fr 1fr;grid-gap:20px;@media ", "{display:block;}"], styles_theme["a" /* default */].breakpoints.maxMobile);
var styled_ImageWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__ImageWrapper",
  componentId: "sc-14q3rme-1"
})(["grid-column:", ";grid-row:1 / span 2;max-width:525px;@media ", "{position:relative;width:100%;grid-column:none;grid-row:none;picture{height:400px !important;}}"], function (_ref) {
  var gridLayout = _ref.gridLayout;
  return gridLayout === 'right' ? '2 / span 1' : '1 / span 1';
}, styles_theme["a" /* default */].breakpoints.maxMobile);
var HeadlineWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__HeadlineWrapper",
  componentId: "sc-14q3rme-2"
})(["align-self:end;width:100%;max-width:400px;grid-column:", ";@media ", "{display:none;}"], function (_ref2) {
  var gridLayout = _ref2.gridLayout;
  return gridLayout === 'left' ? '2 / span 1' : '1 / span 1';
}, styles_theme["a" /* default */].breakpoints.maxMobile);
var HeadlineImageWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__HeadlineImageWrapper",
  componentId: "sc-14q3rme-3"
})(["display:none;@media ", "{display:block;position:absolute;z-index:1;width:100%;top:50%;left:50%;transform:translate(-50%,-50%);text-align:center;}"], styles_theme["a" /* default */].breakpoints.maxMobile);
var styled_DescriptionWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__DescriptionWrapper",
  componentId: "sc-14q3rme-4"
})(["grid-column:", ";grid-row:2 / span 1;max-width:400px;padding-top:40px;@media ", "{padding-top:24px;grid-column:none;grid-row:none;}"], function (_ref3) {
  var gridLayout = _ref3.gridLayout;
  return gridLayout === 'left' ? '2 / span 1' : '1 / span 1';
}, styles_theme["a" /* default */].breakpoints.maxMobile);
// CONCATENATED MODULE: ./components/elements/product-feature/index.web.tsx
var product_feature_index_web_jsx = react_default.a.createElement;

/* eslint-disable react/jsx-curly-brace-presence */






 // eslint-disable-next-line prefer-arrow-callback

var index_web_ProductFeature = /*#__PURE__*/react_default.a.memo(function ProductFeature(_ref) {
  var features = _ref.features;
  return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, features.map(function (_ref2, index) {
    var title = _ref2.title,
        imgPosition = _ref2.imgPosition,
        uri = _ref2.uri,
        uriRanges = _ref2.uriRanges,
        description = _ref2.description,
        content = _ref2.content;
    return /*#__PURE__*/react_default.a.createElement("div", {
      key: title + index
    }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: {
        "default": '60px',
        desktop: '120px'
      }
    }), /*#__PURE__*/react_default.a.createElement(VariantWrapper, null, /*#__PURE__*/react_default.a.createElement(styled_ImageWrapper, {
      gridLayout: imgPosition
    }, /*#__PURE__*/react_default.a.createElement(HeadlineImageWrapper, null, /*#__PURE__*/react_default.a.createElement(elements_typography["e" /* Heading02 */], {
      color: elements_theme["a" /* Color */].White
    }, title)), /*#__PURE__*/react_default.a.createElement(elements_image["a" /* Image */], {
      uri: uri,
      ranges: uriRanges,
      objectFit: "cover",
      alt: title
    })), /*#__PURE__*/react_default.a.createElement(HeadlineWrapper, {
      gridLayout: imgPosition
    }, /*#__PURE__*/react_default.a.createElement(elements_typography["e" /* Heading02 */], {
      color: elements_theme["a" /* Color */].White
    }, title)), /*#__PURE__*/react_default.a.createElement(styled_DescriptionWrapper, {
      gridLayout: imgPosition
    }, /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], {
      color: elements_theme["a" /* Color */].White
    }, description), /*#__PURE__*/react_default.a.createElement(vstack_VStack, null, content))));
  }));
});
// EXTERNAL MODULE: ./public/static/images/usps/USP_sound_375.png
var USP_sound_375 = __webpack_require__("mPlb");
var USP_sound_375_default = /*#__PURE__*/__webpack_require__.n(USP_sound_375);

// EXTERNAL MODULE: ./public/static/images/usps/USP_portability_375.png
var USP_portability_375 = __webpack_require__("GF5w");
var USP_portability_375_default = /*#__PURE__*/__webpack_require__.n(USP_portability_375);

// EXTERNAL MODULE: ./public/static/images/usps/USP_teamup_375.png
var USP_teamup_375 = __webpack_require__("3e8x");
var USP_teamup_375_default = /*#__PURE__*/__webpack_require__.n(USP_teamup_375);

// EXTERNAL MODULE: ./public/static/images/usps/USP_battery_375.png
var USP_battery_375 = __webpack_require__("AmAZ");
var USP_battery_375_default = /*#__PURE__*/__webpack_require__.n(USP_battery_375);

// EXTERNAL MODULE: ./public/static/images/usps/usp-app.png
var usp_app = __webpack_require__("RX7f");
var usp_app_default = /*#__PURE__*/__webpack_require__.n(usp_app);

// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/product-feature/index.tsx
var product_feature_jsx = react_default.a.createElement;

















var product_feature_ProductFeatureSection = function ProductFeatureSection() {
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref) {
    var i18n = _ref.i18n;
    return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentVertical: "center",
      alignContentHorizontal: "center",
      backgroundColor: elements_theme["a" /* Color */].Charcoal
    }, /*#__PURE__*/react_default.a.createElement(index_web_ProductFeature, {
      features: [{
        uri: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_sound_375_default.a.url),
        uriRanges: {
          phone: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_sound_375_default.a.url, {
            width: 327,
            height: 400
          }),
          tabletLandscape: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_sound_375_default.a.url, {
            width: 525,
            height: 600
          }),
          desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_sound_375_default.a.url, {
            width: 525,
            height: 670
          })
        },
        title: i18n._('product.sb3.feature.title.volume.and.sound'),
        description: i18n._('product.sb3.feature.description.volume.and.sound'),
        imgPosition: 'left'
      }, {
        uri: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_app_default.a.url),
        uriRanges: {
          phone: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_app_default.a.url, {
            width: 397,
            height: 470
          }),
          tabletLandscape: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_app_default.a.url, {
            width: 535,
            height: 610
          }),
          desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_app_default.a.url, {
            width: 525,
            height: 670
          })
        },
        title: i18n._('product.sb3.feature.title.app.and.upgradability'),
        description: /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
          id: "product.sb3.feature.description.app.and.upgradability",
          components: [/*#__PURE__*/react_default.a.createElement(product_feature_LinkWrapper, {
            href: "/app"
          })]
        }),
        content: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
          height: {
            "default": '17px',
            desktop: '60px'
          }
        }), /*#__PURE__*/react_default.a.createElement(Composition["b" /* Layout */], {
          omitPadding: true,
          direction: Composition["d" /* LayoutDirection */].Row,
          alignX: Composition["c" /* LayoutAlignment */].Start,
          alignY: Composition["c" /* LayoutAlignment */].Start
        }, /*#__PURE__*/react_default.a.createElement("a", {
          href: "https://play.google.com/store/apps/details?id=com.soundboks.SOUNDBOKS"
        }, /*#__PURE__*/react_default.a.createElement(atoms_Icon["b" /* default */], {
          height: 40,
          id: atoms_Icon["a" /* IconId */].DownloadGooglaPlay
        })), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
          width: "16px"
        }), /*#__PURE__*/react_default.a.createElement("a", {
          href: "https://apps.apple.com/us/app/soundboks/id1440156667"
        }, /*#__PURE__*/react_default.a.createElement(atoms_Icon["b" /* default */], {
          height: 40,
          id: atoms_Icon["a" /* IconId */].DownloadAppStore
        })))),
        imgPosition: 'right'
      }, {
        uri: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_portability_375_default.a.url),
        uriRanges: {
          phone: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_portability_375_default.a.url, {
            width: 337,
            height: 410
          }),
          tabletLandscape: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_portability_375_default.a.url, {
            width: 555,
            height: 660
          }),
          desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_portability_375_default.a.url, {
            width: 545,
            height: 630
          })
        },
        title: i18n._('product.sb3.feature.title.durability.and.portability'),
        description: i18n._('product.sb3.feature.description.durability.and.portability'),
        imgPosition: 'left'
      }, {
        uri: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_teamup_375_default.a.url),
        uriRanges: {
          phone: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_teamup_375_default.a.url, {
            width: 397,
            height: 470
          }),
          tabletLandscape: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_teamup_375_default.a.url, {
            width: 535,
            height: 610
          }),
          desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_teamup_375_default.a.url, {
            width: 525,
            height: 670
          })
        },
        title: i18n._('product.sb3.feature.title.wireless.and.connection'),
        description: i18n._('product.sb3.feature.description.wireless.and.connection'),
        imgPosition: 'right'
      }, {
        uri: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_battery_375_default.a.url),
        uriRanges: {
          phone: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_battery_375_default.a.url, {
            width: 397,
            height: 470
          }),
          tabletLandscape: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_battery_375_default.a.url, {
            width: 535,
            height: 610
          }),
          desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_battery_375_default.a.url, {
            width: 525,
            height: 670
          })
        },
        title: i18n._('product.sb3.feature.title.battery.and.swappability'),
        description: i18n._('product.sb3.feature.description.battery.and.swappability'),
        imgPosition: 'left'
      }]
    }));
  });
};

var Anchor = styled_components_browser_esm["default"].a.withConfig({
  displayName: "product-feature__Anchor",
  componentId: "sc-3pl2d5-0"
})(["color:#fff;cursor:pointer;text-decoration:underline;"]);

var product_feature_LinkWrapper = function LinkWrapper(_ref2) {
  var href = _ref2.href,
      _ref2$children = _ref2.children,
      children = _ref2$children === void 0 ? undefined : _ref2$children;
  return /*#__PURE__*/react_default.a.createElement(Link["a" /* default */], {
    href: href,
    prefetch: false
  }, /*#__PURE__*/react_default.a.createElement(Anchor, null, children));
};

/* harmony default export */ var product_feature = (product_feature_ProductFeatureSection);
// EXTERNAL MODULE: ./node_modules/@soundboks/elements-hstack/index.ts + 1 modules
var elements_hstack = __webpack_require__("EoX6");

// CONCATENATED MODULE: ./components/elements/color-selector/styled.ts


var styled_VariantWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__VariantWrapper",
  componentId: "ytzbi-0"
})(["display:flex;justify-content:flex-start;align-items:left;margin-right:20px;cursor:", ";opacity:", ";span{text-transform:none;margin:0;}"], function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? 'initial' : 'pointer';
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? 0.3 : 'initial';
});
var VariantButton = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__VariantButton",
  componentId: "ytzbi-1"
})(["width:20px;height:20px;border-radius:50%;background:", "};position:relative;flex-shrink:0;&:after{content:'';width:27px;height:27px;position:absolute;top:-4px;left:-4px;border-radius:50%;background:", ";border:4px solid #343434;display:", ";}"], function (_ref3) {
  var color = _ref3.color;
  return color;
}, function (_ref4) {
  var color = _ref4.color;
  return elements_theme["a" /* Color */][color];
}, function (_ref5) {
  var checked = _ref5.checked;
  return checked ? 'block' : 'none';
});
// CONCATENATED MODULE: ./components/elements/color-selector/index.web.tsx
var color_selector_index_web_jsx = react_default.a.createElement;

/* eslint-disable react/jsx-curly-brace-presence */







// eslint-disable-next-line prefer-arrow-callback
var index_web_ColorSelector = /*#__PURE__*/react_default.a.memo(function ColorSelector(_ref) {
  var label = _ref.label,
      _ref$colors = _ref.colors,
      colors = _ref$colors === void 0 ? [] : _ref$colors,
      selectedColor = _ref.selectedColor,
      onChange = _ref.onChange,
      options = _ref.options;
  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    alignContentHorizontal: "left"
  }, /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], {
    color: elements_theme["a" /* Color */].White
  }, label, " "), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    color: elements_theme["a" /* Color */].Grey
  }, colors.filter(function (color) {
    return selectedColor === color.id;
  }).map(function (color) {
    return "// ".concat(options[color.label]);
  }))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "15px"
  }), /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], null, colors.filter(function (color) {
    return !(color.id === 'Chrome') && !(color.id === 'Pink');
  }).map(function (color) {
    return /*#__PURE__*/react_default.a.createElement(styled_VariantWrapper, {
      title: color.disabled ? "".concat(color.label, " is unavailable") : color.label,
      disabled: color.disabled,
      key: color.id,
      onClick: function onClick() {
        return !color.disabled && onChange(color.id);
      }
    }, /*#__PURE__*/react_default.a.createElement(VariantButton, {
      color: color.value,
      checked: selectedColor === color.id
    }));
  })), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "15px"
  }), /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], null, colors.filter(function (color) {
    return color.id === 'Chrome' || color.id === 'Pink';
  }).map(function (color) {
    return /*#__PURE__*/react_default.a.createElement(styled_VariantWrapper, {
      title: color.disabled ? "".concat(color.label, " is unavailable") : color.label,
      disabled: color.disabled,
      key: color.id,
      onClick: function onClick() {
        return !color.disabled && onChange(color.id);
      }
    }, /*#__PURE__*/react_default.a.createElement(VariantButton, {
      color: color.value,
      checked: selectedColor === color.id
    }));
  })));
});
// CONCATENATED MODULE: ./components/elements/battery-selector/styled.ts


var battery_selector_styled_VariantWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__VariantWrapper",
  componentId: "sc-1lovmvt-0"
})(["display:flex;justify-content:flex-start;align-items:center;cursor:pointer;span{text-transform:none;margin:0;}"]);
var styled_VariantButton = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__VariantButton",
  componentId: "sc-1lovmvt-1"
})(["margin-right:10px;width:20px;height:20px;border-radius:50%;background-color:#343434;position:relative;flex-shrink:0;&:after{content:'';width:100%;height:100%;position:absolute;border-radius:50%;background-color:", ";border:6px solid ", ";display:", ";}"], elements_theme["a" /* Color */].Charcoal, elements_theme["a" /* Color */].White, function (_ref) {
  var checked = _ref.checked;
  return checked ? 'block' : 'none';
});
// CONCATENATED MODULE: ./components/elements/battery-selector/index.web.tsx
var battery_selector_index_web_jsx = react_default.a.createElement;

/* eslint-disable react/jsx-curly-brace-presence */







// eslint-disable-next-line prefer-arrow-callback
var index_web_BatterySelector = /*#__PURE__*/react_default.a.memo(function BatterySelector(_ref) {
  var label = _ref.label,
      answer = _ref.answer,
      extraBattery = _ref.extraBattery,
      onChange = _ref.onChange,
      disabled = _ref.disabled;
  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    style: {
      opacity: disabled ? 0.2 : 1
    }
  }, /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], {
    color: elements_theme["a" /* Color */].White
  }, label)), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "15px"
  }), /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], null, /*#__PURE__*/react_default.a.createElement(battery_selector_styled_VariantWrapper, {
    onClick: function onClick() {
      return onChange(false);
    }
  }, /*#__PURE__*/react_default.a.createElement(styled_VariantButton, {
    checked: extraBattery === false
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    color: elements_theme["a" /* Color */].White
  }, answer.no)), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    width: "40px"
  }), /*#__PURE__*/react_default.a.createElement(battery_selector_styled_VariantWrapper, {
    onClick: function onClick() {
      return onChange(true);
    }
  }, /*#__PURE__*/react_default.a.createElement(styled_VariantButton, {
    checked: extraBattery === true
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    color: elements_theme["a" /* Color */].White
  }, answer.yes))));
});
// CONCATENATED MODULE: ./components/elements/merch-selector/styled.ts


var merch_selector_styled_VariantWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__VariantWrapper",
  componentId: "sc-25oxbo-0"
})(["display:flex;justify-content:flex-start;align-items:left;margin-right:10px;cursor:", ";opacity:", ";span{text-transform:none;margin:0;}"], function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? 'initial' : 'pointer';
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? 0.3 : 'initial';
});
var merch_selector_styled_VariantButton = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__VariantButton",
  componentId: "sc-25oxbo-1"
})(["margin-right:10px;width:20px;height:20px;border-radius:50%;background-color:#343434;position:relative;flex-shrink:0;&:after{content:'';width:100%;height:100%;position:absolute;border-radius:50%;background-color:", ";border:6px solid ", ";display:", ";}"], elements_theme["a" /* Color */].Charcoal, elements_theme["a" /* Color */].White, function (_ref3) {
  var checked = _ref3.checked;
  return checked ? 'block' : 'none';
});
// CONCATENATED MODULE: ./components/elements/merch-selector/index.web.tsx
var merch_selector_index_web_jsx = react_default.a.createElement;

/* eslint-disable react/jsx-curly-brace-presence */







// eslint-disable-next-line prefer-arrow-callback
var index_web_MerchSelector = /*#__PURE__*/react_default.a.memo(function MerchSelector(_ref) {
  var label = _ref.label,
      _ref$availableMerch = _ref.availableMerch,
      availableMerch = _ref$availableMerch === void 0 ? [] : _ref$availableMerch,
      selectedMerch = _ref.selectedMerch,
      onChange = _ref.onChange,
      options = _ref.options;
  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    alignContentHorizontal: "left"
  }, /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], {
    color: elements_theme["a" /* Color */].White
  }, label, " ")), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "15px"
  }), /*#__PURE__*/react_default.a.createElement(vstack_VStack, null, availableMerch.map(function (item) {
    return /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      padding: 5,
      key: item.id
    }, /*#__PURE__*/react_default.a.createElement(merch_selector_styled_VariantWrapper, {
      title: item.disabled ? "".concat(item.label, " is unavailable") : item.label,
      disabled: item.disabled,
      key: item.id,
      onClick: function onClick() {
        return !item.disabled && onChange(item.id);
      }
    }, /*#__PURE__*/react_default.a.createElement(merch_selector_styled_VariantButton, {
      checked: selectedMerch === item.id
    })), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
      color: elements_theme["a" /* Color */].Grey
    }, options[item.label]));
  })));
});
// CONCATENATED MODULE: ./components/elements/buy-btn-services/styled.ts


var styled_Container = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Container",
  componentId: "gdp0w-0"
})(["display:flex;flex-direction:column;align-self:normal;column-gap:5px;row-gap:5px;@media ", "{flex-direction:row;margin:auto;}"], styles_theme["a" /* default */].breakpoints.maxMobile);
// CONCATENATED MODULE: ./components/elements/buy-btn-services/index.web.tsx
var buy_btn_services_index_web_jsx = react_default.a.createElement;

 // eslint-disable-next-line prefer-arrow-callback

var index_web_BuyButtonServices = /*#__PURE__*/react_default.a.memo(function BuyButtonServices(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/react_default.a.createElement(styled_Container, null, children);
});
// CONCATENATED MODULE: ./components/elements/product-usp/styled.ts


var USPWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__USPWrapper",
  componentId: "nrzg8j-0"
})(["width:100%;"]);
var USPContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__USPContainer",
  componentId: "nrzg8j-1"
})(["display:flex;justify-content:space-between;width:100%;grid-gap:16px;@media ", "{max-width:", "px;display:grid;grid-template-columns:1fr 1fr;}"], styles_theme["a" /* default */].breakpoints.maxMobile, function (props) {
  return props.theme.standardMaxWidth.mobile + 200;
});
// CONCATENATED MODULE: ./components/elements/product-usp/index.web.tsx
var product_usp_index_web_jsx = react_default.a.createElement;

/* eslint-disable react/jsx-curly-brace-presence */







 // eslint-disable-next-line prefer-arrow-callback

var index_web_ProductUSP = /*#__PURE__*/react_default.a.memo(function ProductUSP(_ref) {
  var usps = _ref.usps;
  return /*#__PURE__*/react_default.a.createElement(USPWrapper, null, /*#__PURE__*/react_default.a.createElement(USPContainer, null, usps.map(function (usp, index) {
    return /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      key: usp.title + index
    }, /*#__PURE__*/react_default.a.createElement(atoms_Icon["b" /* default */], {
      id: atoms_Icon["a" /* IconId */][usp.icon],
      color: theme["a" /* Color */].White,
      size: theme["d" /* IconSize */].Small
    }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      width: "5px"
    }), /*#__PURE__*/react_default.a.createElement(elements_typography["c" /* Caption01 */], {
      color: elements_theme["a" /* Color */].White,
      style: {
        alignSelf: 'center',
        fontSize: 10
      }
    }, usp.title));
  })));
});
// CONCATENATED MODULE: ./components/elements/horizontal-line/styled.ts


var StyledHorizontalLine = styled_components_browser_esm["default"].hr.withConfig({
  displayName: "styled__StyledHorizontalLine",
  componentId: "sc-3btjkb-0"
})(["display:", ";margin:0 auto;height:", ";border:none;max-width:100%;width:100%;background-color:", ";@media ", "{display:block;}"], function (_ref) {
  var checked = _ref.checked;
  return checked ? 'none' : 'block';
}, function (_ref2) {
  var weight = _ref2.weight;
  return weight || '1px';
}, function (_ref3) {
  var color = _ref3.color;
  return color;
}, styles_theme["a" /* default */].breakpoints.onlyMobile);
// CONCATENATED MODULE: ./components/elements/horizontal-line/index.web.tsx
var horizontal_line_index_web_jsx = react_default.a.createElement;

 // eslint-disable-next-line prefer-arrow-callback

var HorizontalLine = /*#__PURE__*/react_default.a.memo(function (_ref) {
  var color = _ref.color,
      weight = _ref.weight,
      checked = _ref.checked;
  return /*#__PURE__*/react_default.a.createElement(StyledHorizontalLine, {
    color: color,
    weight: weight,
    checked: checked
  });
});
// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/atoms/Skeleton/index.tsx
var Skeleton = __webpack_require__("OWaX");

// CONCATENATED MODULE: ./components/elements/breadcrumbs/styled.ts



var breadcrumbs_styled_Container = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Container",
  componentId: "opebo1-0"
})(["display:flex;"]);
var Path = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Path",
  componentId: "opebo1-1"
})(["flex-grow:1;font-family:GTAmerica-ExtendedBold;font-size:10px;line-height:12px;color:", ";"], elements_theme["a" /* Color */].Grey);
var Rating = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Rating",
  componentId: "opebo1-2"
})(["display:flex;flex-direction:row;width:84px;cursor:pointer;@media ", "{width:105px;padding-right:25px;}"], styles_theme["a" /* default */].breakpoints.onlyTablet);
var Stars = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Stars",
  componentId: "opebo1-3"
})(["position:relative;flex:1;display:flex;"]);
var GrayStars = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__GrayStars",
  componentId: "opebo1-4"
})(["display:flex;height:9px;svg{margin-left:2px;}"]);
var WhiteStars = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__WhiteStars",
  componentId: "opebo1-5"
})(["position:absolute;display:flex;height:9px;svg{margin-left:2px;}"]);
var Votes = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Votes",
  componentId: "opebo1-6"
})(["font-family:GTAmerica-ExtendedBold;font-size:10px;line-height:10px;color:", ";"], elements_theme["a" /* Color */].White);
var styled_Link = styled_components_browser_esm["default"].a.withConfig({
  displayName: "styled__Link",
  componentId: "opebo1-7"
})(["color:", ";cursor:pointer;:hover{text-decoration:none;color:", ";}::after{content:\" // \";color:", ";}"], elements_theme["a" /* Color */].Grey, elements_theme["a" /* Color */].White, elements_theme["a" /* Color */].Grey);
// EXTERNAL MODULE: ./node_modules/react-native-svg/lib/module/index.js
var lib_module = __webpack_require__("nc9g");
var module_default = /*#__PURE__*/__webpack_require__.n(lib_module);

// CONCATENATED MODULE: ./components/elements/breadcrumbs/svg-star.tsx
var svg_star_jsx = react["createElement"];
//
// Move this to sb-components
//



var svg_star_SvgStar = function SvgStar(_ref) {
  var width = _ref.width,
      height = _ref.height,
      fill = _ref.fill,
      clipPath = _ref.clipPath;
  return /*#__PURE__*/react["createElement"](module_default.a, {
    width: width,
    height: height,
    fill: fill,
    clipPath: clipPath,
    viewBox: "0 0 30 30"
  }, /*#__PURE__*/react["createElement"](lib_module["Path"], {
    d: "M16.012.6l3.8,7.677a1.1,1.1,0,0,0,.819.592l8.491,1.232a1.074,1.074,0,0,1,.594,1.836l-6.139,5.971a1.1,1.1,0,0,0-.309.96l1.449,8.436a1.08,1.08,0,0,1-1.567,1.137l-7.6-3.981a1.086,1.086,0,0,0-1.009,0l-7.6,3.981a1.08,1.08,0,0,1-1.567-1.137l1.449-8.436a1.1,1.1,0,0,0-.309-.96L.373,11.942a1.076,1.076,0,0,1,.594-1.836L9.457,8.874a1.088,1.088,0,0,0,.819-.592L14.076.6A1.077,1.077,0,0,1,16.012.6Z"
  }));
};

/* harmony default export */ var svg_star = (svg_star_SvgStar);
// CONCATENATED MODULE: ./components/elements/breadcrumbs/index.web.tsx
var breadcrumbs_index_web_jsx = react_default.a.createElement;




 // eslint-disable-next-line prefer-arrow-callback

var index_web_Breadcrumbs = /*#__PURE__*/react_default.a.memo(function Breadcrumbs(_ref) {
  var paths = _ref.paths,
      _ref$stars = _ref.stars,
      stars = _ref$stars === void 0 ? 0 : _ref$stars,
      offset = _ref.offset,
      anchorStack = _ref.anchorStack;
  var breadcrumb = paths.map(function (path) {
    return path.url ? /*#__PURE__*/react_default.a.createElement(styled_Link, {
      href: path.url,
      key: path.label
    }, path.label) : path.label;
  }); // const votesAsText = votes.toLocaleString();

  var decimals = stars % 1;
  var counting = Math.floor(stars - decimals);
  var clip = (decimals - 1) * -100;
  var grayStars = Array.from({
    length: 5
  }, function (_, index) {
    return /*#__PURE__*/react_default.a.createElement(svg_star, {
      key: index,
      fill: elements_theme["a" /* Color */].CharcoalBrighter
    });
  });
  var whiteStars = Array.from({
    length: counting
  }, function (_, index) {
    return /*#__PURE__*/react_default.a.createElement(svg_star, {
      key: index,
      fill: elements_theme["a" /* Color */].White
    });
  });
  whiteStars.push( /*#__PURE__*/react_default.a.createElement(svg_star, {
    key: whiteStars.length,
    clipPath: "inset(0 ".concat(clip, "% 0 0)"),
    fill: elements_theme["a" /* Color */].White
  }));
  return /*#__PURE__*/react_default.a.createElement(breadcrumbs_styled_Container, null, /*#__PURE__*/react_default.a.createElement(Path, null, breadcrumb), /*#__PURE__*/react_default.a.createElement(Rating, {
    onClick: function onClick() {
      return scrollToAnchor(anchorStack[3].ref.current, offset);
    }
  }, /*#__PURE__*/react_default.a.createElement(Stars, null, /*#__PURE__*/react_default.a.createElement(GrayStars, null, grayStars), /*#__PURE__*/react_default.a.createElement(WhiteStars, null, whiteStars))));
});
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__("i8i4");

// CONCATENATED MODULE: ./components/elements/product-artwork/svg-fullscreen.tsx
var svg_fullscreen_jsx = react["createElement"];
//
// Move this to sb-components
//



var svg_fullscreen_SvgFullScreen = function SvgFullScreen(_ref) {
  var width = _ref.width,
      height = _ref.height,
      fill = _ref.fill;
  return /*#__PURE__*/react["createElement"](module_default.a, {
    width: width,
    height: height,
    fill: fill,
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/react["createElement"](lib_module["G"], {
    fill: fill,
    fillRule: "evenodd"
  }, /*#__PURE__*/react["createElement"](lib_module["Path"], {
    d: "M6.31068 13.0038L6.31068 17.5822L10.8887 17.5818L10.8887 16.2066L7.68627 16.2066L7.68594 13.0038L6.31068 13.0038Z"
  }), /*#__PURE__*/react["createElement"](lib_module["Rect"], {
    x: "6.66431",
    y: "16.2559",
    width: "5.5019",
    height: "1.37547",
    transform: "rotate(-45 6.66431 16.2559)"
  }), /*#__PURE__*/react["createElement"](lib_module["Path"], {
    d: "M17.7164 10.754L17.7164 6.17565L13.1384 6.17597L13.1384 7.55124L16.3408 7.55124L16.3412 10.754L17.7164 10.754Z"
  }), /*#__PURE__*/react["createElement"](lib_module["Rect"], {
    x: "17.3628",
    y: "7.50195",
    width: "5.5019",
    height: "1.37547",
    transform: "rotate(135 17.3628 7.50195)"
  })));
};

/* harmony default export */ var svg_fullscreen = (svg_fullscreen_SvgFullScreen);
// CONCATENATED MODULE: ./components/elements/product-artwork/slider.tsx
var slider_jsx = react_default.a.createElement;





// eslint-disable-next-line prefer-arrow-callback
var Slider = /*#__PURE__*/react_default.a.memo(function Carousel(_ref) {
  var _ref$onMotionEnd = _ref.onMotionEnd,
      onMotionEnd = _ref$onMotionEnd === void 0 ? function () {} : _ref$onMotionEnd,
      children = _ref.children,
      controls = _ref.controls,
      variantTitle = _ref.variantTitle,
      allowImageInteractionTracking = _ref.allowImageInteractionTracking,
      setAllowImageInteractionTracking = _ref.setAllowImageInteractionTracking,
      trackImageInteractionLimit = _ref.trackImageInteractionLimit,
      setTrackImageInteractionLimit = _ref.setTrackImageInteractionLimit;
  var focusIndex = controls.focusIndex,
      setFocusIndex = controls.setFocusIndex,
      jumpToIndex = controls.jumpToIndex,
      lastFocusIndex = controls.lastFocusIndex,
      setLastFocusIndex = controls.setLastFocusIndex;

  var _useState = Object(react["useState"])(false),
      inAction = _useState[0],
      setInAction = _useState[1];

  var _useState2 = Object(react["useState"])(0),
      clientOffsetX = _useState2[0],
      setClientOffsetX = _useState2[1];

  var _useState3 = Object(react["useState"])(0),
      canvasX = _useState3[0],
      setCanvasX = _useState3[1];

  var _useState4 = Object(react["useState"])('none'),
      transition = _useState4[0],
      setTransition = _useState4[1];

  var _useState5 = Object(react["useState"])(0),
      lastClientX = _useState5[0],
      setLastClientX = _useState5[1];

  var _useState6 = Object(react["useState"])(0),
      accelerationClientX = _useState6[0],
      setAccelerationClientX = _useState6[1];

  var _useState7 = Object(react["useState"])(0),
      initialFocus = _useState7[0],
      setInitialFocus = _useState7[1];

  var canvasRef = Object(react["useRef"])(null);

  var handleMouseBegin = function handleMouseBegin(event) {
    if (event.button !== 0) return null;
    event.preventDefault();
    begin(event.clientX);
  };

  var handleTouchBegin = function handleTouchBegin(event) {
    if (canvasX >= -1050) begin(event.touches[0].clientX);
  };

  var begin = function begin(clientX) {
    var canvas = canvasRef.current;
    var computedStyle = window.getComputedStyle(canvas);
    var matrix = new DOMMatrix(computedStyle.getPropertyValue('transform'));
    setTransition('none');
    setLastClientX(clientX);
    setCanvasX(matrix.e);
    setClientOffsetX(clientX - matrix.e);
    setInAction(true);
    setInitialFocus(focusIndex);
  };

  Object(react["useEffect"])(function () {
    var canvas = canvasRef.current;

    if (jumpToIndex > -1 || jumpToIndex < lastFocusIndex + 1) {
      var frame = canvas.parentElement;
      var nextCanvasX = frame.clientWidth * jumpToIndex * -1;
      setCanvasX(nextCanvasX);
      setFocusIndex(jumpToIndex);
    }
  }, [jumpToIndex, lastFocusIndex, setFocusIndex]);
  Object(react["useEffect"])(function () {
    var canvas = canvasRef.current;
    var frame = canvas.parentElement;

    var handleMove = function handleMove(event) {
      if (!inAction) return false;
      if (event.button !== 0) return null;
      event.preventDefault();
      move(event.clientX);
    };

    var handleTouchMove = function handleTouchMove(event) {
      if (!inAction) return false;
      event.preventDefault();
      move(event.touches[0].clientX);
    };

    var move = function move(clientX) {
      var returnZone = frame.clientWidth / 2;
      setLastClientX(clientX);
      setAccelerationClientX(lastClientX - clientX);

      if (canvasX > 0) {
        var value = clientX - clientOffsetX;
        var elasticValue = value - value * 0.8;
        setCanvasX(elasticValue < returnZone ? elasticValue : returnZone);
        setFocusIndex(0);
      } else if (canvasX < (canvas.clientWidth - frame.clientWidth) * -1) {
        var _value = clientX - clientOffsetX;

        var overshot = canvas.clientWidth - frame.clientWidth + _value;
        var maxOvershot = (canvas.clientWidth - returnZone) * -1;

        var _elasticValue = _value - overshot * 0.8;

        setCanvasX(_elasticValue > maxOvershot ? _elasticValue : maxOvershot);
        setFocusIndex(lastFocusIndex);
      } else {
        var _value2 = clientX - clientOffsetX;

        setCanvasX(_value2);
        setFocusIndex(Math.abs(Math.round(_value2 * -1 / frame.clientWidth)));
      }
    };

    var handleMouseEnd = function handleMouseEnd() {
      end();
    };

    var handleTouchEnd = function handleTouchEnd() {
      end();
    };

    var end = function end() {
      if (canvasX > 0) {
        setCanvasX(0);
      } else if (canvasX < (canvas.clientWidth - frame.clientWidth) * -1) {
        setCanvasX((canvas.clientWidth - frame.clientWidth) * -1);
      } else if (accelerationClientX < -6) {
        var subtraction = initialFocus === focusIndex ? 1 : 0;
        var nextFocusIndex = focusIndex > 0 ? focusIndex - subtraction : 0;
        var nextCanvasX = frame.clientWidth * nextFocusIndex * -1;
        setFocusIndex(nextFocusIndex);
        setCanvasX(nextCanvasX);
      } else if (accelerationClientX > 6) {
        var addition = initialFocus === focusIndex ? 1 : 0;

        var _nextFocusIndex = focusIndex < lastFocusIndex ? focusIndex + addition : lastFocusIndex;

        var _nextCanvasX = frame.clientWidth * _nextFocusIndex * -1;

        setFocusIndex(_nextFocusIndex);
        setCanvasX(_nextCanvasX);
      } else {
        var _nextCanvasX2 = frame.clientWidth * focusIndex * -1;

        var returnZone = frame.clientWidth / 2;

        if (canvasX > _nextCanvasX2 + returnZone) {
          setCanvasX(frame.clientWidth * (focusIndex - 1) * -1);
        } else if (canvasX < _nextCanvasX2 - returnZone) {
          setCanvasX(frame.clientWidth * (focusIndex + 1) * -1);
        } else {
          setCanvasX(_nextCanvasX2);
        }
      }

      setInAction(false);
      setTransition('transform 250ms ease-out');
      setAccelerationClientX(0);
    };

    window.addEventListener('mouseup', handleMouseEnd);
    window.addEventListener('touchend', handleTouchEnd);
    window.addEventListener('mousemove', handleMove);
    window.addEventListener('touchmove', handleTouchMove, {
      passive: false
    });
    return function () {
      window.removeEventListener('mouseup', handleMouseEnd);
      window.removeEventListener('touchend', handleTouchEnd);
      window.removeEventListener('mousemove', handleMove);
      window.removeEventListener('touchmove', handleTouchMove);
    };
  }, [canvasX, clientOffsetX, focusIndex, setFocusIndex, inAction, accelerationClientX, lastClientX, lastFocusIndex]);
  Object(react["useEffect"])(function () {
    var canvas = canvasRef.current;
    setLastFocusIndex(canvas.children.length - 1);
  }, [children, setLastFocusIndex]);
  Object(react["useEffect"])(function () {
    var preFocusIndex;

    if (canvasX !== 0 && focusIndex !== preFocusIndex) {
      preFocusIndex = focusIndex;
      if (allowImageInteractionTracking) Object(utils["e" /* trackImageInteraction */])(variantTitle);
      if (trackImageInteractionLimit === 2) Object(utils["f" /* trackImageInteractionMultiple */])(variantTitle);
      setAllowImageInteractionTracking(false);
      setTrackImageInteractionLimit(trackImageInteractionLimit + 1);
    }
  }, [focusIndex]);

  var handleBack = function handleBack() {
    if (inAction || focusIndex === 0) return false;
    var canvas = canvasRef.current;
    var frame = canvas.parentElement;
    var nextFocusIndex = focusIndex - 1;
    var nextCanvasX = frame.clientWidth * nextFocusIndex * -1;
    if (allowImageInteractionTracking) Object(utils["e" /* trackImageInteraction */])(variantTitle);
    if (trackImageInteractionLimit === 2) Object(utils["f" /* trackImageInteractionMultiple */])(variantTitle);
    setAllowImageInteractionTracking(false);
    setTrackImageInteractionLimit(trackImageInteractionLimit + 1);
    setCanvasX(nextCanvasX);
    setFocusIndex(nextFocusIndex);
  };

  var handleForward = function handleForward() {
    var canvas = canvasRef.current;
    if (inAction || focusIndex === lastFocusIndex) return false;
    var frame = canvas.parentElement;
    var nextFocusIndex = focusIndex + 1;
    var nextCanvasX = frame.clientWidth * nextFocusIndex * -1;
    if (allowImageInteractionTracking) Object(utils["e" /* trackImageInteraction */])(variantTitle);
    if (trackImageInteractionLimit === 2) Object(utils["f" /* trackImageInteractionMultiple */])(variantTitle);
    setAllowImageInteractionTracking(false);
    setTrackImageInteractionLimit(trackImageInteractionLimit + 1);
    setCanvasX(nextCanvasX);
    setFocusIndex(nextFocusIndex);
  };

  var handleTransitionEnd = function handleTransitionEnd(event) {
    if (event.target === canvasRef.current) {
      onMotionEnd();
    }
  };

  var isBackArrowInactive = function isBackArrowInactive() {
    return focusIndex === 0;
  };

  var isForwardArrowInactive = function isForwardArrowInactive() {
    var _canvasRef$current;

    return focusIndex === ((_canvasRef$current = canvasRef.current) === null || _canvasRef$current === void 0 ? void 0 : _canvasRef$current.children.length) - 1;
  };

  return /*#__PURE__*/react_default.a.createElement(Frame, null, /*#__PURE__*/react_default.a.createElement(Canvas, {
    ref: canvasRef,
    style: {
      transform: "translateX(".concat(canvasX, "px)"),
      transition: transition
    },
    onMouseDown: handleMouseBegin,
    onTouchStart: handleTouchBegin,
    onTransitionEndCapture: handleTransitionEnd
  }, children), /*#__PURE__*/react_default.a.createElement(BackBtn, {
    onClick: handleBack,
    isInactive: isBackArrowInactive()
  }, /*#__PURE__*/react_default.a.createElement(atoms_Icon["b" /* default */], {
    id: atoms_Icon["a" /* IconId */].Back,
    color: theme["a" /* Color */].WhiteOff,
    size: theme["d" /* IconSize */].Medium
  })), /*#__PURE__*/react_default.a.createElement(ForwardBtn, {
    onClick: handleForward,
    isInactive: isForwardArrowInactive()
  }, /*#__PURE__*/react_default.a.createElement(atoms_Icon["b" /* default */], {
    id: atoms_Icon["a" /* IconId */].Forward,
    color: theme["a" /* Color */].WhiteOff,
    size: theme["d" /* IconSize */].Medium
  })));
});
var Frame = styled_components_browser_esm["default"].div.withConfig({
  displayName: "slider__Frame",
  componentId: "sc-1dyecuf-0"
})(["position:relative;width:100%;height:100%;overflow:hidden;"]);
var Canvas = styled_components_browser_esm["default"].div.withConfig({
  displayName: "slider__Canvas",
  componentId: "sc-1dyecuf-1"
})(["position:absolute;display:flex;"]);
var ArrowsBtn = styled_components_browser_esm["default"].button.withConfig({
  displayName: "slider__ArrowsBtn",
  componentId: "sc-1dyecuf-2"
})(["position:absolute;top:50%;transform:translateY(-50%);display:flex;padding:0;cursor:", ";opacity:", ";"], function (_ref2) {
  var isInactive = _ref2.isInactive;
  return isInactive ? 'default' : 'pointer';
}, function (_ref3) {
  var isInactive = _ref3.isInactive;
  return isInactive ? 0.2 : 1;
});
var BackBtn = Object(styled_components_browser_esm["default"])(ArrowsBtn).withConfig({
  displayName: "slider__BackBtn",
  componentId: "sc-1dyecuf-3"
})(["left:15px;"]);
var ForwardBtn = Object(styled_components_browser_esm["default"])(ArrowsBtn).withConfig({
  displayName: "slider__ForwardBtn",
  componentId: "sc-1dyecuf-4"
})(["right:15px;"]);
// CONCATENATED MODULE: ./components/elements/product-artwork/use-controls.tsx

function useControls() {
  var initial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var _useState = Object(react["useState"])(initial),
      focusIndex = _useState[0],
      setFocusIndex = _useState[1];

  var _useState2 = Object(react["useState"])(),
      lastFocusIndex = _useState2[0],
      setLastFocusIndex = _useState2[1];

  var _useState3 = Object(react["useState"])(),
      jumpToIndex = _useState3[0],
      setJumpToIndex = _useState3[1];

  Object(react["useEffect"])(function () {
    setJumpToIndex(initial);
  }, [initial]);
  return {
    focusIndex: focusIndex,
    setFocusIndex: setFocusIndex,
    jumpToIndex: jumpToIndex,
    setJumpToIndex: setJumpToIndex,
    lastFocusIndex: lastFocusIndex,
    setLastFocusIndex: setLastFocusIndex
  };
}
// CONCATENATED MODULE: ./components/elements/product-artwork/styled.ts


var product_artwork_styled_Container = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Container",
  componentId: "ksyrp1-0"
})(["display:flex;z-index:-2;@media ", "{flex-direction:column-reverse;align-items:center;}"], styles_theme["a" /* default */].breakpoints.maxMobile);
var Thumbnails = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Thumbnails",
  componentId: "ksyrp1-1"
})(["width:100px;@media ", "{flex-direction:row;display:flex;width:100%;margin-top:20px;justify-content:center;}"], styles_theme["a" /* default */].breakpoints.maxMobile);
var Thumbnail = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Thumbnail",
  componentId: "ksyrp1-2"
})(["width:100px;height:100px;background-color:", ";transition:background-color 200ms ease-in-out;border-radius:1px;cursor:pointer;@media ", "{width:50px;height:50px;}"], function (_ref) {
  var isSelected = _ref.isSelected;
  return isSelected ? "".concat(styles_theme["a" /* default */].colors.grey1) : null;
}, styles_theme["a" /* default */].breakpoints.maxMobile);
var ThumbnailImage = styled_components_browser_esm["default"].img.withConfig({
  displayName: "styled__ThumbnailImage",
  componentId: "ksyrp1-3"
})(["width:100%;"]);
var Primary = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Primary",
  componentId: "ksyrp1-4"
})(["position:relative;width:280px;height:280px;overflow:hidden;@media ", "{width:350px;height:350px;}@media ", "{width:350px;height:350px;}@media ", "{width:", ";height:", ";}"], styles_theme["a" /* default */].breakpoints.mobile, styles_theme["a" /* default */].breakpoints.tablet, styles_theme["a" /* default */].breakpoints.desktop, function (_ref2) {
  var fullViewport = _ref2.fullViewport;
  return fullViewport ? '600px' : '450px';
}, function (_ref3) {
  var fullViewport = _ref3.fullViewport;
  return fullViewport ? '600px' : '450px';
});
var PrimarySlide = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__PrimarySlide",
  componentId: "ksyrp1-5"
})(["display:flex;justify-content:center;align-items:center;width:280px;height:280px;@media ", "{width:350px;height:350px;}@media ", "{width:350px;height:350px;}@media ", "{width:", ";height:", ";}"], styles_theme["a" /* default */].breakpoints.mobile, styles_theme["a" /* default */].breakpoints.tablet, styles_theme["a" /* default */].breakpoints.desktop, function (_ref4) {
  var fullViewport = _ref4.fullViewport;
  return fullViewport ? '600px' : '450px';
}, function (_ref5) {
  var fullViewport = _ref5.fullViewport;
  return fullViewport ? '600px' : '450px';
});
var PrimaryImage = styled_components_browser_esm["default"].img.withConfig({
  displayName: "styled__PrimaryImage",
  componentId: "ksyrp1-6"
})(["display:block;width:100%;"]);
var FullViewport = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__FullViewport",
  componentId: "ksyrp1-7"
})(["position:fixed;z-index:3;display:flex;justify-content:center;align-items:center;top:0;left:0;width:100%;height:100%;background-color:", ";"], styles_theme["a" /* default */].colors.black);
var FullViewportBtn = styled_components_browser_esm["default"].button.withConfig({
  displayName: "styled__FullViewportBtn",
  componentId: "ksyrp1-8"
})(["position:absolute;right:15px;bottom:0;background-color:", ";display:flex;justify-content:center;align-items:center;padding:0;border-radius:1px;cursor:pointer;"], styles_theme["a" /* default */].colors.grey1);
var CloseBtn = styled_components_browser_esm["default"].button.withConfig({
  displayName: "styled__CloseBtn",
  componentId: "ksyrp1-9"
})(["position:absolute;top:15px;right:15px;cursor:pointer;"]);
// CONCATENATED MODULE: ./components/elements/product-artwork/artwork-group.tsx
var artwork_group_jsx = react_default.a.createElement;

/* eslint-disable react/style-prop-object */






 // eslint-disable-next-line prefer-arrow-callback

var artwork_group_ArtworkGroup = function ArtworkGroup(_ref) {
  var _ref$artworks = _ref.artworks,
      artworks = _ref$artworks === void 0 ? [] : _ref$artworks,
      variantTitle = _ref.variantTitle,
      allowImageInteractionTracking = _ref.allowImageInteractionTracking,
      setAllowImageInteractionTracking = _ref.setAllowImageInteractionTracking,
      trackImageInteractionLimit = _ref.trackImageInteractionLimit,
      setTrackImageInteractionLimit = _ref.setTrackImageInteractionLimit,
      _ref$initialIndex = _ref.initialIndex,
      initialIndex = _ref$initialIndex === void 0 ? 0 : _ref$initialIndex,
      fullViewport = _ref.fullViewport,
      _ref$onFullViewport = _ref.onFullViewport,
      onFullViewport = _ref$onFullViewport === void 0 ? function () {} : _ref$onFullViewport;
  var controls = useControls(initialIndex);
  var focusIndex = controls.focusIndex,
      setJumpToIndex = controls.setJumpToIndex;

  var handleFullViewPort = function handleFullViewPort() {
    onFullViewport(focusIndex);
  };

  return /*#__PURE__*/react_default.a.createElement(product_artwork_styled_Container, null, /*#__PURE__*/react_default.a.createElement(Thumbnails, null, artworks.map(function (artwork, index) {
    return /*#__PURE__*/react_default.a.createElement(Thumbnail, {
      key: artwork.id,
      isSelected: index === focusIndex,
      onClick: function onClick() {
        setJumpToIndex(index);
        if (allowImageInteractionTracking) Object(utils["e" /* trackImageInteraction */])(variantTitle);
        if (trackImageInteractionLimit === 2) Object(utils["f" /* trackImageInteractionMultiple */])(variantTitle);
        setAllowImageInteractionTracking(false);
        setTrackImageInteractionLimit(trackImageInteractionLimit + 1);
      }
    }, /*#__PURE__*/react_default.a.createElement(ThumbnailImage, {
      src: artwork.thumbnail
    }));
  })), /*#__PURE__*/react_default.a.createElement(Primary, {
    fullViewport: fullViewport
  }, /*#__PURE__*/react_default.a.createElement(Slider, {
    controls: controls,
    variantTitle: variantTitle,
    allowImageInteractionTracking: allowImageInteractionTracking,
    setAllowImageInteractionTracking: setAllowImageInteractionTracking,
    trackImageInteractionLimit: trackImageInteractionLimit,
    setTrackImageInteractionLimit: setTrackImageInteractionLimit
  }, artworks.map(function (artwork) {
    return /*#__PURE__*/react_default.a.createElement(PrimarySlide, {
      key: artwork.id,
      fullViewport: fullViewport
    }, /*#__PURE__*/react_default.a.createElement(PrimaryImage, {
      src: artwork.primary
    }));
  })), !fullViewport && /*#__PURE__*/react_default.a.createElement(FullViewportBtn, {
    onClick: function onClick() {
      handleFullViewPort();
      if (allowImageInteractionTracking) Object(utils["e" /* trackImageInteraction */])(variantTitle);
      if (trackImageInteractionLimit === 2) Object(utils["f" /* trackImageInteractionMultiple */])(variantTitle);
      setAllowImageInteractionTracking(false);
      setTrackImageInteractionLimit(trackImageInteractionLimit + 1);
    }
  }, /*#__PURE__*/react_default.a.createElement(svg_fullscreen, {
    fill: theme["a" /* Color */].WhiteOff,
    height: theme["d" /* IconSize */].Medium,
    width: theme["d" /* IconSize */].Medium
  }))));
};
// CONCATENATED MODULE: ./components/elements/product-artwork/use-portal.tsx

function usePortal() {
  var initial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var _useState = Object(react["useState"])(),
      portalElement = _useState[0],
      setPortalElement = _useState[1];

  var _useState2 = Object(react["useState"])(initial),
      portalIndex = _useState2[0],
      setPortalIndex = _useState2[1];

  var _useState3 = Object(react["useState"])(false),
      fullViewport = _useState3[0],
      setFullViewport = _useState3[1];

  Object(react["useEffect"])(function () {
    setPortalElement(document.getElementById('modal-root'));
  }, []);
  Object(react["useEffect"])(function () {
    document.body.style.setProperty('overflow', fullViewport ? 'hidden' : 'auto');
  }, [fullViewport]);
  return {
    portalElement: portalElement,
    portalIndex: portalIndex,
    setPortalIndex: setPortalIndex,
    fullViewport: fullViewport,
    setFullViewport: setFullViewport
  };
}
// CONCATENATED MODULE: ./components/elements/product-artwork/index.web.tsx
var product_artwork_index_web_jsx = react_default.a.createElement;






 // eslint-disable-next-line prefer-arrow-callback

var index_web_ProductArtwork = /*#__PURE__*/react_default.a.memo(function ProductArtwork(_ref) {
  var _ref$artworks = _ref.artworks,
      artworks = _ref$artworks === void 0 ? [] : _ref$artworks,
      variantTitle = _ref.variantTitle,
      productHandle = _ref.productHandle,
      allowImageInteractionTracking = _ref.allowImageInteractionTracking,
      setAllowImageInteractionTracking = _ref.setAllowImageInteractionTracking,
      trackImageInteractionLimit = _ref.trackImageInteractionLimit,
      setTrackImageInteractionLimit = _ref.setTrackImageInteractionLimit,
      initialId = _ref.initialId;
  var initialIndex = initialId ? artworks.findIndex(function (artwork) {
    return artwork.id === initialId;
  }) : 0;

  var _usePortal = usePortal(initialIndex),
      portalElement = _usePortal.portalElement,
      portalIndex = _usePortal.portalIndex,
      setPortalIndex = _usePortal.setPortalIndex,
      fullViewport = _usePortal.fullViewport,
      setFullViewport = _usePortal.setFullViewport;

  var handleOpenFullViewport = function handleOpenFullViewport(index) {
    setPortalIndex(index);
    setFullViewport(true);
  };

  var handleCloseFullViewport = function handleCloseFullViewport() {
    setFullViewport(false);
  };

  var artworkGroup = /*#__PURE__*/react_default.a.createElement(artwork_group_ArtworkGroup, {
    artworks: artworks,
    variantTitle: variantTitle,
    productHandle: productHandle,
    allowImageInteractionTracking: allowImageInteractionTracking,
    setAllowImageInteractionTracking: setAllowImageInteractionTracking,
    trackImageInteractionLimit: trackImageInteractionLimit,
    setTrackImageInteractionLimit: setTrackImageInteractionLimit,
    initialIndex: initialIndex,
    onFullViewport: handleOpenFullViewport
  });
  return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, artworkGroup, fullViewport && /*#__PURE__*/Object(react_dom["createPortal"])( /*#__PURE__*/react_default.a.createElement(FullViewport, null, /*#__PURE__*/Object(react["cloneElement"])(artworkGroup, {
    initialIndex: portalIndex,
    fullViewport: fullViewport
  }), /*#__PURE__*/react_default.a.createElement(CloseBtn, {
    onClick: handleCloseFullViewport
  }, /*#__PURE__*/react_default.a.createElement(atoms_Icon["b" /* default */], {
    id: atoms_Icon["a" /* IconId */].X,
    color: theme["a" /* Color */].WhiteOff,
    size: theme["d" /* IconSize */].Medium
  }))), portalElement));
});
// CONCATENATED MODULE: ./components/elements/price-format/index.web.tsx
var price_format_index_web_jsx = react_default.a.createElement;


var index_web_formatPrice = function formatPrice(locale, currency, price) {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency
  }).format(price);
};
var PriceFormat = /*#__PURE__*/react_default.a.memo(function (_ref) {
  var price = _ref.price,
      currency = _ref.currency,
      locale = _ref.locale,
      className = _ref.className;
  return /*#__PURE__*/react_default.a.createElement(PriceWrapper, {
    className: className
  }, /*#__PURE__*/react_default.a.createElement(index_web_Price, null, index_web_formatPrice(locale, currency, price)));
});
var PriceWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "indexweb__PriceWrapper",
  componentId: "sc-1mi9iq9-0"
})(["display:flex;"]);
var index_web_Price = styled_components_browser_esm["default"].div.withConfig({
  displayName: "indexweb__Price",
  componentId: "sc-1mi9iq9-1"
})(["margin-right:2px;"]);
// CONCATENATED MODULE: ./components/elements/product-tag/styled.ts



var styled_TagWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__TagWrapper",
  componentId: "sc-1r7clqf-0"
})(["background:", ";font-family:", ";color:", ";font-weight:700;font-size:10px;line-height:12px;padding:4px 8px;margin:12px 4px 0px;@media ", "{margin:10px 4px;}"], function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor || styles_theme["a" /* default */].colors.white;
}, elements_theme["b" /* FontFamily */].GTAmericaExtendedBold, function (_ref2) {
  var foregroundColor = _ref2.foregroundColor;
  return foregroundColor || styles_theme["a" /* default */].colors.black;
}, styles_theme["a" /* default */].breakpoints.maxTablet);
// CONCATENATED MODULE: ./components/elements/product-tag/index.web.tsx
var product_tag_index_web_jsx = react_default.a.createElement;


/* eslint-disable react/jsx-curly-brace-presence */


 // eslint-disable-next-line prefer-arrow-callback

var index_web_ProductTag = /*#__PURE__*/react_default.a.memo(function ProductTag(_ref) {
  var content = _ref.content,
      backgroundColor = _ref.backgroundColor,
      foregroundColor = _ref.foregroundColor,
      specialEdition = _ref.specialEdition;
  return /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], null, /*#__PURE__*/react_default.a.createElement(styled_TagWrapper, {
    backgroundColor: backgroundColor,
    foregroundColor: foregroundColor,
    specialEdition: specialEdition
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: content
  })));
});
// CONCATENATED MODULE: ./components/elements/headline-price/index.web.tsx
var headline_price_index_web_jsx = react_default.a.createElement;









var HeadlinePrice = /*#__PURE__*/react_default.a.memo(function (_ref) {
  var headline = _ref.headline,
      subheadline = _ref.subheadline,
      price = _ref.price,
      compareAtPrice = _ref.compareAtPrice,
      discount = _ref.discount,
      currency = _ref.currency,
      locale = _ref.locale,
      handle = _ref.handle,
      selectedColor = _ref.selectedColor;

  var _checkProduct = Object(checkProduct["a" /* checkProduct */])(handle),
      isSoundboksGen3 = _checkProduct.isSoundboksGen3;

  var specialEditionColors = selectedColor === 'Pink' || selectedColor === 'Chrome';
  return /*#__PURE__*/react_default.a.createElement(StyledHeadlinePrice, null, /*#__PURE__*/react_default.a.createElement(StyledHeadline, {
    subheadline: subheadline
  }, headline), subheadline && /*#__PURE__*/react_default.a.createElement(StyledSubheadline, null, subheadline), /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], null, isSoundboksGen3 && specialEditionColors && /*#__PURE__*/react_default.a.createElement(index_web_ProductTag, {
    content: "Limited edition",
    backgroundColor: "linear-gradient(90deg, #E678A0 1.1%, rgba(231, 220, 217, 0) 136.26%, rgba(230, 120, 160, 0.0578647) 136.26%)",
    foregroundColor: "#FFF"
  })), price ? /*#__PURE__*/react_default.a.createElement(StyledPrice, null, discount && /*#__PURE__*/react_default.a.createElement(StyledPriceFormat, {
    price: compareAtPrice,
    currency: currency,
    locale: locale
  }), /*#__PURE__*/react_default.a.createElement(PriceFormat, {
    price: price,
    currency: currency,
    locale: locale
  })) : /*#__PURE__*/react_default.a.createElement(Skeleton["a" /* Skeleton */], {
    width: theme["j" /* Size */].BaseUnit * 20,
    height: theme["j" /* Size */].BaseUnit * 2
  }));
});
var StyledHeadlinePrice = styled_components_browser_esm["default"].div.withConfig({
  displayName: "indexweb__StyledHeadlinePrice",
  componentId: "sc-119jgr8-0"
})(["display:flex;flex-direction:column;justify-content:space-between;align-items:start;max-width:100%;width:100%;@media ", "{display:grid;align-items:center;grid-template-areas:'a b' 'c d';}"], styles_theme["a" /* default */].breakpoints.onlyMobile);
var StyledHeadline = styled_components_browser_esm["default"].div.withConfig({
  displayName: "indexweb__StyledHeadline",
  componentId: "sc-119jgr8-1"
})(["font-size:24px;line-height:28px;color:", ";font-family:", ";@media ", "{margin-bottom:4px;}@media ", "{grid-area:a;font-size:14px;line-height:16px;}"], styles_theme["a" /* default */].colors.white, styles_theme["a" /* default */].fonts.extended, styles_theme["a" /* default */].breakpoints.tablet, styles_theme["a" /* default */].breakpoints.onlyMobile);
var StyledPrice = styled_components_browser_esm["default"].div.withConfig({
  displayName: "indexweb__StyledPrice",
  componentId: "sc-119jgr8-2"
})(["font-size:14px;line-height:12px;color:", ";display:flex;flex-direction:row;justify-content:space-between;font-family:", ";margin-top:33px;@media ", "{grid-area:b;flex-direction:column;font-size:12px;line-height:12px;margin-top:0px;}"], styles_theme["a" /* default */].colors.white, styles_theme["a" /* default */].fonts.extended, styles_theme["a" /* default */].breakpoints.onlyMobile);
var StyledPriceFormat = Object(styled_components_browser_esm["default"])(PriceFormat).withConfig({
  displayName: "indexweb__StyledPriceFormat",
  componentId: "sc-119jgr8-3"
})(["text-decoration:line-through;text-decoration-color:", ";text-decoration-thickness:2px;@media ", "{margin-right:10px;}"], styles_theme["a" /* default */].colors.primary, styles_theme["a" /* default */].breakpoints.tablet);
var StyledSubheadline = styled_components_browser_esm["default"].div.withConfig({
  displayName: "indexweb__StyledSubheadline",
  componentId: "sc-119jgr8-4"
})(["font-size:14px;line-height:16px;font-family:", ";color:", ";@media ", "{margin-bottom:20px;}@media ", "{grid-area:c;font-size:14px;line-height:16px;margin-top:5px;}"], styles_theme["a" /* default */].fonts.regular, styles_theme["a" /* default */].colors.grey, styles_theme["a" /* default */].breakpoints.tablet, styles_theme["a" /* default */].breakpoints.onlyMobile);
// CONCATENATED MODULE: ./components/elements/product-overview/styled.ts


var product_overview_styled_Container = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Container",
  componentId: "y2h0i2-0"
})(["display:flex;color:#fff;max-width:1065px;@media ", "{flex-direction:column;align-items:stretch;width:100%;}"], styles_theme["a" /* default */].breakpoints.maxMobile);
var StyledHeadlinePriceDesktop = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__StyledHeadlinePriceDesktop",
  componentId: "y2h0i2-1"
})(["@media ", "{display:none;}"], styles_theme["a" /* default */].breakpoints.onlyMobile);
var StyledHeadlinePriceMobile = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__StyledHeadlinePriceMobile",
  componentId: "y2h0i2-2"
})(["@media ", "{display:none;}"], styles_theme["a" /* default */].breakpoints.tablet);
var StyledWrapperHorizontalLine = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__StyledWrapperHorizontalLine",
  componentId: "y2h0i2-3"
})(["@media ", "{display:none;}"], styles_theme["a" /* default */].breakpoints.onlyMobile);
var StyledButtonRef = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__StyledButtonRef",
  componentId: "y2h0i2-4"
})(["width:240px;@media ", "{margin:auto;}"], styles_theme["a" /* default */].breakpoints.onlyMobile);
// CONCATENATED MODULE: ./components/elements/condition-selector/styled.ts


var condition_selector_styled_VariantWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__VariantWrapper",
  componentId: "sc-14wsud2-0"
})(["display:flex;justify-content:flex-start;align-items:center;cursor:pointer;span{text-transform:none;margin:0;}"]);
var condition_selector_styled_VariantButton = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__VariantButton",
  componentId: "sc-14wsud2-1"
})(["margin-right:10px;width:20px;height:20px;border-radius:50%;background-color:#343434;position:relative;flex-shrink:0;&:after{content:'';width:100%;height:100%;position:absolute;border-radius:50%;background-color:", ";border:6px solid ", ";display:", ";}"], elements_theme["a" /* Color */].Charcoal, elements_theme["a" /* Color */].White, function (_ref) {
  var checked = _ref.checked;
  return checked ? 'block' : 'none';
});
// CONCATENATED MODULE: ./components/elements/condition-selector/index.web.tsx
var condition_selector_index_web_jsx = react_default.a.createElement;

/* eslint-disable react/jsx-curly-brace-presence */







// eslint-disable-next-line prefer-arrow-callback
var index_web_ConditionSelector = /*#__PURE__*/react_default.a.memo(function ConditionSelector(_ref) {
  var label = _ref.label,
      selectedCondition = _ref.selectedCondition,
      onChange = _ref.onChange,
      answer = _ref.answer;
  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, null, /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], {
    color: elements_theme["a" /* Color */].White
  }, label)), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "15px"
  }), /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], null, /*#__PURE__*/react_default.a.createElement(condition_selector_styled_VariantWrapper, {
    onClick: function onClick() {
      return onChange('Good');
    }
  }, /*#__PURE__*/react_default.a.createElement(condition_selector_styled_VariantButton, {
    checked: selectedCondition === 'Good'
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    color: elements_theme["a" /* Color */].White
  }, answer.good)), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    width: "40px"
  }), /*#__PURE__*/react_default.a.createElement(condition_selector_styled_VariantWrapper, {
    onClick: function onClick() {
      return onChange('Very good');
    }
  }, /*#__PURE__*/react_default.a.createElement(condition_selector_styled_VariantButton, {
    checked: selectedCondition === 'Very good'
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    color: elements_theme["a" /* Color */].White
  }, answer.veryGood))));
});
// CONCATENATED MODULE: ./components/elements/product-overview/index.web.tsx
var product_overview_index_web_jsx = react_default.a.createElement;







 // !BATTERY SELECTOR REMOVED TILL WE START SELLING THEM AGAIN








 // import ProductSticker from 'components/shared/product-sticker-v2';








 // eslint-disable-next-line prefer-arrow-callback

var index_web_ProductOverview = /*#__PURE__*/react_default.a.memo(function ProductOverview(_ref) {
  var productData = _ref.productData,
      labels = _ref.labels,
      paths = _ref.paths,
      offset = _ref.offset,
      anchorStack = _ref.anchorStack,
      onHeaderVisibility = _ref.onHeaderVisibility,
      productVariant = _ref.productVariant,
      avalibleColors = _ref.avalibleColors,
      selectedColor = _ref.selectedColor,
      availableMerch = _ref.availableMerch,
      selectedMerch = _ref.selectedMerch,
      selectedCondition = _ref.selectedCondition,
      handleConditionSelector = _ref.handleConditionSelector,
      handleColorSelector = _ref.handleColorSelector,
      handleMerchSelector = _ref.handleMerchSelector,
      extraBattery = _ref.extraBattery,
      addCarrierStrap = _ref.addCarrierStrap,
      handleBatterySelector = _ref.handleBatterySelector,
      handleCarrierStrapSelector = _ref.handleCarrierStrapSelector,
      disableExtraBattery = _ref.disableExtraBattery,
      handleAddToCart = _ref.handleAddToCart,
      financialServices = _ref.financialServices,
      allowImageInteractionTracking = _ref.allowImageInteractionTracking,
      setAllowImageInteractionTracking = _ref.setAllowImageInteractionTracking,
      trackImageInteractionLimit = _ref.trackImageInteractionLimit,
      setTrackImageInteractionLimit = _ref.setTrackImageInteractionLimit;

  var _checkProduct = Object(checkProduct["a" /* checkProduct */])(productData.handle),
      isSoundboksGen3 = _checkProduct.isSoundboksGen3,
      isJagermeister = _checkProduct.isJagermeister,
      isSoundboksGo = _checkProduct.isSoundboksGo,
      isSB3Refurbished = _checkProduct.isSB3Refurbished;

  var _useCheckRegion = Object(useCheckRegion["a" /* default */])(),
      isDK = _useCheckRegion.isDK,
      isNO = _useCheckRegion.isNO;

  var usps = [{
    icon: 'Warranty',
    title: labels.usp.warranty
  }, {
    icon: 'Transfer',
    title: labels.usp.freeReturns
  }, {
    icon: 'Truck',
    title: labels.usp.freeShipping
  }, {
    icon: 'Help',
    title: labels.usp.premiumSupport
  }, {
    icon: 'PhoneCheckmark',
    title: labels.usp.compatibility
  }];
  var buyButtonRef = Object(react["useCallback"])(function (element) {
    if (element !== null) {
      var handleScroll = function handleScroll() {
        return onHeaderVisibility(element.getBoundingClientRect().y - 58 < 0);
      };

      window.addEventListener('scroll', handleScroll, {
        passive: true
      });
      return function () {
        return window.removeEventListener('scroll', handleScroll);
      };
    }
  }, [onHeaderVisibility]);

  var availableAccessories = function availableAccessories() {
    switch (selectedColor) {
      case 'Black':
        return availableMerch.filter(function (item) {
          return !(item.id === 'Black grill');
        });

      case 'Orange':
        return availableMerch.filter(function (item) {
          return !(item.id === 'Orange grill');
        });

      case 'White':
        return availableMerch.filter(function (item) {
          return !(item.id === 'White grill');
        });

      default:
        return availableMerch;
    }
  };

  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, null, /*#__PURE__*/react_default.a.createElement(product_overview_styled_Container, null, /*#__PURE__*/react_default.a.createElement(vstack_VStack, null, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '10px',
      mobile: '0px'
    }
  }), /*#__PURE__*/react_default.a.createElement(index_web_Breadcrumbs, {
    paths: paths,
    stars: productData.ratingAverage,
    votes: productData.ratingCount,
    offset: offset,
    anchorStack: anchorStack
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '20px',
      desktop: '35px'
    }
  }), /*#__PURE__*/react_default.a.createElement(StyledHeadlinePriceMobile, null, /*#__PURE__*/react_default.a.createElement(HeadlinePrice, {
    compareAtPrice: productVariant === null || productVariant === void 0 ? void 0 : productVariant.compareAtPrice,
    handle: productData.handle,
    headline: productData.title,
    price: productVariant === null || productVariant === void 0 ? void 0 : productVariant.price,
    discount: productVariant === null || productVariant === void 0 ? void 0 : productVariant.discount,
    currency: productVariant === null || productVariant === void 0 ? void 0 : productVariant.currency,
    locale: productData.locale,
    selectedColor: selectedColor
  })), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '20px',
      desktop: '0px'
    }
  }), /*#__PURE__*/react_default.a.createElement(index_web_ProductArtwork, {
    artworks: productVariant === null || productVariant === void 0 ? void 0 : productVariant.artworks,
    variantTitle: productVariant === null || productVariant === void 0 ? void 0 : productVariant.title,
    productHandle: productData.handle,
    allowImageInteractionTracking: allowImageInteractionTracking,
    setAllowImageInteractionTracking: setAllowImageInteractionTracking,
    trackImageInteractionLimit: trackImageInteractionLimit,
    setTrackImageInteractionLimit: setTrackImageInteractionLimit
  })), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    width: {
      "default": '0px',
      desktop: '200px',
      desktopLarge: '300px'
    }
  }), /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    grow: 1
  }, /*#__PURE__*/react_default.a.createElement(StyledHeadlinePriceDesktop, null, /*#__PURE__*/react_default.a.createElement(HeadlinePrice, {
    compareAtPrice: productVariant === null || productVariant === void 0 ? void 0 : productVariant.compareAtPrice,
    handle: productData.handle,
    headline: productData.title,
    price: productVariant === null || productVariant === void 0 ? void 0 : productVariant.price,
    discount: productVariant === null || productVariant === void 0 ? void 0 : productVariant.discount,
    currency: productVariant === null || productVariant === void 0 ? void 0 : productVariant.currency,
    locale: productData.locale,
    selectedColor: selectedColor
  })), labels.grillColor && productVariant ? /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "37px"
  }), /*#__PURE__*/react_default.a.createElement(index_web_ColorSelector, {
    label: labels.grillColor.label,
    options: labels.grillColor.options,
    colors: avalibleColors,
    selectedColor: selectedColor,
    onChange: handleColorSelector
  })) : labels.grillColor && /*#__PURE__*/react_default.a.createElement(vstack_VStack, null, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "37px"
  }), /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], null, /*#__PURE__*/react_default.a.createElement(Skeleton["a" /* Skeleton */], {
    width: theme["j" /* Size */].BaseUnit * 3,
    height: theme["j" /* Size */].BaseUnit * 3,
    radius: "50%"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    width: "20px"
  }), /*#__PURE__*/react_default.a.createElement(Skeleton["a" /* Skeleton */], {
    width: theme["j" /* Size */].BaseUnit * 3,
    height: theme["j" /* Size */].BaseUnit * 3,
    radius: "50%"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    width: "20px"
  }), /*#__PURE__*/react_default.a.createElement(Skeleton["a" /* Skeleton */], {
    width: theme["j" /* Size */].BaseUnit * 3,
    height: theme["j" /* Size */].BaseUnit * 3,
    radius: "50%"
  }))), labels.condition && productVariant ? /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "37px"
  }), /*#__PURE__*/react_default.a.createElement(index_web_ConditionSelector, {
    label: labels.condition.label,
    onChange: handleConditionSelector,
    selectedCondition: selectedCondition,
    answer: {
      good: labels.condition.options.Good,
      veryGood: labels.condition.options.VeryGood
    }
  })) : labels.grillColor && isSB3Refurbished && /*#__PURE__*/react_default.a.createElement(vstack_VStack, null, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "37px"
  }), /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], null, /*#__PURE__*/react_default.a.createElement(Skeleton["a" /* Skeleton */], {
    width: theme["j" /* Size */].BaseUnit * 3,
    height: theme["j" /* Size */].BaseUnit * 3,
    radius: "50%"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    width: "20px"
  }), /*#__PURE__*/react_default.a.createElement(Skeleton["a" /* Skeleton */], {
    width: theme["j" /* Size */].BaseUnit * 3,
    height: theme["j" /* Size */].BaseUnit * 3,
    radius: "50%"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    width: "20px"
  }), /*#__PURE__*/react_default.a.createElement(Skeleton["a" /* Skeleton */], {
    width: theme["j" /* Size */].BaseUnit * 3,
    height: theme["j" /* Size */].BaseUnit * 3,
    radius: "50%"
  }))), (isSoundboksGen3 || isSoundboksGo) && labels.extraBattery && productVariant && /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "40px"
  }), /*#__PURE__*/react_default.a.createElement(index_web_BatterySelector, {
    label: labels.extraBattery.label,
    answer: {
      yes: labels.extraBattery.options.yes,
      no: labels.extraBattery.options.no
    },
    extraBattery: extraBattery,
    onChange: handleBatterySelector,
    disabled: disableExtraBattery
  })), labels.merch && productVariant ? /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "37px"
  }), /*#__PURE__*/react_default.a.createElement(index_web_MerchSelector, {
    label: labels.merch.label,
    options: labels.merch.options,
    availableMerch: availableAccessories(),
    selectedMerch: selectedMerch,
    onChange: handleMerchSelector
  })) : labels.merch && /*#__PURE__*/react_default.a.createElement(vstack_VStack, null, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "37px"
  }), /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], null, /*#__PURE__*/react_default.a.createElement(Skeleton["a" /* Skeleton */], {
    width: theme["j" /* Size */].BaseUnit * 3,
    height: theme["j" /* Size */].BaseUnit * 3,
    radius: "50%"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    width: "20px"
  }), /*#__PURE__*/react_default.a.createElement(Skeleton["a" /* Skeleton */], {
    width: theme["j" /* Size */].BaseUnit * 3,
    height: theme["j" /* Size */].BaseUnit * 3,
    radius: "50%"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    width: "20px"
  }), /*#__PURE__*/react_default.a.createElement(Skeleton["a" /* Skeleton */], {
    width: theme["j" /* Size */].BaseUnit * 3,
    height: theme["j" /* Size */].BaseUnit * 3,
    radius: "50%"
  }))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "40px"
  }), /*#__PURE__*/react_default.a.createElement(StyledButtonRef, {
    ref: buyButtonRef
  }, productVariant && productVariant.available ? /*#__PURE__*/react_default.a.createElement(button_Button, {
    palette: "blue",
    onAction: handleAddToCart
  }, labels.addToCart) : /*#__PURE__*/react_default.a.createElement(waitlist_button_WaitlistButton, {
    label: labels.waitlist,
    handle: productData.handle
  })), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '16px',
      desktop: '10px'
    }
  }), /*#__PURE__*/react_default.a.createElement(index_web_BuyButtonServices, null, productVariant && financialServices(productVariant.price)), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '20px',
      mobile: '40px'
    }
  }), /*#__PURE__*/react_default.a.createElement(HorizontalLine, {
    color: elements_theme["a" /* Color */].CharcoalBrighter
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '20px',
      mobile: '40px'
    }
  }), productData.descriptionBold && isJagermeister && /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    color: elements_theme["a" /* Color */].White,
    bold: true
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: productData.descriptionBold
  })), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    color: elements_theme["a" /* Color */].White
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: productData.description
  })), productData.descriptionBold && !isJagermeister && /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    color: elements_theme["a" /* Color */].White,
    bold: true
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: productData.descriptionBold
  })))), /*#__PURE__*/react_default.a.createElement(StyledWrapperHorizontalLine, null, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(HorizontalLine, {
    color: elements_theme["a" /* Color */].CharcoalBrighter
  })), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '34px',
      desktop: '23px'
    }
  }), /*#__PURE__*/react_default.a.createElement(index_web_ProductUSP, {
    usps: usps
  }));
});
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/product-overview/index.tsx
var product_overview_jsx = react_default.a.createElement;






var product_overview_ProductOverviewSection = function ProductOverviewSection(_ref) {
  var productData = _ref.productData,
      paths = _ref.paths,
      onHeaderVisibility = _ref.onHeaderVisibility,
      handleColorSelector = _ref.handleColorSelector,
      handleBatterySelector = _ref.handleBatterySelector,
      productVariant = _ref.productVariant,
      avalibleColors = _ref.avalibleColors,
      selectedColor = _ref.selectedColor,
      availableMerch = _ref.availableMerch,
      selectedMerch = _ref.selectedMerch,
      handleMerchSelector = _ref.handleMerchSelector,
      extraBattery = _ref.extraBattery,
      disableExtraBattery = _ref.disableExtraBattery,
      handleAddToCart = _ref.handleAddToCart,
      financialServices = _ref.financialServices,
      offset = _ref.offset,
      anchorStack = _ref.anchorStack,
      allowImageInteractionTracking = _ref.allowImageInteractionTracking,
      setAllowImageInteractionTracking = _ref.setAllowImageInteractionTracking,
      trackImageInteractionLimit = _ref.trackImageInteractionLimit,
      setTrackImageInteractionLimit = _ref.setTrackImageInteractionLimit;
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentHorizontal: "center",
      padding: {
        right: 24,
        left: 24
      }
    }, /*#__PURE__*/react_default.a.createElement(index_web_ProductOverview, {
      paths: paths,
      offset: offset,
      anchorStack: anchorStack,
      productData: productData,
      availableMerch: availableMerch,
      selectedMerch: selectedMerch,
      handleMerchSelector: handleMerchSelector,
      handleColorSelector: handleColorSelector,
      handleBatterySelector: handleBatterySelector,
      productVariant: productVariant,
      avalibleColors: avalibleColors,
      selectedColor: selectedColor,
      extraBattery: extraBattery,
      disableExtraBattery: disableExtraBattery,
      handleAddToCart: handleAddToCart,
      financialServices: financialServices,
      allowImageInteractionTracking: allowImageInteractionTracking,
      setAllowImageInteractionTracking: setAllowImageInteractionTracking,
      trackImageInteractionLimit: trackImageInteractionLimit,
      setTrackImageInteractionLimit: setTrackImageInteractionLimit,
      labels: {
        merch: {
          label: i18n._('product.option.label.accessories'),
          options: {
            'Cable bundle': i18n._('Cable bundle'),
            Backpack: i18n._('Backpack'),
            Tripod: i18n._('Tripod'),
            Microphone: i18n._('Microphone'),
            Powerbank: i18n._('Powerbank'),
            None: i18n._('product.option.label.none'),
            'Orange grill': i18n._('product.option.label.orange-grill'),
            'White grill': i18n._('product.option.label.white-grill'),
            'Black grill': i18n._('product.option.label.black-grill')
          }
        },
        grillColor: {
          label: i18n._('product.option.label.grill-color'),
          options: {
            Black: i18n._('product.option.label.black'),
            Orange: i18n._('product.option.label.orange'),
            White: i18n._('product.option.label.white'),
            Blue: i18n._('product.option.label.blue'),
            Red: i18n._('product.option.label.red'),
            Yellow: i18n._('product.option.label.yellow'),
            Teal: i18n._('product.option.label.teal'),
            Pink: i18n._('product.option.label.pink'),
            Chrome: i18n._('product.option.label.chrome')
          }
        },
        // extraBattery: {
        //   label: i18n._('product.option.label.extra-battery'),
        //   options: {
        //     yes: i18n._('product.option.label.yes'),
        //     no: i18n._('product.option.label.no'),
        //   },
        // },
        addToCart: i18n._('product.buy-page.button.addToCart'),
        outOfStock: i18n._('product.buy-page.button.outOfStock'),
        waitlist: i18n._('product.buy-page.button.waitlist'),
        usp: {
          warranty: i18n._('product.usp.warranty'),
          freeReturns: i18n._('product.usp.free-returns'),
          freeShipping: i18n._('product.usp.free-shipping'),
          premiumSupport: i18n._('product.usp.premium-support'),
          compatibility: i18n._('product.usp.compatibility')
        }
      },
      onHeaderVisibility: onHeaderVisibility
    }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    }));
  });
};

/* harmony default export */ var product_overview = (product_overview_ProductOverviewSection);
// CONCATENATED MODULE: ./components/elements/accordion/styled.ts



var OverflowButton = styled_components_browser_esm["default"].button.withConfig({
  displayName: "styled__OverflowButton",
  componentId: "zhezzq-0"
})(["cursor:pointer;font-family:", ";font-size:14px;line-height:16px;color:", ";"], styles_theme["a" /* default */].fonts.extended, styles_theme["a" /* default */].colors.black);
var ButtonWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__ButtonWrapper",
  componentId: "zhezzq-1"
})(["cursor:pointer;width:fit-content;display:flex;align-items:center;"]);
var SubContentWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__SubContentWrapper",
  componentId: "zhezzq-2"
})(["max-height:", ";overflow:hidden;transition:max-height 0.67s ease-in-out;"], function (_ref) {
  var toggleOverflow = _ref.toggleOverflow,
      scrollHeight = _ref.scrollHeight;
  return !toggleOverflow ? '560px' : "".concat(scrollHeight, "px");
});
var styled_ContentWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__ContentWrapper",
  componentId: "zhezzq-3"
})(["background-color:", ";overflow:hidden;max-height:", ";transition:max-height 0.67s ease-in-out;"], elements_theme["a" /* Color */].WhiteOff, function (_ref2) {
  var isExpanded = _ref2.isExpanded,
      scrollHeight = _ref2.scrollHeight;
  return isExpanded ? "".concat(scrollHeight, "px") : 0;
});
var SVGAnim = styled_components_browser_esm["default"].svg.withConfig({
  displayName: "styled__SVGAnim",
  componentId: "zhezzq-4"
})(["transform:", ";transition:transform 200ms;"], function (_ref3) {
  var isExpanded = _ref3.isExpanded;
  return isExpanded ? 'rotate(-45deg)' : 'rotate(0deg)';
});
var SVGWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__SVGWrapper",
  componentId: "zhezzq-5"
})(["margin-right:5px;margin-left:80px;"]);
var TitleWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__TitleWrapper",
  componentId: "zhezzq-6"
})(["display:flex;flex-direction:row;justify-content:space-between;align-items:center;padding:14px 0;cursor:pointer;@media ", "{position:", ";top:120px;background-color:", ";width:100%;padding:14px 0px;z-index:1;}"], styles_theme["a" /* default */].breakpoints.maxMobile, function (_ref4) {
  var isExpanded = _ref4.isExpanded;
  return isExpanded ? 'sticky' : 'auto';
}, function (_ref5) {
  var isExpanded = _ref5.isExpanded;
  return isExpanded ? elements_theme["a" /* Color */].WhiteOff : 'transparent';
});
var styled_Section = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Section",
  componentId: "zhezzq-7"
})(["display:relative;width:100%;background-color:", ";border-bottom:1px solid ", ";border-top:", " solid ", ";z-index:1;"], elements_theme["a" /* Color */].WhiteOff, elements_theme["a" /* Color */].Grey, function (_ref6) {
  var topItem = _ref6.topItem;
  return topItem ? '1px' : 0;
}, elements_theme["a" /* Color */].Grey);
// CONCATENATED MODULE: ./components/elements/accordion/Icon.tsx
var Icon_jsx = react_default.a.createElement;



var Icon_Icon = function Icon(_ref) {
  var isExpanded = _ref.isExpanded,
      color = _ref.color;
  return /*#__PURE__*/react_default.a.createElement(SVGWrapper, null, /*#__PURE__*/react_default.a.createElement(SVGAnim, {
    width: "16",
    height: "15",
    viewBox: "0 0 16 15",
    fill: color,
    xmlns: "http://www.w3.org/2000/svg",
    isExpanded: isExpanded
  }, /*#__PURE__*/react_default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.928711 8.70952L6.49971 8.70952L6.49971 14.2805L9.49971 14.2805L9.49971 8.70952L15.0707 8.70952L15.0707 5.70852L9.49971 5.70852L9.49971 0.137518L6.49971 0.137518L6.49971 5.70852L0.928711 5.70852L0.928711 8.70952Z"
  })));
};

/* harmony default export */ var accordion_Icon = (Icon_Icon);
// CONCATENATED MODULE: ./components/elements/accordion/ArrowIcon.tsx
var ArrowIcon_jsx = react["createElement"];


var ArrowIcon_ArrowIcon = function ArrowIcon(_ref) {
  var toggleOverflow = _ref.toggleOverflow;
  return /*#__PURE__*/react["createElement"]("svg", {
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      transform: toggleOverflow && 'rotate(180deg)'
    }
  }, /*#__PURE__*/react["createElement"]("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m5.775 13.104 7.061 7.06 7.06-7.06-2.12-2.121-4.94 4.939-4.94-4.94-2.12 2.122Z",
    fill: "#212222"
  }), /*#__PURE__*/react["createElement"]("path", {
    fill: "#212222",
    d: "M11.336 17.574v-12h3v12z"
  }));
};

/* harmony default export */ var accordion_ArrowIcon = (ArrowIcon_ArrowIcon);
// CONCATENATED MODULE: ./components/elements/accordion/index.web.tsx
var accordion_index_web_jsx = react_default.a.createElement;







 // eslint-disable-next-line prefer-arrow-callback

var index_web_Accordion = /*#__PURE__*/react_default.a.memo(function Accordion(_ref) {
  var _ref$colorForeground = _ref.colorForeground,
      colorForeground = _ref$colorForeground === void 0 ? elements_theme["a" /* Color */].Black : _ref$colorForeground,
      title = _ref.title,
      content = _ref.content,
      topItem = _ref.topItem,
      moreInfo = _ref.moreInfo;
  var sectionRef = Object(react["useRef"])(null);

  var _useState = Object(react["useState"])(),
      isOverflow = _useState[0],
      setIsOverflow = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      toggleOverflow = _useState2[0],
      setToggleOverflow = _useState2[1];

  var _useState3 = Object(react["useState"])(false),
      isExpanded = _useState3[0],
      setIsExpanded = _useState3[1];

  var _useState4 = Object(react["useState"])(),
      scrollHeight = _useState4[0],
      setScrollHeight = _useState4[1];

  Object(react["useEffect"])(function () {
    var handleOverflow = function handleOverflow() {
      setIsOverflow(sectionRef.current.scrollHeight > sectionRef.current.clientHeight); // Add offset to add an appropiate extra amount to account for extra space around.

      setScrollHeight(sectionRef.current.scrollHeight + sectionRef.current.offsetHeight);
    };

    handleOverflow();
    window.addEventListener('resize', handleOverflow);
    return function () {
      window.removeEventListener('resize', handleOverflow);
    };
  }, [scrollHeight]);
  var moreInfoText = moreInfo || /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "accordion.show.more.button"
  });
  return /*#__PURE__*/react_default.a.createElement(styled_Section, {
    topItem: topItem
  }, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], {
    color: colorForeground
  }, /*#__PURE__*/react_default.a.createElement(TitleWrapper, {
    isExpanded: isExpanded,
    onClick: function onClick() {
      return setIsExpanded(!isExpanded);
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: title
  }), /*#__PURE__*/react_default.a.createElement(accordion_Icon, {
    isExpanded: isExpanded,
    color: colorForeground
  }))), /*#__PURE__*/react_default.a.createElement(styled_ContentWrapper, {
    isExpanded: isExpanded,
    scrollHeight: scrollHeight
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "10px"
  }), /*#__PURE__*/react_default.a.createElement(SubContentWrapper, {
    ref: sectionRef,
    toggleOverflow: toggleOverflow,
    scrollHeight: scrollHeight
  }, content), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "16px"
  }), isOverflow && /*#__PURE__*/react_default.a.createElement(ButtonWrapper, null, /*#__PURE__*/react_default.a.createElement(accordion_ArrowIcon, {
    toggleOverflow: toggleOverflow
  }), /*#__PURE__*/react_default.a.createElement(OverflowButton, {
    onClick: function onClick() {
      return setToggleOverflow(!toggleOverflow);
    }
  }, toggleOverflow ? /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "accordion.show.less.button"
  }) : moreInfoText)), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  })));
});
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/learn-more/whats-in-the-box/styled.ts


var IconWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__IconWrapper",
  componentId: "sc-9d5m8e-0"
})(["display:block;"]);
var styled_Layout = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Layout",
  componentId: "sc-9d5m8e-1"
})(["display:flex;flex-direction:row;justify-content:space-evenly;padding:10px 50px;align-items:end;@media ", "{display:grid;grid-template-columns:1fr 1fr;grid-gap:30px;padding:15px 0px;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
var whats_in_the_box_styled_Link = styled_components_browser_esm["default"].a.withConfig({
  displayName: "styled__Link",
  componentId: "sc-9d5m8e-2"
})(["text-decoration:underline;"]);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/learn-more/whats-in-the-box/index.web.tsx
var whats_in_the_box_index_web_jsx = react_default.a.createElement;





var lookupTable = {
  Backpack: ['tripod-backpack', 'tripod', 'grill', 'cable-bundle', 'powerbank', 'microphone'],
  Powerbank: ['tripod-backpack', 'tripod', 'grill', 'cable-bundle', 'backpack', 'backpack-manual', 'microphone'],
  Microphone: ['tripod-backpack', 'tripod', 'grill', 'cable-bundle', 'backpack', 'backpack-manual', 'powerbank'],
  Tripod: ['backpack', 'grill', 'cable-bundle', 'backpack-manual', 'cable-bundle', 'powerbank', 'microphone'],
  'Cable bundle': ['tripod-backpack', 'tripod', 'grill', 'backpack', 'backpack-manual', 'powerbank', 'microphone'],
  'Orange grill': ['tripod-backpack', 'tripod', 'cable-bundle', 'backpack', 'backpack-manual', 'cable-bundle', 'powerbank', 'microphone'],
  'White grill': ['tripod-backpack', 'tripod', 'cable-bundle', 'backpack', 'backpack-manual', 'cable-bundle', 'powerbank', 'microphone'],
  'Black grill': ['tripod-backpack', 'tripod', 'cable-bundle', 'backpack', 'backpack-manual', 'cable-bundle', 'powerbank', 'microphone'],
  None: ['tripod-backpack', 'tripod', 'cable-bundle', 'backpack', 'backpack-manual', 'grill', 'cable-bundle', 'powerbank', 'microphone']
}; // eslint-disable-next-line prefer-arrow-callback

var index_web_WhatsInTheBox = /*#__PURE__*/react_default.a.memo(function WhatsInTheBox(_ref) {
  var packageItems = _ref.packageItems,
      selectedMerch = _ref.selectedMerch;

  var filteredPackageItems = function filteredPackageItems() {
    return packageItems.filter(function (item) {
      var _lookupTable$selected;

      return !((_lookupTable$selected = lookupTable[selectedMerch]) === null || _lookupTable$selected === void 0 ? void 0 : _lookupTable$selected.includes(item.packageItemId));
    });
  };

  return /*#__PURE__*/react_default.a.createElement(styled_Layout, null, filteredPackageItems().map(function (_ref2) {
    var packageItemId = _ref2.packageItemId,
        title = _ref2.title,
        icon = _ref2.icon,
        downloadUrl = _ref2.downloadUrl;
    return /*#__PURE__*/react_default.a.createElement("div", {
      key: packageItemId
    }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(IconWrapper, null, icon), /*#__PURE__*/react_default.a.createElement(spacer_Spacer, {
      height: 10
    }), /*#__PURE__*/react_default.a.createElement(elements_typography["d" /* Caption02 */], null, title, " ", downloadUrl ? /*#__PURE__*/react_default.a.createElement(whats_in_the_box_styled_Link, {
      href: downloadUrl,
      target: "_blank"
    }, "Download") : null)));
  }));
});
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/learn-more/whats-bluetooth-speaker/styled.ts


var Table = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Table",
  componentId: "zhr36b-0"
})(["width:100%;"]);
var styled_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Wrapper",
  componentId: "zhr36b-1"
})(["padding-left:26px;padding-right:26px;display:grid;grid-template-columns:250px 1fr 1fr 1fr;@media ", "{display:grid;grid-template-columns:1fr 1fr 1fr;}svg{margin:0 auto;}text-align:center;font-family:", ";font-size:10px;line-height:12px;"], styles_theme["a" /* default */].breakpoints.onlyMobile, styles_theme["a" /* default */].fonts.extended);
var whats_bluetooth_speaker_styled_ImageWrapper = Object(styled_components_browser_esm["default"])(styled_Wrapper).withConfig({
  displayName: "styled__ImageWrapper",
  componentId: "zhr36b-2"
})(["align-items:baseline;padding-top:29px;"]);
var ImageTextWrapper = Object(styled_components_browser_esm["default"])(styled_Wrapper).withConfig({
  displayName: "styled__ImageTextWrapper",
  componentId: "zhr36b-3"
})(["padding-top:8px;padding-bottom:12px;align-items:center;"]);
var EmptyCell = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__EmptyCell",
  componentId: "zhr36b-4"
})(["@media ", "{display:none;}"], styles_theme["a" /* default */].breakpoints.onlyMobile);
var LastParagraph = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__LastParagraph",
  componentId: "zhr36b-5"
})(["padding-top:40px;color:", ";font-family:", ";font-size:14px;line-height:16px;white-space:pre-wrap;"], styles_theme["a" /* default */].colors.black, styles_theme["a" /* default */].fonts.regular);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/learn-more/whats-bluetooth-speaker/attribute-row/CheckIcon.tsx
var CheckIcon_jsx = react_default.a.createElement;


var CheckIcon_CheckIcon = function CheckIcon() {
  return /*#__PURE__*/react_default.a.createElement("svg", {
    style: {
      margin: '0 auto'
    },
    width: 15,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react_default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.376.389 6.249 6.516l-3.751-3.75-2.122 2.12 5.873 5.873 8.248-8.25L12.376.39Z",
    fill: "#212222"
  }));
};

/* harmony default export */ var attribute_row_CheckIcon = (CheckIcon_CheckIcon);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/learn-more/whats-bluetooth-speaker/attribute-row/styled.ts


var TableRow = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__TableRow",
  componentId: "z6gc3s-0"
})(["display:grid;grid-template-columns:250px auto;padding:26px;@media ", "{display:flex;flex-direction:column;text-align:center;gap:22px;}"], styles_theme["a" /* default */].breakpoints.onlyMobile);
var AttributeText = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__AttributeText",
  componentId: "z6gc3s-1"
})(["font-family:", ";font-size:14px;line-height:16px;@media ", "{font-size:11px;line-height:12px;}"], styles_theme["a" /* default */].fonts.regular, styles_theme["a" /* default */].breakpoints.onlyMobile);
var CheckIconWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__CheckIconWrapper",
  componentId: "z6gc3s-2"
})(["display:grid;grid-template-columns:1fr 1fr 1fr;"]);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/learn-more/whats-bluetooth-speaker/attribute-row/index.tsx
var attribute_row_jsx = react_default.a.createElement;




 // eslint-disable-next-line prefer-arrow-callback

var attribute_row_AttributeRow = /*#__PURE__*/react_default.a.memo(function AttributeRow(_ref) {
  var text = _ref.text,
      checks = _ref.checks;
  return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(TableRow, null, /*#__PURE__*/react_default.a.createElement(AttributeText, null, text), /*#__PURE__*/react_default.a.createElement(CheckIconWrapper, null, checks.map(function (check, index) {
    return check ? /*#__PURE__*/react_default.a.createElement(attribute_row_CheckIcon, {
      key: "check-icon".concat(index)
    }) : /*#__PURE__*/react_default.a.createElement("div", {
      key: "check-icon".concat(index)
    });
  }))), /*#__PURE__*/react_default.a.createElement(HorizontalLine, {
    color: styles_theme["a" /* default */].colors.white
  }));
});
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/learn-more/whats-bluetooth-speaker/icons/IconSoundboks3.tsx
var IconSoundboks3_jsx = react_default.a.createElement;


var IconSoundboks3_IconSoundboks3 = function IconSoundboks3() {
  return /*#__PURE__*/react_default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "55",
    height: "80",
    viewBox: "0 0 82.471 119.016"
  }, /*#__PURE__*/react_default.a.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(-654 -4240)"
  }, /*#__PURE__*/react_default.a.createElement("path", {
    id: "Vector",
    d: "M5.6,101.5l1.56-2.7h2.51l1.56,2.7h3.7l1.56-2.7h2.55l1.56,2.7h3.7l1.56-2.7h2.51l1.56,2.7h3.7l1.56-2.7H37.7l1.56,2.7h3.7l1.56-2.7h2.55l1.56,2.7h3.7l1.56-2.7H56.4l1.56,2.7h3.7l1.85-3.2-1.56-2.7,1.56-2.71-1.56-2.7,1.56-2.7-1.56-2.71,1.56-2.7-1.56-2.7,1.56-2.7-1.56-2.71,1.56-2.7-1.56-2.7,1.56-2.71-1.56-2.7,1.56-2.7-1.56-2.71,1.56-2.7-1.56-2.7,1.56-2.7-1.56-2.71,1.56-2.7-1.56-2.7,1.56-2.71-1.56-2.7,1.56-2.7-1.56-2.71,1.56-2.7-1.56-2.74,1.56-2.7-1.56-2.71,1.56-2.7-1.56-2.7,1.56-2.71-1.56-2.7,1.56-2.7-1.85-3.21h-3.1L57,.452H53.3l-1.52,2.74h-2.55l-1.56-2.7h-3.7l-1.56,2.7h-2.54l-1.56-2.7h-3.7l-1.56,2.7h-2.52l-1.56-2.7h-3.7l-1.56,2.7H21.2l-1.56-2.7h-3.7l-1.56,2.7h-2.54l-1.56-2.7h-3.7l-1.56,2.7H1.9L.053,6.4l1.56,2.7L.053,11.8l1.56,2.71-1.56,2.7,1.56,2.7-1.56,2.71,1.56,2.7-1.56,2.7,1.56,2.7-1.56,2.71,1.56,2.7-1.56,2.7,1.56,2.71-1.56,2.74,1.56,2.7-1.56,2.71,1.56,2.7-1.56,2.7,1.56,2.7L.053,60.5l1.56,2.7L.053,65.9l1.56,2.71-1.56,2.67,1.56,2.7-1.56,2.71,1.56,2.7-1.56,2.7,1.56,2.7L.053,87.5l1.56,2.7L.053,92.9l1.56,2.71-1.56,2.67,1.85,3.2Zm8.78-97.31H40.5l-1.07,3.65-.21.73H4.073l1.17-4,.11-.39h9ZM47.073,6.9l1.27,2.2-1.27,2.18h-2.52l-1.27-2.2,1.27-2.2Zm9.33,0,1.27,2.2-1.27,2.18h-2.51l-1.27-2.2,1.27-2.2Zm-7.17,88.2-1.27-2.21,1.27-2.2h2.55l1.27,2.2-1.27,2.21Zm-9.36,0-1.27-2.21,1.27-2.2h2.52l1.27,2.2-1.27,2.21Zm-9.34,0-1.27-2.21,1.27-2.2h2.52l1.27,2.2-1.27,2.21Zm-9.33,0-1.27-2.21,1.27-2.2h2.51l1.27,2.2-1.27,2.21Zm-9.36,0-1.28-2.21,1.28-2.2h2.51l1.28,2.2-1.28,2.21Zm30.55-80.09,1.27,2.2-1.27,2.2h-2.52l-1.27-2.2,1.27-2.2Zm4.68-2.73,1.27,2.21-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21Zm4.67-2.7,1.27,2.2-1.23,2.23h-2.55l-1.27-2.21,1.27-2.2Zm4.66,2.7,1.27,2.21-1.27,2.2h-2.51l-1.27-2.2,1.27-2.21Zm-2.51,80.09-1.27-2.2,1.27-2.2H56.4l1.27,2.2-1.27,2.2Zm-4.66-2.7-1.27-2.2,1.27-2.19h2.55l1.27,2.21-1.27,2.2Zm-4.68,2.7-1.27-2.2,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.68-2.7-1.27-2.2,1.27-2.19h2.52l1.27,2.21-1.27,2.2Zm-4.68,2.7-1.28-2.2,1.28-2.2H37.7l1.28,2.2-1.28,2.2Zm-4.66-2.7-1.27-2.2,1.27-2.19h2.52l1.27,2.21-1.27,2.2Zm-4.67,2.7-1.28-2.2,1.28-2.2h2.51l1.27,2.2-1.27,2.2Zm-4.66-2.7-1.27-2.2,1.27-2.19h2.51l1.27,2.21-1.27,2.2Zm-4.68,2.7-1.27-2.2,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.68-2.7-1.28-2.2,1.28-2.19h2.51l1.28,2.21-1.28,2.2Zm-4.68,2.7-1.27-2.2,1.27-2.2h2.51l1.27,2.2-1.27,2.2Zm35.23-72,1.27,2.21-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21Zm4.68-2.7,1.27,2.2-1.27,2.21h-2.52l-1.27-2.21,1.27-2.2Zm4.67-2.7,1.27,2.2-1.23,2.24h-2.55l-1.27-2.2,1.27-2.2Zm4.66,2.7,1.27,2.2-1.27,2.21h-2.51l-1.27-2.21,1.27-2.2Zm-2.51,69.28-1.27-2.21,1.27-2.2H56.4l1.27,2.2-1.27,2.21Zm-4.66-2.67-1.27-2.2,1.27-2.2h2.55l1.27,2.2-1.27,2.2Zm-4.68,2.71-1.27-2.21,1.27-2.2h2.52l1.27,2.2-1.27,2.21Zm-4.68-2.71-1.27-2.2,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.68,2.71-1.28-2.21,1.28-2.2H37.7l1.28,2.2-1.28,2.21Zm-4.66-2.71-1.27-2.2,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.67,2.71-1.28-2.21,1.28-2.2h2.51l1.27,2.2-1.27,2.21Zm-4.66-2.71-1.27-2.2,1.27-2.2h2.51l1.27,2.2-1.27,2.2Zm-4.68,2.71-1.27-2.21,1.27-2.2h2.52l1.27,2.2-1.27,2.21Zm-4.68-2.71-1.28-2.2,1.28-2.2h2.51l1.28,2.2-1.28,2.2Zm2.51-69.27,1.28,2.2-1.28,2.2h-2.51l-1.28-2.2,1.28-2.2Zm4.69-2.73,1.27,2.21-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21Zm4.67,2.71,1.27,2.2-1.27,2.2H21.2l-1.27-2.2,1.27-2.2Zm4.66-2.71,1.27,2.21-1.27,2.2h-2.51l-1.28-2.2,1.28-2.21Zm4.68,2.71,1.27,2.2-1.27,2.2h-2.52l-1.27-2.2,1.27-2.2Zm4.65-2.71,1.28,2.21-1.28,2.2h-2.51l-1.28-2.2,1.28-2.21Zm4.69,13.52,1.27,2.2-1.27,2.2h-2.52L38.6,28l1.27-2.2Zm4.68-2.7,1.27,2.2-1.27,2.2h-2.52l-1.27-2.22,1.27-2.2Zm4.71-2.69,1.27,2.21-1.27,2.2h-2.55l-1.27-2.2,1.27-2.21Zm-2.55,58.47-1.27-2.2,1.27-2.21h2.55l1.27,2.21-1.27,2.2Zm-4.68,2.7-1.27-2.2,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.68-2.7-1.27-2.2,1.27-2.21h2.52l1.27,2.21-1.27,2.2Zm-4.68,2.7-1.28-2.2,1.28-2.2H37.7l1.28,2.2-1.28,2.2Zm-4.66-2.7-1.27-2.2,1.27-2.21h2.52l1.27,2.21-1.27,2.2Zm-4.67,2.7-1.28-2.2,1.28-2.2h2.51l1.27,2.2-1.27,2.2Zm-4.66-2.7-1.27-2.2,1.27-2.21h2.51l1.27,2.21-1.27,2.2Zm-4.68,2.7-1.27-2.2,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.68-2.7-1.28-2.2,1.28-2.21h2.51l1.28,2.21-1.28,2.2Zm2.51-58.47,1.28,2.21-1.28,2.2h-2.51l-1.28-2.2,1.28-2.21Zm4.69-2.7,1.27,2.2-1.27,2.21h-2.52l-1.27-2.21,1.27-2.2Zm4.67,2.7,1.27,2.21-1.27,2.2H21.2l-1.27-2.2,1.27-2.21Zm4.66-2.7,1.27,2.2-1.27,2.21h-2.51l-1.28-2.21,1.28-2.2Zm4.68,2.7,1.27,2.21-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21Zm4.65-2.7,1.28,2.2-1.28,2.21h-2.51l-1.28-2.21,1.28-2.2Zm4.69,13.51,1.27,2.21-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21Zm4.68-2.7,1.27,2.2-1.27,2.21h-2.52l-1.27-2.21,1.27-2.2Zm4.67-2.7,1.27,2.2-1.23,2.2h-2.55l-1.27-2.2,1.27-2.2Zm-2.51,47.65-1.27-2.19,1.27-2.2h2.55l1.27,2.2-1.27,2.19Zm-4.68,2.71-1.27-2.21,1.27-2.2h2.52l1.27,2.2-1.27,2.21Zm-4.68-2.71-1.27-2.19,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.68,2.71-1.28-2.21,1.28-2.2H37.7l1.28,2.2-1.28,2.21Zm-4.66-2.71-1.27-2.19,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.67,2.71-1.28-2.21,1.28-2.2h2.51l1.27,2.2-1.27,2.21Zm-4.66-2.71-1.27-2.19,1.27-2.2h2.51l1.27,2.2-1.27,2.2Zm-4.68,2.71-1.27-2.21,1.27-2.2h2.52l1.27,2.2-1.27,2.21Zm-4.68-2.71-1.28-2.19,1.28-2.2h2.51l1.28,2.2-1.28,2.2Zm2.51-47.65,1.28,2.2-1.28,2.2h-2.51l-1.28-2.2,1.28-2.2Zm4.69-2.7,1.27,2.2-1.27,2.2h-2.52l-1.27-2.24,1.27-2.2Zm4.67,2.7,1.27,2.2-1.27,2.2H21.2l-1.27-2.2,1.27-2.2Zm4.66-2.7,1.27,2.2-1.27,2.2h-2.51l-1.28-2.24,1.28-2.2Zm4.68,2.7,1.27,2.2-1.27,2.2h-2.52l-1.27-2.2,1.27-2.2Zm4.65-2.7,1.28,2.16-1.28,2.2h-2.51l-1.28-2.2,1.28-2.2Zm4.69,13.51,1.27,2.2-1.27,2.21h-2.52l-1.27-2.21,1.27-2.2Zm4.68-2.7,1.27,2.2-1.27,2.2h-2.52l-1.27-2.2,1.27-2.2Zm4.71-2.71,1.27,2.21-1.27,2.2h-2.55l-1.27-2.2,1.27-2.21Zm-2.51,36.85L48,65.862l1.27-2.2h2.51l1.27,2.2-1.27,2.21Zm-4.68,2.7-1.27-2.2,1.27-2.21h2.52l1.27,2.21-1.27,2.2Zm-4.68-2.7-1.27-2.21,1.27-2.2h2.52l1.27,2.2-1.27,2.21Zm-4.68,2.7-1.28-2.2,1.28-2.21h2.51l1.28,2.21-1.28,2.2Zm-4.66-2.7-1.27-2.21,1.27-2.2h2.52l1.27,2.2-1.27,2.21Zm-4.67,2.7-1.28-2.2,1.28-2.21h2.51l1.27,2.21-1.27,2.2Zm-4.66-2.7-1.27-2.21,1.27-2.2h2.51l1.27,2.2-1.27,2.21Zm-4.68,2.7-1.27-2.2,1.27-2.21h2.52l1.27,2.21-1.27,2.2Zm2.52-42.25,1.27,2.2-1.27,2.21h-2.56l-1.27-2.21,1.27-2.2Zm4.67,2.7,1.27,2.21-1.27,2.2H21.2l-1.27-2.2,1.27-2.21Zm4.66-2.7,1.27,2.2-1.27,2.21h-2.55l-1.28-2.21,1.28-2.2Zm4.68,2.7,1.27,2.21-1.27,2.2h-2.56l-1.27-2.2,1.27-2.21Zm4.65-2.7,1.28,2.2-1.28,2.21h-2.55l-1.28-2.21,1.28-2.2Zm4.69,13.52,1.27,2.2-1.27,2.2h-2.56l-1.27-2.16,1.27-2.2Zm4.68-2.71,1.27,2.21-1.27,2.2h-2.56l-1.27-2.2,1.27-2.21Zm-2.52,26-1.27-2.2,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.68-2.7-1.27-2.2,1.23-2.15h2.52l1.27,2.21-1.27,2.2Zm-4.68,2.7-1.28-2.2,1.28-2.2h2.51l1.28,2.2-1.28,2.2Zm-4.66-2.7-1.27-2.2,1.23-2.15h2.52l1.27,2.21-1.27,2.2Zm-4.67,2.7-1.28-2.2,1.28-2.2h2.51l1.27,2.2-1.27,2.2Zm-4.66-2.7-1.27-2.2,1.23-2.15h2.51l1.27,2.21-1.27,2.2Zm-4.68,2.7-1.27-2.2,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm2.52-31.43,1.27,2.2-1.27,2.2h-2.56l-1.27-2.2,1.27-2.2Zm4.67,2.7,1.27,2.2-1.27,2.21H21.2l-1.27-2.21,1.27-2.2Zm4.66-2.7,1.27,2.2-1.27,2.2h-2.55l-1.28-2.2,1.28-2.2Zm4.68,2.7,1.27,2.2-1.27,2.21h-2.56l-1.27-2.21,1.27-2.2Zm4.65-2.7,1.28,2.2-1.28,2.2h-2.55l-1.28-2.2,1.28-2.2Zm4.69,13.51,1.27,2.21-1.27,2.2h-2.56l-1.27-2.2,1.27-2.21Zm4.68-2.7,1.27,2.2-1.27,2.21h-2.56l-1.27-2.21,1.27-2.2Zm-2.52,15.22-1.27-2.21,1.27-2.2h2.52l1.27,2.2-1.27,2.21Zm-4.72-2.65-1.27-2.2,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.68,2.71-1.28-2.21,1.28-2.2H37.7l1.28,2.2-1.28,2.21Zm-4.66-2.71-1.27-2.2,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.67,2.71-1.28-2.21,1.28-2.2h2.51l1.27,2.2-1.27,2.21Zm-4.66-2.71-1.27-2.2,1.27-2.2h2.51l1.27,2.2-1.27,2.2Zm-4.68,2.71-1.27-2.21,1.27-2.2h2.52l1.27,2.2-1.27,2.21Zm2.52-20.63,1.27,2.21-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21Zm4.67,2.71,1.27,2.21-1.27,2.2H21.2l-1.27-2.2,1.27-2.2Zm4.66-2.71,1.27,2.21-1.27,2.2h-2.51l-1.28-2.2,1.28-2.21Zm4.68,2.71,1.27,2.2-1.27,2.2h-2.52l-1.27-2.19,1.27-2.2Zm4.65-2.71,1.28,2.21-1.28,2.2h-2.51l-1.28-2.2,1.28-2.21Zm-2.51,15.22-1.28-2.2,1.28-2.2H37.7l1.28,2.2-1.28,2.2Zm-4.66-2.7-1.27-2.2,1.27-2.21h2.52l1.27,2.21-1.27,2.2Zm-4.67,2.7-1.28-2.2,1.28-2.2h2.51l1.27,2.2-1.27,2.2Zm-4.66-2.7-1.27-2.2,1.27-2.21h2.51l1.27,2.21-1.27,2.2Zm7.17-7.11,1.27,2.2-1.27,2.21h-2.51l-1.28-2.21,1.28-2.2Zm9.33,0,1.28,2.2-1.28,2.21h-2.51l-1.28-2.21,1.28-2.2Zm-18.66,0,1.27,2.2-1.27,2.21h-2.52l-1.27-2.21,1.27-2.2Zm0,5.41,1.27,2.2-1.27,2.2h-2.52l-1.27-2.2,1.27-2.2Zm28,0,1.27,2.2-1.27,2.2h-2.49l-1.27-2.2,1.27-2.2Zm2.16,12.51-1.27-2.2,1.3-2.21h2.55l1.27,2.21-1.27,2.17Zm0-5.41-1.27-2.2,1.27-2.2h2.58l1.27,2.2-1.27,2.2Zm0-5.4-1.27-2.2,1.27-2.21h2.58l1.27,2.21-1.27,2.17Zm0-5.41-1.24-2.19,1.27-2.2h2.55l1.27,2.2-1.27,2.16Zm0-5.4-1.27-2.21,1.27-2.2h2.58l1.27,2.2-1.27,2.18Zm-34.88-9.82,1.28,2.21-1.28,2.2h-2.48l-1.28-2.2,1.28-2.21Zm0,5.41,1.28,2.2-1.28,2.21h-2.48l-1.28-2.21,1.28-2.2Zm0,5.41,1.28,2.2-1.28,2.2h-2.48l-1.28-2.19,1.28-2.2Zm0,5.4,1.28,2.21-1.28,2.2h-2.48l-1.28-2.2,1.28-2.21Zm0,5.41,1.28,2.2-1.25,2.2h-2.51l-1.28-2.2,1.28-2.2Zm0,5.4,1.28,2.21-1.28,2.2h-2.48l-1.28-2.2,1.28-2.21Zm0,5.41,1.28,2.2-1.28,2.21h-2.48l-1.28-2.21,1.28-2.2Zm39.57,17.89-1.27-2.2,1.27-2.2H56.4l1.27,2.2-1.27,2.2Zm0-5.4-1.27-2.21,1.27-2.2H56.4l1.27,2.2-1.27,2.21Zm0-5.41-1.27-2.2,1.27-2.21H56.4l1.27,2.21-1.27,2.2Zm0-5.41-1.27-2.2,1.27-2.2H56.4l1.27,2.2-1.27,2.2Zm0-5.4-1.27-2.21,1.27-2.2H56.4l1.27,2.2-1.27,2.21Zm0-5.41-1.27-2.2,1.27-2.2H56.4l1.27,2.2-1.27,2.2Zm0-5.4-1.27-2.21,1.27-2.2H56.4l1.27,2.2-1.27,2.21Zm0-5.41-1.27-2.2,1.27-2.21H56.4l1.27,2.21-1.27,2.2Zm0-5.41-1.27-2.2,1.27-2.2H56.4l1.27,2.2-1.27,2.2Zm0-5.4-1.27-2.21,1.27-2.2H56.4l1.27,2.2-1.27,2.21Zm0-5.41-1.27-2.24,1.27-2.2H56.4l1.27,2.2-1.27,2.2ZM37.7,11.282h-2.51l-1-1.7h4.49Zm-3.38.5-1.27,2.21h-2.52l-1.27-2.21,1.27-2.2h2.52Zm-5.95-.5h-2.51l-1-1.7h4.48Zm-3.39.5-1.27,2.21H21.2l-1.27-2.21,1.27-2.2h2.51Zm-5.94-.5h-2.52l-1-1.7h4.49Zm-3.41.5-1.28,2.21h-2.51l-1.28-2.21,1.28-2.2h2.51Zm-6-.5H7.163l-1-1.7h4.48Zm0,1,1.27,2.21-1.27,2.2H7.163l-1.27-2.2,1.27-2.21Zm0,5.41,1.27,2.2L9.633,22.1H7.163l-1.27-2.21,1.27-2.2Zm0,5.41,1.27,2.2-1.27,2.2H7.163l-1.27-2.22,1.27-2.2Zm0,5.4,1.27,2.2-1.27,2.21H7.163L5.893,30.7l1.27-2.2Zm0,5.41,1.27,2.2-1.27,2.2H7.163l-1.27-2.2,1.27-2.2Zm0,5.4,1.27,2.21-1.27,2.2H7.163l-1.27-2.2,1.27-2.21Zm0,5.41,1.27,2.2-1.27,2.21H7.163l-1.27-2.21,1.27-2.2Zm0,5.41,1.27,2.2-1.27,2.2H7.163l-1.27-2.2,1.27-2.2Zm0,5.4,1.27,2.2-1.27,2.21H7.163l-1.27-2.21,1.27-2.2Zm0,5.41,1.27,2.2-1.27,2.2H7.163l-1.27-2.2,1.27-2.2Zm0,5.4,1.27,2.21-1.27,2.2H7.163l-1.27-2.2,1.27-2.21Zm0,5.41,1.27,2.2-1.27,2.21H7.163l-1.27-2.21,1.27-2.2Zm0,5.41,1.27,2.2-1.27,2.2H7.163l-1.27-2.2,1.27-2.2Zm0,5.4,1.27,2.2-1.27,2.21H7.163l-1.27-2.21,1.27-2.2Zm-3.78,13,1.27-2.21h2.51l1.27,2.21-1.27,2.2H7.163Zm9.36,0,1.27-2.21H19l1.27,2.21L19,97.762h-2.48Zm9.33,0,1.28-2.21h2.51l1.27,2.21-1.27,2.2h-2.47Zm9.33,0,1.28-2.21h2.51l1.28,2.21-1.28,2.2h-2.47Zm9.37,0,1.27-2.21h2.52l1.27,2.21-1.27,2.2h-2.48Zm9.34,0,1.27-2.21h2.51l1.27,2.21-1.27,2.2h-2.47Zm.39-89.2L51.783,8.6h-2.55l-1.27-2.2,1.27-2.21h2.55Zm-10.62,3.2,1.27,2.2-1.27,2.21h-2.48l-1.27-2.21,1.27-2.2h2.48Zm-28,90.9h-2.57l-1.23-2.18,1.29-2.22h2.51l1.28,2.2Zm9.37,0h-2.55l-1.25-2.18,1.28-2.22h2.51l1.28,2.2Zm9.33,0H30.5l-1.25-2.18,1.28-2.22h2.52l1.27,2.2Zm9.34,0h-2.55l-1.26-2.18,1.29-2.22h2.52l1.27,2.2Zm9.36,0h-2.54l-1.26-2.18,1.28-2.22h2.55l1.28,2.2Zm10.6-2.2-1.27,2.2h-2.54l-1.26-2.18,1.28-2.22h2.52Zm0-5.41-1.27,2.21h-2.52l-1.27-2.21,1.27-2.2h2.52Zm0-5.4-1.27,2.2h-2.52l-1.27-2.2,1.27-2.17h2.52Zm0-5.41-1.27,2.24h-2.52l-1.27-2.2,1.27-2.2h2.52Zm0-5.4-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21h2.52Zm0-5.41-1.27,2.2h-2.52l-1.27-2.15,1.27-2.2h2.52Zm0-5.41-1.27,2.21h-2.52l-1.27-2.21,1.27-2.2h2.52Zm0-5.4-1.27,2.2h-2.52l-1.27-2.2,1.27-2.14h2.52Zm0-5.41-1.27,2.27h-2.52l-1.27-2.2,1.27-2.2h2.52Zm0-5.4-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21h2.52Zm0-5.41-1.27,2.2h-2.52l-1.27-2.12,1.27-2.2h2.52Zm0-5.41L61.083,41h-2.52l-1.27-2.21,1.27-2.2h2.52Zm0-5.4-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21h2.52Zm0-5.41-1.27,2.2h-2.52l-1.27-2.2,1.27-2.2h2.52Zm0-5.4-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21h2.52Zm0-5.41-1.27,2.2h-2.52l-1.27-2.2,1.27-2.2h2.52Zm0-5.41-1.27,2.21h-2.52l-1.27-2.21,1.27-2.2h2.52Zm0-5.4-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21h2.52Zm-8.47-4.91h2.54l1.26,2.18L56.4,5.862h-2.51l-1.28-2.21Zm-9.33,0h2.54l1.26,2.18-1.28,2.23h-2.52l-1.27-2.21Zm-2.16,2.7,1.27,2.21-1.27,2.2h-2.14l1.29-4.41Zm-7.2-2.7h2.59l1,1.7H34.2Zm-9.34,0h2.54l1,1.7h-4.52Zm-9.33,0h2.54l1,1.7h-4.53Zm-9.36,0H9.7l1,1.7H6.173Zm-6,4.91,1.27-2.21h1.84l-1.3,4.41h-.49Zm0,5.4,1.27-2.2h2.54l1.27,2.2-1.27,2.21H2.483Zm0,5.41,1.27-2.2h2.54l1.27,2.2-1.27,2.2H2.483Zm0,5.41,1.27-2.21h2.54l1.27,2.21-1.27,2.2H2.483Zm0,5.4,1.27-2.2h2.54l1.27,2.2-1.27,2.2H2.483Zm0,5.41,1.27-2.21h2.54l1.27,2.21-1.27,2.2H2.483Zm0,5.4,1.27-2.2h2.54l1.27,2.2L4.973,41H2.483Zm0,5.41L2.433,42h2.54l1.27,2.2-1.27,2.2H2.483Zm0,5.41,1.27-2.21h2.54l1.27,2.21-1.27,2.2H2.483Zm0,5.4,1.27-2.2h2.54l1.27,2.2-1.22,2.27H2.483Zm0,5.41,1.32-2.14h2.54l1.27,2.21-1.27,2.2H2.483Zm0,5.4,1.27-2.2h2.54l1.27,2.2-1.27,2.21H2.483Zm0,5.41,1.27-2.2h2.54l1.27,2.2-1.27,2.2H2.483Zm0,5.41,1.27-2.21h2.54l1.27,2.21-1.27,2.2H2.483Zm0,5.4,1.27-2.2h2.54l1.27,2.2-1.22,2.24H2.483Zm0,5.41,1.32-2.17h2.54l1.27,2.21-1.27,2.2H2.483Zm0,5.4,1.27-2.2h2.54l1.27,2.2-1.27,2.21H2.483Zm1.27,3.21h2.54l1.27,2.2-1.27,2.2H2.483l-1.27-2.18Z",
    transform: "translate(663.453 4248.531)",
    fill: "#212222"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    id: "Vector-1",
    d: "M79.353,109.9V9.992a4.84,4.84,0,1,0-5.71-6.43H9.923a4.85,4.85,0,1,0-5.71,6.43V109.9a4.85,4.85,0,1,0,5.68,6.54h63.78a4.85,4.85,0,1,0,5.68-6.54Zm-1.19,8.55a3.871,3.871,0,0,1-3.86-3.86v-.36a3.994,3.994,0,0,1,.3-1.21,3.867,3.867,0,0,1,1.5-1.7,3.986,3.986,0,0,1,1.17-.49,3.923,3.923,0,0,1,.85-.1,3.86,3.86,0,0,1,0,7.72Zm-76.62-3.86a3.859,3.859,0,0,1,3.86-3.86,3.924,3.924,0,0,1,.85.1,3.986,3.986,0,0,1,1.17.49,3.867,3.867,0,0,1,1.5,1.7,4,4,0,0,1,.3,1.21v.36a3.86,3.86,0,0,1-7.72,0Zm5.64-4.51V9.812a4.89,4.89,0,0,0,2.88-3.23,2.74,2.74,0,0,1,.51-.06h62.41a2.74,2.74,0,0,1,.51.06,4.89,4.89,0,0,0,2.88,3.23v100.26a4.858,4.858,0,0,0-2.92,3.34,3.862,3.862,0,0,1-.48.05H10.583a3.861,3.861,0,0,1-.48-.05,4.86,4.86,0,0,0-2.92-3.33ZM5.4,1.452a3.86,3.86,0,0,1,3.86,3.83,3.41,3.41,0,0,1-.05.46A3.83,3.83,0,0,1,8.843,7a3.91,3.91,0,0,1-1.36,1.52,3.76,3.76,0,0,1-1.22.51,3.43,3.43,0,0,1-.86.11,3.86,3.86,0,1,1,0-7.71Zm76.62,3.83a3.86,3.86,0,0,1-3.86,3.86,3.43,3.43,0,0,1-.86-.11,3.76,3.76,0,0,1-1.22-.51A3.91,3.91,0,0,1,74.723,7a3.83,3.83,0,0,1-.37-1.26,3.4,3.4,0,0,1,0-.46,3.86,3.86,0,0,1,7.72,0Zm-3.67,104.47h-.19a4.981,4.981,0,0,0-.78.08V10.082a4.992,4.992,0,0,0,.78.08h.19Zm-5-105.19a4.529,4.529,0,0,0-.08.74,2.3,2.3,0,0,0,0,.26H10.233a2.3,2.3,0,0,0,0-.26,4.53,4.53,0,0,0-.08-.74Zm-68.17,5.58h.19a4.992,4.992,0,0,0,.78-.08v99.73a4.981,4.981,0,0,0-.78-.08h-.19Zm5,105.3a4.809,4.809,0,0,0,.09-.85v-.15c0-.05.22,0,.34,0h62.71c.11,0,0,.1,0,.15a4.808,4.808,0,0,0,.09.85Z",
    transform: "translate(653.46 4239.563)",
    fill: "#212222"
  })));
};

/* harmony default export */ var icons_IconSoundboks3 = (IconSoundboks3_IconSoundboks3);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/learn-more/whats-bluetooth-speaker/icons/IconPASystem.tsx
var IconPASystem_jsx = react_default.a.createElement;


var IconPASystem_IconPASystem = function IconPASystem() {
  return /*#__PURE__*/react_default.a.createElement("svg", {
    width: 81,
    height: 81,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react_default.a.createElement("g", {
    fill: "#212222"
  }, /*#__PURE__*/react_default.a.createElement("path", {
    d: "M33.417 39.027a1.16 1.16 0 1 0 2.32 0 1.16 1.16 0 0 0-2.32 0ZM10.09 40.194a1.16 1.16 0 1 0-.013-2.321 1.16 1.16 0 0 0 .014 2.32ZM34.577 74.774a1.167 1.167 0 1 0 1.103.713 1.158 1.158 0 0 0-1.103-.713ZM10.09 74.774a1.167 1.167 0 1 0-.013 2.333 1.167 1.167 0 0 0 .013-2.333ZM22.33 54.32a11.42 11.42 0 1 0 .04 22.839 11.42 11.42 0 0 0-.04-22.838Zm0 22.167a10.753 10.753 0 1 1 10.774-10.753 10.767 10.767 0 0 1-10.773 10.753Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M22.33 57.147a8.587 8.587 0 1 0 8.587 8.587 8.6 8.6 0 0 0-8.587-8.587Zm0 16.507a7.92 7.92 0 1 1 7.92-7.92 7.926 7.926 0 0 1-7.92 7.92Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M22.33 61.954a3.78 3.78 0 1 0 0 7.559 3.78 3.78 0 0 0 0-7.56Zm0 6.893a3.113 3.113 0 1 1 3.113-3.113 3.119 3.119 0 0 1-3.113 3.127v-.014ZM22.33 51.914a6.627 6.627 0 1 0-6.62-6.627 6.666 6.666 0 0 0 6.62 6.627Zm0-12.58a5.96 5.96 0 1 1-5.953 5.953 5.967 5.967 0 0 1 5.953-5.953Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M22.33 48.247a2.96 2.96 0 1 0 0-5.919 2.96 2.96 0 0 0 0 5.92Zm0-5.253a2.293 2.293 0 1 1-2.293 2.293 2.3 2.3 0 0 1 2.293-2.293Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M71.237 34.387H61.53a4.173 4.173 0 0 0 2-3.567V5.427a4.193 4.193 0 0 0-4.187-4.187H21.55a4.193 4.193 0 0 0-4.187 4.187v25.394a4.18 4.18 0 0 0 2 3.566H9.637a4.194 4.194 0 0 0-4.187 4.187v37.813a4.193 4.193 0 0 0 4.187 4.187H35.03a4.194 4.194 0 0 0 4.187-4.187V38.574a4.195 4.195 0 0 0-2-3.573h6.48a4.193 4.193 0 0 0-2 3.573v37.813a4.193 4.193 0 0 0 4.186 4.187h25.354a4.193 4.193 0 0 0 4.187-4.187V38.574a4.193 4.193 0 0 0-4.187-4.187ZM18.03 30.82V5.427a3.527 3.527 0 0 1 3.52-3.52h37.813a3.527 3.527 0 0 1 3.52 3.52v25.394a3.52 3.52 0 0 1-3.52 3.513H21.55a3.52 3.52 0 0 1-3.52-3.514Zm20.52 7.754v37.813a3.527 3.527 0 0 1-3.52 3.52H9.637a3.527 3.527 0 0 1-3.52-3.52V38.574a3.527 3.527 0 0 1 3.52-3.52H35.03a3.527 3.527 0 0 1 3.52 3.52Zm36.207 37.813a3.527 3.527 0 0 1-3.52 3.52H45.844a3.526 3.526 0 0 1-3.52-3.52V38.574a3.527 3.527 0 0 1 3.52-3.52h25.393a3.527 3.527 0 0 1 3.52 3.52v37.813Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M70.783 37.867a1.16 1.16 0 1 0 .014 2.32 1.16 1.16 0 0 0-.014-2.32ZM46.297 40.194a1.16 1.16 0 1 0 0-2.322 1.16 1.16 0 0 0 0 2.322ZM70.784 74.774a1.166 1.166 0 1 0 1.08.719 1.16 1.16 0 0 0-1.08-.72ZM46.296 74.774a1.167 1.167 0 1 0 1.074.72 1.16 1.16 0 0 0-1.074-.72ZM58.544 54.32a11.42 11.42 0 1 0 11.413 11.414A11.427 11.427 0 0 0 58.544 54.32Zm0 22.167A10.754 10.754 0 1 1 69.29 65.734a10.767 10.767 0 0 1-10.746 10.753Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M58.544 57.147a8.586 8.586 0 1 0-.054 17.173 8.586 8.586 0 0 0 .054-17.173Zm0 16.507a7.92 7.92 0 1 1 7.893-7.92 7.926 7.926 0 0 1-7.893 7.92Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M58.544 61.954a3.78 3.78 0 1 0 0 7.56 3.78 3.78 0 0 0 0-7.56Zm0 6.893a3.113 3.113 0 1 1 3.113-3.113 3.114 3.114 0 0 1-3.113 3.127v-.014ZM58.544 51.914a6.626 6.626 0 1 0 0-13.252 6.626 6.626 0 0 0 0 13.252Zm0-12.58a5.96 5.96 0 1 1-5.96 5.953 5.967 5.967 0 0 1 5.96-5.953Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M58.544 48.247a2.96 2.96 0 1 0-2.96-2.96 2.966 2.966 0 0 0 2.96 2.96Zm0-5.253a2.293 2.293 0 1 1-2.293 2.293 2.3 2.3 0 0 1 2.293-2.293ZM22.004 7.04a1.167 1.167 0 1 0-1.078-.714 1.16 1.16 0 0 0 1.078.714ZM23.163 30.367a1.168 1.168 0 1 0-2.335-.013 1.168 1.168 0 0 0 2.335.013ZM58.91 7.04a1.167 1.167 0 1 0 .054-2.332 1.167 1.167 0 0 0-.053 2.333ZM58.91 29.207a1.16 1.16 0 1 0 .013 2.32 1.16 1.16 0 0 0-.013-2.32ZM48.71 29.527a11.42 11.42 0 1 0-11.413-11.42 11.433 11.433 0 0 0 11.413 11.42Zm0-22.166a10.753 10.753 0 1 1-10.746 10.746A10.76 10.76 0 0 1 48.71 7.374V7.36Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M48.71 26.707a8.587 8.587 0 1 0-8.587-8.587 8.6 8.6 0 0 0 8.587 8.587Zm0-16.507a7.92 7.92 0 1 1-5.601 2.318 7.927 7.927 0 0 1 5.6-2.324v.006Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M48.71 21.9a3.78 3.78 0 1 0 0-7.558 3.78 3.78 0 0 0 0 7.559Zm0-6.893a3.113 3.113 0 1 1-3.113 3.114 3.12 3.12 0 0 1 3.114-3.114ZM28.263 24.747a6.627 6.627 0 1 0-6.626-6.626 6.666 6.666 0 0 0 6.626 6.626Zm0-12.58a5.961 5.961 0 1 1-5.96 5.954 5.96 5.96 0 0 1 5.96-5.927v-.027Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M28.264 21.08a2.96 2.96 0 1 0 0-5.92 2.96 2.96 0 0 0 0 5.92Zm0-5.253a2.293 2.293 0 1 1-2.294 2.293 2.3 2.3 0 0 1 2.294-2.293Z"
  })));
};

/* harmony default export */ var icons_IconPASystem = (IconPASystem_IconPASystem);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/learn-more/whats-bluetooth-speaker/icons/IconSpeaker.tsx
var IconSpeaker_jsx = react_default.a.createElement;


var IconSpeaker_IconSpeaker = function IconSpeaker() {
  return /*#__PURE__*/react_default.a.createElement("svg", {
    width: 81,
    height: 81,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react_default.a.createElement("g", {
    clipPath: "url(#a)",
    fill: "#212222"
  }, /*#__PURE__*/react_default.a.createElement("path", {
    d: "M25.297 41.767a10.6 10.6 0 1 0 10.6 10.6 10.607 10.607 0 0 0-10.6-10.6Zm0 20.533a9.934 9.934 0 1 1 9.934-9.933 9.946 9.946 0 0 1-9.934 9.933Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M25.297 47.747a4.62 4.62 0 1 0 4.62 4.62 4.627 4.627 0 0 0-4.62-4.62Zm0 8.567a3.953 3.953 0 1 1 0-7.907 3.953 3.953 0 0 1 0 7.907ZM21.284 69.794a1.167 1.167 0 1 0 1.073.72 1.16 1.16 0 0 0-1.073-.72ZM29.31 69.794a1.167 1.167 0 1 0-.013 2.333 1.167 1.167 0 0 0 .013-2.333ZM56.297 41.767a10.6 10.6 0 1 0 10.6 10.6 10.614 10.614 0 0 0-10.6-10.6Zm0 20.533a9.934 9.934 0 1 1 9.934-9.933 9.946 9.946 0 0 1-9.934 9.933Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M56.297 47.747a4.62 4.62 0 1 0 4.667 4.62 4.625 4.625 0 0 0-4.667-4.62Zm0 8.567a3.953 3.953 0 1 1 .093-7.905 3.953 3.953 0 0 1-.093 7.905ZM52.297 69.794a1.167 1.167 0 1 0 1.08.719 1.159 1.159 0 0 0-1.08-.72ZM60.296 69.794a1.167 1.167 0 1 0 1.074.72 1.16 1.16 0 0 0-1.074-.72Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "m76.784 68.654-.667-1.86a1.333 1.333 0 0 0-1.334-.88l-.526-1.474a.355.355 0 0 0-.667.24l.52 1.474a1.334 1.334 0 0 0-.493 1.547l.666 1.853a.841.841 0 0 0 .434.486c.115.053.24.08.367.08a.872.872 0 0 0 .286-.053l.233-.08a3.794 3.794 0 0 1-.446 3.574c-1.114 1.48-3.26 2.093-4.627 2.106v-35.42a3.013 3.013 0 0 0-3.007-3.007h-22.4a3.013 3.013 0 0 0-3.006 3.007v34.127c-1.227-.053-2.153-.04-2.627 0V40.247a3.013 3.013 0 0 0-3.007-3.007H14.11a3.013 3.013 0 0 0-3.006 3.007v37.334a3.013 3.013 0 0 0 3.006 3.006h22.373a3.013 3.013 0 0 0 3.007-3.007v-2.546c.453 0 1.393-.034 2.627 0v2.526a3.013 3.013 0 0 0 3.007 3.007h22.373a3.013 3.013 0 0 0 3.007-3.006v-1.227c1.526 0 3.913-.72 5.16-2.38a4.506 4.506 0 0 0 .54-4.2h.073a.847.847 0 0 0 .507-1.1Zm-37.96 8.913a2.346 2.346 0 0 1-2.34 2.34H14.11a2.34 2.34 0 0 1-2.34-2.34V40.234a2.34 2.34 0 0 1 2.34-2.34h22.373a2.347 2.347 0 0 1 2.34 2.34v37.333Zm31.013 0a2.34 2.34 0 0 1-2.34 2.34H45.124a2.346 2.346 0 0 1-2.34-2.34V40.234a2.347 2.347 0 0 1 2.34-2.34h22.373a2.34 2.34 0 0 1 2.34 2.34v37.333Zm5.28-8.126a.174.174 0 0 1-.14 0 .154.154 0 0 1-.094-.1l-.666-1.86a.665.665 0 0 1 0-.514.667.667 0 0 1 .113-.153l.614-.22a.667.667 0 0 1 .526.433l.667 1.853a.174.174 0 0 1 0 .14.153.153 0 0 1-.1.094l-.92.326Z"
  })), /*#__PURE__*/react_default.a.createElement("defs", null, /*#__PURE__*/react_default.a.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/react_default.a.createElement("path", {
    fill: "#fff",
    transform: "translate(11.104 37.24)",
    d: "M0 0h65.733v43.333H0z"
  }))));
};

/* harmony default export */ var icons_IconSpeaker = (IconSpeaker_IconSpeaker);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/learn-more/whats-bluetooth-speaker/index.web.tsx
var whats_bluetooth_speaker_index_web_jsx = react_default.a.createElement;








 // eslint-disable-next-line prefer-arrow-callback

var index_web_WhatsBluetoothSpeaker = /*#__PURE__*/react_default.a.memo(function WhatsBluetoothSpeaker() {
  var icons = [{
    packageItemId: 'bt-speakers',
    title: 'BT Speakers',
    icon: /*#__PURE__*/react_default.a.createElement(icons_IconSpeaker, null)
  }, {
    packageItemId: 'soundboks-gen-3-rf',
    title: 'SOUNDBOKS (Gen. 3)',
    icon: /*#__PURE__*/react_default.a.createElement(icons_IconSoundboks3, null)
  }, {
    packageItemId: 'pa-systems',
    title: 'PA Systems',
    icon: /*#__PURE__*/react_default.a.createElement(icons_IconPASystem, null)
  }];
  var attributeData = [{
    text: 'Concert-level Volumne',
    checks: [false, true, true]
  }, {
    text: 'Crowd-ready Durability',
    checks: [false, true, false]
  }, {
    text: 'Bluetooth Connectivity',
    checks: [true, true, false]
  }, {
    text: '6-second Setup',
    checks: [true, true, false]
  }, {
    text: 'Swappable Battery',
    checks: [false, true, false]
  }, {
    text: 'Wirelessly Pairable',
    checks: [true, true, false]
  }, {
    text: 'Microphone & Instrument Inputs',
    checks: [false, true, false]
  }, {
    text: 'App Compatibility',
    checks: [true, true, false]
  }, {
    text: 'Upgradable Features (Via App)',
    checks: [false, true, false]
  }];
  return /*#__PURE__*/react_default.a.createElement(Table, null, /*#__PURE__*/react_default.a.createElement(whats_bluetooth_speaker_styled_ImageWrapper, null, /*#__PURE__*/react_default.a.createElement(EmptyCell, null), icons.map(function (image, index) {
    return /*#__PURE__*/react_default.a.createElement("div", {
      key: image.packageItemId + index
    }, image.icon);
  })), /*#__PURE__*/react_default.a.createElement(ImageTextWrapper, null, /*#__PURE__*/react_default.a.createElement(EmptyCell, null), icons.map(function (image, index) {
    return /*#__PURE__*/react_default.a.createElement("div", {
      key: image.title + index,
      style: {
        width: '80px',
        margin: '0 auto'
      }
    }, image.title);
  })), /*#__PURE__*/react_default.a.createElement(HorizontalLine, {
    color: styles_theme["a" /* default */].colors.white
  }), attributeData.map(function (row, index) {
    return /*#__PURE__*/react_default.a.createElement(attribute_row_AttributeRow, {
      key: row.text + index,
      text: row.text,
      checks: row.checks
    });
  }), /*#__PURE__*/react_default.a.createElement(LastParagraph, null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.learn-more.whats-bluetooth-speaker"
  })));
});
// CONCATENATED MODULE: ./utils/product/helpCenter.js
var helpCenter_getHelpCenterUrl = function getHelpCenterUrl(regionId, slug) {
  var baseUrl = 'https://soundboks.zendesk.com/hc';

  switch (regionId) {
    case 'de':
      return "".concat(baseUrl, "/de").concat(slug);

    case 'fr':
      return "".concat(baseUrl, "/fr-fr").concat(slug);

    default:
      return "".concat(baseUrl, "/en-gb").concat(slug);
  }
};
// CONCATENATED MODULE: ./public/static/icons/package-items-icons/IconBattery.tsx
var IconBattery_jsx = react_default.a.createElement;


var IconBattery_IconBattery = function IconBattery() {
  return /*#__PURE__*/react_default.a.createElement("svg", {
    width: "44",
    height: "100",
    viewBox: "0 0 44 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react_default.a.createElement("path", {
    d: "M42.634 38.9116H42.274V2.5816C42.274 2.00078 42.0433 1.44374 41.6326 1.03304C41.2219 0.622331 40.6649 0.391602 40.084 0.391602H3.92402C3.3432 0.391602 2.78617 0.622331 2.37546 1.03304C1.96476 1.44374 1.73402 2.00078 1.73402 2.5816V38.8916H1.37402C1.10881 38.8916 0.854452 38.997 0.666916 39.1845C0.47938 39.372 0.374023 39.6264 0.374023 39.8916V53.4416C0.374023 53.7068 0.47938 53.9612 0.666916 54.1487C0.854452 54.3363 1.10881 54.4416 1.37402 54.4416H1.73402V90.5816C1.73271 90.87 1.78838 91.1559 1.89785 91.4228C2.00732 91.6896 2.16842 91.9322 2.37191 92.1366C2.57541 92.341 2.81728 92.5033 3.08363 92.614C3.34999 92.7246 3.63558 92.7816 3.92402 92.7816H18.554C18.9474 92.9074 19.353 92.9912 19.764 93.0316V98.8416L19.914 98.9916C20.5168 99.4318 21.262 99.6314 22.004 99.5516C22.7461 99.6314 23.4913 99.4318 24.094 98.9916L24.244 98.8416V92.9816C24.655 92.9411 25.0606 92.8573 25.454 92.7316H40.084C40.3725 92.7316 40.6581 92.6746 40.9244 92.5639C41.1908 92.4533 41.4326 92.2911 41.6361 92.0866C41.8396 91.8822 42.0007 91.6396 42.1102 91.3727C42.2197 91.1059 42.2753 90.8201 42.274 90.5316V54.4716H42.624C42.8892 54.4716 43.1436 54.3662 43.3311 54.1787C43.5187 53.9912 43.624 53.7368 43.624 53.4716V39.9116C43.624 39.6481 43.5201 39.3953 43.3347 39.208C43.1493 39.0208 42.8975 38.9142 42.634 38.9116ZM42.634 53.4616H42.324H41.324C38.994 53.5316 34.094 53.6216 24.454 53.6416H19.604C9.96402 53.6416 5.06402 53.5316 2.73402 53.4616H1.73402H1.41402V39.9116H1.72403H2.72403C5.06403 39.8416 9.98403 39.7516 19.594 39.7316H24.394C34.004 39.7316 38.914 39.8416 41.264 39.9116H42.264H42.584L42.634 53.4616ZM24.864 91.7316V91.8616C24.6595 91.9097 24.4526 91.9464 24.244 91.9716C22.7557 92.145 21.2523 92.145 19.764 91.9716C19.5548 91.9513 19.3475 91.9145 19.144 91.8616V85.8616C21.0423 86.1149 22.9658 86.1149 24.864 85.8616V91.7316ZM24.724 82.8216C24.0846 82.9178 23.4402 82.9779 22.794 83.0016V84.0016C23.4632 83.9796 24.1308 83.9229 24.794 83.8316V84.8316C22.9168 85.0983 21.0113 85.0983 19.134 84.8316L19.194 83.8316C19.8373 83.9218 20.4849 83.9785 21.134 84.0016V83.0016C20.4878 82.9779 19.8435 82.9178 19.204 82.8216L19.264 81.8216C21.0292 82.0616 22.8188 82.0616 24.584 81.8216L24.724 82.8216ZM24.494 78.9016C23.9306 78.9854 23.3632 79.0388 22.794 79.0616V80.0616C23.3699 80.0406 23.9441 79.9871 24.514 79.9016L24.564 80.8016C22.84 81.055 21.0881 81.055 19.364 80.8016L19.414 79.9016C19.9839 79.9871 20.5581 80.0406 21.134 80.0616V79.0616C20.5649 79.0388 19.9974 78.9854 19.434 78.9016L19.494 77.7716C21.1061 77.9983 22.742 77.9983 24.354 77.7716L24.494 78.9016ZM22.004 76.9016C21.2108 76.9077 20.4183 76.8508 19.634 76.7316L20.004 70.4816H24.004L24.364 76.7716C23.5831 76.8903 22.7939 76.9472 22.004 76.9416V76.9016ZM23.404 69.4416H20.604V54.6916H23.404V69.4416ZM19.074 23.0616C19.9095 22.8424 20.7703 22.7348 21.634 22.7416V21.7416C20.7482 21.74 19.8652 21.8441 19.004 22.0516C19.004 21.8216 19.004 21.5916 19.004 21.3716C20.0006 21.0832 21.0374 20.9582 22.074 21.0016C23.1106 20.9582 24.1474 21.0832 25.144 21.3716C25.144 21.5916 25.144 21.8216 25.144 22.0516C24.2828 21.8441 23.3999 21.74 22.514 21.7416V22.7416C23.3777 22.7348 24.2386 22.8424 25.074 23.0616C25.074 23.3616 25.074 23.6616 25.004 23.9516C24.0755 23.6831 23.1099 23.565 22.144 23.6016C21.1781 23.565 20.2126 23.6831 19.284 23.9516C19.124 23.7016 19.094 23.4016 19.074 23.1016V23.0616ZM18.784 19.4516V19.3316C19.7016 19.0239 20.6666 18.8817 21.634 18.9116V17.9116C20.6577 17.9038 19.6851 18.0317 18.744 18.2916C18.744 17.8316 18.744 17.3916 18.744 16.9716C19.7963 16.6368 20.9025 16.5045 22.004 16.5816C23.1294 16.5138 24.2573 16.6667 25.324 17.0316C25.324 17.4516 25.324 17.8916 25.324 18.3516C24.3829 18.0917 23.4103 17.9638 22.434 17.9716V18.9716C23.4014 18.9417 24.3664 19.0839 25.284 19.3916V19.5116C25.284 19.8116 25.284 20.1116 25.214 20.4116C24.1854 20.1488 23.1252 20.031 22.064 20.0616C21.0029 20.031 19.9426 20.1488 18.914 20.4116C18.834 20.0916 18.804 19.7916 18.784 19.4916V19.4516ZM22.004 15.5816C20.884 15.5434 19.7647 15.6749 18.684 15.9716C18.754 13.2416 19.224 11.4116 20.114 10.4616C20.3614 10.2119 20.6557 10.0136 20.9801 9.87833C21.3045 9.74303 21.6525 9.67337 22.004 9.67337C22.3555 9.67337 22.7035 9.74303 23.0279 9.87833C23.3523 10.0136 23.6467 10.2119 23.894 10.4616C24.784 11.4116 25.254 13.2416 25.324 15.9716C24.2434 15.6749 23.124 15.5434 22.004 15.5816ZM22.004 24.6616C22.9404 24.5967 23.88 24.7261 24.764 25.0416C24.504 27.9816 24.244 30.4116 24.134 31.3716H19.874C19.764 30.3716 19.514 27.9916 19.244 25.0616C20.1209 24.7163 21.0642 24.5727 22.004 24.6416V24.6616ZM20.604 32.3716H23.404V38.7016H20.604V32.3716ZM41.274 27.4516H36.274C36.1484 27.4516 36.0278 27.4024 35.9381 27.3146C35.8484 27.2267 35.7966 27.1072 35.794 26.9816C35.7966 26.8551 35.848 26.7345 35.9374 26.645C36.0269 26.5555 36.1475 26.5042 36.274 26.5016H41.274V27.4516ZM41.274 23.4516H36.274C36.1484 23.4516 36.0278 23.4024 35.9381 23.3146C35.8484 23.2267 35.7966 23.1072 35.794 22.9816C35.7966 22.8551 35.848 22.7345 35.9374 22.645C36.0269 22.5555 36.1475 22.5042 36.274 22.5016H41.274V23.4516ZM41.274 19.4016H36.274C36.1484 19.4016 36.0278 19.3524 35.9381 19.2646C35.8484 19.1767 35.7966 19.0572 35.794 18.9316C35.7966 18.8051 35.848 18.6845 35.9374 18.595C36.0269 18.5055 36.1475 18.4542 36.274 18.4516H41.274V19.4016ZM41.274 15.4016H36.274C36.1414 15.4016 36.0142 15.3489 35.9205 15.2552C35.8267 15.1614 35.774 15.0342 35.774 14.9016C35.774 14.769 35.8267 14.6418 35.9205 14.548C36.0142 14.4543 36.1414 14.4016 36.274 14.4016H41.274V15.4016ZM41.274 11.3516H36.274C36.1414 11.3516 36.0142 11.2989 35.9205 11.2052C35.8267 11.1114 35.774 10.9842 35.774 10.8516C35.774 10.719 35.8267 10.5918 35.9205 10.498C36.0142 10.4043 36.1414 10.3516 36.274 10.3516H41.274V11.3516ZM2.73402 2.5816C2.73402 2.266 2.8594 1.96331 3.08257 1.74014C3.30574 1.51697 3.60842 1.3916 3.92402 1.3916H40.084C40.3996 1.3916 40.7023 1.51697 40.9255 1.74014C41.1486 1.96331 41.274 2.266 41.274 2.5816V9.2816H36.274C35.8762 9.2816 35.4947 9.43964 35.2134 9.72095C34.9321 10.0023 34.774 10.3838 34.774 10.7816C34.774 11.1794 34.9321 11.561 35.2134 11.8423C35.4947 12.1236 35.8762 12.2816 36.274 12.2816H41.274V13.3716H36.274C35.8762 13.3716 35.4947 13.5296 35.2134 13.8109C34.9321 14.0922 34.774 14.4738 34.774 14.8716C34.774 15.2694 34.9321 15.651 35.2134 15.9323C35.4947 16.2136 35.8762 16.3716 36.274 16.3716H41.274V17.4616H36.274C36.0701 17.4448 35.8649 17.4705 35.6714 17.537C35.478 17.6035 35.3004 17.7094 35.1499 17.848C34.9994 17.9866 34.8792 18.1549 34.7971 18.3423C34.7149 18.5296 34.6725 18.732 34.6725 18.9366C34.6725 19.1412 34.7149 19.3436 34.7971 19.531C34.8792 19.7183 34.9994 19.8866 35.1499 20.0253C35.3004 20.1639 35.478 20.2698 35.6714 20.3363C35.8649 20.4028 36.0701 20.4284 36.274 20.4116H41.274V21.5116H36.274C35.8762 21.5116 35.4947 21.6696 35.2134 21.9509C34.9321 22.2322 34.774 22.6138 34.774 23.0116C34.774 23.4094 34.9321 23.791 35.2134 24.0723C35.4947 24.3536 35.8762 24.5116 36.274 24.5116H41.274V25.6116H36.274C36.0701 25.5948 35.8649 25.6205 35.6714 25.687C35.478 25.7535 35.3004 25.8593 35.1499 25.998C34.9994 26.1366 34.8792 26.3049 34.7971 26.4922C34.7149 26.6796 34.6725 26.882 34.6725 27.0866C34.6725 27.2912 34.7149 27.4936 34.7971 27.681C34.8792 27.8683 34.9994 28.0366 35.1499 28.1752C35.3004 28.3139 35.478 28.4198 35.6714 28.4863C35.8649 28.5528 36.0701 28.5784 36.274 28.5616H41.274V38.9916C38.914 38.9216 33.984 38.8316 24.404 38.8116V32.4816H25.004V32.0416C25.004 31.9816 25.704 25.7316 26.144 19.6916C26.504 14.5616 26.004 11.4416 24.554 9.8916C24.212 9.54023 23.8031 9.26095 23.3514 9.07025C22.8997 8.87955 22.4143 8.7813 21.924 8.7813C21.4337 8.7813 20.9484 8.87955 20.4966 9.07025C20.0449 9.26095 19.636 9.54023 19.294 9.8916C17.844 11.4416 17.344 14.5616 17.704 19.6916C18.144 25.6916 18.844 31.9816 18.844 32.0416V32.4816H19.474V38.8116C9.89403 38.8116 4.97402 38.9216 2.60402 38.9916L2.73402 2.5816ZM2.73402 90.5316V54.5316C5.08402 54.6016 9.99402 54.6916 19.604 54.7116V69.4816H19.054L18.144 85.2716V91.7316H3.92402C3.61597 91.7293 3.32061 91.6086 3.09908 91.3945C2.87756 91.1805 2.74685 90.8894 2.73402 90.5816V90.5316ZM23.244 98.3016C22.4389 98.5686 21.5691 98.5686 20.764 98.3016V93.0616C21.124 93.0616 21.524 93.0616 22.004 93.0616C22.484 93.0616 22.884 93.0616 23.244 93.0616V98.3016ZM41.244 90.5316C41.244 90.8482 41.119 91.1519 40.8961 91.3766C40.6732 91.6014 40.3706 91.729 40.054 91.7316H25.864V85.2416L25.004 69.4816H24.404V54.6916C34.014 54.6916 38.924 54.5816 41.274 54.5116L41.244 90.5316Z",
    fill: "#212222"
  }));
};

/* harmony default export */ var package_items_icons_IconBattery = (IconBattery_IconBattery);
// CONCATENATED MODULE: ./public/static/icons/package-items-icons/IconCharger.tsx
var IconCharger_jsx = react_default.a.createElement;


var IconCharger_IconCharger = function IconCharger() {
  return /*#__PURE__*/react_default.a.createElement("svg", {
    width: "120",
    height: "120",
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react_default.a.createElement("g", {
    clipPath: "url(#clip0_333_569)"
  }, /*#__PURE__*/react_default.a.createElement("path", {
    d: "M62.215 21.235C62.3476 21.235 62.4748 21.1823 62.5685 21.0886C62.6623 20.9948 62.715 20.8676 62.715 20.735V16.295C62.715 16.1624 62.6623 16.0352 62.5685 15.9415C62.4748 15.8477 62.3476 15.795 62.215 15.795H49.565L46.805 16.205C46.6857 16.2239 46.577 16.2846 46.4983 16.3762C46.4195 16.4677 46.3759 16.5842 46.375 16.705V17.065H43.005C42.8724 17.065 42.7452 17.1177 42.6514 17.2115C42.5577 17.3052 42.505 17.4324 42.505 17.565V19.465C42.505 19.5976 42.5577 19.7248 42.6514 19.8186C42.7452 19.9123 42.8724 19.965 43.005 19.965H46.315V20.335C46.3182 20.454 46.3629 20.5682 46.4415 20.6577C46.52 20.7472 46.6274 20.8064 46.745 20.825L49.505 21.235H53.005L53.315 26.855C53.3201 26.9841 53.3751 27.1062 53.4683 27.1957C53.5615 27.2852 53.6858 27.3351 53.815 27.335H54.755V81.485C53.5273 77.8835 51.2034 74.7564 48.109 72.542C45.0147 70.3276 41.305 69.137 37.5 69.137C33.6949 69.137 29.9853 70.3276 26.8909 72.542C23.7966 74.7564 21.4727 77.8835 20.245 81.485V60.835H21.125C21.2525 60.8352 21.3754 60.7867 21.4683 60.6993C21.5613 60.6119 21.6173 60.4923 21.625 60.365L22.085 53.155H32.535C32.9514 53.155 33.3507 52.9896 33.6451 52.6952C33.9396 52.4007 34.105 52.0014 34.105 51.585V17.365C34.1103 17.1555 34.0737 16.947 33.9971 16.7519C33.9206 16.5568 33.8058 16.3789 33.6595 16.2289C33.5132 16.0788 33.3383 15.9596 33.1452 15.8782C32.952 15.7968 32.7446 15.7549 32.535 15.755H16.535C16.3288 15.7602 16.1256 15.806 15.9371 15.8897C15.7486 15.9734 15.5785 16.0935 15.4364 16.243C15.2943 16.3925 15.1831 16.5686 15.109 16.7611C15.035 16.9536 14.9997 17.1588 15.005 17.365V51.585C15.0076 52.0023 15.1752 52.4016 15.4713 52.6958C15.7673 52.9899 16.1677 53.155 16.585 53.155H17.415L17.875 60.365C17.8826 60.4923 17.9387 60.6119 18.0316 60.6993C18.1246 60.7867 18.2474 60.8352 18.375 60.835H19.255V87.405C19.198 89.8382 19.6281 92.2583 20.5199 94.5229C21.4117 96.7876 22.7472 98.8511 24.448 100.592C26.1488 102.333 28.1805 103.717 30.4236 104.661C32.6667 105.606 35.0761 106.092 37.51 106.092C39.9439 106.092 42.3532 105.606 44.5964 104.661C46.8395 103.717 48.8712 102.333 50.5719 100.592C52.2727 98.8511 53.6083 96.7876 54.5001 94.5229C55.3919 92.2583 55.8219 89.8382 55.765 87.405V27.335H56.705C56.8335 27.3327 56.9563 27.282 57.049 27.193C57.1418 27.104 57.1974 26.9833 57.205 26.855L57.505 21.235H62.215ZM16.005 51.585V17.365C16.005 17.2893 16.02 17.2144 16.0493 17.1445C16.0786 17.0747 16.1215 17.0114 16.1754 16.9584C16.2294 16.9053 16.2935 16.8635 16.3638 16.8355C16.4341 16.8074 16.5093 16.7937 16.585 16.795H32.585C32.6602 16.7936 32.7349 16.8075 32.8047 16.8356C32.8745 16.8638 32.9378 16.9057 32.9911 16.9589C33.0443 17.0121 33.0862 17.0755 33.1144 17.1453C33.1425 17.215 33.1563 17.2898 33.155 17.365V51.585C33.155 51.7362 33.0949 51.8812 32.988 51.9881C32.8811 52.0949 32.7362 52.155 32.585 52.155H16.585C16.4329 52.155 16.2868 52.0953 16.1784 51.9887C16.0699 51.8821 16.0076 51.7371 16.005 51.585ZM18.415 53.155H21.095L20.665 59.835H18.815L18.415 53.155ZM37.505 104.665C34.0955 104.665 30.7625 103.655 27.9263 101.763C25.0901 99.8708 22.8779 97.181 21.5686 94.033C20.2594 90.885 19.9118 87.4197 20.5697 84.0744C21.2276 80.729 22.8615 77.6534 25.2654 75.2356C27.6693 72.8179 30.7353 71.1662 34.0768 70.4889C37.4183 69.8117 40.8856 70.1393 44.0411 71.4303C47.1966 72.7214 49.8991 74.918 51.8077 77.7433C53.7162 80.5685 54.7452 83.8956 54.765 87.305V87.425C54.7544 92.001 52.9291 96.386 49.6897 99.618C46.4502 102.85 42.061 104.665 37.485 104.665H37.505ZM43.555 18.965V18.065H46.365V18.965H43.555ZM47.365 19.465V17.135L49.125 16.875V20.155L47.365 19.895V19.465ZM50.105 16.755H61.715V20.195H57.275C57.0587 19.8521 56.7591 19.5696 56.4041 19.3738C56.0492 19.178 55.6504 19.0753 55.245 19.0753C54.8396 19.0753 54.4408 19.178 54.0858 19.3738C53.7308 19.5696 53.4312 19.8521 53.215 20.195H50.105V16.755ZM56.215 26.295H54.275L53.975 20.845C54.1197 20.6337 54.3078 20.4557 54.5269 20.3229C54.7459 20.1901 54.9907 20.1056 55.245 20.075C55.4981 20.1051 55.7416 20.1894 55.9591 20.3223C56.1766 20.4552 56.3628 20.6335 56.505 20.845L56.215 26.295Z",
    fill: "#212222"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M103.005 93.755C101.998 92.6459 101.439 91.2028 101.435 89.705L101.345 84.705C101.342 84.5741 101.289 84.4495 101.195 84.3579C101.102 84.2663 100.976 84.215 100.845 84.215H99.845V32.605C99.9019 30.1718 99.4719 27.7517 98.5801 25.4871C97.6883 23.2224 96.3527 21.159 94.6519 19.4179C92.9512 17.6769 90.9195 16.2934 88.6764 15.3488C86.4332 14.4043 84.0239 13.9177 81.59 13.9177C79.1561 13.9177 76.7467 14.4043 74.5036 15.3488C72.2605 16.2934 70.2288 17.6769 68.528 19.4179C66.8272 21.159 65.4917 23.2224 64.5999 25.4871C63.7081 27.7517 63.278 30.1718 63.335 32.605V86.065H62.335C62.2049 86.0675 62.0806 86.1196 61.9876 86.2107C61.8947 86.3018 61.8401 86.425 61.835 86.555L61.745 91.465L60.855 95.405C60.855 95.405 60.855 95.475 60.855 95.515V102.815C60.8576 103.187 61.0073 103.543 61.2715 103.806C61.5356 104.068 61.8928 104.215 62.265 104.215H65.445C65.8172 104.215 66.1743 104.068 66.4385 103.806C66.7026 103.543 66.8523 103.187 66.855 102.815V95.515C66.8597 95.4785 66.8597 95.4415 66.855 95.405L65.975 91.465L65.875 86.555C65.875 86.4898 65.862 86.4253 65.8367 86.3652C65.8115 86.305 65.7745 86.2506 65.7279 86.2049C65.6814 86.1593 65.6262 86.1234 65.5656 86.0994C65.505 86.0754 65.4402 86.0637 65.375 86.065H64.375V38.515C65.6027 42.1165 67.9266 45.2437 71.0209 47.458C74.1153 49.6724 77.8249 50.863 81.63 50.863C85.435 50.863 89.1447 49.6724 92.239 47.458C95.3334 45.2437 97.6573 42.1165 98.885 38.515V84.275H97.885C97.8198 84.2737 97.755 84.2854 97.6944 84.3094C97.6338 84.3334 97.5786 84.3693 97.532 84.4149C97.4855 84.4606 97.4485 84.515 97.4232 84.5751C97.398 84.6353 97.385 84.6998 97.385 84.765L97.285 89.765C97.2734 91.2464 96.7142 92.6712 95.715 93.765C94.3409 95.3839 93.6111 97.4522 93.665 99.575C93.665 99.7076 93.7177 99.8348 93.8114 99.9286C93.9052 100.022 94.0324 100.075 94.165 100.075H96.405V103.755C96.405 103.888 96.4577 104.015 96.5514 104.109C96.6452 104.202 96.7724 104.255 96.905 104.255C97.0376 104.255 97.1648 104.202 97.2585 104.109C97.3523 104.015 97.405 103.888 97.405 103.755V100.125H101.405V103.755C101.405 103.888 101.458 104.015 101.551 104.109C101.645 104.202 101.772 104.255 101.905 104.255C102.038 104.255 102.165 104.202 102.259 104.109C102.352 104.015 102.405 103.888 102.405 103.755V100.125H104.645C104.778 100.125 104.905 100.072 104.999 99.9785C105.092 99.8848 105.145 99.7576 105.145 99.625C105.189 97.4699 104.426 95.3762 103.005 93.755ZM64.925 91.515C64.9196 91.5481 64.9196 91.5819 64.925 91.615L65.815 95.555V102.795C65.815 102.848 65.8043 102.901 65.7836 102.95C65.7629 103 65.7325 103.044 65.6943 103.081C65.6561 103.119 65.6108 103.148 65.5611 103.167C65.5114 103.187 65.4583 103.196 65.405 103.195H62.195C62.1416 103.196 62.0885 103.187 62.0388 103.167C61.9891 103.148 61.9439 103.119 61.9057 103.081C61.8674 103.044 61.8371 103 61.8164 102.95C61.7956 102.901 61.785 102.848 61.785 102.795V95.555L62.675 91.615C62.6804 91.5819 62.6804 91.5481 62.675 91.515L62.755 87.045H64.755L64.925 91.515ZM81.585 49.845C78.1709 49.847 74.8328 48.8364 71.9931 46.941C69.1534 45.0457 66.9396 42.3507 65.6317 39.1971C64.3238 36.0434 63.9806 32.5726 64.6454 29.2239C65.3103 25.8751 66.9533 22.7987 69.3668 20.3839C71.7802 17.969 74.8557 16.3242 78.204 15.6574C81.5524 14.9906 85.0234 15.3318 88.1778 16.6379C91.3322 17.944 94.0285 20.1562 95.9255 22.9948C97.8224 25.8334 98.835 29.1709 98.835 32.585C98.835 34.8551 98.3877 37.1029 97.5187 39.2001C96.6496 41.2972 95.3759 43.2026 93.7702 44.8073C92.1646 46.4121 90.2585 47.6847 88.1608 48.5525C86.0632 49.4203 83.8151 49.8663 81.545 49.865L81.585 49.845ZM94.585 99.065C94.6447 97.3296 95.2977 95.6672 96.435 94.355C97.5595 93.0855 98.1849 91.4509 98.195 89.755L98.285 85.285H100.285L100.365 89.745C100.368 91.456 100.998 93.1066 102.135 94.385C103.265 95.7006 103.914 97.3617 103.975 99.095L94.585 99.065Z",
    fill: "#212222"
  })), /*#__PURE__*/react_default.a.createElement("defs", null, /*#__PURE__*/react_default.a.createElement("clipPath", {
    id: "clip0_333_569"
  }, /*#__PURE__*/react_default.a.createElement("rect", {
    width: "90.03",
    height: "91.31",
    fill: "white",
    transform: "translate(14.985 14.345)"
  }))));
};

/* harmony default export */ var package_items_icons_IconCharger = (IconCharger_IconCharger);
// CONCATENATED MODULE: ./public/static/icons/package-items-icons/IconManual.tsx
var IconManual_jsx = react_default.a.createElement;


var IconManual_IconManual = function IconManual() {
  return /*#__PURE__*/react_default.a.createElement("svg", {
    width: "59",
    height: "89",
    viewBox: "0 0 59 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react_default.a.createElement("path", {
    d: "M58.115 17.2767C58.115 17.2767 58.115 17.2767 58.115 17.2067V17.1567V17.0967H58.055L18.325 0.0966977C18.2494 0.0628631 18.1664 0.048751 18.0839 0.0556668C18.0013 0.0625826 17.9219 0.0903049 17.853 0.136248C17.7841 0.182192 17.7279 0.24485 17.6898 0.318377C17.6517 0.391905 17.6328 0.473906 17.635 0.556704V7.0167L12.325 5.4867C12.2513 5.46639 12.1739 5.46396 12.0991 5.47962C12.0243 5.49527 11.9543 5.52855 11.895 5.57669C11.8355 5.62275 11.7874 5.6819 11.7544 5.74953C11.7215 5.81716 11.7046 5.89146 11.705 5.96669V11.7167L6.57496 11.1467C6.50453 11.1407 6.43362 11.1492 6.36657 11.1715C6.29951 11.1939 6.23772 11.2297 6.18496 11.2767C6.13455 11.3243 6.09436 11.3816 6.06685 11.4452C6.03934 11.5088 6.02509 11.5774 6.02496 11.6467V16.8267H0.834961C0.703154 16.8293 0.577459 16.8827 0.48424 16.976C0.391021 17.0692 0.337521 17.1949 0.334961 17.3267V87.7167C0.337521 87.8485 0.391021 87.9742 0.48424 88.0674C0.577459 88.1606 0.703154 88.2141 0.834961 88.2167H57.615C57.7468 88.2141 57.8725 88.1606 57.9657 88.0674C58.0589 87.9742 58.1124 87.8485 58.115 87.7167V17.2867V17.2767ZM18.385 0.996692L51.685 15.2767L18.385 6.9467V0.996692ZM12.705 6.5567L50.285 15.9567L12.705 11.7767V6.5567ZM7.02496 12.1567L48.585 16.7767H7.02496V12.1567ZM57.115 87.1567H1.33496V17.7767H57.115V87.1567Z",
    fill: "#212222"
  }));
};

/* harmony default export */ var package_items_icons_IconManual = (IconManual_IconManual);
// CONCATENATED MODULE: ./public/static/icons/package-items-icons/IconSoundboks3.tsx
var package_items_icons_IconSoundboks3_jsx = react_default.a.createElement;


var package_items_icons_IconSoundboks3_IconSoundboks3 = function IconSoundboks3() {
  return /*#__PURE__*/react_default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "82.471",
    height: "119.016",
    viewBox: "0 0 82.471 119.016"
  }, /*#__PURE__*/react_default.a.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(-654 -4240)"
  }, /*#__PURE__*/react_default.a.createElement("path", {
    id: "Vector",
    d: "M5.6,101.5l1.56-2.7h2.51l1.56,2.7h3.7l1.56-2.7h2.55l1.56,2.7h3.7l1.56-2.7h2.51l1.56,2.7h3.7l1.56-2.7H37.7l1.56,2.7h3.7l1.56-2.7h2.55l1.56,2.7h3.7l1.56-2.7H56.4l1.56,2.7h3.7l1.85-3.2-1.56-2.7,1.56-2.71-1.56-2.7,1.56-2.7-1.56-2.71,1.56-2.7-1.56-2.7,1.56-2.7-1.56-2.71,1.56-2.7-1.56-2.7,1.56-2.71-1.56-2.7,1.56-2.7-1.56-2.71,1.56-2.7-1.56-2.7,1.56-2.7-1.56-2.71,1.56-2.7-1.56-2.7,1.56-2.71-1.56-2.7,1.56-2.7-1.56-2.71,1.56-2.7-1.56-2.74,1.56-2.7-1.56-2.71,1.56-2.7-1.56-2.7,1.56-2.71-1.56-2.7,1.56-2.7-1.85-3.21h-3.1L57,.452H53.3l-1.52,2.74h-2.55l-1.56-2.7h-3.7l-1.56,2.7h-2.54l-1.56-2.7h-3.7l-1.56,2.7h-2.52l-1.56-2.7h-3.7l-1.56,2.7H21.2l-1.56-2.7h-3.7l-1.56,2.7h-2.54l-1.56-2.7h-3.7l-1.56,2.7H1.9L.053,6.4l1.56,2.7L.053,11.8l1.56,2.71-1.56,2.7,1.56,2.7-1.56,2.71,1.56,2.7-1.56,2.7,1.56,2.7-1.56,2.71,1.56,2.7-1.56,2.7,1.56,2.71-1.56,2.74,1.56,2.7-1.56,2.71,1.56,2.7-1.56,2.7,1.56,2.7L.053,60.5l1.56,2.7L.053,65.9l1.56,2.71-1.56,2.67,1.56,2.7-1.56,2.71,1.56,2.7-1.56,2.7,1.56,2.7L.053,87.5l1.56,2.7L.053,92.9l1.56,2.71-1.56,2.67,1.85,3.2Zm8.78-97.31H40.5l-1.07,3.65-.21.73H4.073l1.17-4,.11-.39h9ZM47.073,6.9l1.27,2.2-1.27,2.18h-2.52l-1.27-2.2,1.27-2.2Zm9.33,0,1.27,2.2-1.27,2.18h-2.51l-1.27-2.2,1.27-2.2Zm-7.17,88.2-1.27-2.21,1.27-2.2h2.55l1.27,2.2-1.27,2.21Zm-9.36,0-1.27-2.21,1.27-2.2h2.52l1.27,2.2-1.27,2.21Zm-9.34,0-1.27-2.21,1.27-2.2h2.52l1.27,2.2-1.27,2.21Zm-9.33,0-1.27-2.21,1.27-2.2h2.51l1.27,2.2-1.27,2.21Zm-9.36,0-1.28-2.21,1.28-2.2h2.51l1.28,2.2-1.28,2.21Zm30.55-80.09,1.27,2.2-1.27,2.2h-2.52l-1.27-2.2,1.27-2.2Zm4.68-2.73,1.27,2.21-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21Zm4.67-2.7,1.27,2.2-1.23,2.23h-2.55l-1.27-2.21,1.27-2.2Zm4.66,2.7,1.27,2.21-1.27,2.2h-2.51l-1.27-2.2,1.27-2.21Zm-2.51,80.09-1.27-2.2,1.27-2.2H56.4l1.27,2.2-1.27,2.2Zm-4.66-2.7-1.27-2.2,1.27-2.19h2.55l1.27,2.21-1.27,2.2Zm-4.68,2.7-1.27-2.2,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.68-2.7-1.27-2.2,1.27-2.19h2.52l1.27,2.21-1.27,2.2Zm-4.68,2.7-1.28-2.2,1.28-2.2H37.7l1.28,2.2-1.28,2.2Zm-4.66-2.7-1.27-2.2,1.27-2.19h2.52l1.27,2.21-1.27,2.2Zm-4.67,2.7-1.28-2.2,1.28-2.2h2.51l1.27,2.2-1.27,2.2Zm-4.66-2.7-1.27-2.2,1.27-2.19h2.51l1.27,2.21-1.27,2.2Zm-4.68,2.7-1.27-2.2,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.68-2.7-1.28-2.2,1.28-2.19h2.51l1.28,2.21-1.28,2.2Zm-4.68,2.7-1.27-2.2,1.27-2.2h2.51l1.27,2.2-1.27,2.2Zm35.23-72,1.27,2.21-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21Zm4.68-2.7,1.27,2.2-1.27,2.21h-2.52l-1.27-2.21,1.27-2.2Zm4.67-2.7,1.27,2.2-1.23,2.24h-2.55l-1.27-2.2,1.27-2.2Zm4.66,2.7,1.27,2.2-1.27,2.21h-2.51l-1.27-2.21,1.27-2.2Zm-2.51,69.28-1.27-2.21,1.27-2.2H56.4l1.27,2.2-1.27,2.21Zm-4.66-2.67-1.27-2.2,1.27-2.2h2.55l1.27,2.2-1.27,2.2Zm-4.68,2.71-1.27-2.21,1.27-2.2h2.52l1.27,2.2-1.27,2.21Zm-4.68-2.71-1.27-2.2,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.68,2.71-1.28-2.21,1.28-2.2H37.7l1.28,2.2-1.28,2.21Zm-4.66-2.71-1.27-2.2,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.67,2.71-1.28-2.21,1.28-2.2h2.51l1.27,2.2-1.27,2.21Zm-4.66-2.71-1.27-2.2,1.27-2.2h2.51l1.27,2.2-1.27,2.2Zm-4.68,2.71-1.27-2.21,1.27-2.2h2.52l1.27,2.2-1.27,2.21Zm-4.68-2.71-1.28-2.2,1.28-2.2h2.51l1.28,2.2-1.28,2.2Zm2.51-69.27,1.28,2.2-1.28,2.2h-2.51l-1.28-2.2,1.28-2.2Zm4.69-2.73,1.27,2.21-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21Zm4.67,2.71,1.27,2.2-1.27,2.2H21.2l-1.27-2.2,1.27-2.2Zm4.66-2.71,1.27,2.21-1.27,2.2h-2.51l-1.28-2.2,1.28-2.21Zm4.68,2.71,1.27,2.2-1.27,2.2h-2.52l-1.27-2.2,1.27-2.2Zm4.65-2.71,1.28,2.21-1.28,2.2h-2.51l-1.28-2.2,1.28-2.21Zm4.69,13.52,1.27,2.2-1.27,2.2h-2.52L38.6,28l1.27-2.2Zm4.68-2.7,1.27,2.2-1.27,2.2h-2.52l-1.27-2.22,1.27-2.2Zm4.71-2.69,1.27,2.21-1.27,2.2h-2.55l-1.27-2.2,1.27-2.21Zm-2.55,58.47-1.27-2.2,1.27-2.21h2.55l1.27,2.21-1.27,2.2Zm-4.68,2.7-1.27-2.2,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.68-2.7-1.27-2.2,1.27-2.21h2.52l1.27,2.21-1.27,2.2Zm-4.68,2.7-1.28-2.2,1.28-2.2H37.7l1.28,2.2-1.28,2.2Zm-4.66-2.7-1.27-2.2,1.27-2.21h2.52l1.27,2.21-1.27,2.2Zm-4.67,2.7-1.28-2.2,1.28-2.2h2.51l1.27,2.2-1.27,2.2Zm-4.66-2.7-1.27-2.2,1.27-2.21h2.51l1.27,2.21-1.27,2.2Zm-4.68,2.7-1.27-2.2,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.68-2.7-1.28-2.2,1.28-2.21h2.51l1.28,2.21-1.28,2.2Zm2.51-58.47,1.28,2.21-1.28,2.2h-2.51l-1.28-2.2,1.28-2.21Zm4.69-2.7,1.27,2.2-1.27,2.21h-2.52l-1.27-2.21,1.27-2.2Zm4.67,2.7,1.27,2.21-1.27,2.2H21.2l-1.27-2.2,1.27-2.21Zm4.66-2.7,1.27,2.2-1.27,2.21h-2.51l-1.28-2.21,1.28-2.2Zm4.68,2.7,1.27,2.21-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21Zm4.65-2.7,1.28,2.2-1.28,2.21h-2.51l-1.28-2.21,1.28-2.2Zm4.69,13.51,1.27,2.21-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21Zm4.68-2.7,1.27,2.2-1.27,2.21h-2.52l-1.27-2.21,1.27-2.2Zm4.67-2.7,1.27,2.2-1.23,2.2h-2.55l-1.27-2.2,1.27-2.2Zm-2.51,47.65-1.27-2.19,1.27-2.2h2.55l1.27,2.2-1.27,2.19Zm-4.68,2.71-1.27-2.21,1.27-2.2h2.52l1.27,2.2-1.27,2.21Zm-4.68-2.71-1.27-2.19,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.68,2.71-1.28-2.21,1.28-2.2H37.7l1.28,2.2-1.28,2.21Zm-4.66-2.71-1.27-2.19,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.67,2.71-1.28-2.21,1.28-2.2h2.51l1.27,2.2-1.27,2.21Zm-4.66-2.71-1.27-2.19,1.27-2.2h2.51l1.27,2.2-1.27,2.2Zm-4.68,2.71-1.27-2.21,1.27-2.2h2.52l1.27,2.2-1.27,2.21Zm-4.68-2.71-1.28-2.19,1.28-2.2h2.51l1.28,2.2-1.28,2.2Zm2.51-47.65,1.28,2.2-1.28,2.2h-2.51l-1.28-2.2,1.28-2.2Zm4.69-2.7,1.27,2.2-1.27,2.2h-2.52l-1.27-2.24,1.27-2.2Zm4.67,2.7,1.27,2.2-1.27,2.2H21.2l-1.27-2.2,1.27-2.2Zm4.66-2.7,1.27,2.2-1.27,2.2h-2.51l-1.28-2.24,1.28-2.2Zm4.68,2.7,1.27,2.2-1.27,2.2h-2.52l-1.27-2.2,1.27-2.2Zm4.65-2.7,1.28,2.16-1.28,2.2h-2.51l-1.28-2.2,1.28-2.2Zm4.69,13.51,1.27,2.2-1.27,2.21h-2.52l-1.27-2.21,1.27-2.2Zm4.68-2.7,1.27,2.2-1.27,2.2h-2.52l-1.27-2.2,1.27-2.2Zm4.71-2.71,1.27,2.21-1.27,2.2h-2.55l-1.27-2.2,1.27-2.21Zm-2.51,36.85L48,65.862l1.27-2.2h2.51l1.27,2.2-1.27,2.21Zm-4.68,2.7-1.27-2.2,1.27-2.21h2.52l1.27,2.21-1.27,2.2Zm-4.68-2.7-1.27-2.21,1.27-2.2h2.52l1.27,2.2-1.27,2.21Zm-4.68,2.7-1.28-2.2,1.28-2.21h2.51l1.28,2.21-1.28,2.2Zm-4.66-2.7-1.27-2.21,1.27-2.2h2.52l1.27,2.2-1.27,2.21Zm-4.67,2.7-1.28-2.2,1.28-2.21h2.51l1.27,2.21-1.27,2.2Zm-4.66-2.7-1.27-2.21,1.27-2.2h2.51l1.27,2.2-1.27,2.21Zm-4.68,2.7-1.27-2.2,1.27-2.21h2.52l1.27,2.21-1.27,2.2Zm2.52-42.25,1.27,2.2-1.27,2.21h-2.56l-1.27-2.21,1.27-2.2Zm4.67,2.7,1.27,2.21-1.27,2.2H21.2l-1.27-2.2,1.27-2.21Zm4.66-2.7,1.27,2.2-1.27,2.21h-2.55l-1.28-2.21,1.28-2.2Zm4.68,2.7,1.27,2.21-1.27,2.2h-2.56l-1.27-2.2,1.27-2.21Zm4.65-2.7,1.28,2.2-1.28,2.21h-2.55l-1.28-2.21,1.28-2.2Zm4.69,13.52,1.27,2.2-1.27,2.2h-2.56l-1.27-2.16,1.27-2.2Zm4.68-2.71,1.27,2.21-1.27,2.2h-2.56l-1.27-2.2,1.27-2.21Zm-2.52,26-1.27-2.2,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.68-2.7-1.27-2.2,1.23-2.15h2.52l1.27,2.21-1.27,2.2Zm-4.68,2.7-1.28-2.2,1.28-2.2h2.51l1.28,2.2-1.28,2.2Zm-4.66-2.7-1.27-2.2,1.23-2.15h2.52l1.27,2.21-1.27,2.2Zm-4.67,2.7-1.28-2.2,1.28-2.2h2.51l1.27,2.2-1.27,2.2Zm-4.66-2.7-1.27-2.2,1.23-2.15h2.51l1.27,2.21-1.27,2.2Zm-4.68,2.7-1.27-2.2,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm2.52-31.43,1.27,2.2-1.27,2.2h-2.56l-1.27-2.2,1.27-2.2Zm4.67,2.7,1.27,2.2-1.27,2.21H21.2l-1.27-2.21,1.27-2.2Zm4.66-2.7,1.27,2.2-1.27,2.2h-2.55l-1.28-2.2,1.28-2.2Zm4.68,2.7,1.27,2.2-1.27,2.21h-2.56l-1.27-2.21,1.27-2.2Zm4.65-2.7,1.28,2.2-1.28,2.2h-2.55l-1.28-2.2,1.28-2.2Zm4.69,13.51,1.27,2.21-1.27,2.2h-2.56l-1.27-2.2,1.27-2.21Zm4.68-2.7,1.27,2.2-1.27,2.21h-2.56l-1.27-2.21,1.27-2.2Zm-2.52,15.22-1.27-2.21,1.27-2.2h2.52l1.27,2.2-1.27,2.21Zm-4.72-2.65-1.27-2.2,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.68,2.71-1.28-2.21,1.28-2.2H37.7l1.28,2.2-1.28,2.21Zm-4.66-2.71-1.27-2.2,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.67,2.71-1.28-2.21,1.28-2.2h2.51l1.27,2.2-1.27,2.21Zm-4.66-2.71-1.27-2.2,1.27-2.2h2.51l1.27,2.2-1.27,2.2Zm-4.68,2.71-1.27-2.21,1.27-2.2h2.52l1.27,2.2-1.27,2.21Zm2.52-20.63,1.27,2.21-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21Zm4.67,2.71,1.27,2.21-1.27,2.2H21.2l-1.27-2.2,1.27-2.2Zm4.66-2.71,1.27,2.21-1.27,2.2h-2.51l-1.28-2.2,1.28-2.21Zm4.68,2.71,1.27,2.2-1.27,2.2h-2.52l-1.27-2.19,1.27-2.2Zm4.65-2.71,1.28,2.21-1.28,2.2h-2.51l-1.28-2.2,1.28-2.21Zm-2.51,15.22-1.28-2.2,1.28-2.2H37.7l1.28,2.2-1.28,2.2Zm-4.66-2.7-1.27-2.2,1.27-2.21h2.52l1.27,2.21-1.27,2.2Zm-4.67,2.7-1.28-2.2,1.28-2.2h2.51l1.27,2.2-1.27,2.2Zm-4.66-2.7-1.27-2.2,1.27-2.21h2.51l1.27,2.21-1.27,2.2Zm7.17-7.11,1.27,2.2-1.27,2.21h-2.51l-1.28-2.21,1.28-2.2Zm9.33,0,1.28,2.2-1.28,2.21h-2.51l-1.28-2.21,1.28-2.2Zm-18.66,0,1.27,2.2-1.27,2.21h-2.52l-1.27-2.21,1.27-2.2Zm0,5.41,1.27,2.2-1.27,2.2h-2.52l-1.27-2.2,1.27-2.2Zm28,0,1.27,2.2-1.27,2.2h-2.49l-1.27-2.2,1.27-2.2Zm2.16,12.51-1.27-2.2,1.3-2.21h2.55l1.27,2.21-1.27,2.17Zm0-5.41-1.27-2.2,1.27-2.2h2.58l1.27,2.2-1.27,2.2Zm0-5.4-1.27-2.2,1.27-2.21h2.58l1.27,2.21-1.27,2.17Zm0-5.41-1.24-2.19,1.27-2.2h2.55l1.27,2.2-1.27,2.16Zm0-5.4-1.27-2.21,1.27-2.2h2.58l1.27,2.2-1.27,2.18Zm-34.88-9.82,1.28,2.21-1.28,2.2h-2.48l-1.28-2.2,1.28-2.21Zm0,5.41,1.28,2.2-1.28,2.21h-2.48l-1.28-2.21,1.28-2.2Zm0,5.41,1.28,2.2-1.28,2.2h-2.48l-1.28-2.19,1.28-2.2Zm0,5.4,1.28,2.21-1.28,2.2h-2.48l-1.28-2.2,1.28-2.21Zm0,5.41,1.28,2.2-1.25,2.2h-2.51l-1.28-2.2,1.28-2.2Zm0,5.4,1.28,2.21-1.28,2.2h-2.48l-1.28-2.2,1.28-2.21Zm0,5.41,1.28,2.2-1.28,2.21h-2.48l-1.28-2.21,1.28-2.2Zm39.57,17.89-1.27-2.2,1.27-2.2H56.4l1.27,2.2-1.27,2.2Zm0-5.4-1.27-2.21,1.27-2.2H56.4l1.27,2.2-1.27,2.21Zm0-5.41-1.27-2.2,1.27-2.21H56.4l1.27,2.21-1.27,2.2Zm0-5.41-1.27-2.2,1.27-2.2H56.4l1.27,2.2-1.27,2.2Zm0-5.4-1.27-2.21,1.27-2.2H56.4l1.27,2.2-1.27,2.21Zm0-5.41-1.27-2.2,1.27-2.2H56.4l1.27,2.2-1.27,2.2Zm0-5.4-1.27-2.21,1.27-2.2H56.4l1.27,2.2-1.27,2.21Zm0-5.41-1.27-2.2,1.27-2.21H56.4l1.27,2.21-1.27,2.2Zm0-5.41-1.27-2.2,1.27-2.2H56.4l1.27,2.2-1.27,2.2Zm0-5.4-1.27-2.21,1.27-2.2H56.4l1.27,2.2-1.27,2.21Zm0-5.41-1.27-2.24,1.27-2.2H56.4l1.27,2.2-1.27,2.2ZM37.7,11.282h-2.51l-1-1.7h4.49Zm-3.38.5-1.27,2.21h-2.52l-1.27-2.21,1.27-2.2h2.52Zm-5.95-.5h-2.51l-1-1.7h4.48Zm-3.39.5-1.27,2.21H21.2l-1.27-2.21,1.27-2.2h2.51Zm-5.94-.5h-2.52l-1-1.7h4.49Zm-3.41.5-1.28,2.21h-2.51l-1.28-2.21,1.28-2.2h2.51Zm-6-.5H7.163l-1-1.7h4.48Zm0,1,1.27,2.21-1.27,2.2H7.163l-1.27-2.2,1.27-2.21Zm0,5.41,1.27,2.2L9.633,22.1H7.163l-1.27-2.21,1.27-2.2Zm0,5.41,1.27,2.2-1.27,2.2H7.163l-1.27-2.22,1.27-2.2Zm0,5.4,1.27,2.2-1.27,2.21H7.163L5.893,30.7l1.27-2.2Zm0,5.41,1.27,2.2-1.27,2.2H7.163l-1.27-2.2,1.27-2.2Zm0,5.4,1.27,2.21-1.27,2.2H7.163l-1.27-2.2,1.27-2.21Zm0,5.41,1.27,2.2-1.27,2.21H7.163l-1.27-2.21,1.27-2.2Zm0,5.41,1.27,2.2-1.27,2.2H7.163l-1.27-2.2,1.27-2.2Zm0,5.4,1.27,2.2-1.27,2.21H7.163l-1.27-2.21,1.27-2.2Zm0,5.41,1.27,2.2-1.27,2.2H7.163l-1.27-2.2,1.27-2.2Zm0,5.4,1.27,2.21-1.27,2.2H7.163l-1.27-2.2,1.27-2.21Zm0,5.41,1.27,2.2-1.27,2.21H7.163l-1.27-2.21,1.27-2.2Zm0,5.41,1.27,2.2-1.27,2.2H7.163l-1.27-2.2,1.27-2.2Zm0,5.4,1.27,2.2-1.27,2.21H7.163l-1.27-2.21,1.27-2.2Zm-3.78,13,1.27-2.21h2.51l1.27,2.21-1.27,2.2H7.163Zm9.36,0,1.27-2.21H19l1.27,2.21L19,97.762h-2.48Zm9.33,0,1.28-2.21h2.51l1.27,2.21-1.27,2.2h-2.47Zm9.33,0,1.28-2.21h2.51l1.28,2.21-1.28,2.2h-2.47Zm9.37,0,1.27-2.21h2.52l1.27,2.21-1.27,2.2h-2.48Zm9.34,0,1.27-2.21h2.51l1.27,2.21-1.27,2.2h-2.47Zm.39-89.2L51.783,8.6h-2.55l-1.27-2.2,1.27-2.21h2.55Zm-10.62,3.2,1.27,2.2-1.27,2.21h-2.48l-1.27-2.21,1.27-2.2h2.48Zm-28,90.9h-2.57l-1.23-2.18,1.29-2.22h2.51l1.28,2.2Zm9.37,0h-2.55l-1.25-2.18,1.28-2.22h2.51l1.28,2.2Zm9.33,0H30.5l-1.25-2.18,1.28-2.22h2.52l1.27,2.2Zm9.34,0h-2.55l-1.26-2.18,1.29-2.22h2.52l1.27,2.2Zm9.36,0h-2.54l-1.26-2.18,1.28-2.22h2.55l1.28,2.2Zm10.6-2.2-1.27,2.2h-2.54l-1.26-2.18,1.28-2.22h2.52Zm0-5.41-1.27,2.21h-2.52l-1.27-2.21,1.27-2.2h2.52Zm0-5.4-1.27,2.2h-2.52l-1.27-2.2,1.27-2.17h2.52Zm0-5.41-1.27,2.24h-2.52l-1.27-2.2,1.27-2.2h2.52Zm0-5.4-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21h2.52Zm0-5.41-1.27,2.2h-2.52l-1.27-2.15,1.27-2.2h2.52Zm0-5.41-1.27,2.21h-2.52l-1.27-2.21,1.27-2.2h2.52Zm0-5.4-1.27,2.2h-2.52l-1.27-2.2,1.27-2.14h2.52Zm0-5.41-1.27,2.27h-2.52l-1.27-2.2,1.27-2.2h2.52Zm0-5.4-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21h2.52Zm0-5.41-1.27,2.2h-2.52l-1.27-2.12,1.27-2.2h2.52Zm0-5.41L61.083,41h-2.52l-1.27-2.21,1.27-2.2h2.52Zm0-5.4-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21h2.52Zm0-5.41-1.27,2.2h-2.52l-1.27-2.2,1.27-2.2h2.52Zm0-5.4-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21h2.52Zm0-5.41-1.27,2.2h-2.52l-1.27-2.2,1.27-2.2h2.52Zm0-5.41-1.27,2.21h-2.52l-1.27-2.21,1.27-2.2h2.52Zm0-5.4-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21h2.52Zm-8.47-4.91h2.54l1.26,2.18L56.4,5.862h-2.51l-1.28-2.21Zm-9.33,0h2.54l1.26,2.18-1.28,2.23h-2.52l-1.27-2.21Zm-2.16,2.7,1.27,2.21-1.27,2.2h-2.14l1.29-4.41Zm-7.2-2.7h2.59l1,1.7H34.2Zm-9.34,0h2.54l1,1.7h-4.52Zm-9.33,0h2.54l1,1.7h-4.53Zm-9.36,0H9.7l1,1.7H6.173Zm-6,4.91,1.27-2.21h1.84l-1.3,4.41h-.49Zm0,5.4,1.27-2.2h2.54l1.27,2.2-1.27,2.21H2.483Zm0,5.41,1.27-2.2h2.54l1.27,2.2-1.27,2.2H2.483Zm0,5.41,1.27-2.21h2.54l1.27,2.21-1.27,2.2H2.483Zm0,5.4,1.27-2.2h2.54l1.27,2.2-1.27,2.2H2.483Zm0,5.41,1.27-2.21h2.54l1.27,2.21-1.27,2.2H2.483Zm0,5.4,1.27-2.2h2.54l1.27,2.2L4.973,41H2.483Zm0,5.41L2.433,42h2.54l1.27,2.2-1.27,2.2H2.483Zm0,5.41,1.27-2.21h2.54l1.27,2.21-1.27,2.2H2.483Zm0,5.4,1.27-2.2h2.54l1.27,2.2-1.22,2.27H2.483Zm0,5.41,1.32-2.14h2.54l1.27,2.21-1.27,2.2H2.483Zm0,5.4,1.27-2.2h2.54l1.27,2.2-1.27,2.21H2.483Zm0,5.41,1.27-2.2h2.54l1.27,2.2-1.27,2.2H2.483Zm0,5.41,1.27-2.21h2.54l1.27,2.21-1.27,2.2H2.483Zm0,5.4,1.27-2.2h2.54l1.27,2.2-1.22,2.24H2.483Zm0,5.41,1.32-2.17h2.54l1.27,2.21-1.27,2.2H2.483Zm0,5.4,1.27-2.2h2.54l1.27,2.2-1.27,2.21H2.483Zm1.27,3.21h2.54l1.27,2.2-1.27,2.2H2.483l-1.27-2.18Z",
    transform: "translate(663.453 4248.531)",
    fill: "#212222"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    id: "Vector-1",
    d: "M79.353,109.9V9.992a4.84,4.84,0,1,0-5.71-6.43H9.923a4.85,4.85,0,1,0-5.71,6.43V109.9a4.85,4.85,0,1,0,5.68,6.54h63.78a4.85,4.85,0,1,0,5.68-6.54Zm-1.19,8.55a3.871,3.871,0,0,1-3.86-3.86v-.36a3.994,3.994,0,0,1,.3-1.21,3.867,3.867,0,0,1,1.5-1.7,3.986,3.986,0,0,1,1.17-.49,3.923,3.923,0,0,1,.85-.1,3.86,3.86,0,0,1,0,7.72Zm-76.62-3.86a3.859,3.859,0,0,1,3.86-3.86,3.924,3.924,0,0,1,.85.1,3.986,3.986,0,0,1,1.17.49,3.867,3.867,0,0,1,1.5,1.7,4,4,0,0,1,.3,1.21v.36a3.86,3.86,0,0,1-7.72,0Zm5.64-4.51V9.812a4.89,4.89,0,0,0,2.88-3.23,2.74,2.74,0,0,1,.51-.06h62.41a2.74,2.74,0,0,1,.51.06,4.89,4.89,0,0,0,2.88,3.23v100.26a4.858,4.858,0,0,0-2.92,3.34,3.862,3.862,0,0,1-.48.05H10.583a3.861,3.861,0,0,1-.48-.05,4.86,4.86,0,0,0-2.92-3.33ZM5.4,1.452a3.86,3.86,0,0,1,3.86,3.83,3.41,3.41,0,0,1-.05.46A3.83,3.83,0,0,1,8.843,7a3.91,3.91,0,0,1-1.36,1.52,3.76,3.76,0,0,1-1.22.51,3.43,3.43,0,0,1-.86.11,3.86,3.86,0,1,1,0-7.71Zm76.62,3.83a3.86,3.86,0,0,1-3.86,3.86,3.43,3.43,0,0,1-.86-.11,3.76,3.76,0,0,1-1.22-.51A3.91,3.91,0,0,1,74.723,7a3.83,3.83,0,0,1-.37-1.26,3.4,3.4,0,0,1,0-.46,3.86,3.86,0,0,1,7.72,0Zm-3.67,104.47h-.19a4.981,4.981,0,0,0-.78.08V10.082a4.992,4.992,0,0,0,.78.08h.19Zm-5-105.19a4.529,4.529,0,0,0-.08.74,2.3,2.3,0,0,0,0,.26H10.233a2.3,2.3,0,0,0,0-.26,4.53,4.53,0,0,0-.08-.74Zm-68.17,5.58h.19a4.992,4.992,0,0,0,.78-.08v99.73a4.981,4.981,0,0,0-.78-.08h-.19Zm5,105.3a4.809,4.809,0,0,0,.09-.85v-.15c0-.05.22,0,.34,0h62.71c.11,0,0,.1,0,.15a4.808,4.808,0,0,0,.09.85Z",
    transform: "translate(653.46 4239.563)",
    fill: "#212222"
  })));
};

/* harmony default export */ var package_items_icons_IconSoundboks3 = (package_items_icons_IconSoundboks3_IconSoundboks3);
// EXTERNAL MODULE: ./public/static/documents/manuals/soundboks3.pdf
var soundboks3 = __webpack_require__("kt2D");

// CONCATENATED MODULE: ./public/static/icons/package-items-icons/IconTripod.tsx
var IconTripod_jsx = react_default.a.createElement;


var IconTripod_IconTripod = function IconTripod() {
  return /*#__PURE__*/react_default.a.createElement("svg", {
    width: "120",
    height: "120",
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react_default.a.createElement("path", {
    d: "M76.05 115L77.15 116.6C77.25 116.8 77.55 116.8 77.75 116.7L78.25 116.4C78.45 116.3 78.45 116 78.35 115.8L77.25 114.2",
    stroke: "#212222",
    strokeWidth: "0.5",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M59.35 89.7L60.45 91.3C60.55 91.5 60.85 91.5 61.05 91.4L61.55 91.1C61.75 91 61.75 90.7 61.65 90.5L60.55 88.9",
    stroke: "#212222",
    strokeWidth: "0.5",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M60.75 91.1V89.2C60.743 89.0962 60.6986 88.9985 60.625 88.925C60.5515 88.8514 60.4538 88.807 60.35 88.8H59.75C59.6462 88.807 59.5485 88.8514 59.475 88.925C59.4014 88.9985 59.357 89.0962 59.35 89.2V91.1",
    stroke: "#212222",
    strokeWidth: "0.5",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M60.55 89.7L59.45 91.3C59.35 91.5 59.05 91.5 58.85 91.4L58.35 91.1C58.15 91 58.15 90.7 58.25 90.5L59.35 88.9",
    stroke: "#212222",
    strokeWidth: "0.5",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M77.85 116.4L71.35 106.5L59.95 89.3",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M44 115L42.9 116.6C42.8 116.8 42.5 116.8 42.3 116.7L41.8 116.4C41.6 116.3 41.6 116 41.7 115.8L42.8 114.2",
    stroke: "#212222",
    strokeWidth: "0.5",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M60 62.2H60.8C60.9 62.2 61 62.5 61 62.8V63.7C61 64 60.9 64.3 60.8 64.3H60",
    stroke: "#212222",
    strokeWidth: "0.81",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M42.15 116.4L59.95 89.3",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M51.25 102.9L59.95 101.6V19.5",
    stroke: "#212222",
    strokeWidth: "1.17",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M59.95 101.6L71.35 106.5",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }));
};

/* harmony default export */ var package_items_icons_IconTripod = (IconTripod_IconTripod);
// CONCATENATED MODULE: ./public/static/icons/package-items-icons/IconTripodBackpack.tsx
var IconTripodBackpack_jsx = react_default.a.createElement;


var IconTripodBackpack_IconTripodBackpack = function IconTripodBackpack() {
  return /*#__PURE__*/react_default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14.821",
    height: "107.514",
    viewBox: "0 0 14.821 107.514"
  }, /*#__PURE__*/react_default.a.createElement("g", {
    transform: "translate(-52.325 -6.4)"
  }, /*#__PURE__*/react_default.a.createElement("line", {
    y2: "101.3",
    transform: "translate(64.7 10.9)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: "1"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M64.5,112.2a10.925,10.925,0,0,1-9.9,0,3.264,3.264,0,0,1-1.8-3v-97a1.23,1.23,0,0,1,.7-1.1,14.534,14.534,0,0,1,12.1,0,1.23,1.23,0,0,1,.7,1.1v97A3.523,3.523,0,0,1,64.5,112.2Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: "0.95"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M55,10.4a3.848,3.848,0,0,1,.9-2.7,1.943,1.943,0,0,1,1.6-.8c1.2,0,2.3,0,3.5.1a2.988,2.988,0,0,1,2.7,2.7,3.75,3.75,0,0,1,.1,1.1",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: "1"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M63.9,60.7V62a.576.576,0,0,0,.6.6h.4a2.3,2.3,0,0,0,1.4-.4l.2-.2a.55.55,0,0,0,.3-.5V60.4a.472.472,0,0,0-.5-.5h0a5.537,5.537,0,0,0-1.8.2l-.2.1A.458.458,0,0,0,63.9,60.7Z",
    fill: "#f4f4f4",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: "0.691"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M64.7,60.9v.7a.265.265,0,0,0,.3.3h.2a1.854,1.854,0,0,0,.7-.2l.1-.1c.1-.1.1-.1.1-.2v-.6a.319.319,0,0,0-.3-.3h0a2.769,2.769,0,0,0-.9.1h-.1A.367.367,0,0,0,64.7,60.9Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: "0.23"
  })));
};

/* harmony default export */ var package_items_icons_IconTripodBackpack = (IconTripodBackpack_IconTripodBackpack);
// CONCATENATED MODULE: ./public/static/icons/package-items-icons/IconSB3Backpack.tsx
var IconSB3Backpack_jsx = react_default.a.createElement;


var IconSB3Backpack_IconSB3Backpack = function IconSB3Backpack() {
  return /*#__PURE__*/react_default.a.createElement("svg", {
    width: "120",
    height: "120",
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react_default.a.createElement("path", {
    d: "M87.11 96.52V32.22C87.089 31.8021 87.0012 31.3902 86.85 31L83.15 22.42C82.9392 21.8973 82.5729 21.4521 82.1007 21.1444C81.6286 20.8368 81.0733 20.6816 80.51 20.7H39.85C39.2901 20.698 38.7419 20.8597 38.2728 21.1653C37.8038 21.4709 37.4343 21.9071 37.21 22.42L33.51 31C33.3587 31.3802 33.2676 31.7817 33.24 32.19V96.49",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M87.11 46.74H61.63",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M61.63 39H68.89C69.5146 39.0152 70.1216 38.7921 70.5878 38.3761C71.0539 37.9601 71.3443 37.3823 71.4 36.76L71.93 32.14C72.0379 31.2208 72.0814 30.2952 72.06 29.37V20.74",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M33.13 46.74H58.61",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M58.61 39H51.35C50.7254 39.0152 50.1184 38.7921 49.6523 38.3761C49.1861 37.9601 48.8957 37.3823 48.84 36.76L48.31 32.14C48.2021 31.2208 48.1587 30.2952 48.18 29.37V20.74",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M86.27 29.45H92.41C92.7259 29.4472 93.0302 29.568 93.2582 29.7866C93.4862 30.0053 93.6196 30.3043 93.63 30.62L93.93 37.42C93.9445 37.7156 93.8511 38.0064 93.6671 38.2382C93.4831 38.47 93.2212 38.627 92.93 38.68L87.24 39.61",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M33.73 29.45H27.59C27.2742 29.4472 26.9698 29.568 26.7418 29.7866C26.5139 30.0053 26.3804 30.3043 26.37 30.62L26.07 37.42C26.0555 37.7156 26.149 38.0064 26.3329 38.2382C26.5169 38.47 26.7789 38.627 27.07 38.68L32.76 39.61",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M66.45 64.97H61.63V96.52",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M78.24 61.01H87.12V64.97H78.51",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M61.63 20.74V61.01H66.51",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M77.32 46.74L78.24 61.01L78.5 64.84L80.1 88.5L67.21 89.28L66.45 64.97L66.32 60.86L65.9 46.74",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M76.77 88.99L77.75 96.52",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M72.53 89.28L73.47 96.52",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M53.91 64.97H58.73V96.52",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M42.12 61.01H33.24V64.97H41.85",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M58.73 20.74V61.01H53.85",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M43.04 46.74L42.12 61.01L41.86 64.84L40.26 88.5L53.16 89.27L53.91 64.97L54.04 60.86L54.46 46.74",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M43.59 88.99L42.61 96.52",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M47.84 89.27L46.89 96.52",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M89.9 112.29L90.27 113.85C90.53 114.11 93.84 116.36 93.84 116.36C94.054 116.511 94.3057 116.601 94.5673 116.618C94.8289 116.635 95.0901 116.579 95.322 116.457C95.5539 116.335 95.7475 116.151 95.8813 115.926C96.0151 115.7 96.0839 115.442 96.08 115.18V98C96.0774 97.6162 95.9238 97.249 95.6524 96.9776C95.3811 96.7062 95.0138 96.5526 94.63 96.55H25.37C24.9863 96.5526 24.619 96.7062 24.3476 96.9776C24.0762 97.249 23.9226 97.6162 23.92 98V115.17C23.9162 115.432 23.985 115.69 24.1188 115.916C24.2525 116.141 24.4461 116.325 24.678 116.447C24.91 116.569 25.1712 116.625 25.4327 116.608C25.6943 116.591 25.946 116.501 26.16 116.35C26.16 116.35 29.47 114.1 29.73 113.84L30.1 112.28",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M19.36 112.33H100.64",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }));
};

/* harmony default export */ var package_items_icons_IconSB3Backpack = (IconSB3Backpack_IconSB3Backpack);
// EXTERNAL MODULE: ./public/static/documents/manuals/backpack.pdf
var backpack = __webpack_require__("JMBC");

// CONCATENATED MODULE: ./public/static/icons/package-items-icons/IconPowerbank.tsx
var IconPowerbank_jsx = react_default.a.createElement;


var IconPowerbank_IconPowerbank = function IconPowerbank() {
  return /*#__PURE__*/react_default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.19,
    height: 107.95
  }, /*#__PURE__*/react_default.a.createElement("g", {
    fill: "#212222"
  }, /*#__PURE__*/react_default.a.createElement("path", {
    d: "M76.461 108h-60.33a16.159 16.159 0 0 1-9.73-3.07 15.332 15.332 0 0 1-6.39-13 15.138 15.138 0 0 1 .67-3.96v-.04l6.62-81.75A6.817 6.817 0 0 1 14.111 0h64.06a6.823 6.823 0 0 1 6.81 6.17l6.62 81.76a15.873 15.873 0 0 1 .67 4.01 15.672 15.672 0 0 1-15.81 16.07ZM14.111 1.1a5.725 5.725 0 0 0-5.71 5.18l-6.64 81.9-.02.05a14.5 14.5 0 0 0 14.07 18.66h60.39a14.945 14.945 0 0 0 8.32-2.37 14.279 14.279 0 0 0 6.64-12.22 10.74 10.74 0 0 0-.25-2.04l-.42-2.2-6.63-81.8a5.717 5.717 0 0 0-5.71-5.17h-64.04Zm70.98 79.39a.689.689 0 0 1-.39-.12 14.439 14.439 0 0 0-7.9-2.34h-61.9a14.439 14.439 0 0 0-7.9 2.34.716.716 0 0 1-1.11-.65l5.63-73.07.03-.22a2.046 2.046 0 0 1 1.98-1.62h64.64a2.031 2.031 0 0 1 1.97 1.59l.03.21 5.62 73.11a.721.721 0 0 1-.34.67.686.686 0 0 1-.37.1Zm-69.6-3.46h61.31a15.439 15.439 0 0 1 7.96 2.2l-5.57-72.5-.02-.14a1.012 1.012 0 0 0-.99-.77h-64.65a1.028 1.028 0 0 0-1 .8l-.02.15-5.57 72.46a15.439 15.439 0 0 1 7.96-2.2h.58Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M77.081 104.17h-62.62a9.884 9.884 0 0 1-9.87-9.87v-3.57a9.884 9.884 0 0 1 9.87-9.87h62.62a9.884 9.884 0 0 1 9.87 9.87v3.57a9.884 9.884 0 0 1-9.87 9.87Zm-62.62-22.31a8.881 8.881 0 0 0-8.87 8.87v3.57a8.881 8.881 0 0 0 8.87 8.87h62.62a8.881 8.881 0 0 0 8.87-8.87v-3.57a8.881 8.881 0 0 0-8.87-8.87h-62.62Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M80.191 91.71h-7.19a1.093 1.093 0 0 1-1.09-1.09v-.14a1.093 1.093 0 0 1 1.09-1.09h7.19a1.093 1.093 0 0 1 1.09 1.09v.14a1.093 1.093 0 0 1-1.09 1.09Zm-7.19-1.31s-.09.04-.09.09v.14s.04.09.09.09h7.19s.09-.04.09-.09v-.14s-.04-.09-.09-.09ZM78.911 95.64h-4.63a1.067 1.067 0 0 1-1.06-1.06v-.19a1.067 1.067 0 0 1 1.06-1.06h4.63a1.067 1.067 0 0 1 1.06 1.06v.19a1.067 1.067 0 0 1-1.06 1.06Zm-4.63-1.31s-.06.03-.06.06v.19l4.69.06.06-.25ZM66.571 95.6h-15.21v-6.17h15.21Zm-14.21-1h13.21v-4.17h-13.21ZM21.981 96.44h-9.65a2.074 2.074 0 0 1-2.07-2.07v-3.7a2.074 2.074 0 0 1 2.07-2.07h9.65a2.074 2.074 0 0 1 2.07 2.07v3.7a2.074 2.074 0 0 1-2.07 2.07Zm-9.65-6.84a1.071 1.071 0 0 0-1.07 1.07v3.7a1.071 1.071 0 0 0 1.07 1.07h9.65a1.071 1.071 0 0 0 1.07-1.07v-3.7a1.071 1.071 0 0 0-1.07-1.07ZM30.481 93.5a.98.98 0 1 1 .98-.98.982.982 0 0 1-.98.98Zm0-1a.02.02 0 0 0-.02.02ZM35.661 93.5a.98.98 0 1 1 .98-.98.982.982 0 0 1-.98.98Zm0-1a.02.02 0 0 0-.02.02ZM40.831 93.5a.98.98 0 1 1 .98-.98.982.982 0 0 1-.98.98Zm0-1a.02.02 0 0 0-.02.02ZM46.001 93.5a.98.98 0 1 1 .98-.98.982.982 0 0 1-.98.98Zm0-1a.02.02 0 0 0-.02.02Z"
  })));
};

/* harmony default export */ var package_items_icons_IconPowerbank = (IconPowerbank_IconPowerbank);
// CONCATENATED MODULE: ./public/static/icons/package-items-icons/IconGrill.tsx
var IconGrill_jsx = react_default.a.createElement;


var IconGrill_IconGrill = function IconGrill() {
  return /*#__PURE__*/react_default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.19,
    height: 107.95
  }, /*#__PURE__*/react_default.a.createElement("g", {
    fill: "#212222"
  }, /*#__PURE__*/react_default.a.createElement("path", {
    d: "M3.91 107.94a3.551 3.551 0 0 1-.57-.06l-.32-.06-.08-.32a4.445 4.445 0 0 0-.95-1.81 4.389 4.389 0 0 0-1.67-1.18l-.32-.12V3.45l.31-.13a4.364 4.364 0 0 0 1.63-1.15A4.283 4.283 0 0 0 2.89.42l.08-.29.3-.06a3.069 3.069 0 0 1 .6-.07h62.42a3.183 3.183 0 0 1 .62.07l.3.06.08.29a4.358 4.358 0 0 0 .96 1.75 4.445 4.445 0 0 0 1.63 1.15l.31.13v100.94l-.32.13a4.284 4.284 0 0 0-1.67 1.18 4.509 4.509 0 0 0-.95 1.81l-.08.32-.32.06a4.953 4.953 0 0 1-.54.06H3.91Zm-.09-1.01h62.57a5.374 5.374 0 0 1 2.81-3.22V4.11a5.411 5.411 0 0 1-1.69-1.27A5.583 5.583 0 0 1 66.43 1H3.77A5.586 5.586 0 0 1 2.7 2.84a5.411 5.411 0 0 1-1.69 1.27v99.62a5.327 5.327 0 0 1 1.74 1.31 5.381 5.381 0 0 1 1.07 1.89Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "m8.92 104.49 1.56-2.7h2.51l1.56 2.7h3.7l1.56-2.7h2.55l1.56 2.7h3.7l1.56-2.7h2.51l1.56 2.7h3.7l1.56-2.7h2.51l1.56 2.7h3.7l1.56-2.7h2.55l1.56 2.7h3.7l1.56-2.7h2.51l1.56 2.7h3.7l1.85-3.2-1.56-2.7 1.56-2.71-1.56-2.7 1.56-2.7-1.56-2.71 1.56-2.7-1.56-2.7 1.56-2.7-1.56-2.71 1.56-2.7-1.56-2.7 1.56-2.71-1.56-2.7 1.56-2.7-1.56-2.71 1.56-2.7-1.56-2.7 1.56-2.7-1.56-2.71 1.56-2.7-1.56-2.7 1.56-2.71-1.56-2.7 1.56-2.7-1.56-2.71 1.56-2.7-1.56-2.74 1.56-2.7-1.56-2.71 1.56-2.7-1.56-2.7 1.56-2.71-1.56-2.7 1.56-2.7-1.85-3.21h-3.1l-1.56-2.7h-3.7L55.1 6.18h-2.55l-1.56-2.7h-3.7l-1.56 2.7h-2.54l-1.56-2.7h-3.7l-1.56 2.7h-2.52l-1.56-2.7h-3.7l-1.56 2.7h-2.51l-1.56-2.7h-3.7l-1.56 2.7h-2.54l-1.56-2.7H9.9l-1.56 2.7H5.22L3.37 9.39l1.56 2.7-1.56 2.7 1.56 2.71-1.56 2.7 1.56 2.7-1.56 2.71 1.56 2.7-1.56 2.7 1.56 2.7-1.56 2.71 1.56 2.7-1.56 2.7 1.56 2.71-1.56 2.74 1.56 2.7-1.56 2.71 1.56 2.7-1.56 2.7 1.56 2.7-1.56 2.71 1.56 2.7-1.56 2.7 1.56 2.71-1.56 2.67 1.56 2.7-1.56 2.71 1.56 2.7-1.56 2.7 1.56 2.7-1.56 2.71 1.56 2.7-1.56 2.7 1.56 2.71-1.56 2.67 1.85 3.2 3.7.02ZM17.7 7.18h26.12l-1.07 3.65-.21.73H7.39l1.17-4 .11-.39h9.03ZM50.39 9.9l1.27 2.2-1.27 2.18h-2.52l-1.27-2.2 1.27-2.2Zm9.33 0 1.27 2.2-1.27 2.18h-2.51l-1.27-2.2 1.27-2.2Zm-7.17 88.2-1.27-2.21 1.27-2.2h2.55l1.27 2.2-1.27 2.21Zm-9.36 0-1.27-2.21 1.27-2.2h2.52l1.27 2.2-1.27 2.21Zm-9.34 0-1.27-2.21 1.27-2.2h2.52l1.27 2.2-1.27 2.21Zm-9.33 0-1.27-2.21 1.27-2.2h2.51l1.27 2.2-1.27 2.21Zm-9.36 0-1.28-2.21 1.28-2.2h2.51l1.28 2.2-1.28 2.21ZM45.71 18l1.27 2.2-1.27 2.2h-2.52l-1.27-2.2 1.27-2.2Zm4.68-2.73 1.27 2.21-1.27 2.2h-2.52l-1.27-2.2 1.27-2.21Zm4.67-2.7 1.27 2.2L55.1 17h-2.55l-1.27-2.21 1.27-2.2 2.51-.02Zm4.66 2.7 1.27 2.21-1.27 2.2h-2.51l-1.27-2.2 1.27-2.21Zm-2.51 80.09-1.27-2.2 1.27-2.2h2.51l1.27 2.2-1.27 2.2Zm-4.66-2.7-1.27-2.2 1.27-2.19h2.55l1.27 2.21-1.27 2.2Zm-4.68 2.7-1.27-2.2 1.27-2.2h2.52l1.27 2.2-1.27 2.2Zm-4.68-2.7-1.27-2.2 1.27-2.19h2.52l1.27 2.21-1.27 2.2Zm-4.68 2.7-1.28-2.2 1.28-2.2h2.51l1.28 2.2-1.28 2.2h-2.51Zm-4.66-2.7-1.27-2.2 1.27-2.19h2.52l1.27 2.21-1.27 2.2Zm-4.67 2.7-1.28-2.2 1.28-2.2h2.51l1.27 2.2-1.27 2.2Zm-4.66-2.7-1.27-2.2 1.27-2.19h2.51l1.27 2.21-1.27 2.2Zm-4.68 2.7-1.27-2.2 1.27-2.2h2.52l1.27 2.2-1.27 2.2Zm-4.68-2.7-1.28-2.2 1.28-2.19h2.51l1.28 2.21-1.28 2.2Zm-4.68 2.7-1.27-2.2 1.27-2.2h2.51l1.27 2.2-1.27 2.2Zm35.23-72 1.27 2.21-1.27 2.2h-2.52l-1.27-2.2 1.27-2.21Zm4.68-2.7 1.27 2.2-1.27 2.21h-2.52l-1.27-2.21 1.27-2.2Zm4.67-2.7 1.27 2.2-1.23 2.24h-2.55l-1.27-2.2 1.27-2.2 2.51-.04Zm4.66 2.7 1.27 2.2-1.27 2.21h-2.51l-1.27-2.21 1.27-2.2Zm-2.51 69.28-1.27-2.21 1.27-2.2h2.51l1.27 2.2-1.27 2.21Zm-4.66-2.67-1.27-2.2 1.27-2.2h2.55l1.27 2.2-1.27 2.2Zm-4.68 2.71-1.27-2.21 1.27-2.2h2.52l1.27 2.2-1.27 2.21Zm-4.68-2.71-1.27-2.2 1.27-2.2h2.52l1.27 2.2-1.27 2.2Zm-4.68 2.71-1.28-2.21 1.28-2.2h2.51l1.28 2.2-1.28 2.21h-2.51Zm-4.66-2.71-1.27-2.2 1.27-2.2h2.52l1.27 2.2-1.27 2.2Zm-4.67 2.71-1.28-2.21 1.28-2.2h2.51l1.27 2.2-1.27 2.21Zm-4.66-2.71-1.27-2.2 1.27-2.2h2.51l1.27 2.2-1.27 2.2Zm-4.68 2.71-1.27-2.21 1.27-2.2h2.52l1.27 2.2-1.27 2.21Zm-4.68-2.71-1.28-2.2 1.28-2.2h2.51l1.28 2.2-1.28 2.2ZM17.67 18l1.28 2.2-1.28 2.2h-2.51l-1.28-2.2 1.28-2.2Zm4.69-2.73 1.27 2.21-1.27 2.2h-2.52l-1.27-2.2 1.27-2.21Zm4.67 2.71 1.27 2.2-1.27 2.2h-2.51l-1.27-2.2 1.27-2.2Zm4.66-2.71 1.27 2.21-1.27 2.2h-2.51l-1.28-2.2 1.28-2.21Zm4.68 2.71 1.27 2.2-1.27 2.2h-2.52l-1.27-2.2 1.27-2.2Zm4.65-2.71 1.28 2.21-1.28 2.2h-2.51l-1.28-2.2 1.28-2.21Zm4.69 13.52 1.27 2.2-1.27 2.2h-2.52l-1.27-2.2 1.27-2.2Zm4.68-2.7 1.27 2.2-1.27 2.2h-2.52l-1.27-2.22 1.27-2.2Zm4.71-2.69 1.27 2.21-1.27 2.2h-2.55l-1.27-2.2 1.27-2.21Zm-2.55 58.47-1.27-2.2 1.27-2.21h2.55l1.27 2.21-1.27 2.2Zm-4.68 2.7-1.27-2.2 1.27-2.2h2.52l1.27 2.2-1.27 2.2Zm-4.68-2.7-1.27-2.2 1.27-2.21h2.52l1.27 2.21-1.27 2.2Zm-4.68 2.7-1.28-2.2 1.28-2.2h2.51l1.28 2.2-1.28 2.2h-2.51Zm-4.66-2.7-1.27-2.2 1.27-2.21h2.52l1.27 2.21-1.27 2.2Zm-4.67 2.7-1.28-2.2 1.28-2.2h2.51l1.27 2.2-1.27 2.2Zm-4.66-2.7-1.27-2.2 1.27-2.21h2.51l1.27 2.21-1.27 2.2Zm-4.68 2.7-1.27-2.2 1.27-2.2h2.52l1.27 2.2-1.27 2.2Zm-4.68-2.7-1.28-2.2 1.28-2.21h2.51l1.28 2.21-1.28 2.2Zm2.51-58.47 1.28 2.21-1.28 2.2h-2.51l-1.28-2.2 1.28-2.21Zm4.69-2.7 1.27 2.2-1.27 2.21h-2.52l-1.27-2.21 1.27-2.2Zm4.67 2.7 1.27 2.21-1.27 2.2h-2.51l-1.27-2.2 1.27-2.21Zm4.66-2.7 1.27 2.2-1.27 2.21h-2.51L27.9 22.9l1.28-2.2Zm4.68 2.7 1.27 2.21-1.27 2.2h-2.52l-1.27-2.2 1.27-2.21Zm4.65-2.7 1.28 2.2-1.28 2.21h-2.51l-1.28-2.21 1.28-2.2Zm4.69 13.51 1.27 2.21-1.27 2.2h-2.52l-1.27-2.2 1.27-2.21Zm4.68-2.7 1.27 2.2-1.27 2.21h-2.52l-1.27-2.21 1.27-2.2Zm4.67-2.7 1.27 2.2-1.23 2.2h-2.55l-1.27-2.2 1.27-2.2h2.51Zm-2.51 47.65-1.27-2.19 1.27-2.2h2.55l1.27 2.2-1.27 2.19Zm-4.68 2.71-1.27-2.21 1.27-2.2h2.52l1.27 2.2-1.27 2.21Zm-4.68-2.71-1.27-2.19 1.27-2.2h2.52l1.27 2.2-1.27 2.2h-2.52Zm-4.68 2.7-1.28-2.21 1.28-2.2h2.51l1.28 2.2-1.28 2.21h-2.51Zm-4.66-2.71-1.27-2.19 1.27-2.2h2.52l1.27 2.2-1.27 2.2h-2.52Zm-4.67 2.7-1.28-2.21 1.28-2.2h2.51l1.27 2.2-1.27 2.21Zm-4.66-2.71-1.27-2.19 1.27-2.2h2.51l1.27 2.2-1.27 2.2h-2.51Zm-4.68 2.7-1.27-2.21 1.27-2.2h2.52l1.27 2.2-1.27 2.21Zm-4.68-2.71-1.28-2.19 1.28-2.2h2.51l1.28 2.2-1.28 2.2h-2.51Zm2.51-47.66 1.28 2.2-1.28 2.2h-2.51l-1.28-2.2 1.28-2.2Zm4.69-2.7 1.27 2.2-1.27 2.2h-2.52l-1.27-2.24 1.27-2.2Zm4.67 2.7 1.27 2.2-1.27 2.2h-2.51l-1.27-2.2 1.27-2.2Zm4.66-2.7 1.27 2.2-1.27 2.2h-2.51l-1.28-2.24 1.28-2.2Zm4.68 2.7 1.27 2.2-1.27 2.2h-2.52l-1.27-2.2 1.27-2.2Zm4.65-2.7 1.28 2.16-1.28 2.2h-2.51l-1.28-2.2 1.28-2.2Zm4.69 13.51 1.27 2.2-1.27 2.21h-2.52l-1.27-2.21 1.27-2.2Zm4.68-2.7 1.27 2.2-1.27 2.2h-2.52l-1.27-2.2 1.27-2.2Zm4.71-2.71 1.27 2.21-1.27 2.2h-2.55l-1.27-2.2 1.27-2.21Zm-2.51 36.85-1.27-2.21 1.27-2.2h2.51l1.27 2.2-1.27 2.21Zm-4.68 2.7-1.27-2.2 1.27-2.21h2.52l1.27 2.21-1.27 2.2Zm-4.68-2.7-1.27-2.21 1.27-2.2h2.52l1.27 2.2-1.27 2.21Zm-4.68 2.7-1.28-2.2 1.28-2.21h2.51l1.28 2.21-1.28 2.2h-2.51Zm-4.66-2.7-1.27-2.21 1.27-2.2h2.52l1.27 2.2-1.27 2.21Zm-4.67 2.7-1.28-2.2 1.28-2.21h2.51L33 71.52l-1.27 2.2Zm-4.66-2.7-1.27-2.21 1.27-2.2h2.51l1.27 2.2-1.27 2.21Zm-4.68 2.7-1.27-2.2 1.27-2.21h2.52l1.27 2.21-1.27 2.2Zm2.52-42.25 1.27 2.2-1.27 2.21h-2.56l-1.27-2.21 1.27-2.2Zm4.67 2.7 1.27 2.21-1.27 2.2h-2.55l-1.27-2.2 1.27-2.21Zm4.66-2.7 1.27 2.2-1.27 2.21h-2.55l-1.28-2.21 1.28-2.2Zm4.68 2.7 1.27 2.21-1.27 2.2h-2.56l-1.27-2.2 1.27-2.21Zm4.65-2.7 1.28 2.2-1.28 2.21h-2.55l-1.28-2.21 1.28-2.2Zm4.69 13.52 1.27 2.2-1.27 2.2h-2.56l-1.27-2.16 1.27-2.2Zm4.68-2.71 1.27 2.21-1.27 2.2h-2.56l-1.27-2.2 1.27-2.21Zm-2.52 26-1.27-2.2 1.27-2.2h2.52l1.27 2.2-1.27 2.2Zm-4.68-2.7-1.27-2.2 1.23-2.15h2.52l1.27 2.21-1.27 2.2Zm-4.68 2.7-1.28-2.2 1.28-2.2h2.51l1.28 2.2-1.28 2.2h-2.51Zm-4.66-2.7-1.27-2.2 1.23-2.15h2.52l1.27 2.21-1.27 2.2Zm-4.67 2.7-1.28-2.2 1.28-2.2h2.51l1.27 2.2-1.27 2.2Zm-4.66-2.7-1.27-2.2 1.23-2.15h2.51l1.27 2.21-1.27 2.2-2.47-.06Zm-4.68 2.7-1.27-2.2 1.27-2.2h2.52l1.27 2.2-1.27 2.2Zm2.52-31.43 1.27 2.2-1.27 2.2h-2.56l-1.27-2.2 1.27-2.2Zm4.67 2.7 1.27 2.2-1.27 2.21h-2.55l-1.27-2.21 1.27-2.2Zm4.66-2.7 1.27 2.2-1.27 2.2h-2.55l-1.28-2.2 1.28-2.2Zm4.68 2.7 1.27 2.2-1.27 2.21h-2.56l-1.27-2.21 1.27-2.2Zm4.65-2.7 1.28 2.2-1.28 2.2h-2.55l-1.28-2.2 1.28-2.2Zm4.69 13.51 1.27 2.21-1.27 2.2h-2.56l-1.27-2.2 1.27-2.21Zm4.68-2.7 1.27 2.2-1.27 2.21h-2.56l-1.27-2.21 1.27-2.2Zm-2.52 15.22-1.27-2.21 1.27-2.2h2.52l1.27 2.2-1.27 2.21Zm-4.72-2.65-1.27-2.2 1.27-2.2h2.52l1.27 2.2-1.27 2.2Zm-4.68 2.71-1.28-2.21 1.28-2.2h2.51l1.28 2.2-1.28 2.21h-2.51Zm-4.66-2.71-1.27-2.2 1.27-2.2h2.52l1.27 2.2-1.27 2.2Zm-4.67 2.71-1.28-2.21 1.28-2.2h2.51l1.27 2.2-1.27 2.21Zm-4.66-2.71-1.27-2.2 1.27-2.2h2.51l1.27 2.2-1.27 2.2Zm-4.68 2.71-1.27-2.21 1.27-2.2h2.52l1.27 2.2-1.27 2.21Zm2.52-20.63 1.27 2.21-1.27 2.2h-2.52l-1.27-2.2 1.27-2.21Zm4.67 2.71 1.27 2.21-1.27 2.2h-2.51l-1.27-2.2 1.27-2.2h2.51Zm4.66-2.72 1.27 2.21-1.27 2.2h-2.51l-1.28-2.2 1.28-2.21Zm4.68 2.71 1.27 2.2-1.27 2.2h-2.52l-1.27-2.19 1.27-2.2h2.52Zm4.65-2.72 1.28 2.21-1.28 2.2h-2.51l-1.28-2.2 1.28-2.21Zm-2.51 15.22-1.28-2.2 1.28-2.2h2.51l1.28 2.2-1.28 2.2Zm-4.66-2.7-1.27-2.2 1.27-2.21h2.52l1.27 2.21-1.27 2.2Zm-4.67 2.7-1.28-2.2 1.28-2.2h2.51l1.27 2.2-1.27 2.2Zm-4.66-2.7-1.27-2.2 1.27-2.21h2.51l1.27 2.21-1.27 2.2Zm7.17-7.11 1.27 2.2-1.27 2.21h-2.51L27.9 49.9l1.28-2.2Zm9.33 0 1.28 2.2-1.28 2.21h-2.51l-1.28-2.21 1.28-2.2Zm-18.66 0 1.27 2.2-1.27 2.21h-2.52l-1.27-2.21 1.27-2.2Zm0 5.41 1.27 2.2-1.27 2.2h-2.52l-1.27-2.2 1.27-2.2h2.52Zm28 0 1.27 2.2-1.27 2.2h-2.49l-1.27-2.2 1.27-2.2h2.49Zm2.16 12.51-1.27-2.2 1.3-2.21h2.55l1.27 2.21-1.27 2.17-2.58.03Zm0-5.41-1.27-2.2 1.27-2.2h2.58l1.27 2.2-1.27 2.2Zm0-5.4-1.27-2.2 1.27-2.21h2.58l1.27 2.21-1.27 2.17Zm0-5.41-1.24-2.19 1.27-2.2h2.55l1.27 2.2-1.27 2.16Zm0-5.4-1.27-2.21 1.27-2.2h2.58l1.27 2.2-1.27 2.18Zm-34.88-9.82 1.28 2.21-1.28 2.2h-2.48l-1.28-2.2 1.28-2.21Zm0 5.41 1.28 2.2L17.64 44h-2.48l-1.28-2.21 1.28-2.2Zm0 5.41 1.28 2.2-1.28 2.2h-2.48l-1.28-2.19 1.28-2.2h2.48Zm0 5.39 1.28 2.21-1.28 2.2h-2.48l-1.28-2.2 1.28-2.21Zm0 5.41 1.28 2.2-1.25 2.2h-2.51L13.88 58l1.28-2.2Zm0 5.4 1.28 2.21-1.28 2.2h-2.48l-1.28-2.2 1.28-2.21Zm0 5.41 1.28 2.2-1.28 2.21h-2.48l-1.28-2.21 1.28-2.2ZM57.21 84.5l-1.27-2.2 1.27-2.2h2.51l1.27 2.2-1.27 2.2Zm0-5.4-1.27-2.21 1.27-2.2h2.51l1.27 2.2-1.27 2.21Zm0-5.41-1.27-2.2 1.27-2.21h2.51l1.27 2.21-1.27 2.2Zm0-5.41-1.27-2.2 1.27-2.2h2.51l1.27 2.2-1.27 2.2Zm0-5.4-1.27-2.21 1.27-2.2h2.51l1.27 2.2-1.27 2.21Zm0-5.41-1.27-2.2 1.27-2.2h2.51l1.27 2.2-1.27 2.2Zm0-5.4-1.27-2.21 1.27-2.2h2.51l1.27 2.2-1.27 2.21Zm0-5.41-1.27-2.2 1.27-2.21h2.51l1.27 2.21-1.27 2.2Zm0-5.41-1.27-2.2 1.27-2.2h2.51l1.27 2.2-1.27 2.2Zm0-5.4-1.27-2.21 1.27-2.2h2.51l1.27 2.2-1.27 2.21Zm0-5.41-1.27-2.24 1.27-2.2h2.51l1.27 2.2-1.27 2.2ZM41.02 14.2h-2.51l-1-1.7H42Zm-3.38.5-1.27 2.21h-2.52l-1.27-2.21 1.27-2.2h2.52l1.27 2.2Zm-5.95-.5h-2.51l-1-1.7h4.48Zm-3.39.5-1.27 2.21h-2.51l-1.27-2.21 1.27-2.2h2.51l1.27 2.2Zm-5.94-.5h-2.52l-1-1.7h4.49l-.97 1.7Zm-3.41.5-1.28 2.21h-2.51l-1.28-2.21 1.28-2.2h2.51l1.28 2.2Zm-6-.5h-2.47l-1-1.7h4.48Zm0 1 1.27 2.21-1.27 2.2h-2.47l-1.27-2.2 1.27-2.21h2.47Zm0 5.41 1.27 2.2-1.27 2.21h-2.47l-1.27-2.21 1.27-2.2h2.47Zm0 5.41 1.27 2.2-1.27 2.2h-2.47L9.21 28.2l1.27-2.2Zm0 5.4 1.27 2.2-1.27 2.21h-2.47l-1.27-2.21 1.27-2.2Zm0 5.41 1.27 2.2-1.27 2.2h-2.47l-1.27-2.2 1.27-2.2Zm0 5.4 1.27 2.21-1.27 2.2h-2.47l-1.27-2.2 1.27-2.21Zm0 5.41 1.27 2.2-1.27 2.21h-2.47l-1.27-2.21 1.27-2.2Zm0 5.41 1.27 2.2-1.27 2.2h-2.47l-1.27-2.2 1.27-2.2Zm0 5.4 1.27 2.2-1.27 2.21h-2.47l-1.27-2.21 1.27-2.2Zm0 5.41 1.27 2.2-1.27 2.2h-2.47l-1.27-2.2 1.27-2.2Zm0 5.4 1.27 2.21-1.27 2.2h-2.47l-1.27-2.2 1.27-2.21Zm0 5.41 1.27 2.2-1.27 2.21h-2.47l-1.27-2.21 1.27-2.2Zm0 5.41 1.27 2.2-1.27 2.2h-2.47l-1.27-2.2 1.27-2.2Zm0 5.4 1.27 2.2-1.27 2.21h-2.47l-1.27-2.21 1.27-2.2Zm-3.78 13 1.27-2.21h2.51l1.27 2.21-1.27 2.2h-2.47l-1.31-2.2Zm9.36 0 1.27-2.21h2.52l1.27 2.21-1.27 2.2h-2.48Zm9.33 0 1.28-2.21h2.51l1.27 2.21-1.27 2.2h-2.47l-1.32-2.2Zm9.33 0 1.28-2.21h2.51l1.28 2.21-1.28 2.2h-2.47Zm9.37 0 1.27-2.21h2.52l1.27 2.21-1.27 2.2h-2.48l-1.31-2.2Zm9.34 0 1.27-2.21h2.51l1.27 2.21-1.27 2.2h-2.47Zm.39-89.2-1.19 2.24h-2.55l-1.27-2.2 1.27-2.21h2.55l1.19 2.17Zm-10.62 3.2 1.27 2.2-1.27 2.21h-2.48l-1.27-2.21 1.27-2.2Zm-28 90.9H15.1l-1.23-2.18 1.29-2.22h2.51l1.28 2.2-1.28 2.2Zm9.37 0h-2.55l-1.25-2.18 1.28-2.22h2.51l1.28 2.2-1.27 2.2Zm9.33 0h-2.55l-1.25-2.18 1.28-2.22h2.52l1.27 2.2-1.27 2.2Zm9.34 0h-2.55l-1.26-2.18 1.29-2.22h2.52l1.27 2.2-1.27 2.2Zm9.36 0h-2.54l-1.26-2.18 1.28-2.22h2.55l1.28 2.2-1.31 2.2Zm10.6-2.2-1.27 2.2h-2.54l-1.26-2.18 1.28-2.22h2.52l1.27 2.2Zm0-5.41-1.27 2.21h-2.52l-1.27-2.21 1.27-2.2h2.52Zm0-5.4-1.27 2.2h-2.52l-1.27-2.2 1.27-2.17h2.52Zm0-5.41L64.4 87.2h-2.52L60.61 85l1.27-2.2h2.52l1.27 2.16Zm0-5.4-1.27 2.2h-2.52l-1.27-2.2 1.27-2.21h2.52Zm0-5.41-1.27 2.2h-2.52l-1.27-2.15 1.27-2.2h2.52Zm0-5.41-1.27 2.21h-2.52l-1.27-2.21 1.27-2.2h2.52Zm0-5.4-1.27 2.2h-2.52l-1.27-2.2 1.27-2.14h2.52Zm0-5.41L64.4 60.2h-2.52L60.61 58l1.27-2.2h2.52Zm0-5.4-1.27 2.2h-2.52l-1.27-2.2 1.27-2.21h2.52Zm0-5.41-1.27 2.2h-2.52l-1.27-2.12 1.27-2.2h2.52Zm0-5.41-1.27 2.21h-2.52l-1.27-2.21 1.27-2.2h2.52Zm0-5.4-1.27 2.2h-2.52l-1.27-2.2 1.27-2.21h2.52Zm0-5.41-1.27 2.2h-2.52l-1.27-2.2 1.27-2.2h2.52Zm0-5.4-1.27 2.2h-2.52l-1.27-2.2 1.27-2.21h2.52Zm0-5.41-1.27 2.2h-2.52l-1.27-2.2 1.27-2.2h2.52Zm0-5.41-1.27 2.21h-2.52l-1.27-2.21 1.27-2.2h2.52Zm0-5.4-1.27 2.2h-2.52l-1.27-2.2 1.27-2.21h2.52ZM57.2 4.37h2.54L61 6.55l-1.28 2.23h-2.51l-1.28-2.21Zm-9.33 0h2.54l1.26 2.18-1.28 2.23h-2.52L46.6 6.57l1.27-2.2Zm-2.16 2.7 1.27 2.21-1.27 2.2h-2.14l1.29-4.41h.85Zm-7.2-2.7h2.59l1 1.7h-4.58Zm-9.34 0h2.54l1 1.7h-4.52Zm-9.33 0h2.54l1 1.7h-4.53l.99-1.7Zm-9.36 0h2.54l1 1.7H9.49l.99-1.7Zm-6 4.91 1.27-2.21h1.84l-1.3 4.41H5.8l-1.32-2.2Zm0 5.4 1.27-2.2h2.54l1.27 2.2-1.27 2.21H5.8l-1.32-2.21Zm0 5.41 1.27-2.2h2.54l1.27 2.2-1.27 2.2H5.8l-1.32-2.2Zm0 5.41 1.27-2.21h2.54l1.27 2.21-1.27 2.2H5.8l-1.32-2.2Zm0 5.4 1.27-2.2h2.54l1.27 2.2-1.27 2.2H5.8l-1.32-2.2Zm0 5.41 1.27-2.21h2.54l1.27 2.21-1.27 2.2H5.8l-1.32-2.2Zm0 5.4 1.27-2.2h2.54l1.27 2.2-1.27 2.21H5.8l-1.32-2.21Zm0 5.41 1.27-2.2h2.54l1.27 2.2-1.27 2.2H5.8l-1.32-2.2Zm0 5.41 1.27-2.21h2.54l1.27 2.21-1.27 2.2H5.8l-1.32-2.2Zm0 5.4 1.27-2.2h2.54l1.27 2.2-1.22 2.27H5.8Zm0 5.41L5.8 61.2h2.54l1.27 2.21-1.27 2.2H5.8Zm0 5.4 1.27-2.2h2.54l1.27 2.2-1.27 2.21H5.8l-1.32-2.21Zm0 5.41 1.27-2.2h2.54l1.27 2.2-1.27 2.2H5.8l-1.32-2.2Zm0 5.41 1.27-2.21h2.54l1.27 2.21-1.27 2.2H5.8l-1.32-2.2Zm0 5.4 1.27-2.2h2.54l1.27 2.2-1.22 2.24H5.8Zm0 5.41L5.8 88.2h2.54l1.27 2.21-1.27 2.2H5.8Zm0 5.4 1.27-2.2h2.54l1.27 2.2-1.27 2.21H5.8l-1.32-2.21Zm1.27 3.21h2.54l1.27 2.2-1.27 2.2H5.8l-1.27-2.18 1.22-2.22ZM67.25 11.86a2.437 2.437 0 0 0 2.44 2.44V9.41a2.437 2.437 0 0 0-2.44 2.44Zm1.22.5a.5.5 0 1 1 .5-.5.5.5 0 0 1-.5.5ZM67.25 39.93a2.437 2.437 0 0 0 2.44 2.44v-4.89a2.437 2.437 0 0 0-2.44 2.44Zm1.22.5a.5.5 0 1 1 .5-.5.5.5 0 0 1-.5.5ZM67.25 68a2.437 2.437 0 0 0 2.44 2.44v-4.89a2.437 2.437 0 0 0-2.44 2.44Zm1.22.5a.5.5 0 1 1 .5-.5.5.5 0 0 1-.5.5ZM67.25 96.07a2.437 2.437 0 0 0 2.44 2.44v-4.89a2.437 2.437 0 0 0-2.44 2.44Zm1.22.5a.5.5 0 1 1 .5-.5.5.5 0 0 1-.5.5ZM.5 9.42v4.89a2.44 2.44 0 1 0 0-4.88Zm.72 2.44a.5.5 0 1 1 .5.5.5.5 0 0 1-.5-.5ZM.5 37.49v4.89a2.44 2.44 0 1 0 0-4.88Zm.72 2.44a.5.5 0 1 1 .5.5.5.5 0 0 1-.5-.5ZM.5 65.56v4.89a2.44 2.44 0 0 0 0-4.88ZM1.22 68a.5.5 0 1 1 .5.5.5.5 0 0 1-.5-.5ZM.5 93.63v4.89a2.44 2.44 0 0 0 0-4.88Zm.72 2.44a.5.5 0 1 1 .5.5.5.5 0 0 1-.5-.5ZM9.47 2.94A2.437 2.437 0 0 0 11.91.5H7.02a2.437 2.437 0 0 0 2.44 2.44Zm.5-1.22a.5.5 0 1 1-.5-.5.5.5 0 0 1 .5.5ZM35.1 2.94A2.437 2.437 0 0 0 37.54.5h-4.89a2.437 2.437 0 0 0 2.44 2.44Zm.5-1.22a.5.5 0 1 1-.5-.5.5.5 0 0 1 .5.5ZM60.73 2.94A2.437 2.437 0 0 0 63.17.5h-4.89a2.437 2.437 0 0 0 2.44 2.44Zm.5-1.22a.5.5 0 1 1-.5-.5.5.5 0 0 1 .5.5ZM7.03 107.44h4.89a2.44 2.44 0 1 0-4.88 0Zm2.44-.72a.5.5 0 1 1 .5-.5.5.5 0 0 1-.5.5ZM32.66 107.44h4.89a2.44 2.44 0 1 0-4.88 0Zm2.44-.72a.5.5 0 1 1 .5-.5.5.5 0 0 1-.5.5ZM58.29 107.44h4.89a2.44 2.44 0 0 0-4.88 0Zm2.44-.72a.5.5 0 1 1 .5-.5.5.5 0 0 1-.5.5Z"
  })));
};

/* harmony default export */ var package_items_icons_IconGrill = (IconGrill_IconGrill);
// CONCATENATED MODULE: ./public/static/icons/package-items-icons/IconCableBundle.tsx
var IconCableBundle_jsx = react_default.a.createElement;


var IconCableBundle_IconCableBundle = function IconCableBundle() {
  return /*#__PURE__*/react_default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.55,
    height: 104.137
  }, /*#__PURE__*/react_default.a.createElement("path", {
    d: "M40.28 103.707a20.67 20.67 0 1 1 20.67-20.67 20.69 20.69 0 0 1-20.67 20.67Zm0-40.6a19.93 19.93 0 1 0 19.93 19.93 19.952 19.952 0 0 0-19.93-19.93Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M40.28 103.807a26.47 26.47 0 1 1 26.47-26.47 26.5 26.5 0 0 1-26.47 26.47Zm0-52a25.53 25.53 0 1 0 25.53 25.53 25.555 25.555 0 0 0-25.53-25.53Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M40.28 104.137a37.445 37.445 0 0 1-37.4-37.4h1a36.443 36.443 0 0 0 36.4 36.4ZM2.87 36.637h1v30.1h-1z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M39.79 104.127v-.98c20.29 0 36.79-15.75 36.79-35.11l.15-18.4h.98l-.15 18.41c0 19.9-16.95 36.09-37.78 36.09ZM6.69 22.207l-.6-.13a13.362 13.362 0 0 0-5.49 0l-.6.13v-9.63l.28-.14a2.424 2.424 0 0 1 .4-.14 1.67 1.67 0 0 0 .2-.06l.12-.04a11.993 11.993 0 0 1 4.7 0 1.654 1.654 0 0 1 .73.24l.28.14v9.63Zm-5.7-8.95v7.73a14.258 14.258 0 0 1 4.7 0v-7.78a.563.563 0 0 0-.1-.02 11.178 11.178 0 0 0-4.35-.02 1.946 1.946 0 0 1-.25.09Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "m.46 26.007-.17-1.73.35-.06a14.158 14.158 0 0 1 1.59-.19v-.25a12.775 12.775 0 0 0-1.34.15l-.66.1v-1.75l.32-.05a18.624 18.624 0 0 1 5.82 0l.35.06-.18 1.75-.39-.07c-.29-.05-.6-.07-.92-.1-.18-.01-.37-.03-.55-.05v.21c.55.03 1.12.12 1.59.19l.35.06-.17 1.73-.38-.04a22.689 22.689 0 0 0-5.21 0l-.38.04Zm2.95-.94c.78 0 1.56.04 2.35.11l.03-.27a10.87 10.87 0 0 0-1.49-.14h-.38v-1.82l.44.07c.29.05.6.07.92.1.2.02.4.03.59.05l.03-.26a18.015 18.015 0 0 0-4.92 0v.24a10.613 10.613 0 0 1 1.62-.14h.38v1.75H2.6a10.725 10.725 0 0 0-1.49.14l.03.27c.75-.07 1.51-.11 2.28-.11Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "m6.33 30.007-.38-.05a19.35 19.35 0 0 0-4.81 0l-.35.04-.33-1.82.38-.06c.31-.05.59-.08.88-.1.17-.02.34-.03.51-.05v-.29a9.593 9.593 0 0 0-1.25.18l-.45.09v-1.67l.31-.05a15.39 15.39 0 0 1 5.33 0l.31.05v1.66l-.44-.07c-.29-.05-.56-.07-.82-.1-.15-.01-.29-.03-.44-.04v.21a10.8 10.8 0 0 1 1.16.16l.57.1-.17 1.83Zm-5-1.2.07.37a20.122 20.122 0 0 1 4.25 0l.03-.37a7.084 7.084 0 0 0-1.3-.14H4v-1.82l.44.07c.29.05.56.07.82.1.15.01.29.03.44.04v-.15a14.436 14.436 0 0 0-4.45 0v.13a7.825 7.825 0 0 1 1.33-.12h.38v1.69l-.31.05c-.31.05-.59.08-.88.1-.15.01-.29.03-.45.04Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M5.86 37.387H.92l-.46-7.24.47-.06a19.648 19.648 0 0 1 4.92.1l.47.06Zm-4-1h3.06l.34-5.26a18.156 18.156 0 0 0-3.74-.09l.34 5.35ZM5.06 10.767H1.73v-6.63a.883.883 0 0 1 .1-.37l-.1-1.98a1.042 1.042 0 0 1 .05-.33l.07-.12a1.114 1.114 0 0 1 .08-.12l.88-.97a.827.827 0 0 1 1.18 0l.87.96a.668.668 0 0 1 .14.23.844.844 0 0 1 .07.32l-.1 1.98a.756.756 0 0 1 .1.39v6.63Zm-2.5-.83h1.67v-5.8l-.13-.13.02-.16.11-2.05v-.05l-.85-.95-.81.96.12 2.22-.08.12-.04 1.03v4.8Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M2.25 3.367h2.28v1H2.25zM2.25 1.377h2.28v1H2.25zM80.52 34.957l-.6-.13a13.362 13.362 0 0 0-5.49 0l-.6.13v-9.62l.28-.14a2.424 2.424 0 0 1 .4-.14 1.669 1.669 0 0 0 .2-.06l.13-.04a11.993 11.993 0 0 1 4.7 0 1.738 1.738 0 0 1 .73.24l.28.14v9.62Zm-5.7-8.95v7.73a14.258 14.258 0 0 1 4.7 0v-7.77a.563.563 0 0 0-.1-.02 11.323 11.323 0 0 0-4.34-.02 1.614 1.614 0 0 1-.26.09Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "m74.29 38.757-.17-1.73.35-.06a14.446 14.446 0 0 1 1.59-.19v-.25a12.9 12.9 0 0 0-1.33.15l-.67.1v-1.75l.32-.05a18.931 18.931 0 0 1 5.82 0l.35.06-.17 1.75-.4-.07c-.29-.05-.6-.07-.92-.1-.18-.01-.37-.03-.55-.05v.21c.54.03 1.12.12 1.59.19l.35.06-.17 1.73-.38-.04a22.69 22.69 0 0 0-5.21 0l-.38.04Zm2.95-.94c.78 0 1.56.04 2.35.11l.03-.27a10.87 10.87 0 0 0-1.49-.14h-.38v-1.82l.44.07c.29.05.6.07.92.1.2.02.39.03.58.05l.03-.26a18.015 18.015 0 0 0-4.92 0v.24a10.613 10.613 0 0 1 1.62-.14h.38v1.75h-.38a10.87 10.87 0 0 0-1.49.14l.03.27c.75-.07 1.51-.11 2.28-.11Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "m80.16 42.757-.38-.05a19.843 19.843 0 0 0-4.81 0l-.35.04-.33-1.82.38-.06c.31-.05.59-.08.88-.1.17-.02.33-.03.51-.05v-.29a9.593 9.593 0 0 0-1.25.18l-.45.09v-1.67l.31-.05a15.39 15.39 0 0 1 5.33 0l.31.05v1.66l-.44-.07c-.29-.05-.56-.07-.82-.1-.15-.01-.29-.03-.44-.04v.21a10.8 10.8 0 0 1 1.16.16l.56.1-.17 1.83Zm-5-1.2.07.37a20.122 20.122 0 0 1 4.25 0l.03-.37a7.071 7.071 0 0 0-1.29-.14h-.38v-1.82l.44.07c.29.05.56.07.82.1.15.01.29.03.44.04v-.15a15.084 15.084 0 0 0-4.45 0v.13a7.8 7.8 0 0 1 1.32-.12h.38v1.69l-.31.05c-.31.05-.59.08-.88.1-.15.01-.29.03-.44.04Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M79.69 50.137h-4.94l-.46-7.24.47-.06a19.626 19.626 0 0 1 4.92.1l.47.06Zm-4-1h3.06l.34-5.26a19.622 19.622 0 0 0-3.74-.09l.34 5.35ZM78.89 23.517h-3.33v-6.64a.883.883 0 0 1 .1-.37l-.1-1.98a1 1 0 0 1 .05-.33l.07-.12a.467.467 0 0 1 .09-.13l.87-.97a.827.827 0 0 1 1.18 0l.87.96a.668.668 0 0 1 .14.23.737.737 0 0 1 .06.27v.06l-.1 1.98a.756.756 0 0 1 .1.39v6.63Zm-2.5-.83h1.67v-5.8l-.13-.13.02-.16.11-2.04v-.06l-.86-.95-.81.97.12 2.22-.08.12-.04 1.03v4.8Zm2.05-8.34-.11.04Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M76.08 16.117h2.28v1h-2.28zM76.08 14.127h2.28v1h-2.28z"
  }));
};

/* harmony default export */ var package_items_icons_IconCableBundle = (IconCableBundle_IconCableBundle);
// CONCATENATED MODULE: ./public/static/icons/package-items-icons/IconMicrophone.tsx
var IconMicrophone_jsx = react_default.a.createElement;


var IconMicrophone_IconMicrophone = function IconMicrophone() {
  return /*#__PURE__*/react_default.a.createElement("svg", {
    width: "120",
    height: "120",
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react_default.a.createElement("path", {
    d: "M66.75 39L71.15 98.8C71.2096 99.8852 71.6741 100.908 72.4518 101.668C73.2295 102.427 74.2637 102.867 75.35 102.9V102.9C76.4523 102.887 77.5086 102.457 78.3065 101.696C79.1043 100.935 79.5843 99.9004 79.65 98.8L83.35 39.5",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M67.75 52.4H82.65",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M75.55 102.8C75.55 110.6 69.65 116.9 62.35 116.9",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M63 116.9C56 116.9 50.4 110.6 50.4 102.8V65.8",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M50.35 65.8C50.35 59.8 44.75 55 37.95 55",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M38 54.9C31.1 54.9 25.6 59.7 25.6 65.7",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M94.15 25.1C94.3488 24.1124 94.4493 23.1075 94.45 22.1C94.45 17.0344 92.4377 12.1762 88.8557 8.59426C85.2738 5.01232 80.4156 3 75.35 3C70.2844 3 65.4262 5.01232 61.8443 8.59426C58.2623 12.1762 56.25 17.0344 56.25 22.1C56.2507 23.1075 56.3512 24.1124 56.55 25.1",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M94.15 25.1C93.4052 29.5746 91.097 33.6399 87.6361 36.5724C84.1752 39.5048 79.7862 41.1143 75.25 41.1143C70.7138 41.1143 66.3247 39.5048 62.8638 36.5724C59.4029 33.6399 57.0947 29.5746 56.35 25.1",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M94.15 25.1C89.35 27.7 82.65 29.3 75.25 29.3C68.7048 29.4316 62.2234 27.9913 56.35 25.1",
    stroke: "#212222",
    strokeMiterlimit: "10"
  }));
};

/* harmony default export */ var package_items_icons_IconMicrophone = (IconMicrophone_IconMicrophone);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/learn-more/content.tsx
var content_jsx = react_default.a.createElement;














var content_packageItems = [{
  packageItemId: 'soundboks-gen-3-rf',
  title: 'Soundboks (Gen 3)',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconSoundboks3, null)
}, {
  packageItemId: 'batteryboks',
  title: 'Batteryboks',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconBattery, null)
}, {
  packageItemId: 'charger',
  title: 'Charger',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconCharger, null)
}, {
  packageItemId: 'microphone',
  title: 'Microphone',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconMicrophone, null)
}, {
  packageItemId: 'cable-bundle',
  title: 'Cable Bundle',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconCableBundle, null)
}, {
  packageItemId: 'powerbank',
  title: 'Powerbank',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconPowerbank, null)
}, {
  packageItemId: 'grill',
  title: 'Grill',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconGrill, null)
}, {
  packageItemId: 'tripod-backpack',
  title: 'Tripod Backpack',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconTripodBackpack, null)
}, {
  packageItemId: 'tripod',
  title: 'Tripod',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconTripod, null)
}, {
  packageItemId: 'backpack',
  title: 'Backpack',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconSB3Backpack, null)
}, {
  packageItemId: 'backpack-manual',
  title: 'Backpack Manual',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconManual, null),
  downloadUrl: backpack["default"]
}, {
  packageItemId: 'soundboks-gen-3-manual',
  title: 'Manual',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconManual, null),
  downloadUrl: soundboks3["default"]
}];
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/learn-more/tech-spec/styled.ts

var DescList = styled_components_browser_esm["default"].dl.withConfig({
  displayName: "styled__DescList",
  componentId: "sc-16r8bg0-0"
})(["margin:20px 0 0 0;"]);
var DescTitle = styled_components_browser_esm["default"].dt.withConfig({
  displayName: "styled__DescTitle",
  componentId: "sc-16r8bg0-1"
})(["margin:0;"]);
var DescDetails = styled_components_browser_esm["default"].dd.withConfig({
  displayName: "styled__DescDetails",
  componentId: "sc-16r8bg0-2"
})(["margin:0;"]);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/learn-more/tech-spec/index.web.tsx
var tech_spec_index_web_jsx = react_default.a.createElement;





 // eslint-disable-next-line prefer-arrow-callback

var index_web_TechSpec = /*#__PURE__*/react_default.a.memo(function TechSpec() {
  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, null, /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "SOUND"
  })), /*#__PURE__*/react_default.a.createElement(DescList, null, /*#__PURE__*/react_default.a.createElement(DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "AMPLIFIER"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Merus Audio eximo\xAE amp switching"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "3 \xD7 72W RMS class D amplifiers"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Advanced Bass DSP"
  })))), /*#__PURE__*/react_default.a.createElement(DescList, null, /*#__PURE__*/react_default.a.createElement(DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "ACOUSTICS"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Effective frequency range: 40Hz - 20kHz"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Custom sound profile with bass enhancer"
  })))), /*#__PURE__*/react_default.a.createElement(DescList, null, /*#__PURE__*/react_default.a.createElement(DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "DRIVER UNITS"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "2 \xD7 10\u201D 96dB woofers"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "1 \xD7 1\u201D 104dB compression driver tweeter"
  })))), /*#__PURE__*/react_default.a.createElement(DescList, null, /*#__PURE__*/react_default.a.createElement(DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "CONNECTIVITY"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Bluetooth 5.0"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "TeamUP connection"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Wirelessly connect up to 5 (total) nearby New SOUNDBOKS(2019) speakers (SKAA network)"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Pro Panel"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA 2 \xD7 Combo microphone/instrument (XLR, 1/4\u201D) input"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA 1 \xD7 3.5mm Stereo Input"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA 1 \xD7 3.5mm Stereo Output"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Bond Button for advanced JOIN settings"
  })))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "BUILD"
  })), /*#__PURE__*/react_default.a.createElement(DescList, null, /*#__PURE__*/react_default.a.createElement(DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "WEIGHT"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "34 pounds (15.4 kg)"
  })))), /*#__PURE__*/react_default.a.createElement(DescList, null, /*#__PURE__*/react_default.a.createElement(DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "MATERIALS"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Poplar cabinet"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Powder-coated aluminum frame"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Powder-coated steel grill and handles"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Silicone ball corners"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "SMP temperature-flex adhesive"
  })))), /*#__PURE__*/react_default.a.createElement(DescList, null, /*#__PURE__*/react_default.a.createElement(DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "DIMENSIONS"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "66 \xD7 43 \xD7 32 cm / 25.6 \xD7 17 \xD7 13 inches (H \xD7 W \xD7 D)"
  })))), /*#__PURE__*/react_default.a.createElement(DescList, null, /*#__PURE__*/react_default.a.createElement(DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "FEATURES"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Swappable grill and batteries"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "IP65 rated electronics coating"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Pulse Reflex Port"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "UI Panel"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Volume control"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Host/Join mode for wireless TeamUP"
  })))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "BATTERY"
  })), /*#__PURE__*/react_default.a.createElement(DescList, null, /*#__PURE__*/react_default.a.createElement(DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "LIFE"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "40 hours at mid-volume"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "5 hours at full volume"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "3.5 hours full recharge"
  })))), /*#__PURE__*/react_default.a.createElement(DescList, null, /*#__PURE__*/react_default.a.createElement(DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "DESIGN"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "5-step LED battery-life indicator"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Heavy-duty DC-connector"
  })))), /*#__PURE__*/react_default.a.createElement(DescList, null, /*#__PURE__*/react_default.a.createElement(DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "CELL TYPE"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "12.8V, 7.8Ah Lithium Iron Phosphate (LiFePO4)"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "-10C to 40C temperature range"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "99.84Wh or 7.8Ah capacity"
  })))), /*#__PURE__*/react_default.a.createElement(DescList, null, /*#__PURE__*/react_default.a.createElement(DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "BATTERY MANAGEMENT SYSTEM (BMS)"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Over and under-discharge protection"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Short circuit protection"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Overheat protection"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Cell voltage management"
  })))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app"
  })), /*#__PURE__*/react_default.a.createElement(DescList, null, /*#__PURE__*/react_default.a.createElement(DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.soundSettings"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.soundSettings.1"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.soundSettings.2"
  })))), /*#__PURE__*/react_default.a.createElement(DescList, null, /*#__PURE__*/react_default.a.createElement(DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.proPanel"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.proPanel.1"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.proPanel.2"
  })))), /*#__PURE__*/react_default.a.createElement(DescList, null, /*#__PURE__*/react_default.a.createElement(DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.1"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.2"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.3"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.4"
  })))), /*#__PURE__*/react_default.a.createElement(DescList, null, /*#__PURE__*/react_default.a.createElement(DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings.1"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings.2"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings.3"
  })))), /*#__PURE__*/react_default.a.createElement(DescList, null, /*#__PURE__*/react_default.a.createElement(DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.firmwareUpdate"
  }))), /*#__PURE__*/react_default.a.createElement(DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.firmwareUpdate.1"
  })))));
});
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/learn-more/styled.ts



var LayoutContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__LayoutContainer",
  componentId: "sc-14u2jey-0"
})(["padding:0 190px;background-color:", ";@media ", "{padding:0 24px;}"], elements_theme["a" /* Color */].WhiteOff, styles_theme["a" /* default */].breakpoints.maxMobile);
var learn_more_styled_Link = styled_components_browser_esm["default"].a.withConfig({
  displayName: "styled__Link",
  componentId: "sc-14u2jey-1"
})(["color:", ";cursor:pointer;text-decoration:underline;"], elements_theme["a" /* Color */].Orange);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/learn-more/faqs/index.web.tsx
var faqs_index_web_jsx = react_default.a.createElement;





// eslint-disable-next-line prefer-arrow-callback
var index_web_FAQs = /*#__PURE__*/react_default.a.memo(function FAQs() {
  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    padding: {
      right: 10
    }
  }, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-1"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-1"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-2"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-2"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-3"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-3"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-4"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-4"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-5"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-5"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-6"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-6"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-7"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-7"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-8"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-8"
  }));
});
// CONCATENATED MODULE: ./components/pages/products-v2/config/learn-more-content.tsx
var learn_more_content_content = {
  shipping: {
    "default": 'product.learn-more.shipping.info',
    na: 'product.learn-more.shipping.info.na',
    no: 'product.learn-more.shipping.info.no',
    dk: 'product.learn-more.shipping.info.dk',
    de: 'product.learn-more.shipping.info.de',
    fr: 'product.learn-more.shipping.info.fr',
    gb: 'product.learn-more.shipping.info.gb',
    ca: 'product.learn-more.shipping.info.ca',
    se: 'product.learn-more.shipping.info.se'
  }
};
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/learn-more/index.tsx
var learn_more_jsx = react_default.a.createElement;


















var learn_more_LearnMoreSection = function LearnMoreSection(_ref) {
  var extraBattery = _ref.extraBattery,
      selectedMerch = _ref.selectedMerch,
      locale = _ref.locale;

  var _useSelector = Object(es["d" /* useSelector */])(function (state) {
    return state.settings;
  }),
      regionId = _useSelector.regionId;

  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(learn_more_LayoutContainer, null, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(elements_typography["e" /* Heading02 */], {
      ariaLevel: elements_typography["h" /* TextLevel */].H2,
      style: {
        textTransform: 'uppercase',
        textAlign: 'center'
      }
    }, i18n._('product.learn-more.heading')), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "35px"
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.whats-in-the-box",
      content: /*#__PURE__*/react_default.a.createElement(index_web_WhatsInTheBox, {
        extraBattery: extraBattery,
        selectedMerch: selectedMerch,
        packageItems: content_packageItems
      }),
      topItem: true
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.tech-specs",
      content: /*#__PURE__*/react_default.a.createElement(index_web_TechSpec, null)
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.whats-a-bluetooth-performance-speaker",
      content: /*#__PURE__*/react_default.a.createElement(index_web_WhatsBluetoothSpeaker, null)
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.shipping",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: learn_more_content_content.shipping[regionId] || learn_more_content_content.shipping["default"],
        components: [/*#__PURE__*/react_default.a.createElement(learn_more_styled_Link, {
          href: helpCenter_getHelpCenterUrl(locale, '/sections/360003609413-SHIPPING')
        }), /*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement("br", null)]
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.warranty",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "product.learn-more.warranty.info",
        components: [/*#__PURE__*/react_default.a.createElement(learn_more_styled_Link, {
          href: helpCenter_getHelpCenterUrl(locale, '/articles/211920329-RETURN-AND-REFUND-POLICY-AND-PROCESS')
        })]
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.payment-options",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "product.learn-more.payment-options.info"
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.faqs",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(index_web_FAQs, null))
    })));
  });
};

var learn_more_LayoutContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "learn-more__LayoutContainer",
  componentId: "icorc1-0"
})(["max-width:1062px;width:100%;@media ", "{padding:0 24px;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
/* harmony default export */ var learn_more = (learn_more_LearnMoreSection);
// CONCATENATED MODULE: ./components/elements/video-feature/styles.ts


var ShadowBox = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styles__ShadowBox",
  componentId: "sc-1scnms5-0"
})(["background:#FFFFFF;box-shadow:0px 2px 4px rgba(0,0,0,0.25);@media ", "{width:327px;}"], styles_theme["a" /* default */].breakpoints.tablet);
var VideoFeatureContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styles__VideoFeatureContainer",
  componentId: "sc-1scnms5-1"
})(["padding:0 24px;@media ", "{display:grid;grid-template-columns:1fr 1fr;grid-gap:25px;padding:0;}@media ", "{grid-template-columns:1fr 1fr 1fr;}"], styles_theme["a" /* default */].breakpoints.tablet, styles_theme["a" /* default */].breakpoints.desktop);
// EXTERNAL MODULE: ./components/elements/video-player/index.web.tsx + 2 modules
var video_player_index_web = __webpack_require__("5CrD");

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__("Vvt1");
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);

// CONCATENATED MODULE: ./components/elements/video-youtube/play-icon.tsx
var play_icon_jsx = react_default.a.createElement;


var play_icon_IconPlay = function IconPlay() {
  return /*#__PURE__*/react_default.a.createElement("svg", {
    width: "94",
    height: "96",
    viewBox: "0 0 94 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react_default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9993 22.5594V74.8571L70.8386 48.7053L28.9993 22.5594ZM37.7584 38.3609L54.313 48.7053L37.7584 59.0498V38.3609Z",
    fill: "white"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M47 0C21.0381 0 0 21.4206 0 47.8545C0 74.2885 21.0381 95.7091 47 95.7091C72.9619 95.7091 94 74.2885 94 47.8545C94 21.4206 72.9619 0 47 0ZM47 84.3151C27.3048 84.3151 11.1905 67.9079 11.1905 47.8545C11.1905 27.8012 27.3048 11.3939 47 11.3939C66.6952 11.3939 82.8095 27.8012 82.8095 47.8545C82.8095 67.9079 66.6952 84.3151 47 84.3151Z",
    fill: "white"
  }));
};

/* harmony default export */ var play_icon = (play_icon_IconPlay);
// CONCATENATED MODULE: ./components/elements/video-youtube/styled.ts


var Video = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Video",
  componentId: "trbuoq-0"
})(["position:relative;height:100%;width:100%;iframe,div{height:100%;width:100%;}"]);
var PreviewImage = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__PreviewImage",
  componentId: "trbuoq-1"
})(["height:100%;width:100%;background:", ";background-size:cover;background-position:center;"], function (_ref) {
  var shadow = _ref.shadow,
      customImage = _ref.customImage,
      videoId = _ref.videoId;
  return shadow ? "linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(".concat(customImage || "https://img.youtube.com/vi/".concat(videoId, "/maxresdefault.jpg"), ")") : "url(".concat(customImage || "https://img.youtube.com/vi/".concat(videoId, "/maxresdefault.jpg"), ")");
});
var PlayButton = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__PlayButton",
  componentId: "trbuoq-2"
})(["position:absolute;top:0;left:0;bottom:0;right:0;"]);
var styled_IconWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__IconWrapper",
  componentId: "trbuoq-3"
})(["display:flex;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;@media ", "{width:45px !important;}"], styles_theme["a" /* default */].breakpoints.onlyMobile);
var IconContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__IconContainer",
  componentId: "trbuoq-4"
})(["display:flex;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;"]);
// CONCATENATED MODULE: ./components/elements/video-youtube/index.web.tsx
var video_youtube_index_web_jsx = react_default.a.createElement;






var YouTube = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 22).then(__webpack_require__.bind(null, "pVhd"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("pVhd")];
    },
    modules: ['react-youtube']
  }
}); // youtube Videos
// eslint-disable-next-line prefer-arrow-callback

var index_web_VideoYouTube = /*#__PURE__*/react_default.a.memo(function VideoYouTube(_ref) {
  var videoId = _ref.videoId,
      customImage = _ref.customImage,
      circleIcon = _ref.circleIcon,
      shadow = _ref.shadow;

  var _useState = Object(react["useState"])(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var handlePreviewClick = function handlePreviewClick() {
    return setIsOpen(true);
  };

  var ytOptions = {
    height: '100%',
    width: '100%'
  };
  return /*#__PURE__*/react_default.a.createElement(Video, {
    onClick: function onClick() {
      return isOpen ? null : handlePreviewClick();
    }
  }, isOpen ? /*#__PURE__*/react_default.a.createElement(YouTube, {
    videoId: videoId,
    opts: ytOptions,
    onReady: function onReady(e) {
      return e.target.playVideo();
    }
  }) : /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(PreviewImage, {
    videoId: videoId,
    customImage: customImage,
    shadow: shadow
  }), /*#__PURE__*/react_default.a.createElement(PlayButton, null, circleIcon ? /*#__PURE__*/react_default.a.createElement(IconContainer, null, /*#__PURE__*/react_default.a.createElement(styled_IconWrapper, null, /*#__PURE__*/react_default.a.createElement(play_icon, null))) : /*#__PURE__*/react_default.a.createElement(atoms_Icon["b" /* default */], {
    id: atoms_Icon["a" /* IconId */].Play,
    color: theme["a" /* Color */].White,
    size: theme["d" /* IconSize */].MediumLarge
  }))));
});
// CONCATENATED MODULE: ./components/elements/video-feature/index.web.tsx
var video_feature_index_web_jsx = react_default.a.createElement;






 // eslint-disable-next-line prefer-arrow-callback

var index_web_VideoFeature = /*#__PURE__*/react_default.a.memo(function VideoFeature(_ref) {
  var videos = _ref.videos;
  return /*#__PURE__*/react_default.a.createElement(VideoFeatureContainer, null, videos.map(function (_ref2, index) {
    var videoUri = _ref2.videoUri,
        videoType = _ref2.videoType,
        posterUri = _ref2.posterUri,
        children = _ref2.children,
        controls = _ref2.controls,
        YouTubeId = _ref2.YouTubeId;
    return /*#__PURE__*/react_default.a.createElement("div", {
      key: (posterUri || YouTubeId) + index
    }, /*#__PURE__*/react_default.a.createElement(ShadowBox, null, YouTubeId && /*#__PURE__*/react_default.a.createElement("div", {
      style: {
        height: '184px'
      }
    }, /*#__PURE__*/react_default.a.createElement(index_web_VideoYouTube, {
      videoId: YouTubeId,
      shadow: true
    })), videoUri && /*#__PURE__*/react_default.a.createElement(video_player_index_web["a" /* VideoPlayer */], {
      videoUri: videoUri,
      videoType: videoType,
      posterUri: posterUri,
      controls: controls,
      muted: true
    }), /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      padding: {
        top: 14,
        right: 16,
        bottom: 14,
        left: 16
      }
    }, /*#__PURE__*/react_default.a.createElement(elements_typography["c" /* Caption01 */], null, children))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: {
        "default": '0px',
        mobile: '16px'
      }
    }));
  }));
});
// EXTERNAL MODULE: ./node_modules/react-swipeable/dist/react-swipeable.umd.js
var react_swipeable_umd = __webpack_require__("7BfX");

// CONCATENATED MODULE: ./components/elements/product-review/styled.ts



var styled_ReviewWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__ReviewWrapper",
  componentId: "pxwqna-0"
})(["display:flex;flex-direction:column;padding:0 48px;width:700px;@media ", "{padding:0;}"], styles_theme["a" /* default */].breakpoints.onlyMobile);
var SourceLogo = styled_components_browser_esm["default"].img.withConfig({
  displayName: "styled__SourceLogo",
  componentId: "pxwqna-1"
})(["display:block;width:auto;margin:0 auto;cursor:pointer;height:50px;"]);
var LogoWrapper = styled_components_browser_esm["default"].a.withConfig({
  displayName: "styled__LogoWrapper",
  componentId: "pxwqna-2"
})(["&:hover{text-decoration:none;}"]);
var CarouselOverflow = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__CarouselOverflow",
  componentId: "pxwqna-3"
})(["overflow:hidden;text-align:center;width:100%;"]);
var Inner = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Inner",
  componentId: "pxwqna-4"
})(["white-space:nowrap;margin:auto;transform:translateX(-", "%);transition:transform 0.3s;"], function (_ref) {
  var activeIndex = _ref.activeIndex;
  return activeIndex * 100;
});
var Item = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Item",
  componentId: "pxwqna-5"
})(["display:inline-flex;width:", ";height:200px;justify-content:center;color:#fff;h3{align-self:center;}@media ", "{padding:0px 24px;height:300px;}"], function (_ref2) {
  var width = _ref2.width;
  return width || 'auto';
}, styles_theme["a" /* default */].breakpoints.maxMobile);
var Indicators = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Indicators",
  componentId: "pxwqna-6"
})(["display:flex;justify-content:center;cursor:pointer;height:8px;width:8px;margin:0px 4px;background-color:", ";border-radius:50%;display:inline-block;transition:background-color 0.6s ease;&:hover{background-color:", ";}"], function (_ref3) {
  var index = _ref3.index,
      activeIndex = _ref3.activeIndex;
  return index === activeIndex ? elements_theme["a" /* Color */].Orange : 'rgba(250, 70, 22, 0.5)';
}, elements_theme["a" /* Color */].Orange);
var Arrows = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Arrows",
  componentId: "pxwqna-7"
})(["display:none;background-color:", ";box-shadow:1px 1px 4px rgba(0,0,0,0.25);border-radius:18px;position:absolute;cursor:", ";opacity:", ";top:calc(50% - 15px);", ";width:32px;height:auto;transition:0.2s ease-in-out;z-index:2;", " @media ", "{display:block;width:32px;top:calc(50% - 18px);}@media ", "{width:32px;top:calc(50% - 24px);}"], elements_theme["a" /* Color */].White, function (_ref4) {
  var isInactive = _ref4.isInactive;
  return isInactive ? 'default' : 'pointer';
}, function (_ref5) {
  var isInactive = _ref5.isInactive;
  return isInactive ? 0.5 : 1;
}, function (_ref6) {
  var direction = _ref6.direction;
  return direction === 'back' ? 'left: 8px' : 'right: 8px';
}, function (_ref7) {
  var isInactive = _ref7.isInactive;
  return isInactive && "&:hover {\n  background-color: '#F2F0F0';\n}";
}, styles_theme["a" /* default */].breakpoints.tablet, styles_theme["a" /* default */].breakpoints.desktopLarge);
// CONCATENATED MODULE: ./components/elements/product-review/carousel/arrow.tsx
var arrow_jsx = react_default.a.createElement;




var Arrow = /*#__PURE__*/react_default.a.memo(function (_ref) {
  var direction = _ref.direction,
      isInactive = _ref.isInactive,
      action = _ref.action;
  return /*#__PURE__*/react_default.a.createElement(Arrows, {
    direction: direction,
    onClick: action,
    isInactive: isInactive
  }, /*#__PURE__*/react_default.a.createElement(atoms_Icon["b" /* default */], {
    id: direction === 'forward' ? atoms_Icon["a" /* IconId */].Forward : atoms_Icon["a" /* IconId */].Back,
    color: theme["a" /* Color */].Primary,
    size: 30
  }));
});
// CONCATENATED MODULE: ./components/elements/product-review/carousel/index.tsx
var carousel_jsx = react_default.a.createElement;




var carousel_CarouselItem = function CarouselItem(_ref) {
  var children = _ref.children,
      width = _ref.width;
  return /*#__PURE__*/react_default.a.createElement(Item, {
    style: {
      width: width
    }
  }, children);
};
var carousel_Carousel = /*#__PURE__*/react_default.a.memo(function (_ref2) {
  var children = _ref2.children;

  var _useState = Object(react["useState"])(0),
      current = _useState[0],
      setCurrent = _useState[1];

  var length = children.length;

  var nextSlide = function nextSlide() {
    if (current !== length - 1) setCurrent(current === length - 1 ? 0 : current + 1);
  };

  var prevSlide = function prevSlide() {
    if (current !== 0) setCurrent(current === 0 ? length - 1 : current - 1);
  };

  var handlers = Object(react_swipeable_umd["useSwipeable"])({
    onSwipedLeft: function onSwipedLeft() {
      return nextSlide();
    },
    onSwipedRight: function onSwipedRight() {
      return prevSlide();
    }
  });
  return /*#__PURE__*/react_default.a.createElement(CarouselOverflow, handlers, /*#__PURE__*/react_default.a.createElement(Inner, {
    activeIndex: current
  }, react_default.a.Children.map(children, function (child) {
    return /*#__PURE__*/react_default.a.cloneElement(child, {
      width: '100%'
    });
  })), length > 1 && /*#__PURE__*/react_default.a.createElement(Arrow, {
    isInactive: current === 0,
    direction: "back",
    action: prevSlide
  }), react_default.a.Children.map(children, function (child, index) {
    return /*#__PURE__*/react_default.a.createElement(Indicators, {
      key: child.text,
      index: index,
      activeIndex: current,
      onClick: function onClick() {
        setCurrent(index);
      }
    });
  }), length > 1 && /*#__PURE__*/react_default.a.createElement(Arrow, {
    action: nextSlide,
    direction: "forward",
    isInactive: current === length - 1
  }));
});
// CONCATENATED MODULE: ./components/elements/product-review/index.web.tsx
var product_review_index_web_jsx = react_default.a.createElement;




var ProductReview = /*#__PURE__*/react_default.a.memo(function (_ref) {
  var reviews = _ref.reviews,
      colorForeground = _ref.colorForeground;
  return /*#__PURE__*/react_default.a.createElement(carousel_Carousel, null, reviews.map(function (review, index) {
    return /*#__PURE__*/react_default.a.createElement(carousel_CarouselItem, {
      width: 30,
      key: review.text + index
    }, /*#__PURE__*/react_default.a.createElement(styled_ReviewWrapper, null, /*#__PURE__*/react_default.a.createElement(LogoWrapper, {
      href: review.url,
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/react_default.a.createElement(SourceLogo, {
      src: review.logo,
      alt: review.text
    })), /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], {
      ariaLevel: elements_typography["h" /* TextLevel */].H3,
      color: colorForeground,
      style: {
        width: '100%',
        margin: 'auto'
      }
    }, "\"", review.text, "\"")));
  }));
});
// CONCATENATED MODULE: ./components/elements/trustbox/index.web.tsx
var trustbox_index_web_jsx = react_default.a.createElement;




var Trustbox = /*#__PURE__*/react_default.a.memo(function () {
  var trustboxDesktopRef = Object(react["useRef"])(null);
  var trustboxMobileRef = Object(react["useRef"])(null);

  var _ref = Object(es["d" /* useSelector */])(function (state) {
    return state.settings;
  }),
      languageId = _ref.languageId,
      countryId = _ref.countryId;

  var languages = languageId.split('-')[0];
  var locale = "".concat(languages, "-").concat(countryId);
  Object(react["useEffect"])(function () {
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(trustboxDesktopRef.current, true);
      window.Trustpilot.loadFromElement(trustboxMobileRef.current, true);
    }
  }, [languageId]);
  return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(TrustboxDesktop, {
    ref: trustboxDesktopRef,
    className: "trustpilot-widget",
    "data-locale": locale,
    "data-template-id": "54ad5defc6454f065c28af8b",
    "data-businessunit-id": "55228c0d0000ff00057e90d1",
    "data-style-height": "240px",
    "data-style-width": "100%",
    "data-theme": "light",
    "data-stars": "3,4,5",
    "data-review-languages": languages,
    "data-text-color": "#212222",
    style: {
      textAlign: 'center',
      fontFamily: styles_theme["a" /* default */].fonts.extended
    }
  }), /*#__PURE__*/react_default.a.createElement(TrustboxMobile, {
    ref: trustboxMobileRef,
    className: "trustpilot-widget",
    "data-locale": locale,
    "data-template-id": "539ad0ffdec7e10e686debd7",
    "data-businessunit-id": "55228c0d0000ff00057e90d1",
    "data-style-height": "350px",
    "data-style-width": "100%",
    "data-theme": "light",
    "data-stars": "3,4,5",
    "data-review-languages": languages,
    "data-text-color": "#212222",
    "data-no-reviews": "hide",
    "data-scroll-to-list": "true",
    "data-allow-robots": "true",
    style: {
      textAlign: 'center',
      fontFamily: styles_theme["a" /* default */].fonts.extended
    }
  }));
});
var TrustboxDesktop = styled_components_browser_esm["default"].div.withConfig({
  displayName: "indexweb__TrustboxDesktop",
  componentId: "sc-1qpzkd8-0"
})(["width:100%;max-width:1090px;@media ", "{display:none;}"], styles_theme["a" /* default */].breakpoints.onlyMobileAndTablet);
var TrustboxMobile = styled_components_browser_esm["default"].div.withConfig({
  displayName: "indexweb__TrustboxMobile",
  componentId: "sc-1qpzkd8-1"
})(["@media ", "{display:none;}"], styles_theme["a" /* default */].breakpoints.desktop);
// EXTERNAL MODULE: ./public/static/partnerLogos/engadget_black.png
var engadget_black = __webpack_require__("0zxa");
var engadget_black_default = /*#__PURE__*/__webpack_require__.n(engadget_black);

// EXTERNAL MODULE: ./public/static/partnerLogos/chip_black.png
var chip_black = __webpack_require__("HpDZ");
var chip_black_default = /*#__PURE__*/__webpack_require__.n(chip_black);

// EXTERNAL MODULE: ./public/static/partnerLogos/computer-bild_black.png
var computer_bild_black = __webpack_require__("ec63");
var computer_bild_black_default = /*#__PURE__*/__webpack_require__.n(computer_bild_black);

// EXTERNAL MODULE: ./public/static/partnerLogos/geekdad_black.png
var geekdad_black = __webpack_require__("Hsne");
var geekdad_black_default = /*#__PURE__*/__webpack_require__.n(geekdad_black);

// EXTERNAL MODULE: ./public/static/partnerLogos/techcrunch_black.png
var techcrunch_black = __webpack_require__("sIDi");
var techcrunch_black_default = /*#__PURE__*/__webpack_require__.n(techcrunch_black);

// EXTERNAL MODULE: ./public/static/partnerLogos/sueddeutsche-zeitung_black.png
var sueddeutsche_zeitung_black = __webpack_require__("wegZ");
var sueddeutsche_zeitung_black_default = /*#__PURE__*/__webpack_require__.n(sueddeutsche_zeitung_black);

// EXTERNAL MODULE: ./public/static/partnerLogos/mobilsiden_black.png
var mobilsiden_black = __webpack_require__("oMw8");
var mobilsiden_black_default = /*#__PURE__*/__webpack_require__.n(mobilsiden_black);

// EXTERNAL MODULE: ./public/static/partnerLogos/dinside_black.png
var dinside_black = __webpack_require__("QN2O");
var dinside_black_default = /*#__PURE__*/__webpack_require__.n(dinside_black);

// EXTERNAL MODULE: ./public/static/partnerLogos/euroman_black.png
var euroman_black = __webpack_require__("mKIF");
var euroman_black_default = /*#__PURE__*/__webpack_require__.n(euroman_black);

// EXTERNAL MODULE: ./public/static/partnerLogos/know-techie_black.png
var know_techie_black = __webpack_require__("kx/G");
var know_techie_black_default = /*#__PURE__*/__webpack_require__.n(know_techie_black);

// EXTERNAL MODULE: ./public/static/partnerLogos/hiconsumption_black.png
var hiconsumption_black = __webpack_require__("ouqV");
var hiconsumption_black_default = /*#__PURE__*/__webpack_require__.n(hiconsumption_black);

// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/product-review/config/reviews.js











var reviews_reviews = {};
reviews_reviews.techcrunch = {
  logo: techcrunch_black_default.a.url,
  text: 'Connecting several together is silly easy.',
  url: 'https://techcrunch.com/2019/08/15/the-new-soundboks-is-a-massive-pro-level-battery-powered-bluetooth-speaker/'
};
reviews_reviews.engadget = {
  logo: engadget_black_default.a.url,
  text: 'This imposing portable boombox is now wirelessly expandable, more dynamic and thankfully no bigger than before.',
  url: 'https://www.engadget.com/2019/08/15/soundboks-2019-big-bluetooth-speaker-louder-wireless-daisy-chain/'
};
reviews_reviews.geekDad = {
  logo: geekdad_black_default.a.url,
  text: 'A speaker that actually sounds like you want a speaker to sound.',
  url: 'https://geekdad.com/2019/08/the-new-soundboks-wireless-speaker-compromises-nothing-to-deliver-gigantic-sound/'
};
reviews_reviews.computedBildLogo = {
  logo: computer_bild_black_default.a.url,
  logoLarger: true,
  text: 'Der Sound ist ausgewogen und präzise.',
  url: 'https://www.computerbild.de/artikel/cb-Tests-Lautsprecher-The-New-Soundboks-Test-23961189.html'
}; // reviews.amazona = {
//   logo: amazonaLogo.url,
//   text: 'Deutlich zu erkennen ist das 2.5-Wege System des Lautsprechers, wodurch das Design der Box futuristischer wirkt.',
//   url: 'https://www.amazona.de/new-soundboks-update-des-mobilen-lautsprechers/',
// };

reviews_reviews.chip = {
  logo: chip_black_default.a.url,
  text: 'In Sachen Lautstärke hat der SOUNDBOKS noch nie jemand etwas vorgemacht.',
  url: 'https://www.chip.de/news/The-New-Soundboks-Lautester-Akku-Speaker-der-Welt_171770519.html'
};
reviews_reviews.sueddeutscheZeitung = {
  logo: sueddeutsche_zeitung_black_default.a.url,
  text: 'Die Ansteuerung über Bluetooth und die Möglichkeit zur kabellosen Kopplung untereinander sind hübsche Beigaben, die die Boxen von der Konkurrenz abheben.',
  url: 'https://www.sueddeutsche.de/wirtschaft/braucht-man-das-party-lautsprecher-new-soundboks-1.4569792'
}; // reviews.tekno = {
//   logo: teknoLogo.url,
//   logoLarger: true,
//   text: 'SOUNDBOKS er sannsynligvis den ultimate slepbare partyhøyttaleren.',
//   url: 'https://www.tek.no/artikler/korttest-soundboks/470930',
// };
// reviews.lydogbillede = {
//   logo: lydogbilledeLogo.url,
//   logoLarger: true,
//   text: 'Ingen batteridrevet høyttaler er i nærheten av den',
//   url: 'https://www.lydogbilde.no/test/hoyttalere/the-new-soundboks?hw=1',
// };

reviews_reviews.dinside = {
  logo: dinside_black_default.a.url,
  logoLarger: true,
  text: 'Rett og slett et monster av en Bluetooth-høyttaler - Festen er reddet.',
  url: 'https://www.dinside.no/mobil/rett-og-slett-et-monster-av-en-bluetooth-hoyttaler/71544423'
};
reviews_reviews.mobilsiden = {
  logo: mobilsiden_black_default.a.url,
  logoLarger: true,
  text: 'The New SOUNDBOKS er den mest alsidige højtaler, jeg nogensinde har set.',
  url: 'https://www.mobilsiden.dk/anmeldelser/test-the-new-soundboks-den-komplette-hojtaler,lid.41191/'
}; // reviews.inputmag = {
//   logo: inputmagLogo.url,
//   logoLarger: true,
//   text: 'The New SOUNDBOKS er en imponerende krabat.',
//   url: 'https://www.inputmag.dk/anmeldelse-the-new-soundboks/',
// };

reviews_reviews.euroman = {
  logo: euroman_black_default.a.url,
  logoLarger: true,
  text: 'Tager din fest til næste niveau med endnu højere lyd og mulighed for at parre op til fem højttalere.',
  url: 'https://www.euroman.dk/teknik/test-vi-anmelder-den-nye-soundboks'
}; // reviews.altomdata = {
//   logo: altomdataLogo.url,
//   logoLarger: true,
//   text: 'Stort set alt er opgraderet.',
//   url: 'https://www.altomdata.dk/ny-monsterhoejttaler-fra-soundboks',
// };

reviews_reviews.knowTechchie = {
  logo: know_techie_black_default.a.url,
  text: 'This will make you rethink what you knew about wireless audio',
  url: 'https://knowtechie.com/review-soundboks-35lbs-of-kick-ass-bluetooth-speaker/'
}; // reviews.audioReputation = {
//   logo: audioReputationLogo.url,
//   text: 'Bluetooth connection worked like a charm. The range is impressive and the connection is perfectly stable, even at 50ft distance.',
//   url: 'https://www.audioreputation.com/new-soundboks/',
// };

reviews_reviews.hiconsumption = {
  logo: hiconsumption_black_default.a.url,
  text: 'SOUNDBOKS’ most recent release is an awe-inspiring piece of hardware',
  url: 'https://hiconsumption.com/review-soundboks-the-new-sounboks-speaker/'
};
/* harmony default export */ var config_reviews = (reviews_reviews);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/product-review/config/regionalReviews.js

var regionalReviews = {
  XX: [config_reviews.techcrunch, config_reviews.engadget, config_reviews.geekDad, config_reviews.knowTechchie, // reviews.audioReputation,
  config_reviews.hiconsumption],
  DE: [config_reviews.computedBildLogo, // reviews.amazona,
  config_reviews.chip, config_reviews.sueddeutscheZeitung, config_reviews.techcrunch, config_reviews.engadget, config_reviews.geekDad],
  NO: [// reviews.tekno,
  // reviews.lydogbillede,
  config_reviews.dinside, config_reviews.techcrunch, config_reviews.engadget, config_reviews.geekDad, config_reviews.knowTechchie, // reviews.audioReputation,
  config_reviews.hiconsumption],
  DK: [config_reviews.mobilsiden, // reviews.inputmag,
  config_reviews.euroman, // reviews.altomdata,
  // reviews.lydogbillede,
  config_reviews.techcrunch, config_reviews.engadget, config_reviews.geekDad, config_reviews.hiconsumption, config_reviews.knowTechchie // reviews.audioReputation,
  ]
};
/* harmony default export */ var config_regionalReviews = (regionalReviews);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/product-review/styled.tsx


var styled_StyledHorizontalLine = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__StyledHorizontalLine",
  componentId: "sc-1u9gl0t-0"
})(["display:none;@media ", "{display:block;padding:0px 24px;}"], styles_theme["a" /* default */].breakpoints.maxMobile);
var styled_LayoutContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__LayoutContainer",
  componentId: "sc-1u9gl0t-1"
})(["position:relative;width:100%;max-width:1024px;text-align:center;align-self:center;@media ", "{max-width:720px;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/product-review/index.tsx
var product_review_jsx = react_default.a.createElement;














var product_review_ProductReviewSection = function ProductReviewSection() {
  var _useSelector = Object(es["d" /* useSelector */])(function (state) {
    return state.settings;
  }),
      countryId = _useSelector.countryId;

  var reviews = config_regionalReviews[countryId] || config_regionalReviews.XX;
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref) {
    var i18n = _ref.i18n;
    return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(styled_LayoutContainer, null, /*#__PURE__*/react_default.a.createElement(elements_typography["e" /* Heading02 */], {
      ariaLevel: elements_typography["h" /* TextLevel */].H2,
      color: elements_theme["a" /* Color */].Orange,
      style: {
        textTransform: 'uppercase'
      }
    }, i18n._('product.reviews.heading')), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "20px"
    }), /*#__PURE__*/react_default.a.createElement(ProductReview, {
      reviews: reviews,
      colorForeground: elements_theme["a" /* Color */].Charcoal
    })), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    }), /*#__PURE__*/react_default.a.createElement(styled_StyledHorizontalLine, null, /*#__PURE__*/react_default.a.createElement(HorizontalLine, {
      color: elements_theme["a" /* Color */].WhiteOff
    }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    })), /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(index_web_VideoFeature, {
      videos: [{
        YouTubeId: 'FuD9ujTbZCE',
        children: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "The world's LOUDEST portable speaker for DJs?")
      }, {
        YouTubeId: 'JrGlmymabNg',
        children: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "Soundboks Update - New Sound Modes New Features")
      }, {
        YouTubeId: 'j9WFgrGU5ro',
        children: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "The world's Loudest Wireless Speaker")
      }],
      height: "184px"
    })), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    }), /*#__PURE__*/react_default.a.createElement(styled_StyledHorizontalLine, null, /*#__PURE__*/react_default.a.createElement(HorizontalLine, {
      color: elements_theme["a" /* Color */].WhiteOff
    }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    })), /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(Trustbox, null)));
  });
};

/* harmony default export */ var product_review = (product_review_ProductReviewSection);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/image-collage/styled.ts


var ContainerProductFeature = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__ContainerProductFeature",
  componentId: "k6ltic-0"
})(["display:grid;grid-template-columns:1fr 1fr;max-width:1064px;margin:auto;grid-gap:14px;@media ", "{grid-gap:5px;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
var ContainerImage1 = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__ContainerImage1",
  componentId: "k6ltic-1"
})(["width:100%;grid-column:1 / span 1;grid-row:1 / span 2;"]);
var ContainerImage2 = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__ContainerImage2",
  componentId: "k6ltic-2"
})(["width:100%;grid-column:2 / span 1;grid-row:1 / span 1;"]);
var ContainerImage3 = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__ContainerImage3",
  componentId: "k6ltic-3"
})(["width:100%;grid-column:2 / span 1;grid-row:2 / span 1;"]);
var ContainerImage4 = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__ContainerImage4",
  componentId: "k6ltic-4"
})(["width:100%;grid-column:1 / span 2;grid-row:3 / span 1;"]);
// EXTERNAL MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/assets/Soundboks3-lifestyle-2-small.png
var Soundboks3_lifestyle_2_small = __webpack_require__("ZDPV");
var Soundboks3_lifestyle_2_small_default = /*#__PURE__*/__webpack_require__.n(Soundboks3_lifestyle_2_small);

// EXTERNAL MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/assets/Soundboks3-lifestyle-2-large.png
var Soundboks3_lifestyle_2_large = __webpack_require__("TMeu");
var Soundboks3_lifestyle_2_large_default = /*#__PURE__*/__webpack_require__.n(Soundboks3_lifestyle_2_large);

// EXTERNAL MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/assets/Soundboks3-lifestyle-3-small.png
var Soundboks3_lifestyle_3_small = __webpack_require__("52F1");
var Soundboks3_lifestyle_3_small_default = /*#__PURE__*/__webpack_require__.n(Soundboks3_lifestyle_3_small);

// EXTERNAL MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/assets/Soundboks3-lifestyle-3-large.png
var Soundboks3_lifestyle_3_large = __webpack_require__("U3dx");
var Soundboks3_lifestyle_3_large_default = /*#__PURE__*/__webpack_require__.n(Soundboks3_lifestyle_3_large);

// EXTERNAL MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/assets/Soundboks3-lifestyle-4-small.png
var Soundboks3_lifestyle_4_small = __webpack_require__("biPD");
var Soundboks3_lifestyle_4_small_default = /*#__PURE__*/__webpack_require__.n(Soundboks3_lifestyle_4_small);

// EXTERNAL MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/assets/Soundboks3-lifestyle-4-large.png
var Soundboks3_lifestyle_4_large = __webpack_require__("p1tu");
var Soundboks3_lifestyle_4_large_default = /*#__PURE__*/__webpack_require__.n(Soundboks3_lifestyle_4_large);

// EXTERNAL MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/assets/Soundboks3-lifestyle-5-small.png
var Soundboks3_lifestyle_5_small = __webpack_require__("cujP");
var Soundboks3_lifestyle_5_small_default = /*#__PURE__*/__webpack_require__.n(Soundboks3_lifestyle_5_small);

// EXTERNAL MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/assets/Soundboks3-lifestyle-5-large.png
var Soundboks3_lifestyle_5_large = __webpack_require__("anZF");
var Soundboks3_lifestyle_5_large_default = /*#__PURE__*/__webpack_require__.n(Soundboks3_lifestyle_5_large);

// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/image-collage/index.tsx
var image_collage_jsx = react_default.a.createElement;












var image_collage_ProductFeatureSection = function ProductFeatureSection() {
  return /*#__PURE__*/react_default.a.createElement(ContainerProductFeature, null, /*#__PURE__*/react_default.a.createElement(ContainerImage1, null, /*#__PURE__*/react_default.a.createElement(elements_image["a" /* Image */], {
    uri: Object(elements_image["b" /* imgIxUrlFormatter */])(Soundboks3_lifestyle_2_large_default.a.url),
    ranges: {
      phone: Object(elements_image["b" /* imgIxUrlFormatter */])(Soundboks3_lifestyle_2_small_default.a.url),
      desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(Soundboks3_lifestyle_2_large_default.a.url)
    }
  })), /*#__PURE__*/react_default.a.createElement(ContainerImage2, null, /*#__PURE__*/react_default.a.createElement(elements_image["a" /* Image */], {
    uri: Object(elements_image["b" /* imgIxUrlFormatter */])(Soundboks3_lifestyle_3_large_default.a.url),
    ranges: {
      phone: Object(elements_image["b" /* imgIxUrlFormatter */])(Soundboks3_lifestyle_3_small_default.a.url),
      desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(Soundboks3_lifestyle_3_large_default.a.url)
    }
  })), /*#__PURE__*/react_default.a.createElement(ContainerImage3, null, /*#__PURE__*/react_default.a.createElement(elements_image["a" /* Image */], {
    uri: Object(elements_image["b" /* imgIxUrlFormatter */])(Soundboks3_lifestyle_4_large_default.a.url),
    ranges: {
      phone: Object(elements_image["b" /* imgIxUrlFormatter */])(Soundboks3_lifestyle_4_small_default.a.url),
      desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(Soundboks3_lifestyle_4_large_default.a.url)
    }
  })), /*#__PURE__*/react_default.a.createElement(ContainerImage4, null, /*#__PURE__*/react_default.a.createElement(elements_image["a" /* Image */], {
    uri: Object(elements_image["b" /* imgIxUrlFormatter */])(Soundboks3_lifestyle_5_large_default.a.url),
    ranges: {
      phone: Object(elements_image["b" /* imgIxUrlFormatter */])(Soundboks3_lifestyle_5_small_default.a.url),
      desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(Soundboks3_lifestyle_5_large_default.a.url)
    }
  })));
};

/* harmony default export */ var image_collage = (image_collage_ProductFeatureSection);
// CONCATENATED MODULE: ./components/elements/related-products/rp-card/index.tsx
var rp_card_jsx = react_default.a.createElement;






var RPCard = /*#__PURE__*/react_default.a.memo(function (_ref) {
  var image = _ref.image,
      headline = _ref.headline,
      price = _ref.price,
      discount = _ref.discount,
      currency = _ref.currency,
      locale = _ref.locale,
      promotion = _ref.promotion,
      productBuyPageHandler = _ref.productBuyPageHandler,
      productBuyPageURL = _ref.productBuyPageURL;
  return /*#__PURE__*/react_default.a.createElement(Link["a" /* default */], {
    href: productBuyPageHandler,
    as: productBuyPageURL,
    passHref: true
  }, /*#__PURE__*/react_default.a.createElement(CardContainer, null, promotion && /*#__PURE__*/react_default.a.createElement(PromotionTag, null, promotion), /*#__PURE__*/react_default.a.createElement(ImgWrapper, null, /*#__PURE__*/react_default.a.createElement(elements_image["a" /* Image */], {
    uri: image.url,
    alt: image.placeholder
  })), /*#__PURE__*/react_default.a.createElement(CardInfoWrapper, null, /*#__PURE__*/react_default.a.createElement(CardText, null, headline, /*#__PURE__*/react_default.a.createElement("div", {
    style: {
      display: 'flex'
    }
  }, discount && /*#__PURE__*/react_default.a.createElement(rp_card_StyledPriceFormat, {
    price: price,
    currency: currency,
    locale: locale
  }), /*#__PURE__*/react_default.a.createElement(PriceFormat, {
    price: discount || price,
    currency: currency,
    locale: locale
  }))))));
});
var CardContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "rp-card__CardContainer",
  componentId: "sc-1ugco4x-0"
})(["width:228px;height:304px;background-color:", ";box-shadow:0px 2px 6px rgba(0,0,0,0.07);position:relative;cursor:pointer;@media ", "{width:150px;height:200px;}"], styles_theme["a" /* default */].colors.white, styles_theme["a" /* default */].breakpoints.onlyMobile);
var CardText = styled_components_browser_esm["default"].div.withConfig({
  displayName: "rp-card__CardText",
  componentId: "sc-1ugco4x-1"
})(["font-family:", ";font-size:14px;line-height:16px;@media ", "{font-size:10px;line-height:12px;}"], styles_theme["a" /* default */].fonts.extended, styles_theme["a" /* default */].breakpoints.onlyMobile);
var PromotionTag = styled_components_browser_esm["default"].div.withConfig({
  displayName: "rp-card__PromotionTag",
  componentId: "sc-1ugco4x-2"
})(["background-color:", ";color:", ";width:60px;height:24px;position:absolute;top:0;right:0;font-size:10px;line-height:12px;font-family:", ";display:grid;place-items:center;@media ", "{width:40px;height:16px;}"], styles_theme["a" /* default */].colors.primary, styles_theme["a" /* default */].colors.white, styles_theme["a" /* default */].fonts.extended, styles_theme["a" /* default */].breakpoints.onlyMobile);
var ImgWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "rp-card__ImgWrapper",
  componentId: "sc-1ugco4x-3"
})(["padding:25px;@media ", "{padding:8px;}"], styles_theme["a" /* default */].breakpoints.onlyMobile);
var CardInfoWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "rp-card__CardInfoWrapper",
  componentId: "sc-1ugco4x-4"
})(["padding:12px;@media ", "{padding:8px;}"], styles_theme["a" /* default */].breakpoints.onlyMobile);
var rp_card_StyledPriceFormat = Object(styled_components_browser_esm["default"])(PriceFormat).withConfig({
  displayName: "rp-card__StyledPriceFormat",
  componentId: "sc-1ugco4x-5"
})(["text-decoration:line-through;text-decoration-color:", ";text-decoration-thickness:2px;margin-right:10px;@media ", "{margin-right:5px;}"], styles_theme["a" /* default */].colors.primary, styles_theme["a" /* default */].breakpoints.onlyMobile);
// CONCATENATED MODULE: ./components/elements/related-products/arrow/index.tsx
var related_products_arrow_jsx = react_default.a.createElement;





var arrow_Arrow = /*#__PURE__*/react_default.a.memo(function (_ref) {
  var direction = _ref.direction,
      action = _ref.action,
      isInactive = _ref.isInactive;
  return /*#__PURE__*/react_default.a.createElement(arrow_Arrows, {
    direction: direction,
    onClick: action,
    isInactive: isInactive
  }, /*#__PURE__*/react_default.a.createElement(atoms_Icon["b" /* default */], {
    id: direction === 'forward' ? atoms_Icon["a" /* IconId */].Forward : atoms_Icon["a" /* IconId */].Back,
    color: theme["a" /* Color */].Primary,
    size: 30
  }));
});
var arrow_Arrows = styled_components_browser_esm["default"].div.withConfig({
  displayName: "arrow__Arrows",
  componentId: "r8cxm2-0"
})(["background-color:", ";box-shadow:1px 1px 4px rgba(0,0,0,0.25);border-radius:18px;cursor:pointer;width:32px;transition:0.2s ease-in-out;cursor:", ";opacity:", ";z-index:999;position:absolute;left:", ";right:", ";", " @media ", "{display:none;}"], theme["a" /* Color */].White, function (_ref2) {
  var isInactive = _ref2.isInactive;
  return isInactive ? 'default' : 'pointer';
}, function (_ref3) {
  var isInactive = _ref3.isInactive;
  return isInactive ? 0.5 : 1;
}, function (_ref4) {
  var direction = _ref4.direction;
  return direction === 'back' && '8px';
}, function (_ref5) {
  var direction = _ref5.direction;
  return direction === 'forward' && '8px';
}, function (_ref6) {
  var isInactive = _ref6.isInactive;
  return isInactive && "&:hover {\n      background-color: '#F2F0F0';\n    }";
}, styles_theme["a" /* default */].breakpoints.onlyMobile);
// CONCATENATED MODULE: ./components/elements/related-products/styled.ts



var IndicatorWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__IndicatorWrapper",
  componentId: "tdgkj4-0"
})(["width:100%;text-align:center;position:relative;top:25px;"]);
var styled_Indicators = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Indicators",
  componentId: "tdgkj4-1"
})(["cursor:pointer;height:8px;width:8px;margin:0 4px;background-color:", ";border-radius:50%;display:inline-block;justify-content:center;transition:background-color 0.6s ease;&:hover{background-color:", ";}"], function (_ref) {
  var index = _ref.index,
      activeIndex = _ref.activeIndex;
  return index === activeIndex ? elements_theme["a" /* Color */].Orange : 'rgba(253, 70, 22, 0.5)';
}, elements_theme["a" /* Color */].Orange);
var RPsContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__RPsContainer",
  componentId: "tdgkj4-2"
})(["position:relative;@media ", "{margin:0 24px;}@media ", "{margin:auto;}"], styles_theme["a" /* default */].breakpoints.onlyTablet, styles_theme["a" /* default */].breakpoints.desktop);
var RPsWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__RPsWrapper",
  componentId: "tdgkj4-3"
})(["display:flex;align-items:center;@media ", "{padding-left:20px;padding-right:20px;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
var RPsSubWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__RPsSubWrapper",
  componentId: "tdgkj4-4"
})(["z-index:99;position:relative;display:grid;place-items:center;padding-top:40px;grid-gap:25px;padding-left:12.5px;padding-right:12.5px;grid-auto-flow:column;overflow:hidden;max-width:1012px;@media ", "{padding-top:35px;grid-gap:16px;overflow-x:scroll;overflow-y:hidden;margin:0;}::-webkit-scrollbar{display:none;}-ms-overflow-style:none;scrollbar-width:none;"], styles_theme["a" /* default */].breakpoints.onlyMobile);
// CONCATENATED MODULE: ./components/elements/related-products/index.web.tsx
var related_products_index_web_jsx = react_default.a.createElement;







var RelatedProducts = /*#__PURE__*/react_default.a.memo(function (_ref) {
  var relatedProducts = _ref.relatedProducts,
      headline = _ref.headline;
  var scrollRef = Object(react["useRef"])(null);

  var _useState = Object(react["useState"])(),
      numberOfIndicators = _useState[0],
      setNumberOfIndicators = _useState[1];

  var _useState2 = Object(react["useState"])([]),
      carouselShow = _useState2[0],
      setCarouselShow = _useState2[1];

  var _useState3 = Object(react["useState"])(0),
      currentlyActive = _useState3[0],
      setCurrentlyActive = _useState3[1];

  Object(react["useEffect"])(function () {
    var handleResize = function handleResize() {
      var carouselList = []; // Product width for desktop is 228 + gab (25) = 253. Mobile: 150 + 16 = 166.

      var productWidth = scrollRef.current.offsetWidth < styles_theme["a" /* default */].screenWidths.tablet ? 166 : 253; // The amount of space in which the amount of fully visible products can be seen on an offset.

      var productSpace = scrollRef.current.offsetWidth - scrollRef.current.offsetWidth % productWidth; // If there is room for more than one product then round up else round down.

      setNumberOfIndicators(scrollRef.current.scrollWidth % productSpace >= productWidth ? Math.ceil(scrollRef.current.scrollWidth / productSpace) : Math.floor(scrollRef.current.scrollWidth / productSpace));

      for (var index = 0; index < numberOfIndicators; index += 1) {
        if (index === numberOfIndicators - 1) {
          // Ignore position and push to the end if at the last indicator.
          carouselList.push(scrollRef.current.scrollWidth);
        } else {
          carouselList.push(index * productSpace);
        }
      }

      setCarouselShow(carouselList);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, [numberOfIndicators]);

  var nextSlide = function nextSlide() {
    var makeNextActive = currentlyActive + 1;

    if (currentlyActive !== numberOfIndicators - 1) {
      setCurrentlyActive(makeNextActive);
      scrollRef.current.scrollLeft = carouselShow[makeNextActive];
    }
  };

  var prevSlide = function prevSlide() {
    var makePrevActive = currentlyActive - 1;

    if (currentlyActive !== 0) {
      setCurrentlyActive(makePrevActive);
      scrollRef.current.scrollLeft = carouselShow[makePrevActive];
    }
  };

  var clickIndicator = function clickIndicator(clickedIndicator) {
    setCurrentlyActive(clickedIndicator);
    scrollRef.current.scrollLeft = carouselShow[clickedIndicator];
  };

  var handlers = Object(react_swipeable_umd["useSwipeable"])({
    onSwipedLeft: function onSwipedLeft() {
      return nextSlide();
    },
    onSwipedRight: function onSwipedRight() {
      return prevSlide();
    }
  });
  return /*#__PURE__*/react_default.a.createElement(RPsContainer, null, /*#__PURE__*/react_default.a.createElement(elements_typography["e" /* Heading02 */], {
    style: {
      display: 'flex',
      textAlign: 'center',
      justifyContent: 'center',
      textTransform: 'uppercase'
    }
  }, headline), /*#__PURE__*/react_default.a.createElement(RPsWrapper, handlers, numberOfIndicators > 1 && /*#__PURE__*/react_default.a.createElement(arrow_Arrow, {
    direction: "back",
    action: function action() {
      return prevSlide();
    },
    isInactive: currentlyActive === 0
  }), /*#__PURE__*/react_default.a.createElement(RPsSubWrapper, {
    style: {
      scrollBehavior: 'smooth'
    },
    ref: scrollRef
  }, relatedProducts.map(function (rp, index) {
    return /*#__PURE__*/react_default.a.createElement(RPCard, {
      key: rp.headline + index,
      image: rp.image,
      headline: rp.headline,
      price: rp.price,
      locale: rp.locale,
      discount: rp.discount,
      currency: rp.currency,
      promotion: rp.promotion,
      productBuyPageHandler: rp.productBuyPageHandler,
      productBuyPageURL: rp.productBuyPageURL
    });
  })), numberOfIndicators > 1 && /*#__PURE__*/react_default.a.createElement(arrow_Arrow, {
    direction: "forward",
    action: function action() {
      return nextSlide();
    },
    isInactive: currentlyActive === numberOfIndicators - 1
  })), numberOfIndicators > 1 && /*#__PURE__*/react_default.a.createElement(IndicatorWrapper, null, Array.from({
    length: numberOfIndicators
  }, function (_, index) {
    return /*#__PURE__*/react_default.a.createElement(styled_Indicators, {
      key: index,
      index: index,
      activeIndex: currentlyActive,
      onClick: function onClick() {
        return clickIndicator(index);
      }
    });
  })));
});
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/related-products/index.tsx
var related_products_jsx = react_default.a.createElement;






var related_products_RelatedProductsSection = function RelatedProductsSection(_ref) {
  var relatedProducts = _ref.relatedProducts;
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      grow: 1
    }, /*#__PURE__*/react_default.a.createElement(RelatedProducts, {
      relatedProducts: relatedProducts,
      headline: i18n._('product.related-products.heading')
    })));
  });
};

/* harmony default export */ var related_products = (related_products_RelatedProductsSection);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-gen3/index.tsx

var soundboks_gen3_jsx = react_default.a.createElement;

function soundboks_gen3_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function soundboks_gen3_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { soundboks_gen3_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { soundboks_gen3_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





















var soundboks_gen3_paths = [{
  label: 'Home',
  url: '/'
}, {
  label: 'Speakers',
  url: '/products/?filter=speakers'
}, {
  label: 'Soundboks (Gen. 3)'
}];
var soundboks_gen3_options = {
  grillColor: 'Grill Color',
  batteries: 'Batteries',
  merch: 'Accessories'
};
var klarnaData = {
  de: {
    klarnaLocale: 'de-DE',
    klarnaClassName: 'klarna-pricetag-de'
  },
  no: {
    klarnaLocale: 'no-NO',
    klarnaClassName: 'klarna-pricetag-no'
  },
  da: {
    klarnaLocale: 'da-DK',
    klarnaClassName: 'klarna-pricetag-dk'
  }
};
var colorOptions = [{
  id: 'Black',
  label: 'Black',
  value: '#000000'
}, {
  id: 'Orange',
  label: 'Orange',
  value: '#FA4616'
}, {
  id: 'White',
  label: 'White',
  value: '#FFFFFF'
}, {
  id: 'Yellow',
  label: 'Yellow',
  value: '#f7b500'
}, {
  id: 'Teal',
  label: 'Teal',
  value: '#005f4e'
}, {
  id: 'Blue',
  label: 'Blue',
  value: '#19415E'
}, {
  id: 'Red',
  label: 'Red',
  value: '#AA273B'
}, {
  id: 'Pink',
  label: 'Pink',
  value: '#E678A0'
}, {
  id: 'Chrome',
  label: 'Chrome',
  value: 'linear-gradient(90deg, rgba(157,157,159,1) 0%, rgba(250,250,252,1) 40%, rgba(145,149,149,1) 100%)'
}];
var batteriOptions = {
  onePack: '1x BATTERYBOKS',
  twoPack: '2x BATTERYBOKS'
};
var merchOptions = [{
  id: 'Backpack',
  label: 'Backpack'
}, {
  id: 'Tripod',
  label: 'Tripod'
}, {
  id: 'Powerbank',
  label: 'Powerbank'
}, {
  id: 'Microphone',
  label: 'Microphone'
}, {
  id: 'Cable bundle',
  label: 'Cable bundle'
}, {
  id: 'Orange grill',
  label: 'Orange grill'
}, {
  id: 'White grill',
  label: 'White grill'
}, {
  id: 'Black grill',
  label: 'Black grill'
}, {
  id: 'None',
  label: 'None'
}];

var soundboks_gen3_SoundboksGen3 = function SoundboksGen3(_ref) {
  var productData = _ref.productData,
      dispatchAddCartItem = _ref.dispatchAddCartItem;

  var _useSelector = Object(es["d" /* useSelector */])(function (state) {
    return state;
  }),
      settings = _useSelector.settings;

  var regionId = settings.regionId,
      languageId = settings.languageId;
  var overview = Object(react["useRef"])(null);
  var feature = Object(react["useRef"])(null);
  var learnMore = Object(react["useRef"])(null);
  var reviews = Object(react["useRef"])(null);
  var relatedProducts = Object(react["useRef"])(null);

  var _useState = Object(react["useState"])(),
      anchorStack = _useState[0],
      setAnchorStack = _useState[1];

  var _useState2 = Object(react["useState"])(),
      selectedAnchor = _useState2[0],
      setSelectedAnchor = _useState2[1];

  var _useState3 = Object(react["useState"])(false),
      isHeaderVisibility = _useState3[0],
      setIsHeaderVisibility = _useState3[1];

  var _useState4 = Object(react["useState"])(),
      productVariant = _useState4[0],
      setProductVariant = _useState4[1];

  var _useState5 = Object(react["useState"])(),
      selectedColor = _useState5[0],
      setSelectedColor = _useState5[1];

  var _useState6 = Object(react["useState"])(),
      avalibleColors = _useState6[0],
      setAvalibleColors = _useState6[1];

  var _useState7 = Object(react["useState"])(),
      selectedMerch = _useState7[0],
      setSelectedMerch = _useState7[1];

  var _useState8 = Object(react["useState"])(),
      availableMerch = _useState8[0],
      setAvailableMerch = _useState8[1];

  var _useState9 = Object(react["useState"])(),
      extraBattery = _useState9[0],
      setExtraBattery = _useState9[1];

  var _useState10 = Object(react["useState"])(),
      disableExtraBattery = _useState10[0],
      setDisableExtraBattery = _useState10[1];

  var productCategories = Object(mergeUACategories["a" /* default */])(abstractProducts_default.a.byId[productData.handle].categories);

  var _useState11 = Object(react["useState"])(true),
      allowImageInteractionTracking = _useState11[0],
      setAllowImageInteractionTracking = _useState11[1];

  var _useState12 = Object(react["useState"])(0),
      trackImageInteractionLimit = _useState12[0],
      setTrackImageInteractionLimit = _useState12[1];

  var router = Object(next_router["useRouter"])();
  var offset = 124;
  Object(react["useEffect"])(function () {
    var initialStack = [{
      label: 'products.subnavigation.achor.overview',
      ref: overview
    }, {
      label: 'products.subnavigation.achor.feature',
      ref: feature
    }, {
      label: 'products.subnavigation.achor.learn-more',
      ref: learnMore
    }, {
      label: 'products.subnavigation.achor.reviews',
      ref: reviews
    }, {
      label: 'products.subnavigation.achor.related-products',
      ref: relatedProducts
    }];
    setAnchorStack(initialStack);

    var handleScroll = function handleScroll() {
      var stackIndex = initialStack.findIndex(function (stack) {
        return stack.ref.current.getBoundingClientRect().y - offset > 0;
      });
      var stack = stackIndex === -1 ? initialStack[initialStack.length - 1] : initialStack[stackIndex - 1];
      setSelectedAnchor(stack.ref.current);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return function () {
      return window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  var handleHeaderVisibility = function handleHeaderVisibility(isVisibility) {
    setIsHeaderVisibility(isVisibility);
  };

  var pathCheck;
  var exclEnRegions = regionId !== 'eu' && regionId !== 'tr';

  if (languageId === 'en' && exclEnRegions) {
    pathCheck = "/".concat(regionId, "/en");
  } else {
    pathCheck = regionId === 'na' ? '' : "/".concat(regionId);
  }

  Object(react["useEffect"])(function () {
    var defaultOption = productData.variants.find(function (variant) {
      return variant.sku === productData.defaultSku;
    }); // const BatteriesQueryOption = router.query[options.batteries] === 'true' ? batteriOptions.twoPack : batteriOptions.onePack;

    var optionsFromUrlQueries = productData.variants.find(function (variant) {
      return variant.options[soundboks_gen3_options.grillColor] === router.query[soundboks_gen3_options.grillColor] && variant.options[soundboks_gen3_options.merch] === router.query[soundboks_gen3_options.merch];
    });
    var defaultVariant = optionsFromUrlQueries || defaultOption;
    setSelectedColor(defaultVariant === null || defaultVariant === void 0 ? void 0 : defaultVariant.options[soundboks_gen3_options.grillColor]);
    var variantColors = productData.variants.map(function (variant) {
      return variant.options[soundboks_gen3_options.grillColor];
    });
    var colors = colorOptions.filter(function (_ref2) {
      var id = _ref2.id;
      return variantColors.includes(id);
    });
    setAvalibleColors(colors);
    setSelectedMerch(defaultVariant === null || defaultVariant === void 0 ? void 0 : defaultVariant.options[soundboks_gen3_options.merch]);
    var variantMerch = productData.variants.map(function (variant) {
      return variant.options[soundboks_gen3_options.merch];
    });
    var merch = merchOptions.filter(function (_ref3) {
      var id = _ref3.id;
      return variantMerch.includes(id);
    });
    setAvailableMerch(merch);
    setExtraBattery((defaultVariant === null || defaultVariant === void 0 ? void 0 : defaultVariant.options[soundboks_gen3_options.batteries]) === batteriOptions.twoPack); // Does this variant exist with opposite selected battery?

    var reverseBatteryOption = (defaultVariant === null || defaultVariant === void 0 ? void 0 : defaultVariant.options[soundboks_gen3_options.batteries]) === batteriOptions.onePack ? batteriOptions.twoPack : batteriOptions.onePack;
    var reverseBatteryChoice = productData.variants.some(function (variant) {
      return variant.options[soundboks_gen3_options.grillColor] === (defaultVariant === null || defaultVariant === void 0 ? void 0 : defaultVariant.options[soundboks_gen3_options.grillColor]) && variant.options[soundboks_gen3_options.batteries] === reverseBatteryOption;
    });
    setDisableExtraBattery(!reverseBatteryChoice);
    setProductVariant(defaultVariant);
  }, [productData, router.query]);

  var handleColorSelector = function handleColorSelector(color) {
    var nextVariant = productData.variants.find(function (variant) {
      return variant.options[soundboks_gen3_options.grillColor] === color && variant.options[soundboks_gen3_options.merch] === selectedMerch;
    });
    setSelectedColor(color);
    Object(utils["m" /* trackVariantInteraction */])(color);
    setAllowImageInteractionTracking(true);
    setTrackImageInteractionLimit(0);
    window.history.replaceState(null, "".concat(pathCheck, "/products/soundboks-gen-3/"), "".concat(pathCheck, "/products/soundboks-gen-3/?Grill+Color=").concat(color, "&Accessories=").concat(selectedMerch));
    setProductVariant(nextVariant);
  };

  var refreshData = function refreshData(item) {
    Object(utils["m" /* trackVariantInteraction */])(item);
    setAllowImageInteractionTracking(true);
    setTrackImageInteractionLimit(0);
    window.history.replaceState(null, "".concat(pathCheck, "/products/soundboks-gen-3/"), "".concat(pathCheck, "/products/soundboks-gen-3/?Grill+Color=").concat(selectedColor, "&Accessories=").concat(item));
  };

  var handleMerchSelector = function handleMerchSelector(item) {
    var variants = productData.variants.filter(function (variant) {
      return variant.options[soundboks_gen3_options.merch] === item;
    });
    var colors = variants.map(function (variant) {
      return variant.options[soundboks_gen3_options.grillColor];
    });
    setAvalibleColors(function (prev) {
      return prev.map(function (el) {
        return colors.includes(el.id) ? soundboks_gen3_objectSpread(soundboks_gen3_objectSpread({}, el), {}, {
          disabled: false
        }) : soundboks_gen3_objectSpread(soundboks_gen3_objectSpread({}, el), {}, {
          disabled: true
        });
      });
    });
    var nextVariant = productData.variants.find(function (variant) {
      return variant.options[soundboks_gen3_options.merch] === item && variant.options[soundboks_gen3_options.grillColor] === selectedColor;
    });
    setSelectedMerch(item);
    refreshData(item);
    setProductVariant(nextVariant);
  }; // const handleBatterySelector = (selected: boolean) => {
  //   const variants = productData.variants.filter(
  //     (variant) =>
  //       variant.options[options.batteries]
  //       === (selected ? batteriOptions.twoPack : batteriOptions.onePack),
  //   );
  //   const colors = variants.map((variant) => variant.options[options.grillColor]);
  //   setAvalibleColors((prev) =>
  //     prev.map((el) =>
  //       (colors.includes(el.id) ? { ...el, disabled: false } : { ...el, disabled: true })));
  //   setExtraBattery(selected);
  //   const trackBattery = selected ? batteriOptions.twoPack : batteriOptions.onePack;
  //   trackVariantInteraction(trackBattery);
  //   setAllowImageInteractionTracking(true);
  //   setTrackImageInteractionLimit(0);
  //   const nextVariant = variants.find(
  //     (variant) => variant.options[options.grillColor] === selectedColor,
  //   );
  //   window.history.replaceState(
  //     null,
  //     `${pathCheck}/products/soundboks-gen-3/`,
  //     `${pathCheck}/products/soundboks-gen-3/?Grill+Color=${selectedColor}&Batteries=${selected}`,
  //   );
  //   setProductVariant(nextVariant);
  // };


  Object(react["useEffect"])(function () {
    if (productVariant) {
      var productImages = Object(getProductImages["a" /* default */])(productData.handle, productVariant.sku);
      var imageUrl = productImages.length ? productImages[0].url : '';
      var timer = setTimeout(function () {
        return Object(utils["i" /* trackProductPageview */])({
          name: productData.title,
          id: productVariant.sku,
          price: productVariant.price,
          brand: 'soundboks',
          category: productCategories,
          variant: productVariant.title,
          image: imageUrl
        });
      }, 1000);
      return function () {
        return clearTimeout(timer);
      };
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [regionId, productVariant]);

  var handleAddToCart = function handleAddToCart() {
    console.log('handleAddToCart', productVariant);

    if (productVariant.available) {
      dispatchAddCartItem(productVariant.id, 1, true);
    } else {
      console.log('join waitinglist dialog');
    }
  };

  var financialServices = function financialServices(variantPrice) {
    var locale = productData.locale;
    var klarnaAvailable = locale === 'de' || locale === 'no' || locale === 'da';
    var affirmAvailable = locale === 'en-US';
    return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, affirmAvailable && /*#__PURE__*/react_default.a.createElement(index_web_AffirmService, {
      price: variantPrice,
      locale: locale,
      isBlackTheme: true
    }), klarnaAvailable && /*#__PURE__*/react_default.a.createElement(index_web_KlarnaService, {
      price: variantPrice,
      locale: klarnaData[locale].klarnaLocale,
      klarnaClassName: klarnaData[locale].klarnaClassName
    }));
  };

  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    backgroundColor: elements_theme["a" /* Color */].Charcoal
  }, /*#__PURE__*/react_default.a.createElement(sub_navigation_SubNavigation, {
    productData: productData,
    productVariant: productVariant,
    anchorStack: anchorStack,
    selectedAnchor: selectedAnchor,
    isHeaderVisibility: isHeaderVisibility,
    offset: offset,
    handleAddToCart: handleAddToCart
  }), /*#__PURE__*/react_default.a.createElement("div", {
    ref: overview
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '24px',
      desktop: '46px'
    }
  }), /*#__PURE__*/react_default.a.createElement(product_overview, {
    paths: soundboks_gen3_paths,
    offset: offset,
    anchorStack: anchorStack,
    productData: productData,
    productVariant: productVariant,
    onHeaderVisibility: handleHeaderVisibility,
    handleColorSelector: handleColorSelector,
    avalibleColors: avalibleColors,
    selectedColor: selectedColor,
    availableMerch: availableMerch,
    selectedMerch: selectedMerch,
    handleMerchSelector: handleMerchSelector // handleBatterySelector={handleBatterySelector}
    // extraBattery={extraBattery}
    // disableExtraBattery={disableExtraBattery}
    ,
    handleAddToCart: handleAddToCart,
    financialServices: financialServices,
    allowImageInteractionTracking: allowImageInteractionTracking,
    setAllowImageInteractionTracking: setAllowImageInteractionTracking,
    trackImageInteractionLimit: trackImageInteractionLimit,
    setTrackImageInteractionLimit: setTrackImageInteractionLimit
  })), /*#__PURE__*/react_default.a.createElement(BackgroundImage, null), /*#__PURE__*/react_default.a.createElement("div", {
    ref: feature
  }, /*#__PURE__*/react_default.a.createElement(product_feature, null), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '60px',
      desktop: '120px'
    }
  }), /*#__PURE__*/react_default.a.createElement(image_collage, null)), /*#__PURE__*/react_default.a.createElement("div", {
    ref: learnMore
  }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    alignContentHorizontal: "center",
    backgroundColor: elements_theme["a" /* Color */].WhiteOff
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }), /*#__PURE__*/react_default.a.createElement(learn_more, {
    extraBattery: extraBattery,
    selectedMerch: selectedMerch,
    locale: productData.locale
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }))), /*#__PURE__*/react_default.a.createElement("div", {
    ref: reviews
  }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    backgroundColor: elements_theme["a" /* Color */].White
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }), /*#__PURE__*/react_default.a.createElement(product_review, null), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }))), /*#__PURE__*/react_default.a.createElement("div", {
    ref: relatedProducts
  }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    backgroundColor: elements_theme["a" /* Color */].WhiteOff
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }), /*#__PURE__*/react_default.a.createElement(related_products, {
    relatedProducts: productData.crossSellHandles
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '60px',
      desktop: '72px'
    }
  }))));
};

/* harmony default export */ var soundboks_gen3 = (soundboks_gen3_SoundboksGen3);
// EXTERNAL MODULE: ./components/pages/products-v2/speakers/soundboks-go/assets/SBGO_lifestyle_1_large.jpg
var SBGO_lifestyle_1_large = __webpack_require__("S7QA");
var SBGO_lifestyle_1_large_default = /*#__PURE__*/__webpack_require__.n(SBGO_lifestyle_1_large);

// EXTERNAL MODULE: ./components/pages/products-v2/speakers/soundboks-go/assets/SBGO_lifestyle_1_small.jpg
var SBGO_lifestyle_1_small = __webpack_require__("m38I");
var SBGO_lifestyle_1_small_default = /*#__PURE__*/__webpack_require__.n(SBGO_lifestyle_1_small);

// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-go/styled.ts




var styled_BackgroundImage = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__BackgroundImage",
  componentId: "sc-1l80g2l-0"
})(["display:block;width:100%;height:400px;background-image:url(", ");background-repeat:no-repeat;background-size:cover;background-position:30% 70%;@media ", "{height:852px;padding:20px;background-position:center;background-image:url(", ");}"], SBGO_lifestyle_1_large_default.a.url, styles_theme["a" /* default */].breakpoints.tablet, SBGO_lifestyle_1_small_default.a.url);
// EXTERNAL MODULE: ./public/static/images/usps/usp-sbgo-performance.jpg
var usp_sbgo_performance = __webpack_require__("94BA");
var usp_sbgo_performance_default = /*#__PURE__*/__webpack_require__.n(usp_sbgo_performance);

// EXTERNAL MODULE: ./public/static/images/usps/usp-sbgo-app.png
var usp_sbgo_app = __webpack_require__("GUDp");
var usp_sbgo_app_default = /*#__PURE__*/__webpack_require__.n(usp_sbgo_app);

// EXTERNAL MODULE: ./public/static/images/usps/usp-sbgo-dynamic.jpg
var usp_sbgo_dynamic = __webpack_require__("ra44");
var usp_sbgo_dynamic_default = /*#__PURE__*/__webpack_require__.n(usp_sbgo_dynamic);

// EXTERNAL MODULE: ./public/static/images/usps/usp-sbgo-portability.jpg
var usp_sbgo_portability = __webpack_require__("guMD");
var usp_sbgo_portability_default = /*#__PURE__*/__webpack_require__.n(usp_sbgo_portability);

// EXTERNAL MODULE: ./public/static/images/usps/usp-sbgo-breakthrough.jpg
var usp_sbgo_breakthrough = __webpack_require__("EnV8");
var usp_sbgo_breakthrough_default = /*#__PURE__*/__webpack_require__.n(usp_sbgo_breakthrough);

// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-go/product-feature/index.tsx
var soundboks_go_product_feature_jsx = react_default.a.createElement;

















var soundboks_go_product_feature_ProductFeatureSection = function ProductFeatureSection() {
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref) {
    var i18n = _ref.i18n;
    return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentVertical: "center",
      alignContentHorizontal: "center",
      backgroundColor: elements_theme["a" /* Color */].Charcoal
    }, /*#__PURE__*/react_default.a.createElement(index_web_ProductFeature, {
      features: [{
        uri: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_sbgo_performance_default.a.url),
        uriRanges: {
          phone: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_sbgo_performance_default.a.url, {
            width: 327,
            height: 400
          }),
          tabletLandscape: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_sbgo_performance_default.a.url, {
            width: 525,
            height: 600
          }),
          desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_sbgo_performance_default.a.url, {
            width: 525,
            height: 670
          })
        },
        title: i18n._('product.sb-go.feature.title.performance'),
        description: i18n._('product.sb-go.feature.description.performance'),
        imgPosition: 'left'
      }, {
        uri: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_sbgo_app_default.a.url),
        uriRanges: {
          phone: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_sbgo_app_default.a.url, {
            width: 397,
            height: 470
          }),
          tabletLandscape: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_sbgo_app_default.a.url, {
            width: 535,
            height: 610
          }),
          desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_sbgo_app_default.a.url, {
            width: 525,
            height: 670
          })
        },
        title: i18n._('product.sb3.feature.title.app.and.upgradability'),
        description: /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
          id: "product.sb3.feature.description.app.and.upgradability",
          components: [/*#__PURE__*/react_default.a.createElement(soundboks_go_product_feature_LinkWrapper, {
            href: "/products/soundboks-gen-3/app"
          })]
        }),
        content: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
          height: {
            "default": '17px',
            desktop: '60px'
          }
        }), /*#__PURE__*/react_default.a.createElement(Composition["b" /* Layout */], {
          omitPadding: true,
          direction: Composition["d" /* LayoutDirection */].Row,
          alignX: Composition["c" /* LayoutAlignment */].Start,
          alignY: Composition["c" /* LayoutAlignment */].Start
        }, /*#__PURE__*/react_default.a.createElement("a", {
          href: "https://play.google.com/store/apps/details?id=com.soundboks.SOUNDBOKS"
        }, /*#__PURE__*/react_default.a.createElement(atoms_Icon["b" /* default */], {
          height: 40,
          id: atoms_Icon["a" /* IconId */].DownloadGooglaPlay
        })), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
          width: "16px"
        }), /*#__PURE__*/react_default.a.createElement("a", {
          href: "https://apps.apple.com/us/app/soundboks/id1440156667"
        }, /*#__PURE__*/react_default.a.createElement(atoms_Icon["b" /* default */], {
          height: 40,
          id: atoms_Icon["a" /* IconId */].DownloadAppStore
        })))),
        imgPosition: 'right'
      }, {
        uri: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_sbgo_dynamic_default.a.url),
        uriRanges: {
          phone: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_sbgo_dynamic_default.a.url, {
            width: 397,
            height: 470
          }),
          tabletLandscape: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_sbgo_dynamic_default.a.url, {
            width: 535,
            height: 610
          }),
          desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_sbgo_dynamic_default.a.url, {
            width: 525,
            height: 670
          })
        },
        title: i18n._('product.sb-go.feature.title.dynamic'),
        description: i18n._('product.sb-go.feature.description.dynamic'),
        imgPosition: 'left'
      }, {
        uri: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_sbgo_portability_default.a.url),
        uriRanges: {
          phone: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_sbgo_portability_default.a.url, {
            width: 337,
            height: 410
          }),
          tabletLandscape: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_sbgo_portability_default.a.url, {
            width: 555,
            height: 660
          }),
          desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_sbgo_portability_default.a.url, {
            width: 545,
            height: 630
          })
        },
        title: i18n._('product.sb-go.feature.title.portability'),
        description: i18n._('product.sb-go.feature.description.portability'),
        imgPosition: 'right'
      }, {
        uri: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_sbgo_breakthrough_default.a.url),
        uriRanges: {
          phone: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_sbgo_breakthrough_default.a.url, {
            width: 397,
            height: 470
          }),
          tabletLandscape: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_sbgo_breakthrough_default.a.url, {
            width: 535,
            height: 610
          }),
          desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_sbgo_breakthrough_default.a.url, {
            width: 525,
            height: 670
          })
        },
        title: i18n._('product.sb-go.feature.title.break-through'),
        description: i18n._('product.sb-go.feature.description.break-through'),
        imgPosition: 'left'
      }]
    }));
  });
};

/* harmony default export */ var soundboks_go_product_feature = (soundboks_go_product_feature_ProductFeatureSection);
var product_feature_Anchor = styled_components_browser_esm["default"].a.withConfig({
  displayName: "product-feature__Anchor",
  componentId: "uhlfhs-0"
})(["color:", ";cursor:pointer;text-decoration:underline;"], elements_theme["a" /* Color */].White);

var soundboks_go_product_feature_LinkWrapper = function LinkWrapper(_ref2) {
  var href = _ref2.href,
      _ref2$children = _ref2.children,
      children = _ref2$children === void 0 ? undefined : _ref2$children;
  return /*#__PURE__*/react_default.a.createElement(Link["a" /* default */], {
    href: href,
    prefetch: false
  }, /*#__PURE__*/react_default.a.createElement(product_feature_Anchor, null, children));
};
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-go/product-overview/index.tsx
var soundboks_go_product_overview_jsx = react_default.a.createElement;






var soundboks_go_product_overview_ProductOverviewSection = function ProductOverviewSection(_ref) {
  var productData = _ref.productData,
      paths = _ref.paths,
      onHeaderVisibility = _ref.onHeaderVisibility,
      availableMerch = _ref.availableMerch,
      selectedMerch = _ref.selectedMerch,
      handleMerchSelector = _ref.handleMerchSelector,
      handleBatterySelector = _ref.handleBatterySelector,
      productVariant = _ref.productVariant,
      extraBattery = _ref.extraBattery,
      disableExtraBattery = _ref.disableExtraBattery,
      handleCarrierStrapSelector = _ref.handleCarrierStrapSelector,
      handleAddToCart = _ref.handleAddToCart,
      addCarrierStrap = _ref.addCarrierStrap,
      financialServices = _ref.financialServices,
      offset = _ref.offset,
      anchorStack = _ref.anchorStack,
      allowImageInteractionTracking = _ref.allowImageInteractionTracking,
      setAllowImageInteractionTracking = _ref.setAllowImageInteractionTracking,
      trackImageInteractionLimit = _ref.trackImageInteractionLimit,
      setTrackImageInteractionLimit = _ref.setTrackImageInteractionLimit;
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentHorizontal: "center",
      padding: {
        right: 24,
        left: 24
      }
    }, /*#__PURE__*/react_default.a.createElement(index_web_ProductOverview, {
      offset: offset,
      paths: paths,
      anchorStack: anchorStack,
      productData: productData,
      handleBatterySelector: handleBatterySelector // handleCarrierStrapSelector={handleCarrierStrapSelector}
      ,
      productVariant: productVariant,
      availableMerch: availableMerch,
      selectedMerch: selectedMerch,
      handleMerchSelector: handleMerchSelector,
      extraBattery: extraBattery // addCarrierStrap={addCarrierStrap}
      ,
      disableExtraBattery: disableExtraBattery,
      handleAddToCart: handleAddToCart,
      financialServices: financialServices,
      allowImageInteractionTracking: allowImageInteractionTracking,
      setAllowImageInteractionTracking: setAllowImageInteractionTracking,
      trackImageInteractionLimit: trackImageInteractionLimit,
      setTrackImageInteractionLimit: setTrackImageInteractionLimit,
      labels: {
        // addCarrierStrap: {
        //   label: i18n._('product.option.label.carrier-strap'),
        //   options: {
        //     yes: i18n._('product.option.label.yes'),
        //     no: i18n._('product.option.label.no'),
        //   },
        // },
        // extraBattery: {
        //   label: i18n._('product.option.label.extra-battery'),
        //   options: {
        //     yes: i18n._('product.option.label.yes'),
        //     no: i18n._('product.option.label.no'),
        //   },
        // },
        merch: {
          label: i18n._('product.option.label.accessories'),
          options: {
            Strap: i18n._('Strap'),
            Tripod: i18n._('Tripod'),
            Powerbank: i18n._('Powerbank'),
            None: i18n._('product.option.label.none')
          }
        },
        addToCart: i18n._('product.buy-page.button.addToCart'),
        outOfStock: i18n._('product.buy-page.button.outOfStock'),
        waitlist: i18n._('product.buy-page.button.waitlist'),
        usp: {
          warranty: i18n._('product.usp.warranty'),
          freeReturns: i18n._('product.usp.free-returns'),
          freeShipping: i18n._('product.usp.free-shipping'),
          premiumSupport: i18n._('product.usp.premium-support'),
          compatibility: i18n._('product.usp.compatibility')
        }
      },
      onHeaderVisibility: onHeaderVisibility
    }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    }));
  });
};

/* harmony default export */ var soundboks_go_product_overview = (soundboks_go_product_overview_ProductOverviewSection);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-go/learn-more/styled.ts



var learn_more_styled_LayoutContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__LayoutContainer",
  componentId: "sc-7v0eyt-0"
})(["padding:0 190px;background-color:", ";@media ", "{padding:0 24px;}"], elements_theme["a" /* Color */].WhiteOff, styles_theme["a" /* default */].breakpoints.maxMobile);
var StyledLink = styled_components_browser_esm["default"].a.withConfig({
  displayName: "styled__StyledLink",
  componentId: "sc-7v0eyt-1"
})(["color:", ";cursor:pointer;text-decoration:underline;"], elements_theme["a" /* Color */].Orange);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-go/learn-more/whats-in-the-box/styled.ts


var whats_in_the_box_styled_IconWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__IconWrapper",
  componentId: "sc-1hsfmnm-0"
})(["display:block;"]);
var whats_in_the_box_styled_Layout = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Layout",
  componentId: "sc-1hsfmnm-1"
})(["display:flex;flex-direction:row;justify-content:space-evenly;padding:10px 50px;align-items:end;@media ", "{display:grid;grid-template-columns:1fr 1fr;grid-gap:30px;padding:15px 0px;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
var learn_more_whats_in_the_box_styled_Link = styled_components_browser_esm["default"].a.withConfig({
  displayName: "styled__Link",
  componentId: "sc-1hsfmnm-2"
})(["text-decoration:underline;"]);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-go/learn-more/whats-in-the-box/index.web.tsx
var learn_more_whats_in_the_box_index_web_jsx = react_default.a.createElement;





var index_web_lookupTable = {
  Strap: ['tripod-backpack', 'tripod', 'powerbank'],
  Powerbank: ['tripod-backpack', 'tripod', 'carrier-strap'],
  Tripod: ['powerbank', 'carrier-strap'],
  None: ['carrier-strap', 'tripod', 'tripod-backpack', 'powerbank']
}; // eslint-disable-next-line prefer-arrow-callback

var whats_in_the_box_index_web_WhatsInTheBox = /*#__PURE__*/react_default.a.memo(function WhatsInTheBox(_ref) {
  var packageItems = _ref.packageItems,
      selectedMerch = _ref.selectedMerch;

  var filteredPackageItems = function filteredPackageItems() {
    return packageItems.filter(function (item) {
      var _lookupTable$selected;

      return !((_lookupTable$selected = index_web_lookupTable[selectedMerch]) === null || _lookupTable$selected === void 0 ? void 0 : _lookupTable$selected.includes(item.packageItemId));
    });
  };

  return /*#__PURE__*/react_default.a.createElement(whats_in_the_box_styled_Layout, null, // eslint-disable-next-line no-nested-ternary
  filteredPackageItems().map(function (_ref2) {
    var packageItemId = _ref2.packageItemId,
        title = _ref2.title,
        icon = _ref2.icon,
        downloadUrl = _ref2.downloadUrl;
    return /*#__PURE__*/react_default.a.createElement("div", {
      key: packageItemId
    }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(whats_in_the_box_styled_IconWrapper, null, icon), /*#__PURE__*/react_default.a.createElement(spacer_Spacer, {
      height: 10
    }), /*#__PURE__*/react_default.a.createElement(elements_typography["d" /* Caption02 */], null, title, " ", downloadUrl ? /*#__PURE__*/react_default.a.createElement(learn_more_whats_in_the_box_styled_Link, {
      href: downloadUrl
    }, "Download") : null)));
  }));
});
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-go/learn-more/whats-bluetooth-speaker/styled.ts


var styled_Table = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Table",
  componentId: "sc-13jp83t-0"
})(["width:100%;"]);
var whats_bluetooth_speaker_styled_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Wrapper",
  componentId: "sc-13jp83t-1"
})(["padding-left:26px;padding-right:26px;display:grid;grid-template-columns:250px 1fr 1fr 1fr;@media ", "{display:grid;grid-template-columns:1fr 1fr 1fr;}svg{margin:0 auto;}text-align:center;font-family:", ";font-size:10px;line-height:12px;"], styles_theme["a" /* default */].breakpoints.onlyMobile, styles_theme["a" /* default */].fonts.extended);
var learn_more_whats_bluetooth_speaker_styled_ImageWrapper = Object(styled_components_browser_esm["default"])(whats_bluetooth_speaker_styled_Wrapper).withConfig({
  displayName: "styled__ImageWrapper",
  componentId: "sc-13jp83t-2"
})(["align-items:baseline;padding-top:29px;"]);
var styled_ImageTextWrapper = Object(styled_components_browser_esm["default"])(whats_bluetooth_speaker_styled_Wrapper).withConfig({
  displayName: "styled__ImageTextWrapper",
  componentId: "sc-13jp83t-3"
})(["padding-top:8px;padding-bottom:12px;align-items:center;"]);
var styled_EmptyCell = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__EmptyCell",
  componentId: "sc-13jp83t-4"
})(["@media ", "{display:none;}"], styles_theme["a" /* default */].breakpoints.onlyMobile);
var styled_LastParagraph = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__LastParagraph",
  componentId: "sc-13jp83t-5"
})(["padding-top:40px;color:", ";font-family:", ";font-size:14px;line-height:16px;white-space:pre-wrap;"], styles_theme["a" /* default */].colors.black, styles_theme["a" /* default */].fonts.regular);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-go/learn-more/whats-bluetooth-speaker/attribute-row/CheckIcon.tsx
var attribute_row_CheckIcon_jsx = react_default.a.createElement;


var attribute_row_CheckIcon_CheckIcon = function CheckIcon() {
  return /*#__PURE__*/react_default.a.createElement("svg", {
    style: {
      margin: '0 auto'
    },
    width: 15,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react_default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.376.389 6.249 6.516l-3.751-3.75-2.122 2.12 5.873 5.873 8.248-8.25L12.376.39Z",
    fill: "#212222"
  }));
};

/* harmony default export */ var whats_bluetooth_speaker_attribute_row_CheckIcon = (attribute_row_CheckIcon_CheckIcon);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-go/learn-more/whats-bluetooth-speaker/attribute-row/styled.ts


var styled_TableRow = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__TableRow",
  componentId: "sc-1aeb71o-0"
})(["display:grid;grid-template-columns:250px auto;padding:26px;@media ", "{display:flex;flex-direction:column;text-align:center;gap:22px;}"], styles_theme["a" /* default */].breakpoints.onlyMobile);
var styled_AttributeText = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__AttributeText",
  componentId: "sc-1aeb71o-1"
})(["font-family:", ";font-size:14px;line-height:16px;@media ", "{font-size:11px;line-height:12px;}"], styles_theme["a" /* default */].fonts.regular, styles_theme["a" /* default */].breakpoints.onlyMobile);
var styled_CheckIconWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__CheckIconWrapper",
  componentId: "sc-1aeb71o-2"
})(["display:grid;grid-template-columns:1fr 1fr 1fr;"]);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-go/learn-more/whats-bluetooth-speaker/attribute-row/index.tsx
var whats_bluetooth_speaker_attribute_row_jsx = react_default.a.createElement;




 // eslint-disable-next-line prefer-arrow-callback

var whats_bluetooth_speaker_attribute_row_AttributeRow = /*#__PURE__*/react_default.a.memo(function AttributeRow(_ref) {
  var text = _ref.text,
      checks = _ref.checks;
  return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(styled_TableRow, null, /*#__PURE__*/react_default.a.createElement(styled_AttributeText, null, text), /*#__PURE__*/react_default.a.createElement(styled_CheckIconWrapper, null, checks.map(function (check, index) {
    return check ? /*#__PURE__*/react_default.a.createElement(whats_bluetooth_speaker_attribute_row_CheckIcon, {
      key: "check-icon".concat(index)
    }) : /*#__PURE__*/react_default.a.createElement("div", {
      key: "check-icon".concat(index)
    });
  }))), /*#__PURE__*/react_default.a.createElement(HorizontalLine, {
    color: styles_theme["a" /* default */].colors.white
  }));
});
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-go/learn-more/whats-bluetooth-speaker/icons/IconSoundboksGo.tsx
var IconSoundboksGo_jsx = react_default.a.createElement;


var IconSoundboksGo_IconSoundboksGo = function IconSoundboksGo() {
  return /*#__PURE__*/react_default.a.createElement("svg", {
    width: "120",
    height: "120",
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react_default.a.createElement("g", {
    clipPath: "url(#clip0_306_867)"
  }, /*#__PURE__*/react_default.a.createElement("path", {
    d: "M94.555 70.68H91.465L89.905 67.97H86.205L84.6451 70.68H82.1351L80.575 67.97H76.8751L75.315 70.68H72.7651L71.205 67.97H67.5051L65.945 70.68H63.435L61.8651 67.97H58.175L56.6151 70.68H54.095L52.535 67.97H48.845L47.275 70.68H44.735L43.175 67.97H39.475L37.915 70.68H35.335L33.775 67.97H30.085L28.525 70.68H25.405L23.555 73.88L25.1151 76.58L23.555 79.29L25.1151 81.99L23.555 84.69L25.1151 87.4L23.555 90.1L25.1151 92.8L23.555 95.5L25.1151 98.21L23.555 100.91L25.1151 103.61L23.555 106.32L25.1151 109.02L23.555 111.72L25.405 114.93H29.105L30.665 112.22H33.205L34.6151 114.68L34.7651 114.93H38.465L40.025 112.22H42.535L44.095 114.93H47.795L47.945 114.66L49.355 112.2H51.8751L53.435 114.91H57.1351L58.695 112.2H61.205L62.7651 114.91H66.465L66.605 114.65L68.0151 112.19H70.535L72.095 114.9H75.795L75.945 114.63L77.355 112.17H79.8751L81.435 114.88H85.1351L86.695 112.17H89.205L90.7651 114.88H94.465L96.315 111.67L94.7551 108.97L96.315 106.27L94.7551 103.56L96.315 100.86L94.7551 98.16L96.315 95.45L94.7551 92.75L96.315 90.05L94.7551 87.35L96.315 84.64L94.7551 81.94L96.315 79.24L94.7551 76.53L96.315 73.83L94.555 70.68ZM65.945 77.08L67.225 79.29L65.945 81.49H63.435L62.155 79.29L63.435 77.08H65.945ZM70.605 74.38L71.8751 76.58L70.605 78.79H68.085L66.815 76.58L68.085 74.38H70.605ZM79.965 74.38L81.2451 76.58L79.965 78.79H77.445L76.175 76.58L77.445 74.38H79.965ZM89.295 74.38L90.575 76.58L89.295 78.79H86.785L85.5151 76.58L86.785 74.38H89.295ZM86.785 105.82L85.5151 103.61L86.785 101.41H89.295L90.575 103.61L89.295 105.82H86.785ZM82.1351 108.52L80.855 106.32L82.1351 104.11H84.6451L85.915 106.32L84.6451 108.52H82.1351ZM77.445 105.82L76.175 103.61L77.445 101.41H79.965L81.2451 103.61L79.965 105.82H77.445ZM72.7651 108.52L71.4951 106.32L72.7651 104.11H75.285L76.555 106.32L75.335 108.56L72.7651 108.52ZM68.085 105.82L66.815 103.61L68.085 101.41H70.605L71.8751 103.61L70.605 105.82H68.085ZM63.435 108.52L62.155 106.32L63.435 104.11H65.945L67.225 106.32L65.945 108.52H63.435ZM58.7551 105.82L57.485 103.61L58.7551 101.41H61.2651L62.535 103.61L61.2651 105.82H58.7551ZM54.095 108.52L52.825 106.32L54.095 104.11H56.6151L57.8851 106.32L56.6151 108.52H54.095ZM49.415 105.82L48.1451 103.61L49.415 101.41H51.935L53.205 103.61L51.935 105.82H49.415ZM44.735 108.52L43.465 106.32L44.735 104.11H47.2551L48.525 106.32L47.2551 108.52H44.735ZM40.065 105.82L38.785 103.61L40.065 101.41H42.575L43.845 103.61L42.575 105.82H40.065ZM35.335 108.56L34.705 107.46L34.065 106.36L34.705 105.25L35.335 104.15H37.8751L39.1451 106.36L37.8751 108.56H35.335ZM30.665 105.86L29.3951 103.65L30.665 101.45H33.205L33.835 102.55L34.475 103.65L33.835 104.75L33.205 105.86H30.665ZM28.965 72.48L29.185 71.72H62.435L61.8951 73.54L61.6351 74.42L61.5051 74.87L61.1351 76.1H27.8951L28.965 72.47V72.48ZM65.905 82.53L67.185 84.73L65.905 86.93H63.3951L62.1151 84.73L63.3951 82.53H65.905ZM70.565 79.83L71.835 82.03L70.565 84.23H68.045L66.775 82.03L68.045 79.83H70.565ZM75.2451 77.12L76.5151 79.33L75.2451 81.53H72.725L71.455 79.33L72.725 77.12H75.2451ZM79.925 79.83L81.205 82.03L79.925 84.23H77.405L76.1351 82.03L77.405 79.83H79.925ZM84.605 77.12L85.8751 79.33L84.605 81.53H82.095L80.815 79.33L82.095 77.12H84.605ZM89.2551 79.83L90.535 82.03L89.2551 84.23H86.7451L85.475 82.03L86.7451 79.83H89.2551ZM86.7451 100.45L85.475 98.25L86.7451 96.04H89.2551L90.535 98.25L89.2551 100.45H86.7451ZM82.095 103.15L80.815 100.95L82.095 98.75H84.605L85.8751 100.95L84.605 103.15H82.095ZM77.405 100.45L76.1351 98.25L77.405 96.04H79.925L81.205 98.25L79.925 100.45H77.405ZM72.725 103.15L71.455 100.95L72.725 98.75H75.2451L76.5151 100.95L75.2451 103.15H72.725ZM68.045 100.45L66.775 98.25L68.045 96.04H70.565L71.835 98.25L70.565 100.45H68.045ZM63.3951 103.15L62.1151 100.95L63.3951 98.75H65.905L67.185 100.95L65.905 103.15H63.3951ZM58.715 100.45L57.445 98.25L58.715 96.04H61.225L62.4951 98.25L61.225 100.45H58.715ZM54.055 103.15L52.785 100.95L54.055 98.75H56.575L57.845 100.95L56.575 103.15H54.055ZM49.3751 100.45L48.105 98.25L49.3751 96.04H51.8951L53.165 98.25L51.8951 100.45H49.3751ZM44.695 103.15L43.425 100.95L44.695 98.75H47.215L48.485 100.95L47.215 103.15H44.695ZM40.025 100.45L38.7451 98.25L40.025 96.04H42.535L43.805 98.25L42.535 100.45H40.025ZM35.335 103.15L34.705 102.05L34.065 100.95L34.705 99.85L35.335 98.75H37.8751L39.1451 100.95L37.8751 103.15H35.335ZM30.665 100.45L29.3951 98.25L30.665 96.04H33.205L33.835 97.15L34.475 98.25L33.835 99.35L33.205 100.45H30.665ZM65.905 87.93L67.185 90.14L65.905 92.34H63.3951L62.1151 90.14L63.3951 87.93H65.905ZM70.565 85.23L71.835 87.44L70.565 89.64H68.045L66.775 87.43L68.045 85.23H70.565ZM75.2451 82.53L76.5151 84.73L75.2451 86.93H72.725L71.455 84.73L72.725 82.53H75.2451ZM79.925 85.23L81.205 87.44L79.925 89.64H77.405L76.1351 87.43L77.405 85.23H79.925ZM84.605 82.53L85.8751 84.73L84.605 86.93H82.095L80.815 84.73L82.095 82.53H84.605ZM82.095 97.75L80.815 95.54L82.095 93.34H84.605L85.8751 95.54L84.605 97.75H82.095ZM77.405 95.04L76.1351 92.84L77.405 90.64H79.925L81.205 92.84L79.925 95.04H77.405ZM72.725 97.75L71.455 95.54L72.725 93.34H75.2451L76.5151 95.54L75.2451 97.75H72.725ZM68.045 95.04L66.775 92.84L68.045 90.64H70.565L71.835 92.84L70.565 95.04H68.045ZM63.3951 97.75L62.1151 95.54L63.3951 93.34H65.905L67.185 95.54L65.905 97.75H63.3951ZM58.715 95.04L57.445 92.84L58.715 90.64H61.225L62.4951 92.84L61.225 95.04H58.715ZM54.055 97.75L52.785 95.54L54.055 93.34H56.575L57.845 95.54L56.575 97.75H54.055ZM49.3751 95.04L48.105 92.84L49.3751 90.64H51.8951L53.165 92.84L51.8951 95.04H49.3751ZM44.695 97.75L43.425 95.54L44.695 93.34H47.215L48.485 95.54L47.215 97.75H44.695ZM40.025 95.04L38.7451 92.84L40.025 90.64H42.535L43.805 92.84L42.535 95.04H40.025ZM35.335 97.75L34.705 96.65L34.065 95.54L34.705 94.44L35.335 93.34H37.8751L39.1451 95.54L37.8751 97.75H35.335ZM37.8751 77.12L39.1451 79.33L37.8751 81.53H35.335L34.705 80.43L34.065 79.33L34.705 78.22L35.335 77.12H37.8751ZM47.215 77.12L48.485 79.33L47.215 81.53H44.695L43.425 79.33L44.695 77.12H47.215ZM56.575 77.12L57.845 79.33L56.575 81.53H54.055L52.785 79.33L54.055 77.12H56.575ZM61.225 79.83L62.4951 82.03L61.225 84.23H58.715L57.445 82.03L58.715 79.83H61.225ZM58.715 89.64L57.445 87.44L58.715 85.23H61.225L62.4951 87.44L61.225 89.64H58.715ZM54.055 92.34L52.785 90.14L54.055 87.93H56.575L57.845 90.14L56.575 92.34H54.055ZM49.3751 89.64L48.105 87.43L49.3751 85.23H51.8951L53.165 87.44L51.8951 89.64H49.3751ZM44.695 92.34L43.425 90.14L44.695 87.93H47.215L48.485 90.14L47.215 92.34H44.695ZM40.025 89.64L38.7451 87.44L40.025 85.23H42.535L43.805 87.44L42.535 89.64H40.025ZM35.335 92.34L34.705 91.24L34.065 90.14L34.705 89.04L35.335 87.93H37.8751L39.1451 90.14L37.8751 92.34H35.335ZM34.065 84.73L34.705 83.63L35.335 82.53H37.8751L39.1451 84.73L37.8751 86.93H35.335L34.705 85.83L34.065 84.73ZM42.535 79.83L43.805 82.03L42.535 84.23H40.025L38.7451 82.03L40.025 79.83H42.535ZM47.215 82.53L48.485 84.73L47.215 86.93H44.695L43.425 84.73L44.695 82.53H47.215ZM51.8951 79.83L53.165 82.03L51.8951 84.23H49.3751L48.105 82.03L49.3751 79.83H51.8951ZM56.575 82.53L57.845 84.73L56.575 86.93H54.055L52.785 84.73L54.055 82.53H56.575ZM51.8951 78.83H49.3751L48.3751 77.12H52.855L51.8951 78.83ZM42.535 78.83H40.025L39.025 77.12H43.5051L42.535 78.83ZM75.2451 87.93L76.5151 90.14L75.2451 92.34H72.725L71.455 90.14L72.725 87.93H75.2451ZM84.605 87.93L85.8751 90.14L84.605 92.34H82.095L80.815 90.14L82.095 87.93H84.605ZM61.225 78.83H58.715L57.715 77.12H61.8651L62.175 76.12L62.475 76.65L61.225 78.83ZM34.225 77.12L33.8751 77.72L33.2451 78.83H30.705L29.705 77.12H34.225ZM33.225 79.83L33.855 80.93L34.4951 82.03L33.855 83.13L33.225 84.23H30.685L29.415 82.03L30.685 79.83H33.225ZM33.225 85.23L33.855 86.33L34.4951 87.44L33.855 88.54L33.225 89.64H30.685L29.415 87.44L30.685 85.23H33.225ZM33.225 90.64L33.855 91.74L34.4951 92.84L33.855 93.94L33.225 95.04H30.685L29.415 92.84L30.685 90.64H33.225ZM86.7651 95.04L85.4951 92.84L86.7651 90.64H89.275L90.555 92.84L89.275 95.04H86.7651ZM86.7651 89.64L85.4951 87.44L86.7651 85.23H89.275L90.555 87.44L89.335 89.56L86.7651 89.64ZM85.8951 73.92L84.6251 76.12H82.1151L80.835 73.92L82.1151 71.72H84.6251L85.8951 73.92ZM76.535 73.92L75.2651 76.12H72.7451L71.475 73.92L72.7451 71.72H75.2651L76.535 73.92ZM29.415 109.06L30.685 106.86H33.225L33.855 107.96L34.4951 109.06L33.855 110.16L33.225 111.26H30.685L29.415 109.06ZM34.085 111.76L34.725 110.66L35.355 109.56H37.8951L39.165 111.76L37.8951 113.97H35.335L34.085 111.76ZM38.7651 109.06L40.045 106.86H42.555L43.825 109.06L42.555 111.26H40.045L38.7651 109.06ZM43.445 111.76L44.715 109.56H47.235L48.5051 111.76L47.235 113.97H44.715L43.445 111.76ZM48.1251 109.06L49.3951 106.86H51.915L53.185 109.06L51.915 111.26H49.3951L48.1251 109.06ZM52.805 111.76L54.075 109.56H56.595L57.8651 111.76L56.595 113.97H54.075L52.805 111.76ZM57.465 109.06L58.735 106.86H61.2451L62.5151 109.06L61.2451 111.26H58.735L57.465 109.06ZM62.1351 111.76L63.415 109.56H65.925L67.205 111.76L65.925 113.97H63.415L62.1351 111.76ZM66.795 109.06L68.065 106.86H70.585L71.855 109.06L70.585 111.26H68.065L66.795 109.06ZM71.475 111.76L72.7451 109.56H75.2651L76.535 111.76L75.2651 113.97H72.7451L71.475 111.76ZM76.155 109.06L77.425 106.86H79.945L81.225 109.06L79.945 111.26H77.425L76.155 109.06ZM80.835 111.76L82.1151 109.56H84.6251L85.8951 111.76L84.6251 113.97H82.1151L80.835 111.76ZM85.4951 109.06L86.7651 106.86H89.275L90.555 109.06L89.275 111.26H86.7651L85.4951 109.06ZM86.7651 69.01H89.305L90.565 71.19L89.275 73.42H86.7651L85.4951 71.21L86.7651 69.01ZM77.425 69.01H79.975L81.235 71.19L79.945 73.42H77.425L76.155 71.22L77.425 69.01ZM68.065 69.01H70.6151L71.8651 71.2L70.585 73.42H68.065L66.795 71.22L68.065 69.01ZM65.925 71.72L67.205 73.92L65.925 76.12H63.415L62.605 74.74L63.4951 71.74L65.925 71.72ZM58.725 69.01H61.275L62.275 70.72H57.7651L58.725 69.01ZM49.3951 69.01H51.945L52.945 70.72H48.435L49.3951 69.01ZM40.035 69.01H42.575L43.575 70.72H39.065L40.035 69.01ZM30.675 69.01H33.225L34.225 70.72H29.715L30.675 69.01ZM24.735 73.92L26.0051 71.72H28.165L26.8751 76.12H26.0051L24.735 73.92ZM24.735 79.33L26.0051 77.12H28.545L29.815 79.33L28.545 81.53H26.0051L24.735 79.33ZM24.735 84.73L26.0051 82.53H28.545L29.815 84.73L28.545 86.93H26.0051L24.735 84.73ZM24.735 90.14L26.0051 87.93H28.545L29.815 90.14L28.545 92.34H26.0051L24.735 90.14ZM24.735 95.54L26.0051 93.34H28.545L29.815 95.54L28.545 97.75H26.0051L24.735 95.54ZM24.735 100.95L26.0051 98.75H28.545L29.815 100.95L28.545 103.15H26.0051L24.735 100.95ZM24.735 106.36L26.0051 104.15H28.545L29.815 106.36L28.545 108.56H26.0051L24.735 106.36ZM24.735 111.76L26.0051 109.56H28.545L29.815 111.76L28.535 113.97H26.0051L24.735 111.76ZM95.235 111.76L93.965 113.97H91.445L90.175 111.76L91.445 109.56H93.965L95.235 111.76ZM95.235 106.36L93.965 108.56H91.445L90.175 106.36L91.445 104.15H93.965L95.235 106.36ZM95.235 100.95L93.965 103.15H91.445L90.175 100.95L91.445 98.75H93.965L95.235 100.95ZM95.235 95.54L93.965 97.75H91.445L90.175 95.54L91.445 93.34H93.965L95.235 95.54ZM95.235 90.14L93.965 92.34H91.445L90.175 90.14L91.445 87.93H93.965L95.235 90.14ZM95.235 84.73L93.965 86.93H91.445L90.175 84.73L91.445 82.53H93.965L95.235 84.73ZM95.235 79.33L93.965 81.53H91.445L90.175 79.33L91.445 77.12H93.965L95.235 79.33ZM93.965 76.12H91.445L90.175 73.92L91.445 71.72H93.965L95.235 73.92L93.965 76.12Z",
    fill: "#212222"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M95.585 62.9H24.415C22.9173 62.9026 21.4818 63.4988 20.4228 64.5578C19.3638 65.6168 18.7677 67.0523 18.7651 68.55V114.35C18.7677 115.848 19.3638 117.283 20.4228 118.342C21.4818 119.401 22.9173 119.997 24.415 120H95.585C97.0835 120 98.5206 119.405 99.5801 118.345C100.64 117.286 101.235 115.848 101.235 114.35V68.56C101.236 67.8172 101.091 67.0814 100.808 66.3948C100.524 65.7081 100.108 65.0841 99.5837 64.5584C99.0589 64.0327 98.4356 63.6156 97.7495 63.331C97.0633 63.0465 96.3278 62.9 95.585 62.9ZM100.235 114.35C100.235 115.583 99.7452 116.766 98.8731 117.638C98.0011 118.51 96.8183 119 95.585 119H24.415C23.1825 118.997 22.0014 118.507 21.1299 117.635C20.2585 116.764 19.7677 115.582 19.7651 114.35V68.56C19.7677 67.3276 20.2585 66.1463 21.1299 65.2749C22.0014 64.4034 23.1825 63.9126 24.415 63.91H95.585C96.8183 63.91 98.0011 64.3999 98.8731 65.272C99.7452 66.144 100.235 67.3267 100.235 68.56V114.35Z",
    fill: "#212222"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M95.405 65.56H24.605C23.751 65.56 22.9321 65.8992 22.3282 66.5031C21.7243 67.107 21.3851 67.926 21.3851 68.78V114.16C21.3851 115.014 21.7243 115.833 22.3282 116.437C22.9321 117.041 23.751 117.38 24.605 117.38H95.405C96.2572 117.377 97.0738 117.037 97.6755 116.433C98.2772 115.83 98.6151 115.012 98.6151 114.16V68.74C98.6046 67.8947 98.262 67.0874 97.6614 66.4924C97.0609 65.8975 96.2504 65.5626 95.405 65.56ZM97.6151 114.2C97.6151 114.787 97.3825 115.35 96.9683 115.766C96.5542 116.182 95.992 116.417 95.405 116.42H24.605C24.0171 116.417 23.4539 116.183 23.0381 115.767C22.6224 115.351 22.3877 114.788 22.3851 114.2V68.74C22.3851 68.1512 22.6189 67.5866 23.0352 67.1702C23.4515 66.7539 24.0163 66.52 24.605 66.52H95.405C95.696 66.52 95.9843 66.5775 96.2531 66.6892C96.5219 66.8009 96.7659 66.9645 96.9713 67.1708C97.1766 67.3771 97.3392 67.6219 97.4496 67.8912C97.5601 68.1605 97.6164 68.4489 97.6151 68.74V114.2Z",
    fill: "#212222"
  })), /*#__PURE__*/react_default.a.createElement("defs", null, /*#__PURE__*/react_default.a.createElement("clipPath", {
    id: "clip0_306_867"
  }, /*#__PURE__*/react_default.a.createElement("rect", {
    width: "82.47",
    height: "57.1",
    fill: "white",
    transform: "translate(18.765 62.9)"
  }))));
};

/* harmony default export */ var icons_IconSoundboksGo = (IconSoundboksGo_IconSoundboksGo);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-go/learn-more/whats-bluetooth-speaker/icons/IconPASystem.tsx
var icons_IconPASystem_jsx = react_default.a.createElement;


var icons_IconPASystem_IconPASystem = function IconPASystem() {
  return /*#__PURE__*/react_default.a.createElement("svg", {
    width: 81,
    height: 81,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react_default.a.createElement("g", {
    fill: "#212222"
  }, /*#__PURE__*/react_default.a.createElement("path", {
    d: "M33.417 39.027a1.16 1.16 0 1 0 2.32 0 1.16 1.16 0 0 0-2.32 0ZM10.09 40.194a1.16 1.16 0 1 0-.013-2.321 1.16 1.16 0 0 0 .014 2.32ZM34.577 74.774a1.167 1.167 0 1 0 1.103.713 1.158 1.158 0 0 0-1.103-.713ZM10.09 74.774a1.167 1.167 0 1 0-.013 2.333 1.167 1.167 0 0 0 .013-2.333ZM22.33 54.32a11.42 11.42 0 1 0 .04 22.839 11.42 11.42 0 0 0-.04-22.838Zm0 22.167a10.753 10.753 0 1 1 10.774-10.753 10.767 10.767 0 0 1-10.773 10.753Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M22.33 57.147a8.587 8.587 0 1 0 8.587 8.587 8.6 8.6 0 0 0-8.587-8.587Zm0 16.507a7.92 7.92 0 1 1 7.92-7.92 7.926 7.926 0 0 1-7.92 7.92Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M22.33 61.954a3.78 3.78 0 1 0 0 7.559 3.78 3.78 0 0 0 0-7.56Zm0 6.893a3.113 3.113 0 1 1 3.113-3.113 3.119 3.119 0 0 1-3.113 3.127v-.014ZM22.33 51.914a6.627 6.627 0 1 0-6.62-6.627 6.666 6.666 0 0 0 6.62 6.627Zm0-12.58a5.96 5.96 0 1 1-5.953 5.953 5.967 5.967 0 0 1 5.953-5.953Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M22.33 48.247a2.96 2.96 0 1 0 0-5.919 2.96 2.96 0 0 0 0 5.92Zm0-5.253a2.293 2.293 0 1 1-2.293 2.293 2.3 2.3 0 0 1 2.293-2.293Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M71.237 34.387H61.53a4.173 4.173 0 0 0 2-3.567V5.427a4.193 4.193 0 0 0-4.187-4.187H21.55a4.193 4.193 0 0 0-4.187 4.187v25.394a4.18 4.18 0 0 0 2 3.566H9.637a4.194 4.194 0 0 0-4.187 4.187v37.813a4.193 4.193 0 0 0 4.187 4.187H35.03a4.194 4.194 0 0 0 4.187-4.187V38.574a4.195 4.195 0 0 0-2-3.573h6.48a4.193 4.193 0 0 0-2 3.573v37.813a4.193 4.193 0 0 0 4.186 4.187h25.354a4.193 4.193 0 0 0 4.187-4.187V38.574a4.193 4.193 0 0 0-4.187-4.187ZM18.03 30.82V5.427a3.527 3.527 0 0 1 3.52-3.52h37.813a3.527 3.527 0 0 1 3.52 3.52v25.394a3.52 3.52 0 0 1-3.52 3.513H21.55a3.52 3.52 0 0 1-3.52-3.514Zm20.52 7.754v37.813a3.527 3.527 0 0 1-3.52 3.52H9.637a3.527 3.527 0 0 1-3.52-3.52V38.574a3.527 3.527 0 0 1 3.52-3.52H35.03a3.527 3.527 0 0 1 3.52 3.52Zm36.207 37.813a3.527 3.527 0 0 1-3.52 3.52H45.844a3.526 3.526 0 0 1-3.52-3.52V38.574a3.527 3.527 0 0 1 3.52-3.52h25.393a3.527 3.527 0 0 1 3.52 3.52v37.813Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M70.783 37.867a1.16 1.16 0 1 0 .014 2.32 1.16 1.16 0 0 0-.014-2.32ZM46.297 40.194a1.16 1.16 0 1 0 0-2.322 1.16 1.16 0 0 0 0 2.322ZM70.784 74.774a1.166 1.166 0 1 0 1.08.719 1.16 1.16 0 0 0-1.08-.72ZM46.296 74.774a1.167 1.167 0 1 0 1.074.72 1.16 1.16 0 0 0-1.074-.72ZM58.544 54.32a11.42 11.42 0 1 0 11.413 11.414A11.427 11.427 0 0 0 58.544 54.32Zm0 22.167A10.754 10.754 0 1 1 69.29 65.734a10.767 10.767 0 0 1-10.746 10.753Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M58.544 57.147a8.586 8.586 0 1 0-.054 17.173 8.586 8.586 0 0 0 .054-17.173Zm0 16.507a7.92 7.92 0 1 1 7.893-7.92 7.926 7.926 0 0 1-7.893 7.92Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M58.544 61.954a3.78 3.78 0 1 0 0 7.56 3.78 3.78 0 0 0 0-7.56Zm0 6.893a3.113 3.113 0 1 1 3.113-3.113 3.114 3.114 0 0 1-3.113 3.127v-.014ZM58.544 51.914a6.626 6.626 0 1 0 0-13.252 6.626 6.626 0 0 0 0 13.252Zm0-12.58a5.96 5.96 0 1 1-5.96 5.953 5.967 5.967 0 0 1 5.96-5.953Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M58.544 48.247a2.96 2.96 0 1 0-2.96-2.96 2.966 2.966 0 0 0 2.96 2.96Zm0-5.253a2.293 2.293 0 1 1-2.293 2.293 2.3 2.3 0 0 1 2.293-2.293ZM22.004 7.04a1.167 1.167 0 1 0-1.078-.714 1.16 1.16 0 0 0 1.078.714ZM23.163 30.367a1.168 1.168 0 1 0-2.335-.013 1.168 1.168 0 0 0 2.335.013ZM58.91 7.04a1.167 1.167 0 1 0 .054-2.332 1.167 1.167 0 0 0-.053 2.333ZM58.91 29.207a1.16 1.16 0 1 0 .013 2.32 1.16 1.16 0 0 0-.013-2.32ZM48.71 29.527a11.42 11.42 0 1 0-11.413-11.42 11.433 11.433 0 0 0 11.413 11.42Zm0-22.166a10.753 10.753 0 1 1-10.746 10.746A10.76 10.76 0 0 1 48.71 7.374V7.36Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M48.71 26.707a8.587 8.587 0 1 0-8.587-8.587 8.6 8.6 0 0 0 8.587 8.587Zm0-16.507a7.92 7.92 0 1 1-5.601 2.318 7.927 7.927 0 0 1 5.6-2.324v.006Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M48.71 21.9a3.78 3.78 0 1 0 0-7.558 3.78 3.78 0 0 0 0 7.559Zm0-6.893a3.113 3.113 0 1 1-3.113 3.114 3.12 3.12 0 0 1 3.114-3.114ZM28.263 24.747a6.627 6.627 0 1 0-6.626-6.626 6.666 6.666 0 0 0 6.626 6.626Zm0-12.58a5.961 5.961 0 1 1-5.96 5.954 5.96 5.96 0 0 1 5.96-5.927v-.027Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M28.264 21.08a2.96 2.96 0 1 0 0-5.92 2.96 2.96 0 0 0 0 5.92Zm0-5.253a2.293 2.293 0 1 1-2.294 2.293 2.3 2.3 0 0 1 2.294-2.293Z"
  })));
};

/* harmony default export */ var whats_bluetooth_speaker_icons_IconPASystem = (icons_IconPASystem_IconPASystem);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-go/learn-more/whats-bluetooth-speaker/icons/IconSpeaker.tsx
var icons_IconSpeaker_jsx = react_default.a.createElement;


var icons_IconSpeaker_IconSpeaker = function IconSpeaker() {
  return /*#__PURE__*/react_default.a.createElement("svg", {
    width: 81,
    height: 81,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react_default.a.createElement("g", {
    clipPath: "url(#a)",
    fill: "#212222"
  }, /*#__PURE__*/react_default.a.createElement("path", {
    d: "M25.297 41.767a10.6 10.6 0 1 0 10.6 10.6 10.607 10.607 0 0 0-10.6-10.6Zm0 20.533a9.934 9.934 0 1 1 9.934-9.933 9.946 9.946 0 0 1-9.934 9.933Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M25.297 47.747a4.62 4.62 0 1 0 4.62 4.62 4.627 4.627 0 0 0-4.62-4.62Zm0 8.567a3.953 3.953 0 1 1 0-7.907 3.953 3.953 0 0 1 0 7.907ZM21.284 69.794a1.167 1.167 0 1 0 1.073.72 1.16 1.16 0 0 0-1.073-.72ZM29.31 69.794a1.167 1.167 0 1 0-.013 2.333 1.167 1.167 0 0 0 .013-2.333ZM56.297 41.767a10.6 10.6 0 1 0 10.6 10.6 10.614 10.614 0 0 0-10.6-10.6Zm0 20.533a9.934 9.934 0 1 1 9.934-9.933 9.946 9.946 0 0 1-9.934 9.933Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M56.297 47.747a4.62 4.62 0 1 0 4.667 4.62 4.625 4.625 0 0 0-4.667-4.62Zm0 8.567a3.953 3.953 0 1 1 .093-7.905 3.953 3.953 0 0 1-.093 7.905ZM52.297 69.794a1.167 1.167 0 1 0 1.08.719 1.159 1.159 0 0 0-1.08-.72ZM60.296 69.794a1.167 1.167 0 1 0 1.074.72 1.16 1.16 0 0 0-1.074-.72Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "m76.784 68.654-.667-1.86a1.333 1.333 0 0 0-1.334-.88l-.526-1.474a.355.355 0 0 0-.667.24l.52 1.474a1.334 1.334 0 0 0-.493 1.547l.666 1.853a.841.841 0 0 0 .434.486c.115.053.24.08.367.08a.872.872 0 0 0 .286-.053l.233-.08a3.794 3.794 0 0 1-.446 3.574c-1.114 1.48-3.26 2.093-4.627 2.106v-35.42a3.013 3.013 0 0 0-3.007-3.007h-22.4a3.013 3.013 0 0 0-3.006 3.007v34.127c-1.227-.053-2.153-.04-2.627 0V40.247a3.013 3.013 0 0 0-3.007-3.007H14.11a3.013 3.013 0 0 0-3.006 3.007v37.334a3.013 3.013 0 0 0 3.006 3.006h22.373a3.013 3.013 0 0 0 3.007-3.007v-2.546c.453 0 1.393-.034 2.627 0v2.526a3.013 3.013 0 0 0 3.007 3.007h22.373a3.013 3.013 0 0 0 3.007-3.006v-1.227c1.526 0 3.913-.72 5.16-2.38a4.506 4.506 0 0 0 .54-4.2h.073a.847.847 0 0 0 .507-1.1Zm-37.96 8.913a2.346 2.346 0 0 1-2.34 2.34H14.11a2.34 2.34 0 0 1-2.34-2.34V40.234a2.34 2.34 0 0 1 2.34-2.34h22.373a2.347 2.347 0 0 1 2.34 2.34v37.333Zm31.013 0a2.34 2.34 0 0 1-2.34 2.34H45.124a2.346 2.346 0 0 1-2.34-2.34V40.234a2.347 2.347 0 0 1 2.34-2.34h22.373a2.34 2.34 0 0 1 2.34 2.34v37.333Zm5.28-8.126a.174.174 0 0 1-.14 0 .154.154 0 0 1-.094-.1l-.666-1.86a.665.665 0 0 1 0-.514.667.667 0 0 1 .113-.153l.614-.22a.667.667 0 0 1 .526.433l.667 1.853a.174.174 0 0 1 0 .14.153.153 0 0 1-.1.094l-.92.326Z"
  })), /*#__PURE__*/react_default.a.createElement("defs", null, /*#__PURE__*/react_default.a.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/react_default.a.createElement("path", {
    fill: "#fff",
    transform: "translate(11.104 37.24)",
    d: "M0 0h65.733v43.333H0z"
  }))));
};

/* harmony default export */ var whats_bluetooth_speaker_icons_IconSpeaker = (icons_IconSpeaker_IconSpeaker);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-go/learn-more/whats-bluetooth-speaker/index.web.tsx
var learn_more_whats_bluetooth_speaker_index_web_jsx = react_default.a.createElement;








 // eslint-disable-next-line prefer-arrow-callback

var whats_bluetooth_speaker_index_web_WhatsBluetoothSpeaker = /*#__PURE__*/react_default.a.memo(function WhatsBluetoothSpeaker() {
  var icons = [{
    packageItemId: 'bt-speakers',
    title: 'BT Speakers',
    icon: /*#__PURE__*/react_default.a.createElement(whats_bluetooth_speaker_icons_IconSpeaker, null)
  }, {
    packageItemId: 'soundboks-go',
    title: 'Soundboks Go',
    icon: /*#__PURE__*/react_default.a.createElement(icons_IconSoundboksGo, null)
  }, {
    packageItemId: 'pa-systems',
    title: 'PA Systems',
    icon: /*#__PURE__*/react_default.a.createElement(whats_bluetooth_speaker_icons_IconPASystem, null)
  }];
  var attributeData = [{
    text: 'Concert-level Volumne',
    checks: [false, true, true]
  }, {
    text: 'Crowd-ready Durability',
    checks: [false, true, false]
  }, {
    text: 'Bluetooth Connectivity',
    checks: [true, true, false]
  }, {
    text: '6-second Setup',
    checks: [true, true, false]
  }, {
    text: 'Swappable Battery',
    checks: [false, true, false]
  }, {
    text: 'Wirelessly Pairable',
    checks: [true, true, false]
  }, {
    text: 'Microphone & Instrument Inputs',
    checks: [false, false, true]
  }, {
    text: 'App Compatibility',
    checks: [true, true, false]
  }, {
    text: 'Upgradable Features (Via App)',
    checks: [false, true, false]
  }];
  return /*#__PURE__*/react_default.a.createElement(styled_Table, null, /*#__PURE__*/react_default.a.createElement(learn_more_whats_bluetooth_speaker_styled_ImageWrapper, null, /*#__PURE__*/react_default.a.createElement(styled_EmptyCell, null), icons.map(function (image, index) {
    return /*#__PURE__*/react_default.a.createElement("div", {
      key: image.packageItemId + index
    }, image.icon);
  })), /*#__PURE__*/react_default.a.createElement(styled_ImageTextWrapper, null, /*#__PURE__*/react_default.a.createElement(styled_EmptyCell, null), icons.map(function (image, index) {
    return /*#__PURE__*/react_default.a.createElement("div", {
      key: image.title + index,
      style: {
        width: '80px',
        margin: '0 auto'
      }
    }, image.title);
  })), /*#__PURE__*/react_default.a.createElement(HorizontalLine, {
    color: styles_theme["a" /* default */].colors.white
  }), attributeData.map(function (row, index) {
    return /*#__PURE__*/react_default.a.createElement(whats_bluetooth_speaker_attribute_row_AttributeRow, {
      key: row.text + index,
      text: row.text,
      checks: row.checks
    });
  }), /*#__PURE__*/react_default.a.createElement(styled_LastParagraph, null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.learn-more.SBGO.whats-bluetooth-speaker"
  })));
});
// CONCATENATED MODULE: ./public/static/icons/package-items-icons/IconSoundboksGo.tsx
var package_items_icons_IconSoundboksGo_jsx = react_default.a.createElement;


var package_items_icons_IconSoundboksGo_IconSoundboksGo = function IconSoundboksGo() {
  return /*#__PURE__*/react_default.a.createElement("svg", {
    width: "120",
    height: "120",
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react_default.a.createElement("g", {
    clipPath: "url(#clip0_306_867)"
  }, /*#__PURE__*/react_default.a.createElement("path", {
    d: "M94.555 70.68H91.465L89.905 67.97H86.205L84.6451 70.68H82.1351L80.575 67.97H76.8751L75.315 70.68H72.7651L71.205 67.97H67.5051L65.945 70.68H63.435L61.8651 67.97H58.175L56.6151 70.68H54.095L52.535 67.97H48.845L47.275 70.68H44.735L43.175 67.97H39.475L37.915 70.68H35.335L33.775 67.97H30.085L28.525 70.68H25.405L23.555 73.88L25.1151 76.58L23.555 79.29L25.1151 81.99L23.555 84.69L25.1151 87.4L23.555 90.1L25.1151 92.8L23.555 95.5L25.1151 98.21L23.555 100.91L25.1151 103.61L23.555 106.32L25.1151 109.02L23.555 111.72L25.405 114.93H29.105L30.665 112.22H33.205L34.6151 114.68L34.7651 114.93H38.465L40.025 112.22H42.535L44.095 114.93H47.795L47.945 114.66L49.355 112.2H51.8751L53.435 114.91H57.1351L58.695 112.2H61.205L62.7651 114.91H66.465L66.605 114.65L68.0151 112.19H70.535L72.095 114.9H75.795L75.945 114.63L77.355 112.17H79.8751L81.435 114.88H85.1351L86.695 112.17H89.205L90.7651 114.88H94.465L96.315 111.67L94.7551 108.97L96.315 106.27L94.7551 103.56L96.315 100.86L94.7551 98.16L96.315 95.45L94.7551 92.75L96.315 90.05L94.7551 87.35L96.315 84.64L94.7551 81.94L96.315 79.24L94.7551 76.53L96.315 73.83L94.555 70.68ZM65.945 77.08L67.225 79.29L65.945 81.49H63.435L62.155 79.29L63.435 77.08H65.945ZM70.605 74.38L71.8751 76.58L70.605 78.79H68.085L66.815 76.58L68.085 74.38H70.605ZM79.965 74.38L81.2451 76.58L79.965 78.79H77.445L76.175 76.58L77.445 74.38H79.965ZM89.295 74.38L90.575 76.58L89.295 78.79H86.785L85.5151 76.58L86.785 74.38H89.295ZM86.785 105.82L85.5151 103.61L86.785 101.41H89.295L90.575 103.61L89.295 105.82H86.785ZM82.1351 108.52L80.855 106.32L82.1351 104.11H84.6451L85.915 106.32L84.6451 108.52H82.1351ZM77.445 105.82L76.175 103.61L77.445 101.41H79.965L81.2451 103.61L79.965 105.82H77.445ZM72.7651 108.52L71.4951 106.32L72.7651 104.11H75.285L76.555 106.32L75.335 108.56L72.7651 108.52ZM68.085 105.82L66.815 103.61L68.085 101.41H70.605L71.8751 103.61L70.605 105.82H68.085ZM63.435 108.52L62.155 106.32L63.435 104.11H65.945L67.225 106.32L65.945 108.52H63.435ZM58.7551 105.82L57.485 103.61L58.7551 101.41H61.2651L62.535 103.61L61.2651 105.82H58.7551ZM54.095 108.52L52.825 106.32L54.095 104.11H56.6151L57.8851 106.32L56.6151 108.52H54.095ZM49.415 105.82L48.1451 103.61L49.415 101.41H51.935L53.205 103.61L51.935 105.82H49.415ZM44.735 108.52L43.465 106.32L44.735 104.11H47.2551L48.525 106.32L47.2551 108.52H44.735ZM40.065 105.82L38.785 103.61L40.065 101.41H42.575L43.845 103.61L42.575 105.82H40.065ZM35.335 108.56L34.705 107.46L34.065 106.36L34.705 105.25L35.335 104.15H37.8751L39.1451 106.36L37.8751 108.56H35.335ZM30.665 105.86L29.3951 103.65L30.665 101.45H33.205L33.835 102.55L34.475 103.65L33.835 104.75L33.205 105.86H30.665ZM28.965 72.48L29.185 71.72H62.435L61.8951 73.54L61.6351 74.42L61.5051 74.87L61.1351 76.1H27.8951L28.965 72.47V72.48ZM65.905 82.53L67.185 84.73L65.905 86.93H63.3951L62.1151 84.73L63.3951 82.53H65.905ZM70.565 79.83L71.835 82.03L70.565 84.23H68.045L66.775 82.03L68.045 79.83H70.565ZM75.2451 77.12L76.5151 79.33L75.2451 81.53H72.725L71.455 79.33L72.725 77.12H75.2451ZM79.925 79.83L81.205 82.03L79.925 84.23H77.405L76.1351 82.03L77.405 79.83H79.925ZM84.605 77.12L85.8751 79.33L84.605 81.53H82.095L80.815 79.33L82.095 77.12H84.605ZM89.2551 79.83L90.535 82.03L89.2551 84.23H86.7451L85.475 82.03L86.7451 79.83H89.2551ZM86.7451 100.45L85.475 98.25L86.7451 96.04H89.2551L90.535 98.25L89.2551 100.45H86.7451ZM82.095 103.15L80.815 100.95L82.095 98.75H84.605L85.8751 100.95L84.605 103.15H82.095ZM77.405 100.45L76.1351 98.25L77.405 96.04H79.925L81.205 98.25L79.925 100.45H77.405ZM72.725 103.15L71.455 100.95L72.725 98.75H75.2451L76.5151 100.95L75.2451 103.15H72.725ZM68.045 100.45L66.775 98.25L68.045 96.04H70.565L71.835 98.25L70.565 100.45H68.045ZM63.3951 103.15L62.1151 100.95L63.3951 98.75H65.905L67.185 100.95L65.905 103.15H63.3951ZM58.715 100.45L57.445 98.25L58.715 96.04H61.225L62.4951 98.25L61.225 100.45H58.715ZM54.055 103.15L52.785 100.95L54.055 98.75H56.575L57.845 100.95L56.575 103.15H54.055ZM49.3751 100.45L48.105 98.25L49.3751 96.04H51.8951L53.165 98.25L51.8951 100.45H49.3751ZM44.695 103.15L43.425 100.95L44.695 98.75H47.215L48.485 100.95L47.215 103.15H44.695ZM40.025 100.45L38.7451 98.25L40.025 96.04H42.535L43.805 98.25L42.535 100.45H40.025ZM35.335 103.15L34.705 102.05L34.065 100.95L34.705 99.85L35.335 98.75H37.8751L39.1451 100.95L37.8751 103.15H35.335ZM30.665 100.45L29.3951 98.25L30.665 96.04H33.205L33.835 97.15L34.475 98.25L33.835 99.35L33.205 100.45H30.665ZM65.905 87.93L67.185 90.14L65.905 92.34H63.3951L62.1151 90.14L63.3951 87.93H65.905ZM70.565 85.23L71.835 87.44L70.565 89.64H68.045L66.775 87.43L68.045 85.23H70.565ZM75.2451 82.53L76.5151 84.73L75.2451 86.93H72.725L71.455 84.73L72.725 82.53H75.2451ZM79.925 85.23L81.205 87.44L79.925 89.64H77.405L76.1351 87.43L77.405 85.23H79.925ZM84.605 82.53L85.8751 84.73L84.605 86.93H82.095L80.815 84.73L82.095 82.53H84.605ZM82.095 97.75L80.815 95.54L82.095 93.34H84.605L85.8751 95.54L84.605 97.75H82.095ZM77.405 95.04L76.1351 92.84L77.405 90.64H79.925L81.205 92.84L79.925 95.04H77.405ZM72.725 97.75L71.455 95.54L72.725 93.34H75.2451L76.5151 95.54L75.2451 97.75H72.725ZM68.045 95.04L66.775 92.84L68.045 90.64H70.565L71.835 92.84L70.565 95.04H68.045ZM63.3951 97.75L62.1151 95.54L63.3951 93.34H65.905L67.185 95.54L65.905 97.75H63.3951ZM58.715 95.04L57.445 92.84L58.715 90.64H61.225L62.4951 92.84L61.225 95.04H58.715ZM54.055 97.75L52.785 95.54L54.055 93.34H56.575L57.845 95.54L56.575 97.75H54.055ZM49.3751 95.04L48.105 92.84L49.3751 90.64H51.8951L53.165 92.84L51.8951 95.04H49.3751ZM44.695 97.75L43.425 95.54L44.695 93.34H47.215L48.485 95.54L47.215 97.75H44.695ZM40.025 95.04L38.7451 92.84L40.025 90.64H42.535L43.805 92.84L42.535 95.04H40.025ZM35.335 97.75L34.705 96.65L34.065 95.54L34.705 94.44L35.335 93.34H37.8751L39.1451 95.54L37.8751 97.75H35.335ZM37.8751 77.12L39.1451 79.33L37.8751 81.53H35.335L34.705 80.43L34.065 79.33L34.705 78.22L35.335 77.12H37.8751ZM47.215 77.12L48.485 79.33L47.215 81.53H44.695L43.425 79.33L44.695 77.12H47.215ZM56.575 77.12L57.845 79.33L56.575 81.53H54.055L52.785 79.33L54.055 77.12H56.575ZM61.225 79.83L62.4951 82.03L61.225 84.23H58.715L57.445 82.03L58.715 79.83H61.225ZM58.715 89.64L57.445 87.44L58.715 85.23H61.225L62.4951 87.44L61.225 89.64H58.715ZM54.055 92.34L52.785 90.14L54.055 87.93H56.575L57.845 90.14L56.575 92.34H54.055ZM49.3751 89.64L48.105 87.43L49.3751 85.23H51.8951L53.165 87.44L51.8951 89.64H49.3751ZM44.695 92.34L43.425 90.14L44.695 87.93H47.215L48.485 90.14L47.215 92.34H44.695ZM40.025 89.64L38.7451 87.44L40.025 85.23H42.535L43.805 87.44L42.535 89.64H40.025ZM35.335 92.34L34.705 91.24L34.065 90.14L34.705 89.04L35.335 87.93H37.8751L39.1451 90.14L37.8751 92.34H35.335ZM34.065 84.73L34.705 83.63L35.335 82.53H37.8751L39.1451 84.73L37.8751 86.93H35.335L34.705 85.83L34.065 84.73ZM42.535 79.83L43.805 82.03L42.535 84.23H40.025L38.7451 82.03L40.025 79.83H42.535ZM47.215 82.53L48.485 84.73L47.215 86.93H44.695L43.425 84.73L44.695 82.53H47.215ZM51.8951 79.83L53.165 82.03L51.8951 84.23H49.3751L48.105 82.03L49.3751 79.83H51.8951ZM56.575 82.53L57.845 84.73L56.575 86.93H54.055L52.785 84.73L54.055 82.53H56.575ZM51.8951 78.83H49.3751L48.3751 77.12H52.855L51.8951 78.83ZM42.535 78.83H40.025L39.025 77.12H43.5051L42.535 78.83ZM75.2451 87.93L76.5151 90.14L75.2451 92.34H72.725L71.455 90.14L72.725 87.93H75.2451ZM84.605 87.93L85.8751 90.14L84.605 92.34H82.095L80.815 90.14L82.095 87.93H84.605ZM61.225 78.83H58.715L57.715 77.12H61.8651L62.175 76.12L62.475 76.65L61.225 78.83ZM34.225 77.12L33.8751 77.72L33.2451 78.83H30.705L29.705 77.12H34.225ZM33.225 79.83L33.855 80.93L34.4951 82.03L33.855 83.13L33.225 84.23H30.685L29.415 82.03L30.685 79.83H33.225ZM33.225 85.23L33.855 86.33L34.4951 87.44L33.855 88.54L33.225 89.64H30.685L29.415 87.44L30.685 85.23H33.225ZM33.225 90.64L33.855 91.74L34.4951 92.84L33.855 93.94L33.225 95.04H30.685L29.415 92.84L30.685 90.64H33.225ZM86.7651 95.04L85.4951 92.84L86.7651 90.64H89.275L90.555 92.84L89.275 95.04H86.7651ZM86.7651 89.64L85.4951 87.44L86.7651 85.23H89.275L90.555 87.44L89.335 89.56L86.7651 89.64ZM85.8951 73.92L84.6251 76.12H82.1151L80.835 73.92L82.1151 71.72H84.6251L85.8951 73.92ZM76.535 73.92L75.2651 76.12H72.7451L71.475 73.92L72.7451 71.72H75.2651L76.535 73.92ZM29.415 109.06L30.685 106.86H33.225L33.855 107.96L34.4951 109.06L33.855 110.16L33.225 111.26H30.685L29.415 109.06ZM34.085 111.76L34.725 110.66L35.355 109.56H37.8951L39.165 111.76L37.8951 113.97H35.335L34.085 111.76ZM38.7651 109.06L40.045 106.86H42.555L43.825 109.06L42.555 111.26H40.045L38.7651 109.06ZM43.445 111.76L44.715 109.56H47.235L48.5051 111.76L47.235 113.97H44.715L43.445 111.76ZM48.1251 109.06L49.3951 106.86H51.915L53.185 109.06L51.915 111.26H49.3951L48.1251 109.06ZM52.805 111.76L54.075 109.56H56.595L57.8651 111.76L56.595 113.97H54.075L52.805 111.76ZM57.465 109.06L58.735 106.86H61.2451L62.5151 109.06L61.2451 111.26H58.735L57.465 109.06ZM62.1351 111.76L63.415 109.56H65.925L67.205 111.76L65.925 113.97H63.415L62.1351 111.76ZM66.795 109.06L68.065 106.86H70.585L71.855 109.06L70.585 111.26H68.065L66.795 109.06ZM71.475 111.76L72.7451 109.56H75.2651L76.535 111.76L75.2651 113.97H72.7451L71.475 111.76ZM76.155 109.06L77.425 106.86H79.945L81.225 109.06L79.945 111.26H77.425L76.155 109.06ZM80.835 111.76L82.1151 109.56H84.6251L85.8951 111.76L84.6251 113.97H82.1151L80.835 111.76ZM85.4951 109.06L86.7651 106.86H89.275L90.555 109.06L89.275 111.26H86.7651L85.4951 109.06ZM86.7651 69.01H89.305L90.565 71.19L89.275 73.42H86.7651L85.4951 71.21L86.7651 69.01ZM77.425 69.01H79.975L81.235 71.19L79.945 73.42H77.425L76.155 71.22L77.425 69.01ZM68.065 69.01H70.6151L71.8651 71.2L70.585 73.42H68.065L66.795 71.22L68.065 69.01ZM65.925 71.72L67.205 73.92L65.925 76.12H63.415L62.605 74.74L63.4951 71.74L65.925 71.72ZM58.725 69.01H61.275L62.275 70.72H57.7651L58.725 69.01ZM49.3951 69.01H51.945L52.945 70.72H48.435L49.3951 69.01ZM40.035 69.01H42.575L43.575 70.72H39.065L40.035 69.01ZM30.675 69.01H33.225L34.225 70.72H29.715L30.675 69.01ZM24.735 73.92L26.0051 71.72H28.165L26.8751 76.12H26.0051L24.735 73.92ZM24.735 79.33L26.0051 77.12H28.545L29.815 79.33L28.545 81.53H26.0051L24.735 79.33ZM24.735 84.73L26.0051 82.53H28.545L29.815 84.73L28.545 86.93H26.0051L24.735 84.73ZM24.735 90.14L26.0051 87.93H28.545L29.815 90.14L28.545 92.34H26.0051L24.735 90.14ZM24.735 95.54L26.0051 93.34H28.545L29.815 95.54L28.545 97.75H26.0051L24.735 95.54ZM24.735 100.95L26.0051 98.75H28.545L29.815 100.95L28.545 103.15H26.0051L24.735 100.95ZM24.735 106.36L26.0051 104.15H28.545L29.815 106.36L28.545 108.56H26.0051L24.735 106.36ZM24.735 111.76L26.0051 109.56H28.545L29.815 111.76L28.535 113.97H26.0051L24.735 111.76ZM95.235 111.76L93.965 113.97H91.445L90.175 111.76L91.445 109.56H93.965L95.235 111.76ZM95.235 106.36L93.965 108.56H91.445L90.175 106.36L91.445 104.15H93.965L95.235 106.36ZM95.235 100.95L93.965 103.15H91.445L90.175 100.95L91.445 98.75H93.965L95.235 100.95ZM95.235 95.54L93.965 97.75H91.445L90.175 95.54L91.445 93.34H93.965L95.235 95.54ZM95.235 90.14L93.965 92.34H91.445L90.175 90.14L91.445 87.93H93.965L95.235 90.14ZM95.235 84.73L93.965 86.93H91.445L90.175 84.73L91.445 82.53H93.965L95.235 84.73ZM95.235 79.33L93.965 81.53H91.445L90.175 79.33L91.445 77.12H93.965L95.235 79.33ZM93.965 76.12H91.445L90.175 73.92L91.445 71.72H93.965L95.235 73.92L93.965 76.12Z",
    fill: "#212222"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M95.585 62.9H24.415C22.9173 62.9026 21.4818 63.4988 20.4228 64.5578C19.3638 65.6168 18.7677 67.0523 18.7651 68.55V114.35C18.7677 115.848 19.3638 117.283 20.4228 118.342C21.4818 119.401 22.9173 119.997 24.415 120H95.585C97.0835 120 98.5206 119.405 99.5801 118.345C100.64 117.286 101.235 115.848 101.235 114.35V68.56C101.236 67.8172 101.091 67.0814 100.808 66.3948C100.524 65.7081 100.108 65.0841 99.5837 64.5584C99.0589 64.0327 98.4356 63.6156 97.7495 63.331C97.0633 63.0465 96.3278 62.9 95.585 62.9ZM100.235 114.35C100.235 115.583 99.7452 116.766 98.8731 117.638C98.0011 118.51 96.8183 119 95.585 119H24.415C23.1825 118.997 22.0014 118.507 21.1299 117.635C20.2585 116.764 19.7677 115.582 19.7651 114.35V68.56C19.7677 67.3276 20.2585 66.1463 21.1299 65.2749C22.0014 64.4034 23.1825 63.9126 24.415 63.91H95.585C96.8183 63.91 98.0011 64.3999 98.8731 65.272C99.7452 66.144 100.235 67.3267 100.235 68.56V114.35Z",
    fill: "#212222"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M95.405 65.56H24.605C23.751 65.56 22.9321 65.8992 22.3282 66.5031C21.7243 67.107 21.3851 67.926 21.3851 68.78V114.16C21.3851 115.014 21.7243 115.833 22.3282 116.437C22.9321 117.041 23.751 117.38 24.605 117.38H95.405C96.2572 117.377 97.0738 117.037 97.6755 116.433C98.2772 115.83 98.6151 115.012 98.6151 114.16V68.74C98.6046 67.8947 98.262 67.0874 97.6614 66.4924C97.0609 65.8975 96.2504 65.5626 95.405 65.56ZM97.6151 114.2C97.6151 114.787 97.3825 115.35 96.9683 115.766C96.5542 116.182 95.992 116.417 95.405 116.42H24.605C24.0171 116.417 23.4539 116.183 23.0381 115.767C22.6224 115.351 22.3877 114.788 22.3851 114.2V68.74C22.3851 68.1512 22.6189 67.5866 23.0352 67.1702C23.4515 66.7539 24.0163 66.52 24.605 66.52H95.405C95.696 66.52 95.9843 66.5775 96.2531 66.6892C96.5219 66.8009 96.7659 66.9645 96.9713 67.1708C97.1766 67.3771 97.3392 67.6219 97.4496 67.8912C97.5601 68.1605 97.6164 68.4489 97.6151 68.74V114.2Z",
    fill: "#212222"
  })), /*#__PURE__*/react_default.a.createElement("defs", null, /*#__PURE__*/react_default.a.createElement("clipPath", {
    id: "clip0_306_867"
  }, /*#__PURE__*/react_default.a.createElement("rect", {
    width: "82.47",
    height: "57.1",
    fill: "white",
    transform: "translate(18.765 62.9)"
  }))));
};

/* harmony default export */ var package_items_icons_IconSoundboksGo = (package_items_icons_IconSoundboksGo_IconSoundboksGo);
// EXTERNAL MODULE: ./public/static/documents/manuals/soundboks-go.pdf
var soundboks_go = __webpack_require__("8QYT");

// CONCATENATED MODULE: ./public/static/icons/package-items-icons/IconCarrierStrap.tsx
var IconCarrierStrap_jsx = react["createElement"];

/* SVGR has dropped some elements not supported by react-native-svg: style */

var IconCarrierStrap_IconCarrierStrap = function IconCarrierStrap() {
  return /*#__PURE__*/react["createElement"]("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "54.054",
    height: "115.4",
    viewBox: "0 0 54.054 115.4"
  }, /*#__PURE__*/react["createElement"]("g", {
    transform: "translate(-33 -1.5)"
  }, /*#__PURE__*/react["createElement"]("path", {
    d: "M46,45.8a10.261,10.261,0,0,0-1.4-.4,1.086,1.086,0,0,1-.7-1.2l.8-5.2a1.088,1.088,0,0,1,1.1-.9h1.3",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: "1"
  }), /*#__PURE__*/react["createElement"]("path", {
    d: "M56.1,39.5c.6.2,1,.3,1.4.4a1.086,1.086,0,0,1,.7,1.2l-.8,5.2a1.088,1.088,0,0,1-1.1.9H55",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: "1"
  }), /*#__PURE__*/react["createElement"]("path", {
    d: "M48.6,29.1,35.9,107.5a.972.972,0,0,0,1,1.1h7.3a.974.974,0,0,0,1-.8L57.7,30.7",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: "1"
  }), /*#__PURE__*/react["createElement"]("line", {
    x1: "1.5",
    y1: "9.1",
    transform: "translate(71.7 29.1)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: "0.98"
  }), /*#__PURE__*/react["createElement"]("line", {
    x1: "8.7",
    y1: "54.2",
    transform: "translate(74.4 45.9)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: "0.98"
  }), /*#__PURE__*/react["createElement"]("line", {
    x2: "8.7",
    y2: "54.1",
    transform: "translate(65.3 47.3)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: "1"
  }), /*#__PURE__*/react["createElement"]("line", {
    x2: "1.5",
    y2: "8.8",
    transform: "translate(62.6 30.7)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: "0.98"
  }), /*#__PURE__*/react["createElement"]("path", {
    d: "M75.6,39.1a1.088,1.088,0,0,0-1.1-.9,35.844,35.844,0,0,0-5.9.4A37.981,37.981,0,0,0,62.8,40a1.086,1.086,0,0,0-.7,1.2l.8,5.2a1.088,1.088,0,0,0,1.1.9,35.844,35.844,0,0,0,5.9-.4,41.294,41.294,0,0,0,5.8-1.4,1.086,1.086,0,0,0,.7-1.2Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: "1"
  }), /*#__PURE__*/react["createElement"]("path", {
    d: "M74.1,43.8l-9.4,1.4a.548.548,0,0,1-.6-.4l-.4-2.4a.548.548,0,0,1,.4-.6l9.4-1.4a.548.548,0,0,1,.6.4l.4,2.4C74.6,43.5,74.4,43.7,74.1,43.8Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: "0.5"
  }), /*#__PURE__*/react["createElement"]("path", {
    d: "M60.4,27.6a7.039,7.039,0,0,1-7.5,4.1,6.745,6.745,0,0,1-5.6-7.9L52.7,5.9A4.423,4.423,0,0,1,57.1,2h4.8a6.543,6.543,0,0,1,6.2,4.6l5.1,17.1a6.837,6.837,0,0,1-5.6,7.9h0c-2.4.3-9,.2-9-14.3S54.1,3.1,54.1,3.1",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: "1"
  }), /*#__PURE__*/react["createElement"]("path", {
    d: "M36.6,103.3H34.9a1.278,1.278,0,0,0-1.2,1.1l-.2,3.7a2.016,2.016,0,0,0,.3,1.1l.4.5a1.235,1.235,0,0,0,.8.4l8.2,1a.533.533,0,0,1,.5.7l-.2,1.5a.56.56,0,0,1-.6.5L38,114a.993.993,0,0,1-1-.7l-.4-1.2H33.9l.6,3.2a1.5,1.5,0,0,0,1.5,1.1l8.4-.2A1.712,1.712,0,0,0,46,115l1.6-5.4a6.723,6.723,0,0,0,.4-2.4v-2.9a1,1,0,0,0-1-1H45.8",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: "1"
  }), /*#__PURE__*/react["createElement"]("path", {
    d: "M86.5,103.2l-.5-2.8a.968.968,0,0,0-1.2-.8l-12,2.1a1.3,1.3,0,0,0-1,1.3l.4,3.6a1.389,1.389,0,0,0,.5,1l.4.4a1.136,1.136,0,0,0,.8.3l8.2-.4a.669.669,0,0,1,.7.6V110a.56.56,0,0,1-.5.6l-4.8,1a1.074,1.074,0,0,1-1.2-.6l-.6-1.1-2.6.5,1.2,3a1.484,1.484,0,0,0,1.7.8l8.2-1.6a1.7,1.7,0,0,0,1.4-1.4l.6-5.6A3.929,3.929,0,0,0,86.5,103.2Zm-2.6.8a1.243,1.243,0,0,1-1.1,1.1l-7.4,1.1a.6.6,0,0,1-.4-.1l-.2-.2a.764.764,0,0,1-.2-.5l-.2-1.7a.675.675,0,0,1,.4-.6l8.3-1.4a.548.548,0,0,1,.6.4A9.205,9.205,0,0,1,83.9,104Z",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: "10",
    strokeWidth: "1"
  })));
};

/* harmony default export */ var package_items_icons_IconCarrierStrap = (IconCarrierStrap_IconCarrierStrap);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-go/learn-more/content.tsx
var learn_more_content_jsx = react_default.a.createElement;




 // import IconCarrierStrap from 'public/static/icons/package-items-icons/IconCarrierStrap';






var learn_more_content_packageItems = [{
  packageItemId: 'soundboks-go',
  title: 'Soundboks Go',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconSoundboksGo, null)
}, {
  packageItemId: 'carrier-strap',
  title: 'Carrier Strap',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconCarrierStrap, null)
}, {
  packageItemId: 'tripod',
  title: 'Tripod',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconTripod, null)
}, {
  packageItemId: 'tripod-backpack',
  title: 'Tripod Backpack',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconTripodBackpack, null)
}, {
  packageItemId: 'powerbank',
  title: 'Powerbank',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconPowerbank, null)
}, {
  packageItemId: 'batteryboks',
  title: 'Batteryboks',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconBattery, null)
}, {
  packageItemId: 'charger',
  title: 'Charger',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconCharger, null)
}, {
  packageItemId: 'soundboks-gen-3-manual',
  title: 'Manual',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconManual, null),
  downloadUrl: soundboks_go["default"]
}];
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-go/learn-more/tech-spec/styled.ts

var styled_DescList = styled_components_browser_esm["default"].dl.withConfig({
  displayName: "styled__DescList",
  componentId: "ve3bnw-0"
})(["margin:20px 0 0 0;"]);
var styled_DescTitle = styled_components_browser_esm["default"].dt.withConfig({
  displayName: "styled__DescTitle",
  componentId: "ve3bnw-1"
})(["margin:0;"]);
var styled_DescDetails = styled_components_browser_esm["default"].dd.withConfig({
  displayName: "styled__DescDetails",
  componentId: "ve3bnw-2"
})(["margin:0;"]);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-go/learn-more/tech-spec/index.web.tsx
var learn_more_tech_spec_index_web_jsx = react_default.a.createElement;





 // eslint-disable-next-line prefer-arrow-callback

var tech_spec_index_web_TechSpec = /*#__PURE__*/react_default.a.memo(function TechSpec() {
  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, null, /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.sound"
  })), /*#__PURE__*/react_default.a.createElement(styled_DescList, null, /*#__PURE__*/react_default.a.createElement(styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.sound.amplifier"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.sound.amplifier.1"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.sound.amplifier.2"
  })))), /*#__PURE__*/react_default.a.createElement(styled_DescList, null, /*#__PURE__*/react_default.a.createElement(styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.sound.driver-units"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.sound.driver-units.1"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.sound.driver-units.2"
  })))), /*#__PURE__*/react_default.a.createElement(styled_DescList, null, /*#__PURE__*/react_default.a.createElement(styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.sound.audio"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.sound.audio.1"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.sound.audio.2"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.sound.audio.3"
  })))), /*#__PURE__*/react_default.a.createElement(styled_DescList, null, /*#__PURE__*/react_default.a.createElement(styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.sound.connectivity"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.sound.connectivity.1"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.sound.connectivity.2"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.sound.connectivity.3"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.sound.connectivity.4"
  })))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.build"
  })), /*#__PURE__*/react_default.a.createElement(styled_DescList, null, /*#__PURE__*/react_default.a.createElement(styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.build.weight"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.build.weight.1"
  })))), /*#__PURE__*/react_default.a.createElement(styled_DescList, null, /*#__PURE__*/react_default.a.createElement(styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.build.dimensions"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.build.dimensions.1"
  })))), /*#__PURE__*/react_default.a.createElement(styled_DescList, null, /*#__PURE__*/react_default.a.createElement(styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.build.materials"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.build.materials.1"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.build.materials.2"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.build.materials.3"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.build.materials.4"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.build.materials.5"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.build.materials.6"
  })))), /*#__PURE__*/react_default.a.createElement(styled_DescList, null, /*#__PURE__*/react_default.a.createElement(styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.build.feature"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.build.feature.1"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.build.feature.2"
  })))), /*#__PURE__*/react_default.a.createElement(styled_DescList, null, /*#__PURE__*/react_default.a.createElement(styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.build.ui-panel"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.build.ui-panel.1"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.build.ui-panel.2"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.build.ui-panel.3"
  })))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.battery"
  })), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.battery.1"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescList, null, /*#__PURE__*/react_default.a.createElement(styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.battery.life"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.battery.life.1"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.battery.life.2"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.battery.life.3"
  })))), /*#__PURE__*/react_default.a.createElement(styled_DescList, null, /*#__PURE__*/react_default.a.createElement(styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.battery.cell-type"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.battery.cell-type.1"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.battery.cell-type.2"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.battery.cell-type.3"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.battery.cell-type.4"
  })))), /*#__PURE__*/react_default.a.createElement(styled_DescList, null, /*#__PURE__*/react_default.a.createElement(styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.battery.design"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.battery.design.1"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.battery.design.2"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.battery.design.3"
  })))), /*#__PURE__*/react_default.a.createElement(styled_DescList, null, /*#__PURE__*/react_default.a.createElement(styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.battery.management"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.battery.management.1"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.battery.management.2"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.battery.management.3"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.battery.management.4"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.battery.management.5"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.battery.management.6"
  })))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.app"
  })), /*#__PURE__*/react_default.a.createElement(styled_DescList, null, /*#__PURE__*/react_default.a.createElement(styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.app.soundSettings"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.app.soundSettings.1"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.app.soundSettings.2"
  })))), /*#__PURE__*/react_default.a.createElement(styled_DescList, null, /*#__PURE__*/react_default.a.createElement(styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.app.advanced-controls"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.app.advanced-controls.1"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.app.advanced-controls.2"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.app.advanced-controls.3"
  })))), /*#__PURE__*/react_default.a.createElement(styled_DescList, null, /*#__PURE__*/react_default.a.createElement(styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.app.wirelessSettings"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.app.wirelessSettings.1"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.app.wirelessSettings.2"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.app.wirelessSettings.3"
  })))), /*#__PURE__*/react_default.a.createElement(styled_DescList, null, /*#__PURE__*/react_default.a.createElement(styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.app.firmwareUpdate"
  }))), /*#__PURE__*/react_default.a.createElement(styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "sbgo.tech-specs.app.firmwareUpdate.1"
  })))));
});
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-go/learn-more/faqs/index.web.tsx
var learn_more_faqs_index_web_jsx = react_default.a.createElement;





// eslint-disable-next-line prefer-arrow-callback
var faqs_index_web_FAQs = /*#__PURE__*/react_default.a.memo(function FAQs() {
  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    padding: {
      right: 10
    }
  }, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.learn-more.SBGO.faqs.question-1"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.learn-more.SBGO.faqs.answer-1"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.learn-more.SBGO.faqs.question-2"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.learn-more.SBGO.faqs.answer-2"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.learn-more.SBGO.faqs.question-3"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.learn-more.SBGO.faqs.answer-3"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.learn-more.SBGO.faqs.question-4"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.learn-more.SBGO.faqs.answer-4"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.learn-more.SBGO.faqs.question-5"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.learn-more.SBGO.faqs.answer-5"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.learn-more.SBGO.faqs.question-6"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.learn-more.SBGO.faqs.answer-6"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.learn-more.SBGO.faqs.question-7"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.learn-more.SBGO.faqs.answer-7"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.learn-more.SBGO.faqs.question-8"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.learn-more.SBGO.faqs.answer-8"
  }));
});
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-go/learn-more/index.tsx
var soundboks_go_learn_more_jsx = react_default.a.createElement;



















var soundboks_go_learn_more_LearnMoreSection = function LearnMoreSection(_ref) {
  var selectedMerch = _ref.selectedMerch,
      locale = _ref.locale;

  var _useSelector = Object(es["d" /* useSelector */])(function (state) {
    return state.settings;
  }),
      regionId = _useSelector.regionId;

  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(soundboks_go_learn_more_LayoutContainer, null, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(elements_typography["e" /* Heading02 */], {
      ariaLevel: elements_typography["h" /* TextLevel */].H2,
      style: {
        textTransform: 'uppercase',
        textAlign: 'center'
      }
    }, i18n._('product.learn-more.heading')), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "35px"
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.whats-in-the-box",
      content: /*#__PURE__*/react_default.a.createElement(whats_in_the_box_index_web_WhatsInTheBox, {
        selectedMerch: selectedMerch,
        packageItems: learn_more_content_packageItems
      }),
      topItem: true
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.tech-specs",
      content: /*#__PURE__*/react_default.a.createElement(tech_spec_index_web_TechSpec, null)
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.whats-a-bluetooth-performance-speaker",
      content: /*#__PURE__*/react_default.a.createElement(whats_bluetooth_speaker_index_web_WhatsBluetoothSpeaker, null)
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.shipping",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: learn_more_content_content.shipping[regionId] || learn_more_content_content.shipping["default"],
        components: [/*#__PURE__*/react_default.a.createElement(Link["a" /* default */], {
          href: helpCenter_getHelpCenterUrl(locale, '/sections/360003609413-SHIPPING')
        }), /*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement("br", null)]
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.warranty",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "product.learn-more.SBGO.warranty.info",
        components: [/*#__PURE__*/react_default.a.createElement(StyledLink, {
          href: helpCenter_getHelpCenterUrl(locale, '/articles/211920329-RETURN-AND-REFUND-POLICY-AND-PROCESS')
        })]
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.payment-options",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "product.learn-more.SBGO.payment-options.info"
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.faqs",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(faqs_index_web_FAQs, null))
    })));
  });
};

var soundboks_go_learn_more_LayoutContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "learn-more__LayoutContainer",
  componentId: "sc-4wukdb-0"
})(["max-width:1062px;width:100%;@media ", "{padding:0 24px;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
/* harmony default export */ var soundboks_go_learn_more = (soundboks_go_learn_more_LearnMoreSection);
// EXTERNAL MODULE: ./public/static/partnerLogos/hypebeast.png
var hypebeast = __webpack_require__("k/jh");
var hypebeast_default = /*#__PURE__*/__webpack_require__.n(hypebeast);

// EXTERNAL MODULE: ./public/static/partnerLogos/digital-DJ-tips.png
var digital_DJ_tips = __webpack_require__("uLo+");
var digital_DJ_tips_default = /*#__PURE__*/__webpack_require__.n(digital_DJ_tips);

// EXTERNAL MODULE: ./public/static/partnerLogos/play_experience.webp
var play_experience = __webpack_require__("NSeO");
var play_experience_default = /*#__PURE__*/__webpack_require__.n(play_experience);

// EXTERNAL MODULE: ./public/static/partnerLogos/games-mag.png
var games_mag = __webpack_require__("Q3bz");
var games_mag_default = /*#__PURE__*/__webpack_require__.n(games_mag);

// EXTERNAL MODULE: ./public/static/partnerLogos/m1m-tech-channel.png
var m1m_tech_channel = __webpack_require__("37+v");
var m1m_tech_channel_default = /*#__PURE__*/__webpack_require__.n(m1m_tech_channel);

// EXTERNAL MODULE: ./public/static/partnerLogos/9to5Mac.png
var _9to5Mac = __webpack_require__("AHcM");
var _9to5Mac_default = /*#__PURE__*/__webpack_require__.n(_9to5Mac);

// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-go/product-review/config/reviews.js








var config_reviews_reviews = {}; // SOUNDBOKS GO Reviews
// English

config_reviews_reviews.digitalDJTips_1 = {
  logo: digital_DJ_tips_default.a.url,
  text: 'If you’ve got an RV, a car, a camper—and you want [to bring] a speaker that’s one-up from a regular Bluetooth speaker—the SOUNDBOKS Go is definitely it.'
};
config_reviews_reviews.digitalDJTips_2 = {
  logo: digital_DJ_tips_default.a.url,
  text: 'It goes loud—it goes very loud.'
};
config_reviews_reviews.digitalDJTips_3 = {
  logo: digital_DJ_tips_default.a.url,
  text: '10 hours of battery life on full volume—and we tested that.'
};
config_reviews_reviews.digitalDJTips_4 = {
  logo: digital_DJ_tips_default.a.url,
  text: 'It’s got that combination of being able to connect wirelessly to other speakers, the ability to Bluetooth and the ability to plug in—plus the sound quality. It’s loud and it has that big punch to it…'
};
config_reviews_reviews.hypeBeast_1 = {
  logo: hypebeast_default.a.url,
  text: 'The SOUNDBOKS Go is a wireless Bluetooth speaker offering superior portability and performance…'
};
config_reviews_reviews.hypeBeast_2 = {
  logo: hypebeast_default.a.url,
  text: 'The SOUNDBOKS Go refines technical aspects of its predecessors by enhancing the sound quality, portability and battery life…'
};
config_reviews_reviews.engadget_1 = {
  logo: engadget_black_default.a.url,
  text: 'It continues to offer the incredible battery life and connectivity synonymous with the brand…'
};
config_reviews_reviews.engadget_2 = {
  logo: engadget_black_default.a.url,
  text: 'Dust tight and resistant to powerful jets of water…'
};
config_reviews_reviews.engadget_3 = {
  logo: engadget_black_default.a.url,
  text: 'Half the size of the SOUNDBOKS Gen 3 and nearly half the price—it still has a thumping bass output, clear, long-throw mids and highs and wireless TeamUP expansion.'
};
config_reviews_reviews.NineToFiveMac = {
  logo: _9to5Mac_default.a.url,
  text: 'Bass. Lots and lots of bass. And battery life. Lots and lots of battery life.'
}; // German

config_reviews_reviews.playExperience_1 = {
  logo: play_experience_default.a.url,
  text: 'Eine klare Kaufempfehlung'
};
config_reviews_reviews.playExperience_2 = {
  logo: play_experience_default.a.url,
  text: 'Eine klare Kaufempfehlung! ; Zum Party machen ideal ; Der kleine Bruder lässt es ganz schön rappeln'
};
config_reviews_reviews.M1MTechChannel = {
  logo: m1m_tech_channel_default.a.url,
  text: 'Die SOUNDBOKS Go ist eine tolle Erweiterung des SOUNDBOKS Line-Ups und hat meiner Meinung nach Potenzial für eine Platzierung bei den beste Outdoor Speakern 2022.'
};
config_reviews_reviews.chip_1 = {
  logo: chip_black_default.a.url,
  text: 'Ein kleines Klangwunder'
};
config_reviews_reviews.chip_2 = {
  logo: chip_black_default.a.url,
  text: 'Kleiner Speaker mit ordentlich Wumms'
};
config_reviews_reviews.chip_3 = {
  logo: chip_black_default.a.url,
  text: 'Doppelt so lange Akkulaufzeit bei voller Lautstärke'
};
config_reviews_reviews.gamesMag = {
  logo: games_mag_default.a.url,
  text: 'Großer Sound in kleiner Boks ; Klangqualität auf Konzertniveau ;'
};
/* harmony default export */ var product_review_config_reviews = (config_reviews_reviews);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-go/product-review/config/regionalReviews.js

var regionalReviews_regionalReviews = {
  XX: [product_review_config_reviews.digitalDJTips_1, product_review_config_reviews.digitalDJTips_2, product_review_config_reviews.digitalDJTips_3, product_review_config_reviews.digitalDJTips_4, product_review_config_reviews.hypeBeast_1, product_review_config_reviews.hypeBeast_2, product_review_config_reviews.engadget_1, product_review_config_reviews.engadget_2, product_review_config_reviews.engadget_3, product_review_config_reviews.NineToFiveMac],
  DE: [product_review_config_reviews.playExperience_1, product_review_config_reviews.playExperience_2, product_review_config_reviews.chip_1, product_review_config_reviews.chip_2, product_review_config_reviews.chip_3, product_review_config_reviews.M1MTechChannel, product_review_config_reviews.gamesMag]
};
/* harmony default export */ var product_review_config_regionalReviews = (regionalReviews_regionalReviews);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-go/product-review/styled.tsx


var product_review_styled_StyledHorizontalLine = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__StyledHorizontalLine",
  componentId: "sc-11q37ur-0"
})(["display:none;@media ", "{display:block;padding:0px 24px;}"], styles_theme["a" /* default */].breakpoints.maxMobile);
var product_review_styled_LayoutContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__LayoutContainer",
  componentId: "sc-11q37ur-1"
})(["position:relative;width:100%;max-width:1024px;text-align:center;align-self:center;@media ", "{max-width:720px;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-go/product-review/index.tsx
var soundboks_go_product_review_jsx = react_default.a.createElement;














var videoList = {
  de: [{
    YouTubeId: 'yt-gcwInit0',
    children: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "Soundboks Go: Testbericht nach 14 Tagen")
  }, {
    YouTubeId: 'jiA6Utj5h-s',
    children: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "SOUNDBOKS Go vs SOUNDBOKS 3 \u26A0\uFE0F Es wird wieder laut!")
  }, {
    YouTubeId: 'S7Be-CuI6Tc',
    children: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "SoundBoks Go erster Eindruck und Soundcheck")
  }],
  xx: [{
    YouTubeId: 'JM5izq3u_iM',
    children: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "Soundboks Go Vs JBL Partybox 110 Vs Sony XP500")
  }, {
    YouTubeId: 'fn3doSryJV8',
    children: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "Soundboks Go Review - For Outdoor Use Only")
  }, {
    YouTubeId: '0IARLVjhvR0',
    children: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "SOUNDBOKS Go: Unboxing, Einrichten und erster Eindruck")
  }]
};

var soundboks_go_product_review_ProductReviewSection = function ProductReviewSection() {
  var _useCheckRegion = Object(useCheckRegion["a" /* default */])(),
      isDE = _useCheckRegion.isDE;

  var _useSelector = Object(es["d" /* useSelector */])(function (state) {
    return state.settings;
  }),
      countryId = _useSelector.countryId;

  var reviews = product_review_config_regionalReviews[countryId] || product_review_config_regionalReviews.XX;
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref) {
    var i18n = _ref.i18n;
    return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(product_review_styled_LayoutContainer, null, /*#__PURE__*/react_default.a.createElement(elements_typography["e" /* Heading02 */], {
      ariaLevel: elements_typography["h" /* TextLevel */].H2,
      color: elements_theme["a" /* Color */].Orange,
      style: {
        textTransform: 'uppercase'
      }
    }, i18n._('product.reviews.heading')), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "20px"
    }), /*#__PURE__*/react_default.a.createElement(ProductReview, {
      reviews: reviews,
      colorForeground: elements_theme["a" /* Color */].Charcoal
    })), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    }), /*#__PURE__*/react_default.a.createElement(product_review_styled_StyledHorizontalLine, null, /*#__PURE__*/react_default.a.createElement(HorizontalLine, {
      color: elements_theme["a" /* Color */].WhiteOff
    }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    })), /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(index_web_VideoFeature, {
      videos: isDE ? videoList.de : videoList.xx,
      height: "184px"
    })), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    }), /*#__PURE__*/react_default.a.createElement(product_review_styled_StyledHorizontalLine, null, /*#__PURE__*/react_default.a.createElement(HorizontalLine, {
      color: elements_theme["a" /* Color */].WhiteOff
    }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    })), /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(Trustbox, null)));
  });
};

/* harmony default export */ var soundboks_go_product_review = (soundboks_go_product_review_ProductReviewSection);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-go/image-collage/styled.ts


var styled_ContainerProductFeature = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__ContainerProductFeature",
  componentId: "sc-1uld8gt-0"
})(["display:grid;grid-template-columns:1fr 1fr;max-width:1064px;margin:auto;grid-gap:14px;@media ", "{grid-gap:5px;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
var styled_ContainerImage1 = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__ContainerImage1",
  componentId: "sc-1uld8gt-1"
})(["width:100%;grid-column:1 / span 1;grid-row:1 / span 2;"]);
var styled_ContainerImage2 = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__ContainerImage2",
  componentId: "sc-1uld8gt-2"
})(["width:100%;grid-column:2 / span 1;grid-row:1 / span 1;"]);
var styled_ContainerImage3 = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__ContainerImage3",
  componentId: "sc-1uld8gt-3"
})(["width:100%;grid-column:2 / span 1;grid-row:2 / span 1;"]);
var styled_ContainerImage4 = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__ContainerImage4",
  componentId: "sc-1uld8gt-4"
})(["width:100%;grid-column:1 / span 2;grid-row:3 / span 1;"]);
// EXTERNAL MODULE: ./components/pages/products-v2/speakers/soundboks-go/assets/SBGO_lifestyle_2_small.png
var SBGO_lifestyle_2_small = __webpack_require__("JxcM");
var SBGO_lifestyle_2_small_default = /*#__PURE__*/__webpack_require__.n(SBGO_lifestyle_2_small);

// EXTERNAL MODULE: ./components/pages/products-v2/speakers/soundboks-go/assets/SBGO_lifestyle_2_large.png
var SBGO_lifestyle_2_large = __webpack_require__("Mefb");
var SBGO_lifestyle_2_large_default = /*#__PURE__*/__webpack_require__.n(SBGO_lifestyle_2_large);

// EXTERNAL MODULE: ./components/pages/products-v2/speakers/soundboks-go/assets/SBGO_lifestyle_3_small.png
var SBGO_lifestyle_3_small = __webpack_require__("Tdr2");
var SBGO_lifestyle_3_small_default = /*#__PURE__*/__webpack_require__.n(SBGO_lifestyle_3_small);

// EXTERNAL MODULE: ./components/pages/products-v2/speakers/soundboks-go/assets/SBGO_lifestyle_3_large.png
var SBGO_lifestyle_3_large = __webpack_require__("p1gb");
var SBGO_lifestyle_3_large_default = /*#__PURE__*/__webpack_require__.n(SBGO_lifestyle_3_large);

// EXTERNAL MODULE: ./components/pages/products-v2/speakers/soundboks-go/assets/SBGO_lifestyle_4_small.png
var SBGO_lifestyle_4_small = __webpack_require__("RJ4o");
var SBGO_lifestyle_4_small_default = /*#__PURE__*/__webpack_require__.n(SBGO_lifestyle_4_small);

// EXTERNAL MODULE: ./components/pages/products-v2/speakers/soundboks-go/assets/SBGO_lifestyle_4_large.png
var SBGO_lifestyle_4_large = __webpack_require__("wEU9");
var SBGO_lifestyle_4_large_default = /*#__PURE__*/__webpack_require__.n(SBGO_lifestyle_4_large);

// EXTERNAL MODULE: ./components/pages/products-v2/speakers/soundboks-go/assets/SBGO_lifestyle_5_small.png
var SBGO_lifestyle_5_small = __webpack_require__("VgIB");
var SBGO_lifestyle_5_small_default = /*#__PURE__*/__webpack_require__.n(SBGO_lifestyle_5_small);

// EXTERNAL MODULE: ./components/pages/products-v2/speakers/soundboks-go/assets/SBGO_lifestyle_5_large.png
var SBGO_lifestyle_5_large = __webpack_require__("x78r");
var SBGO_lifestyle_5_large_default = /*#__PURE__*/__webpack_require__.n(SBGO_lifestyle_5_large);

// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-go/image-collage/index.tsx
var soundboks_go_image_collage_jsx = react_default.a.createElement;












var soundboks_go_image_collage_ProductFeatureSection = function ProductFeatureSection() {
  return /*#__PURE__*/react_default.a.createElement(styled_ContainerProductFeature, null, /*#__PURE__*/react_default.a.createElement(styled_ContainerImage1, null, /*#__PURE__*/react_default.a.createElement(elements_image["a" /* Image */], {
    uri: Object(elements_image["b" /* imgIxUrlFormatter */])(SBGO_lifestyle_2_large_default.a.url),
    ranges: {
      phone: Object(elements_image["b" /* imgIxUrlFormatter */])(SBGO_lifestyle_2_small_default.a.url),
      desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(SBGO_lifestyle_2_large_default.a.url)
    }
  })), /*#__PURE__*/react_default.a.createElement(styled_ContainerImage2, null, /*#__PURE__*/react_default.a.createElement(elements_image["a" /* Image */], {
    uri: Object(elements_image["b" /* imgIxUrlFormatter */])(SBGO_lifestyle_3_large_default.a.url),
    ranges: {
      phone: Object(elements_image["b" /* imgIxUrlFormatter */])(SBGO_lifestyle_3_small_default.a.url),
      desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(SBGO_lifestyle_3_large_default.a.url)
    }
  })), /*#__PURE__*/react_default.a.createElement(styled_ContainerImage3, null, /*#__PURE__*/react_default.a.createElement(elements_image["a" /* Image */], {
    uri: Object(elements_image["b" /* imgIxUrlFormatter */])(SBGO_lifestyle_4_large_default.a.url),
    ranges: {
      phone: Object(elements_image["b" /* imgIxUrlFormatter */])(SBGO_lifestyle_4_small_default.a.url),
      desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(SBGO_lifestyle_4_large_default.a.url)
    }
  })), /*#__PURE__*/react_default.a.createElement(styled_ContainerImage4, null, /*#__PURE__*/react_default.a.createElement(elements_image["a" /* Image */], {
    uri: Object(elements_image["b" /* imgIxUrlFormatter */])(SBGO_lifestyle_5_large_default.a.url),
    ranges: {
      phone: Object(elements_image["b" /* imgIxUrlFormatter */])(SBGO_lifestyle_5_small_default.a.url),
      desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(SBGO_lifestyle_5_large_default.a.url)
    }
  })));
};

/* harmony default export */ var soundboks_go_image_collage = (soundboks_go_image_collage_ProductFeatureSection);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-go/related-products/index.tsx
var soundboks_go_related_products_jsx = react_default.a.createElement;






var soundboks_go_related_products_RelatedProductsSection = function RelatedProductsSection(_ref) {
  var relatedProducts = _ref.relatedProducts;
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      grow: 1
    }, /*#__PURE__*/react_default.a.createElement(RelatedProducts, {
      relatedProducts: relatedProducts,
      headline: i18n._('product.related-products.heading')
    })));
  });
};

/* harmony default export */ var soundboks_go_related_products = (soundboks_go_related_products_RelatedProductsSection);
// CONCATENATED MODULE: ./components/pages/products-v2/speakers/soundboks-go/index.tsx
var soundboks_go_jsx = react_default.a.createElement;




















var soundboks_go_options = {
  merch: 'Accessories',
  batteries: 'Batteries',
  carrierStrap: 'Strap'
};
var soundboks_go_paths = [{
  label: 'Home',
  url: '/'
}, {
  label: 'Speakers',
  url: '/products/?filter=speakers'
}, {
  label: 'Soundboks Go'
}];
var soundboks_go_klarnaData = {
  de: {
    klarnaLocale: 'de-DE',
    klarnaClassName: 'klarna-pricetag-de'
  },
  no: {
    klarnaLocale: 'no-NO',
    klarnaClassName: 'klarna-pricetag-no'
  },
  da: {
    klarnaLocale: 'da-DK',
    klarnaClassName: 'klarna-pricetag-dk'
  }
}; // const colorOptions = [
//   { id: 'Black', label: 'Black', value: '#000000' },
//   { id: 'Orange', label: 'Orange', value: '#FA4616' },
//   { id: 'White', label: 'White', value: '#FFFFFF' },
//   { id: 'Blue', label: 'Blue', value: '#19415E' },
//   { id: 'Red', label: 'Red', value: '#AA273B' },
// ];
// const batteriOptions = {
//   onePack: '1x BATTERYBOKS',
//   twoPack: '2x BATTERYBOKS',
// };
// const carrierStrapOptions = {
//   withStrap: 'Incl. Strap',
//   withoutStrap: 'Excl. Strap',
// };

var soundboks_go_merchOptions = [{
  id: 'Strap',
  label: 'Strap'
}, {
  id: 'Tripod',
  label: 'Tripod'
}, {
  id: 'Powerbank',
  label: 'Powerbank'
}, {
  id: 'None',
  label: 'None'
}];

var soundboks_go_SoundboksGo = function SoundboksGo(_ref) {
  var productData = _ref.productData,
      dispatchAddCartItem = _ref.dispatchAddCartItem;

  var _useSelector = Object(es["d" /* useSelector */])(function (state) {
    return state;
  }),
      settings = _useSelector.settings;

  var regionId = settings.regionId,
      languageId = settings.languageId;
  var overview = Object(react["useRef"])(null);
  var feature = Object(react["useRef"])(null);
  var learnMore = Object(react["useRef"])(null);
  var reviews = Object(react["useRef"])(null);
  var relatedProducts = Object(react["useRef"])(null);

  var _useState = Object(react["useState"])(),
      anchorStack = _useState[0],
      setAnchorStack = _useState[1];

  var _useState2 = Object(react["useState"])(),
      selectedAnchor = _useState2[0],
      setSelectedAnchor = _useState2[1];

  var _useState3 = Object(react["useState"])(false),
      isHeaderVisibility = _useState3[0],
      setIsHeaderVisibility = _useState3[1];

  var _useState4 = Object(react["useState"])(),
      selectedMerch = _useState4[0],
      setSelectedMerch = _useState4[1];

  var _useState5 = Object(react["useState"])(),
      availableMerch = _useState5[0],
      setAvailableMerch = _useState5[1];

  var _useState6 = Object(react["useState"])(),
      productVariant = _useState6[0],
      setProductVariant = _useState6[1]; // const [extraBattery, setExtraBattery] = useState<boolean>();
  // const [carrierStrap, setCarrierStrap] = useState<boolean>();
  // const [disableExtraBattery, setDisableExtraBattery] = useState<boolean>();


  var productCategories = Object(mergeUACategories["a" /* default */])(abstractProducts_default.a.byId[productData.handle].categories);

  var _useState7 = Object(react["useState"])(true),
      allowImageInteractionTracking = _useState7[0],
      setAllowImageInteractionTracking = _useState7[1];

  var _useState8 = Object(react["useState"])(0),
      trackImageInteractionLimit = _useState8[0],
      setTrackImageInteractionLimit = _useState8[1];

  var router = Object(next_router["useRouter"])();
  var offset = 124;
  Object(react["useEffect"])(function () {
    var initialStack = [{
      label: 'products.subnavigation.achor.overview',
      ref: overview
    }, {
      label: 'products.subnavigation.achor.feature',
      ref: feature
    }, {
      label: 'products.subnavigation.achor.learn-more',
      ref: learnMore
    }, {
      label: 'products.subnavigation.achor.reviews',
      ref: reviews
    }, {
      label: 'products.subnavigation.achor.related-products',
      ref: relatedProducts
    }];
    setAnchorStack(initialStack);

    var handleScroll = function handleScroll() {
      var stackIndex = initialStack.findIndex(function (stack) {
        return stack.ref.current.getBoundingClientRect().y - offset > 0;
      });
      var stack = stackIndex === -1 ? initialStack[initialStack.length - 1] : initialStack[stackIndex - 1];
      setSelectedAnchor(stack.ref.current);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return function () {
      return window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  var handleHeaderVisibility = function handleHeaderVisibility(isVisibility) {
    setIsHeaderVisibility(isVisibility);
  };

  Object(react["useEffect"])(function () {
    var defaultOption = productData.variants.find(function (variant) {
      return variant.sku === productData.defaultSku;
    }); // const optionsFromUrlQueries = productData.variants.find(
    //   (variant) => variant.options[options.carrierStrap] === router.query[options.carrierStrap],
    // );

    var optionsFromUrlQueries = productData.variants.find(function (variant) {
      return variant.options[soundboks_go_options.merch] === router.query[soundboks_go_options.merch];
    });
    var defaultVariant = optionsFromUrlQueries || defaultOption;
    setSelectedMerch(defaultVariant === null || defaultVariant === void 0 ? void 0 : defaultVariant.options[soundboks_go_options.merch]);
    var variantMerch = productData.variants.map(function (variant) {
      return variant.options[soundboks_go_options.merch];
    });
    var merch = soundboks_go_merchOptions.filter(function (_ref2) {
      var id = _ref2.id;
      return variantMerch.includes(id);
    });
    setAvailableMerch(merch); // setExtraBattery(defaultVariant?.options[options.batteries] === batteriOptions.twoPack);
    // setCarrierStrap(
    //   defaultVariant?.options[options.carrierStrap] === carrierStrapOptions.withStrap,
    // );
    // Does this variant exist with opposite selected battery?
    // const reverseBatteryOption = defaultVariant?.options[options.batteries] === batteriOptions.onePack
    //   ? batteriOptions.twoPack
    //   : batteriOptions.onePack;
    // const reverseBatteryChoice = productData.variants.some(
    //   (variant) =>
    //     variant.options[options.grillColor] === defaultVariant?.options[options.grillColor]
    //     && variant.options[options.batteries] === reverseBatteryOption,
    // );
    // setDisableExtraBattery(!reverseBatteryChoice);

    setProductVariant(defaultVariant);
  }, [productData, router.query]); // const handleBatterySelector = (selected: boolean) => {
  //   const variants = productData.variants.filter(
  //     (variant) =>
  //       variant.options[options.batteries]
  //       === (selected ? batteriOptions.twoPack : batteriOptions.onePack),
  //   );
  //   const colors = variants.map((variant) => variant.options[options.grillColor]);
  //   setAvalibleColors((prev) =>
  //     prev.map((color) =>
  //       (colors.includes(color.id) ? { ...color, disabled: false } : { ...color, disabled: true })));
  //   setExtraBattery(selected);
  //   const trackBattery = selected ? batteriOptions.twoPack : batteriOptions.onePack;
  //   trackVariantInteraction(trackBattery);
  //   setAllowImageInteractionTracking(true);
  //   setTrackImageInteractionLimit(0);
  //   const nextVariant = variants.find(
  //     (variant) => variant.options[options.grillColor] === selectedColor,
  //   );
  //   setProductVariant(nextVariant);
  // };

  var refreshData = function refreshData(item) {
    var pathCheck;
    var exclEnRegions = regionId !== 'eu' && regionId !== 'tr';

    if (languageId === 'en' && exclEnRegions) {
      pathCheck = "/".concat(regionId, "/en");
    } else {
      pathCheck = regionId === 'na' ? '' : "/".concat(regionId);
    }

    window.history.replaceState(null, "".concat(pathCheck, "/products/soundboks-go/"), "".concat(pathCheck, "/products/soundboks-go/?Accessories=").concat(item));
  };

  var handleMerchSelector = function handleMerchSelector(item) {
    var nextVariant = productData.variants.find(function (variant) {
      return variant.options[soundboks_go_options.merch] === item;
    });
    setSelectedMerch(item);
    refreshData(item);
    setProductVariant(nextVariant);
  }; // const handleCarrierStrapSelector = (selected: boolean) => {
  //   const variants = productData.variants.filter(
  //     (variant) =>
  //       variant.options[options.carrierStrap]
  //       === (selected ? carrierStrapOptions.withStrap : carrierStrapOptions.withoutStrap),
  //   );
  //   const colors = variants.map((variant) => variant.options[options.grillColor]);
  //   setAvalibleColors((prev) =>
  //     prev.map((color) =>
  //       (colors.includes(color.id) ? { ...color, disabled: false } : { ...color, disabled: true })));
  //   setCarrierStrap(selected);
  //   const trackStrap = selected ? carrierStrapOptions.withStrap : carrierStrapOptions.withoutStrap;
  //   trackVariantInteraction(trackStrap);
  //   setAllowImageInteractionTracking(true);
  //   setTrackImageInteractionLimit(0);
  //   const nextVariant = variants.find(
  //     (variant) => variant.options[options.grillColor] === selectedColor,
  //   );
  //   setProductVariant(nextVariant);
  // };


  Object(react["useEffect"])(function () {
    if (productVariant) {
      var productImages = Object(getProductImages["a" /* default */])(productData.handle, productVariant.sku);
      var imageUrl = productImages.length ? productImages[0].url : '';
      var timer = setTimeout(function () {
        return Object(utils["i" /* trackProductPageview */])({
          name: productData.title,
          id: productVariant.sku,
          price: productVariant.price,
          brand: 'soundboks',
          category: productCategories,
          variant: productVariant.title,
          image: imageUrl
        });
      }, 1000);
      return function () {
        return clearTimeout(timer);
      };
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [regionId, productVariant]);

  var handleAddToCart = function handleAddToCart() {
    console.log('handleAddToCart', productVariant);

    if (productVariant.available) {
      dispatchAddCartItem(productVariant.id, 1, true);
    } else {
      console.log('join waitinglist dialog');
    }
  };

  var financialServices = function financialServices(variantPrice) {
    var locale = productData.locale;
    var klarnaAvailable = locale === 'de' || locale === 'no' || locale === 'da';
    var affirmAvailable = locale === 'en-US';
    return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, affirmAvailable && /*#__PURE__*/react_default.a.createElement(index_web_AffirmService, {
      price: variantPrice,
      locale: locale,
      isBlackTheme: true
    }), klarnaAvailable && /*#__PURE__*/react_default.a.createElement(index_web_KlarnaService, {
      price: variantPrice,
      locale: soundboks_go_klarnaData[locale].klarnaLocale,
      klarnaClassName: soundboks_go_klarnaData[locale].klarnaClassName
    }));
  };

  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    backgroundColor: elements_theme["a" /* Color */].Charcoal
  }, /*#__PURE__*/react_default.a.createElement(sub_navigation_SubNavigation, {
    productData: productData,
    productVariant: productVariant,
    anchorStack: anchorStack,
    selectedAnchor: selectedAnchor,
    isHeaderVisibility: isHeaderVisibility,
    offset: offset,
    handleAddToCart: handleAddToCart
  }), /*#__PURE__*/react_default.a.createElement("div", {
    ref: overview
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '24px',
      desktop: '46px'
    }
  }), /*#__PURE__*/react_default.a.createElement(soundboks_go_product_overview, {
    paths: soundboks_go_paths,
    offset: offset,
    anchorStack: anchorStack,
    productData: productData,
    productVariant: productVariant,
    availableMerch: availableMerch,
    selectedMerch: selectedMerch,
    handleMerchSelector: handleMerchSelector,
    onHeaderVisibility: handleHeaderVisibility // handleBatterySelector={handleBatterySelector}
    // handleCarrierStrapSelector={handleCarrierStrapSelector}
    // extraBattery={extraBattery}
    // addCarrierStrap={carrierStrap}
    // disableExtraBattery={disableExtraBattery}
    ,
    handleAddToCart: handleAddToCart,
    financialServices: financialServices,
    allowImageInteractionTracking: allowImageInteractionTracking,
    setAllowImageInteractionTracking: setAllowImageInteractionTracking,
    trackImageInteractionLimit: trackImageInteractionLimit,
    setTrackImageInteractionLimit: setTrackImageInteractionLimit
  })), /*#__PURE__*/react_default.a.createElement(styled_BackgroundImage, null), /*#__PURE__*/react_default.a.createElement("div", {
    ref: feature
  }, /*#__PURE__*/react_default.a.createElement(soundboks_go_product_feature, null), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '60px',
      desktop: '120px'
    }
  }), /*#__PURE__*/react_default.a.createElement(soundboks_go_image_collage, null)), /*#__PURE__*/react_default.a.createElement("div", {
    ref: learnMore
  }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    alignContentHorizontal: "center",
    backgroundColor: elements_theme["a" /* Color */].WhiteOff
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }), /*#__PURE__*/react_default.a.createElement(soundboks_go_learn_more, {
    selectedMerch: selectedMerch,
    locale: productData.locale
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }))), /*#__PURE__*/react_default.a.createElement("div", {
    ref: reviews
  }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    backgroundColor: elements_theme["a" /* Color */].White
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }), /*#__PURE__*/react_default.a.createElement(soundboks_go_product_review, null), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }))), /*#__PURE__*/react_default.a.createElement("div", {
    ref: relatedProducts
  }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    backgroundColor: elements_theme["a" /* Color */].WhiteOff
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }), /*#__PURE__*/react_default.a.createElement(soundboks_go_related_products, {
    relatedProducts: productData.crossSellHandles
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '60px',
      desktop: '72px'
    }
  }))));
};

/* harmony default export */ var speakers_soundboks_go = (soundboks_go_SoundboksGo);
// EXTERNAL MODULE: ./components/pages/products-v2/bundles/explorer-pack/assets/ExplorerPack-lifestyle-large.jpg
var ExplorerPack_lifestyle_large = __webpack_require__("wn/i");
var ExplorerPack_lifestyle_large_default = /*#__PURE__*/__webpack_require__.n(ExplorerPack_lifestyle_large);

// EXTERNAL MODULE: ./components/pages/products-v2/bundles/explorer-pack/assets/ExplorerPack-lifestyle-small.jpg
var ExplorerPack_lifestyle_small = __webpack_require__("zVQo");
var ExplorerPack_lifestyle_small_default = /*#__PURE__*/__webpack_require__.n(ExplorerPack_lifestyle_small);

// CONCATENATED MODULE: ./components/pages/products-v2/bundles/explorer-pack/styled.ts




var explorer_pack_styled_BackgroundImage = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__BackgroundImage",
  componentId: "sc-7ksx8l-0"
})(["display:block;width:100%;height:400px;background-image:url(", ");background-repeat:no-repeat;background-size:cover;background-position:center;@media ", "{height:852px;padding:20px;background-size:contain;background-image:url(", ");}"], ExplorerPack_lifestyle_large_default.a.url, styles_theme["a" /* default */].breakpoints.tablet, ExplorerPack_lifestyle_small_default.a.url);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/explorer-pack/product-overview/index.tsx
var explorer_pack_product_overview_jsx = react_default.a.createElement;






var explorer_pack_product_overview_ProductOverviewSection = function ProductOverviewSection(_ref) {
  var productData = _ref.productData,
      paths = _ref.paths,
      onHeaderVisibility = _ref.onHeaderVisibility,
      handleColorSelector = _ref.handleColorSelector,
      productVariant = _ref.productVariant,
      avalibleColors = _ref.avalibleColors,
      selectedColor = _ref.selectedColor,
      handleAddToCart = _ref.handleAddToCart,
      financialServices = _ref.financialServices,
      offset = _ref.offset,
      anchorStack = _ref.anchorStack,
      allowImageInteractionTracking = _ref.allowImageInteractionTracking,
      setAllowImageInteractionTracking = _ref.setAllowImageInteractionTracking,
      trackImageInteractionLimit = _ref.trackImageInteractionLimit,
      setTrackImageInteractionLimit = _ref.setTrackImageInteractionLimit;
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentHorizontal: "center",
      padding: {
        right: 24,
        left: 24
      }
    }, /*#__PURE__*/react_default.a.createElement(index_web_ProductOverview, {
      paths: paths,
      offset: offset,
      anchorStack: anchorStack,
      productData: productData,
      handleColorSelector: handleColorSelector,
      productVariant: productVariant,
      avalibleColors: avalibleColors,
      selectedColor: selectedColor,
      handleAddToCart: handleAddToCart,
      financialServices: financialServices,
      allowImageInteractionTracking: allowImageInteractionTracking,
      setAllowImageInteractionTracking: setAllowImageInteractionTracking,
      trackImageInteractionLimit: trackImageInteractionLimit,
      setTrackImageInteractionLimit: setTrackImageInteractionLimit,
      labels: {
        grillColor: {
          label: i18n._('product.option.label.grill-color'),
          options: {
            Black: i18n._('product.option.label.black'),
            Orange: i18n._('product.option.label.orange'),
            White: i18n._('product.option.label.white'),
            Blue: i18n._('product.option.label.blue'),
            Red: i18n._('product.option.label.red')
          }
        },
        // extraBattery: {
        //   label: i18n._('product.option.label.extra-battery'),
        //   options: {
        //     yes: i18n._('product.option.label.yes'),
        //     no: i18n._('product.option.label.no'),
        //   },
        // },
        addToCart: i18n._('product.buy-page.button.addToCart'),
        outOfStock: i18n._('product.buy-page.button.outOfStock'),
        waitlist: i18n._('product.buy-page.button.waitlist'),
        usp: {
          warranty: i18n._('product.usp.warranty'),
          freeReturns: i18n._('product.usp.free-returns'),
          freeShipping: i18n._('product.usp.free-shipping'),
          premiumSupport: i18n._('product.usp.premium-support'),
          compatibility: i18n._('product.usp.compatibility')
        }
      },
      onHeaderVisibility: onHeaderVisibility
    }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    }));
  });
};

/* harmony default export */ var explorer_pack_product_overview = (explorer_pack_product_overview_ProductOverviewSection);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/explorer-pack/learn-more/whats-in-the-box/styled.ts


var learn_more_whats_in_the_box_styled_IconWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__IconWrapper",
  componentId: "sc-1nhrsda-0"
})(["display:block;"]);
var learn_more_whats_in_the_box_styled_Layout = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Layout",
  componentId: "sc-1nhrsda-1"
})(["display:flex;flex-direction:row;justify-content:space-evenly;padding:10px 50px;align-items:end;@media ", "{display:grid;grid-template-columns:1fr 1fr;grid-gap:30px;padding:15px 0px;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
var explorer_pack_learn_more_whats_in_the_box_styled_Link = styled_components_browser_esm["default"].a.withConfig({
  displayName: "styled__Link",
  componentId: "sc-1nhrsda-2"
})(["text-decoration:underline;"]);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/explorer-pack/learn-more/whats-in-the-box/index.web.tsx
var explorer_pack_learn_more_whats_in_the_box_index_web_jsx = react_default.a.createElement;





// eslint-disable-next-line prefer-arrow-callback
var learn_more_whats_in_the_box_index_web_WhatsInTheBox = /*#__PURE__*/react_default.a.memo(function WhatsInTheBox(_ref) {
  var packageItems = _ref.packageItems,
      extraBattery = _ref.extraBattery;
  return /*#__PURE__*/react_default.a.createElement(learn_more_whats_in_the_box_styled_Layout, null, packageItems.filter(function (item) {
    return !extraBattery ? item.packageItemId !== 'extra-batteryboks' : item;
  }).map(function (_ref2) {
    var packageItemId = _ref2.packageItemId,
        title = _ref2.title,
        icon = _ref2.icon,
        downloadUrl = _ref2.downloadUrl;
    return /*#__PURE__*/react_default.a.createElement("div", {
      key: packageItemId
    }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(learn_more_whats_in_the_box_styled_IconWrapper, null, icon), /*#__PURE__*/react_default.a.createElement(spacer_Spacer, {
      height: 10
    }), /*#__PURE__*/react_default.a.createElement(elements_typography["d" /* Caption02 */], null, title, " ", downloadUrl ? /*#__PURE__*/react_default.a.createElement(explorer_pack_learn_more_whats_in_the_box_styled_Link, {
      href: downloadUrl,
      target: "_blank"
    }, "Download") : null)));
  }));
});
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/explorer-pack/learn-more/whats-bluetooth-speaker/styled.ts


var whats_bluetooth_speaker_styled_Table = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Table",
  componentId: "sc-1cbxb7x-0"
})(["width:100%;"]);
var learn_more_whats_bluetooth_speaker_styled_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Wrapper",
  componentId: "sc-1cbxb7x-1"
})(["padding-left:26px;padding-right:26px;display:grid;grid-template-columns:250px 1fr 1fr 1fr;@media ", "{display:grid;grid-template-columns:1fr 1fr 1fr;}svg{margin:0 auto;}text-align:center;font-family:", ";font-size:10px;line-height:12px;"], styles_theme["a" /* default */].breakpoints.onlyMobile, styles_theme["a" /* default */].fonts.extended);
var explorer_pack_learn_more_whats_bluetooth_speaker_styled_ImageWrapper = Object(styled_components_browser_esm["default"])(learn_more_whats_bluetooth_speaker_styled_Wrapper).withConfig({
  displayName: "styled__ImageWrapper",
  componentId: "sc-1cbxb7x-2"
})(["align-items:baseline;padding-top:29px;"]);
var whats_bluetooth_speaker_styled_ImageTextWrapper = Object(styled_components_browser_esm["default"])(learn_more_whats_bluetooth_speaker_styled_Wrapper).withConfig({
  displayName: "styled__ImageTextWrapper",
  componentId: "sc-1cbxb7x-3"
})(["padding-top:8px;padding-bottom:12px;align-items:center;"]);
var whats_bluetooth_speaker_styled_EmptyCell = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__EmptyCell",
  componentId: "sc-1cbxb7x-4"
})(["@media ", "{display:none;}"], styles_theme["a" /* default */].breakpoints.onlyMobile);
var whats_bluetooth_speaker_styled_LastParagraph = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__LastParagraph",
  componentId: "sc-1cbxb7x-5"
})(["padding-top:40px;color:", ";font-family:", ";font-size:14px;line-height:16px;white-space:pre-wrap;"], styles_theme["a" /* default */].colors.black, styles_theme["a" /* default */].fonts.regular);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/explorer-pack/learn-more/whats-bluetooth-speaker/attribute-row/CheckIcon.tsx
var whats_bluetooth_speaker_attribute_row_CheckIcon_jsx = react_default.a.createElement;


var whats_bluetooth_speaker_attribute_row_CheckIcon_CheckIcon = function CheckIcon() {
  return /*#__PURE__*/react_default.a.createElement("svg", {
    style: {
      margin: '0 auto'
    },
    width: 15,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react_default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.376.389 6.249 6.516l-3.751-3.75-2.122 2.12 5.873 5.873 8.248-8.25L12.376.39Z",
    fill: "#212222"
  }));
};

/* harmony default export */ var learn_more_whats_bluetooth_speaker_attribute_row_CheckIcon = (whats_bluetooth_speaker_attribute_row_CheckIcon_CheckIcon);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/explorer-pack/learn-more/whats-bluetooth-speaker/attribute-row/styled.ts


var attribute_row_styled_TableRow = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__TableRow",
  componentId: "sc-2m9b7u-0"
})(["display:grid;grid-template-columns:250px auto;padding:26px;@media ", "{display:flex;flex-direction:column;text-align:center;gap:22px;}"], styles_theme["a" /* default */].breakpoints.onlyMobile);
var attribute_row_styled_AttributeText = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__AttributeText",
  componentId: "sc-2m9b7u-1"
})(["font-family:", ";font-size:14px;line-height:16px;@media ", "{font-size:11px;line-height:12px;}"], styles_theme["a" /* default */].fonts.regular, styles_theme["a" /* default */].breakpoints.onlyMobile);
var attribute_row_styled_CheckIconWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__CheckIconWrapper",
  componentId: "sc-2m9b7u-2"
})(["display:grid;grid-template-columns:1fr 1fr 1fr;"]);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/explorer-pack/learn-more/whats-bluetooth-speaker/attribute-row/index.tsx
var learn_more_whats_bluetooth_speaker_attribute_row_jsx = react_default.a.createElement;




 // eslint-disable-next-line prefer-arrow-callback

var learn_more_whats_bluetooth_speaker_attribute_row_AttributeRow = /*#__PURE__*/react_default.a.memo(function AttributeRow(_ref) {
  var text = _ref.text,
      checks = _ref.checks;
  return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(attribute_row_styled_TableRow, null, /*#__PURE__*/react_default.a.createElement(attribute_row_styled_AttributeText, null, text), /*#__PURE__*/react_default.a.createElement(attribute_row_styled_CheckIconWrapper, null, checks.map(function (check, index) {
    return check ? /*#__PURE__*/react_default.a.createElement(learn_more_whats_bluetooth_speaker_attribute_row_CheckIcon, {
      key: "check-icon".concat(index)
    }) : /*#__PURE__*/react_default.a.createElement("div", {
      key: "check-icon".concat(index)
    });
  }))), /*#__PURE__*/react_default.a.createElement(HorizontalLine, {
    color: styles_theme["a" /* default */].colors.white
  }));
});
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/explorer-pack/learn-more/whats-bluetooth-speaker/icons/IconSoundboks3.tsx
var icons_IconSoundboks3_jsx = react_default.a.createElement;


var icons_IconSoundboks3_IconSoundboks3 = function IconSoundboks3() {
  return /*#__PURE__*/react_default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "55",
    height: "80",
    viewBox: "0 0 82.471 119.016"
  }, /*#__PURE__*/react_default.a.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(-654 -4240)"
  }, /*#__PURE__*/react_default.a.createElement("path", {
    id: "Vector",
    d: "M5.6,101.5l1.56-2.7h2.51l1.56,2.7h3.7l1.56-2.7h2.55l1.56,2.7h3.7l1.56-2.7h2.51l1.56,2.7h3.7l1.56-2.7H37.7l1.56,2.7h3.7l1.56-2.7h2.55l1.56,2.7h3.7l1.56-2.7H56.4l1.56,2.7h3.7l1.85-3.2-1.56-2.7,1.56-2.71-1.56-2.7,1.56-2.7-1.56-2.71,1.56-2.7-1.56-2.7,1.56-2.7-1.56-2.71,1.56-2.7-1.56-2.7,1.56-2.71-1.56-2.7,1.56-2.7-1.56-2.71,1.56-2.7-1.56-2.7,1.56-2.7-1.56-2.71,1.56-2.7-1.56-2.7,1.56-2.71-1.56-2.7,1.56-2.7-1.56-2.71,1.56-2.7-1.56-2.74,1.56-2.7-1.56-2.71,1.56-2.7-1.56-2.7,1.56-2.71-1.56-2.7,1.56-2.7-1.85-3.21h-3.1L57,.452H53.3l-1.52,2.74h-2.55l-1.56-2.7h-3.7l-1.56,2.7h-2.54l-1.56-2.7h-3.7l-1.56,2.7h-2.52l-1.56-2.7h-3.7l-1.56,2.7H21.2l-1.56-2.7h-3.7l-1.56,2.7h-2.54l-1.56-2.7h-3.7l-1.56,2.7H1.9L.053,6.4l1.56,2.7L.053,11.8l1.56,2.71-1.56,2.7,1.56,2.7-1.56,2.71,1.56,2.7-1.56,2.7,1.56,2.7-1.56,2.71,1.56,2.7-1.56,2.7,1.56,2.71-1.56,2.74,1.56,2.7-1.56,2.71,1.56,2.7-1.56,2.7,1.56,2.7L.053,60.5l1.56,2.7L.053,65.9l1.56,2.71-1.56,2.67,1.56,2.7-1.56,2.71,1.56,2.7-1.56,2.7,1.56,2.7L.053,87.5l1.56,2.7L.053,92.9l1.56,2.71-1.56,2.67,1.85,3.2Zm8.78-97.31H40.5l-1.07,3.65-.21.73H4.073l1.17-4,.11-.39h9ZM47.073,6.9l1.27,2.2-1.27,2.18h-2.52l-1.27-2.2,1.27-2.2Zm9.33,0,1.27,2.2-1.27,2.18h-2.51l-1.27-2.2,1.27-2.2Zm-7.17,88.2-1.27-2.21,1.27-2.2h2.55l1.27,2.2-1.27,2.21Zm-9.36,0-1.27-2.21,1.27-2.2h2.52l1.27,2.2-1.27,2.21Zm-9.34,0-1.27-2.21,1.27-2.2h2.52l1.27,2.2-1.27,2.21Zm-9.33,0-1.27-2.21,1.27-2.2h2.51l1.27,2.2-1.27,2.21Zm-9.36,0-1.28-2.21,1.28-2.2h2.51l1.28,2.2-1.28,2.21Zm30.55-80.09,1.27,2.2-1.27,2.2h-2.52l-1.27-2.2,1.27-2.2Zm4.68-2.73,1.27,2.21-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21Zm4.67-2.7,1.27,2.2-1.23,2.23h-2.55l-1.27-2.21,1.27-2.2Zm4.66,2.7,1.27,2.21-1.27,2.2h-2.51l-1.27-2.2,1.27-2.21Zm-2.51,80.09-1.27-2.2,1.27-2.2H56.4l1.27,2.2-1.27,2.2Zm-4.66-2.7-1.27-2.2,1.27-2.19h2.55l1.27,2.21-1.27,2.2Zm-4.68,2.7-1.27-2.2,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.68-2.7-1.27-2.2,1.27-2.19h2.52l1.27,2.21-1.27,2.2Zm-4.68,2.7-1.28-2.2,1.28-2.2H37.7l1.28,2.2-1.28,2.2Zm-4.66-2.7-1.27-2.2,1.27-2.19h2.52l1.27,2.21-1.27,2.2Zm-4.67,2.7-1.28-2.2,1.28-2.2h2.51l1.27,2.2-1.27,2.2Zm-4.66-2.7-1.27-2.2,1.27-2.19h2.51l1.27,2.21-1.27,2.2Zm-4.68,2.7-1.27-2.2,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.68-2.7-1.28-2.2,1.28-2.19h2.51l1.28,2.21-1.28,2.2Zm-4.68,2.7-1.27-2.2,1.27-2.2h2.51l1.27,2.2-1.27,2.2Zm35.23-72,1.27,2.21-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21Zm4.68-2.7,1.27,2.2-1.27,2.21h-2.52l-1.27-2.21,1.27-2.2Zm4.67-2.7,1.27,2.2-1.23,2.24h-2.55l-1.27-2.2,1.27-2.2Zm4.66,2.7,1.27,2.2-1.27,2.21h-2.51l-1.27-2.21,1.27-2.2Zm-2.51,69.28-1.27-2.21,1.27-2.2H56.4l1.27,2.2-1.27,2.21Zm-4.66-2.67-1.27-2.2,1.27-2.2h2.55l1.27,2.2-1.27,2.2Zm-4.68,2.71-1.27-2.21,1.27-2.2h2.52l1.27,2.2-1.27,2.21Zm-4.68-2.71-1.27-2.2,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.68,2.71-1.28-2.21,1.28-2.2H37.7l1.28,2.2-1.28,2.21Zm-4.66-2.71-1.27-2.2,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.67,2.71-1.28-2.21,1.28-2.2h2.51l1.27,2.2-1.27,2.21Zm-4.66-2.71-1.27-2.2,1.27-2.2h2.51l1.27,2.2-1.27,2.2Zm-4.68,2.71-1.27-2.21,1.27-2.2h2.52l1.27,2.2-1.27,2.21Zm-4.68-2.71-1.28-2.2,1.28-2.2h2.51l1.28,2.2-1.28,2.2Zm2.51-69.27,1.28,2.2-1.28,2.2h-2.51l-1.28-2.2,1.28-2.2Zm4.69-2.73,1.27,2.21-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21Zm4.67,2.71,1.27,2.2-1.27,2.2H21.2l-1.27-2.2,1.27-2.2Zm4.66-2.71,1.27,2.21-1.27,2.2h-2.51l-1.28-2.2,1.28-2.21Zm4.68,2.71,1.27,2.2-1.27,2.2h-2.52l-1.27-2.2,1.27-2.2Zm4.65-2.71,1.28,2.21-1.28,2.2h-2.51l-1.28-2.2,1.28-2.21Zm4.69,13.52,1.27,2.2-1.27,2.2h-2.52L38.6,28l1.27-2.2Zm4.68-2.7,1.27,2.2-1.27,2.2h-2.52l-1.27-2.22,1.27-2.2Zm4.71-2.69,1.27,2.21-1.27,2.2h-2.55l-1.27-2.2,1.27-2.21Zm-2.55,58.47-1.27-2.2,1.27-2.21h2.55l1.27,2.21-1.27,2.2Zm-4.68,2.7-1.27-2.2,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.68-2.7-1.27-2.2,1.27-2.21h2.52l1.27,2.21-1.27,2.2Zm-4.68,2.7-1.28-2.2,1.28-2.2H37.7l1.28,2.2-1.28,2.2Zm-4.66-2.7-1.27-2.2,1.27-2.21h2.52l1.27,2.21-1.27,2.2Zm-4.67,2.7-1.28-2.2,1.28-2.2h2.51l1.27,2.2-1.27,2.2Zm-4.66-2.7-1.27-2.2,1.27-2.21h2.51l1.27,2.21-1.27,2.2Zm-4.68,2.7-1.27-2.2,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.68-2.7-1.28-2.2,1.28-2.21h2.51l1.28,2.21-1.28,2.2Zm2.51-58.47,1.28,2.21-1.28,2.2h-2.51l-1.28-2.2,1.28-2.21Zm4.69-2.7,1.27,2.2-1.27,2.21h-2.52l-1.27-2.21,1.27-2.2Zm4.67,2.7,1.27,2.21-1.27,2.2H21.2l-1.27-2.2,1.27-2.21Zm4.66-2.7,1.27,2.2-1.27,2.21h-2.51l-1.28-2.21,1.28-2.2Zm4.68,2.7,1.27,2.21-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21Zm4.65-2.7,1.28,2.2-1.28,2.21h-2.51l-1.28-2.21,1.28-2.2Zm4.69,13.51,1.27,2.21-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21Zm4.68-2.7,1.27,2.2-1.27,2.21h-2.52l-1.27-2.21,1.27-2.2Zm4.67-2.7,1.27,2.2-1.23,2.2h-2.55l-1.27-2.2,1.27-2.2Zm-2.51,47.65-1.27-2.19,1.27-2.2h2.55l1.27,2.2-1.27,2.19Zm-4.68,2.71-1.27-2.21,1.27-2.2h2.52l1.27,2.2-1.27,2.21Zm-4.68-2.71-1.27-2.19,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.68,2.71-1.28-2.21,1.28-2.2H37.7l1.28,2.2-1.28,2.21Zm-4.66-2.71-1.27-2.19,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.67,2.71-1.28-2.21,1.28-2.2h2.51l1.27,2.2-1.27,2.21Zm-4.66-2.71-1.27-2.19,1.27-2.2h2.51l1.27,2.2-1.27,2.2Zm-4.68,2.71-1.27-2.21,1.27-2.2h2.52l1.27,2.2-1.27,2.21Zm-4.68-2.71-1.28-2.19,1.28-2.2h2.51l1.28,2.2-1.28,2.2Zm2.51-47.65,1.28,2.2-1.28,2.2h-2.51l-1.28-2.2,1.28-2.2Zm4.69-2.7,1.27,2.2-1.27,2.2h-2.52l-1.27-2.24,1.27-2.2Zm4.67,2.7,1.27,2.2-1.27,2.2H21.2l-1.27-2.2,1.27-2.2Zm4.66-2.7,1.27,2.2-1.27,2.2h-2.51l-1.28-2.24,1.28-2.2Zm4.68,2.7,1.27,2.2-1.27,2.2h-2.52l-1.27-2.2,1.27-2.2Zm4.65-2.7,1.28,2.16-1.28,2.2h-2.51l-1.28-2.2,1.28-2.2Zm4.69,13.51,1.27,2.2-1.27,2.21h-2.52l-1.27-2.21,1.27-2.2Zm4.68-2.7,1.27,2.2-1.27,2.2h-2.52l-1.27-2.2,1.27-2.2Zm4.71-2.71,1.27,2.21-1.27,2.2h-2.55l-1.27-2.2,1.27-2.21Zm-2.51,36.85L48,65.862l1.27-2.2h2.51l1.27,2.2-1.27,2.21Zm-4.68,2.7-1.27-2.2,1.27-2.21h2.52l1.27,2.21-1.27,2.2Zm-4.68-2.7-1.27-2.21,1.27-2.2h2.52l1.27,2.2-1.27,2.21Zm-4.68,2.7-1.28-2.2,1.28-2.21h2.51l1.28,2.21-1.28,2.2Zm-4.66-2.7-1.27-2.21,1.27-2.2h2.52l1.27,2.2-1.27,2.21Zm-4.67,2.7-1.28-2.2,1.28-2.21h2.51l1.27,2.21-1.27,2.2Zm-4.66-2.7-1.27-2.21,1.27-2.2h2.51l1.27,2.2-1.27,2.21Zm-4.68,2.7-1.27-2.2,1.27-2.21h2.52l1.27,2.21-1.27,2.2Zm2.52-42.25,1.27,2.2-1.27,2.21h-2.56l-1.27-2.21,1.27-2.2Zm4.67,2.7,1.27,2.21-1.27,2.2H21.2l-1.27-2.2,1.27-2.21Zm4.66-2.7,1.27,2.2-1.27,2.21h-2.55l-1.28-2.21,1.28-2.2Zm4.68,2.7,1.27,2.21-1.27,2.2h-2.56l-1.27-2.2,1.27-2.21Zm4.65-2.7,1.28,2.2-1.28,2.21h-2.55l-1.28-2.21,1.28-2.2Zm4.69,13.52,1.27,2.2-1.27,2.2h-2.56l-1.27-2.16,1.27-2.2Zm4.68-2.71,1.27,2.21-1.27,2.2h-2.56l-1.27-2.2,1.27-2.21Zm-2.52,26-1.27-2.2,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.68-2.7-1.27-2.2,1.23-2.15h2.52l1.27,2.21-1.27,2.2Zm-4.68,2.7-1.28-2.2,1.28-2.2h2.51l1.28,2.2-1.28,2.2Zm-4.66-2.7-1.27-2.2,1.23-2.15h2.52l1.27,2.21-1.27,2.2Zm-4.67,2.7-1.28-2.2,1.28-2.2h2.51l1.27,2.2-1.27,2.2Zm-4.66-2.7-1.27-2.2,1.23-2.15h2.51l1.27,2.21-1.27,2.2Zm-4.68,2.7-1.27-2.2,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm2.52-31.43,1.27,2.2-1.27,2.2h-2.56l-1.27-2.2,1.27-2.2Zm4.67,2.7,1.27,2.2-1.27,2.21H21.2l-1.27-2.21,1.27-2.2Zm4.66-2.7,1.27,2.2-1.27,2.2h-2.55l-1.28-2.2,1.28-2.2Zm4.68,2.7,1.27,2.2-1.27,2.21h-2.56l-1.27-2.21,1.27-2.2Zm4.65-2.7,1.28,2.2-1.28,2.2h-2.55l-1.28-2.2,1.28-2.2Zm4.69,13.51,1.27,2.21-1.27,2.2h-2.56l-1.27-2.2,1.27-2.21Zm4.68-2.7,1.27,2.2-1.27,2.21h-2.56l-1.27-2.21,1.27-2.2Zm-2.52,15.22-1.27-2.21,1.27-2.2h2.52l1.27,2.2-1.27,2.21Zm-4.72-2.65-1.27-2.2,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.68,2.71-1.28-2.21,1.28-2.2H37.7l1.28,2.2-1.28,2.21Zm-4.66-2.71-1.27-2.2,1.27-2.2h2.52l1.27,2.2-1.27,2.2Zm-4.67,2.71-1.28-2.21,1.28-2.2h2.51l1.27,2.2-1.27,2.21Zm-4.66-2.71-1.27-2.2,1.27-2.2h2.51l1.27,2.2-1.27,2.2Zm-4.68,2.71-1.27-2.21,1.27-2.2h2.52l1.27,2.2-1.27,2.21Zm2.52-20.63,1.27,2.21-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21Zm4.67,2.71,1.27,2.21-1.27,2.2H21.2l-1.27-2.2,1.27-2.2Zm4.66-2.71,1.27,2.21-1.27,2.2h-2.51l-1.28-2.2,1.28-2.21Zm4.68,2.71,1.27,2.2-1.27,2.2h-2.52l-1.27-2.19,1.27-2.2Zm4.65-2.71,1.28,2.21-1.28,2.2h-2.51l-1.28-2.2,1.28-2.21Zm-2.51,15.22-1.28-2.2,1.28-2.2H37.7l1.28,2.2-1.28,2.2Zm-4.66-2.7-1.27-2.2,1.27-2.21h2.52l1.27,2.21-1.27,2.2Zm-4.67,2.7-1.28-2.2,1.28-2.2h2.51l1.27,2.2-1.27,2.2Zm-4.66-2.7-1.27-2.2,1.27-2.21h2.51l1.27,2.21-1.27,2.2Zm7.17-7.11,1.27,2.2-1.27,2.21h-2.51l-1.28-2.21,1.28-2.2Zm9.33,0,1.28,2.2-1.28,2.21h-2.51l-1.28-2.21,1.28-2.2Zm-18.66,0,1.27,2.2-1.27,2.21h-2.52l-1.27-2.21,1.27-2.2Zm0,5.41,1.27,2.2-1.27,2.2h-2.52l-1.27-2.2,1.27-2.2Zm28,0,1.27,2.2-1.27,2.2h-2.49l-1.27-2.2,1.27-2.2Zm2.16,12.51-1.27-2.2,1.3-2.21h2.55l1.27,2.21-1.27,2.17Zm0-5.41-1.27-2.2,1.27-2.2h2.58l1.27,2.2-1.27,2.2Zm0-5.4-1.27-2.2,1.27-2.21h2.58l1.27,2.21-1.27,2.17Zm0-5.41-1.24-2.19,1.27-2.2h2.55l1.27,2.2-1.27,2.16Zm0-5.4-1.27-2.21,1.27-2.2h2.58l1.27,2.2-1.27,2.18Zm-34.88-9.82,1.28,2.21-1.28,2.2h-2.48l-1.28-2.2,1.28-2.21Zm0,5.41,1.28,2.2-1.28,2.21h-2.48l-1.28-2.21,1.28-2.2Zm0,5.41,1.28,2.2-1.28,2.2h-2.48l-1.28-2.19,1.28-2.2Zm0,5.4,1.28,2.21-1.28,2.2h-2.48l-1.28-2.2,1.28-2.21Zm0,5.41,1.28,2.2-1.25,2.2h-2.51l-1.28-2.2,1.28-2.2Zm0,5.4,1.28,2.21-1.28,2.2h-2.48l-1.28-2.2,1.28-2.21Zm0,5.41,1.28,2.2-1.28,2.21h-2.48l-1.28-2.21,1.28-2.2Zm39.57,17.89-1.27-2.2,1.27-2.2H56.4l1.27,2.2-1.27,2.2Zm0-5.4-1.27-2.21,1.27-2.2H56.4l1.27,2.2-1.27,2.21Zm0-5.41-1.27-2.2,1.27-2.21H56.4l1.27,2.21-1.27,2.2Zm0-5.41-1.27-2.2,1.27-2.2H56.4l1.27,2.2-1.27,2.2Zm0-5.4-1.27-2.21,1.27-2.2H56.4l1.27,2.2-1.27,2.21Zm0-5.41-1.27-2.2,1.27-2.2H56.4l1.27,2.2-1.27,2.2Zm0-5.4-1.27-2.21,1.27-2.2H56.4l1.27,2.2-1.27,2.21Zm0-5.41-1.27-2.2,1.27-2.21H56.4l1.27,2.21-1.27,2.2Zm0-5.41-1.27-2.2,1.27-2.2H56.4l1.27,2.2-1.27,2.2Zm0-5.4-1.27-2.21,1.27-2.2H56.4l1.27,2.2-1.27,2.21Zm0-5.41-1.27-2.24,1.27-2.2H56.4l1.27,2.2-1.27,2.2ZM37.7,11.282h-2.51l-1-1.7h4.49Zm-3.38.5-1.27,2.21h-2.52l-1.27-2.21,1.27-2.2h2.52Zm-5.95-.5h-2.51l-1-1.7h4.48Zm-3.39.5-1.27,2.21H21.2l-1.27-2.21,1.27-2.2h2.51Zm-5.94-.5h-2.52l-1-1.7h4.49Zm-3.41.5-1.28,2.21h-2.51l-1.28-2.21,1.28-2.2h2.51Zm-6-.5H7.163l-1-1.7h4.48Zm0,1,1.27,2.21-1.27,2.2H7.163l-1.27-2.2,1.27-2.21Zm0,5.41,1.27,2.2L9.633,22.1H7.163l-1.27-2.21,1.27-2.2Zm0,5.41,1.27,2.2-1.27,2.2H7.163l-1.27-2.22,1.27-2.2Zm0,5.4,1.27,2.2-1.27,2.21H7.163L5.893,30.7l1.27-2.2Zm0,5.41,1.27,2.2-1.27,2.2H7.163l-1.27-2.2,1.27-2.2Zm0,5.4,1.27,2.21-1.27,2.2H7.163l-1.27-2.2,1.27-2.21Zm0,5.41,1.27,2.2-1.27,2.21H7.163l-1.27-2.21,1.27-2.2Zm0,5.41,1.27,2.2-1.27,2.2H7.163l-1.27-2.2,1.27-2.2Zm0,5.4,1.27,2.2-1.27,2.21H7.163l-1.27-2.21,1.27-2.2Zm0,5.41,1.27,2.2-1.27,2.2H7.163l-1.27-2.2,1.27-2.2Zm0,5.4,1.27,2.21-1.27,2.2H7.163l-1.27-2.2,1.27-2.21Zm0,5.41,1.27,2.2-1.27,2.21H7.163l-1.27-2.21,1.27-2.2Zm0,5.41,1.27,2.2-1.27,2.2H7.163l-1.27-2.2,1.27-2.2Zm0,5.4,1.27,2.2-1.27,2.21H7.163l-1.27-2.21,1.27-2.2Zm-3.78,13,1.27-2.21h2.51l1.27,2.21-1.27,2.2H7.163Zm9.36,0,1.27-2.21H19l1.27,2.21L19,97.762h-2.48Zm9.33,0,1.28-2.21h2.51l1.27,2.21-1.27,2.2h-2.47Zm9.33,0,1.28-2.21h2.51l1.28,2.21-1.28,2.2h-2.47Zm9.37,0,1.27-2.21h2.52l1.27,2.21-1.27,2.2h-2.48Zm9.34,0,1.27-2.21h2.51l1.27,2.21-1.27,2.2h-2.47Zm.39-89.2L51.783,8.6h-2.55l-1.27-2.2,1.27-2.21h2.55Zm-10.62,3.2,1.27,2.2-1.27,2.21h-2.48l-1.27-2.21,1.27-2.2h2.48Zm-28,90.9h-2.57l-1.23-2.18,1.29-2.22h2.51l1.28,2.2Zm9.37,0h-2.55l-1.25-2.18,1.28-2.22h2.51l1.28,2.2Zm9.33,0H30.5l-1.25-2.18,1.28-2.22h2.52l1.27,2.2Zm9.34,0h-2.55l-1.26-2.18,1.29-2.22h2.52l1.27,2.2Zm9.36,0h-2.54l-1.26-2.18,1.28-2.22h2.55l1.28,2.2Zm10.6-2.2-1.27,2.2h-2.54l-1.26-2.18,1.28-2.22h2.52Zm0-5.41-1.27,2.21h-2.52l-1.27-2.21,1.27-2.2h2.52Zm0-5.4-1.27,2.2h-2.52l-1.27-2.2,1.27-2.17h2.52Zm0-5.41-1.27,2.24h-2.52l-1.27-2.2,1.27-2.2h2.52Zm0-5.4-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21h2.52Zm0-5.41-1.27,2.2h-2.52l-1.27-2.15,1.27-2.2h2.52Zm0-5.41-1.27,2.21h-2.52l-1.27-2.21,1.27-2.2h2.52Zm0-5.4-1.27,2.2h-2.52l-1.27-2.2,1.27-2.14h2.52Zm0-5.41-1.27,2.27h-2.52l-1.27-2.2,1.27-2.2h2.52Zm0-5.4-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21h2.52Zm0-5.41-1.27,2.2h-2.52l-1.27-2.12,1.27-2.2h2.52Zm0-5.41L61.083,41h-2.52l-1.27-2.21,1.27-2.2h2.52Zm0-5.4-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21h2.52Zm0-5.41-1.27,2.2h-2.52l-1.27-2.2,1.27-2.2h2.52Zm0-5.4-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21h2.52Zm0-5.41-1.27,2.2h-2.52l-1.27-2.2,1.27-2.2h2.52Zm0-5.41-1.27,2.21h-2.52l-1.27-2.21,1.27-2.2h2.52Zm0-5.4-1.27,2.2h-2.52l-1.27-2.2,1.27-2.21h2.52Zm-8.47-4.91h2.54l1.26,2.18L56.4,5.862h-2.51l-1.28-2.21Zm-9.33,0h2.54l1.26,2.18-1.28,2.23h-2.52l-1.27-2.21Zm-2.16,2.7,1.27,2.21-1.27,2.2h-2.14l1.29-4.41Zm-7.2-2.7h2.59l1,1.7H34.2Zm-9.34,0h2.54l1,1.7h-4.52Zm-9.33,0h2.54l1,1.7h-4.53Zm-9.36,0H9.7l1,1.7H6.173Zm-6,4.91,1.27-2.21h1.84l-1.3,4.41h-.49Zm0,5.4,1.27-2.2h2.54l1.27,2.2-1.27,2.21H2.483Zm0,5.41,1.27-2.2h2.54l1.27,2.2-1.27,2.2H2.483Zm0,5.41,1.27-2.21h2.54l1.27,2.21-1.27,2.2H2.483Zm0,5.4,1.27-2.2h2.54l1.27,2.2-1.27,2.2H2.483Zm0,5.41,1.27-2.21h2.54l1.27,2.21-1.27,2.2H2.483Zm0,5.4,1.27-2.2h2.54l1.27,2.2L4.973,41H2.483Zm0,5.41L2.433,42h2.54l1.27,2.2-1.27,2.2H2.483Zm0,5.41,1.27-2.21h2.54l1.27,2.21-1.27,2.2H2.483Zm0,5.4,1.27-2.2h2.54l1.27,2.2-1.22,2.27H2.483Zm0,5.41,1.32-2.14h2.54l1.27,2.21-1.27,2.2H2.483Zm0,5.4,1.27-2.2h2.54l1.27,2.2-1.27,2.21H2.483Zm0,5.41,1.27-2.2h2.54l1.27,2.2-1.27,2.2H2.483Zm0,5.41,1.27-2.21h2.54l1.27,2.21-1.27,2.2H2.483Zm0,5.4,1.27-2.2h2.54l1.27,2.2-1.22,2.24H2.483Zm0,5.41,1.32-2.17h2.54l1.27,2.21-1.27,2.2H2.483Zm0,5.4,1.27-2.2h2.54l1.27,2.2-1.27,2.21H2.483Zm1.27,3.21h2.54l1.27,2.2-1.27,2.2H2.483l-1.27-2.18Z",
    transform: "translate(663.453 4248.531)",
    fill: "#212222"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    id: "Vector-1",
    d: "M79.353,109.9V9.992a4.84,4.84,0,1,0-5.71-6.43H9.923a4.85,4.85,0,1,0-5.71,6.43V109.9a4.85,4.85,0,1,0,5.68,6.54h63.78a4.85,4.85,0,1,0,5.68-6.54Zm-1.19,8.55a3.871,3.871,0,0,1-3.86-3.86v-.36a3.994,3.994,0,0,1,.3-1.21,3.867,3.867,0,0,1,1.5-1.7,3.986,3.986,0,0,1,1.17-.49,3.923,3.923,0,0,1,.85-.1,3.86,3.86,0,0,1,0,7.72Zm-76.62-3.86a3.859,3.859,0,0,1,3.86-3.86,3.924,3.924,0,0,1,.85.1,3.986,3.986,0,0,1,1.17.49,3.867,3.867,0,0,1,1.5,1.7,4,4,0,0,1,.3,1.21v.36a3.86,3.86,0,0,1-7.72,0Zm5.64-4.51V9.812a4.89,4.89,0,0,0,2.88-3.23,2.74,2.74,0,0,1,.51-.06h62.41a2.74,2.74,0,0,1,.51.06,4.89,4.89,0,0,0,2.88,3.23v100.26a4.858,4.858,0,0,0-2.92,3.34,3.862,3.862,0,0,1-.48.05H10.583a3.861,3.861,0,0,1-.48-.05,4.86,4.86,0,0,0-2.92-3.33ZM5.4,1.452a3.86,3.86,0,0,1,3.86,3.83,3.41,3.41,0,0,1-.05.46A3.83,3.83,0,0,1,8.843,7a3.91,3.91,0,0,1-1.36,1.52,3.76,3.76,0,0,1-1.22.51,3.43,3.43,0,0,1-.86.11,3.86,3.86,0,1,1,0-7.71Zm76.62,3.83a3.86,3.86,0,0,1-3.86,3.86,3.43,3.43,0,0,1-.86-.11,3.76,3.76,0,0,1-1.22-.51A3.91,3.91,0,0,1,74.723,7a3.83,3.83,0,0,1-.37-1.26,3.4,3.4,0,0,1,0-.46,3.86,3.86,0,0,1,7.72,0Zm-3.67,104.47h-.19a4.981,4.981,0,0,0-.78.08V10.082a4.992,4.992,0,0,0,.78.08h.19Zm-5-105.19a4.529,4.529,0,0,0-.08.74,2.3,2.3,0,0,0,0,.26H10.233a2.3,2.3,0,0,0,0-.26,4.53,4.53,0,0,0-.08-.74Zm-68.17,5.58h.19a4.992,4.992,0,0,0,.78-.08v99.73a4.981,4.981,0,0,0-.78-.08h-.19Zm5,105.3a4.809,4.809,0,0,0,.09-.85v-.15c0-.05.22,0,.34,0h62.71c.11,0,0,.1,0,.15a4.808,4.808,0,0,0,.09.85Z",
    transform: "translate(653.46 4239.563)",
    fill: "#212222"
  })));
};

/* harmony default export */ var whats_bluetooth_speaker_icons_IconSoundboks3 = (icons_IconSoundboks3_IconSoundboks3);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/explorer-pack/learn-more/whats-bluetooth-speaker/icons/IconPASystem.tsx
var whats_bluetooth_speaker_icons_IconPASystem_jsx = react_default.a.createElement;


var whats_bluetooth_speaker_icons_IconPASystem_IconPASystem = function IconPASystem() {
  return /*#__PURE__*/react_default.a.createElement("svg", {
    width: 81,
    height: 81,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react_default.a.createElement("g", {
    fill: "#212222"
  }, /*#__PURE__*/react_default.a.createElement("path", {
    d: "M33.417 39.027a1.16 1.16 0 1 0 2.32 0 1.16 1.16 0 0 0-2.32 0ZM10.09 40.194a1.16 1.16 0 1 0-.013-2.321 1.16 1.16 0 0 0 .014 2.32ZM34.577 74.774a1.167 1.167 0 1 0 1.103.713 1.158 1.158 0 0 0-1.103-.713ZM10.09 74.774a1.167 1.167 0 1 0-.013 2.333 1.167 1.167 0 0 0 .013-2.333ZM22.33 54.32a11.42 11.42 0 1 0 .04 22.839 11.42 11.42 0 0 0-.04-22.838Zm0 22.167a10.753 10.753 0 1 1 10.774-10.753 10.767 10.767 0 0 1-10.773 10.753Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M22.33 57.147a8.587 8.587 0 1 0 8.587 8.587 8.6 8.6 0 0 0-8.587-8.587Zm0 16.507a7.92 7.92 0 1 1 7.92-7.92 7.926 7.926 0 0 1-7.92 7.92Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M22.33 61.954a3.78 3.78 0 1 0 0 7.559 3.78 3.78 0 0 0 0-7.56Zm0 6.893a3.113 3.113 0 1 1 3.113-3.113 3.119 3.119 0 0 1-3.113 3.127v-.014ZM22.33 51.914a6.627 6.627 0 1 0-6.62-6.627 6.666 6.666 0 0 0 6.62 6.627Zm0-12.58a5.96 5.96 0 1 1-5.953 5.953 5.967 5.967 0 0 1 5.953-5.953Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M22.33 48.247a2.96 2.96 0 1 0 0-5.919 2.96 2.96 0 0 0 0 5.92Zm0-5.253a2.293 2.293 0 1 1-2.293 2.293 2.3 2.3 0 0 1 2.293-2.293Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M71.237 34.387H61.53a4.173 4.173 0 0 0 2-3.567V5.427a4.193 4.193 0 0 0-4.187-4.187H21.55a4.193 4.193 0 0 0-4.187 4.187v25.394a4.18 4.18 0 0 0 2 3.566H9.637a4.194 4.194 0 0 0-4.187 4.187v37.813a4.193 4.193 0 0 0 4.187 4.187H35.03a4.194 4.194 0 0 0 4.187-4.187V38.574a4.195 4.195 0 0 0-2-3.573h6.48a4.193 4.193 0 0 0-2 3.573v37.813a4.193 4.193 0 0 0 4.186 4.187h25.354a4.193 4.193 0 0 0 4.187-4.187V38.574a4.193 4.193 0 0 0-4.187-4.187ZM18.03 30.82V5.427a3.527 3.527 0 0 1 3.52-3.52h37.813a3.527 3.527 0 0 1 3.52 3.52v25.394a3.52 3.52 0 0 1-3.52 3.513H21.55a3.52 3.52 0 0 1-3.52-3.514Zm20.52 7.754v37.813a3.527 3.527 0 0 1-3.52 3.52H9.637a3.527 3.527 0 0 1-3.52-3.52V38.574a3.527 3.527 0 0 1 3.52-3.52H35.03a3.527 3.527 0 0 1 3.52 3.52Zm36.207 37.813a3.527 3.527 0 0 1-3.52 3.52H45.844a3.526 3.526 0 0 1-3.52-3.52V38.574a3.527 3.527 0 0 1 3.52-3.52h25.393a3.527 3.527 0 0 1 3.52 3.52v37.813Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M70.783 37.867a1.16 1.16 0 1 0 .014 2.32 1.16 1.16 0 0 0-.014-2.32ZM46.297 40.194a1.16 1.16 0 1 0 0-2.322 1.16 1.16 0 0 0 0 2.322ZM70.784 74.774a1.166 1.166 0 1 0 1.08.719 1.16 1.16 0 0 0-1.08-.72ZM46.296 74.774a1.167 1.167 0 1 0 1.074.72 1.16 1.16 0 0 0-1.074-.72ZM58.544 54.32a11.42 11.42 0 1 0 11.413 11.414A11.427 11.427 0 0 0 58.544 54.32Zm0 22.167A10.754 10.754 0 1 1 69.29 65.734a10.767 10.767 0 0 1-10.746 10.753Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M58.544 57.147a8.586 8.586 0 1 0-.054 17.173 8.586 8.586 0 0 0 .054-17.173Zm0 16.507a7.92 7.92 0 1 1 7.893-7.92 7.926 7.926 0 0 1-7.893 7.92Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M58.544 61.954a3.78 3.78 0 1 0 0 7.56 3.78 3.78 0 0 0 0-7.56Zm0 6.893a3.113 3.113 0 1 1 3.113-3.113 3.114 3.114 0 0 1-3.113 3.127v-.014ZM58.544 51.914a6.626 6.626 0 1 0 0-13.252 6.626 6.626 0 0 0 0 13.252Zm0-12.58a5.96 5.96 0 1 1-5.96 5.953 5.967 5.967 0 0 1 5.96-5.953Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M58.544 48.247a2.96 2.96 0 1 0-2.96-2.96 2.966 2.966 0 0 0 2.96 2.96Zm0-5.253a2.293 2.293 0 1 1-2.293 2.293 2.3 2.3 0 0 1 2.293-2.293ZM22.004 7.04a1.167 1.167 0 1 0-1.078-.714 1.16 1.16 0 0 0 1.078.714ZM23.163 30.367a1.168 1.168 0 1 0-2.335-.013 1.168 1.168 0 0 0 2.335.013ZM58.91 7.04a1.167 1.167 0 1 0 .054-2.332 1.167 1.167 0 0 0-.053 2.333ZM58.91 29.207a1.16 1.16 0 1 0 .013 2.32 1.16 1.16 0 0 0-.013-2.32ZM48.71 29.527a11.42 11.42 0 1 0-11.413-11.42 11.433 11.433 0 0 0 11.413 11.42Zm0-22.166a10.753 10.753 0 1 1-10.746 10.746A10.76 10.76 0 0 1 48.71 7.374V7.36Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M48.71 26.707a8.587 8.587 0 1 0-8.587-8.587 8.6 8.6 0 0 0 8.587 8.587Zm0-16.507a7.92 7.92 0 1 1-5.601 2.318 7.927 7.927 0 0 1 5.6-2.324v.006Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M48.71 21.9a3.78 3.78 0 1 0 0-7.558 3.78 3.78 0 0 0 0 7.559Zm0-6.893a3.113 3.113 0 1 1-3.113 3.114 3.12 3.12 0 0 1 3.114-3.114ZM28.263 24.747a6.627 6.627 0 1 0-6.626-6.626 6.666 6.666 0 0 0 6.626 6.626Zm0-12.58a5.961 5.961 0 1 1-5.96 5.954 5.96 5.96 0 0 1 5.96-5.927v-.027Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M28.264 21.08a2.96 2.96 0 1 0 0-5.92 2.96 2.96 0 0 0 0 5.92Zm0-5.253a2.293 2.293 0 1 1-2.294 2.293 2.3 2.3 0 0 1 2.294-2.293Z"
  })));
};

/* harmony default export */ var learn_more_whats_bluetooth_speaker_icons_IconPASystem = (whats_bluetooth_speaker_icons_IconPASystem_IconPASystem);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/explorer-pack/learn-more/whats-bluetooth-speaker/icons/IconSpeaker.tsx
var whats_bluetooth_speaker_icons_IconSpeaker_jsx = react_default.a.createElement;


var whats_bluetooth_speaker_icons_IconSpeaker_IconSpeaker = function IconSpeaker() {
  return /*#__PURE__*/react_default.a.createElement("svg", {
    width: 81,
    height: 81,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/react_default.a.createElement("g", {
    clipPath: "url(#a)",
    fill: "#212222"
  }, /*#__PURE__*/react_default.a.createElement("path", {
    d: "M25.297 41.767a10.6 10.6 0 1 0 10.6 10.6 10.607 10.607 0 0 0-10.6-10.6Zm0 20.533a9.934 9.934 0 1 1 9.934-9.933 9.946 9.946 0 0 1-9.934 9.933Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M25.297 47.747a4.62 4.62 0 1 0 4.62 4.62 4.627 4.627 0 0 0-4.62-4.62Zm0 8.567a3.953 3.953 0 1 1 0-7.907 3.953 3.953 0 0 1 0 7.907ZM21.284 69.794a1.167 1.167 0 1 0 1.073.72 1.16 1.16 0 0 0-1.073-.72ZM29.31 69.794a1.167 1.167 0 1 0-.013 2.333 1.167 1.167 0 0 0 .013-2.333ZM56.297 41.767a10.6 10.6 0 1 0 10.6 10.6 10.614 10.614 0 0 0-10.6-10.6Zm0 20.533a9.934 9.934 0 1 1 9.934-9.933 9.946 9.946 0 0 1-9.934 9.933Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "M56.297 47.747a4.62 4.62 0 1 0 4.667 4.62 4.625 4.625 0 0 0-4.667-4.62Zm0 8.567a3.953 3.953 0 1 1 .093-7.905 3.953 3.953 0 0 1-.093 7.905ZM52.297 69.794a1.167 1.167 0 1 0 1.08.719 1.159 1.159 0 0 0-1.08-.72ZM60.296 69.794a1.167 1.167 0 1 0 1.074.72 1.16 1.16 0 0 0-1.074-.72Z"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    d: "m76.784 68.654-.667-1.86a1.333 1.333 0 0 0-1.334-.88l-.526-1.474a.355.355 0 0 0-.667.24l.52 1.474a1.334 1.334 0 0 0-.493 1.547l.666 1.853a.841.841 0 0 0 .434.486c.115.053.24.08.367.08a.872.872 0 0 0 .286-.053l.233-.08a3.794 3.794 0 0 1-.446 3.574c-1.114 1.48-3.26 2.093-4.627 2.106v-35.42a3.013 3.013 0 0 0-3.007-3.007h-22.4a3.013 3.013 0 0 0-3.006 3.007v34.127c-1.227-.053-2.153-.04-2.627 0V40.247a3.013 3.013 0 0 0-3.007-3.007H14.11a3.013 3.013 0 0 0-3.006 3.007v37.334a3.013 3.013 0 0 0 3.006 3.006h22.373a3.013 3.013 0 0 0 3.007-3.007v-2.546c.453 0 1.393-.034 2.627 0v2.526a3.013 3.013 0 0 0 3.007 3.007h22.373a3.013 3.013 0 0 0 3.007-3.006v-1.227c1.526 0 3.913-.72 5.16-2.38a4.506 4.506 0 0 0 .54-4.2h.073a.847.847 0 0 0 .507-1.1Zm-37.96 8.913a2.346 2.346 0 0 1-2.34 2.34H14.11a2.34 2.34 0 0 1-2.34-2.34V40.234a2.34 2.34 0 0 1 2.34-2.34h22.373a2.347 2.347 0 0 1 2.34 2.34v37.333Zm31.013 0a2.34 2.34 0 0 1-2.34 2.34H45.124a2.346 2.346 0 0 1-2.34-2.34V40.234a2.347 2.347 0 0 1 2.34-2.34h22.373a2.34 2.34 0 0 1 2.34 2.34v37.333Zm5.28-8.126a.174.174 0 0 1-.14 0 .154.154 0 0 1-.094-.1l-.666-1.86a.665.665 0 0 1 0-.514.667.667 0 0 1 .113-.153l.614-.22a.667.667 0 0 1 .526.433l.667 1.853a.174.174 0 0 1 0 .14.153.153 0 0 1-.1.094l-.92.326Z"
  })), /*#__PURE__*/react_default.a.createElement("defs", null, /*#__PURE__*/react_default.a.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/react_default.a.createElement("path", {
    fill: "#fff",
    transform: "translate(11.104 37.24)",
    d: "M0 0h65.733v43.333H0z"
  }))));
};

/* harmony default export */ var learn_more_whats_bluetooth_speaker_icons_IconSpeaker = (whats_bluetooth_speaker_icons_IconSpeaker_IconSpeaker);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/explorer-pack/learn-more/whats-bluetooth-speaker/index.web.tsx
var explorer_pack_learn_more_whats_bluetooth_speaker_index_web_jsx = react_default.a.createElement;








 // eslint-disable-next-line prefer-arrow-callback

var learn_more_whats_bluetooth_speaker_index_web_WhatsBluetoothSpeaker = /*#__PURE__*/react_default.a.memo(function WhatsBluetoothSpeaker() {
  var icons = [{
    packageItemId: 'bt-speakers',
    title: 'BT Speakers',
    icon: /*#__PURE__*/react_default.a.createElement(learn_more_whats_bluetooth_speaker_icons_IconSpeaker, null)
  }, {
    packageItemId: 'soundboks-gen-3-rf',
    title: 'SOUNDBOKS (Gen. 3)',
    icon: /*#__PURE__*/react_default.a.createElement(whats_bluetooth_speaker_icons_IconSoundboks3, null)
  }, {
    packageItemId: 'pa-systems',
    title: 'PA Systems',
    icon: /*#__PURE__*/react_default.a.createElement(learn_more_whats_bluetooth_speaker_icons_IconPASystem, null)
  }];
  var attributeData = [{
    text: 'Concert-level Volumne',
    checks: [false, true, true]
  }, {
    text: 'Crowd-ready Durability',
    checks: [false, true, false]
  }, {
    text: 'Bluetooth Connectivity',
    checks: [true, true, false]
  }, {
    text: '6-second Setup',
    checks: [true, true, false]
  }, {
    text: 'Swappable Battery',
    checks: [false, true, false]
  }, {
    text: 'Wirelessly Pairable',
    checks: [true, true, false]
  }, {
    text: 'Microphone & Instrument Inputs',
    checks: [false, true, false]
  }, {
    text: 'App Compatibility',
    checks: [true, true, false]
  }, {
    text: 'Upgradable Features (Via App)',
    checks: [false, true, false]
  }];
  return /*#__PURE__*/react_default.a.createElement(whats_bluetooth_speaker_styled_Table, null, /*#__PURE__*/react_default.a.createElement(explorer_pack_learn_more_whats_bluetooth_speaker_styled_ImageWrapper, null, /*#__PURE__*/react_default.a.createElement(whats_bluetooth_speaker_styled_EmptyCell, null), icons.map(function (image, index) {
    return /*#__PURE__*/react_default.a.createElement("div", {
      key: image.packageItemId + index
    }, image.icon);
  })), /*#__PURE__*/react_default.a.createElement(whats_bluetooth_speaker_styled_ImageTextWrapper, null, /*#__PURE__*/react_default.a.createElement(whats_bluetooth_speaker_styled_EmptyCell, null), icons.map(function (image, index) {
    return /*#__PURE__*/react_default.a.createElement("div", {
      key: image.title + index,
      style: {
        width: '80px',
        margin: '0 auto'
      }
    }, image.title);
  })), /*#__PURE__*/react_default.a.createElement(HorizontalLine, {
    color: styles_theme["a" /* default */].colors.white
  }), attributeData.map(function (row, index) {
    return /*#__PURE__*/react_default.a.createElement(learn_more_whats_bluetooth_speaker_attribute_row_AttributeRow, {
      key: row.text + index,
      text: row.text,
      checks: row.checks
    });
  }), /*#__PURE__*/react_default.a.createElement(whats_bluetooth_speaker_styled_LastParagraph, null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.learn-more.whats-bluetooth-speaker"
  })));
});
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/explorer-pack/learn-more/content.tsx
var explorer_pack_learn_more_content_jsx = react_default.a.createElement;








var explorer_pack_learn_more_content_packageItems = [{
  packageItemId: 'soundboks-gen-3-rf',
  title: 'Soundboks (Gen 3)',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconSoundboks3, null)
}, {
  packageItemId: 'backpack',
  title: 'Backpack',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconSB3Backpack, null)
}, {
  packageItemId: 'batteryboks',
  title: 'Batteryboks',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconBattery, null)
}, {
  packageItemId: 'extra-batteryboks',
  title: 'Extra Batteryboks',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconBattery, null)
}, {
  packageItemId: 'charger',
  title: 'Charger',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconCharger, null)
}, {
  packageItemId: 'backpack-manual',
  title: 'Backpack Manual',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconManual, null),
  downloadUrl: backpack["default"]
}, {
  packageItemId: 'soundboks-gen-3-manual',
  title: 'Manual',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconManual, null),
  downloadUrl: soundboks3["default"]
}];
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/explorer-pack/learn-more/tech-spec/styled.ts

var tech_spec_styled_DescList = styled_components_browser_esm["default"].dl.withConfig({
  displayName: "styled__DescList",
  componentId: "qvhhx7-0"
})(["margin:20px 0 0 0;"]);
var tech_spec_styled_DescTitle = styled_components_browser_esm["default"].dt.withConfig({
  displayName: "styled__DescTitle",
  componentId: "qvhhx7-1"
})(["margin:0;"]);
var tech_spec_styled_DescDetails = styled_components_browser_esm["default"].dd.withConfig({
  displayName: "styled__DescDetails",
  componentId: "qvhhx7-2"
})(["margin:0;"]);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/explorer-pack/learn-more/tech-spec/index.web.tsx
var explorer_pack_learn_more_tech_spec_index_web_jsx = react_default.a.createElement;





 // eslint-disable-next-line prefer-arrow-callback

var learn_more_tech_spec_index_web_TechSpec = /*#__PURE__*/react_default.a.memo(function TechSpec() {
  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, null, /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "SOUND"
  })), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "AMPLIFIER"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Merus Audio eximo\xAE amp switching"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "3 \xD7 72W RMS class D amplifiers"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Advanced Bass DSP"
  })))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "ACOUSTICS"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Effective frequency range: 40Hz - 20kHz"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Custom sound profile with bass enhancer"
  })))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "DRIVER UNITS"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "2 \xD7 10\u201D 96dB woofers"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "1 \xD7 1\u201D 104dB compression driver tweeter"
  })))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "CONNECTIVITY"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Bluetooth 5.0"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "TeamUP connection"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Wirelessly connect up to 5 (total) nearby New SOUNDBOKS(2019) speakers (SKAA network)"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Pro Panel"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA 2 \xD7 Combo microphone/instrument (XLR, 1/4\u201D) input"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA 1 \xD7 3.5mm Stereo Input"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA 1 \xD7 3.5mm Stereo Output"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Bond Button for advanced JOIN settings"
  })))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "BUILD"
  })), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "WEIGHT"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "34 pounds (15.4 kg)"
  })))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "MATERIALS"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Poplar cabinet"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Powder-coated aluminum frame"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Powder-coated steel grill and handles"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Silicone ball corners"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "SMP temperature-flex adhesive"
  })))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "DIMENSIONS"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "66 \xD7 43 \xD7 32 cm / 25.6 \xD7 17 \xD7 13 inches (H \xD7 W \xD7 D)"
  })))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "FEATURES"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Swappable grill and batteries"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "IP65 rated electronics coating"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Pulse Reflex Port"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "UI Panel"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Volume control"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Host/Join mode for wireless TeamUP"
  })))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "BATTERY"
  })), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "LIFE"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "40 hours at mid-volume"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "5 hours at full volume"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "3.5 hours full recharge"
  })))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "DESIGN"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "5-step LED battery-life indicator"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Heavy-duty DC-connector"
  })))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "CELL TYPE"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "12.8V, 7.8Ah Lithium Iron Phosphate (LiFePO4)"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "-10C to 40C temperature range"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "99.84Wh or 7.8Ah capacity"
  })))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "BATTERY MANAGEMENT SYSTEM (BMS)"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Over and under-discharge protection"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Short circuit protection"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Overheat protection"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Cell voltage management"
  })))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app"
  })), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.soundSettings"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.soundSettings.1"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.soundSettings.2"
  })))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.proPanel"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.proPanel.1"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.proPanel.2"
  })))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.1"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.2"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.3"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.4"
  })))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings.1"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings.2"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings.3"
  })))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.firmwareUpdate"
  }))), /*#__PURE__*/react_default.a.createElement(tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.firmwareUpdate.1"
  })))));
});
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/explorer-pack/learn-more/styled.ts



var explorer_pack_learn_more_styled_LayoutContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__LayoutContainer",
  componentId: "qtt3lc-0"
})(["padding:0 190px;background-color:", ";@media ", "{padding:0 24px;}"], elements_theme["a" /* Color */].WhiteOff, styles_theme["a" /* default */].breakpoints.maxMobile);
var explorer_pack_learn_more_styled_Link = styled_components_browser_esm["default"].a.withConfig({
  displayName: "styled__Link",
  componentId: "qtt3lc-1"
})(["color:", ";cursor:pointer;text-decoration:underline;"], elements_theme["a" /* Color */].Orange);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/explorer-pack/learn-more/faqs/index.web.tsx
var explorer_pack_learn_more_faqs_index_web_jsx = react_default.a.createElement;





// eslint-disable-next-line prefer-arrow-callback
var learn_more_faqs_index_web_FAQs = /*#__PURE__*/react_default.a.memo(function FAQs() {
  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    padding: {
      right: 10
    }
  }, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.explorer-pack.learn-more.faqs.question-1"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.explorer-pack.learn-more.faqs.answer-1"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.explorer-pack.learn-more.faqs.question-2"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.explorer-pack.learn-more.faqs.answer-2"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.explorer-pack.learn-more.faqs.question-3"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.explorer-pack.learn-more.faqs.answer-3"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.explorer-pack.learn-more.faqs.question-4"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.explorer-pack.learn-more.faqs.answer-4"
  }));
});
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/explorer-pack/learn-more/index.tsx
var explorer_pack_learn_more_jsx = react_default.a.createElement;


















var explorer_pack_learn_more_LearnMoreSection = function LearnMoreSection(_ref) {
  var extraBattery = _ref.extraBattery,
      locale = _ref.locale;

  var _useSelector = Object(es["d" /* useSelector */])(function (state) {
    return state.settings;
  }),
      regionId = _useSelector.regionId;

  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(explorer_pack_learn_more_LayoutContainer, null, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(elements_typography["e" /* Heading02 */], {
      ariaLevel: elements_typography["h" /* TextLevel */].H2,
      style: {
        textTransform: 'uppercase',
        textAlign: 'center'
      }
    }, i18n._('product.learn-more.heading')), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "35px"
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.whats-in-the-box",
      content: /*#__PURE__*/react_default.a.createElement(learn_more_whats_in_the_box_index_web_WhatsInTheBox, {
        extraBattery: extraBattery,
        packageItems: explorer_pack_learn_more_content_packageItems
      }),
      topItem: true
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.tech-specs",
      content: /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_index_web_TechSpec, null)
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.whats-a-bluetooth-performance-speaker",
      content: /*#__PURE__*/react_default.a.createElement(learn_more_whats_bluetooth_speaker_index_web_WhatsBluetoothSpeaker, null)
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.shipping",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: learn_more_content_content.shipping[regionId] || learn_more_content_content.shipping["default"],
        components: [/*#__PURE__*/react_default.a.createElement(explorer_pack_learn_more_styled_Link, {
          href: helpCenter_getHelpCenterUrl(locale, '/sections/360003609413-SHIPPING')
        }), /*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement("br", null)]
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.warranty",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "product.learn-more.warranty.info",
        components: [/*#__PURE__*/react_default.a.createElement(explorer_pack_learn_more_styled_Link, {
          href: helpCenter_getHelpCenterUrl(locale, '/articles/211920329-RETURN-AND-REFUND-POLICY-AND-PROCESS')
        })]
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.payment-options",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "product.learn-more.payment-options.info"
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.faqs",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(learn_more_faqs_index_web_FAQs, null))
    })));
  });
};

var explorer_pack_learn_more_LayoutContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "learn-more__LayoutContainer",
  componentId: "sc-1bz8kk4-0"
})(["max-width:1062px;width:100%;@media ", "{padding:0 24px;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
/* harmony default export */ var explorer_pack_learn_more = (explorer_pack_learn_more_LearnMoreSection);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/explorer-pack/product-review/styled.tsx


var explorer_pack_product_review_styled_StyledHorizontalLine = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__StyledHorizontalLine",
  componentId: "sc-1d242aa-0"
})(["display:none;@media ", "{display:block;padding:0px 24px;}"], styles_theme["a" /* default */].breakpoints.maxMobile);
var explorer_pack_product_review_styled_LayoutContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__LayoutContainer",
  componentId: "sc-1d242aa-1"
})(["position:relative;width:100%;max-width:1024px;text-align:center;align-self:center;@media ", "{max-width:720px;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/explorer-pack/product-review/index.tsx
var explorer_pack_product_review_jsx = react_default.a.createElement;











var explorer_pack_product_review_ProductReviewSection = function ProductReviewSection() {
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref) {
    var i18n = _ref.i18n;
    return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(explorer_pack_product_review_styled_LayoutContainer, null, /*#__PURE__*/react_default.a.createElement(elements_typography["e" /* Heading02 */], {
      ariaLevel: elements_typography["h" /* TextLevel */].H2,
      color: elements_theme["a" /* Color */].Orange,
      style: {
        textTransform: 'uppercase'
      }
    }, i18n._('product.reviews.heading'))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    }), /*#__PURE__*/react_default.a.createElement(explorer_pack_product_review_styled_StyledHorizontalLine, null, /*#__PURE__*/react_default.a.createElement(HorizontalLine, {
      color: elements_theme["a" /* Color */].WhiteOff
    }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    })), /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(index_web_VideoFeature, {
      videos: [{
        YouTubeId: 'FuD9ujTbZCE',
        children: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "The world's LOUDEST portable speaker for DJs?")
      }, {
        YouTubeId: 'JrGlmymabNg',
        children: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "Soundboks Update - New Sound Modes New Features")
      }, {
        YouTubeId: 'j9WFgrGU5ro',
        children: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "The world's Loudest Wireless Speaker")
      }],
      height: "184px"
    })), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    }), /*#__PURE__*/react_default.a.createElement(explorer_pack_product_review_styled_StyledHorizontalLine, null, /*#__PURE__*/react_default.a.createElement(HorizontalLine, {
      color: elements_theme["a" /* Color */].WhiteOff
    }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    })), /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(Trustbox, null)));
  });
};

/* harmony default export */ var explorer_pack_product_review = (explorer_pack_product_review_ProductReviewSection);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/explorer-pack/related-products/index.tsx
var explorer_pack_related_products_jsx = react_default.a.createElement;






var explorer_pack_related_products_RelatedProductsSection = function RelatedProductsSection(_ref) {
  var relatedProducts = _ref.relatedProducts;
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      grow: 1
    }, /*#__PURE__*/react_default.a.createElement(RelatedProducts, {
      relatedProducts: relatedProducts,
      headline: i18n._('product.related-products.heading')
    })));
  });
};

/* harmony default export */ var explorer_pack_related_products = (explorer_pack_related_products_RelatedProductsSection);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/explorer-pack/index.tsx
var explorer_pack_jsx = react_default.a.createElement;


















var explorer_pack_paths = [{
  label: 'Home',
  url: '/'
}, {
  label: 'Bundles',
  url: '/products/?filter=bundles'
}, {
  label: 'Explorer Pack'
}];
var explorer_pack_options = {
  grillColor: 'Color'
};
var explorer_pack_klarnaData = {
  de: {
    klarnaLocale: 'de-DE',
    klarnaClassName: 'klarna-pricetag-de'
  },
  no: {
    klarnaLocale: 'no-NO',
    klarnaClassName: 'klarna-pricetag-no'
  },
  da: {
    klarnaLocale: 'da-DK',
    klarnaClassName: 'klarna-pricetag-dk'
  }
};
var explorer_pack_colorOptions = [{
  id: 'Black',
  label: 'Black',
  value: '#000000'
}, {
  id: 'Orange',
  label: 'Orange',
  value: '#FA4616'
}, {
  id: 'White',
  label: 'White',
  value: '#FFFFFF'
} // Temporarly removed till further instructions
// { id: 'Blue', label: 'Blue', value: '#19415E' },
// { id: 'Red', label: 'Red', value: '#AA273B' },
];

var explorer_pack_ExplorerPack = function ExplorerPack(_ref) {
  var productData = _ref.productData,
      dispatchAddCartItem = _ref.dispatchAddCartItem;

  var _useSelector = Object(es["d" /* useSelector */])(function (state) {
    return state;
  }),
      settings = _useSelector.settings;

  var regionId = settings.regionId;
  var overview = Object(react["useRef"])(null);
  var learnMore = Object(react["useRef"])(null);
  var reviews = Object(react["useRef"])(null);
  var relatedProducts = Object(react["useRef"])(null);

  var _useState = Object(react["useState"])(),
      anchorStack = _useState[0],
      setAnchorStack = _useState[1];

  var _useState2 = Object(react["useState"])(),
      selectedAnchor = _useState2[0],
      setSelectedAnchor = _useState2[1];

  var _useState3 = Object(react["useState"])(false),
      isHeaderVisibility = _useState3[0],
      setIsHeaderVisibility = _useState3[1];

  var _useState4 = Object(react["useState"])(),
      productVariant = _useState4[0],
      setProductVariant = _useState4[1];

  var _useState5 = Object(react["useState"])(),
      selectedColor = _useState5[0],
      setSelectedColor = _useState5[1];

  var _useState6 = Object(react["useState"])(),
      avalibleColors = _useState6[0],
      setAvalibleColors = _useState6[1];

  var productCategories = Object(mergeUACategories["a" /* default */])(abstractProducts_default.a.byId[productData.handle].categories);

  var _useState7 = Object(react["useState"])(true),
      allowImageInteractionTracking = _useState7[0],
      setAllowImageInteractionTracking = _useState7[1];

  var _useState8 = Object(react["useState"])(0),
      trackImageInteractionLimit = _useState8[0],
      setTrackImageInteractionLimit = _useState8[1];

  var router = Object(next_router["useRouter"])();
  var offset = 124;
  Object(react["useEffect"])(function () {
    var initialStack = [{
      label: 'products.subnavigation.achor.overview',
      ref: overview
    }, {
      label: 'products.subnavigation.achor.learn-more',
      ref: learnMore
    }, {
      label: 'products.subnavigation.achor.reviews',
      ref: reviews
    }, {
      label: 'products.subnavigation.achor.related-products',
      ref: relatedProducts
    }];
    setAnchorStack(initialStack);

    var handleScroll = function handleScroll() {
      var stackIndex = initialStack.findIndex(function (stack) {
        return stack.ref.current.getBoundingClientRect().y - offset > 0;
      });
      var stack = stackIndex === -1 ? initialStack[initialStack.length - 1] : initialStack[stackIndex - 1];
      setSelectedAnchor(stack.ref.current);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return function () {
      return window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  var handleHeaderVisibility = function handleHeaderVisibility(isVisibility) {
    setIsHeaderVisibility(isVisibility);
  };

  Object(react["useEffect"])(function () {
    var defaultOption = productData.variants.find(function (variant) {
      return variant.sku;
    });
    var optionsFromUrlQueries = productData.variants.find(function (variant) {
      return variant.options[explorer_pack_options.grillColor] === router.query[explorer_pack_options.grillColor];
    });
    var defaultVariant = optionsFromUrlQueries || defaultOption;
    setSelectedColor(defaultVariant === null || defaultVariant === void 0 ? void 0 : defaultVariant.options[explorer_pack_options.grillColor]);
    var variantColors = productData.variants.map(function (variant) {
      return variant.options[explorer_pack_options.grillColor];
    });
    var colors = explorer_pack_colorOptions.filter(function (_ref2) {
      var id = _ref2.id;
      return variantColors.includes(id);
    });
    setAvalibleColors(colors);
    setProductVariant(defaultVariant);
  }, [productData, router.query]);

  var refreshData = function refreshData(color) {
    var regionCheck = regionId === 'na' ? '' : "/".concat(regionId);
    window.history.replaceState(null, "".concat(regionCheck, "/products/explorer-pack/"), "".concat(regionCheck, "/products/explorer-pack/?Grill+Color=").concat(color));
  };

  var handleColorSelector = function handleColorSelector(color) {
    var nextVariant = productData.variants.find(function (variant) {
      return variant.options[explorer_pack_options.grillColor] === color;
    });
    setSelectedColor(color);
    setAllowImageInteractionTracking(true);
    setTrackImageInteractionLimit(0);
    refreshData(color);
    setProductVariant(nextVariant);
  };

  Object(react["useEffect"])(function () {
    if (productVariant) {
      var productImages = Object(getProductImages["a" /* default */])(productData.handle, productVariant.sku);
      var imageUrl = productImages.length ? productImages[0].url : '';
      var timer = setTimeout(function () {
        return Object(utils["i" /* trackProductPageview */])({
          name: productData.title,
          id: productVariant.sku,
          price: productVariant.price,
          brand: 'soundboks',
          category: productCategories,
          variant: productVariant.title,
          image: imageUrl
        });
      }, 1000);
      return function () {
        return clearTimeout(timer);
      };
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [regionId, productVariant]);

  var handleAddToCart = function handleAddToCart() {
    console.log('handleAddToCart', productVariant);

    if (productVariant.available) {
      dispatchAddCartItem(productVariant.id, 1, true);
    } else {
      console.log('join waitinglist dialog');
    }
  };

  var financialServices = function financialServices(variantPrice) {
    var locale = productData.locale;
    var klarnaAvailable = locale === 'de' || locale === 'no' || locale === 'da';
    var affirmAvailable = locale === 'en-US';
    return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, affirmAvailable && /*#__PURE__*/react_default.a.createElement(index_web_AffirmService, {
      price: variantPrice,
      locale: locale,
      isBlackTheme: true
    }), klarnaAvailable && /*#__PURE__*/react_default.a.createElement(index_web_KlarnaService, {
      price: variantPrice,
      locale: explorer_pack_klarnaData[locale].klarnaLocale,
      klarnaClassName: explorer_pack_klarnaData[locale].klarnaClassName
    }));
  };

  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    backgroundColor: elements_theme["a" /* Color */].Charcoal
  }, /*#__PURE__*/react_default.a.createElement(sub_navigation_SubNavigation, {
    productData: productData,
    productVariant: productVariant,
    anchorStack: anchorStack,
    selectedAnchor: selectedAnchor,
    isHeaderVisibility: isHeaderVisibility,
    offset: offset,
    handleAddToCart: handleAddToCart
  }), /*#__PURE__*/react_default.a.createElement("div", {
    ref: overview
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '24px',
      desktop: '46px'
    }
  }), /*#__PURE__*/react_default.a.createElement(explorer_pack_product_overview, {
    paths: explorer_pack_paths,
    offset: offset,
    anchorStack: anchorStack,
    productData: productData,
    productVariant: productVariant,
    onHeaderVisibility: handleHeaderVisibility,
    handleColorSelector: handleColorSelector,
    avalibleColors: avalibleColors,
    selectedColor: selectedColor,
    handleAddToCart: handleAddToCart,
    financialServices: financialServices,
    allowImageInteractionTracking: allowImageInteractionTracking,
    setAllowImageInteractionTracking: setAllowImageInteractionTracking,
    trackImageInteractionLimit: trackImageInteractionLimit,
    setTrackImageInteractionLimit: setTrackImageInteractionLimit
  })), /*#__PURE__*/react_default.a.createElement(explorer_pack_styled_BackgroundImage, null), /*#__PURE__*/react_default.a.createElement("div", {
    ref: learnMore
  }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    alignContentHorizontal: "center",
    backgroundColor: elements_theme["a" /* Color */].WhiteOff
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }), /*#__PURE__*/react_default.a.createElement(explorer_pack_learn_more, {
    locale: productData.locale
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }))), /*#__PURE__*/react_default.a.createElement("div", {
    ref: reviews
  }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    backgroundColor: elements_theme["a" /* Color */].White
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }), /*#__PURE__*/react_default.a.createElement(explorer_pack_product_review, null), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }))), /*#__PURE__*/react_default.a.createElement("div", {
    ref: relatedProducts
  }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    backgroundColor: elements_theme["a" /* Color */].WhiteOff
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }), /*#__PURE__*/react_default.a.createElement(explorer_pack_related_products, {
    relatedProducts: productData.crossSellHandles
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '60px',
      desktop: '72px'
    }
  }))));
};

/* harmony default export */ var explorer_pack = (explorer_pack_ExplorerPack);
// EXTERNAL MODULE: ./components/pages/products-v2/bundles/elevation-pack/assets/ElevationPack-lifestyle-large.jpg
var ElevationPack_lifestyle_large = __webpack_require__("TCdS");
var ElevationPack_lifestyle_large_default = /*#__PURE__*/__webpack_require__.n(ElevationPack_lifestyle_large);

// EXTERNAL MODULE: ./components/pages/products-v2/bundles/elevation-pack/assets/ElevationPack-lifestyle-small.jpg
var ElevationPack_lifestyle_small = __webpack_require__("sW8a");
var ElevationPack_lifestyle_small_default = /*#__PURE__*/__webpack_require__.n(ElevationPack_lifestyle_small);

// CONCATENATED MODULE: ./components/pages/products-v2/bundles/elevation-pack/styled.ts




var elevation_pack_styled_BackgroundImage = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__BackgroundImage",
  componentId: "sc-1sczv8z-0"
})(["display:block;width:100%;height:400px;background-image:url(", ");background-repeat:no-repeat;background-size:cover;background-position:center;@media ", "{height:852px;padding:20px;background-size:contain;background-position:center;background-image:url(", ");}"], ElevationPack_lifestyle_large_default.a.url, styles_theme["a" /* default */].breakpoints.tablet, ElevationPack_lifestyle_small_default.a.url);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/elevation-pack/product-overview/index.tsx
var elevation_pack_product_overview_jsx = react_default.a.createElement;






var elevation_pack_product_overview_ProductOverviewSection = function ProductOverviewSection(_ref) {
  var productData = _ref.productData,
      paths = _ref.paths,
      onHeaderVisibility = _ref.onHeaderVisibility,
      handleColorSelector = _ref.handleColorSelector,
      handleBatterySelector = _ref.handleBatterySelector,
      productVariant = _ref.productVariant,
      avalibleColors = _ref.avalibleColors,
      selectedColor = _ref.selectedColor,
      handleAddToCart = _ref.handleAddToCart,
      financialServices = _ref.financialServices,
      offset = _ref.offset,
      anchorStack = _ref.anchorStack,
      allowImageInteractionTracking = _ref.allowImageInteractionTracking,
      setAllowImageInteractionTracking = _ref.setAllowImageInteractionTracking,
      trackImageInteractionLimit = _ref.trackImageInteractionLimit,
      setTrackImageInteractionLimit = _ref.setTrackImageInteractionLimit;
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentHorizontal: "center",
      padding: {
        right: 24,
        left: 24
      }
    }, /*#__PURE__*/react_default.a.createElement(index_web_ProductOverview, {
      paths: paths,
      offset: offset,
      anchorStack: anchorStack,
      productData: productData,
      handleColorSelector: handleColorSelector,
      handleBatterySelector: handleBatterySelector,
      productVariant: productVariant,
      avalibleColors: avalibleColors,
      selectedColor: selectedColor,
      handleAddToCart: handleAddToCart,
      financialServices: financialServices,
      allowImageInteractionTracking: allowImageInteractionTracking,
      setAllowImageInteractionTracking: setAllowImageInteractionTracking,
      trackImageInteractionLimit: trackImageInteractionLimit,
      setTrackImageInteractionLimit: setTrackImageInteractionLimit,
      labels: {
        grillColor: {
          label: i18n._('product.option.label.grill-color'),
          options: {
            Black: i18n._('product.option.label.black'),
            Orange: i18n._('product.option.label.orange'),
            White: i18n._('product.option.label.white'),
            Blue: i18n._('product.option.label.blue'),
            Red: i18n._('product.option.label.red')
          }
        },
        // extraBattery: {
        //   label: i18n._('product.option.label.extra-battery'),
        //   options: {
        //     yes: i18n._('product.option.label.yes'),
        //     no: i18n._('product.option.label.no'),
        //   },
        // },
        addToCart: i18n._('product.buy-page.button.addToCart'),
        outOfStock: i18n._('product.buy-page.button.outOfStock'),
        waitlist: i18n._('product.buy-page.button.waitlist'),
        usp: {
          warranty: i18n._('product.usp.warranty'),
          freeReturns: i18n._('product.usp.free-returns'),
          freeShipping: i18n._('product.usp.free-shipping'),
          premiumSupport: i18n._('product.usp.premium-support'),
          compatibility: i18n._('product.usp.compatibility')
        }
      },
      onHeaderVisibility: onHeaderVisibility
    }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    }));
  });
};

/* harmony default export */ var elevation_pack_product_overview = (elevation_pack_product_overview_ProductOverviewSection);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/elevation-pack/learn-more/whats-in-the-box/styled.ts


var elevation_pack_learn_more_whats_in_the_box_styled_IconWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__IconWrapper",
  componentId: "sc-1m5pf13-0"
})(["display:block;"]);
var elevation_pack_learn_more_whats_in_the_box_styled_Layout = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Layout",
  componentId: "sc-1m5pf13-1"
})(["display:flex;flex-direction:row;justify-content:space-evenly;padding:10px 50px;align-items:end;@media ", "{display:grid;grid-template-columns:1fr 1fr;grid-gap:30px;padding:15px 0px;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
var elevation_pack_learn_more_whats_in_the_box_styled_Link = styled_components_browser_esm["default"].a.withConfig({
  displayName: "styled__Link",
  componentId: "sc-1m5pf13-2"
})(["text-decoration:underline;"]);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/elevation-pack/learn-more/whats-in-the-box/index.web.tsx
var elevation_pack_learn_more_whats_in_the_box_index_web_jsx = react_default.a.createElement;





// eslint-disable-next-line prefer-arrow-callback
var elevation_pack_learn_more_whats_in_the_box_index_web_WhatsInTheBox = /*#__PURE__*/react_default.a.memo(function WhatsInTheBox(_ref) {
  var packageItems = _ref.packageItems,
      extraBattery = _ref.extraBattery;
  return /*#__PURE__*/react_default.a.createElement(elevation_pack_learn_more_whats_in_the_box_styled_Layout, null, packageItems.filter(function (item) {
    return !extraBattery ? item.packageItemId !== 'extra-batteryboks' : item;
  }).map(function (_ref2) {
    var packageItemId = _ref2.packageItemId,
        title = _ref2.title,
        icon = _ref2.icon,
        downloadUrl = _ref2.downloadUrl;
    return /*#__PURE__*/react_default.a.createElement("div", {
      key: packageItemId
    }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(elevation_pack_learn_more_whats_in_the_box_styled_IconWrapper, null, icon), /*#__PURE__*/react_default.a.createElement(spacer_Spacer, {
      height: 10
    }), /*#__PURE__*/react_default.a.createElement(elements_typography["d" /* Caption02 */], null, title, " ", downloadUrl ? /*#__PURE__*/react_default.a.createElement(elevation_pack_learn_more_whats_in_the_box_styled_Link, {
      href: downloadUrl,
      target: "_blank"
    }, "Download") : null)));
  }));
});
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/elevation-pack/learn-more/content.tsx
var elevation_pack_learn_more_content_jsx = react_default.a.createElement;








var elevation_pack_learn_more_content_packageItems = [{
  packageItemId: 'soundboks-gen-3-rf',
  title: 'Soundboks (Gen 3)',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconSoundboks3, null)
}, {
  packageItemId: 'batteryboks',
  title: 'Batteryboks',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconBattery, null)
}, {
  packageItemId: 'extra-batteryboks',
  title: 'Extra Batteryboks',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconBattery, null)
}, {
  packageItemId: 'tripod',
  title: 'Tripod',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconTripod, null)
}, {
  packageItemId: 'tripod-backpack',
  title: 'Tripod Backpack',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconTripodBackpack, null)
}, {
  packageItemId: 'charger',
  title: 'Charger',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconCharger, null)
}, {
  packageItemId: 'soundboks-gen-3-manual',
  title: 'Manual',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconManual, null),
  downloadUrl: soundboks3["default"]
}];
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/elevation-pack/learn-more/tech-spec/styled.ts

var learn_more_tech_spec_styled_DescList = styled_components_browser_esm["default"].dl.withConfig({
  displayName: "styled__DescList",
  componentId: "swtdse-0"
})(["margin:20px 0 0 0;"]);
var learn_more_tech_spec_styled_DescTitle = styled_components_browser_esm["default"].dt.withConfig({
  displayName: "styled__DescTitle",
  componentId: "swtdse-1"
})(["margin:0;"]);
var learn_more_tech_spec_styled_DescDetails = styled_components_browser_esm["default"].dd.withConfig({
  displayName: "styled__DescDetails",
  componentId: "swtdse-2"
})(["margin:0;"]);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/elevation-pack/learn-more/tech-spec/index.web.tsx
var elevation_pack_learn_more_tech_spec_index_web_jsx = react_default.a.createElement;





 // eslint-disable-next-line prefer-arrow-callback

var elevation_pack_learn_more_tech_spec_index_web_TechSpec = /*#__PURE__*/react_default.a.memo(function TechSpec() {
  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, null, /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "SOUND"
  })), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "AMPLIFIER"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Merus Audio eximo\xAE amp switching"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "3 \xD7 72W RMS class D amplifiers"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Advanced Bass DSP"
  })))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "ACOUSTICS"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Effective frequency range: 40Hz - 20kHz"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Custom sound profile with bass enhancer"
  })))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "DRIVER UNITS"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "2 \xD7 10\u201D 96dB woofers"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "1 \xD7 1\u201D 104dB compression driver tweeter"
  })))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "CONNECTIVITY"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Bluetooth 5.0"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "TeamUP connection"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Wirelessly connect up to 5 (total) nearby New SOUNDBOKS(2019) speakers (SKAA network)"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Pro Panel"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA 2 \xD7 Combo microphone/instrument (XLR, 1/4\u201D) input"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA 1 \xD7 3.5mm Stereo Input"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA 1 \xD7 3.5mm Stereo Output"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Bond Button for advanced JOIN settings"
  })))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "BUILD"
  })), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "WEIGHT"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "34 pounds (15.4 kg)"
  })))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "MATERIALS"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Poplar cabinet"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Powder-coated aluminum frame"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Powder-coated steel grill and handles"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Silicone ball corners"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "SMP temperature-flex adhesive"
  })))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "DIMENSIONS"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "66 \xD7 43 \xD7 32 cm / 25.6 \xD7 17 \xD7 13 inches (H \xD7 W \xD7 D)"
  })))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "FEATURES"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Swappable grill and batteries"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "IP65 rated electronics coating"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Pulse Reflex Port"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "UI Panel"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Volume control"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Host/Join mode for wireless TeamUP"
  })))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "BATTERY"
  })), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "LIFE"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "40 hours at mid-volume"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "5 hours at full volume"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "3.5 hours full recharge"
  })))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "DESIGN"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "5-step LED battery-life indicator"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Heavy-duty DC-connector"
  })))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "CELL TYPE"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "12.8V, 7.8Ah Lithium Iron Phosphate (LiFePO4)"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "-10C to 40C temperature range"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "99.84Wh or 7.8Ah capacity"
  })))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "BATTERY MANAGEMENT SYSTEM (BMS)"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Over and under-discharge protection"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Short circuit protection"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Overheat protection"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Cell voltage management"
  })))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app"
  })), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.soundSettings"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.soundSettings.1"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.soundSettings.2"
  })))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.proPanel"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.proPanel.1"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.proPanel.2"
  })))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.1"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.2"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.3"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.4"
  })))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings.1"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings.2"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings.3"
  })))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.firmwareUpdate"
  }))), /*#__PURE__*/react_default.a.createElement(learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.firmwareUpdate.1"
  })))));
});
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/elevation-pack/learn-more/styled.ts



var elevation_pack_learn_more_styled_LayoutContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__LayoutContainer",
  componentId: "ej72xa-0"
})(["padding:0 190px;background-color:", ";@media ", "{padding:0 24px;}"], elements_theme["a" /* Color */].WhiteOff, styles_theme["a" /* default */].breakpoints.maxMobile);
var elevation_pack_learn_more_styled_Link = styled_components_browser_esm["default"].a.withConfig({
  displayName: "styled__Link",
  componentId: "ej72xa-1"
})(["color:", ";cursor:pointer;text-decoration:underline;"], elements_theme["a" /* Color */].Orange);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/elevation-pack/learn-more/faqs/index.web.tsx
var elevation_pack_learn_more_faqs_index_web_jsx = react_default.a.createElement;





// eslint-disable-next-line prefer-arrow-callback
var elevation_pack_learn_more_faqs_index_web_FAQs = /*#__PURE__*/react_default.a.memo(function FAQs() {
  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    padding: {
      right: 10
    }
  }, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.elevation-pack.learn-more.faqs.question-1"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.elevation-pack.learn-more.faqs.answer-1"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.elevation-pack.learn-more.faqs.question-2"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.elevation-pack.learn-more.faqs.answer-2"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.elevation-pack.learn-more.faqs.question-3"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.elevation-pack.learn-more.faqs.answer-3"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.elevation-pack.learn-more.faqs.question-4"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.elevation-pack.learn-more.faqs.answer-4"
  }));
});
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/elevation-pack/learn-more/index.tsx
var elevation_pack_learn_more_jsx = react_default.a.createElement;

















var elevation_pack_learn_more_LearnMoreSection = function LearnMoreSection(_ref) {
  var extraBattery = _ref.extraBattery,
      locale = _ref.locale;

  var _useSelector = Object(es["d" /* useSelector */])(function (state) {
    return state.settings;
  }),
      regionId = _useSelector.regionId;

  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(elevation_pack_learn_more_LayoutContainer, null, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(elements_typography["e" /* Heading02 */], {
      ariaLevel: elements_typography["h" /* TextLevel */].H2,
      style: {
        textTransform: 'uppercase',
        textAlign: 'center'
      }
    }, i18n._('product.learn-more.heading')), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "35px"
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.whats-in-the-box",
      content: /*#__PURE__*/react_default.a.createElement(elevation_pack_learn_more_whats_in_the_box_index_web_WhatsInTheBox, {
        extraBattery: extraBattery,
        packageItems: elevation_pack_learn_more_content_packageItems
      }),
      topItem: true
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.elevation-pack.seo.blurb",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "product.learn-more.elevation-pack.seo.blurb.info"
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.tech-specs",
      content: /*#__PURE__*/react_default.a.createElement(elevation_pack_learn_more_tech_spec_index_web_TechSpec, null)
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.shipping",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: learn_more_content_content.shipping[regionId] || learn_more_content_content.shipping["default"],
        components: [/*#__PURE__*/react_default.a.createElement(elevation_pack_learn_more_styled_Link, {
          href: helpCenter_getHelpCenterUrl(locale, '/sections/360003609413-SHIPPING')
        }), /*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement("br", null)]
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.warranty",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "product.learn-more.warranty.info",
        components: [/*#__PURE__*/react_default.a.createElement(elevation_pack_learn_more_styled_Link, {
          href: helpCenter_getHelpCenterUrl(locale, '/articles/211920329-RETURN-AND-REFUND-POLICY-AND-PROCESS')
        })]
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.payment-options",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "product.learn-more.payment-options.info"
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.faqs",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(elevation_pack_learn_more_faqs_index_web_FAQs, null))
    })));
  });
};

var elevation_pack_learn_more_LayoutContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "learn-more__LayoutContainer",
  componentId: "hlfptd-0"
})(["max-width:1062px;width:100%;@media ", "{padding:0 24px;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
/* harmony default export */ var elevation_pack_learn_more = (elevation_pack_learn_more_LearnMoreSection);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/elevation-pack/product-review/styled.tsx


var elevation_pack_product_review_styled_StyledHorizontalLine = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__StyledHorizontalLine",
  componentId: "iwm0sc-0"
})(["display:none;@media ", "{display:block;padding:0px 24px;}"], styles_theme["a" /* default */].breakpoints.maxMobile);
var elevation_pack_product_review_styled_LayoutContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__LayoutContainer",
  componentId: "iwm0sc-1"
})(["position:relative;width:100%;max-width:1024px;text-align:center;align-self:center;@media ", "{max-width:720px;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/elevation-pack/product-review/index.tsx
var elevation_pack_product_review_jsx = react_default.a.createElement;











var elevation_pack_product_review_ProductReviewSection = function ProductReviewSection() {
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref) {
    var i18n = _ref.i18n;
    return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(elevation_pack_product_review_styled_LayoutContainer, null, /*#__PURE__*/react_default.a.createElement(elements_typography["e" /* Heading02 */], {
      ariaLevel: elements_typography["h" /* TextLevel */].H2,
      color: elements_theme["a" /* Color */].Orange,
      style: {
        textTransform: 'uppercase'
      }
    }, i18n._('product.reviews.heading'))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    }), /*#__PURE__*/react_default.a.createElement(elevation_pack_product_review_styled_StyledHorizontalLine, null, /*#__PURE__*/react_default.a.createElement(HorizontalLine, {
      color: elements_theme["a" /* Color */].WhiteOff
    }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    })), /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(index_web_VideoFeature, {
      videos: [{
        YouTubeId: 'FuD9ujTbZCE',
        children: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "The world's LOUDEST portable speaker for DJs?")
      }, {
        YouTubeId: 'JrGlmymabNg',
        children: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "Soundboks Update - New Sound Modes New Features")
      }, {
        YouTubeId: 'j9WFgrGU5ro',
        children: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "The world's Loudest Wireless Speaker")
      }],
      height: "184px"
    })), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    }), /*#__PURE__*/react_default.a.createElement(elevation_pack_product_review_styled_StyledHorizontalLine, null, /*#__PURE__*/react_default.a.createElement(HorizontalLine, {
      color: elements_theme["a" /* Color */].WhiteOff
    }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    })), /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(Trustbox, null)));
  });
};

/* harmony default export */ var elevation_pack_product_review = (elevation_pack_product_review_ProductReviewSection);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/elevation-pack/related-products/index.tsx
var elevation_pack_related_products_jsx = react_default.a.createElement;






var elevation_pack_related_products_RelatedProductsSection = function RelatedProductsSection(_ref) {
  var relatedProducts = _ref.relatedProducts;
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      grow: 1
    }, /*#__PURE__*/react_default.a.createElement(RelatedProducts, {
      relatedProducts: relatedProducts,
      headline: i18n._('product.related-products.heading')
    })));
  });
};

/* harmony default export */ var elevation_pack_related_products = (elevation_pack_related_products_RelatedProductsSection);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/elevation-pack/index.tsx

var elevation_pack_jsx = react_default.a.createElement;

function elevation_pack_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function elevation_pack_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { elevation_pack_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { elevation_pack_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



















var elevation_pack_paths = [{
  label: 'Home',
  url: '/'
}, {
  label: 'Bundles',
  url: '/products/?filter=bundles'
}, {
  label: 'Elevation Pack'
}];
var elevation_pack_options = {
  grillColor: 'Grill Color',
  batteries: 'Batteries'
};
var elevation_pack_klarnaData = {
  de: {
    klarnaLocale: 'de-DE',
    klarnaClassName: 'klarna-pricetag-de'
  },
  no: {
    klarnaLocale: 'no-NO',
    klarnaClassName: 'klarna-pricetag-no'
  },
  da: {
    klarnaLocale: 'da-DK',
    klarnaClassName: 'klarna-pricetag-dk'
  }
};
var elevation_pack_colorOptions = [{
  id: 'Black',
  label: 'Black',
  value: '#000000'
}, {
  id: 'Orange',
  label: 'Orange',
  value: '#FA4616'
}, {
  id: 'White',
  label: 'White',
  value: '#FFFFFF'
}];
var elevation_pack_batteriOptions = {
  onePack: '1x BATTERYBOKS',
  twoPack: '2x BATTERYBOKS'
};

var elevation_pack_ElevationPack = function ElevationPack(_ref) {
  var productData = _ref.productData,
      dispatchAddCartItem = _ref.dispatchAddCartItem;

  var _useSelector = Object(es["d" /* useSelector */])(function (state) {
    return state;
  }),
      settings = _useSelector.settings;

  var regionId = settings.regionId;
  var overview = Object(react["useRef"])(null);
  var learnMore = Object(react["useRef"])(null);
  var reviews = Object(react["useRef"])(null);
  var relatedProducts = Object(react["useRef"])(null);

  var _useState = Object(react["useState"])(),
      anchorStack = _useState[0],
      setAnchorStack = _useState[1];

  var _useState2 = Object(react["useState"])(),
      selectedAnchor = _useState2[0],
      setSelectedAnchor = _useState2[1];

  var _useState3 = Object(react["useState"])(false),
      isHeaderVisibility = _useState3[0],
      setIsHeaderVisibility = _useState3[1];

  var _useState4 = Object(react["useState"])(),
      productVariant = _useState4[0],
      setProductVariant = _useState4[1];

  var _useState5 = Object(react["useState"])(),
      selectedColor = _useState5[0],
      setSelectedColor = _useState5[1];

  var _useState6 = Object(react["useState"])(),
      avalibleColors = _useState6[0],
      setAvalibleColors = _useState6[1];

  var productCategories = Object(mergeUACategories["a" /* default */])(abstractProducts_default.a.byId[productData.handle].categories);

  var _useState7 = Object(react["useState"])(true),
      allowImageInteractionTracking = _useState7[0],
      setAllowImageInteractionTracking = _useState7[1];

  var _useState8 = Object(react["useState"])(0),
      trackImageInteractionLimit = _useState8[0],
      setTrackImageInteractionLimit = _useState8[1];

  var router = Object(next_router["useRouter"])();
  var offset = 124;
  Object(react["useEffect"])(function () {
    var initialStack = [{
      label: 'products.subnavigation.achor.overview',
      ref: overview
    }, {
      label: 'products.subnavigation.achor.learn-more',
      ref: learnMore
    }, {
      label: 'products.subnavigation.achor.reviews',
      ref: reviews
    }, {
      label: 'products.subnavigation.achor.related-products',
      ref: relatedProducts
    }];
    setAnchorStack(initialStack);

    var handleScroll = function handleScroll() {
      var stackIndex = initialStack.findIndex(function (stack) {
        return stack.ref.current.getBoundingClientRect().y - offset > 0;
      });
      var stack = stackIndex === -1 ? initialStack[initialStack.length - 1] : initialStack[stackIndex - 1];
      setSelectedAnchor(stack.ref.current);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return function () {
      return window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  var handleHeaderVisibility = function handleHeaderVisibility(isVisibility) {
    setIsHeaderVisibility(isVisibility);
  };

  Object(react["useEffect"])(function () {
    var defaultOption = productData.variants.find(function (variant) {
      return variant.sku;
    });
    var optionsFromUrlQueries = productData.variants.find(function (variant) {
      return variant.options[elevation_pack_options.grillColor] === router.query[elevation_pack_options.grillColor];
    });
    var defaultVariant = optionsFromUrlQueries || defaultOption;
    setSelectedColor(defaultVariant === null || defaultVariant === void 0 ? void 0 : defaultVariant.options[elevation_pack_options.grillColor]);
    var variantColors = productData.variants.map(function (variant) {
      return variant.options[elevation_pack_options.grillColor];
    });
    var colors = elevation_pack_colorOptions.filter(function (_ref2) {
      var id = _ref2.id;
      return variantColors.includes(id);
    });
    setAvalibleColors(colors);
    setProductVariant(defaultVariant);
  }, [productData, router.query]);

  var refreshData = function refreshData(color) {
    var regionCheck = regionId === 'na' ? '' : "/".concat(regionId);
    window.history.replaceState(null, "".concat(regionCheck, "/products/elevation-pack/"), "".concat(regionCheck, "/products/elevation-pack/?Grill+Color=").concat(color));
  };

  var handleColorSelector = function handleColorSelector(color) {
    var nextVariant = productData.variants.find(function (variant) {
      return variant.options[elevation_pack_options.grillColor] === color;
    });
    setSelectedColor(color);
    setAllowImageInteractionTracking(true);
    setTrackImageInteractionLimit(0);
    refreshData(color);
    setProductVariant(nextVariant);
  };

  var handleBatterySelector = function handleBatterySelector(selected) {
    var variants = productData.variants.filter(function (variant) {
      return variant.options[elevation_pack_options.batteries] === (selected ? elevation_pack_batteriOptions.twoPack : elevation_pack_batteriOptions.onePack);
    });
    var colors = variants.map(function (variant) {
      return variant.options[elevation_pack_options.grillColor];
    });
    var trackBattery = selected ? elevation_pack_batteriOptions.twoPack : elevation_pack_batteriOptions.onePack;
    Object(utils["m" /* trackVariantInteraction */])(trackBattery);
    setAvalibleColors(function (prev) {
      return prev.map(function (color) {
        return colors.includes(color.id) ? elevation_pack_objectSpread(elevation_pack_objectSpread({}, color), {}, {
          disabled: false
        }) : elevation_pack_objectSpread(elevation_pack_objectSpread({}, color), {}, {
          disabled: true
        });
      });
    });
    var nextVariant = variants.find(function (variant) {
      return variant.options[elevation_pack_options.grillColor] === selectedColor;
    });
    setProductVariant(nextVariant);
  };

  Object(react["useEffect"])(function () {
    if (productVariant) {
      var productImages = Object(getProductImages["a" /* default */])(productData.handle, productVariant.sku);
      var imageUrl = productImages.length ? productImages[0].url : '';
      var timer = setTimeout(function () {
        return Object(utils["i" /* trackProductPageview */])({
          name: productData.title,
          id: productVariant.sku,
          price: productVariant.price,
          brand: 'soundboks',
          category: productCategories,
          variant: productVariant.title,
          image: imageUrl
        });
      }, 1000);
      return function () {
        return clearTimeout(timer);
      };
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [regionId, productVariant]);

  var handleAddToCart = function handleAddToCart() {
    console.log('handleAddToCart', productVariant);

    if (productVariant.available) {
      dispatchAddCartItem(productVariant.id, 1, true);
    } else {
      console.log('join waitinglist dialog');
    }
  };

  var financialServices = function financialServices(variantPrice) {
    var locale = productData.locale;
    var klarnaAvailable = locale === 'de' || locale === 'no' || locale === 'da';
    var affirmAvailable = locale === 'en-US';
    return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, affirmAvailable && /*#__PURE__*/react_default.a.createElement(index_web_AffirmService, {
      price: variantPrice,
      locale: locale,
      isBlackTheme: true
    }), klarnaAvailable && /*#__PURE__*/react_default.a.createElement(index_web_KlarnaService, {
      price: variantPrice,
      locale: elevation_pack_klarnaData[locale].klarnaLocale,
      klarnaClassName: elevation_pack_klarnaData[locale].klarnaClassName
    }));
  };

  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    backgroundColor: elements_theme["a" /* Color */].Charcoal
  }, /*#__PURE__*/react_default.a.createElement(sub_navigation_SubNavigation, {
    productData: productData,
    productVariant: productVariant,
    anchorStack: anchorStack,
    selectedAnchor: selectedAnchor,
    isHeaderVisibility: isHeaderVisibility,
    offset: offset,
    handleAddToCart: handleAddToCart
  }), /*#__PURE__*/react_default.a.createElement("div", {
    ref: overview
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '24px',
      desktop: '46px'
    }
  }), /*#__PURE__*/react_default.a.createElement(elevation_pack_product_overview, {
    paths: elevation_pack_paths,
    offset: offset,
    anchorStack: anchorStack,
    productData: productData,
    productVariant: productVariant,
    onHeaderVisibility: handleHeaderVisibility,
    handleColorSelector: handleColorSelector,
    handleBatterySelector: handleBatterySelector,
    avalibleColors: avalibleColors,
    selectedColor: selectedColor,
    handleAddToCart: handleAddToCart,
    financialServices: financialServices,
    allowImageInteractionTracking: allowImageInteractionTracking,
    setAllowImageInteractionTracking: setAllowImageInteractionTracking,
    trackImageInteractionLimit: trackImageInteractionLimit,
    setTrackImageInteractionLimit: setTrackImageInteractionLimit
  })), /*#__PURE__*/react_default.a.createElement(elevation_pack_styled_BackgroundImage, null), /*#__PURE__*/react_default.a.createElement("div", {
    ref: learnMore
  }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    alignContentHorizontal: "center",
    backgroundColor: elements_theme["a" /* Color */].WhiteOff
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }), /*#__PURE__*/react_default.a.createElement(elevation_pack_learn_more, {
    locale: productData.locale
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }))), /*#__PURE__*/react_default.a.createElement("div", {
    ref: reviews
  }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    backgroundColor: elements_theme["a" /* Color */].White
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }), /*#__PURE__*/react_default.a.createElement(elevation_pack_product_review, null), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }))), /*#__PURE__*/react_default.a.createElement("div", {
    ref: relatedProducts
  }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    backgroundColor: elements_theme["a" /* Color */].WhiteOff
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }), /*#__PURE__*/react_default.a.createElement(elevation_pack_related_products, {
    relatedProducts: productData.crossSellHandles
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '60px',
      desktop: '72px'
    }
  }))));
};

/* harmony default export */ var elevation_pack = (elevation_pack_ElevationPack);
// EXTERNAL MODULE: ./components/pages/products-v2/bundles/weekender-pack/assets/WeekenderPack_large.jpg
var WeekenderPack_large = __webpack_require__("YakH");
var WeekenderPack_large_default = /*#__PURE__*/__webpack_require__.n(WeekenderPack_large);

// EXTERNAL MODULE: ./components/pages/products-v2/bundles/weekender-pack/assets/WeekenderPack_small.jpg
var WeekenderPack_small = __webpack_require__("E7uR");
var WeekenderPack_small_default = /*#__PURE__*/__webpack_require__.n(WeekenderPack_small);

// CONCATENATED MODULE: ./components/pages/products-v2/bundles/weekender-pack/styled.ts




var weekender_pack_styled_BackgroundImage = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__BackgroundImage",
  componentId: "sc-1bkq45v-0"
})(["display:block;width:100%;height:400px;background-image:url(", ");background-repeat:no-repeat;background-size:cover;background-position:30% 70%;@media ", "{height:852px;padding:20px;background-position:center;background-image:url(", ");}"], WeekenderPack_large_default.a.url, styles_theme["a" /* default */].breakpoints.tablet, WeekenderPack_small_default.a.url);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/weekender-pack/product-overview/index.tsx
var weekender_pack_product_overview_jsx = react_default.a.createElement;






var weekender_pack_product_overview_ProductOverviewSection = function ProductOverviewSection(_ref) {
  var productData = _ref.productData,
      paths = _ref.paths,
      onHeaderVisibility = _ref.onHeaderVisibility,
      handleColorSelector = _ref.handleColorSelector,
      handleBatterySelector = _ref.handleBatterySelector,
      productVariant = _ref.productVariant,
      avalibleColors = _ref.avalibleColors,
      selectedColor = _ref.selectedColor,
      extraBattery = _ref.extraBattery,
      disableExtraBattery = _ref.disableExtraBattery,
      handleAddToCart = _ref.handleAddToCart,
      financialServices = _ref.financialServices,
      offset = _ref.offset,
      anchorStack = _ref.anchorStack,
      allowImageInteractionTracking = _ref.allowImageInteractionTracking,
      setAllowImageInteractionTracking = _ref.setAllowImageInteractionTracking,
      trackImageInteractionLimit = _ref.trackImageInteractionLimit,
      setTrackImageInteractionLimit = _ref.setTrackImageInteractionLimit;
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentHorizontal: "center",
      padding: {
        right: 24,
        left: 24
      }
    }, /*#__PURE__*/react_default.a.createElement(index_web_ProductOverview, {
      paths: paths,
      offset: offset,
      anchorStack: anchorStack,
      productData: productData,
      handleColorSelector: handleColorSelector,
      handleBatterySelector: handleBatterySelector,
      productVariant: productVariant,
      avalibleColors: avalibleColors,
      selectedColor: selectedColor,
      extraBattery: extraBattery,
      disableExtraBattery: disableExtraBattery,
      handleAddToCart: handleAddToCart,
      financialServices: financialServices,
      allowImageInteractionTracking: allowImageInteractionTracking,
      setAllowImageInteractionTracking: setAllowImageInteractionTracking,
      trackImageInteractionLimit: trackImageInteractionLimit,
      setTrackImageInteractionLimit: setTrackImageInteractionLimit,
      labels: {
        grillColor: {
          label: i18n._('product.option.label.grill-color'),
          options: {
            Black: i18n._('product.option.label.black'),
            Orange: i18n._('product.option.label.orange'),
            White: i18n._('product.option.label.white'),
            Blue: i18n._('product.option.label.blue'),
            Red: i18n._('product.option.label.red')
          }
        },
        // extraBattery: {
        //   label: i18n._('product.option.label.extra-battery'),
        //   options: {
        //     yes: i18n._('product.option.label.yes'),
        //     no: i18n._('product.option.label.no'),
        //   },
        // },
        addToCart: i18n._('product.buy-page.button.addToCart'),
        outOfStock: i18n._('product.buy-page.button.outOfStock'),
        waitlist: i18n._('product.buy-page.button.waitlist'),
        usp: {
          warranty: i18n._('product.usp.warranty'),
          freeReturns: i18n._('product.usp.free-returns'),
          freeShipping: i18n._('product.usp.free-shipping'),
          premiumSupport: i18n._('product.usp.premium-support'),
          compatibility: i18n._('product.usp.compatibility')
        }
      },
      onHeaderVisibility: onHeaderVisibility
    }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    }));
  });
};

/* harmony default export */ var weekender_pack_product_overview = (weekender_pack_product_overview_ProductOverviewSection);
// CONCATENATED MODULE: ./public/static/icons/package-items-icons/IconBackpack.tsx
var IconBackpack_jsx = react_default.a.createElement;


var IconBackpack_IconBackpack = function IconBackpack() {
  return /*#__PURE__*/react_default.a.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "89.838",
    height: "104.89",
    viewBox: "0 0 89.838 104.89"
  }, /*#__PURE__*/react_default.a.createElement("g", {
    id: "line-drawings_Backpack2_charcoal",
    transform: "translate(-15.087 -11.68)"
  }, /*#__PURE__*/react_default.a.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: "46.45",
    height: "48.26",
    rx: "1.16",
    transform: "translate(36.67 52.72)",
    fill: "none",
    stroke: "#222",
    strokeMiterlimit: "10",
    strokeWidth: "1"
  }), /*#__PURE__*/react_default.a.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20"
  }, /*#__PURE__*/react_default.a.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    y2: "28.12",
    transform: "translate(56.64 24.6)",
    fill: "none",
    stroke: "#222",
    strokeMiterlimit: "10",
    strokeWidth: "1"
  }), /*#__PURE__*/react_default.a.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    y2: "28.12",
    transform: "translate(63.22 24.6)",
    fill: "none",
    stroke: "#222",
    strokeMiterlimit: "10",
    strokeWidth: "1"
  })), /*#__PURE__*/react_default.a.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22"
  }, /*#__PURE__*/react_default.a.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21"
  }, /*#__PURE__*/react_default.a.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M93.17,95.6l-2.11.02a.591.591,0,0,0-.59.59v14.93a4.934,4.934,0,0,1-4.93,4.93H34.46a4.934,4.934,0,0,1-4.93-4.93V96.21a.585.585,0,0,0-.59-.59l-2.11-.02",
    fill: "none",
    stroke: "#212222",
    strokeMiterlimit: "10",
    strokeWidth: "1"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M93.17,95.6h0a2.269,2.269,0,0,0,2.24-1.93h0l2.32-7.53a52.523,52.523,0,0,0,1.86-9.55c.11-1.52.16-3.05.15-4.58a47.923,47.923,0,0,0-2.89-15.62l-1.44-4.05h0a2.411,2.411,0,0,0-2.29-1.93h-1.4a.95.95,0,0,1-.95-.95V42.28h13.26a.392.392,0,0,0,.38-.49l-3.95-15.87a1.733,1.733,0,0,0-1.68-1.31l-33.94.03H53.61l-32.38-.03a1.733,1.733,0,0,0-1.68,1.31L15.6,41.79a.4.4,0,0,0,.38.49H29.24v7.18a.95.95,0,0,1-.95.95h-1.4a2.42,2.42,0,0,0-2.29,1.93h0l-1.44,4.05a47.923,47.923,0,0,0-2.89,15.62c-.01,1.53.04,3.06.15,4.58a52.69,52.69,0,0,0,1.86,9.55l2.32,7.53h0a2.269,2.269,0,0,0,2.24,1.93h0",
    fill: "none",
    stroke: "#212222",
    strokeMiterlimit: "10",
    strokeWidth: "1"
  })), /*#__PURE__*/react_default.a.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: "8.46",
    height: "10.53",
    rx: "1.28",
    transform: "translate(55.75 28.13)",
    fill: "#fff",
    stroke: "#212222",
    strokeMiterlimit: "10",
    strokeWidth: "1"
  })), /*#__PURE__*/react_default.a.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    x1: "27.46",
    transform: "translate(29.18 42.28)",
    fill: "none",
    stroke: "#222",
    strokeMiterlimit: "10",
    strokeWidth: "1"
  }), /*#__PURE__*/react_default.a.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    x1: "27.49",
    transform: "translate(63.22 42.28)",
    fill: "none",
    stroke: "#222",
    strokeMiterlimit: "10",
    strokeWidth: "1"
  }), /*#__PURE__*/react_default.a.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M48.01,24.6s-.4-12.42,11.83-12.42S72,24.34,72,24.34",
    fill: "none",
    stroke: "#212222",
    strokeMiterlimit: "10",
    strokeWidth: "1"
  })));
};

/* harmony default export */ var package_items_icons_IconBackpack = (IconBackpack_IconBackpack);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/weekender-pack/learn-more/content.tsx
var weekender_pack_learn_more_content_jsx = react_default.a.createElement;







var weekender_pack_learn_more_content_packageItems = [{
  packageItemId: 'soundboks-gen-3',
  title: 'Soundboks (Gen 3)',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconSoundboks3, null)
}, {
  packageItemId: '2-in-1-bag',
  title: '2 in 1 Bag',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconBackpack, null)
}, {
  packageItemId: 'batteryboks',
  title: 'Batteryboks',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconBattery, null)
}, {
  packageItemId: 'extra-batteryboks',
  title: 'Extra Batteryboks',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconBattery, null)
}, {
  packageItemId: 'charger',
  title: 'Charger',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconCharger, null)
}, {
  packageItemId: 'soundboks-gen-3-manual',
  title: 'Manual',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconManual, null),
  downloadUrl: soundboks3["default"]
}];
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/weekender-pack/learn-more/tech-spec/styled.ts

var weekender_pack_learn_more_tech_spec_styled_DescList = styled_components_browser_esm["default"].dl.withConfig({
  displayName: "styled__DescList",
  componentId: "rnfs4j-0"
})(["margin:20px 0 0 0;"]);
var weekender_pack_learn_more_tech_spec_styled_DescTitle = styled_components_browser_esm["default"].dt.withConfig({
  displayName: "styled__DescTitle",
  componentId: "rnfs4j-1"
})(["margin:0;"]);
var weekender_pack_learn_more_tech_spec_styled_DescDetails = styled_components_browser_esm["default"].dd.withConfig({
  displayName: "styled__DescDetails",
  componentId: "rnfs4j-2"
})(["margin:0;"]);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/weekender-pack/learn-more/tech-spec/index.web.tsx
var weekender_pack_learn_more_tech_spec_index_web_jsx = react_default.a.createElement;





 // eslint-disable-next-line prefer-arrow-callback

var weekender_pack_learn_more_tech_spec_index_web_TechSpec = /*#__PURE__*/react_default.a.memo(function TechSpec() {
  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, null, /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "SOUND"
  })), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "AMPLIFIER"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Merus Audio eximo\xAE amp switching"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "3 \xD7 72W RMS class D amplifiers"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Advanced Bass DSP"
  })))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "ACOUSTICS"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Effective frequency range: 40Hz - 20kHz"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Custom sound profile with bass enhancer"
  })))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "DRIVER UNITS"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "2 \xD7 10\u201D 96dB woofers"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "1 \xD7 1\u201D 104dB compression driver tweeter"
  })))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "CONNECTIVITY"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Bluetooth 5.0"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "TeamUP connection"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Wirelessly connect up to 5 (total) nearby New SOUNDBOKS(2019) speakers (SKAA network)"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Pro Panel"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA 2 \xD7 Combo microphone/instrument (XLR, 1/4\u201D) input"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA 1 \xD7 3.5mm Stereo Input"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA 1 \xD7 3.5mm Stereo Output"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Bond Button for advanced JOIN settings"
  })))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "BUILD"
  })), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "WEIGHT"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "34 pounds (15.4 kg)"
  })))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "MATERIALS"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Poplar cabinet"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Powder-coated aluminum frame"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Powder-coated steel grill and handles"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Silicone ball corners"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "SMP temperature-flex adhesive"
  })))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "DIMENSIONS"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "66 \xD7 43 \xD7 32 cm / 25.6 \xD7 17 \xD7 13 inches (H \xD7 W \xD7 D)"
  })))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "FEATURES"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Swappable grill and batteries"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "IP65 rated electronics coating"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Pulse Reflex Port"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "UI Panel"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Volume control"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Host/Join mode for wireless TeamUP"
  })))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "BATTERY"
  })), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "LIFE"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "40 hours at mid-volume"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "5 hours at full volume"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "3.5 hours full recharge"
  })))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "DESIGN"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "5-step LED battery-life indicator"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Heavy-duty DC-connector"
  })))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "CELL TYPE"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "12.8V, 7.8Ah Lithium Iron Phosphate (LiFePO4)"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "-10C to 40C temperature range"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "99.84Wh or 7.8Ah capacity"
  })))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "BATTERY MANAGEMENT SYSTEM (BMS)"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Over and under-discharge protection"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Short circuit protection"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Overheat protection"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Cell voltage management"
  })))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app"
  })), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.soundSettings"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.soundSettings.1"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.soundSettings.2"
  })))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.proPanel"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.proPanel.1"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.proPanel.2"
  })))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.1"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.2"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.3"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.4"
  })))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings.1"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings.2"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings.3"
  })))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.firmwareUpdate"
  }))), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.firmwareUpdate.1"
  })))));
});
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/weekender-pack/learn-more/styled.ts



var weekender_pack_learn_more_styled_LayoutContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__LayoutContainer",
  componentId: "sc-52m6jh-0"
})(["padding:0 190px;background-color:", ";@media ", "{padding:0 24px;}"], elements_theme["a" /* Color */].WhiteOff, styles_theme["a" /* default */].breakpoints.maxMobile);
var weekender_pack_learn_more_styled_Link = styled_components_browser_esm["default"].a.withConfig({
  displayName: "styled__Link",
  componentId: "sc-52m6jh-1"
})(["color:", ";cursor:pointer;text-decoration:underline;"], elements_theme["a" /* Color */].Orange);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/weekender-pack/learn-more/faqs/index.web.tsx
var weekender_pack_learn_more_faqs_index_web_jsx = react_default.a.createElement;





// eslint-disable-next-line prefer-arrow-callback
var weekender_pack_learn_more_faqs_index_web_FAQs = /*#__PURE__*/react_default.a.memo(function FAQs() {
  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    padding: {
      right: 10
    }
  }, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-1"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-1"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-2"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-2"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-3"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-3"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-4"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-4"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-5"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-5"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-6"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-6"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-7"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-7"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-8"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-8"
  }));
});
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/weekender-pack/learn-more/index.tsx
var weekender_pack_learn_more_jsx = react_default.a.createElement;

















var weekender_pack_learn_more_LearnMoreSection = function LearnMoreSection(_ref) {
  var extraBattery = _ref.extraBattery,
      locale = _ref.locale;

  var _useSelector = Object(es["d" /* useSelector */])(function (state) {
    return state.settings;
  }),
      regionId = _useSelector.regionId;

  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_LayoutContainer, null, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(elements_typography["e" /* Heading02 */], {
      ariaLevel: elements_typography["h" /* TextLevel */].H2,
      style: {
        textTransform: 'uppercase',
        textAlign: 'center'
      }
    }, i18n._('product.learn-more.heading')), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "35px"
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.whats-in-the-box",
      content: /*#__PURE__*/react_default.a.createElement(index_web_WhatsInTheBox, {
        extraBattery: extraBattery,
        packageItems: weekender_pack_learn_more_content_packageItems
      }),
      topItem: true
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.tech-specs",
      content: /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_tech_spec_index_web_TechSpec, null)
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.shipping",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: learn_more_content_content.shipping[regionId] || learn_more_content_content.shipping["default"],
        components: [/*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_styled_Link, {
          href: helpCenter_getHelpCenterUrl(locale, '/sections/360003609413-SHIPPING')
        }), /*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement("br", null)]
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.warranty",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "product.learn-more.warranty.info",
        components: [/*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_styled_Link, {
          href: helpCenter_getHelpCenterUrl(locale, '/articles/211920329-RETURN-AND-REFUND-POLICY-AND-PROCESS')
        })]
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.payment-options",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "product.learn-more.payment-options.info"
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.faqs",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more_faqs_index_web_FAQs, null))
    })));
  });
};

var weekender_pack_learn_more_LayoutContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "learn-more__LayoutContainer",
  componentId: "sc-13phtba-0"
})(["max-width:1062px;width:100%;@media ", "{padding:0 24px;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
/* harmony default export */ var weekender_pack_learn_more = (weekender_pack_learn_more_LearnMoreSection);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/weekender-pack/product-review/styled.tsx


var weekender_pack_product_review_styled_StyledHorizontalLine = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__StyledHorizontalLine",
  componentId: "ohysn5-0"
})(["display:none;@media ", "{display:block;padding:0px 24px;}"], styles_theme["a" /* default */].breakpoints.maxMobile);
var weekender_pack_product_review_styled_LayoutContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__LayoutContainer",
  componentId: "ohysn5-1"
})(["position:relative;width:100%;max-width:1024px;text-align:center;align-self:center;@media ", "{max-width:720px;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/weekender-pack/product-review/index.tsx
var weekender_pack_product_review_jsx = react_default.a.createElement;











var weekender_pack_product_review_ProductReviewSection = function ProductReviewSection() {
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref) {
    var i18n = _ref.i18n;
    return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(weekender_pack_product_review_styled_LayoutContainer, null, /*#__PURE__*/react_default.a.createElement(elements_typography["e" /* Heading02 */], {
      ariaLevel: elements_typography["h" /* TextLevel */].H2,
      color: elements_theme["a" /* Color */].Orange,
      style: {
        textTransform: 'uppercase'
      }
    }, i18n._('product.reviews.heading'))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    }), /*#__PURE__*/react_default.a.createElement(weekender_pack_product_review_styled_StyledHorizontalLine, null, /*#__PURE__*/react_default.a.createElement(HorizontalLine, {
      color: elements_theme["a" /* Color */].WhiteOff
    }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    })), /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(index_web_VideoFeature, {
      videos: [{
        YouTubeId: 'FuD9ujTbZCE',
        children: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "The world's LOUDEST portable speaker for DJs?")
      }, {
        YouTubeId: 'JrGlmymabNg',
        children: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "Soundboks Update - New Sound Modes New Features")
      }, {
        YouTubeId: 'j9WFgrGU5ro',
        children: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "The world's Loudest Wireless Speaker")
      }],
      height: "184px"
    })), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    }), /*#__PURE__*/react_default.a.createElement(weekender_pack_product_review_styled_StyledHorizontalLine, null, /*#__PURE__*/react_default.a.createElement(HorizontalLine, {
      color: elements_theme["a" /* Color */].WhiteOff
    }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    })), /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(Trustbox, null)));
  });
};

/* harmony default export */ var weekender_pack_product_review = (weekender_pack_product_review_ProductReviewSection);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/weekender-pack/related-products/index.tsx
var weekender_pack_related_products_jsx = react_default.a.createElement;






var weekender_pack_related_products_RelatedProductsSection = function RelatedProductsSection(_ref) {
  var relatedProducts = _ref.relatedProducts;
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      grow: 1
    }, /*#__PURE__*/react_default.a.createElement(RelatedProducts, {
      relatedProducts: relatedProducts,
      headline: i18n._('product.related-products.heading')
    })));
  });
};

/* harmony default export */ var weekender_pack_related_products = (weekender_pack_related_products_RelatedProductsSection);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/weekender-pack/index.tsx

var weekender_pack_jsx = react_default.a.createElement;

function weekender_pack_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function weekender_pack_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { weekender_pack_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { weekender_pack_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



















var weekender_pack_paths = [{
  label: 'Home',
  url: '/'
}, {
  label: 'Bundles',
  url: '/products/?filter=bundles'
}, {
  label: 'Weekender Pack'
}];
var weekender_pack_options = {
  grillColor: 'Grill Color',
  batteries: 'Batteries'
};
var weekender_pack_klarnaData = {
  de: {
    klarnaLocale: 'de-DE',
    klarnaClassName: 'klarna-pricetag-de'
  },
  no: {
    klarnaLocale: 'no-NO',
    klarnaClassName: 'klarna-pricetag-no'
  },
  da: {
    klarnaLocale: 'da-DK',
    klarnaClassName: 'klarna-pricetag-dk'
  }
};
var weekender_pack_colorOptions = [{
  id: 'Black',
  label: 'Black',
  value: '#000000'
}, {
  id: 'Orange',
  label: 'Orange',
  value: '#FA4616'
}, {
  id: 'White',
  label: 'White',
  value: '#FFFFFF'
} // Temporarly removed till further instructions
// { id: 'Blue', label: 'Blue', value: '#19415E' },
// { id: 'Red', label: 'Red', value: '#AA273B' },
];
var weekender_pack_batteriOptions = {
  onePack: '1x BATTERYBOKS',
  twoPack: '2x BATTERYBOKS'
};

var weekender_pack_WeekenderPack = function WeekenderPack(_ref) {
  var productData = _ref.productData,
      dispatchAddCartItem = _ref.dispatchAddCartItem;

  var _useSelector = Object(es["d" /* useSelector */])(function (state) {
    return state;
  }),
      settings = _useSelector.settings;

  var regionId = settings.regionId;
  var overview = Object(react["useRef"])(null);
  var learnMore = Object(react["useRef"])(null);
  var reviews = Object(react["useRef"])(null);
  var relatedProducts = Object(react["useRef"])(null);

  var _useState = Object(react["useState"])(),
      anchorStack = _useState[0],
      setAnchorStack = _useState[1];

  var _useState2 = Object(react["useState"])(),
      selectedAnchor = _useState2[0],
      setSelectedAnchor = _useState2[1];

  var _useState3 = Object(react["useState"])(false),
      isHeaderVisibility = _useState3[0],
      setIsHeaderVisibility = _useState3[1];

  var _useState4 = Object(react["useState"])(),
      productVariant = _useState4[0],
      setProductVariant = _useState4[1];

  var _useState5 = Object(react["useState"])(),
      selectedColor = _useState5[0],
      setSelectedColor = _useState5[1];

  var _useState6 = Object(react["useState"])(),
      avalibleColors = _useState6[0],
      setAvalibleColors = _useState6[1];

  var _useState7 = Object(react["useState"])(),
      extraBattery = _useState7[0],
      setExtraBattery = _useState7[1];

  var _useState8 = Object(react["useState"])(),
      disableExtraBattery = _useState8[0],
      setDisableExtraBattery = _useState8[1];

  var productCategories = Object(mergeUACategories["a" /* default */])(abstractProducts_default.a.byId[productData.handle].categories);

  var _useState9 = Object(react["useState"])(true),
      allowImageInteractionTracking = _useState9[0],
      setAllowImageInteractionTracking = _useState9[1];

  var _useState10 = Object(react["useState"])(0),
      trackImageInteractionLimit = _useState10[0],
      setTrackImageInteractionLimit = _useState10[1];

  var router = Object(next_router["useRouter"])();
  var offset = 124;
  Object(react["useEffect"])(function () {
    var initialStack = [{
      label: 'products.subnavigation.achor.overview',
      ref: overview
    }, {
      label: 'products.subnavigation.achor.learn-more',
      ref: learnMore
    }, {
      label: 'products.subnavigation.achor.reviews',
      ref: reviews
    }, {
      label: 'products.subnavigation.achor.related-products',
      ref: relatedProducts
    }];
    setAnchorStack(initialStack);

    var handleScroll = function handleScroll() {
      var stackIndex = initialStack.findIndex(function (stack) {
        return stack.ref.current.getBoundingClientRect().y - offset > 0;
      });
      var stack = stackIndex === -1 ? initialStack[initialStack.length - 1] : initialStack[stackIndex - 1];
      setSelectedAnchor(stack.ref.current);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return function () {
      return window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  var handleHeaderVisibility = function handleHeaderVisibility(isVisibility) {
    setIsHeaderVisibility(isVisibility);
  };

  Object(react["useEffect"])(function () {
    var defaultOption = productData.variants.find(function (variant) {
      return variant.sku;
    });
    var optionsFromUrlQueries = productData.variants.find(function (variant) {
      return variant.options[weekender_pack_options.grillColor] === router.query[weekender_pack_options.grillColor];
    });
    var defaultVariant = optionsFromUrlQueries || defaultOption;
    setSelectedColor(defaultVariant === null || defaultVariant === void 0 ? void 0 : defaultVariant.options[weekender_pack_options.grillColor]);
    var variantColors = productData.variants.map(function (variant) {
      return variant.options[weekender_pack_options.grillColor];
    });
    var colors = weekender_pack_colorOptions.filter(function (_ref2) {
      var id = _ref2.id;
      return variantColors.includes(id);
    });
    setAvalibleColors(colors);
    setExtraBattery((defaultVariant === null || defaultVariant === void 0 ? void 0 : defaultVariant.options[weekender_pack_options.batteries]) === weekender_pack_batteriOptions.twoPack); // Does this variant exist with opposite selected battery?

    var reverseBatteryOption = (defaultVariant === null || defaultVariant === void 0 ? void 0 : defaultVariant.options[weekender_pack_options.batteries]) === weekender_pack_batteriOptions.onePack ? weekender_pack_batteriOptions.twoPack : weekender_pack_batteriOptions.onePack;
    var reverseBatteryChoice = productData.variants.some(function (variant) {
      return variant.options[weekender_pack_options.grillColor] === (defaultVariant === null || defaultVariant === void 0 ? void 0 : defaultVariant.options[weekender_pack_options.grillColor]) && variant.options[weekender_pack_options.batteries] === reverseBatteryOption;
    });
    setDisableExtraBattery(!reverseBatteryChoice);
    setProductVariant(defaultVariant);
  }, [productData, router.query]);

  var refreshData = function refreshData(color) {
    var regionCheck = regionId === 'na' ? '' : "/".concat(regionId);
    window.history.replaceState(null, "".concat(regionCheck, "/products/weekender-pack/"), "".concat(regionCheck, "/products/weekender-pack/?Grill+Color=").concat(color));
  };

  var handleColorSelector = function handleColorSelector(color) {
    var nextVariant = productData.variants.find(function (variant) {
      return variant.options[weekender_pack_options.grillColor] === color && variant.options[weekender_pack_options.batteries] === (extraBattery ? weekender_pack_batteriOptions.twoPack : weekender_pack_batteriOptions.onePack);
    });
    setSelectedColor(color);
    setAllowImageInteractionTracking(true);
    setTrackImageInteractionLimit(0);
    refreshData(color); // Does this variant exist with opposite selected battery?

    var reverseBatteryOption = nextVariant.options[weekender_pack_options.batteries] === weekender_pack_batteriOptions.onePack ? weekender_pack_batteriOptions.twoPack : weekender_pack_batteriOptions.onePack;
    var reverseBatteryChoice = productData.variants.some(function (variant) {
      return variant.options[weekender_pack_options.grillColor] === nextVariant.options[weekender_pack_options.grillColor] && variant.options[weekender_pack_options.batteries] === reverseBatteryOption;
    });
    setDisableExtraBattery(!reverseBatteryChoice);
    setProductVariant(nextVariant);
  };

  var handleBatterySelector = function handleBatterySelector(selected) {
    var variants = productData.variants.filter(function (variant) {
      return variant.options[weekender_pack_options.batteries] === (selected ? weekender_pack_batteriOptions.twoPack : weekender_pack_batteriOptions.onePack);
    });
    var colors = variants.map(function (variant) {
      return variant.options[weekender_pack_options.grillColor];
    });
    setAvalibleColors(function (prev) {
      return prev.map(function (color) {
        return colors.includes(color.id) ? weekender_pack_objectSpread(weekender_pack_objectSpread({}, color), {}, {
          disabled: false
        }) : weekender_pack_objectSpread(weekender_pack_objectSpread({}, color), {}, {
          disabled: true
        });
      });
    });
    setExtraBattery(selected);
    var trackBattery = selected ? weekender_pack_batteriOptions.twoPack : weekender_pack_batteriOptions.onePack;
    Object(utils["m" /* trackVariantInteraction */])(trackBattery);
    setAllowImageInteractionTracking(true);
    setTrackImageInteractionLimit(0);
    var nextVariant = variants.find(function (variant) {
      return variant.options[weekender_pack_options.grillColor] === selectedColor;
    });
    setProductVariant(nextVariant);
  };

  Object(react["useEffect"])(function () {
    if (productVariant) {
      var productImages = Object(getProductImages["a" /* default */])(productData.handle, productVariant.sku);
      var imageUrl = productImages.length ? productImages[0].url : '';
      var timer = setTimeout(function () {
        return Object(utils["i" /* trackProductPageview */])({
          name: productData.title,
          id: productVariant.sku,
          price: productVariant.price,
          brand: 'soundboks',
          category: productCategories,
          variant: productVariant.title,
          image: imageUrl
        });
      }, 1000);
      return function () {
        return clearTimeout(timer);
      };
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [regionId, productVariant]);

  var handleAddToCart = function handleAddToCart() {
    console.log('handleAddToCart', productVariant);

    if (productVariant.available) {
      dispatchAddCartItem(productVariant.id, 1, true);
    } else {
      console.log('join waitinglist dialog');
    }
  };

  var financialServices = function financialServices(variantPrice) {
    var locale = productData.locale;
    var klarnaAvailable = locale === 'de' || locale === 'no' || locale === 'da';
    var affirmAvailable = locale === 'en-US';
    return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, affirmAvailable && /*#__PURE__*/react_default.a.createElement(index_web_AffirmService, {
      price: variantPrice,
      locale: locale,
      isBlackTheme: true
    }), klarnaAvailable && /*#__PURE__*/react_default.a.createElement(index_web_KlarnaService, {
      price: variantPrice,
      locale: weekender_pack_klarnaData[locale].klarnaLocale,
      klarnaClassName: weekender_pack_klarnaData[locale].klarnaClassName
    }));
  };

  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    backgroundColor: elements_theme["a" /* Color */].Charcoal
  }, /*#__PURE__*/react_default.a.createElement(sub_navigation_SubNavigation, {
    productData: productData,
    productVariant: productVariant,
    anchorStack: anchorStack,
    selectedAnchor: selectedAnchor,
    isHeaderVisibility: isHeaderVisibility,
    offset: offset,
    handleAddToCart: handleAddToCart
  }), /*#__PURE__*/react_default.a.createElement("div", {
    ref: overview
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '24px',
      desktop: '46px'
    }
  }), /*#__PURE__*/react_default.a.createElement(weekender_pack_product_overview, {
    paths: weekender_pack_paths,
    offset: offset,
    anchorStack: anchorStack,
    productData: productData,
    productVariant: productVariant,
    onHeaderVisibility: handleHeaderVisibility,
    handleColorSelector: handleColorSelector,
    handleBatterySelector: handleBatterySelector,
    avalibleColors: avalibleColors,
    selectedColor: selectedColor,
    extraBattery: extraBattery,
    disableExtraBattery: disableExtraBattery,
    handleAddToCart: handleAddToCart,
    financialServices: financialServices,
    allowImageInteractionTracking: allowImageInteractionTracking,
    setAllowImageInteractionTracking: setAllowImageInteractionTracking,
    trackImageInteractionLimit: trackImageInteractionLimit,
    setTrackImageInteractionLimit: setTrackImageInteractionLimit
  })), /*#__PURE__*/react_default.a.createElement(weekender_pack_styled_BackgroundImage, null), /*#__PURE__*/react_default.a.createElement("div", {
    ref: learnMore
  }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    alignContentHorizontal: "center",
    backgroundColor: elements_theme["a" /* Color */].WhiteOff
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }), /*#__PURE__*/react_default.a.createElement(weekender_pack_learn_more, {
    extraBattery: extraBattery,
    locale: productData.locale
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }))), /*#__PURE__*/react_default.a.createElement("div", {
    ref: reviews
  }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    backgroundColor: elements_theme["a" /* Color */].White
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }), /*#__PURE__*/react_default.a.createElement(weekender_pack_product_review, null), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }))), /*#__PURE__*/react_default.a.createElement("div", {
    ref: relatedProducts
  }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    backgroundColor: elements_theme["a" /* Color */].WhiteOff
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }), /*#__PURE__*/react_default.a.createElement(weekender_pack_related_products, {
    relatedProducts: productData.crossSellHandles
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '60px',
      desktop: '72px'
    }
  }))));
};

/* harmony default export */ var weekender_pack = (weekender_pack_WeekenderPack);
// EXTERNAL MODULE: ./components/pages/products-v2/bundles/performer-pack/assets/PerformerPack-lifestyle-large.jpg
var PerformerPack_lifestyle_large = __webpack_require__("oP02");
var PerformerPack_lifestyle_large_default = /*#__PURE__*/__webpack_require__.n(PerformerPack_lifestyle_large);

// EXTERNAL MODULE: ./components/pages/products-v2/bundles/performer-pack/assets/PerformerPack-lifestyle-small.jpg
var PerformerPack_lifestyle_small = __webpack_require__("UmJs");
var PerformerPack_lifestyle_small_default = /*#__PURE__*/__webpack_require__.n(PerformerPack_lifestyle_small);

// CONCATENATED MODULE: ./components/pages/products-v2/bundles/performer-pack/styled.ts




var performer_pack_styled_BackgroundImage = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__BackgroundImage",
  componentId: "sc-1irsca6-0"
})(["display:block;width:100%;height:400px;background-image:url(", ");background-repeat:no-repeat;background-size:cover;background-position:center;@media ", "{height:852px;padding:20px;background-size:contain;background-image:url(", ");}"], PerformerPack_lifestyle_large_default.a.url, styles_theme["a" /* default */].breakpoints.tablet, PerformerPack_lifestyle_small_default.a.url);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/performer-pack/product-overview/index.tsx
var performer_pack_product_overview_jsx = react_default.a.createElement;






var performer_pack_product_overview_ProductOverviewSection = function ProductOverviewSection(_ref) {
  var productData = _ref.productData,
      paths = _ref.paths,
      onHeaderVisibility = _ref.onHeaderVisibility,
      handleColorSelector = _ref.handleColorSelector,
      handleBatterySelector = _ref.handleBatterySelector,
      productVariant = _ref.productVariant,
      avalibleColors = _ref.avalibleColors,
      selectedColor = _ref.selectedColor,
      extraBattery = _ref.extraBattery,
      disableExtraBattery = _ref.disableExtraBattery,
      handleAddToCart = _ref.handleAddToCart,
      financialServices = _ref.financialServices,
      offset = _ref.offset,
      anchorStack = _ref.anchorStack,
      allowImageInteractionTracking = _ref.allowImageInteractionTracking,
      setAllowImageInteractionTracking = _ref.setAllowImageInteractionTracking,
      trackImageInteractionLimit = _ref.trackImageInteractionLimit,
      setTrackImageInteractionLimit = _ref.setTrackImageInteractionLimit;
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentHorizontal: "center",
      padding: {
        right: 24,
        left: 24
      }
    }, /*#__PURE__*/react_default.a.createElement(index_web_ProductOverview, {
      paths: paths,
      offset: offset,
      anchorStack: anchorStack,
      productData: productData,
      handleColorSelector: handleColorSelector,
      handleBatterySelector: handleBatterySelector,
      productVariant: productVariant,
      avalibleColors: avalibleColors,
      selectedColor: selectedColor,
      extraBattery: extraBattery,
      disableExtraBattery: disableExtraBattery,
      handleAddToCart: handleAddToCart,
      financialServices: financialServices,
      allowImageInteractionTracking: allowImageInteractionTracking,
      setAllowImageInteractionTracking: setAllowImageInteractionTracking,
      trackImageInteractionLimit: trackImageInteractionLimit,
      setTrackImageInteractionLimit: setTrackImageInteractionLimit,
      labels: {
        grillColor: {
          label: i18n._('product.option.label.grill-color'),
          options: {
            Black: i18n._('product.option.label.black'),
            Orange: i18n._('product.option.label.orange'),
            White: i18n._('product.option.label.white'),
            Blue: i18n._('product.option.label.blue'),
            Red: i18n._('product.option.label.red')
          }
        },
        // extraBattery: {
        //   label: i18n._('product.option.label.extra-battery'),
        //   options: {
        //     yes: i18n._('product.option.label.yes'),
        //     no: i18n._('product.option.label.no'),
        //   },
        // },
        addToCart: i18n._('product.buy-page.button.addToCart'),
        outOfStock: i18n._('product.buy-page.button.outOfStock'),
        waitlist: i18n._('product.buy-page.button.waitlist'),
        usp: {
          warranty: i18n._('product.usp.warranty'),
          freeReturns: i18n._('product.usp.free-returns'),
          freeShipping: i18n._('product.usp.free-shipping'),
          premiumSupport: i18n._('product.usp.premium-support'),
          compatibility: i18n._('product.usp.compatibility')
        }
      },
      onHeaderVisibility: onHeaderVisibility
    }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    }));
  });
};

/* harmony default export */ var performer_pack_product_overview = (performer_pack_product_overview_ProductOverviewSection);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/performer-pack/learn-more/content.tsx
var performer_pack_learn_more_content_jsx = react_default.a.createElement;







var performer_pack_learn_more_content_packageItems = [{
  packageItemId: 'soundboks-gen-3-rf',
  title: 'Soundboks (Gen 3)',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconSoundboks3, null)
}, {
  packageItemId: 'microphone',
  title: 'Microphone',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconMicrophone, null)
}, {
  packageItemId: 'batteryboks',
  title: 'Batteryboks',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconBattery, null)
}, {
  packageItemId: 'extra-batteryboks',
  title: 'Extra Batteryboks',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconBattery, null)
}, {
  packageItemId: 'charger',
  title: 'Charger',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconCharger, null)
}, {
  packageItemId: 'soundboks-gen-3-manual',
  title: 'Manual',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconManual, null),
  downloadUrl: soundboks3["default"]
}];
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/performer-pack/learn-more/tech-spec/styled.ts

var performer_pack_learn_more_tech_spec_styled_DescList = styled_components_browser_esm["default"].dl.withConfig({
  displayName: "styled__DescList",
  componentId: "sc-1321cis-0"
})(["margin:20px 0 0 0;"]);
var performer_pack_learn_more_tech_spec_styled_DescTitle = styled_components_browser_esm["default"].dt.withConfig({
  displayName: "styled__DescTitle",
  componentId: "sc-1321cis-1"
})(["margin:0;"]);
var performer_pack_learn_more_tech_spec_styled_DescDetails = styled_components_browser_esm["default"].dd.withConfig({
  displayName: "styled__DescDetails",
  componentId: "sc-1321cis-2"
})(["margin:0;"]);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/performer-pack/learn-more/tech-spec/index.web.tsx
var performer_pack_learn_more_tech_spec_index_web_jsx = react_default.a.createElement;





 // eslint-disable-next-line prefer-arrow-callback

var performer_pack_learn_more_tech_spec_index_web_TechSpec = /*#__PURE__*/react_default.a.memo(function TechSpec() {
  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, null, /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "SOUND"
  })), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "AMPLIFIER"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Merus Audio eximo\xAE amp switching"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "3 \xD7 72W RMS class D amplifiers"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Advanced Bass DSP"
  })))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "ACOUSTICS"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Effective frequency range: 40Hz - 20kHz"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Custom sound profile with bass enhancer"
  })))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "DRIVER UNITS"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "2 \xD7 10\u201D 96dB woofers"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "1 \xD7 1\u201D 104dB compression driver tweeter"
  })))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "CONNECTIVITY"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Bluetooth 5.0"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "TeamUP connection"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Wirelessly connect up to 5 (total) nearby New SOUNDBOKS(2019) speakers (SKAA network)"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Pro Panel"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA 2 \xD7 Combo microphone/instrument (XLR, 1/4\u201D) input"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA 1 \xD7 3.5mm Stereo Input"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA 1 \xD7 3.5mm Stereo Output"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Bond Button for advanced JOIN settings"
  })))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "BUILD"
  })), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "WEIGHT"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "34 pounds (15.4 kg)"
  })))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "MATERIALS"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Poplar cabinet"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Powder-coated aluminum frame"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Powder-coated steel grill and handles"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Silicone ball corners"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "SMP temperature-flex adhesive"
  })))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "DIMENSIONS"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "66 \xD7 43 \xD7 32 cm / 25.6 \xD7 17 \xD7 13 inches (H \xD7 W \xD7 D)"
  })))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "FEATURES"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Swappable grill and batteries"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "IP65 rated electronics coating"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Pulse Reflex Port"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "UI Panel"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Volume control"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Host/Join mode for wireless TeamUP"
  })))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "BATTERY"
  })), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "LIFE"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "40 hours at mid-volume"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "5 hours at full volume"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "3.5 hours full recharge"
  })))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "DESIGN"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "5-step LED battery-life indicator"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Heavy-duty DC-connector"
  })))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "CELL TYPE"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "12.8V, 7.8Ah Lithium Iron Phosphate (LiFePO4)"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "-10C to 40C temperature range"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "99.84Wh or 7.8Ah capacity"
  })))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "BATTERY MANAGEMENT SYSTEM (BMS)"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Over and under-discharge protection"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Short circuit protection"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Overheat protection"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Cell voltage management"
  })))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app"
  })), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.soundSettings"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.soundSettings.1"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.soundSettings.2"
  })))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.proPanel"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.proPanel.1"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.proPanel.2"
  })))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.1"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.2"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.3"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.4"
  })))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings.1"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings.2"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings.3"
  })))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.firmwareUpdate"
  }))), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.firmwareUpdate.1"
  })))));
});
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/performer-pack/learn-more/styled.ts



var performer_pack_learn_more_styled_LayoutContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__LayoutContainer",
  componentId: "sc-19a0tkk-0"
})(["padding:0 190px;background-color:", ";@media ", "{padding:0 24px;}"], elements_theme["a" /* Color */].WhiteOff, styles_theme["a" /* default */].breakpoints.maxMobile);
var performer_pack_learn_more_styled_Link = styled_components_browser_esm["default"].a.withConfig({
  displayName: "styled__Link",
  componentId: "sc-19a0tkk-1"
})(["color:", ";cursor:pointer;text-decoration:underline;"], elements_theme["a" /* Color */].Orange);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/performer-pack/learn-more/faqs/index.web.tsx
var performer_pack_learn_more_faqs_index_web_jsx = react_default.a.createElement;





// eslint-disable-next-line prefer-arrow-callback
var performer_pack_learn_more_faqs_index_web_FAQs = /*#__PURE__*/react_default.a.memo(function FAQs() {
  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    padding: {
      right: 10
    }
  }, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.performer-pack.learn-more.faqs.question-1"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.performer-pack.learn-more.faqs.answer-1"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.performer-pack.learn-more.faqs.question-2"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.performer-pack.learn-more.faqs.answer-2"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.performer-pack.learn-more.faqs.question-3"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.performer-pack.learn-more.faqs.answer-3"
  }));
});
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/performer-pack/learn-more/index.tsx
var performer_pack_learn_more_jsx = react_default.a.createElement;

















var performer_pack_learn_more_LearnMoreSection = function LearnMoreSection(_ref) {
  var extraBattery = _ref.extraBattery,
      locale = _ref.locale;

  var _useSelector = Object(es["d" /* useSelector */])(function (state) {
    return state.settings;
  }),
      regionId = _useSelector.regionId;

  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_LayoutContainer, null, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(elements_typography["e" /* Heading02 */], {
      ariaLevel: elements_typography["h" /* TextLevel */].H2,
      style: {
        textTransform: 'uppercase',
        textAlign: 'center'
      }
    }, i18n._('product.learn-more.heading')), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "35px"
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.whats-in-the-box",
      content: /*#__PURE__*/react_default.a.createElement(index_web_WhatsInTheBox, {
        extraBattery: extraBattery,
        packageItems: performer_pack_learn_more_content_packageItems
      }),
      topItem: true
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.tech-specs",
      content: /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_tech_spec_index_web_TechSpec, null)
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.performer-pack.seo.blurb",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "product.learn-more.performer-pack.seo.blurb.info"
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.shipping",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: learn_more_content_content.shipping[regionId] || learn_more_content_content.shipping["default"],
        components: [/*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_styled_Link, {
          href: helpCenter_getHelpCenterUrl(locale, '/sections/360003609413-SHIPPING')
        }), /*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement("br", null)]
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.warranty",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "product.learn-more.warranty.info",
        components: [/*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_styled_Link, {
          href: helpCenter_getHelpCenterUrl(locale, '/articles/211920329-RETURN-AND-REFUND-POLICY-AND-PROCESS')
        })]
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.payment-options",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "product.learn-more.payment-options.info"
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.faqs",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more_faqs_index_web_FAQs, null))
    })));
  });
};

var performer_pack_learn_more_LayoutContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "learn-more__LayoutContainer",
  componentId: "krpp8k-0"
})(["max-width:1062px;width:100%;@media ", "{padding:0 24px;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
/* harmony default export */ var performer_pack_learn_more = (performer_pack_learn_more_LearnMoreSection);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/performer-pack/product-review/styled.tsx


var performer_pack_product_review_styled_StyledHorizontalLine = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__StyledHorizontalLine",
  componentId: "sc-1qd964u-0"
})(["display:none;@media ", "{display:block;padding:0px 24px;}"], styles_theme["a" /* default */].breakpoints.maxMobile);
var performer_pack_product_review_styled_LayoutContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__LayoutContainer",
  componentId: "sc-1qd964u-1"
})(["position:relative;width:100%;max-width:1024px;text-align:center;align-self:center;@media ", "{max-width:720px;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/performer-pack/product-review/index.tsx
var performer_pack_product_review_jsx = react_default.a.createElement;











var performer_pack_product_review_ProductReviewSection = function ProductReviewSection() {
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref) {
    var i18n = _ref.i18n;
    return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(performer_pack_product_review_styled_LayoutContainer, null, /*#__PURE__*/react_default.a.createElement(elements_typography["e" /* Heading02 */], {
      ariaLevel: elements_typography["h" /* TextLevel */].H2,
      color: elements_theme["a" /* Color */].Orange,
      style: {
        textTransform: 'uppercase'
      }
    }, i18n._('product.reviews.heading'))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    }), /*#__PURE__*/react_default.a.createElement(performer_pack_product_review_styled_StyledHorizontalLine, null, /*#__PURE__*/react_default.a.createElement(HorizontalLine, {
      color: elements_theme["a" /* Color */].WhiteOff
    }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    })), /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(index_web_VideoFeature, {
      videos: [{
        YouTubeId: 'FuD9ujTbZCE',
        children: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "The world's LOUDEST portable speaker for DJs?")
      }, {
        YouTubeId: 'JrGlmymabNg',
        children: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "Soundboks Update - New Sound Modes New Features")
      }, {
        YouTubeId: 'j9WFgrGU5ro',
        children: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "The world's Loudest Wireless Speaker")
      }],
      height: "184px"
    })), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    }), /*#__PURE__*/react_default.a.createElement(performer_pack_product_review_styled_StyledHorizontalLine, null, /*#__PURE__*/react_default.a.createElement(HorizontalLine, {
      color: elements_theme["a" /* Color */].WhiteOff
    }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    })), /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(Trustbox, null)));
  });
};

/* harmony default export */ var performer_pack_product_review = (performer_pack_product_review_ProductReviewSection);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/performer-pack/related-products/index.tsx
var performer_pack_related_products_jsx = react_default.a.createElement;






var performer_pack_related_products_RelatedProductsSection = function RelatedProductsSection(_ref) {
  var relatedProducts = _ref.relatedProducts;
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      grow: 1
    }, /*#__PURE__*/react_default.a.createElement(RelatedProducts, {
      relatedProducts: relatedProducts,
      headline: i18n._('product.related-products.heading')
    })));
  });
};

/* harmony default export */ var performer_pack_related_products = (performer_pack_related_products_RelatedProductsSection);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/performer-pack/index.tsx

var performer_pack_jsx = react_default.a.createElement;

function performer_pack_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function performer_pack_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { performer_pack_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { performer_pack_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



















var performer_pack_paths = [{
  label: 'Home',
  url: '/'
}, {
  label: 'Bundles',
  url: '/products/?filter=bundles'
}, {
  label: 'Performer Pack'
}];
var performer_pack_options = {
  grillColor: 'Grill Color',
  batteries: 'Batteries'
};
var performer_pack_klarnaData = {
  de: {
    klarnaLocale: 'de-DE',
    klarnaClassName: 'klarna-pricetag-de'
  },
  no: {
    klarnaLocale: 'no-NO',
    klarnaClassName: 'klarna-pricetag-no'
  },
  da: {
    klarnaLocale: 'da-DK',
    klarnaClassName: 'klarna-pricetag-dk'
  }
};
var performer_pack_colorOptions = [{
  id: 'Black',
  label: 'Black',
  value: '#000000'
}, {
  id: 'Orange',
  label: 'Orange',
  value: '#FA4616'
}, {
  id: 'White',
  label: 'White',
  value: '#FFFFFF'
} // Temporarly removed till further instructions
// { id: 'Blue', label: 'Blue', value: '#19415E' },
// { id: 'Red', label: 'Red', value: '#AA273B' },
];
var performer_pack_batteriOptions = {
  onePack: '1x BATTERYBOKS',
  twoPack: '2x BATTERYBOKS'
};

var performer_pack_PerformerPack = function PerformerPack(_ref) {
  var productData = _ref.productData,
      dispatchAddCartItem = _ref.dispatchAddCartItem;

  var _useSelector = Object(es["d" /* useSelector */])(function (state) {
    return state;
  }),
      settings = _useSelector.settings;

  var regionId = settings.regionId;
  var overview = Object(react["useRef"])(null);
  var learnMore = Object(react["useRef"])(null);
  var reviews = Object(react["useRef"])(null);
  var relatedProducts = Object(react["useRef"])(null);

  var _useState = Object(react["useState"])(),
      anchorStack = _useState[0],
      setAnchorStack = _useState[1];

  var _useState2 = Object(react["useState"])(),
      selectedAnchor = _useState2[0],
      setSelectedAnchor = _useState2[1];

  var _useState3 = Object(react["useState"])(false),
      isHeaderVisibility = _useState3[0],
      setIsHeaderVisibility = _useState3[1];

  var _useState4 = Object(react["useState"])(),
      productVariant = _useState4[0],
      setProductVariant = _useState4[1];

  var _useState5 = Object(react["useState"])(),
      selectedColor = _useState5[0],
      setSelectedColor = _useState5[1];

  var _useState6 = Object(react["useState"])(),
      avalibleColors = _useState6[0],
      setAvalibleColors = _useState6[1];

  var _useState7 = Object(react["useState"])(),
      extraBattery = _useState7[0],
      setExtraBattery = _useState7[1];

  var _useState8 = Object(react["useState"])(),
      disableExtraBattery = _useState8[0],
      setDisableExtraBattery = _useState8[1];

  var productCategories = Object(mergeUACategories["a" /* default */])(abstractProducts_default.a.byId[productData.handle].categories);

  var _useState9 = Object(react["useState"])(true),
      allowImageInteractionTracking = _useState9[0],
      setAllowImageInteractionTracking = _useState9[1];

  var _useState10 = Object(react["useState"])(0),
      trackImageInteractionLimit = _useState10[0],
      setTrackImageInteractionLimit = _useState10[1];

  var router = Object(next_router["useRouter"])();
  var offset = 124;
  Object(react["useEffect"])(function () {
    var initialStack = [{
      label: 'products.subnavigation.achor.overview',
      ref: overview
    }, {
      label: 'products.subnavigation.achor.learn-more',
      ref: learnMore
    }, {
      label: 'products.subnavigation.achor.reviews',
      ref: reviews
    }, {
      label: 'products.subnavigation.achor.related-products',
      ref: relatedProducts
    }];
    setAnchorStack(initialStack);

    var handleScroll = function handleScroll() {
      var stackIndex = initialStack.findIndex(function (stack) {
        return stack.ref.current.getBoundingClientRect().y - offset > 0;
      });
      var stack = stackIndex === -1 ? initialStack[initialStack.length - 1] : initialStack[stackIndex - 1];
      setSelectedAnchor(stack.ref.current);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return function () {
      return window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  var handleHeaderVisibility = function handleHeaderVisibility(isVisibility) {
    setIsHeaderVisibility(isVisibility);
  };

  Object(react["useEffect"])(function () {
    var defaultOption = productData.variants.find(function (variant) {
      return variant.sku;
    });
    var optionsFromUrlQueries = productData.variants.find(function (variant) {
      return variant.options[performer_pack_options.grillColor] === router.query[performer_pack_options.grillColor];
    });
    var defaultVariant = optionsFromUrlQueries || defaultOption;
    setSelectedColor(defaultVariant === null || defaultVariant === void 0 ? void 0 : defaultVariant.options[performer_pack_options.grillColor]);
    var variantColors = productData.variants.map(function (variant) {
      return variant.options[performer_pack_options.grillColor];
    });
    var colors = performer_pack_colorOptions.filter(function (_ref2) {
      var id = _ref2.id;
      return variantColors.includes(id);
    });
    setAvalibleColors(colors);
    setExtraBattery((defaultVariant === null || defaultVariant === void 0 ? void 0 : defaultVariant.options[performer_pack_options.batteries]) === performer_pack_batteriOptions.twoPack); // Does this variant exist with opposite selected battery?

    var reverseBatteryOption = (defaultVariant === null || defaultVariant === void 0 ? void 0 : defaultVariant.options[performer_pack_options.batteries]) === performer_pack_batteriOptions.onePack ? performer_pack_batteriOptions.twoPack : performer_pack_batteriOptions.onePack;
    var reverseBatteryChoice = productData.variants.some(function (variant) {
      return variant.options[performer_pack_options.grillColor] === (defaultVariant === null || defaultVariant === void 0 ? void 0 : defaultVariant.options[performer_pack_options.grillColor]) && variant.options[performer_pack_options.batteries] === reverseBatteryOption;
    });
    setDisableExtraBattery(!reverseBatteryChoice);
    setProductVariant(defaultVariant);
  }, [productData, router.query]);

  var refreshData = function refreshData(color) {
    var regionCheck = regionId === 'na' ? '' : "/".concat(regionId);
    window.history.replaceState(null, "".concat(regionCheck, "/products/performer-pack/"), "".concat(regionCheck, "/products/performer-pack/?Grill+Color=").concat(color));
  };

  var handleColorSelector = function handleColorSelector(color) {
    var nextVariant = productData.variants.find(function (variant) {
      return variant.options[performer_pack_options.grillColor] === color && variant.options[performer_pack_options.batteries] === (extraBattery ? performer_pack_batteriOptions.twoPack : performer_pack_batteriOptions.onePack);
    });
    setSelectedColor(color);
    setAllowImageInteractionTracking(true);
    setTrackImageInteractionLimit(0);
    refreshData(color); // Does this variant exist with opposite selected battery?

    var reverseBatteryOption = nextVariant.options[performer_pack_options.batteries] === performer_pack_batteriOptions.onePack ? performer_pack_batteriOptions.twoPack : performer_pack_batteriOptions.onePack;
    var reverseBatteryChoice = productData.variants.some(function (variant) {
      return variant.options[performer_pack_options.grillColor] === nextVariant.options[performer_pack_options.grillColor] && variant.options[performer_pack_options.batteries] === reverseBatteryOption;
    });
    setDisableExtraBattery(!reverseBatteryChoice);
    setProductVariant(nextVariant);
  };

  var handleBatterySelector = function handleBatterySelector(selected) {
    var variants = productData.variants.filter(function (variant) {
      return variant.options[performer_pack_options.batteries] === (selected ? performer_pack_batteriOptions.twoPack : performer_pack_batteriOptions.onePack);
    });
    var colors = variants.map(function (variant) {
      return variant.options[performer_pack_options.grillColor];
    });
    setAvalibleColors(function (prev) {
      return prev.map(function (color) {
        return colors.includes(color.id) ? performer_pack_objectSpread(performer_pack_objectSpread({}, color), {}, {
          disabled: false
        }) : performer_pack_objectSpread(performer_pack_objectSpread({}, color), {}, {
          disabled: true
        });
      });
    });
    setExtraBattery(selected);
    var trackBattery = selected ? performer_pack_batteriOptions.twoPack : performer_pack_batteriOptions.onePack;
    Object(utils["m" /* trackVariantInteraction */])(trackBattery);
    setAllowImageInteractionTracking(true);
    setTrackImageInteractionLimit(0);
    var nextVariant = variants.find(function (variant) {
      return variant.options[performer_pack_options.grillColor] === selectedColor;
    });
    setProductVariant(nextVariant);
  };

  Object(react["useEffect"])(function () {
    if (productVariant) {
      var productImages = Object(getProductImages["a" /* default */])(productData.handle, productVariant.sku);
      var imageUrl = productImages.length ? productImages[0].url : '';
      var timer = setTimeout(function () {
        return Object(utils["i" /* trackProductPageview */])({
          name: productData.title,
          id: productVariant.sku,
          price: productVariant.price,
          brand: 'soundboks',
          category: productCategories,
          variant: productVariant.title,
          image: imageUrl
        });
      }, 1000);
      return function () {
        return clearTimeout(timer);
      };
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [regionId, productVariant]);

  var handleAddToCart = function handleAddToCart() {
    console.log('handleAddToCart', productVariant);

    if (productVariant.available) {
      dispatchAddCartItem(productVariant.id, 1, true);
    } else {
      console.log('join waitinglist dialog');
    }
  };

  var financialServices = function financialServices(variantPrice) {
    var locale = productData.locale;
    var klarnaAvailable = locale === 'de' || locale === 'no' || locale === 'da';
    var affirmAvailable = locale === 'en-US';
    return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, affirmAvailable && /*#__PURE__*/react_default.a.createElement(index_web_AffirmService, {
      price: variantPrice,
      locale: locale,
      isBlackTheme: true
    }), klarnaAvailable && /*#__PURE__*/react_default.a.createElement(index_web_KlarnaService, {
      price: variantPrice,
      locale: performer_pack_klarnaData[locale].klarnaLocale,
      klarnaClassName: performer_pack_klarnaData[locale].klarnaClassName
    }));
  };

  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    backgroundColor: elements_theme["a" /* Color */].Charcoal
  }, /*#__PURE__*/react_default.a.createElement(sub_navigation_SubNavigation, {
    productData: productData,
    productVariant: productVariant,
    anchorStack: anchorStack,
    selectedAnchor: selectedAnchor,
    isHeaderVisibility: isHeaderVisibility,
    offset: offset,
    handleAddToCart: handleAddToCart
  }), /*#__PURE__*/react_default.a.createElement("div", {
    ref: overview
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '24px',
      desktop: '46px'
    }
  }), /*#__PURE__*/react_default.a.createElement(performer_pack_product_overview, {
    paths: performer_pack_paths,
    offset: offset,
    anchorStack: anchorStack,
    productData: productData,
    productVariant: productVariant,
    onHeaderVisibility: handleHeaderVisibility,
    handleColorSelector: handleColorSelector,
    handleBatterySelector: handleBatterySelector,
    avalibleColors: avalibleColors,
    selectedColor: selectedColor,
    extraBattery: extraBattery,
    disableExtraBattery: disableExtraBattery,
    handleAddToCart: handleAddToCart,
    financialServices: financialServices,
    allowImageInteractionTracking: allowImageInteractionTracking,
    setAllowImageInteractionTracking: setAllowImageInteractionTracking,
    trackImageInteractionLimit: trackImageInteractionLimit,
    setTrackImageInteractionLimit: setTrackImageInteractionLimit
  })), /*#__PURE__*/react_default.a.createElement(performer_pack_styled_BackgroundImage, null), /*#__PURE__*/react_default.a.createElement("div", {
    ref: learnMore
  }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    alignContentHorizontal: "center",
    backgroundColor: elements_theme["a" /* Color */].WhiteOff
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }), /*#__PURE__*/react_default.a.createElement(performer_pack_learn_more, {
    extraBattery: extraBattery,
    locale: productData.locale
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }))), /*#__PURE__*/react_default.a.createElement("div", {
    ref: reviews
  }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    backgroundColor: elements_theme["a" /* Color */].White
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }), /*#__PURE__*/react_default.a.createElement(performer_pack_product_review, null), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }))), /*#__PURE__*/react_default.a.createElement("div", {
    ref: relatedProducts
  }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    backgroundColor: elements_theme["a" /* Color */].WhiteOff
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }), /*#__PURE__*/react_default.a.createElement(performer_pack_related_products, {
    relatedProducts: productData.crossSellHandles
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '60px',
      desktop: '72px'
    }
  }))));
};

/* harmony default export */ var performer_pack = (performer_pack_PerformerPack);
// EXTERNAL MODULE: ./components/pages/products-v2/accessories/carrier-strap/assets/SBGO_STRAP_MOBILE.jpg
var SBGO_STRAP_MOBILE = __webpack_require__("JoWG");
var SBGO_STRAP_MOBILE_default = /*#__PURE__*/__webpack_require__.n(SBGO_STRAP_MOBILE);

// EXTERNAL MODULE: ./components/pages/products-v2/accessories/carrier-strap/assets/SBGO_STRAP_DESKTOP.jpg
var SBGO_STRAP_DESKTOP = __webpack_require__("E+LM");
var SBGO_STRAP_DESKTOP_default = /*#__PURE__*/__webpack_require__.n(SBGO_STRAP_DESKTOP);

// CONCATENATED MODULE: ./components/pages/products-v2/accessories/carrier-strap/styled.ts




var carrier_strap_styled_BackgroundImage = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__BackgroundImage",
  componentId: "sc-1ejfz4t-0"
})(["display:block;width:100%;height:400px;background-image:url(", ");background-repeat:no-repeat;background-size:cover;background-position:30% 70%;@media ", "{height:852px;padding:20px;background-position:center;background-image:url(", ");}"], SBGO_STRAP_MOBILE_default.a.url, styles_theme["a" /* default */].breakpoints.tablet, SBGO_STRAP_DESKTOP_default.a.url);
// CONCATENATED MODULE: ./components/pages/products-v2/accessories/carrier-strap/product-overview/index.tsx
var carrier_strap_product_overview_jsx = react_default.a.createElement;






var carrier_strap_product_overview_ProductOverviewSection = function ProductOverviewSection(_ref) {
  var productData = _ref.productData,
      paths = _ref.paths,
      onHeaderVisibility = _ref.onHeaderVisibility,
      productVariant = _ref.productVariant,
      handleAddToCart = _ref.handleAddToCart,
      financialServices = _ref.financialServices,
      offset = _ref.offset,
      anchorStack = _ref.anchorStack,
      allowImageInteractionTracking = _ref.allowImageInteractionTracking,
      setAllowImageInteractionTracking = _ref.setAllowImageInteractionTracking,
      trackImageInteractionLimit = _ref.trackImageInteractionLimit,
      setTrackImageInteractionLimit = _ref.setTrackImageInteractionLimit;
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentHorizontal: "center",
      padding: {
        right: 24,
        left: 24
      }
    }, /*#__PURE__*/react_default.a.createElement(index_web_ProductOverview, {
      paths: paths,
      offset: offset,
      anchorStack: anchorStack,
      productData: productData,
      productVariant: productVariant,
      handleAddToCart: handleAddToCart,
      financialServices: financialServices,
      allowImageInteractionTracking: allowImageInteractionTracking,
      setAllowImageInteractionTracking: setAllowImageInteractionTracking,
      trackImageInteractionLimit: trackImageInteractionLimit,
      setTrackImageInteractionLimit: setTrackImageInteractionLimit,
      labels: {
        addToCart: i18n._('product.buy-page.button.addToCart'),
        outOfStock: i18n._('product.buy-page.button.outOfStock'),
        waitlist: i18n._('product.buy-page.button.waitlist'),
        usp: {
          warranty: i18n._('product.usp.warranty'),
          freeReturns: i18n._('product.usp.free-returns'),
          freeShipping: i18n._('product.usp.free-shipping'),
          premiumSupport: i18n._('product.usp.premium-support'),
          compatibility: i18n._('product.usp.compatibility')
        }
      },
      onHeaderVisibility: onHeaderVisibility
    }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    }));
  });
};

/* harmony default export */ var carrier_strap_product_overview = (carrier_strap_product_overview_ProductOverviewSection);
// CONCATENATED MODULE: ./components/pages/products-v2/accessories/carrier-strap/learn-more/whats-in-the-box/styled.ts


var carrier_strap_learn_more_whats_in_the_box_styled_IconWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__IconWrapper",
  componentId: "cetpsa-0"
})(["display:block;"]);
var carrier_strap_learn_more_whats_in_the_box_styled_Layout = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__Layout",
  componentId: "cetpsa-1"
})(["display:flex;flex-direction:row;justify-content:space-evenly;padding:10px 50px;align-items:end;@media ", "{display:grid;grid-template-columns:1fr 1fr;grid-gap:30px;padding:15px 0px;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
var carrier_strap_learn_more_whats_in_the_box_styled_Link = styled_components_browser_esm["default"].a.withConfig({
  displayName: "styled__Link",
  componentId: "cetpsa-2"
})(["text-decoration:underline;"]);
// CONCATENATED MODULE: ./components/pages/products-v2/accessories/carrier-strap/learn-more/whats-in-the-box/index.web.tsx
var carrier_strap_learn_more_whats_in_the_box_index_web_jsx = react_default.a.createElement;





// eslint-disable-next-line prefer-arrow-callback
var carrier_strap_learn_more_whats_in_the_box_index_web_WhatsInTheBox = /*#__PURE__*/react_default.a.memo(function WhatsInTheBox(_ref) {
  var packageItems = _ref.packageItems,
      extraBattery = _ref.extraBattery;
  return /*#__PURE__*/react_default.a.createElement(carrier_strap_learn_more_whats_in_the_box_styled_Layout, null, packageItems.filter(function (item) {
    return !extraBattery ? item.packageItemId !== 'extra-batteryboks' : item;
  }).map(function (_ref2) {
    var packageItemId = _ref2.packageItemId,
        title = _ref2.title,
        icon = _ref2.icon,
        downloadUrl = _ref2.downloadUrl;
    return /*#__PURE__*/react_default.a.createElement("div", {
      key: packageItemId
    }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(carrier_strap_learn_more_whats_in_the_box_styled_IconWrapper, null, icon), /*#__PURE__*/react_default.a.createElement(spacer_Spacer, {
      height: 10
    }), /*#__PURE__*/react_default.a.createElement(elements_typography["d" /* Caption02 */], null, title, " ", downloadUrl ? /*#__PURE__*/react_default.a.createElement(carrier_strap_learn_more_whats_in_the_box_styled_Link, {
      href: downloadUrl,
      target: "_blank"
    }, "Download") : null)));
  }));
});
// CONCATENATED MODULE: ./components/pages/products-v2/accessories/carrier-strap/learn-more/content.tsx
var carrier_strap_learn_more_content_jsx = react_default.a.createElement;


var carrier_strap_learn_more_content_packageItems = [{
  packageItemId: 'carrier-strap',
  title: 'Carrier Strap',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconCarrierStrap, null)
}];
// CONCATENATED MODULE: ./components/pages/products-v2/accessories/carrier-strap/learn-more/styled.ts



var carrier_strap_learn_more_styled_LayoutContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__LayoutContainer",
  componentId: "sc-1s5flm1-0"
})(["padding:0 190px;background-color:", ";@media ", "{padding:0 24px;}"], elements_theme["a" /* Color */].WhiteOff, styles_theme["a" /* default */].breakpoints.maxMobile);
var carrier_strap_learn_more_styled_Link = styled_components_browser_esm["default"].a.withConfig({
  displayName: "styled__Link",
  componentId: "sc-1s5flm1-1"
})(["color:", ";cursor:pointer;text-decoration:underline;"], elements_theme["a" /* Color */].Orange);
// CONCATENATED MODULE: ./components/pages/products-v2/accessories/carrier-strap/learn-more/index.tsx
var carrier_strap_learn_more_jsx = react_default.a.createElement;















var carrier_strap_learn_more_LearnMoreSection = function LearnMoreSection(_ref) {
  var extraBattery = _ref.extraBattery,
      locale = _ref.locale;

  var _useSelector = Object(es["d" /* useSelector */])(function (state) {
    return state.settings;
  }),
      regionId = _useSelector.regionId;

  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(carrier_strap_learn_more_LayoutContainer, null, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(elements_typography["e" /* Heading02 */], {
      ariaLevel: elements_typography["h" /* TextLevel */].H2,
      style: {
        textTransform: 'uppercase',
        textAlign: 'center'
      }
    }, i18n._('product.learn-more.heading')), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "35px"
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.whats-in-the-box",
      content: /*#__PURE__*/react_default.a.createElement(carrier_strap_learn_more_whats_in_the_box_index_web_WhatsInTheBox, {
        extraBattery: extraBattery,
        packageItems: carrier_strap_learn_more_content_packageItems
      }),
      topItem: true
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.carrier-strap.learn-more.seo-blurb",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "product.carrier-strap.learn-more.seo-blurb.info"
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.shipping",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: learn_more_content_content.shipping[regionId] || learn_more_content_content.shipping["default"],
        components: [/*#__PURE__*/react_default.a.createElement(carrier_strap_learn_more_styled_Link, {
          href: helpCenter_getHelpCenterUrl(locale, '/sections/360003609413-SHIPPING')
        }), /*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement("br", null)]
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.warranty",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "product.learn-more.warranty.info",
        components: [/*#__PURE__*/react_default.a.createElement(carrier_strap_learn_more_styled_Link, {
          href: helpCenter_getHelpCenterUrl(locale, '/articles/211920329-RETURN-AND-REFUND-POLICY-AND-PROCESS')
        })]
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.payment-options",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "product.learn-more.payment-options.info"
      }))
    })));
  });
};

var carrier_strap_learn_more_LayoutContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "learn-more__LayoutContainer",
  componentId: "sc-1jbeg18-0"
})(["max-width:1062px;width:100%;@media ", "{padding:0 24px;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
/* harmony default export */ var carrier_strap_learn_more = (carrier_strap_learn_more_LearnMoreSection);
// CONCATENATED MODULE: ./components/pages/products-v2/accessories/carrier-strap/product-review/index.tsx
var carrier_strap_product_review_jsx = react_default.a.createElement;









var carrier_strap_product_review_ProductReviewSection = function ProductReviewSection() {
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref) {
    var i18n = _ref.i18n;
    return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentVertical: "center",
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(elements_typography["e" /* Heading02 */], {
      ariaLevel: elements_typography["h" /* TextLevel */].H2,
      color: elements_theme["a" /* Color */].Orange,
      style: {
        textTransform: 'uppercase'
      }
    }, i18n._('product.reviews.heading'))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    }), /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(Trustbox, null)));
  });
};

/* harmony default export */ var carrier_strap_product_review = (carrier_strap_product_review_ProductReviewSection);
// CONCATENATED MODULE: ./components/pages/products-v2/accessories/carrier-strap/related-products/index.tsx
var carrier_strap_related_products_jsx = react_default.a.createElement;






var carrier_strap_related_products_RelatedProductsSection = function RelatedProductsSection(_ref) {
  var relatedProducts = _ref.relatedProducts;
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      grow: 1
    }, /*#__PURE__*/react_default.a.createElement(RelatedProducts, {
      relatedProducts: relatedProducts,
      headline: i18n._('product.related-products.heading')
    })));
  });
};

/* harmony default export */ var carrier_strap_related_products = (carrier_strap_related_products_RelatedProductsSection);
// CONCATENATED MODULE: ./components/pages/products-v2/accessories/carrier-strap/index.tsx
var carrier_strap_jsx = react_default.a.createElement;


















var carrier_strap_paths = [{
  label: 'Home',
  url: '/'
}, {
  label: 'Accesssories',
  url: '/products/?filter=accessories'
}, {
  label: 'Carrier Strap'
}];
var carrier_strap_klarnaData = {
  de: {
    klarnaLocale: 'de-DE',
    klarnaClassName: 'klarna-pricetag-de'
  },
  no: {
    klarnaLocale: 'no-NO',
    klarnaClassName: 'klarna-pricetag-no'
  },
  da: {
    klarnaLocale: 'da-DK',
    klarnaClassName: 'klarna-pricetag-dk'
  }
};

var carrier_strap_CarrierStrap = function CarrierStrap(_ref) {
  var productData = _ref.productData,
      dispatchAddCartItem = _ref.dispatchAddCartItem;

  var _useSelector = Object(es["d" /* useSelector */])(function (state) {
    return state;
  }),
      settings = _useSelector.settings;

  var regionId = settings.regionId;
  var overview = Object(react["useRef"])(null);
  var learnMore = Object(react["useRef"])(null);
  var reviews = Object(react["useRef"])(null);
  var relatedProducts = Object(react["useRef"])(null);

  var _useState = Object(react["useState"])(),
      anchorStack = _useState[0],
      setAnchorStack = _useState[1];

  var _useState2 = Object(react["useState"])(),
      selectedAnchor = _useState2[0],
      setSelectedAnchor = _useState2[1];

  var _useState3 = Object(react["useState"])(false),
      isHeaderVisibility = _useState3[0],
      setIsHeaderVisibility = _useState3[1];

  var _useState4 = Object(react["useState"])(),
      productVariant = _useState4[0],
      setProductVariant = _useState4[1];

  var productCategories = Object(mergeUACategories["a" /* default */])(abstractProducts_default.a.byId[productData.handle].categories);

  var _useState5 = Object(react["useState"])(true),
      allowImageInteractionTracking = _useState5[0],
      setAllowImageInteractionTracking = _useState5[1];

  var _useState6 = Object(react["useState"])(0),
      trackImageInteractionLimit = _useState6[0],
      setTrackImageInteractionLimit = _useState6[1];

  var router = Object(next_router["useRouter"])();
  var offset = 124;
  Object(react["useEffect"])(function () {
    var initialStack = [{
      label: 'products.subnavigation.achor.overview',
      ref: overview
    }, {
      label: 'products.subnavigation.achor.learn-more',
      ref: learnMore
    }, {
      label: 'products.subnavigation.achor.reviews',
      ref: reviews
    }, {
      label: 'products.subnavigation.achor.related-products',
      ref: relatedProducts
    }];
    setAnchorStack(initialStack);

    var handleScroll = function handleScroll() {
      var stackIndex = initialStack.findIndex(function (stack) {
        return stack.ref.current.getBoundingClientRect().y - offset > 0;
      });
      var stack = stackIndex === -1 ? initialStack[initialStack.length - 1] : initialStack[stackIndex - 1];
      setSelectedAnchor(stack.ref.current);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return function () {
      return window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  var handleHeaderVisibility = function handleHeaderVisibility(isVisibility) {
    setIsHeaderVisibility(isVisibility);
  };

  Object(react["useEffect"])(function () {
    var defaultOption = productData.variants.find(function (variant) {
      return variant.sku === productData.defaultSku;
    });
    setProductVariant(defaultOption);
  }, [productData, router.query]);
  Object(react["useEffect"])(function () {
    if (productVariant) {
      var productImages = Object(getProductImages["a" /* default */])(productData.handle, productVariant.sku);
      var imageUrl = productImages.length ? productImages[0].url : '';
      var timer = setTimeout(function () {
        return Object(utils["i" /* trackProductPageview */])({
          name: productData.title,
          id: productVariant.sku,
          price: productVariant.price,
          brand: 'soundboks',
          category: productCategories,
          variant: productVariant.title,
          image: imageUrl
        });
      }, 1000);
      return function () {
        return clearTimeout(timer);
      };
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [regionId, productVariant]);

  var handleAddToCart = function handleAddToCart() {
    if (productVariant.available) {
      dispatchAddCartItem(productVariant.id, 1, true);
    } else {
      console.log('join waitinglist dialog');
    }
  };

  var financialServices = function financialServices(variantPrice) {
    var locale = productData.locale;
    var klarnaAvailable = locale === 'de' || locale === 'no' || locale === 'da';
    var affirmAvailable = locale === 'en-US';
    return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, affirmAvailable && /*#__PURE__*/react_default.a.createElement(index_web_AffirmService, {
      price: variantPrice,
      locale: locale,
      isBlackTheme: true
    }), klarnaAvailable && /*#__PURE__*/react_default.a.createElement(index_web_KlarnaService, {
      price: variantPrice,
      locale: carrier_strap_klarnaData[locale].klarnaLocale,
      klarnaClassName: carrier_strap_klarnaData[locale].klarnaClassName
    }));
  };

  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    backgroundColor: elements_theme["a" /* Color */].Charcoal
  }, /*#__PURE__*/react_default.a.createElement(sub_navigation_SubNavigation, {
    productData: productData,
    productVariant: productVariant,
    anchorStack: anchorStack,
    selectedAnchor: selectedAnchor,
    isHeaderVisibility: isHeaderVisibility,
    offset: offset,
    handleAddToCart: handleAddToCart
  }), /*#__PURE__*/react_default.a.createElement("div", {
    ref: overview
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '24px',
      desktop: '46px'
    }
  }), /*#__PURE__*/react_default.a.createElement(carrier_strap_product_overview, {
    paths: carrier_strap_paths,
    offset: offset,
    anchorStack: anchorStack,
    productData: productData,
    productVariant: productVariant,
    onHeaderVisibility: handleHeaderVisibility,
    handleAddToCart: handleAddToCart,
    financialServices: financialServices,
    allowImageInteractionTracking: allowImageInteractionTracking,
    setAllowImageInteractionTracking: setAllowImageInteractionTracking,
    trackImageInteractionLimit: trackImageInteractionLimit,
    setTrackImageInteractionLimit: setTrackImageInteractionLimit
  })), /*#__PURE__*/react_default.a.createElement(carrier_strap_styled_BackgroundImage, null), /*#__PURE__*/react_default.a.createElement("div", {
    ref: learnMore
  }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    alignContentHorizontal: "center",
    backgroundColor: elements_theme["a" /* Color */].WhiteOff
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }), /*#__PURE__*/react_default.a.createElement(carrier_strap_learn_more, {
    locale: productData.locale
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }))), /*#__PURE__*/react_default.a.createElement("div", {
    ref: reviews
  }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    backgroundColor: elements_theme["a" /* Color */].White
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }), /*#__PURE__*/react_default.a.createElement(carrier_strap_product_review, null), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }))), /*#__PURE__*/react_default.a.createElement("div", {
    ref: relatedProducts
  }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    backgroundColor: elements_theme["a" /* Color */].WhiteOff
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }), /*#__PURE__*/react_default.a.createElement(carrier_strap_related_products, {
    relatedProducts: productData.crossSellHandles
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '60px',
      desktop: '72px'
    }
  }))));
};

/* harmony default export */ var carrier_strap = (carrier_strap_CarrierStrap);
// CONCATENATED MODULE: ./components/pages/products-v2/special-editions/soundboks-rf50/product-overview/index.tsx
var soundboks_rf50_product_overview_jsx = react_default.a.createElement;






var soundboks_rf50_product_overview_ProductOverviewSection = function ProductOverviewSection(_ref) {
  var productData = _ref.productData,
      paths = _ref.paths,
      onHeaderVisibility = _ref.onHeaderVisibility,
      handleBatterySelector = _ref.handleBatterySelector,
      productVariant = _ref.productVariant,
      handleAddToCart = _ref.handleAddToCart,
      financialServices = _ref.financialServices,
      offset = _ref.offset,
      anchorStack = _ref.anchorStack,
      allowImageInteractionTracking = _ref.allowImageInteractionTracking,
      setAllowImageInteractionTracking = _ref.setAllowImageInteractionTracking,
      trackImageInteractionLimit = _ref.trackImageInteractionLimit,
      setTrackImageInteractionLimit = _ref.setTrackImageInteractionLimit;
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentHorizontal: "center",
      padding: {
        right: 24,
        left: 24
      }
    }, /*#__PURE__*/react_default.a.createElement(index_web_ProductOverview, {
      paths: paths,
      offset: offset,
      anchorStack: anchorStack,
      productData: productData,
      handleBatterySelector: handleBatterySelector,
      productVariant: productVariant,
      handleAddToCart: handleAddToCart,
      financialServices: financialServices,
      allowImageInteractionTracking: allowImageInteractionTracking,
      setAllowImageInteractionTracking: setAllowImageInteractionTracking,
      trackImageInteractionLimit: trackImageInteractionLimit,
      setTrackImageInteractionLimit: setTrackImageInteractionLimit,
      labels: {
        // extraBattery: {
        //   label: i18n._('product.option.label.extra-battery'),
        //   options: {
        //     yes: i18n._('product.option.label.yes'),
        //     no: i18n._('product.option.label.no'),
        //   },
        // },
        addToCart: i18n._('product.buy-page.button.addToCart'),
        outOfStock: i18n._('product.buy-page.button.outOfStock'),
        waitlist: i18n._('product.buy-page.button.waitlist'),
        usp: {
          warranty: i18n._('product.usp.warranty'),
          freeReturns: i18n._('product.usp.free-returns'),
          freeShipping: i18n._('product.usp.free-shipping'),
          premiumSupport: i18n._('product.usp.premium-support'),
          compatibility: i18n._('product.usp.compatibility')
        }
      },
      onHeaderVisibility: onHeaderVisibility
    }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    }));
  });
};

/* harmony default export */ var soundboks_rf50_product_overview = (soundboks_rf50_product_overview_ProductOverviewSection);
// CONCATENATED MODULE: ./components/pages/products-v2/special-editions/soundboks-rf50/product-feature/index.tsx
var soundboks_rf50_product_feature_jsx = react_default.a.createElement;

















var soundboks_rf50_product_feature_ProductFeatureSection = function ProductFeatureSection() {
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref) {
    var i18n = _ref.i18n;
    return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentVertical: "center",
      alignContentHorizontal: "center",
      backgroundColor: elements_theme["a" /* Color */].Charcoal
    }, /*#__PURE__*/react_default.a.createElement(index_web_ProductFeature, {
      features: [{
        uri: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_sound_375_default.a.url),
        uriRanges: {
          phone: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_sound_375_default.a.url, {
            width: 327,
            height: 400
          }),
          tabletLandscape: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_sound_375_default.a.url, {
            width: 525,
            height: 600
          }),
          desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_sound_375_default.a.url, {
            width: 525,
            height: 670
          })
        },
        title: i18n._('product.sb3.feature.title.volume.and.sound'),
        description: i18n._('product.sb3.feature.description.volume.and.sound'),
        imgPosition: 'left'
      }, {
        uri: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_app_default.a.url),
        uriRanges: {
          phone: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_app_default.a.url, {
            width: 397,
            height: 470
          }),
          tabletLandscape: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_app_default.a.url, {
            width: 535,
            height: 610
          }),
          desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_app_default.a.url, {
            width: 525,
            height: 670
          })
        },
        title: i18n._('product.sb3.feature.title.app.and.upgradability'),
        description: /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
          id: "product.sb3.feature.description.app.and.upgradability",
          components: [/*#__PURE__*/react_default.a.createElement(soundboks_rf50_product_feature_LinkWrapper, {
            href: "/app"
          })]
        }),
        content: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
          height: {
            "default": '17px',
            desktop: '60px'
          }
        }), /*#__PURE__*/react_default.a.createElement(Composition["b" /* Layout */], {
          omitPadding: true,
          direction: Composition["d" /* LayoutDirection */].Row,
          alignX: Composition["c" /* LayoutAlignment */].Start,
          alignY: Composition["c" /* LayoutAlignment */].Start
        }, /*#__PURE__*/react_default.a.createElement("a", {
          href: "https://play.google.com/store/apps/details?id=com.soundboks.SOUNDBOKS"
        }, /*#__PURE__*/react_default.a.createElement(atoms_Icon["b" /* default */], {
          height: 40,
          id: atoms_Icon["a" /* IconId */].DownloadGooglaPlay
        })), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
          width: "16px"
        }), /*#__PURE__*/react_default.a.createElement("a", {
          href: "https://apps.apple.com/us/app/soundboks/id1440156667"
        }, /*#__PURE__*/react_default.a.createElement(atoms_Icon["b" /* default */], {
          height: 40,
          id: atoms_Icon["a" /* IconId */].DownloadAppStore
        })))),
        imgPosition: 'right'
      }, {
        uri: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_portability_375_default.a.url),
        uriRanges: {
          phone: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_portability_375_default.a.url, {
            width: 337,
            height: 410
          }),
          tabletLandscape: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_portability_375_default.a.url, {
            width: 555,
            height: 660
          }),
          desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_portability_375_default.a.url, {
            width: 545,
            height: 630
          })
        },
        title: i18n._('product.sb3.feature.title.durability.and.portability'),
        description: i18n._('product.sb3.feature.description.durability.and.portability'),
        imgPosition: 'left'
      }, {
        uri: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_teamup_375_default.a.url),
        uriRanges: {
          phone: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_teamup_375_default.a.url, {
            width: 397,
            height: 470
          }),
          tabletLandscape: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_teamup_375_default.a.url, {
            width: 535,
            height: 610
          }),
          desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_teamup_375_default.a.url, {
            width: 525,
            height: 670
          })
        },
        title: i18n._('product.sb3.feature.title.wireless.and.connection'),
        description: i18n._('product.sb3.feature.description.wireless.and.connection'),
        imgPosition: 'right'
      }, {
        uri: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_battery_375_default.a.url),
        uriRanges: {
          phone: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_battery_375_default.a.url, {
            width: 397,
            height: 470
          }),
          tabletLandscape: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_battery_375_default.a.url, {
            width: 535,
            height: 610
          }),
          desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_battery_375_default.a.url, {
            width: 525,
            height: 670
          })
        },
        title: i18n._('product.sb3.feature.title.battery.and.swappability'),
        description: i18n._('product.sb3.feature.description.battery.and.swappability'),
        imgPosition: 'left'
      }]
    }));
  });
};

var soundboks_rf50_product_feature_Anchor = styled_components_browser_esm["default"].a.withConfig({
  displayName: "product-feature__Anchor",
  componentId: "sc-3xqifi-0"
})(["color:#fff;cursor:pointer;text-decoration:underline;"]);

var soundboks_rf50_product_feature_LinkWrapper = function LinkWrapper(_ref2) {
  var href = _ref2.href,
      _ref2$children = _ref2.children,
      children = _ref2$children === void 0 ? undefined : _ref2$children;
  return /*#__PURE__*/react_default.a.createElement(Link["a" /* default */], {
    href: href,
    prefetch: false
  }, /*#__PURE__*/react_default.a.createElement(soundboks_rf50_product_feature_Anchor, null, children));
};

/* harmony default export */ var soundboks_rf50_product_feature = (soundboks_rf50_product_feature_ProductFeatureSection);
// CONCATENATED MODULE: ./components/pages/products-v2/special-editions/soundboks-rf50/learn-more/content.tsx
var soundboks_rf50_learn_more_content_jsx = react_default.a.createElement;






var soundboks_rf50_learn_more_content_packageItems = [{
  packageItemId: 'soundboks-gen-3-rf',
  title: 'Soundboks (Gen 3)',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconSoundboks3, null)
}, {
  packageItemId: 'batteryboks',
  title: 'Batteryboks',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconBattery, null)
}, {
  packageItemId: 'extra-batteryboks',
  title: 'Extra Batteryboks',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconBattery, null)
}, {
  packageItemId: 'charger',
  title: 'Charger',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconCharger, null)
}, {
  packageItemId: 'soundboks-gen-3-manual',
  title: 'Manual',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconManual, null),
  downloadUrl: soundboks3["default"]
}];
// CONCATENATED MODULE: ./components/pages/products-v2/special-editions/soundboks-rf50/learn-more/tech-spec/styled.ts

var soundboks_rf50_learn_more_tech_spec_styled_DescList = styled_components_browser_esm["default"].dl.withConfig({
  displayName: "styled__DescList",
  componentId: "sc-1gujq29-0"
})(["margin:20px 0 0 0;"]);
var soundboks_rf50_learn_more_tech_spec_styled_DescTitle = styled_components_browser_esm["default"].dt.withConfig({
  displayName: "styled__DescTitle",
  componentId: "sc-1gujq29-1"
})(["margin:0;"]);
var soundboks_rf50_learn_more_tech_spec_styled_DescDetails = styled_components_browser_esm["default"].dd.withConfig({
  displayName: "styled__DescDetails",
  componentId: "sc-1gujq29-2"
})(["margin:0;"]);
// CONCATENATED MODULE: ./components/pages/products-v2/special-editions/soundboks-rf50/learn-more/tech-spec/index.web.tsx
var soundboks_rf50_learn_more_tech_spec_index_web_jsx = react_default.a.createElement;





 // eslint-disable-next-line prefer-arrow-callback

var soundboks_rf50_learn_more_tech_spec_index_web_TechSpec = /*#__PURE__*/react_default.a.memo(function TechSpec() {
  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, null, /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "SOUND"
  })), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "AMPLIFIER"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Merus Audio eximo\xAE amp switching"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "3 \xD7 72W RMS class D amplifiers"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Advanced Bass DSP"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "ACOUSTICS"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Effective frequency range: 40Hz - 20kHz"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Custom sound profile with bass enhancer"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "DRIVER UNITS"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "2 \xD7 10\u201D 96dB woofers"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "1 \xD7 1\u201D 104dB compression driver tweeter"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "CONNECTIVITY"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Bluetooth 5.0"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "TeamUP connection"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Wirelessly connect up to 5 (total) nearby New SOUNDBOKS(2019) speakers (SKAA network)"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Pro Panel"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA 2 \xD7 Combo microphone/instrument (XLR, 1/4\u201D) input"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA 1 \xD7 3.5mm Stereo Input"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA 1 \xD7 3.5mm Stereo Output"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Bond Button for advanced JOIN settings"
  })))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "BUILD"
  })), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "WEIGHT"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "34 pounds (15.4 kg)"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "MATERIALS"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Poplar cabinet"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Powder-coated aluminum frame"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Powder-coated steel grill and handles"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Silicone ball corners"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "SMP temperature-flex adhesive"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "DIMENSIONS"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "66 \xD7 43 \xD7 32 cm / 25.6 \xD7 17 \xD7 13 inches (H \xD7 W \xD7 D)"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "FEATURES"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Swappable grill and batteries"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "IP65 rated electronics coating"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Pulse Reflex Port"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "UI Panel"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Volume control"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Host/Join mode for wireless TeamUP"
  })))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "BATTERY"
  })), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "LIFE"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "40 hours at mid-volume"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "5 hours at full volume"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "3.5 hours full recharge"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "DESIGN"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "5-step LED battery-life indicator"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Heavy-duty DC-connector"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "CELL TYPE"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "12.8V, 7.8Ah Lithium Iron Phosphate (LiFePO4)"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "-10C to 40C temperature range"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "99.84Wh or 7.8Ah capacity"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "BATTERY MANAGEMENT SYSTEM (BMS)"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Over and under-discharge protection"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Short circuit protection"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Overheat protection"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Cell voltage management"
  })))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app"
  })), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.soundSettings"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.soundSettings.1"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.soundSettings.2"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.proPanel"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.proPanel.1"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.proPanel.2"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.1"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.2"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.3"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.4"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings.1"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings.2"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings.3"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.firmwareUpdate"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.firmwareUpdate.1"
  })))));
});
// CONCATENATED MODULE: ./components/pages/products-v2/special-editions/soundboks-rf50/learn-more/styled.ts



var soundboks_rf50_learn_more_styled_LayoutContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__LayoutContainer",
  componentId: "sc-12mgch-0"
})(["padding:0 190px;background-color:", ";@media ", "{padding:0 24px;}"], elements_theme["a" /* Color */].WhiteOff, styles_theme["a" /* default */].breakpoints.maxMobile);
var soundboks_rf50_learn_more_styled_Link = styled_components_browser_esm["default"].a.withConfig({
  displayName: "styled__Link",
  componentId: "sc-12mgch-1"
})(["color:", ";cursor:pointer;text-decoration:underline;"], elements_theme["a" /* Color */].Orange);
// CONCATENATED MODULE: ./components/pages/products-v2/special-editions/soundboks-rf50/learn-more/faqs/index.web.tsx
var soundboks_rf50_learn_more_faqs_index_web_jsx = react_default.a.createElement;





// eslint-disable-next-line prefer-arrow-callback
var soundboks_rf50_learn_more_faqs_index_web_FAQs = /*#__PURE__*/react_default.a.memo(function FAQs() {
  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    padding: {
      right: 10
    }
  }, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-1"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-1"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-2"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-2"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-3"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-3"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-4"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-4"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-5"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-5"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-6"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-6"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-7"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-7"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-8"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-8"
  }));
});
// CONCATENATED MODULE: ./components/pages/products-v2/special-editions/soundboks-rf50/learn-more/index.tsx
var soundboks_rf50_learn_more_jsx = react_default.a.createElement;















var soundboks_rf50_learn_more_LearnMoreSection = function LearnMoreSection(_ref) {
  var extraBattery = _ref.extraBattery,
      locale = _ref.locale;
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_LayoutContainer, null, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(elements_typography["e" /* Heading02 */], {
      ariaLevel: elements_typography["h" /* TextLevel */].H2,
      style: {
        textTransform: 'uppercase',
        textAlign: 'center'
      }
    }, i18n._('product.learn-more.heading')), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "35px"
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.whats-in-the-box",
      content: /*#__PURE__*/react_default.a.createElement(elevation_pack_learn_more_whats_in_the_box_index_web_WhatsInTheBox, {
        extraBattery: extraBattery,
        packageItems: soundboks_rf50_learn_more_content_packageItems
      }),
      topItem: true
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.soundboks-gen-3-rf50.seo.blurb",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "product.learn-more.soundboks-gen-3-rf50.seo.blurb.info"
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.tech-specs",
      content: /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_tech_spec_index_web_TechSpec, null)
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.shipping",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "product.learn-more.shipping.info",
        components: [/*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_styled_Link, {
          href: helpCenter_getHelpCenterUrl(locale, '/sections/360003609413-SHIPPING')
        }), /*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement("br", null)]
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.warranty",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "product.learn-more.warranty.info",
        components: [/*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_styled_Link, {
          href: helpCenter_getHelpCenterUrl(locale, '/articles/211920329-RETURN-AND-REFUND-POLICY-AND-PROCESS')
        })]
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.payment-options",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "product.learn-more.payment-options.info"
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.faqs",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more_faqs_index_web_FAQs, null))
    })));
  });
};

var soundboks_rf50_learn_more_LayoutContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "learn-more__LayoutContainer",
  componentId: "np42un-0"
})(["max-width:1062px;width:100%;@media ", "{padding:0 24px;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
/* harmony default export */ var soundboks_rf50_learn_more = (soundboks_rf50_learn_more_LearnMoreSection);
// CONCATENATED MODULE: ./components/pages/products-v2/special-editions/soundboks-rf50/product-review/styled.tsx


var soundboks_rf50_product_review_styled_StyledHorizontalLine = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__StyledHorizontalLine",
  componentId: "sc-8krvx2-0"
})(["display:none;@media ", "{display:block;padding:0px 24px;}"], styles_theme["a" /* default */].breakpoints.maxMobile);
var soundboks_rf50_product_review_styled_LayoutContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__LayoutContainer",
  componentId: "sc-8krvx2-1"
})(["position:relative;width:100%;max-width:1024px;text-align:center;align-self:center;@media ", "{max-width:720px;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
// CONCATENATED MODULE: ./components/pages/products-v2/special-editions/soundboks-rf50/product-review/index.tsx
var soundboks_rf50_product_review_jsx = react_default.a.createElement;











var soundboks_rf50_product_review_ProductReviewSection = function ProductReviewSection() {
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref) {
    var i18n = _ref.i18n;
    return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(soundboks_rf50_product_review_styled_LayoutContainer, null, /*#__PURE__*/react_default.a.createElement(elements_typography["e" /* Heading02 */], {
      ariaLevel: elements_typography["h" /* TextLevel */].H2,
      color: elements_theme["a" /* Color */].Orange,
      style: {
        textTransform: 'uppercase'
      }
    }, i18n._('product.reviews.heading'))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    }), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_product_review_styled_StyledHorizontalLine, null, /*#__PURE__*/react_default.a.createElement(HorizontalLine, {
      color: elements_theme["a" /* Color */].WhiteOff
    }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    })), /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(index_web_VideoFeature, {
      videos: [{
        YouTubeId: 'FuD9ujTbZCE',
        children: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "The world's LOUDEST portable speaker for DJs?")
      }, {
        YouTubeId: 'JrGlmymabNg',
        children: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "Soundboks Update - New Sound Modes New Features")
      }, {
        YouTubeId: 'j9WFgrGU5ro',
        children: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "The world's Loudest Wireless Speaker")
      }],
      height: "184px"
    })), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    }), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_product_review_styled_StyledHorizontalLine, null, /*#__PURE__*/react_default.a.createElement(HorizontalLine, {
      color: elements_theme["a" /* Color */].WhiteOff
    }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    })), /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(Trustbox, null)));
  });
};

/* harmony default export */ var soundboks_rf50_product_review = (soundboks_rf50_product_review_ProductReviewSection);
// CONCATENATED MODULE: ./components/pages/products-v2/special-editions/soundboks-rf50/related-products/index.tsx
var soundboks_rf50_related_products_jsx = react_default.a.createElement;






var soundboks_rf50_related_products_RelatedProductsSection = function RelatedProductsSection(_ref) {
  var relatedProducts = _ref.relatedProducts;
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      grow: 1
    }, /*#__PURE__*/react_default.a.createElement(RelatedProducts, {
      relatedProducts: relatedProducts,
      headline: i18n._('product.related-products.heading')
    })));
  });
};

/* harmony default export */ var soundboks_rf50_related_products = (soundboks_rf50_related_products_RelatedProductsSection);
// CONCATENATED MODULE: ./components/pages/products-v2/special-editions/soundboks-rf50/index.tsx
var soundboks_rf50_jsx = react_default.a.createElement;


















var soundboks_rf50_paths = [{
  label: 'Home',
  url: '/'
}, {
  label: 'Special Editions',
  url: '/products/?filter=special-editions'
}, {
  label: 'SOUNDBOKS × RF50 Limited Edition'
}];
var soundboks_rf50_options = {
  grillColor: 'Grill Color',
  batteries: 'Batteries'
};
var soundboks_rf50_klarnaData = {
  de: {
    klarnaLocale: 'de-DE',
    klarnaClassName: 'klarna-pricetag-de'
  },
  no: {
    klarnaLocale: 'no-NO',
    klarnaClassName: 'klarna-pricetag-no'
  },
  da: {
    klarnaLocale: 'da-DK',
    klarnaClassName: 'klarna-pricetag-dk'
  }
};
var soundboks_rf50_batteriOptions = {
  onePack: '1x BATTERYBOKS',
  twoPack: '2x BATTERYBOKS'
};

var soundboks_rf50_SoundboksRF50 = function SoundboksRF50(_ref) {
  var productData = _ref.productData,
      dispatchAddCartItem = _ref.dispatchAddCartItem;

  var _useSelector = Object(es["d" /* useSelector */])(function (state) {
    return state;
  }),
      settings = _useSelector.settings;

  var regionId = settings.regionId;
  var overview = Object(react["useRef"])(null);
  var feature = Object(react["useRef"])(null);
  var learnMore = Object(react["useRef"])(null);
  var reviews = Object(react["useRef"])(null);
  var relatedProducts = Object(react["useRef"])(null);

  var _useState = Object(react["useState"])(),
      anchorStack = _useState[0],
      setAnchorStack = _useState[1];

  var _useState2 = Object(react["useState"])(),
      selectedAnchor = _useState2[0],
      setSelectedAnchor = _useState2[1];

  var _useState3 = Object(react["useState"])(false),
      isHeaderVisibility = _useState3[0],
      setIsHeaderVisibility = _useState3[1];

  var _useState4 = Object(react["useState"])(),
      productVariant = _useState4[0],
      setProductVariant = _useState4[1];

  var productCategories = Object(mergeUACategories["a" /* default */])(abstractProducts_default.a.byId[productData.handle].categories);

  var _useState5 = Object(react["useState"])(true),
      allowImageInteractionTracking = _useState5[0],
      setAllowImageInteractionTracking = _useState5[1];

  var _useState6 = Object(react["useState"])(0),
      trackImageInteractionLimit = _useState6[0],
      setTrackImageInteractionLimit = _useState6[1];

  var router = Object(next_router["useRouter"])();
  var offset = 124;
  Object(react["useEffect"])(function () {
    var initialStack = [{
      label: 'products.subnavigation.achor.overview',
      ref: overview
    }, {
      label: 'products.subnavigation.achor.feature',
      ref: feature
    }, {
      label: 'products.subnavigation.achor.learn-more',
      ref: learnMore
    }, {
      label: 'products.subnavigation.achor.reviews',
      ref: reviews
    }, {
      label: 'products.subnavigation.achor.related-products',
      ref: relatedProducts
    }];
    setAnchorStack(initialStack);

    var handleScroll = function handleScroll() {
      var stackIndex = initialStack.findIndex(function (stack) {
        return stack.ref.current.getBoundingClientRect().y - offset > 0;
      });
      var stack = stackIndex === -1 ? initialStack[initialStack.length - 1] : initialStack[stackIndex - 1];
      setSelectedAnchor(stack.ref.current);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return function () {
      return window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  var handleHeaderVisibility = function handleHeaderVisibility(isVisibility) {
    setIsHeaderVisibility(isVisibility);
  };

  Object(react["useEffect"])(function () {
    var defaultOption = productData.variants.find(function (variant) {
      return variant.sku;
    });
    var optionsFromUrlQueries = productData.variants.find(function (variant) {
      return variant.options[soundboks_rf50_options.grillColor] === router.query[soundboks_rf50_options.grillColor];
    });
    var defaultVariant = optionsFromUrlQueries || defaultOption;
    setProductVariant(defaultVariant);
  }, [productData, router.query]);

  var handleBatterySelector = function handleBatterySelector(selected) {
    var variants = productData.variants.filter(function (variant) {
      return variant.options[soundboks_rf50_options.batteries] === (selected ? soundboks_rf50_batteriOptions.twoPack : soundboks_rf50_batteriOptions.onePack);
    });
    var nextVariant = variants.find(function (variant) {
      return variant.options[soundboks_rf50_options.batteries] === (selected ? soundboks_rf50_batteriOptions.twoPack : soundboks_rf50_batteriOptions.onePack);
    });
    setProductVariant(nextVariant);
  };

  Object(react["useEffect"])(function () {
    if (productVariant) {
      var productImages = Object(getProductImages["a" /* default */])(productData.handle, productVariant.sku);
      var imageUrl = productImages.length ? productImages[0].url : '';
      var timer = setTimeout(function () {
        return Object(utils["i" /* trackProductPageview */])({
          name: productData.title,
          id: productVariant.sku,
          price: productVariant.price,
          brand: 'soundboks',
          category: productCategories,
          variant: productVariant.title,
          image: imageUrl
        });
      }, 1000);
      return function () {
        return clearTimeout(timer);
      };
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [regionId, productVariant]);

  var handleAddToCart = function handleAddToCart() {
    console.log('handleAddToCart', productVariant);

    if (productVariant.available) {
      dispatchAddCartItem(productVariant.id, 1, true);
    } else {
      console.log('join waitinglist dialog');
    }
  };

  var financialServices = function financialServices(variantPrice) {
    var locale = productData.locale;
    var klarnaAvailable = locale === 'de' || locale === 'no' || locale === 'da';
    var affirmAvailable = locale === 'en-US';
    return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, affirmAvailable && /*#__PURE__*/react_default.a.createElement(index_web_AffirmService, {
      price: variantPrice,
      locale: locale,
      isBlackTheme: true
    }), klarnaAvailable && /*#__PURE__*/react_default.a.createElement(index_web_KlarnaService, {
      price: variantPrice,
      locale: soundboks_rf50_klarnaData[locale].klarnaLocale,
      klarnaClassName: soundboks_rf50_klarnaData[locale].klarnaClassName
    }));
  };

  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    backgroundColor: elements_theme["a" /* Color */].Charcoal
  }, /*#__PURE__*/react_default.a.createElement(sub_navigation_SubNavigation, {
    productData: productData,
    productVariant: productVariant,
    anchorStack: anchorStack,
    selectedAnchor: selectedAnchor,
    isHeaderVisibility: isHeaderVisibility,
    offset: offset,
    handleAddToCart: handleAddToCart
  }), /*#__PURE__*/react_default.a.createElement("div", {
    ref: overview
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '24px',
      desktop: '46px'
    }
  }), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_product_overview, {
    paths: soundboks_rf50_paths,
    offset: offset,
    anchorStack: anchorStack,
    productData: productData,
    productVariant: productVariant,
    onHeaderVisibility: handleHeaderVisibility,
    handleBatterySelector: handleBatterySelector,
    handleAddToCart: handleAddToCart,
    financialServices: financialServices,
    allowImageInteractionTracking: allowImageInteractionTracking,
    setAllowImageInteractionTracking: setAllowImageInteractionTracking,
    trackImageInteractionLimit: trackImageInteractionLimit,
    setTrackImageInteractionLimit: setTrackImageInteractionLimit
  })), /*#__PURE__*/react_default.a.createElement("div", {
    ref: feature
  }, /*#__PURE__*/react_default.a.createElement(soundboks_rf50_product_feature, null), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '60px',
      desktop: '120px'
    }
  })), /*#__PURE__*/react_default.a.createElement("div", {
    ref: learnMore
  }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    alignContentHorizontal: "center",
    backgroundColor: elements_theme["a" /* Color */].WhiteOff
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_learn_more, {
    locale: productData.locale
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }))), /*#__PURE__*/react_default.a.createElement("div", {
    ref: reviews
  }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    backgroundColor: elements_theme["a" /* Color */].White
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_product_review, null), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }))), /*#__PURE__*/react_default.a.createElement("div", {
    ref: relatedProducts
  }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    backgroundColor: elements_theme["a" /* Color */].WhiteOff
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }), /*#__PURE__*/react_default.a.createElement(soundboks_rf50_related_products, {
    relatedProducts: productData.crossSellHandles
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '60px',
      desktop: '72px'
    }
  }))));
};

/* harmony default export */ var soundboks_rf50 = (soundboks_rf50_SoundboksRF50);
// CONCATENATED MODULE: ./components/pages/products-v2/special-editions/soundboks-jagermeister/product-overview/index.tsx
var soundboks_jagermeister_product_overview_jsx = react_default.a.createElement;






var soundboks_jagermeister_product_overview_ProductOverviewSection = function ProductOverviewSection(_ref) {
  var productData = _ref.productData,
      paths = _ref.paths,
      onHeaderVisibility = _ref.onHeaderVisibility,
      handleMerchSelector = _ref.handleMerchSelector,
      handleBatterySelector = _ref.handleBatterySelector,
      productVariant = _ref.productVariant,
      availableMerch = _ref.availableMerch,
      selectedMerch = _ref.selectedMerch,
      extraBattery = _ref.extraBattery,
      disableExtraBattery = _ref.disableExtraBattery,
      handleAddToCart = _ref.handleAddToCart,
      financialServices = _ref.financialServices,
      offset = _ref.offset,
      anchorStack = _ref.anchorStack,
      allowImageInteractionTracking = _ref.allowImageInteractionTracking,
      setAllowImageInteractionTracking = _ref.setAllowImageInteractionTracking,
      trackImageInteractionLimit = _ref.trackImageInteractionLimit,
      setTrackImageInteractionLimit = _ref.setTrackImageInteractionLimit;
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentHorizontal: "center",
      padding: {
        right: 24,
        left: 24
      }
    }, /*#__PURE__*/react_default.a.createElement(index_web_ProductOverview, {
      paths: paths,
      offset: offset,
      anchorStack: anchorStack,
      productData: productData,
      availableMerch: availableMerch,
      selectedMerch: selectedMerch,
      extraBattery: extraBattery,
      handleMerchSelector: handleMerchSelector,
      disableExtraBattery: disableExtraBattery,
      handleBatterySelector: handleBatterySelector,
      productVariant: productVariant,
      handleAddToCart: handleAddToCart,
      financialServices: financialServices,
      allowImageInteractionTracking: allowImageInteractionTracking,
      setAllowImageInteractionTracking: setAllowImageInteractionTracking,
      trackImageInteractionLimit: trackImageInteractionLimit,
      setTrackImageInteractionLimit: setTrackImageInteractionLimit,
      labels: {
        // merch: {
        //   label: i18n._('product.option.label.merch'),
        //   options: {
        //     'Sleeping Bag': i18n._('product.option.label.sleepingBag'),
        //     Hammock: i18n._('product.option.label.hammock'),
        //     Tent: i18n._('product.option.label.tent'),
        //   },
        // },
        addToCart: i18n._('product.buy-page.button.addToCart'),
        outOfStock: i18n._('product.buy-page.button.outOfStock'),
        waitlist: i18n._('product.buy-page.button.waitlist'),
        usp: {
          warranty: i18n._('product.usp.warranty'),
          freeReturns: i18n._('product.usp.free-returns'),
          freeShipping: i18n._('product.usp.free-shipping'),
          premiumSupport: i18n._('product.usp.premium-support'),
          compatibility: i18n._('product.usp.compatibility')
        }
      },
      onHeaderVisibility: onHeaderVisibility
    }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    }));
  });
};

/* harmony default export */ var soundboks_jagermeister_product_overview = (soundboks_jagermeister_product_overview_ProductOverviewSection);
// CONCATENATED MODULE: ./components/pages/products-v2/special-editions/soundboks-jagermeister/product-feature/index.tsx
var soundboks_jagermeister_product_feature_jsx = react_default.a.createElement;

















var soundboks_jagermeister_product_feature_ProductFeatureSection = function ProductFeatureSection() {
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref) {
    var i18n = _ref.i18n;
    return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentVertical: "center",
      alignContentHorizontal: "center",
      backgroundColor: elements_theme["a" /* Color */].Charcoal
    }, /*#__PURE__*/react_default.a.createElement(index_web_ProductFeature, {
      features: [{
        uri: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_sound_375_default.a.url),
        uriRanges: {
          phone: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_sound_375_default.a.url, {
            width: 327,
            height: 400
          }),
          tabletLandscape: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_sound_375_default.a.url, {
            width: 525,
            height: 600
          }),
          desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_sound_375_default.a.url, {
            width: 525,
            height: 670
          })
        },
        title: i18n._('product.sb3.feature.title.volume.and.sound'),
        description: i18n._('product.sb3.feature.description.volume.and.sound'),
        imgPosition: 'left'
      }, {
        uri: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_app_default.a.url),
        uriRanges: {
          phone: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_app_default.a.url, {
            width: 397,
            height: 470
          }),
          tabletLandscape: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_app_default.a.url, {
            width: 535,
            height: 610
          }),
          desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_app_default.a.url, {
            width: 525,
            height: 670
          })
        },
        title: i18n._('product.sb3.feature.title.app.and.upgradability'),
        description: /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
          id: "product.sb3.feature.description.app.and.upgradability",
          components: [/*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_product_feature_LinkWrapper, {
            href: "/app"
          })]
        }),
        content: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
          height: {
            "default": '17px',
            desktop: '60px'
          }
        }), /*#__PURE__*/react_default.a.createElement(Composition["b" /* Layout */], {
          omitPadding: true,
          direction: Composition["d" /* LayoutDirection */].Row,
          alignX: Composition["c" /* LayoutAlignment */].Start,
          alignY: Composition["c" /* LayoutAlignment */].Start
        }, /*#__PURE__*/react_default.a.createElement("a", {
          href: "https://play.google.com/store/apps/details?id=com.soundboks.SOUNDBOKS"
        }, /*#__PURE__*/react_default.a.createElement(atoms_Icon["b" /* default */], {
          height: 40,
          id: atoms_Icon["a" /* IconId */].DownloadGooglaPlay
        })), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
          width: "16px"
        }), /*#__PURE__*/react_default.a.createElement("a", {
          href: "https://apps.apple.com/us/app/soundboks/id1440156667"
        }, /*#__PURE__*/react_default.a.createElement(atoms_Icon["b" /* default */], {
          height: 40,
          id: atoms_Icon["a" /* IconId */].DownloadAppStore
        })))),
        imgPosition: 'right'
      }, {
        uri: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_portability_375_default.a.url),
        uriRanges: {
          phone: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_portability_375_default.a.url, {
            width: 337,
            height: 410
          }),
          tabletLandscape: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_portability_375_default.a.url, {
            width: 555,
            height: 660
          }),
          desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_portability_375_default.a.url, {
            width: 545,
            height: 630
          })
        },
        title: i18n._('product.sb3.feature.title.durability.and.portability'),
        description: i18n._('product.sb3.feature.description.durability.and.portability'),
        imgPosition: 'left'
      }, {
        uri: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_teamup_375_default.a.url),
        uriRanges: {
          phone: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_teamup_375_default.a.url, {
            width: 397,
            height: 470
          }),
          tabletLandscape: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_teamup_375_default.a.url, {
            width: 535,
            height: 610
          }),
          desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_teamup_375_default.a.url, {
            width: 525,
            height: 670
          })
        },
        title: i18n._('product.sb3.feature.title.wireless.and.connection'),
        description: i18n._('product.sb3.feature.description.wireless.and.connection'),
        imgPosition: 'right'
      }, {
        uri: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_battery_375_default.a.url),
        uriRanges: {
          phone: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_battery_375_default.a.url, {
            width: 397,
            height: 470
          }),
          tabletLandscape: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_battery_375_default.a.url, {
            width: 535,
            height: 610
          }),
          desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_battery_375_default.a.url, {
            width: 525,
            height: 670
          })
        },
        title: i18n._('product.sb3.feature.title.battery.and.swappability'),
        description: i18n._('product.sb3.feature.description.battery.and.swappability'),
        imgPosition: 'left'
      }]
    }));
  });
};

var soundboks_jagermeister_product_feature_Anchor = styled_components_browser_esm["default"].a.withConfig({
  displayName: "product-feature__Anchor",
  componentId: "u4y6jc-0"
})(["color:#fff;cursor:pointer;text-decoration:underline;"]);

var soundboks_jagermeister_product_feature_LinkWrapper = function LinkWrapper(_ref2) {
  var href = _ref2.href,
      _ref2$children = _ref2.children,
      children = _ref2$children === void 0 ? undefined : _ref2$children;
  return /*#__PURE__*/react_default.a.createElement(Link["a" /* default */], {
    href: href,
    prefetch: false
  }, /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_product_feature_Anchor, null, children));
};

/* harmony default export */ var soundboks_jagermeister_product_feature = (soundboks_jagermeister_product_feature_ProductFeatureSection);
// CONCATENATED MODULE: ./components/pages/products-v2/special-editions/soundboks-jagermeister/learn-more/content.tsx
var soundboks_jagermeister_learn_more_content_jsx = react_default.a.createElement;






var soundboks_jagermeister_learn_more_content_packageItems = [{
  packageItemId: 'soundboks-gen-3-rf',
  title: 'Soundboks (Gen 3)',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconSoundboks3, null)
}, {
  packageItemId: 'batteryboks',
  title: 'Batteryboks',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconBattery, null)
}, {
  packageItemId: 'extra-batteryboks',
  title: 'Extra Batteryboks',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconBattery, null)
}, {
  packageItemId: 'charger',
  title: 'Charger',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconCharger, null)
}, {
  packageItemId: 'soundboks-gen-3-manual',
  title: 'Manual',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconManual, null),
  downloadUrl: soundboks3["default"]
}];
// CONCATENATED MODULE: ./components/pages/products-v2/special-editions/soundboks-jagermeister/learn-more/tech-spec/styled.ts

var soundboks_jagermeister_learn_more_tech_spec_styled_DescList = styled_components_browser_esm["default"].dl.withConfig({
  displayName: "styled__DescList",
  componentId: "ghnsxn-0"
})(["margin:20px 0 0 0;"]);
var soundboks_jagermeister_learn_more_tech_spec_styled_DescTitle = styled_components_browser_esm["default"].dt.withConfig({
  displayName: "styled__DescTitle",
  componentId: "ghnsxn-1"
})(["margin:0;"]);
var soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails = styled_components_browser_esm["default"].dd.withConfig({
  displayName: "styled__DescDetails",
  componentId: "ghnsxn-2"
})(["margin:0;"]);
// CONCATENATED MODULE: ./components/pages/products-v2/special-editions/soundboks-jagermeister/learn-more/tech-spec/index.web.tsx
var soundboks_jagermeister_learn_more_tech_spec_index_web_jsx = react_default.a.createElement;





 // eslint-disable-next-line prefer-arrow-callback

var soundboks_jagermeister_learn_more_tech_spec_index_web_TechSpec = /*#__PURE__*/react_default.a.memo(function TechSpec() {
  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, null, /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "SOUND"
  })), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "AMPLIFIER"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Merus Audio eximo\xAE amp switching"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "3 \xD7 72W RMS class D amplifiers"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Advanced Bass DSP"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "ACOUSTICS"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Effective frequency range: 40Hz - 20kHz"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Custom sound profile with bass enhancer"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "DRIVER UNITS"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "2 \xD7 10\u201D 96dB woofers"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "1 \xD7 1\u201D 104dB compression driver tweeter"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "CONNECTIVITY"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Bluetooth 5.0"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "TeamUP connection"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Wirelessly connect up to 5 (total) nearby New SOUNDBOKS(2019) speakers (SKAA network)"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Pro Panel"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA 2 \xD7 Combo microphone/instrument (XLR, 1/4\u201D) input"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA 1 \xD7 3.5mm Stereo Input"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA 1 \xD7 3.5mm Stereo Output"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Bond Button for advanced JOIN settings"
  })))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "BUILD"
  })), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "WEIGHT"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "34 pounds (15.4 kg)"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "MATERIALS"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Poplar cabinet"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Powder-coated aluminum frame"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Powder-coated steel grill and handles"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Silicone ball corners"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "SMP temperature-flex adhesive"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "DIMENSIONS"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "66 \xD7 43 \xD7 32 cm / 25.6 \xD7 17 \xD7 13 inches (H \xD7 W \xD7 D)"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "FEATURES"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Swappable grill and batteries"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "IP65 rated electronics coating"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Pulse Reflex Port"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "UI Panel"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Volume control"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Host/Join mode for wireless TeamUP"
  })))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "BATTERY"
  })), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "LIFE"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "40 hours at mid-volume"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "5 hours at full volume"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "3.5 hours full recharge"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "DESIGN"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "5-step LED battery-life indicator"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Heavy-duty DC-connector"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "CELL TYPE"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "12.8V, 7.8Ah Lithium Iron Phosphate (LiFePO4)"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "-10C to 40C temperature range"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "99.84Wh or 7.8Ah capacity"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "BATTERY MANAGEMENT SYSTEM (BMS)"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Over and under-discharge protection"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Short circuit protection"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Overheat protection"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Cell voltage management"
  })))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app"
  })), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.soundSettings"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.soundSettings.1"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.soundSettings.2"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.proPanel"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.proPanel.1"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.proPanel.2"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.1"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.2"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.3"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.4"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings.1"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings.2"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings.3"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.firmwareUpdate"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.firmwareUpdate.1"
  })))));
});
// CONCATENATED MODULE: ./components/pages/products-v2/special-editions/soundboks-jagermeister/learn-more/styled.ts



var soundboks_jagermeister_learn_more_styled_LayoutContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__LayoutContainer",
  componentId: "sc-15pkp99-0"
})(["padding:0 190px;background-color:", ";@media ", "{padding:0 24px;}"], elements_theme["a" /* Color */].WhiteOff, styles_theme["a" /* default */].breakpoints.maxMobile);
var soundboks_jagermeister_learn_more_styled_Link = styled_components_browser_esm["default"].a.withConfig({
  displayName: "styled__Link",
  componentId: "sc-15pkp99-1"
})(["color:", ";cursor:pointer;text-decoration:underline;"], elements_theme["a" /* Color */].Orange);
// CONCATENATED MODULE: ./components/pages/products-v2/special-editions/soundboks-jagermeister/learn-more/faqs/index.web.tsx
var soundboks_jagermeister_learn_more_faqs_index_web_jsx = react_default.a.createElement;





// eslint-disable-next-line prefer-arrow-callback
var soundboks_jagermeister_learn_more_faqs_index_web_FAQs = /*#__PURE__*/react_default.a.memo(function FAQs() {
  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    padding: {
      right: 10
    }
  }, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-1"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-1"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-2"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-2"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-3"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-3"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-4"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-4"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-5"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-5"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-6"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-6"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-7"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-7"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-8"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-8"
  }));
});
// CONCATENATED MODULE: ./components/pages/products-v2/special-editions/soundboks-jagermeister/learn-more/index.tsx
var soundboks_jagermeister_learn_more_jsx = react_default.a.createElement;















var soundboks_jagermeister_learn_more_LearnMoreSection = function LearnMoreSection(_ref) {
  var extraBattery = _ref.extraBattery,
      locale = _ref.locale;
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_LayoutContainer, null, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(elements_typography["e" /* Heading02 */], {
      ariaLevel: elements_typography["h" /* TextLevel */].H2,
      style: {
        textTransform: 'uppercase',
        textAlign: 'center'
      }
    }, i18n._('product.learn-more.heading')), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "35px"
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.whats-in-the-box",
      content: /*#__PURE__*/react_default.a.createElement(elevation_pack_learn_more_whats_in_the_box_index_web_WhatsInTheBox, {
        extraBattery: extraBattery,
        packageItems: soundboks_jagermeister_learn_more_content_packageItems
      }),
      topItem: true
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.soundboks-gen-3-jager.seo.blurb",
      content: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "product.learn-more.soundboks-gen-3-jager.seo.blurb.info"
      })))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.tech-specs",
      content: /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_tech_spec_index_web_TechSpec, null)
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.shipping",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "product.learn-more.shipping.info",
        components: [/*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_styled_Link, {
          href: helpCenter_getHelpCenterUrl(locale, '/sections/360003609413-SHIPPING')
        }), /*#__PURE__*/react_default.a.createElement("br", null), /*#__PURE__*/react_default.a.createElement("br", null)]
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.warranty",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "product.learn-more.warranty.info",
        components: [/*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_styled_Link, {
          href: helpCenter_getHelpCenterUrl(locale, '/articles/211920329-RETURN-AND-REFUND-POLICY-AND-PROCESS')
        })]
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.payment-options",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "product.learn-more.payment-options.info"
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.faqs",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more_faqs_index_web_FAQs, null))
    })));
  });
};

var soundboks_jagermeister_learn_more_LayoutContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "learn-more__LayoutContainer",
  componentId: "sc-1blkji4-0"
})(["max-width:1062px;width:100%;@media ", "{padding:0 24px;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
/* harmony default export */ var soundboks_jagermeister_learn_more = (soundboks_jagermeister_learn_more_LearnMoreSection);
// CONCATENATED MODULE: ./components/pages/products-v2/special-editions/soundboks-jagermeister/product-review/styled.tsx


var soundboks_jagermeister_product_review_styled_StyledHorizontalLine = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__StyledHorizontalLine",
  componentId: "sc-1my9211-0"
})(["display:none;@media ", "{display:block;padding:0px 24px;}"], styles_theme["a" /* default */].breakpoints.maxMobile);
var soundboks_jagermeister_product_review_styled_LayoutContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__LayoutContainer",
  componentId: "sc-1my9211-1"
})(["position:relative;width:100%;max-width:1024px;text-align:center;align-self:center;@media ", "{max-width:720px;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
// CONCATENATED MODULE: ./components/pages/products-v2/special-editions/soundboks-jagermeister/product-review/index.tsx
var soundboks_jagermeister_product_review_jsx = react_default.a.createElement;











var soundboks_jagermeister_product_review_ProductReviewSection = function ProductReviewSection() {
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref) {
    var i18n = _ref.i18n;
    return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_product_review_styled_LayoutContainer, null, /*#__PURE__*/react_default.a.createElement(elements_typography["e" /* Heading02 */], {
      ariaLevel: elements_typography["h" /* TextLevel */].H2,
      color: elements_theme["a" /* Color */].Orange,
      style: {
        textTransform: 'uppercase'
      }
    }, i18n._('product.reviews.heading'))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    }), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_product_review_styled_StyledHorizontalLine, null, /*#__PURE__*/react_default.a.createElement(HorizontalLine, {
      color: elements_theme["a" /* Color */].WhiteOff
    }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    })), /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(index_web_VideoFeature, {
      videos: [{
        YouTubeId: 'FuD9ujTbZCE',
        children: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "The world's LOUDEST portable speaker for DJs?")
      }, {
        YouTubeId: 'JrGlmymabNg',
        children: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "Soundboks Update - New Sound Modes New Features")
      }, {
        YouTubeId: 'j9WFgrGU5ro',
        children: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "The world's Loudest Wireless Speaker")
      }],
      height: "184px"
    })), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    }), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_product_review_styled_StyledHorizontalLine, null, /*#__PURE__*/react_default.a.createElement(HorizontalLine, {
      color: elements_theme["a" /* Color */].WhiteOff
    }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    })), /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(Trustbox, null)));
  });
};

/* harmony default export */ var soundboks_jagermeister_product_review = (soundboks_jagermeister_product_review_ProductReviewSection);
// CONCATENATED MODULE: ./components/pages/products-v2/special-editions/soundboks-jagermeister/related-products/index.tsx
var soundboks_jagermeister_related_products_jsx = react_default.a.createElement;






var soundboks_jagermeister_related_products_RelatedProductsSection = function RelatedProductsSection(_ref) {
  var relatedProducts = _ref.relatedProducts;
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      grow: 1
    }, /*#__PURE__*/react_default.a.createElement(RelatedProducts, {
      relatedProducts: relatedProducts,
      headline: i18n._('product.related-products.heading')
    })));
  });
};

/* harmony default export */ var soundboks_jagermeister_related_products = (soundboks_jagermeister_related_products_RelatedProductsSection);
// CONCATENATED MODULE: ./components/pages/products-v2/special-editions/soundboks-jagermeister/index.tsx

var soundboks_jagermeister_jsx = react_default.a.createElement;

function soundboks_jagermeister_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function soundboks_jagermeister_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { soundboks_jagermeister_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { soundboks_jagermeister_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



















var soundboks_jagermeister_paths = [{
  label: 'Home',
  url: '/'
}, {
  label: 'Special Editions',
  url: '/products/?filter=special-editions'
}, {
  label: 'SOUNDBOKS × Jägermeister'
}];
var soundboks_jagermeister_options = {
  merch: 'Merch',
  batteries: 'Batteries'
};
var soundboks_jagermeister_klarnaData = {
  de: {
    klarnaLocale: 'de-DE',
    klarnaClassName: 'klarna-pricetag-de'
  },
  no: {
    klarnaLocale: 'no-NO',
    klarnaClassName: 'klarna-pricetag-no'
  },
  da: {
    klarnaLocale: 'da-DK',
    klarnaClassName: 'klarna-pricetag-dk'
  }
};
var soundboks_jagermeister_merchOptions = [{
  id: 'Sleeping Bag',
  label: 'Sleeping Bag'
}, {
  id: 'Hammock',
  label: 'Hammock'
}, {
  id: 'Tent',
  label: 'Tent'
}];
var soundboks_jagermeister_batteriOptions = {
  onePack: '1x BATTERYBOKS',
  twoPack: '2x BATTERYBOKS'
};
var soundboks_jagermeister_offset = 124;

var soundboks_jagermeister_SoundboksJagermeister = function SoundboksJagermeister(_ref) {
  var productData = _ref.productData,
      dispatchAddCartItem = _ref.dispatchAddCartItem;

  var _useSelector = Object(es["d" /* useSelector */])(function (state) {
    return state;
  }),
      settings = _useSelector.settings;

  var regionId = settings.regionId,
      languageId = settings.languageId;
  var overview = Object(react["useRef"])(null);
  var feature = Object(react["useRef"])(null);
  var learnMore = Object(react["useRef"])(null);
  var reviews = Object(react["useRef"])(null);
  var relatedProducts = Object(react["useRef"])(null);

  var _useState = Object(react["useState"])(),
      anchorStack = _useState[0],
      setAnchorStack = _useState[1];

  var _useState2 = Object(react["useState"])(),
      selectedAnchor = _useState2[0],
      setSelectedAnchor = _useState2[1];

  var _useState3 = Object(react["useState"])(false),
      isHeaderVisibility = _useState3[0],
      setIsHeaderVisibility = _useState3[1];

  var _useState4 = Object(react["useState"])(),
      productVariant = _useState4[0],
      setProductVariant = _useState4[1];

  var _useState5 = Object(react["useState"])(),
      selectedMerch = _useState5[0],
      setSelectedMerch = _useState5[1];

  var _useState6 = Object(react["useState"])(),
      availableMerch = _useState6[0],
      setAvailableMerch = _useState6[1];

  var _useState7 = Object(react["useState"])(),
      extraBattery = _useState7[0],
      setExtraBattery = _useState7[1];

  var _useState8 = Object(react["useState"])(),
      disableExtraBattery = _useState8[0],
      setDisableExtraBattery = _useState8[1];

  var productCategories = Object(mergeUACategories["a" /* default */])(abstractProducts_default.a.byId[productData.handle].categories);

  var _useState9 = Object(react["useState"])(true),
      allowImageInteractionTracking = _useState9[0],
      setAllowImageInteractionTracking = _useState9[1];

  var _useState10 = Object(react["useState"])(0),
      trackImageInteractionLimit = _useState10[0],
      setTrackImageInteractionLimit = _useState10[1];

  var router = Object(next_router["useRouter"])();
  Object(react["useEffect"])(function () {
    var initialStack = [{
      label: 'products.subnavigation.achor.overview',
      ref: overview
    }, {
      label: 'products.subnavigation.achor.feature',
      ref: feature
    }, {
      label: 'products.subnavigation.achor.learn-more',
      ref: learnMore
    }, {
      label: 'products.subnavigation.achor.reviews',
      ref: reviews
    }, {
      label: 'products.subnavigation.achor.related-products',
      ref: relatedProducts
    }];
    setAnchorStack(initialStack);

    var handleScroll = function handleScroll() {
      var stackIndex = initialStack.findIndex(function (stack) {
        return stack.ref.current.getBoundingClientRect().y - soundboks_jagermeister_offset > 0;
      });
      var stack = stackIndex === -1 ? initialStack[initialStack.length - 1] : initialStack[stackIndex - 1];
      setSelectedAnchor(stack.ref.current);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return function () {
      return window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  var handleHeaderVisibility = function handleHeaderVisibility(isVisibility) {
    setIsHeaderVisibility(isVisibility);
  };

  Object(react["useEffect"])(function () {
    var defaultOption = productData.variants.find(function (variant) {
      return variant.sku;
    });
    var optionsFromUrlQueries = productData.variants.find(function (variant) {
      return variant.options[soundboks_jagermeister_options.merch] === router.query[soundboks_jagermeister_options.merch];
    });
    var defaultVariant = optionsFromUrlQueries || defaultOption;
    setSelectedMerch(defaultVariant === null || defaultVariant === void 0 ? void 0 : defaultVariant.options[soundboks_jagermeister_options.merch]);
    var variantMerch = productData.variants.map(function (variant) {
      return variant.options[soundboks_jagermeister_options.merch];
    });
    var merch = soundboks_jagermeister_merchOptions.filter(function (_ref2) {
      var id = _ref2.id;
      return variantMerch.includes(id);
    });
    setAvailableMerch(merch);
    setExtraBattery((defaultVariant === null || defaultVariant === void 0 ? void 0 : defaultVariant.options[soundboks_jagermeister_options.batteries]) === soundboks_jagermeister_batteriOptions.twoPack); // Does this variant exist with opposite selected battery?

    var reverseBatteryOption = (defaultVariant === null || defaultVariant === void 0 ? void 0 : defaultVariant.options[soundboks_jagermeister_options.batteries]) === soundboks_jagermeister_batteriOptions.onePack ? soundboks_jagermeister_batteriOptions.twoPack : soundboks_jagermeister_batteriOptions.onePack;
    var reverseBatteryChoice = productData.variants.some(function (variant) {
      return variant.options[soundboks_jagermeister_options.merch] === (defaultVariant === null || defaultVariant === void 0 ? void 0 : defaultVariant.options[soundboks_jagermeister_options.merch]) && variant.options[soundboks_jagermeister_options.batteries] === reverseBatteryOption;
    });
    setDisableExtraBattery(!reverseBatteryChoice);
    setProductVariant(defaultVariant);
  }, [productData, router.query]); // const refreshData = (item?: string) => {
  //   let pathCheck;
  //   const exclEnRegions = regionId !== 'eu' && regionId !== 'tr';
  //   if (languageId === 'en' && exclEnRegions) {
  //     pathCheck = `/${regionId}/en`;
  //   } else {
  //     pathCheck = regionId === 'na' ? '' : `/${regionId}`;
  //   }
  //   window.history.replaceState(
  //     null,
  //     `${pathCheck}/products/jagermeister-limited-edition/`,
  //     `${pathCheck}/products/jagermeister-limited-edition/?Merch=${item}`,
  //   );
  // };
  // const handleMerchSelector = (item: string) => {
  //   const nextVariant = productData.variants.find(
  //     (variant) =>
  //       variant.options[options.merch] === item
  //       && variant.options[options.batteries]
  //         === (extraBattery ? batteriOptions.twoPack : batteriOptions.onePack),
  //   );
  //   setSelectedMerch(item);
  //   refreshData(item);
  //   // Does this variant exist with opposite selected battery?
  //   const reverseBatteryOption = nextVariant.options[options.batteries] === batteriOptions.onePack
  //     ? batteriOptions.twoPack
  //     : batteriOptions.onePack;
  //   const reverseBatteryChoice = productData.variants.some(
  //     (variant) =>
  //       variant.options[options.merch] === nextVariant.options[options.merch]
  //       && variant.options[options.batteries] === reverseBatteryOption,
  //   );
  //   setDisableExtraBattery(!reverseBatteryChoice);
  //   setProductVariant(nextVariant);
  // };

  var handleBatterySelector = function handleBatterySelector(selected) {
    var variants = productData.variants.filter(function (variant) {
      return variant.options[soundboks_jagermeister_options.batteries] === (selected ? soundboks_jagermeister_batteriOptions.twoPack : soundboks_jagermeister_batteriOptions.onePack);
    });
    var merch = variants.map(function (variant) {
      return variant.options[soundboks_jagermeister_options.merch];
    });
    setAvailableMerch(function (prev) {
      return prev.map(function (item) {
        return merch.includes(item.id) ? soundboks_jagermeister_objectSpread(soundboks_jagermeister_objectSpread({}, item), {}, {
          disabled: false
        }) : soundboks_jagermeister_objectSpread(soundboks_jagermeister_objectSpread({}, item), {}, {
          disabled: true
        });
      });
    });
    setExtraBattery(selected);
    var nextVariant = variants.find(function (variant) {
      return variant.options[soundboks_jagermeister_options.merch] === selectedMerch;
    });
    setProductVariant(nextVariant);
  };

  Object(react["useEffect"])(function () {
    if (productVariant) {
      var productImages = Object(getProductImages["a" /* default */])(productData.handle, productVariant.sku);
      var imageUrl = productImages.length ? productImages[0].url : '';
      var timer = setTimeout(function () {
        return Object(utils["i" /* trackProductPageview */])({
          name: productData.title,
          id: productVariant.sku,
          price: productVariant.price,
          brand: 'soundboks',
          category: productCategories,
          variant: productVariant.title,
          image: imageUrl
        });
      }, 1000);
      return function () {
        return clearTimeout(timer);
      };
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [regionId, productVariant]);

  var handleAddToCart = function handleAddToCart() {
    if (productVariant.available) {
      dispatchAddCartItem(productVariant.id, 1, true);
    }
  };

  var financialServices = function financialServices(variantPrice) {
    var locale = productData.locale;
    var klarnaAvailable = locale === 'de' || locale === 'no' || locale === 'da';
    var affirmAvailable = locale === 'en-US';
    return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, affirmAvailable && /*#__PURE__*/react_default.a.createElement(index_web_AffirmService, {
      price: variantPrice,
      locale: locale,
      isBlackTheme: true
    }), klarnaAvailable && /*#__PURE__*/react_default.a.createElement(index_web_KlarnaService, {
      price: variantPrice,
      locale: soundboks_jagermeister_klarnaData[locale].klarnaLocale,
      klarnaClassName: soundboks_jagermeister_klarnaData[locale].klarnaClassName
    }));
  };

  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    backgroundColor: elements_theme["a" /* Color */].Charcoal
  }, /*#__PURE__*/react_default.a.createElement(sub_navigation_SubNavigation, {
    productData: productData,
    productVariant: productVariant,
    anchorStack: anchorStack,
    selectedAnchor: selectedAnchor,
    isHeaderVisibility: isHeaderVisibility,
    offset: soundboks_jagermeister_offset,
    handleAddToCart: handleAddToCart
  }), /*#__PURE__*/react_default.a.createElement("div", {
    ref: overview
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '24px',
      desktop: '46px'
    }
  }), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_product_overview, {
    paths: soundboks_jagermeister_paths,
    offset: soundboks_jagermeister_offset,
    anchorStack: anchorStack,
    productData: productData,
    availableMerch: availableMerch,
    selectedMerch: selectedMerch,
    productVariant: productVariant,
    onHeaderVisibility: handleHeaderVisibility // handleMerchSelector={handleMerchSelector}
    ,
    handleAddToCart: handleAddToCart,
    disableExtraBattery: disableExtraBattery,
    financialServices: financialServices,
    handleBatterySelector: handleBatterySelector,
    allowImageInteractionTracking: allowImageInteractionTracking,
    setAllowImageInteractionTracking: setAllowImageInteractionTracking,
    trackImageInteractionLimit: trackImageInteractionLimit,
    setTrackImageInteractionLimit: setTrackImageInteractionLimit
  })), /*#__PURE__*/react_default.a.createElement("div", {
    ref: feature
  }, /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_product_feature, null), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '60px',
      desktop: '120px'
    }
  })), /*#__PURE__*/react_default.a.createElement("div", {
    ref: learnMore
  }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    alignContentHorizontal: "center",
    backgroundColor: elements_theme["a" /* Color */].WhiteOff
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_learn_more, {
    locale: productData.locale
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }))), /*#__PURE__*/react_default.a.createElement("div", {
    ref: reviews
  }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    backgroundColor: elements_theme["a" /* Color */].White
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_product_review, null), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }))), /*#__PURE__*/react_default.a.createElement("div", {
    ref: relatedProducts
  }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    backgroundColor: elements_theme["a" /* Color */].WhiteOff
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister_related_products, {
    relatedProducts: productData.crossSellHandles
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '60px',
      desktop: '72px'
    }
  }))));
};

/* harmony default export */ var soundboks_jagermeister = (soundboks_jagermeister_SoundboksJagermeister);
// EXTERNAL MODULE: ./components/pages/products-v2/bundles/soundboks-gen3-refurbished/assets/Soundboks3-lifestyle-1-large.jpg
var assets_Soundboks3_lifestyle_1_large = __webpack_require__("MYjm");
var assets_Soundboks3_lifestyle_1_large_default = /*#__PURE__*/__webpack_require__.n(assets_Soundboks3_lifestyle_1_large);

// EXTERNAL MODULE: ./components/pages/products-v2/bundles/soundboks-gen3-refurbished/assets/Soundboks3-lifestyle-1-small.jpg
var assets_Soundboks3_lifestyle_1_small = __webpack_require__("G0OZ");
var assets_Soundboks3_lifestyle_1_small_default = /*#__PURE__*/__webpack_require__.n(assets_Soundboks3_lifestyle_1_small);

// CONCATENATED MODULE: ./components/pages/products-v2/bundles/soundboks-gen3-refurbished/styled.ts




var soundboks_gen3_refurbished_styled_BackgroundImage = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__BackgroundImage",
  componentId: "qzolau-0"
})(["display:block;width:100%;height:400px;background-image:url(", ");background-repeat:no-repeat;background-size:cover;background-position:30% 70%;@media ", "{height:852px;padding:20px;background-position:center;background-image:url(", ");}"], assets_Soundboks3_lifestyle_1_large_default.a.url, styles_theme["a" /* default */].breakpoints.tablet, assets_Soundboks3_lifestyle_1_small_default.a.url);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/soundboks-gen3-refurbished/product-feature/index.tsx
var soundboks_gen3_refurbished_product_feature_jsx = react_default.a.createElement;

















var soundboks_gen3_refurbished_product_feature_ProductFeatureSection = function ProductFeatureSection() {
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref) {
    var i18n = _ref.i18n;
    return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentVertical: "center",
      alignContentHorizontal: "center",
      backgroundColor: elements_theme["a" /* Color */].Charcoal
    }, /*#__PURE__*/react_default.a.createElement(index_web_ProductFeature, {
      features: [{
        uri: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_sound_375_default.a.url),
        uriRanges: {
          phone: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_sound_375_default.a.url, {
            width: 327,
            height: 400
          }),
          tabletLandscape: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_sound_375_default.a.url, {
            width: 525,
            height: 600
          }),
          desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_sound_375_default.a.url, {
            width: 525,
            height: 670
          })
        },
        title: i18n._('product.sb3.feature.title.volume.and.sound'),
        description: i18n._('product.sb3.feature.description.volume.and.sound'),
        imgPosition: 'left'
      }, {
        uri: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_app_default.a.url),
        uriRanges: {
          phone: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_app_default.a.url, {
            width: 397,
            height: 470
          }),
          tabletLandscape: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_app_default.a.url, {
            width: 535,
            height: 610
          }),
          desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(usp_app_default.a.url, {
            width: 525,
            height: 670
          })
        },
        title: i18n._('product.sb3.feature.title.app.and.upgradability'),
        description: /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
          id: "product.sb3.feature.description.app.and.upgradability",
          components: [/*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_product_feature_LinkWrapper, {
            href: "/app"
          })]
        }),
        content: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
          height: {
            "default": '17px',
            desktop: '60px'
          }
        }), /*#__PURE__*/react_default.a.createElement(Composition["b" /* Layout */], {
          omitPadding: true,
          direction: Composition["d" /* LayoutDirection */].Row,
          alignX: Composition["c" /* LayoutAlignment */].Start,
          alignY: Composition["c" /* LayoutAlignment */].Start
        }, /*#__PURE__*/react_default.a.createElement("a", {
          href: "https://play.google.com/store/apps/details?id=com.soundboks.SOUNDBOKS"
        }, /*#__PURE__*/react_default.a.createElement(atoms_Icon["b" /* default */], {
          height: 40,
          id: atoms_Icon["a" /* IconId */].DownloadGooglaPlay
        })), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
          width: "16px"
        }), /*#__PURE__*/react_default.a.createElement("a", {
          href: "https://apps.apple.com/us/app/soundboks/id1440156667"
        }, /*#__PURE__*/react_default.a.createElement(atoms_Icon["b" /* default */], {
          height: 40,
          id: atoms_Icon["a" /* IconId */].DownloadAppStore
        })))),
        imgPosition: 'right'
      }, {
        uri: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_portability_375_default.a.url),
        uriRanges: {
          phone: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_portability_375_default.a.url, {
            width: 337,
            height: 410
          }),
          tabletLandscape: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_portability_375_default.a.url, {
            width: 555,
            height: 660
          }),
          desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_portability_375_default.a.url, {
            width: 545,
            height: 630
          })
        },
        title: i18n._('product.sb3.feature.title.durability.and.portability'),
        description: i18n._('product.sb3.feature.description.durability.and.portability'),
        imgPosition: 'left'
      }, {
        uri: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_teamup_375_default.a.url),
        uriRanges: {
          phone: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_teamup_375_default.a.url, {
            width: 397,
            height: 470
          }),
          tabletLandscape: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_teamup_375_default.a.url, {
            width: 535,
            height: 610
          }),
          desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_teamup_375_default.a.url, {
            width: 525,
            height: 670
          })
        },
        title: i18n._('product.sb3.feature.title.wireless.and.connection'),
        description: i18n._('product.sb3.feature.description.wireless.and.connection'),
        imgPosition: 'right'
      }, {
        uri: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_battery_375_default.a.url),
        uriRanges: {
          phone: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_battery_375_default.a.url, {
            width: 397,
            height: 470
          }),
          tabletLandscape: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_battery_375_default.a.url, {
            width: 535,
            height: 610
          }),
          desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(USP_battery_375_default.a.url, {
            width: 525,
            height: 670
          })
        },
        title: i18n._('product.sb3.feature.title.battery.and.swappability'),
        description: i18n._('product.sb3.feature.description.battery.and.swappability'),
        imgPosition: 'left'
      }]
    }));
  });
};

var soundboks_gen3_refurbished_product_feature_Anchor = styled_components_browser_esm["default"].a.withConfig({
  displayName: "product-feature__Anchor",
  componentId: "sc-10vxdwl-0"
})(["color:#fff;cursor:pointer;text-decoration:underline;"]);

var soundboks_gen3_refurbished_product_feature_LinkWrapper = function LinkWrapper(_ref2) {
  var href = _ref2.href,
      _ref2$children = _ref2.children,
      children = _ref2$children === void 0 ? undefined : _ref2$children;
  return /*#__PURE__*/react_default.a.createElement(Link["a" /* default */], {
    href: href,
    prefetch: false
  }, /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_product_feature_Anchor, null, children));
};

/* harmony default export */ var soundboks_gen3_refurbished_product_feature = (soundboks_gen3_refurbished_product_feature_ProductFeatureSection);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/soundboks-gen3-refurbished/product-overview/index.tsx
var soundboks_gen3_refurbished_product_overview_jsx = react_default.a.createElement;






var soundboks_gen3_refurbished_product_overview_ProductOverviewSection = function ProductOverviewSection(_ref) {
  var productData = _ref.productData,
      paths = _ref.paths,
      onHeaderVisibility = _ref.onHeaderVisibility,
      handleColorSelector = _ref.handleColorSelector,
      handleBatterySelector = _ref.handleBatterySelector,
      handleConditionSelector = _ref.handleConditionSelector,
      selectedCondition = _ref.selectedCondition,
      productVariant = _ref.productVariant,
      avalibleColors = _ref.avalibleColors,
      selectedColor = _ref.selectedColor,
      extraBattery = _ref.extraBattery,
      disableExtraBattery = _ref.disableExtraBattery,
      handleAddToCart = _ref.handleAddToCart,
      financialServices = _ref.financialServices,
      offset = _ref.offset,
      anchorStack = _ref.anchorStack,
      allowImageInteractionTracking = _ref.allowImageInteractionTracking,
      setAllowImageInteractionTracking = _ref.setAllowImageInteractionTracking,
      trackImageInteractionLimit = _ref.trackImageInteractionLimit,
      setTrackImageInteractionLimit = _ref.setTrackImageInteractionLimit;
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentHorizontal: "center",
      padding: {
        right: 24,
        left: 24
      }
    }, /*#__PURE__*/react_default.a.createElement(index_web_ProductOverview, {
      paths: paths,
      offset: offset,
      anchorStack: anchorStack,
      productData: productData,
      handleConditionSelector: handleConditionSelector,
      selectedCondition: selectedCondition,
      handleColorSelector: handleColorSelector,
      handleBatterySelector: handleBatterySelector,
      productVariant: productVariant,
      avalibleColors: avalibleColors,
      selectedColor: selectedColor,
      extraBattery: extraBattery,
      disableExtraBattery: disableExtraBattery,
      handleAddToCart: handleAddToCart,
      financialServices: financialServices,
      allowImageInteractionTracking: allowImageInteractionTracking,
      setAllowImageInteractionTracking: setAllowImageInteractionTracking,
      trackImageInteractionLimit: trackImageInteractionLimit,
      setTrackImageInteractionLimit: setTrackImageInteractionLimit,
      labels: {
        condition: {
          label: i18n._('product.option.label.condition'),
          options: {
            Good: i18n._('product.option.label.good'),
            VeryGood: i18n._('product.option.label.verygood')
          }
        },
        addToCart: i18n._('product.buy-page.button.addToCart'),
        outOfStock: i18n._('product.buy-page.button.outOfStock'),
        waitlist: i18n._('product.buy-page.button.waitlist'),
        usp: {
          warranty: i18n._('product.usp.warranty'),
          freeReturns: i18n._('product.usp.free-returns'),
          freeShipping: i18n._('product.usp.free-shipping'),
          premiumSupport: i18n._('product.usp.premium-support'),
          compatibility: i18n._('product.usp.compatibility')
        }
      },
      onHeaderVisibility: onHeaderVisibility
    }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    }));
  });
};

/* harmony default export */ var soundboks_gen3_refurbished_product_overview = (soundboks_gen3_refurbished_product_overview_ProductOverviewSection);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/soundboks-gen3-refurbished/learn-more/content.tsx
var soundboks_gen3_refurbished_learn_more_content_jsx = react_default.a.createElement;






var soundboks_gen3_refurbished_learn_more_content_packageItems = [{
  packageItemId: 'soundboks-gen-3-rf',
  title: 'Soundboks (Gen 3)',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconSoundboks3, null)
}, {
  packageItemId: 'batteryboks',
  title: 'Batteryboks',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconBattery, null)
}, {
  packageItemId: 'charger',
  title: 'Charger',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconCharger, null)
}, {
  packageItemId: 'soundboks-gen-3-manual',
  title: 'Manual',
  icon: /*#__PURE__*/react_default.a.createElement(package_items_icons_IconManual, null),
  downloadUrl: soundboks3["default"]
}];
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/soundboks-gen3-refurbished/learn-more/tech-spec/styled.ts

var soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescList = styled_components_browser_esm["default"].dl.withConfig({
  displayName: "styled__DescList",
  componentId: "w0tyfh-0"
})(["margin:20px 0 0 0;"]);
var soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescTitle = styled_components_browser_esm["default"].dt.withConfig({
  displayName: "styled__DescTitle",
  componentId: "w0tyfh-1"
})(["margin:0;"]);
var soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails = styled_components_browser_esm["default"].dd.withConfig({
  displayName: "styled__DescDetails",
  componentId: "w0tyfh-2"
})(["margin:0;"]);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/soundboks-gen3-refurbished/learn-more/tech-spec/index.web.tsx
var soundboks_gen3_refurbished_learn_more_tech_spec_index_web_jsx = react_default.a.createElement;





 // eslint-disable-next-line prefer-arrow-callback

var soundboks_gen3_refurbished_learn_more_tech_spec_index_web_TechSpec = /*#__PURE__*/react_default.a.memo(function TechSpec() {
  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, null, /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "SOUND"
  })), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "AMPLIFIER"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Merus Audio eximo\xAE amp switching"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "3 \xD7 72W RMS class D amplifiers"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Advanced Bass DSP"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "ACOUSTICS"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Effective frequency range: 40Hz - 20kHz"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Custom sound profile with bass enhancer"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "DRIVER UNITS"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "2 \xD7 10\u201D 96dB woofers"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "1 \xD7 1\u201D 104dB compression driver tweeter"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "CONNECTIVITY"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Bluetooth 5.0"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "TeamUP connection"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Wirelessly connect up to 5 (total) nearby New SOUNDBOKS(2019) speakers (SKAA network)"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Pro Panel"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA 2 \xD7 Combo microphone/instrument (XLR, 1/4\u201D) input"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA 1 \xD7 3.5mm Stereo Input"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA 1 \xD7 3.5mm Stereo Output"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Bond Button for advanced JOIN settings"
  })))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "BUILD"
  })), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "WEIGHT"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "34 pounds (15.4 kg)"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "MATERIALS"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Poplar cabinet"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Powder-coated aluminum frame"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Powder-coated steel grill and handles"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Silicone ball corners"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "SMP temperature-flex adhesive"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "DIMENSIONS"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "66 \xD7 43 \xD7 32 cm / 25.6 \xD7 17 \xD7 13 inches (H \xD7 W \xD7 D)"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "FEATURES"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Swappable grill and batteries"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "IP65 rated electronics coating"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Pulse Reflex Port"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "UI Panel"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Volume control"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "\u25AA Host/Join mode for wireless TeamUP"
  })))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "BATTERY"
  })), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "LIFE"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "40 hours at mid-volume"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "5 hours at full volume"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "3.5 hours full recharge"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "DESIGN"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "5-step LED battery-life indicator"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Heavy-duty DC-connector"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "CELL TYPE"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "12.8V, 7.8Ah Lithium Iron Phosphate (LiFePO4)"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "-10C to 40C temperature range"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "99.84Wh or 7.8Ah capacity"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "BATTERY MANAGEMENT SYSTEM (BMS)"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Over and under-discharge protection"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Short circuit protection"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Overheat protection"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Cell voltage management"
  })))), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["g" /* Highlight01 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app"
  })), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.soundSettings"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.soundSettings.1"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.soundSettings.2"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.proPanel"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.proPanel.1"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.proPanel.2"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.1"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.2"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.3"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.general.4"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings.1"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings.2"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.wirelessSettings.3"
  })))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescList, null, /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescTitle, null, /*#__PURE__*/react_default.a.createElement(elements_typography["f" /* Heading03 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.firmwareUpdate"
  }))), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_styled_DescDetails, null, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "nsb.techSpecs.app.firmwareUpdate.1"
  })))));
});
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/soundboks-gen3-refurbished/learn-more/styled.ts



var soundboks_gen3_refurbished_learn_more_styled_LayoutContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__LayoutContainer",
  componentId: "nr99ct-0"
})(["padding:0 190px;background-color:", ";@media ", "{padding:0 24px;}"], elements_theme["a" /* Color */].WhiteOff, styles_theme["a" /* default */].breakpoints.maxMobile);
var soundboks_gen3_refurbished_learn_more_styled_Link = styled_components_browser_esm["default"].a.withConfig({
  displayName: "styled__Link",
  componentId: "nr99ct-1"
})(["color:", ";cursor:pointer;text-decoration:underline;"], elements_theme["a" /* Color */].Orange);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/soundboks-gen3-refurbished/learn-more/faqs/index.web.tsx
var soundboks_gen3_refurbished_learn_more_faqs_index_web_jsx = react_default.a.createElement;





// eslint-disable-next-line prefer-arrow-callback
var soundboks_gen3_refurbished_learn_more_faqs_index_web_FAQs = /*#__PURE__*/react_default.a.memo(function FAQs() {
  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    padding: {
      right: 10
    }
  }, /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-1"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-1"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-2"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-2"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-3"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-3"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-4"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-4"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-5"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-5"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-6"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-6"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-7"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-7"
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "30px"
  }), /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], {
    bold: true,
    style: {
      paddingBottom: '7px'
    }
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.question-8"
  })), /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "product.SB3.learn-more.faqs.answer-8"
  }));
});
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/soundboks-gen3-refurbished/learn-more/index.tsx
var soundboks_gen3_refurbished_learn_more_jsx = react_default.a.createElement;


















var soundboks_gen3_refurbished_learn_more_LearnMoreSection = function LearnMoreSection(_ref) {
  var extraBattery = _ref.extraBattery,
      locale = _ref.locale;

  var _useSelector = Object(es["d" /* useSelector */])(function (state) {
    return state.settings;
  }),
      regionId = _useSelector.regionId;

  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_LayoutContainer, null, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(elements_typography["e" /* Heading02 */], {
      ariaLevel: elements_typography["h" /* TextLevel */].H2,
      style: {
        textTransform: 'uppercase',
        textAlign: 'center'
      }
    }, i18n._('product.learn-more.heading')), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "35px"
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.whats-in-the-box",
      content: /*#__PURE__*/react_default.a.createElement(index_web_WhatsInTheBox, {
        extraBattery: extraBattery,
        packageItems: soundboks_gen3_refurbished_learn_more_content_packageItems
      }),
      topItem: true
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.tech-specs",
      content: /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_tech_spec_index_web_TechSpec, null)
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.whats-a-bluetooth-performance-speaker",
      content: /*#__PURE__*/react_default.a.createElement(index_web_WhatsBluetoothSpeaker, null)
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.shipping",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: learn_more_content_content.shipping[regionId] || learn_more_content_content.shipping["default"],
        components: [/*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_styled_Link, {
          href: helpCenter_getHelpCenterUrl(locale, '/sections/360003609413-SHIPPING')
        })]
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.warranty",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "product.learn-more.warranty.info.refurbished",
        components: [/*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_styled_Link, {
          href: helpCenter_getHelpCenterUrl(locale, '/articles/211920329-RETURN-AND-REFUND-POLICY-AND-PROCESS')
        })]
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.payment-options",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
        id: "product.learn-more.payment-options.info"
      }))
    }), /*#__PURE__*/react_default.a.createElement(index_web_Accordion, {
      title: "product.learn-more.faqs",
      content: /*#__PURE__*/react_default.a.createElement(elements_typography["b" /* BodyText02 */], null, /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more_faqs_index_web_FAQs, null))
    })));
  });
};

var soundboks_gen3_refurbished_learn_more_LayoutContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "learn-more__LayoutContainer",
  componentId: "sc-1ig5soh-0"
})(["max-width:1062px;width:100%;@media ", "{padding:0 24px;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
/* harmony default export */ var soundboks_gen3_refurbished_learn_more = (soundboks_gen3_refurbished_learn_more_LearnMoreSection);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/soundboks-gen3-refurbished/product-review/config/reviews.js











var product_review_config_reviews_reviews = {};
product_review_config_reviews_reviews.techcrunch = {
  logo: techcrunch_black_default.a.url,
  text: 'Connecting several together is silly easy.',
  url: 'https://techcrunch.com/2019/08/15/the-new-soundboks-is-a-massive-pro-level-battery-powered-bluetooth-speaker/'
};
product_review_config_reviews_reviews.engadget = {
  logo: engadget_black_default.a.url,
  text: 'This imposing portable boombox is now wirelessly expandable, more dynamic and thankfully no bigger than before.',
  url: 'https://www.engadget.com/2019/08/15/soundboks-2019-big-bluetooth-speaker-louder-wireless-daisy-chain/'
};
product_review_config_reviews_reviews.geekDad = {
  logo: geekdad_black_default.a.url,
  text: 'A speaker that actually sounds like you want a speaker to sound.',
  url: 'https://geekdad.com/2019/08/the-new-soundboks-wireless-speaker-compromises-nothing-to-deliver-gigantic-sound/'
};
product_review_config_reviews_reviews.computedBildLogo = {
  logo: computer_bild_black_default.a.url,
  logoLarger: true,
  text: 'Der Sound ist ausgewogen und präzise.',
  url: 'https://www.computerbild.de/artikel/cb-Tests-Lautsprecher-The-New-Soundboks-Test-23961189.html'
}; // reviews.amazona = {
//   logo: amazonaLogo.url,
//   text: 'Deutlich zu erkennen ist das 2.5-Wege System des Lautsprechers, wodurch das Design der Box futuristischer wirkt.',
//   url: 'https://www.amazona.de/new-soundboks-update-des-mobilen-lautsprechers/',
// };

product_review_config_reviews_reviews.chip = {
  logo: chip_black_default.a.url,
  text: 'In Sachen Lautstärke hat der SOUNDBOKS noch nie jemand etwas vorgemacht.',
  url: 'https://www.chip.de/news/The-New-Soundboks-Lautester-Akku-Speaker-der-Welt_171770519.html'
};
product_review_config_reviews_reviews.sueddeutscheZeitung = {
  logo: sueddeutsche_zeitung_black_default.a.url,
  text: 'Die Ansteuerung über Bluetooth und die Möglichkeit zur kabellosen Kopplung untereinander sind hübsche Beigaben, die die Boxen von der Konkurrenz abheben.',
  url: 'https://www.sueddeutsche.de/wirtschaft/braucht-man-das-party-lautsprecher-new-soundboks-1.4569792'
}; // reviews.tekno = {
//   logo: teknoLogo.url,
//   logoLarger: true,
//   text: 'SOUNDBOKS er sannsynligvis den ultimate slepbare partyhøyttaleren.',
//   url: 'https://www.tek.no/artikler/korttest-soundboks/470930',
// };
// reviews.lydogbillede = {
//   logo: lydogbilledeLogo.url,
//   logoLarger: true,
//   text: 'Ingen batteridrevet høyttaler er i nærheten av den',
//   url: 'https://www.lydogbilde.no/test/hoyttalere/the-new-soundboks?hw=1',
// };

product_review_config_reviews_reviews.dinside = {
  logo: dinside_black_default.a.url,
  logoLarger: true,
  text: 'Rett og slett et monster av en Bluetooth-høyttaler - Festen er reddet.',
  url: 'https://www.dinside.no/mobil/rett-og-slett-et-monster-av-en-bluetooth-hoyttaler/71544423'
};
product_review_config_reviews_reviews.mobilsiden = {
  logo: mobilsiden_black_default.a.url,
  logoLarger: true,
  text: 'The New SOUNDBOKS er den mest alsidige højtaler, jeg nogensinde har set.',
  url: 'https://www.mobilsiden.dk/anmeldelser/test-the-new-soundboks-den-komplette-hojtaler,lid.41191/'
}; // reviews.inputmag = {
//   logo: inputmagLogo.url,
//   logoLarger: true,
//   text: 'The New SOUNDBOKS er en imponerende krabat.',
//   url: 'https://www.inputmag.dk/anmeldelse-the-new-soundboks/',
// };

product_review_config_reviews_reviews.euroman = {
  logo: euroman_black_default.a.url,
  logoLarger: true,
  text: 'Tager din fest til næste niveau med endnu højere lyd og mulighed for at parre op til fem højttalere.',
  url: 'https://www.euroman.dk/teknik/test-vi-anmelder-den-nye-soundboks'
}; // reviews.altomdata = {
//   logo: altomdataLogo.url,
//   logoLarger: true,
//   text: 'Stort set alt er opgraderet.',
//   url: 'https://www.altomdata.dk/ny-monsterhoejttaler-fra-soundboks',
// };

product_review_config_reviews_reviews.knowTechchie = {
  logo: know_techie_black_default.a.url,
  text: 'This will make you rethink what you knew about wireless audio',
  url: 'https://knowtechie.com/review-soundboks-35lbs-of-kick-ass-bluetooth-speaker/'
}; // reviews.audioReputation = {
//   logo: audioReputationLogo.url,
//   text: 'Bluetooth connection worked like a charm. The range is impressive and the connection is perfectly stable, even at 50ft distance.',
//   url: 'https://www.audioreputation.com/new-soundboks/',
// };

product_review_config_reviews_reviews.hiconsumption = {
  logo: hiconsumption_black_default.a.url,
  text: 'SOUNDBOKS’ most recent release is an awe-inspiring piece of hardware',
  url: 'https://hiconsumption.com/review-soundboks-the-new-sounboks-speaker/'
};
/* harmony default export */ var soundboks_gen3_refurbished_product_review_config_reviews = (product_review_config_reviews_reviews);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/soundboks-gen3-refurbished/product-review/config/regionalReviews.js

var config_regionalReviews_regionalReviews = {
  XX: [soundboks_gen3_refurbished_product_review_config_reviews.techcrunch, soundboks_gen3_refurbished_product_review_config_reviews.engadget, soundboks_gen3_refurbished_product_review_config_reviews.geekDad, soundboks_gen3_refurbished_product_review_config_reviews.knowTechchie, // reviews.audioReputation,
  soundboks_gen3_refurbished_product_review_config_reviews.hiconsumption],
  DE: [soundboks_gen3_refurbished_product_review_config_reviews.computedBildLogo, // reviews.amazona,
  soundboks_gen3_refurbished_product_review_config_reviews.chip, soundboks_gen3_refurbished_product_review_config_reviews.sueddeutscheZeitung, soundboks_gen3_refurbished_product_review_config_reviews.techcrunch, soundboks_gen3_refurbished_product_review_config_reviews.engadget, soundboks_gen3_refurbished_product_review_config_reviews.geekDad],
  NO: [// reviews.tekno,
  // reviews.lydogbillede,
  soundboks_gen3_refurbished_product_review_config_reviews.dinside, soundboks_gen3_refurbished_product_review_config_reviews.techcrunch, soundboks_gen3_refurbished_product_review_config_reviews.engadget, soundboks_gen3_refurbished_product_review_config_reviews.geekDad, soundboks_gen3_refurbished_product_review_config_reviews.knowTechchie, // reviews.audioReputation,
  soundboks_gen3_refurbished_product_review_config_reviews.hiconsumption],
  DK: [soundboks_gen3_refurbished_product_review_config_reviews.mobilsiden, // reviews.inputmag,
  soundboks_gen3_refurbished_product_review_config_reviews.euroman, // reviews.altomdata,
  // reviews.lydogbillede,
  soundboks_gen3_refurbished_product_review_config_reviews.techcrunch, soundboks_gen3_refurbished_product_review_config_reviews.engadget, soundboks_gen3_refurbished_product_review_config_reviews.geekDad, soundboks_gen3_refurbished_product_review_config_reviews.hiconsumption, soundboks_gen3_refurbished_product_review_config_reviews.knowTechchie // reviews.audioReputation,
  ]
};
/* harmony default export */ var soundboks_gen3_refurbished_product_review_config_regionalReviews = (config_regionalReviews_regionalReviews);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/soundboks-gen3-refurbished/product-review/styled.tsx


var soundboks_gen3_refurbished_product_review_styled_StyledHorizontalLine = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__StyledHorizontalLine",
  componentId: "lwhk1k-0"
})(["display:none;@media ", "{display:block;padding:0px 24px;}"], styles_theme["a" /* default */].breakpoints.maxMobile);
var soundboks_gen3_refurbished_product_review_styled_LayoutContainer = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__LayoutContainer",
  componentId: "lwhk1k-1"
})(["position:relative;width:100%;max-width:1024px;text-align:center;align-self:center;@media ", "{max-width:720px;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/soundboks-gen3-refurbished/product-review/index.tsx
var soundboks_gen3_refurbished_product_review_jsx = react_default.a.createElement;














var soundboks_gen3_refurbished_product_review_ProductReviewSection = function ProductReviewSection() {
  var _useSelector = Object(es["d" /* useSelector */])(function (state) {
    return state.settings;
  }),
      countryId = _useSelector.countryId;

  var reviews = soundboks_gen3_refurbished_product_review_config_regionalReviews[countryId] || soundboks_gen3_refurbished_product_review_config_regionalReviews.XX;
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref) {
    var i18n = _ref.i18n;
    return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_product_review_styled_LayoutContainer, null, /*#__PURE__*/react_default.a.createElement(elements_typography["e" /* Heading02 */], {
      ariaLevel: elements_typography["h" /* TextLevel */].H2,
      color: elements_theme["a" /* Color */].Orange,
      style: {
        textTransform: 'uppercase'
      }
    }, i18n._('product.reviews.heading')), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "20px"
    }), /*#__PURE__*/react_default.a.createElement(ProductReview, {
      reviews: reviews,
      colorForeground: elements_theme["a" /* Color */].Charcoal
    })), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    }), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_product_review_styled_StyledHorizontalLine, null, /*#__PURE__*/react_default.a.createElement(HorizontalLine, {
      color: elements_theme["a" /* Color */].WhiteOff
    }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    })), /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(index_web_VideoFeature, {
      videos: [{
        YouTubeId: 'FuD9ujTbZCE',
        children: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "The world's LOUDEST portable speaker for DJs?")
      }, {
        YouTubeId: 'JrGlmymabNg',
        children: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "Soundboks Update - New Sound Modes New Features")
      }, {
        YouTubeId: 'j9WFgrGU5ro',
        children: /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, "The world's Loudest Wireless Speaker")
      }],
      height: "184px"
    })), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    }), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_product_review_styled_StyledHorizontalLine, null, /*#__PURE__*/react_default.a.createElement(HorizontalLine, {
      color: elements_theme["a" /* Color */].WhiteOff
    }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
      height: "60px"
    })), /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(Trustbox, null)));
  });
};

/* harmony default export */ var soundboks_gen3_refurbished_product_review = (soundboks_gen3_refurbished_product_review_ProductReviewSection);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/soundboks-gen3-refurbished/image-collage/styled.ts


var image_collage_styled_ContainerProductFeature = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__ContainerProductFeature",
  componentId: "h5ndqm-0"
})(["display:grid;grid-template-columns:1fr 1fr;max-width:1064px;margin:auto;grid-gap:14px;@media ", "{grid-gap:5px;}"], styles_theme["a" /* default */].breakpoints.maxTablet);
var image_collage_styled_ContainerImage1 = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__ContainerImage1",
  componentId: "h5ndqm-1"
})(["width:100%;grid-column:1 / span 1;grid-row:1 / span 2;"]);
var image_collage_styled_ContainerImage2 = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__ContainerImage2",
  componentId: "h5ndqm-2"
})(["width:100%;grid-column:2 / span 1;grid-row:1 / span 1;"]);
var image_collage_styled_ContainerImage3 = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__ContainerImage3",
  componentId: "h5ndqm-3"
})(["width:100%;grid-column:2 / span 1;grid-row:2 / span 1;"]);
var image_collage_styled_ContainerImage4 = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styled__ContainerImage4",
  componentId: "h5ndqm-4"
})(["width:100%;grid-column:1 / span 2;grid-row:3 / span 1;"]);
// EXTERNAL MODULE: ./components/pages/products-v2/bundles/soundboks-gen3-refurbished/assets/Soundboks3-lifestyle-2-small.png
var assets_Soundboks3_lifestyle_2_small = __webpack_require__("bDvF");
var assets_Soundboks3_lifestyle_2_small_default = /*#__PURE__*/__webpack_require__.n(assets_Soundboks3_lifestyle_2_small);

// EXTERNAL MODULE: ./components/pages/products-v2/bundles/soundboks-gen3-refurbished/assets/Soundboks3-lifestyle-2-large.png
var assets_Soundboks3_lifestyle_2_large = __webpack_require__("AYZk");
var assets_Soundboks3_lifestyle_2_large_default = /*#__PURE__*/__webpack_require__.n(assets_Soundboks3_lifestyle_2_large);

// EXTERNAL MODULE: ./components/pages/products-v2/bundles/soundboks-gen3-refurbished/assets/Soundboks3-lifestyle-3-small.png
var assets_Soundboks3_lifestyle_3_small = __webpack_require__("jNdC");
var assets_Soundboks3_lifestyle_3_small_default = /*#__PURE__*/__webpack_require__.n(assets_Soundboks3_lifestyle_3_small);

// EXTERNAL MODULE: ./components/pages/products-v2/bundles/soundboks-gen3-refurbished/assets/Soundboks3-lifestyle-3-large.png
var assets_Soundboks3_lifestyle_3_large = __webpack_require__("ChL7");
var assets_Soundboks3_lifestyle_3_large_default = /*#__PURE__*/__webpack_require__.n(assets_Soundboks3_lifestyle_3_large);

// EXTERNAL MODULE: ./components/pages/products-v2/bundles/soundboks-gen3-refurbished/assets/Soundboks3-lifestyle-4-small.png
var assets_Soundboks3_lifestyle_4_small = __webpack_require__("T2cC");
var assets_Soundboks3_lifestyle_4_small_default = /*#__PURE__*/__webpack_require__.n(assets_Soundboks3_lifestyle_4_small);

// EXTERNAL MODULE: ./components/pages/products-v2/bundles/soundboks-gen3-refurbished/assets/Soundboks3-lifestyle-4-large.png
var assets_Soundboks3_lifestyle_4_large = __webpack_require__("1kso");
var assets_Soundboks3_lifestyle_4_large_default = /*#__PURE__*/__webpack_require__.n(assets_Soundboks3_lifestyle_4_large);

// EXTERNAL MODULE: ./components/pages/products-v2/bundles/soundboks-gen3-refurbished/assets/Soundboks3-lifestyle-5-small.png
var assets_Soundboks3_lifestyle_5_small = __webpack_require__("IIcZ");
var assets_Soundboks3_lifestyle_5_small_default = /*#__PURE__*/__webpack_require__.n(assets_Soundboks3_lifestyle_5_small);

// EXTERNAL MODULE: ./components/pages/products-v2/bundles/soundboks-gen3-refurbished/assets/Soundboks3-lifestyle-5-large.png
var assets_Soundboks3_lifestyle_5_large = __webpack_require__("sn9D");
var assets_Soundboks3_lifestyle_5_large_default = /*#__PURE__*/__webpack_require__.n(assets_Soundboks3_lifestyle_5_large);

// CONCATENATED MODULE: ./components/pages/products-v2/bundles/soundboks-gen3-refurbished/image-collage/index.tsx
var soundboks_gen3_refurbished_image_collage_jsx = react_default.a.createElement;












var soundboks_gen3_refurbished_image_collage_ProductFeatureSection = function ProductFeatureSection() {
  return /*#__PURE__*/react_default.a.createElement(image_collage_styled_ContainerProductFeature, null, /*#__PURE__*/react_default.a.createElement(image_collage_styled_ContainerImage1, null, /*#__PURE__*/react_default.a.createElement(elements_image["a" /* Image */], {
    uri: Object(elements_image["b" /* imgIxUrlFormatter */])(assets_Soundboks3_lifestyle_2_large_default.a.url),
    ranges: {
      phone: Object(elements_image["b" /* imgIxUrlFormatter */])(assets_Soundboks3_lifestyle_2_small_default.a.url),
      desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(assets_Soundboks3_lifestyle_2_large_default.a.url)
    }
  })), /*#__PURE__*/react_default.a.createElement(image_collage_styled_ContainerImage2, null, /*#__PURE__*/react_default.a.createElement(elements_image["a" /* Image */], {
    uri: Object(elements_image["b" /* imgIxUrlFormatter */])(assets_Soundboks3_lifestyle_3_large_default.a.url),
    ranges: {
      phone: Object(elements_image["b" /* imgIxUrlFormatter */])(assets_Soundboks3_lifestyle_3_small_default.a.url),
      desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(assets_Soundboks3_lifestyle_3_large_default.a.url)
    }
  })), /*#__PURE__*/react_default.a.createElement(image_collage_styled_ContainerImage3, null, /*#__PURE__*/react_default.a.createElement(elements_image["a" /* Image */], {
    uri: Object(elements_image["b" /* imgIxUrlFormatter */])(assets_Soundboks3_lifestyle_4_large_default.a.url),
    ranges: {
      phone: Object(elements_image["b" /* imgIxUrlFormatter */])(assets_Soundboks3_lifestyle_4_small_default.a.url),
      desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(assets_Soundboks3_lifestyle_4_large_default.a.url)
    }
  })), /*#__PURE__*/react_default.a.createElement(image_collage_styled_ContainerImage4, null, /*#__PURE__*/react_default.a.createElement(elements_image["a" /* Image */], {
    uri: Object(elements_image["b" /* imgIxUrlFormatter */])(assets_Soundboks3_lifestyle_5_large_default.a.url),
    ranges: {
      phone: Object(elements_image["b" /* imgIxUrlFormatter */])(assets_Soundboks3_lifestyle_5_small_default.a.url),
      desktop: Object(elements_image["b" /* imgIxUrlFormatter */])(assets_Soundboks3_lifestyle_5_large_default.a.url)
    }
  })));
};

/* harmony default export */ var soundboks_gen3_refurbished_image_collage = (soundboks_gen3_refurbished_image_collage_ProductFeatureSection);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/soundboks-gen3-refurbished/related-products/index.tsx
var soundboks_gen3_refurbished_related_products_jsx = react_default.a.createElement;






var soundboks_gen3_refurbished_related_products_RelatedProductsSection = function RelatedProductsSection(_ref) {
  var relatedProducts = _ref.relatedProducts;
  return /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref2) {
    var i18n = _ref2.i18n;
    return /*#__PURE__*/react_default.a.createElement(elements_hstack["a" /* HStack */], {
      alignContentHorizontal: "center"
    }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
      grow: 1
    }, /*#__PURE__*/react_default.a.createElement(RelatedProducts, {
      relatedProducts: relatedProducts,
      headline: i18n._('product.related-products.heading')
    })));
  });
};

/* harmony default export */ var soundboks_gen3_refurbished_related_products = (soundboks_gen3_refurbished_related_products_RelatedProductsSection);
// CONCATENATED MODULE: ./components/pages/products-v2/bundles/soundboks-gen3-refurbished/index.tsx
var soundboks_gen3_refurbished_jsx = react_default.a.createElement;





















var soundboks_gen3_refurbished_paths = [{
  label: 'Home',
  url: '/'
}, {
  label: 'Speakers',
  url: '/products/?filter=speakers'
}, {
  label: 'Soundboks (Gen. 3)'
}];
var soundboks_gen3_refurbished_options = {
  grillColor: 'Grill Color',
  batteries: 'Batteries',
  condition: 'Condition'
};
var soundboks_gen3_refurbished_klarnaData = {
  de: {
    klarnaLocale: 'de-DE',
    klarnaClassName: 'klarna-pricetag-de'
  },
  no: {
    klarnaLocale: 'no-NO',
    klarnaClassName: 'klarna-pricetag-no'
  },
  da: {
    klarnaLocale: 'da-DK',
    klarnaClassName: 'klarna-pricetag-dk'
  }
};
var conditionOptions = {
  good: 'Good',
  veryGood: 'Very good'
};

var soundboks_gen3_refurbished_SoundboksGen3Refurbished = function SoundboksGen3Refurbished(_ref) {
  var productData = _ref.productData,
      dispatchAddCartItem = _ref.dispatchAddCartItem;

  var _useSelector = Object(es["d" /* useSelector */])(function (state) {
    return state;
  }),
      settings = _useSelector.settings;

  var regionId = settings.regionId,
      languageId = settings.languageId;
  var overview = Object(react["useRef"])(null);
  var feature = Object(react["useRef"])(null);
  var learnMore = Object(react["useRef"])(null);
  var reviews = Object(react["useRef"])(null);
  var relatedProducts = Object(react["useRef"])(null);

  var _useState = Object(react["useState"])(),
      anchorStack = _useState[0],
      setAnchorStack = _useState[1];

  var _useState2 = Object(react["useState"])(),
      selectedAnchor = _useState2[0],
      setSelectedAnchor = _useState2[1];

  var _useState3 = Object(react["useState"])(false),
      isHeaderVisibility = _useState3[0],
      setIsHeaderVisibility = _useState3[1];

  var _useState4 = Object(react["useState"])(),
      productVariant = _useState4[0],
      setProductVariant = _useState4[1];

  var _useState5 = Object(react["useState"])(),
      selectedCondition = _useState5[0],
      setSelectedCondition = _useState5[1];

  var productCategories = Object(mergeUACategories["a" /* default */])(abstractProducts_default.a.byId[productData.handle].categories);

  var _useCheckRegion = Object(useCheckRegion["a" /* default */])(),
      isNA = _useCheckRegion.isNA,
      isCA = _useCheckRegion.isCA,
      isTU = _useCheckRegion.isTU;

  var _useState6 = Object(react["useState"])(true),
      allowImageInteractionTracking = _useState6[0],
      setAllowImageInteractionTracking = _useState6[1];

  var _useState7 = Object(react["useState"])(0),
      trackImageInteractionLimit = _useState7[0],
      setTrackImageInteractionLimit = _useState7[1];

  var router = Object(next_router["useRouter"])();
  var offset = 124;
  Object(react["useEffect"])(function () {
    var initialStack = [{
      label: 'products.subnavigation.achor.overview',
      ref: overview
    }, {
      label: 'products.subnavigation.achor.feature',
      ref: feature
    }, {
      label: 'products.subnavigation.achor.learn-more',
      ref: learnMore
    }, {
      label: 'products.subnavigation.achor.reviews',
      ref: reviews
    }, {
      label: 'products.subnavigation.achor.related-products',
      ref: relatedProducts
    }];
    setAnchorStack(initialStack);

    var handleScroll = function handleScroll() {
      var stackIndex = initialStack.findIndex(function (stack) {
        return stack.ref.current.getBoundingClientRect().y - offset > 0;
      });
      var stack = stackIndex === -1 ? initialStack[initialStack.length - 1] : initialStack[stackIndex - 1];
      setSelectedAnchor(stack.ref.current);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return function () {
      return window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  var handleHeaderVisibility = function handleHeaderVisibility(isVisibility) {
    setIsHeaderVisibility(isVisibility);
  };

  var pathCheck;
  var exclEnRegions = regionId !== 'eu' && regionId !== 'tr';

  if (languageId === 'en' && exclEnRegions) {
    pathCheck = "/".concat(regionId, "/en");
  } else {
    pathCheck = regionId === 'na' ? '' : "/".concat(regionId);
  }

  Object(react["useEffect"])(function () {
    var defaultOption = productData.variants.find(function (variant) {
      return variant.sku === productData.defaultSku;
    });
    var ConditionQueryOption = router.query[soundboks_gen3_refurbished_options.condition] === 'good' ? conditionOptions.good : conditionOptions.veryGood;
    var optionsFromUrlQueries = productData.variants.find(function (variant) {
      return variant.options[soundboks_gen3_refurbished_options.batteries] === ConditionQueryOption;
    });
    var defaultVariant = optionsFromUrlQueries || defaultOption;
    setSelectedCondition(defaultVariant === null || defaultVariant === void 0 ? void 0 : defaultVariant.options[soundboks_gen3_refurbished_options.condition]);
    setProductVariant(defaultVariant);
  }, [productData, router.query]);

  var handleConditionSelector = function handleConditionSelector(condition) {
    var nextVariant = productData.variants.find(function (variant) {
      return variant.options[soundboks_gen3_refurbished_options.condition] === condition;
    });
    setSelectedCondition(condition);
    Object(utils["m" /* trackVariantInteraction */])(condition);
    setAllowImageInteractionTracking(true);
    setTrackImageInteractionLimit(0);
    window.history.replaceState(null, "".concat(pathCheck, "/products/soundboks-gen-3-refurbished/"), "".concat(pathCheck, "/products/soundboks-gen-3-refurbished/?Condition=").concat(condition));
    setProductVariant(nextVariant);
  };

  Object(react["useEffect"])(function () {
    if (productVariant) {
      var productImages = Object(getProductImages["a" /* default */])(productData.handle, productVariant.sku);
      var imageUrl = productImages.length ? productImages[0].url : '';
      var timer = setTimeout(function () {
        return Object(utils["i" /* trackProductPageview */])({
          name: productData.title,
          id: productVariant.sku,
          price: productVariant.price,
          brand: 'soundboks',
          category: productCategories,
          variant: productVariant.title,
          image: imageUrl
        });
      }, 1000);
      return function () {
        return clearTimeout(timer);
      };
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [regionId, productVariant]);

  var handleAddToCart = function handleAddToCart() {
    console.log('handleAddToCart', productVariant);

    if (productVariant.available) {
      dispatchAddCartItem(productVariant.id, 1, true);
    } else {
      console.log('join waitinglist dialog');
    }
  };

  var financialServices = function financialServices(variantPrice) {
    var locale = productData.locale;
    var klarnaAvailable = locale === 'de' || locale === 'no' || locale === 'da';
    var affirmAvailable = locale === 'en-US';
    return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, affirmAvailable && /*#__PURE__*/react_default.a.createElement(index_web_AffirmService, {
      price: variantPrice,
      locale: locale,
      isBlackTheme: true
    }), klarnaAvailable && /*#__PURE__*/react_default.a.createElement(index_web_KlarnaService, {
      price: variantPrice,
      locale: soundboks_gen3_refurbished_klarnaData[locale].klarnaLocale,
      klarnaClassName: soundboks_gen3_refurbished_klarnaData[locale].klarnaClassName
    }));
  };

  return /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    backgroundColor: elements_theme["a" /* Color */].Charcoal
  }, /*#__PURE__*/react_default.a.createElement(sub_navigation_SubNavigation, {
    productData: productData,
    productVariant: productVariant,
    anchorStack: anchorStack,
    selectedAnchor: selectedAnchor,
    isHeaderVisibility: isHeaderVisibility,
    offset: offset,
    handleAddToCart: handleAddToCart
  }), /*#__PURE__*/react_default.a.createElement("div", {
    ref: overview
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '24px',
      desktop: '46px'
    }
  }), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_product_overview, {
    paths: soundboks_gen3_refurbished_paths,
    offset: offset,
    anchorStack: anchorStack,
    productData: productData,
    productVariant: productVariant,
    onHeaderVisibility: handleHeaderVisibility,
    handleConditionSelector: handleConditionSelector,
    selectedCondition: selectedCondition,
    handleAddToCart: handleAddToCart,
    financialServices: financialServices,
    allowImageInteractionTracking: allowImageInteractionTracking,
    setAllowImageInteractionTracking: setAllowImageInteractionTracking,
    trackImageInteractionLimit: trackImageInteractionLimit,
    setTrackImageInteractionLimit: setTrackImageInteractionLimit
  })), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_styled_BackgroundImage, null), /*#__PURE__*/react_default.a.createElement("div", {
    ref: feature
  }, /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_product_feature, null), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '60px',
      desktop: '120px'
    }
  }), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_image_collage, null)), /*#__PURE__*/react_default.a.createElement("div", {
    ref: learnMore
  }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    alignContentHorizontal: "center",
    backgroundColor: elements_theme["a" /* Color */].WhiteOff
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_learn_more, {
    locale: productData.locale
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }))), /*#__PURE__*/react_default.a.createElement("div", {
    ref: reviews
  }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    backgroundColor: elements_theme["a" /* Color */].White
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_product_review, null), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }))), /*#__PURE__*/react_default.a.createElement("div", {
    ref: relatedProducts
  }, /*#__PURE__*/react_default.a.createElement(vstack_VStack, {
    backgroundColor: elements_theme["a" /* Color */].WhiteOff
  }, /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: "60px"
  }), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished_related_products, {
    relatedProducts: productData.crossSellHandles
  }), /*#__PURE__*/react_default.a.createElement(index_web["a" /* Spacer */], {
    height: {
      "default": '60px',
      desktop: '72px'
    }
  }))));
};

/* harmony default export */ var soundboks_gen3_refurbished = (soundboks_gen3_refurbished_SoundboksGen3Refurbished);
// CONCATENATED MODULE: ./containers/products-v2/product-template.tsx
var product_template_jsx = react_default.a.createElement;






















var product_template_ProductBuyPage = function ProductBuyPage(_ref) {
  var productData = _ref.productData,
      productHandle = _ref.productHandle,
      metadata = _ref.metadata,
      dispatchAddCartItem = _ref.dispatchAddCartItem;

  var _checkProduct = Object(checkProduct["a" /* checkProduct */])(productHandle),
      isSoundboksGen3 = _checkProduct.isSoundboksGen3,
      isSoundboksGo = _checkProduct.isSoundboksGo,
      isExplorerPack = _checkProduct.isExplorerPack,
      isPerformerPack = _checkProduct.isPerformerPack,
      isElevationPack = _checkProduct.isElevationPack,
      isCarrierStrap = _checkProduct.isCarrierStrap,
      isRfLimitted = _checkProduct.isRfLimitted,
      isWeekenderPack = _checkProduct.isWeekenderPack,
      isJagermeister = _checkProduct.isJagermeister,
      isSB3Refurbished = _checkProduct.isSB3Refurbished;

  return /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, isSoundboksGen3 && /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(Meta["a" /* default */], {
    pageInfo: metadata["default"]
  }), /*#__PURE__*/react_default.a.createElement(soundboks_gen3, {
    productData: productData,
    dispatchAddCartItem: dispatchAddCartItem
  })), isSB3Refurbished && /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(Meta["a" /* default */], {
    pageInfo: metadata["default"]
  }), /*#__PURE__*/react_default.a.createElement(soundboks_gen3_refurbished, {
    productData: productData,
    dispatchAddCartItem: dispatchAddCartItem
  })), isSoundboksGo && /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(Meta["a" /* default */], {
    pageInfo: metadata["default"]
  }), /*#__PURE__*/react_default.a.createElement(speakers_soundboks_go, {
    productData: productData,
    dispatchAddCartItem: dispatchAddCartItem
  })), isExplorerPack && /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(Meta["a" /* default */], {
    pageInfo: metadata["default"]
  }), /*#__PURE__*/react_default.a.createElement(explorer_pack, {
    productData: productData,
    dispatchAddCartItem: dispatchAddCartItem
  })), isElevationPack && /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(Meta["a" /* default */], {
    pageInfo: metadata["default"]
  }), /*#__PURE__*/react_default.a.createElement(elevation_pack, {
    productData: productData,
    dispatchAddCartItem: dispatchAddCartItem
  })), isPerformerPack && /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(Meta["a" /* default */], {
    pageInfo: metadata["default"]
  }), /*#__PURE__*/react_default.a.createElement(performer_pack, {
    productData: productData,
    dispatchAddCartItem: dispatchAddCartItem
  })), isCarrierStrap && /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(Meta["a" /* default */], {
    pageInfo: metadata["default"]
  }), /*#__PURE__*/react_default.a.createElement(carrier_strap, {
    productData: productData,
    dispatchAddCartItem: dispatchAddCartItem
  })), isWeekenderPack && /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(Meta["a" /* default */], {
    pageInfo: metadata["default"]
  }), /*#__PURE__*/react_default.a.createElement(weekender_pack, {
    productData: productData,
    dispatchAddCartItem: dispatchAddCartItem
  })), isRfLimitted && /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(Meta["a" /* default */], {
    pageInfo: metadata["default"]
  }), /*#__PURE__*/react_default.a.createElement(soundboks_rf50, {
    productData: productData,
    dispatchAddCartItem: dispatchAddCartItem
  })), isJagermeister && /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(Meta["a" /* default */], {
    pageInfo: metadata["default"]
  }), /*#__PURE__*/react_default.a.createElement(soundboks_jagermeister, {
    productData: productData,
    dispatchAddCartItem: dispatchAddCartItem
  })));
};

var product_template_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    dispatchAddCartItem: function dispatchAddCartItem(variantId, quantity, showPopover) {
      dispatch(Object(handleAddCartItem["a" /* default */])(variantId, quantity, showPopover));
    }
  };
};

var product_template_mapStateToProps = function mapStateToProps(state, _ref2) {
  var _abstractProduct$defa;

  var productHandle = _ref2.productHandle;
  // WHERE TO PLACE THIS?
  var _state$settings = state.settings,
      regionId = _state$settings.regionId,
      languageId = _state$settings.languageId;
  var shopId = regions_default.a.byId[regionId].shopId;
  var shop = shops_default.a.byId[shopId];
  var allProducts = state.entities.products;
  var allVariants = state.entities.variants;
  var productId = allProducts.allIds.find(function (id) {
    var product = allProducts.byId[id];
    return product.handle === productHandle && product.shopId === shopId;
  });
  var product = allProducts.byId[productId];
  var filteredProducts = allProducts.allIds.reduce(function (acc, id) {
    var filteredproduct = allProducts.byId[id];

    if (filteredproduct.shopId === shopId) {
      acc.push(filteredproduct);
    }

    return acc;
  }, []);
  var abstractProduct = abstractProducts_default.a.byId[productHandle];
  var variants = product.variantIds.map(function (variantId) {
    var _abstractVariants$byI;

    var _allVariants$byId$var = allVariants.byId[variantId],
        available = _allVariants$byId$var.available,
        options = _allVariants$byId$var.options,
        compareAtPrice = _allVariants$byId$var.compareAtPrice,
        price = _allVariants$byId$var.price,
        sku = _allVariants$byId$var.sku,
        title = _allVariants$byId$var.title,
        weight = _allVariants$byId$var.weight;
    var variantOptions = Object.values(options).reduce(function (acc, curr) {
      acc[curr.name] = curr.value;
      return acc;
    }, {});
    var artworkIds = ((_abstractVariants$byI = abstractVariants_default.a.byId[sku]) === null || _abstractVariants$byI === void 0 ? void 0 : _abstractVariants$byI.productImageIds) || abstractProduct.productImageIds;
    var artworks = artworkIds.map(function (key) {
      var image = productImages_default.a.byId[key].url;
      return {
        id: key,
        primary: "".concat(image, "?w=400"),
        thumbnail: "".concat(image, "?w=100")
      };
    });
    var discount = compareAtPrice !== undefined && compareAtPrice !== null ? parseFloat(price) - parseFloat(compareAtPrice) : null;
    return {
      available: available,
      compareAtPrice: parseFloat(compareAtPrice) || null,
      price: parseFloat(price),
      discount: discount,
      currency: shop.currencyId,
      options: variantOptions,
      sku: sku,
      id: variantId,
      title: title,
      weight: weight,
      artworks: artworks
    };
  });
  var defaultSku = (productHandle === 'soundboks-gen-3' || productHandle === 'soundboks-go' || productHandle === 'soundboks-gen-3-refurbished' || productHandle === 'carrier-strap') && abstractProduct.defaultSkuByCountryId[regionId] ? abstractProduct.defaultSkuByCountryId[regionId] : (_abstractProduct$defa = abstractProduct.defaultSkuByCountryId) === null || _abstractProduct$defa === void 0 ? void 0 : _abstractProduct$defa["default"];
  var crossSalesProducts = abstractProduct.crossSellHandles.reduce(function (acc, handle) {
    var crossSalesproduct = filteredProducts.find(function (p) {
      return p.handle === handle;
    });

    if (!crossSalesproduct) {
      return acc;
    } // eslint-disable-next-line max-len


    var imageId = abstractProducts_default.a.byId[crossSalesproduct.handle].productImageIds[0]; // find related product // get its first image

    var variant = crossSalesproduct.variantIds[0]; // get first product variant

    var oldPrice = allVariants.byId[variant].compareAtPrice;
    var price = allVariants.byId[variant].price;
    var discount = oldPrice !== undefined && oldPrice !== null ? parseFloat(price) - parseFloat(oldPrice) : null;
    var promotion = discount !== undefined && discount !== null && "-".concat(Math.ceil((price - discount) / price), "%");
    acc.push({
      image: productImages_default.a.byId[imageId],
      price: parseFloat(price),
      oldPrice: parseFloat(oldPrice),
      headline: crossSalesproduct.title,
      discount: discount,
      currency: shop.currencyId,
      locale: languageId,
      promotion: promotion,
      productBuyPageHandler: "/products/product?productHandle=".concat(crossSalesproduct.handle),
      productBuyPageURL: "/products/".concat(crossSalesproduct.handle)
    });
    return acc;
  }, []);

  var extraBoldDescription = function extraBoldDescription(handle) {
    if (handle === 'soundboks-gen-3') return 'product.soundboksGen3.buy-page.description.text.bold';
    if (handle === 'soundboks-go') return 'product.soundboks-go.buy-page.description.text.bold';
    return null;
  };

  var extraBoldHeaderDescription = function extraBoldHeaderDescription(handle) {
    if (handle === 'soundboks-gen-3') return 'product.soundboksGen3.buy-page.description.text.bold-header';
    if (handle === 'soundboks-go') return 'product.soundboks-go.buy-page.description.text.bold-header';
    return null;
  };

  var productData = {
    locale: languageId,
    handle: product.handle,
    title: product.title,
    defaultSku: defaultSku,
    variants: variants,
    description: abstractProduct.descriptionBuyPage.text["default"],
    descriptionBold: extraBoldDescription(productHandle),
    descriptionBoldHeader: extraBoldHeaderDescription(productHandle),
    financingOptions: abstractProduct.financingOptions,
    crossSellHandles: crossSalesProducts,
    ratingAverage: abstractProduct.rating.ratingAverage,
    ratingCount: abstractProduct.rating.ratingCount
  };
  var metadata = data_productMetadata[productHandle];
  return {
    productData: productData,
    metadata: metadata
  };
};

/* harmony default export */ var product_template = (Object(es["b" /* connect */])(product_template_mapStateToProps, product_template_mapDispatchToProps)(product_template_ProductBuyPage));
// CONCATENATED MODULE: ./pages/products/product.jsx
var product_jsx = react_default.a.createElement;











var product_ConnectedProductPage = function ConnectedProductPage(_ref) {
  var productId = _ref.productId,
      productHandle = _ref.productHandle,
      subPage = _ref.subPage,
      isAvailable = _ref.isAvailable;
  // Set product component by default to Error page
  var productComponent = /*#__PURE__*/react_default.a.createElement(error_default.a, {
    statusCode: 404
  }); // Only create product page if it is visibled

  if (isAvailable) {
    switch (productHandle) {
      case 'soundboks-gen-3':
      case 'soundboks-gen-3-refurbished':
      case 'soundboks-go':
      case 'elevation-pack':
      case 'performer-pack':
      case 'explorer-pack':
      case 'carrier-strap':
      case 'soundboks-rf50':
      case 'weekender-pack':
      case 'jagermeister-2022-edition':
        productComponent = /*#__PURE__*/react_default.a.createElement(product_template, {
          productHandle: productHandle
        });
        break;

      case 'soundboks-gen-2':
        productComponent = /*#__PURE__*/react_default.a.createElement(product_Soundboks2, {
          productId: productId,
          productHandle: productHandle,
          subPage: subPage
        });
        break;

      case 'batteryboks':
        productComponent = /*#__PURE__*/react_default.a.createElement(product_Batteryboks, {
          productId: productId,
          productHandle: productHandle,
          subPage: subPage
        });
        break;

      default:
        productComponent = /*#__PURE__*/react_default.a.createElement(BuyProduct, {
          productId: productId,
          productHandle: productHandle
        });
        break;
    }
  }

  return (// If product has sub pages, do not stick the header
    productHandle === '7-battery-swaps' ? /*#__PURE__*/react_default.a.createElement(error_default.a, {
      statusCode: 404
    }) : /*#__PURE__*/react_default.a.createElement(Layout["a" /* default */], {
      isHeaderFixed: true
    }, productComponent)
  );
}; // defaultProps


product_ConnectedProductPage.defaultProps = {
  subPage: undefined
}; // propTypes

// mapStateToProps
var product_mapStateToProps = function mapStateToProps(state, props) {
  var productHandle = props.productHandle,
      subPage = props.subPage;
  var _state$settings = state.settings,
      regionId = _state$settings.regionId,
      countryId = _state$settings.countryId;
  var shopId = regions_default.a.byId[regionId].shopId;
  var allProducts = state.entities.products; // Find productId for the given handle

  var targetProductId = allProducts.allIds.find(function (productId) {
    var product = allProducts.byId[productId];
    return product.handle === productHandle && product.shopId === shopId;
  }); // Check if product has subpages and visible

  var productSubPages = [];
  var isAvailable = false; // Make sure abstractProduct has handle for given Shopify product

  if (productHandle in abstractProducts_default.a.byId) {
    productSubPages = abstractProducts_default.a.byId[productHandle].subPages;
    isAvailable = abstractProducts_default.a.byId[productHandle].availableRegions.includes(regionId) && !abstractProducts_default.a.byId[productHandle].excludedCountries.includes(countryId.toLowerCase()); // Otherwise print error log
  } else {
    console.warn("".concat(productHandle, " is not found in local configuration."));
  }

  return {
    productHandle: productHandle,
    productId: targetProductId,
    subPage: subPage,
    hasSubPages: productSubPages.length > 0,
    isAvailable: isAvailable
  };
}; // Connect


var ProductPage = Object(es["b" /* connect */])(product_mapStateToProps)(product_ConnectedProductPage); // getInitialProps

ProductPage.getInitialProps = function (props) {
  return {
    productHandle: props.query.productHandle,
    subPage: props.query.subPage
  };
};

/* harmony default export */ var products_product = __webpack_exports__["default"] = (ProductPage);

/***/ }),

/***/ "kx/G":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/know-techie_black-7c4f1771fb913c87e3100dbbd10a3016.png", "placeholder": ""};

/***/ }),

/***/ "l8P3":
/***/ (function(module, exports) {

module.exports = { "url": "data:image/svg+xml;base64,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" };

/***/ }),

/***/ "m38I":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/SBGO_lifestyle_1_small-2e54910114d1de68b3901937e749dd78.jpg", "placeholder": ""};

/***/ }),

/***/ "mKIF":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/euroman_black-300edc3f264217f077db91a72ad21c95.png", "placeholder": ""};

/***/ }),

/***/ "mPlb":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/USP_sound_375-d3e74a23d75499631b15000802f00cee.png", "placeholder": ""};

/***/ }),

/***/ "nxir":
/***/ (function(module, exports) {

module.exports = { "url": "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICA8ZyBpZD0iaWNvbi1jb21wYXJpc29uLW5vIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTMyIC0zMjMyKSI+CiAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzE2MzYiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDE2MzYiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTMyIDMyMzIpIiBmaWxsPSJub25lIi8+CiAgICA8cGF0aCBpZD0iUGF0aF8xNTMyIiBkYXRhLW5hbWU9IlBhdGggMTUzMiIgZD0iTTE4LjUsMTUsMTIuOCw5LjNsNS43LTUuOEwxNSwwLDkuMyw1LjcsMy41LDAsMCwzLjUsNS43LDkuMywwLDE1bDMuNSwzLjUsNS44LTUuN0wxNSwxOC41WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTM1IDMyMzQuODQpIiBmaWxsPSIjZTY1NDJmIi8+CiAgPC9nPgo8L3N2Zz4K" };

/***/ }),

/***/ "oMw8":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/mobilsiden_black-2f42c97ee5aab609400a2139e5594878.png", "placeholder": ""};

/***/ }),

/***/ "oP02":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/PerformerPack-lifestyle-large-8effc5285eea0cd7d1b232a3145c6fc4.jpg", "placeholder": ""};

/***/ }),

/***/ "ouqV":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/hiconsumption_black-eeff58521c11df2f1441dc47ae985438.png", "placeholder": ""};

/***/ }),

/***/ "p1gb":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/SBGO_lifestyle_3_large-d1ba80b19bbb7682912a5d0c0a21a7d8.png", "placeholder": ""};

/***/ }),

/***/ "p1tu":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/Soundboks3-lifestyle-4-large-f7ea04131d4b00b80033790806e3abc3.png", "placeholder": ""};

/***/ }),

/***/ "ra44":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/usp-sbgo-dynamic-c9c08574e4938a551e442eb9a46234e8.jpg", "placeholder": ""};

/***/ }),

/***/ "sIDi":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/techcrunch_black-48c6f1faa7906efdcfb6a51c494f836f.png", "placeholder": ""};

/***/ }),

/***/ "sW8a":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/ElevationPack-lifestyle-small-e4e146209800bf0bf013280e3a707100.jpg", "placeholder": ""};

/***/ }),

/***/ "sn9D":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/Soundboks3-lifestyle-5-large-433b88692815b3c86459a4eb41dedae2.png", "placeholder": ""};

/***/ }),

/***/ "tA+R":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * content-type
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * RegExp to match *( ";" parameter ) in RFC 7231 sec 3.1.1.1
 *
 * parameter     = token "=" ( token / quoted-string )
 * token         = 1*tchar
 * tchar         = "!" / "#" / "$" / "%" / "&" / "'" / "*"
 *               / "+" / "-" / "." / "^" / "_" / "`" / "|" / "~"
 *               / DIGIT / ALPHA
 *               ; any VCHAR, except delimiters
 * quoted-string = DQUOTE *( qdtext / quoted-pair ) DQUOTE
 * qdtext        = HTAB / SP / %x21 / %x23-5B / %x5D-7E / obs-text
 * obs-text      = %x80-FF
 * quoted-pair   = "\" ( HTAB / SP / VCHAR / obs-text )
 */
var PARAM_REGEXP = /; *([!#$%&'*+.^_`|~0-9A-Za-z-]+) *= *("(?:[\u000b\u0020\u0021\u0023-\u005b\u005d-\u007e\u0080-\u00ff]|\\[\u000b\u0020-\u00ff])*"|[!#$%&'*+.^_`|~0-9A-Za-z-]+) */g
var TEXT_REGEXP = /^[\u000b\u0020-\u007e\u0080-\u00ff]+$/
var TOKEN_REGEXP = /^[!#$%&'*+.^_`|~0-9A-Za-z-]+$/

/**
 * RegExp to match quoted-pair in RFC 7230 sec 3.2.6
 *
 * quoted-pair = "\" ( HTAB / SP / VCHAR / obs-text )
 * obs-text    = %x80-FF
 */
var QESC_REGEXP = /\\([\u000b\u0020-\u00ff])/g

/**
 * RegExp to match chars that must be quoted-pair in RFC 7230 sec 3.2.6
 */
var QUOTE_REGEXP = /([\\"])/g

/**
 * RegExp to match type in RFC 7231 sec 3.1.1.1
 *
 * media-type = type "/" subtype
 * type       = token
 * subtype    = token
 */
var TYPE_REGEXP = /^[!#$%&'*+.^_`|~0-9A-Za-z-]+\/[!#$%&'*+.^_`|~0-9A-Za-z-]+$/

/**
 * Module exports.
 * @public
 */

exports.format = format
exports.parse = parse

/**
 * Format object to media type.
 *
 * @param {object} obj
 * @return {string}
 * @public
 */

function format (obj) {
  if (!obj || typeof obj !== 'object') {
    throw new TypeError('argument obj is required')
  }

  var parameters = obj.parameters
  var type = obj.type

  if (!type || !TYPE_REGEXP.test(type)) {
    throw new TypeError('invalid type')
  }

  var string = type

  // append parameters
  if (parameters && typeof parameters === 'object') {
    var param
    var params = Object.keys(parameters).sort()

    for (var i = 0; i < params.length; i++) {
      param = params[i]

      if (!TOKEN_REGEXP.test(param)) {
        throw new TypeError('invalid parameter name')
      }

      string += '; ' + param + '=' + qstring(parameters[param])
    }
  }

  return string
}

/**
 * Parse media type to object.
 *
 * @param {string|object} string
 * @return {Object}
 * @public
 */

function parse (string) {
  if (!string) {
    throw new TypeError('argument string is required')
  }

  // support req/res-like objects as argument
  var header = typeof string === 'object'
    ? getcontenttype(string)
    : string

  if (typeof header !== 'string') {
    throw new TypeError('argument string is required to be a string')
  }

  var index = header.indexOf(';')
  var type = index !== -1
    ? header.substr(0, index).trim()
    : header.trim()

  if (!TYPE_REGEXP.test(type)) {
    throw new TypeError('invalid media type')
  }

  var obj = new ContentType(type.toLowerCase())

  // parse parameters
  if (index !== -1) {
    var key
    var match
    var value

    PARAM_REGEXP.lastIndex = index

    while ((match = PARAM_REGEXP.exec(header))) {
      if (match.index !== index) {
        throw new TypeError('invalid parameter format')
      }

      index += match[0].length
      key = match[1].toLowerCase()
      value = match[2]

      if (value[0] === '"') {
        // remove quotes and escapes
        value = value
          .substr(1, value.length - 2)
          .replace(QESC_REGEXP, '$1')
      }

      obj.parameters[key] = value
    }

    if (index !== header.length) {
      throw new TypeError('invalid parameter format')
    }
  }

  return obj
}

/**
 * Get content-type from req/res objects.
 *
 * @param {object}
 * @return {Object}
 * @private
 */

function getcontenttype (obj) {
  var header

  if (typeof obj.getHeader === 'function') {
    // res-like
    header = obj.getHeader('content-type')
  } else if (typeof obj.headers === 'object') {
    // req-like
    header = obj.headers && obj.headers['content-type']
  }

  if (typeof header !== 'string') {
    throw new TypeError('content-type header is missing from object')
  }

  return header
}

/**
 * Quote a string if necessary.
 *
 * @param {string} val
 * @return {string}
 * @private
 */

function qstring (val) {
  var str = String(val)

  // no need to quote tokens
  if (TOKEN_REGEXP.test(str)) {
    return str
  }

  if (str.length > 0 && !TEXT_REGEXP.test(str)) {
    throw new TypeError('invalid parameter value')
  }

  return '"' + str.replace(QUOTE_REGEXP, '\\$1') + '"'
}

/**
 * Class to represent a content type.
 * @private
 */
function ContentType (type) {
  this.parameters = Object.create(null)
  this.type = type
}


/***/ }),

/***/ "tvl1":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/soundboks_hero-1920-e9f834cc51206f42ff6e50a2d08a77fd.jpg", "placeholder": ""};

/***/ }),

/***/ "uFxA":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/soundboks_sound-1024-9d8f8bc2e181166a3174c033e08815e5.jpg", "placeholder": ""};

/***/ }),

/***/ "uLo+":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/digital-DJ-tips-24b34f867552da43931cd0806d26f12d.png", "placeholder": ""};

/***/ }),

/***/ "vrg1":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/soundboks_blueprint-117dbdf11497718505630f78169dbb72.svg", "placeholder": ""};

/***/ }),

/***/ "vzqh":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/Soundboks3-lifestyle-1-large-419fef0b1d6bb3384f3d0583249a5f57.jpg", "placeholder": ""};

/***/ }),

/***/ "wEU9":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/SBGO_lifestyle_4_large-10a44b82bca3d7fd9a2059947491bede.png", "placeholder": ""};

/***/ }),

/***/ "wegZ":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/sueddeutsche-zeitung_black-dd3e2ba547584ab1ecf8def9f56fdfd2.png", "placeholder": ""};

/***/ }),

/***/ "wn/i":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/ExplorerPack-lifestyle-large-4452f1ef37da222ed33de4d3313fefce.jpg", "placeholder": ""};

/***/ }),

/***/ "x78r":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/SBGO_lifestyle_5_large-b8f49698cd4c53c365294521a35aeefe.png", "placeholder": ""};

/***/ }),

/***/ "xQ0t":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/chip-c274d61e905d667c1627fb83f8c0c39d.png", "placeholder": ""};

/***/ }),

/***/ "y14P":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/compareSoundboks-3c138cc160772881e3f0bf66dc7235bf.svg", "placeholder": ""};

/***/ }),

/***/ "zVQo":
/***/ (function(module, exports) {

module.exports = {"url": "https://soundboks.imgix.net/ExplorerPack-lifestyle-small-97dc3f668b60ea4a9415a4a50762dd70.jpg", "placeholder": ""};

/***/ })

},[["NXYy",0,1,2,3,4,5,6,7,8,9,10,12,11,13,14,15,16,20,26,27,24]]]);